(function () {
  'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  function commonjsRequire () {
  	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
  }

  var runtime_1 = createCommonjsModule(function (module) {
    /**
     * Copyright (c) 2014-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var runtime = function (exports) {

      var Op = Object.prototype;
      var hasOwn = Op.hasOwnProperty;
      var undefined$1; // More compressible than void 0.

      var $Symbol = typeof Symbol === "function" ? Symbol : {};
      var iteratorSymbol = $Symbol.iterator || "@@iterator";
      var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
      var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

      function define(obj, key, value) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
        return obj[key];
      }

      try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
      } catch (err) {
        define = function define(obj, key, value) {
          return obj[key] = value;
        };
      }

      function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.

        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
      }

      exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
      // record like context.tryEntries[i].completion. This interface could
      // have been (and was previously) designed to take a closure to be
      // invoked without arguments, but in all the cases we care about we
      // already have an existing method we want to call, so there's no need
      // to create a new function object. We can even get away with assuming
      // the method takes exactly one argument, since that happens to be true
      // in every case, so we don't have to touch the arguments object. The
      // only additional allocation required is the completion record, which
      // has a stable shape and so hopefully should be cheap to allocate.

      function tryCatch(fn, obj, arg) {
        try {
          return {
            type: "normal",
            arg: fn.call(obj, arg)
          };
        } catch (err) {
          return {
            type: "throw",
            arg: err
          };
        }
      }

      var GenStateSuspendedStart = "suspendedStart";
      var GenStateSuspendedYield = "suspendedYield";
      var GenStateExecuting = "executing";
      var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
      // breaking out of the dispatch switch statement.

      var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
      // .constructor.prototype properties for functions that return Generator
      // objects. For full spec compliance, you may wish to configure your
      // minifier not to mangle the names of these two functions.

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
      // don't natively support it.


      var IteratorPrototype = {};
      define(IteratorPrototype, iteratorSymbol, function () {
        return this;
      });
      var getProto = Object.getPrototypeOf;
      var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

      if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
        // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
      }

      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
      GeneratorFunction.prototype = GeneratorFunctionPrototype;
      define(Gp, "constructor", GeneratorFunctionPrototype);
      define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
      GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
      // Iterator interface in terms of a single ._invoke method.

      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
          define(prototype, method, function (arg) {
            return this._invoke(method, arg);
          });
        });
      }

      exports.isGeneratorFunction = function (genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
      };

      exports.mark = function (genFun) {
        if (Object.setPrototypeOf) {
          Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        } else {
          genFun.__proto__ = GeneratorFunctionPrototype;
          define(genFun, toStringTagSymbol, "GeneratorFunction");
        }

        genFun.prototype = Object.create(Gp);
        return genFun;
      }; // Within the body of any async function, `await x` is transformed to
      // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
      // `hasOwn.call(value, "__await")` to determine if the yielded value is
      // meant to be awaited.


      exports.awrap = function (arg) {
        return {
          __await: arg
        };
      };

      function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);

          if (record.type === "throw") {
            reject(record.arg);
          } else {
            var result = record.arg;
            var value = result.value;

            if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
              return PromiseImpl.resolve(value.__await).then(function (value) {
                invoke("next", value, resolve, reject);
              }, function (err) {
                invoke("throw", err, resolve, reject);
              });
            }

            return PromiseImpl.resolve(value).then(function (unwrapped) {
              // When a yielded Promise is resolved, its final value becomes
              // the .value of the Promise<{value,done}> result for the
              // current iteration.
              result.value = unwrapped;
              resolve(result);
            }, function (error) {
              // If a rejected Promise was yielded, throw the rejection back
              // into the async generator function so it can be handled there.
              return invoke("throw", error, resolve, reject);
            });
          }
        }

        var previousPromise;

        function enqueue(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }

          return previousPromise = // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        } // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).


        this._invoke = enqueue;
      }

      defineIteratorMethods(AsyncIterator.prototype);
      define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
        return this;
      });
      exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
      // AsyncIterator objects; they just return a Promise for the value of
      // the final result produced by the iterator.

      exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function (result) {
          return result.done ? result.value : iter.next();
        });
      };

      function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
          if (state === GenStateExecuting) {
            throw new Error("Generator is already running");
          }

          if (state === GenStateCompleted) {
            if (method === "throw") {
              throw arg;
            } // Be forgiving, per 25.3.3.3.3 of the spec:
            // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


            return doneResult();
          }

          context.method = method;
          context.arg = arg;

          while (true) {
            var delegate = context.delegate;

            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context);

              if (delegateResult) {
                if (delegateResult === ContinueSentinel) continue;
                return delegateResult;
              }
            }

            if (context.method === "next") {
              // Setting context._sent for legacy support of Babel's
              // function.sent implementation.
              context.sent = context._sent = context.arg;
            } else if (context.method === "throw") {
              if (state === GenStateSuspendedStart) {
                state = GenStateCompleted;
                throw context.arg;
              }

              context.dispatchException(context.arg);
            } else if (context.method === "return") {
              context.abrupt("return", context.arg);
            }

            state = GenStateExecuting;
            var record = tryCatch(innerFn, self, context);

            if (record.type === "normal") {
              // If an exception is thrown from innerFn, we leave state ===
              // GenStateExecuting and loop back for another invocation.
              state = context.done ? GenStateCompleted : GenStateSuspendedYield;

              if (record.arg === ContinueSentinel) {
                continue;
              }

              return {
                value: record.arg,
                done: context.done
              };
            } else if (record.type === "throw") {
              state = GenStateCompleted; // Dispatch the exception by looping back around to the
              // context.dispatchException(context.arg) call above.

              context.method = "throw";
              context.arg = record.arg;
            }
          }
        };
      } // Call delegate.iterator[context.method](context.arg) and handle the
      // result, either by returning a { value, done } result from the
      // delegate iterator, or by modifying context.method and context.arg,
      // setting context.delegate to null, and returning the ContinueSentinel.


      function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];

        if (method === undefined$1) {
          // A .throw or .return when the delegate iterator has no .throw
          // method always terminates the yield* loop.
          context.delegate = null;

          if (context.method === "throw") {
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (delegate.iterator["return"]) {
              // If the delegate iterator has a return method, give it a
              // chance to clean up.
              context.method = "return";
              context.arg = undefined$1;
              maybeInvokeDelegate(delegate, context);

              if (context.method === "throw") {
                // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
              }
            }

            context.method = "throw";
            context.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return ContinueSentinel;
        }

        var record = tryCatch(method, delegate.iterator, context.arg);

        if (record.type === "throw") {
          context.method = "throw";
          context.arg = record.arg;
          context.delegate = null;
          return ContinueSentinel;
        }

        var info = record.arg;

        if (!info) {
          context.method = "throw";
          context.arg = new TypeError("iterator result is not an object");
          context.delegate = null;
          return ContinueSentinel;
        }

        if (info.done) {
          // Assign the result of the finished delegate to the temporary
          // variable specified by delegate.resultName (see delegateYield).
          context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

          context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
          // exception, let the outer generator proceed normally. If
          // context.method was "next", forget context.arg since it has been
          // "consumed" by the delegate iterator. If context.method was
          // "return", allow the original .return call to continue in the
          // outer generator.

          if (context.method !== "return") {
            context.method = "next";
            context.arg = undefined$1;
          }
        } else {
          // Re-yield the result returned by the delegate method.
          return info;
        } // The delegate iterator is finished, so forget it and continue with
        // the outer generator.


        context.delegate = null;
        return ContinueSentinel;
      } // Define Generator.prototype.{next,throw,return} in terms of the
      // unified ._invoke helper method.


      defineIteratorMethods(Gp);
      define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
      // @@iterator function is called on it. Some browsers' implementations of the
      // iterator prototype chain incorrectly implement this, causing the Generator
      // object to not be returned from this call. This ensures that doesn't happen.
      // See https://github.com/facebook/regenerator/issues/274 for more details.

      define(Gp, iteratorSymbol, function () {
        return this;
      });
      define(Gp, "toString", function () {
        return "[object Generator]";
      });

      function pushTryEntry(locs) {
        var entry = {
          tryLoc: locs[0]
        };

        if (1 in locs) {
          entry.catchLoc = locs[1];
        }

        if (2 in locs) {
          entry.finallyLoc = locs[2];
          entry.afterLoc = locs[3];
        }

        this.tryEntries.push(entry);
      }

      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
      }

      function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [{
          tryLoc: "root"
        }];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
      }

      exports.keys = function (object) {
        var keys = [];

        for (var key in object) {
          keys.push(key);
        }

        keys.reverse(); // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.

        return function next() {
          while (keys.length) {
            var key = keys.pop();

            if (key in object) {
              next.value = key;
              next.done = false;
              return next;
            }
          } // To avoid creating an additional object, we just hang the .value
          // and .done properties off the next function object itself. This
          // also ensures that the minifier will not anonymize the function.


          next.done = true;
          return next;
        };
      };

      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];

          if (iteratorMethod) {
            return iteratorMethod.call(iterable);
          }

          if (typeof iterable.next === "function") {
            return iterable;
          }

          if (!isNaN(iterable.length)) {
            var i = -1,
                next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }

              next.value = undefined$1;
              next.done = true;
              return next;
            };

            return next.next = next;
          }
        } // Return an iterator with no values.


        return {
          next: doneResult
        };
      }

      exports.values = values;

      function doneResult() {
        return {
          value: undefined$1,
          done: true
        };
      }

      Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
          this.prev = 0;
          this.next = 0; // Resetting context._sent for legacy support of Babel's
          // function.sent implementation.

          this.sent = this._sent = undefined$1;
          this.done = false;
          this.delegate = null;
          this.method = "next";
          this.arg = undefined$1;
          this.tryEntries.forEach(resetTryEntry);

          if (!skipTempReset) {
            for (var name in this) {
              // Not sure about the optimal order of these conditions:
              if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                this[name] = undefined$1;
              }
            }
          }
        },
        stop: function stop() {
          this.done = true;
          var rootEntry = this.tryEntries[0];
          var rootRecord = rootEntry.completion;

          if (rootRecord.type === "throw") {
            throw rootRecord.arg;
          }

          return this.rval;
        },
        dispatchException: function dispatchException(exception) {
          if (this.done) {
            throw exception;
          }

          var context = this;

          function handle(loc, caught) {
            record.type = "throw";
            record.arg = exception;
            context.next = loc;

            if (caught) {
              // If the dispatched exception was caught by a catch block,
              // then let that catch block handle the exception normally.
              context.method = "next";
              context.arg = undefined$1;
            }

            return !!caught;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            var record = entry.completion;

            if (entry.tryLoc === "root") {
              // Exception thrown outside of any try block that could handle
              // it, so set the completion value of the entire function to
              // throw the exception.
              return handle("end");
            }

            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc");
              var hasFinally = hasOwn.call(entry, "finallyLoc");

              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                } else if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                }
              } else if (hasFinally) {
                if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else {
                throw new Error("try statement without catch or finally");
              }
            }
          }
        },
        abrupt: function abrupt(type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }

          if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
            // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
          }

          var record = finallyEntry ? finallyEntry.completion : {};
          record.type = type;
          record.arg = arg;

          if (finallyEntry) {
            this.method = "next";
            this.next = finallyEntry.finallyLoc;
            return ContinueSentinel;
          }

          return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
          if (record.type === "throw") {
            throw record.arg;
          }

          if (record.type === "break" || record.type === "continue") {
            this.next = record.arg;
          } else if (record.type === "return") {
            this.rval = this.arg = record.arg;
            this.method = "return";
            this.next = "end";
          } else if (record.type === "normal" && afterLoc) {
            this.next = afterLoc;
          }

          return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.finallyLoc === finallyLoc) {
              this.complete(entry.completion, entry.afterLoc);
              resetTryEntry(entry);
              return ContinueSentinel;
            }
          }
        },
        "catch": function _catch(tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;

              if (record.type === "throw") {
                var thrown = record.arg;
                resetTryEntry(entry);
              }

              return thrown;
            }
          } // The context.catch method must only be called with a location
          // argument that corresponds to a known catch block.


          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
          this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          };

          if (this.method === "next") {
            // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined$1;
          }

          return ContinueSentinel;
        }
      }; // Regardless of whether this script is executing as a CommonJS module
      // or not, return the runtime object so that we can declare the variable
      // regeneratorRuntime in the outer scope, which allows this module to be
      // injected easily by `bin/regenerator --include-runtime script.js`.

      return exports;
    }( // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
     module.exports );

    try {
      regeneratorRuntime = runtime;
    } catch (accidentalStrictMode) {
      // This module should not be running in strict mode, so the above
      // assignment should always work unless something is misconfigured. Just
      // in case runtime.js accidentally runs in strict mode, in modern engines
      // we can explicitly access globalThis. In older engines we can escape
      // strict mode using a global Function call. This could conceivably fail
      // if a Content Security Policy forbids using Function, but in that case
      // the proper solution is to fix the accidental strict mode problem. If
      // you've misconfigured your bundler to force strict mode and applied a
      // CSP to forbid Function, and you're not willing to fix either of those
      // problems, please detail your unique predicament in a GitHub issue.
      if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
        globalThis.regeneratorRuntime = runtime;
      } else {
        Function("r", "regeneratorRuntime = r")(runtime);
      }
    }
  });

  /*!
   * Vue.js v2.6.14
   * (c) 2014-2021 Evan You
   * Released under the MIT License.
   */

  /*  */
  var emptyObject = Object.freeze({}); // These helpers produce better VM code in JS engines due to their
  // explicitness and function inlining.

  function isUndef(v) {
    return v === undefined || v === null;
  }

  function isDef(v) {
    return v !== undefined && v !== null;
  }

  function isTrue(v) {
    return v === true;
  }

  function isFalse(v) {
    return v === false;
  }
  /**
   * Check if value is primitive.
   */


  function isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' || // $flow-disable-line
    _typeof(value) === 'symbol' || typeof value === 'boolean';
  }
  /**
   * Quick object check - this is primarily used to tell
   * Objects from primitive values when we know the value
   * is a JSON-compliant type.
   */


  function isObject(obj) {
    return obj !== null && _typeof(obj) === 'object';
  }
  /**
   * Get the raw type string of a value, e.g., [object Object].
   */


  var _toString = Object.prototype.toString;

  function toRawType(value) {
    return _toString.call(value).slice(8, -1);
  }
  /**
   * Strict object type check. Only returns true
   * for plain JavaScript objects.
   */


  function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
  }

  function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
  }
  /**
   * Check if val is a valid array index.
   */


  function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
  }

  function isPromise(val) {
    return isDef(val) && typeof val.then === 'function' && typeof val.catch === 'function';
  }
  /**
   * Convert a value to a string that is actually rendered.
   */


  function toString(val) {
    return val == null ? '' : Array.isArray(val) || isPlainObject(val) && val.toString === _toString ? JSON.stringify(val, null, 2) : String(val);
  }
  /**
   * Convert an input value to a number for persistence.
   * If the conversion fails, return original string.
   */


  function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
  }
  /**
   * Make a map and return a function for checking if a key
   * is in that map.
   */


  function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');

    for (var i = 0; i < list.length; i++) {
      map[list[i]] = true;
    }

    return expectsLowerCase ? function (val) {
      return map[val.toLowerCase()];
    } : function (val) {
      return map[val];
    };
  }
  /**
   * Check if a tag is a built-in tag.
   */


  var isBuiltInTag = makeMap('slot,component', true);
  /**
   * Check if an attribute is a reserved attribute.
   */

  var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
  /**
   * Remove an item from an array.
   */

  function remove(arr, item) {
    if (arr.length) {
      var index = arr.indexOf(item);

      if (index > -1) {
        return arr.splice(index, 1);
      }
    }
  }
  /**
   * Check whether an object has the property.
   */


  var hasOwnProperty = Object.prototype.hasOwnProperty;

  function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
  }
  /**
   * Create a cached version of a pure function.
   */


  function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
      var hit = cache[str];
      return hit || (cache[str] = fn(str));
    };
  }
  /**
   * Camelize a hyphen-delimited string.
   */


  var camelizeRE = /-(\w)/g;
  var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) {
      return c ? c.toUpperCase() : '';
    });
  });
  /**
   * Capitalize a string.
   */

  var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  });
  /**
   * Hyphenate a camelCase string.
   */

  var hyphenateRE = /\B([A-Z])/g;
  var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
  });
  /**
   * Simple bind polyfill for environments that do not support it,
   * e.g., PhantomJS 1.x. Technically, we don't need this anymore
   * since native bind is now performant enough in most browsers.
   * But removing it would mean breaking code that was able to run in
   * PhantomJS 1.x, so this must be kept for backward compatibility.
   */

  /* istanbul ignore next */

  function polyfillBind(fn, ctx) {
    function boundFn(a) {
      var l = arguments.length;
      return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
    }

    boundFn._length = fn.length;
    return boundFn;
  }

  function nativeBind(fn, ctx) {
    return fn.bind(ctx);
  }

  var bind = Function.prototype.bind ? nativeBind : polyfillBind;
  /**
   * Convert an Array-like object to a real Array.
   */

  function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);

    while (i--) {
      ret[i] = list[i + start];
    }

    return ret;
  }
  /**
   * Mix properties into target object.
   */


  function extend(to, _from) {
    for (var key in _from) {
      to[key] = _from[key];
    }

    return to;
  }
  /**
   * Merge an Array of Objects into a single Object.
   */


  function toObject(arr) {
    var res = {};

    for (var i = 0; i < arr.length; i++) {
      if (arr[i]) {
        extend(res, arr[i]);
      }
    }

    return res;
  }
  /* eslint-disable no-unused-vars */

  /**
   * Perform no operation.
   * Stubbing args to make Flow happy without leaving useless transpiled code
   * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
   */


  function noop(a, b, c) {}
  /**
   * Always return false.
   */


  var no = function no(a, b, c) {
    return false;
  };
  /* eslint-enable no-unused-vars */

  /**
   * Return the same value.
   */


  var identity = function identity(_) {
    return _;
  };
  /**
   * Generate a string containing static keys from compiler modules.
   */


  function genStaticKeys(modules) {
    return modules.reduce(function (keys, m) {
      return keys.concat(m.staticKeys || []);
    }, []).join(',');
  }
  /**
   * Check if two values are loosely equal - that is,
   * if they are plain objects, do they have the same shape?
   */


  function looseEqual(a, b) {
    if (a === b) {
      return true;
    }

    var isObjectA = isObject(a);
    var isObjectB = isObject(b);

    if (isObjectA && isObjectB) {
      try {
        var isArrayA = Array.isArray(a);
        var isArrayB = Array.isArray(b);

        if (isArrayA && isArrayB) {
          return a.length === b.length && a.every(function (e, i) {
            return looseEqual(e, b[i]);
          });
        } else if (a instanceof Date && b instanceof Date) {
          return a.getTime() === b.getTime();
        } else if (!isArrayA && !isArrayB) {
          var keysA = Object.keys(a);
          var keysB = Object.keys(b);
          return keysA.length === keysB.length && keysA.every(function (key) {
            return looseEqual(a[key], b[key]);
          });
        } else {
          /* istanbul ignore next */
          return false;
        }
      } catch (e) {
        /* istanbul ignore next */
        return false;
      }
    } else if (!isObjectA && !isObjectB) {
      return String(a) === String(b);
    } else {
      return false;
    }
  }
  /**
   * Return the first index at which a loosely equal value can be
   * found in the array (if value is a plain object, the array must
   * contain an object of the same shape), or -1 if it is not present.
   */


  function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
      if (looseEqual(arr[i], val)) {
        return i;
      }
    }

    return -1;
  }
  /**
   * Ensure a function is called only once.
   */


  function once(fn) {
    var called = false;
    return function () {
      if (!called) {
        called = true;
        fn.apply(this, arguments);
      }
    };
  }

  var SSR_ATTR = 'data-server-rendered';
  var ASSET_TYPES = ['component', 'directive', 'filter'];
  var LIFECYCLE_HOOKS = ['beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'beforeDestroy', 'destroyed', 'activated', 'deactivated', 'errorCaptured', 'serverPrefetch'];
  /*  */

  var config = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),

    /**
     * Whether to suppress warnings.
     */
    silent: false,

    /**
     * Show production mode tip message on boot?
     */
    productionTip: "development" !== 'production',

    /**
     * Whether to enable devtools
     */
    devtools: "development" !== 'production',

    /**
     * Whether to record perf
     */
    performance: false,

    /**
     * Error handler for watcher errors
     */
    errorHandler: null,

    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,

    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],

    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),

    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,

    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,

    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,

    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,

    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,

    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,

    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,

    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
  };
  /*  */

  /**
   * unicode letters used for parsing html tags, component names and property paths.
   * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
   * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
   */

  var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
  /**
   * Check if a string starts with $ or _
   */

  function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5F;
  }
  /**
   * Define a property.
   */


  function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
      value: val,
      enumerable: !!enumerable,
      writable: true,
      configurable: true
    });
  }
  /**
   * Parse simple path.
   */


  var bailRE = new RegExp("[^" + unicodeRegExp.source + ".$_\\d]");

  function parsePath(path) {
    if (bailRE.test(path)) {
      return;
    }

    var segments = path.split('.');
    return function (obj) {
      for (var i = 0; i < segments.length; i++) {
        if (!obj) {
          return;
        }

        obj = obj[segments[i]];
      }

      return obj;
    };
  }
  /*  */
  // can we use __proto__?


  var hasProto = ('__proto__' in {}); // Browser environment sniffing

  var inBrowser = typeof window !== 'undefined';
  var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
  var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
  var UA = inBrowser && window.navigator.userAgent.toLowerCase();
  var isIE = UA && /msie|trident/.test(UA);
  var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
  var isEdge = UA && UA.indexOf('edge/') > 0;
  var isAndroid = UA && UA.indexOf('android') > 0 || weexPlatform === 'android';
  var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA) || weexPlatform === 'ios';
  var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
  var isPhantomJS = UA && /phantomjs/.test(UA);
  var isFF = UA && UA.match(/firefox\/(\d+)/); // Firefox has a "watch" function on Object.prototype...

  var nativeWatch = {}.watch;
  var supportsPassive = false;

  if (inBrowser) {
    try {
      var opts = {};
      Object.defineProperty(opts, 'passive', {
        get: function get() {
          /* istanbul ignore next */
          supportsPassive = true;
        }
      }); // https://github.com/facebook/flow/issues/285

      window.addEventListener('test-passive', null, opts);
    } catch (e) {}
  } // this needs to be lazy-evaled because vue may be required before
  // vue-server-renderer can set VUE_ENV


  var _isServer;

  var isServerRendering = function isServerRendering() {
    if (_isServer === undefined) {
      /* istanbul ignore if */
      if (!inBrowser && !inWeex && typeof global !== 'undefined') {
        // detect presence of vue-server-renderer and avoid
        // Webpack shimming the process
        _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
      } else {
        _isServer = false;
      }
    }

    return _isServer;
  }; // detect devtools


  var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
  /* istanbul ignore next */

  function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
  }

  var hasSymbol = typeof Symbol !== 'undefined' && isNative(Symbol) && typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

  var _Set;
  /* istanbul ignore if */
  // $flow-disable-line


  if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
  } else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /*@__PURE__*/function () {
      function Set() {
        this.set = Object.create(null);
      }

      Set.prototype.has = function has(key) {
        return this.set[key] === true;
      };

      Set.prototype.add = function add(key) {
        this.set[key] = true;
      };

      Set.prototype.clear = function clear() {
        this.set = Object.create(null);
      };

      return Set;
    }();
  }
  /*  */


  var warn = noop;
  var tip = noop;
  var generateComponentTrace = noop; // work around flow check

  var formatComponentName = noop;

  {
    var hasConsole = typeof console !== 'undefined';
    var classifyRE = /(?:^|[-_])(\w)/g;

    var classify = function classify(str) {
      return str.replace(classifyRE, function (c) {
        return c.toUpperCase();
      }).replace(/[-_]/g, '');
    };

    warn = function warn(msg, vm) {
      var trace = vm ? generateComponentTrace(vm) : '';

      if (config.warnHandler) {
        config.warnHandler.call(null, msg, vm, trace);
      } else if (hasConsole && !config.silent) {
        console.error("[Vue warn]: " + msg + trace);
      }
    };

    tip = function tip(msg, vm) {
      if (hasConsole && !config.silent) {
        console.warn("[Vue tip]: " + msg + (vm ? generateComponentTrace(vm) : ''));
      }
    };

    formatComponentName = function formatComponentName(vm, includeFile) {
      if (vm.$root === vm) {
        return '<Root>';
      }

      var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm;
      var name = options.name || options._componentTag;
      var file = options.__file;

      if (!name && file) {
        var match = file.match(/([^/\\]+)\.vue$/);
        name = match && match[1];
      }

      return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : '');
    };

    var repeat = function repeat(str, n) {
      var res = '';

      while (n) {
        if (n % 2 === 1) {
          res += str;
        }

        if (n > 1) {
          str += str;
        }

        n >>= 1;
      }

      return res;
    };

    generateComponentTrace = function generateComponentTrace(vm) {
      if (vm._isVue && vm.$parent) {
        var tree = [];
        var currentRecursiveSequence = 0;

        while (vm) {
          if (tree.length > 0) {
            var last = tree[tree.length - 1];

            if (last.constructor === vm.constructor) {
              currentRecursiveSequence++;
              vm = vm.$parent;
              continue;
            } else if (currentRecursiveSequence > 0) {
              tree[tree.length - 1] = [last, currentRecursiveSequence];
              currentRecursiveSequence = 0;
            }
          }

          tree.push(vm);
          vm = vm.$parent;
        }

        return '\n\nfound in\n\n' + tree.map(function (vm, i) {
          return "" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm) ? formatComponentName(vm[0]) + "... (" + vm[1] + " recursive calls)" : formatComponentName(vm));
        }).join('\n');
      } else {
        return "\n\n(found in " + formatComponentName(vm) + ")";
      }
    };
  }
  /*  */


  var uid = 0;
  /**
   * A dep is an observable that can have multiple
   * directives subscribing to it.
   */

  var Dep = function Dep() {
    this.id = uid++;
    this.subs = [];
  };

  Dep.prototype.addSub = function addSub(sub) {
    this.subs.push(sub);
  };

  Dep.prototype.removeSub = function removeSub(sub) {
    remove(this.subs, sub);
  };

  Dep.prototype.depend = function depend() {
    if (Dep.target) {
      Dep.target.addDep(this);
    }
  };

  Dep.prototype.notify = function notify() {
    // stabilize the subscriber list first
    var subs = this.subs.slice();

    if ( !config.async) {
      // subs aren't sorted in scheduler if not running async
      // we need to sort them now to make sure they fire in correct
      // order
      subs.sort(function (a, b) {
        return a.id - b.id;
      });
    }

    for (var i = 0, l = subs.length; i < l; i++) {
      subs[i].update();
    }
  }; // The current target watcher being evaluated.
  // This is globally unique because only one watcher
  // can be evaluated at a time.


  Dep.target = null;
  var targetStack = [];

  function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
  }

  function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
  }
  /*  */


  var VNode = function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
    this.tag = tag;
    this.data = data;
    this.children = children;
    this.text = text;
    this.elm = elm;
    this.ns = undefined;
    this.context = context;
    this.fnContext = undefined;
    this.fnOptions = undefined;
    this.fnScopeId = undefined;
    this.key = data && data.key;
    this.componentOptions = componentOptions;
    this.componentInstance = undefined;
    this.parent = undefined;
    this.raw = false;
    this.isStatic = false;
    this.isRootInsert = true;
    this.isComment = false;
    this.isCloned = false;
    this.isOnce = false;
    this.asyncFactory = asyncFactory;
    this.asyncMeta = undefined;
    this.isAsyncPlaceholder = false;
  };

  var prototypeAccessors = {
    child: {
      configurable: true
    }
  }; // DEPRECATED: alias for componentInstance for backwards compat.

  /* istanbul ignore next */

  prototypeAccessors.child.get = function () {
    return this.componentInstance;
  };

  Object.defineProperties(VNode.prototype, prototypeAccessors);

  var createEmptyVNode = function createEmptyVNode(text) {
    if (text === void 0) text = '';
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
  };

  function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
  } // optimized shallow clone
  // used for static nodes and slot nodes because they may be reused across
  // multiple renders, cloning them avoids errors when DOM manipulations rely
  // on their elm reference.


  function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data, // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
  }
  /*
   * not type checking this file because flow doesn't play well with
   * dynamically accessing methods on Array prototype
   */


  var arrayProto = Array.prototype;
  var arrayMethods = Object.create(arrayProto);
  var methodsToPatch = ['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'];
  /**
   * Intercept mutating methods and emit events
   */

  methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
      var args = [],
          len = arguments.length;

      while (len--) {
        args[len] = arguments[len];
      }

      var result = original.apply(this, args);
      var ob = this.__ob__;
      var inserted;

      switch (method) {
        case 'push':
        case 'unshift':
          inserted = args;
          break;

        case 'splice':
          inserted = args.slice(2);
          break;
      }

      if (inserted) {
        ob.observeArray(inserted);
      } // notify change


      ob.dep.notify();
      return result;
    });
  });
  /*  */

  var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
  /**
   * In some cases we may want to disable observation inside a component's
   * update computation.
   */

  var shouldObserve = true;

  function toggleObserving(value) {
    shouldObserve = value;
  }
  /**
   * Observer class that is attached to each observed
   * object. Once attached, the observer converts the target
   * object's property keys into getter/setters that
   * collect dependencies and dispatch updates.
   */


  var Observer = function Observer(value) {
    this.value = value;
    this.dep = new Dep();
    this.vmCount = 0;
    def(value, '__ob__', this);

    if (Array.isArray(value)) {
      if (hasProto) {
        protoAugment(value, arrayMethods);
      } else {
        copyAugment(value, arrayMethods, arrayKeys);
      }

      this.observeArray(value);
    } else {
      this.walk(value);
    }
  };
  /**
   * Walk through all properties and convert them into
   * getter/setters. This method should only be called when
   * value type is Object.
   */


  Observer.prototype.walk = function walk(obj) {
    var keys = Object.keys(obj);

    for (var i = 0; i < keys.length; i++) {
      defineReactive$$1(obj, keys[i]);
    }
  };
  /**
   * Observe a list of Array items.
   */


  Observer.prototype.observeArray = function observeArray(items) {
    for (var i = 0, l = items.length; i < l; i++) {
      observe(items[i]);
    }
  }; // helpers

  /**
   * Augment a target Object or Array by intercepting
   * the prototype chain using __proto__
   */


  function protoAugment(target, src) {
    /* eslint-disable no-proto */
    target.__proto__ = src;
    /* eslint-enable no-proto */
  }
  /**
   * Augment a target Object or Array by defining
   * hidden properties.
   */

  /* istanbul ignore next */


  function copyAugment(target, src, keys) {
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      def(target, key, src[key]);
    }
  }
  /**
   * Attempt to create an observer instance for a value,
   * returns the new observer if successfully observed,
   * or the existing observer if the value already has one.
   */


  function observe(value, asRootData) {
    if (!isObject(value) || value instanceof VNode) {
      return;
    }

    var ob;

    if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
      ob = value.__ob__;
    } else if (shouldObserve && !isServerRendering() && (Array.isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
      ob = new Observer(value);
    }

    if (asRootData && ob) {
      ob.vmCount++;
    }

    return ob;
  }
  /**
   * Define a reactive property on an Object.
   */


  function defineReactive$$1(obj, key, val, customSetter, shallow) {
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);

    if (property && property.configurable === false) {
      return;
    } // cater for pre-defined getter/setters


    var getter = property && property.get;
    var setter = property && property.set;

    if ((!getter || setter) && arguments.length === 2) {
      val = obj[key];
    }

    var childOb = !shallow && observe(val);
    Object.defineProperty(obj, key, {
      enumerable: true,
      configurable: true,
      get: function reactiveGetter() {
        var value = getter ? getter.call(obj) : val;

        if (Dep.target) {
          dep.depend();

          if (childOb) {
            childOb.dep.depend();

            if (Array.isArray(value)) {
              dependArray(value);
            }
          }
        }

        return value;
      },
      set: function reactiveSetter(newVal) {
        var value = getter ? getter.call(obj) : val;
        /* eslint-disable no-self-compare */

        if (newVal === value || newVal !== newVal && value !== value) {
          return;
        }
        /* eslint-enable no-self-compare */


        if ( customSetter) {
          customSetter();
        } // #7981: for accessor properties without setter


        if (getter && !setter) {
          return;
        }

        if (setter) {
          setter.call(obj, newVal);
        } else {
          val = newVal;
        }

        childOb = !shallow && observe(newVal);
        dep.notify();
      }
    });
  }
  /**
   * Set a property on an object. Adds the new property and
   * triggers change notification if the property doesn't
   * already exist.
   */


  function set(target, key, val) {
    if ( (isUndef(target) || isPrimitive(target))) {
      warn("Cannot set reactive property on undefined, null, or primitive value: " + target);
    }

    if (Array.isArray(target) && isValidArrayIndex(key)) {
      target.length = Math.max(target.length, key);
      target.splice(key, 1, val);
      return val;
    }

    if (key in target && !(key in Object.prototype)) {
      target[key] = val;
      return val;
    }

    var ob = target.__ob__;

    if (target._isVue || ob && ob.vmCount) {
       warn('Avoid adding reactive properties to a Vue instance or its root $data ' + 'at runtime - declare it upfront in the data option.');
      return val;
    }

    if (!ob) {
      target[key] = val;
      return val;
    }

    defineReactive$$1(ob.value, key, val);
    ob.dep.notify();
    return val;
  }
  /**
   * Delete a property and trigger change if necessary.
   */


  function del(target, key) {
    if ( (isUndef(target) || isPrimitive(target))) {
      warn("Cannot delete reactive property on undefined, null, or primitive value: " + target);
    }

    if (Array.isArray(target) && isValidArrayIndex(key)) {
      target.splice(key, 1);
      return;
    }

    var ob = target.__ob__;

    if (target._isVue || ob && ob.vmCount) {
       warn('Avoid deleting properties on a Vue instance or its root $data ' + '- just set it to null.');
      return;
    }

    if (!hasOwn(target, key)) {
      return;
    }

    delete target[key];

    if (!ob) {
      return;
    }

    ob.dep.notify();
  }
  /**
   * Collect dependencies on array elements when the array is touched, since
   * we cannot intercept array element access like property getters.
   */


  function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
      e = value[i];
      e && e.__ob__ && e.__ob__.dep.depend();

      if (Array.isArray(e)) {
        dependArray(e);
      }
    }
  }
  /*  */

  /**
   * Option overwriting strategies are functions that handle
   * how to merge a parent option value and a child option
   * value into the final value.
   */


  var strats = config.optionMergeStrategies;
  /**
   * Options with restrictions
   */

  {
    strats.el = strats.propsData = function (parent, child, vm, key) {
      if (!vm) {
        warn("option \"" + key + "\" can only be used during instance " + 'creation with the `new` keyword.');
      }

      return defaultStrat(parent, child);
    };
  }
  /**
   * Helper that recursively merges two data objects together.
   */


  function mergeData(to, from) {
    if (!from) {
      return to;
    }

    var key, toVal, fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);

    for (var i = 0; i < keys.length; i++) {
      key = keys[i]; // in case the object is already observed...

      if (key === '__ob__') {
        continue;
      }

      toVal = to[key];
      fromVal = from[key];

      if (!hasOwn(to, key)) {
        set(to, key, fromVal);
      } else if (toVal !== fromVal && isPlainObject(toVal) && isPlainObject(fromVal)) {
        mergeData(toVal, fromVal);
      }
    }

    return to;
  }
  /**
   * Data
   */


  function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
      // in a Vue.extend merge, both should be functions
      if (!childVal) {
        return parentVal;
      }

      if (!parentVal) {
        return childVal;
      } // when parentVal & childVal are both present,
      // we need to return a function that returns the
      // merged result of both functions... no need to
      // check if parentVal is a function here because
      // it has to be a function to pass previous merges.


      return function mergedDataFn() {
        return mergeData(typeof childVal === 'function' ? childVal.call(this, this) : childVal, typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal);
      };
    } else {
      return function mergedInstanceDataFn() {
        // instance merge
        var instanceData = typeof childVal === 'function' ? childVal.call(vm, vm) : childVal;
        var defaultData = typeof parentVal === 'function' ? parentVal.call(vm, vm) : parentVal;

        if (instanceData) {
          return mergeData(instanceData, defaultData);
        } else {
          return defaultData;
        }
      };
    }
  }

  strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
      if (childVal && typeof childVal !== 'function') {
         warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
        return parentVal;
      }

      return mergeDataOrFn(parentVal, childVal);
    }

    return mergeDataOrFn(parentVal, childVal, vm);
  };
  /**
   * Hooks and props are merged as arrays.
   */


  function mergeHook(parentVal, childVal) {
    var res = childVal ? parentVal ? parentVal.concat(childVal) : Array.isArray(childVal) ? childVal : [childVal] : parentVal;
    return res ? dedupeHooks(res) : res;
  }

  function dedupeHooks(hooks) {
    var res = [];

    for (var i = 0; i < hooks.length; i++) {
      if (res.indexOf(hooks[i]) === -1) {
        res.push(hooks[i]);
      }
    }

    return res;
  }

  LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeHook;
  });
  /**
   * Assets
   *
   * When a vm is present (instance creation), we need to do
   * a three-way merge between constructor options, instance
   * options and parent options.
   */

  function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);

    if (childVal) {
       assertObjectType(key, childVal, vm);
      return extend(res, childVal);
    } else {
      return res;
    }
  }

  ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
  });
  /**
   * Watchers.
   *
   * Watchers hashes should not overwrite one
   * another, so we merge them as arrays.
   */

  strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    if (parentVal === nativeWatch) {
      parentVal = undefined;
    }

    if (childVal === nativeWatch) {
      childVal = undefined;
    }
    /* istanbul ignore if */


    if (!childVal) {
      return Object.create(parentVal || null);
    }

    {
      assertObjectType(key, childVal, vm);
    }

    if (!parentVal) {
      return childVal;
    }

    var ret = {};
    extend(ret, parentVal);

    for (var key$1 in childVal) {
      var parent = ret[key$1];
      var child = childVal[key$1];

      if (parent && !Array.isArray(parent)) {
        parent = [parent];
      }

      ret[key$1] = parent ? parent.concat(child) : Array.isArray(child) ? child : [child];
    }

    return ret;
  };
  /**
   * Other object hashes.
   */


  strats.props = strats.methods = strats.inject = strats.computed = function (parentVal, childVal, vm, key) {
    if (childVal && "development" !== 'production') {
      assertObjectType(key, childVal, vm);
    }

    if (!parentVal) {
      return childVal;
    }

    var ret = Object.create(null);
    extend(ret, parentVal);

    if (childVal) {
      extend(ret, childVal);
    }

    return ret;
  };

  strats.provide = mergeDataOrFn;
  /**
   * Default strategy.
   */

  var defaultStrat = function defaultStrat(parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
  };
  /**
   * Validate component names
   */


  function checkComponents(options) {
    for (var key in options.components) {
      validateComponentName(key);
    }
  }

  function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_" + unicodeRegExp.source + "]*$").test(name)) {
      warn('Invalid component name: "' + name + '". Component names ' + 'should conform to valid custom element name in html5 specification.');
    }

    if (isBuiltInTag(name) || config.isReservedTag(name)) {
      warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + name);
    }
  }
  /**
   * Ensure all props option syntax are normalized into the
   * Object-based format.
   */


  function normalizeProps(options, vm) {
    var props = options.props;

    if (!props) {
      return;
    }

    var res = {};
    var i, val, name;

    if (Array.isArray(props)) {
      i = props.length;

      while (i--) {
        val = props[i];

        if (typeof val === 'string') {
          name = camelize(val);
          res[name] = {
            type: null
          };
        } else {
          warn('props must be strings when using array syntax.');
        }
      }
    } else if (isPlainObject(props)) {
      for (var key in props) {
        val = props[key];
        name = camelize(key);
        res[name] = isPlainObject(val) ? val : {
          type: val
        };
      }
    } else {
      warn("Invalid value for option \"props\": expected an Array or an Object, " + "but got " + toRawType(props) + ".", vm);
    }

    options.props = res;
  }
  /**
   * Normalize all injections into Object-based format
   */


  function normalizeInject(options, vm) {
    var inject = options.inject;

    if (!inject) {
      return;
    }

    var normalized = options.inject = {};

    if (Array.isArray(inject)) {
      for (var i = 0; i < inject.length; i++) {
        normalized[inject[i]] = {
          from: inject[i]
        };
      }
    } else if (isPlainObject(inject)) {
      for (var key in inject) {
        var val = inject[key];
        normalized[key] = isPlainObject(val) ? extend({
          from: key
        }, val) : {
          from: val
        };
      }
    } else {
      warn("Invalid value for option \"inject\": expected an Array or an Object, " + "but got " + toRawType(inject) + ".", vm);
    }
  }
  /**
   * Normalize raw function directives into object format.
   */


  function normalizeDirectives(options) {
    var dirs = options.directives;

    if (dirs) {
      for (var key in dirs) {
        var def$$1 = dirs[key];

        if (typeof def$$1 === 'function') {
          dirs[key] = {
            bind: def$$1,
            update: def$$1
          };
        }
      }
    }
  }

  function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
      warn("Invalid value for option \"" + name + "\": expected an Object, " + "but got " + toRawType(value) + ".", vm);
    }
  }
  /**
   * Merge two option objects into a new one.
   * Core utility used in both instantiation and inheritance.
   */


  function mergeOptions(parent, child, vm) {
    {
      checkComponents(child);
    }

    if (typeof child === 'function') {
      child = child.options;
    }

    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives(child); // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.

    if (!child._base) {
      if (child.extends) {
        parent = mergeOptions(parent, child.extends, vm);
      }

      if (child.mixins) {
        for (var i = 0, l = child.mixins.length; i < l; i++) {
          parent = mergeOptions(parent, child.mixins[i], vm);
        }
      }
    }

    var options = {};
    var key;

    for (key in parent) {
      mergeField(key);
    }

    for (key in child) {
      if (!hasOwn(parent, key)) {
        mergeField(key);
      }
    }

    function mergeField(key) {
      var strat = strats[key] || defaultStrat;
      options[key] = strat(parent[key], child[key], vm, key);
    }

    return options;
  }
  /**
   * Resolve an asset.
   * This function is used because child instances need access
   * to assets defined in its ancestor chain.
   */


  function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
      return;
    }

    var assets = options[type]; // check local registration variations first

    if (hasOwn(assets, id)) {
      return assets[id];
    }

    var camelizedId = camelize(id);

    if (hasOwn(assets, camelizedId)) {
      return assets[camelizedId];
    }

    var PascalCaseId = capitalize(camelizedId);

    if (hasOwn(assets, PascalCaseId)) {
      return assets[PascalCaseId];
    } // fallback to prototype chain


    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];

    if ( warnMissing && !res) {
      warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
    }

    return res;
  }
  /*  */


  function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key]; // boolean casting

    var booleanIndex = getTypeIndex(Boolean, prop.type);

    if (booleanIndex > -1) {
      if (absent && !hasOwn(prop, 'default')) {
        value = false;
      } else if (value === '' || value === hyphenate(key)) {
        // only cast empty string / same name to boolean if
        // boolean has higher priority
        var stringIndex = getTypeIndex(String, prop.type);

        if (stringIndex < 0 || booleanIndex < stringIndex) {
          value = true;
        }
      }
    } // check default value


    if (value === undefined) {
      value = getPropDefaultValue(vm, prop, key); // since the default value is a fresh copy,
      // make sure to observe it.

      var prevShouldObserve = shouldObserve;
      toggleObserving(true);
      observe(value);
      toggleObserving(prevShouldObserve);
    }

    {
      assertProp(prop, key, value, vm, absent);
    }

    return value;
  }
  /**
   * Get the default value of a prop.
   */


  function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
      return undefined;
    }

    var def = prop.default; // warn against non-factory defaults for Object & Array

    if ( isObject(def)) {
      warn('Invalid default value for prop "' + key + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
    } // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger


    if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) {
      return vm._props[key];
    } // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context


    return typeof def === 'function' && getType(prop.type) !== 'Function' ? def.call(vm) : def;
  }
  /**
   * Assert whether a prop is valid.
   */


  function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
      warn('Missing required prop: "' + name + '"', vm);
      return;
    }

    if (value == null && !prop.required) {
      return;
    }

    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];

    if (type) {
      if (!Array.isArray(type)) {
        type = [type];
      }

      for (var i = 0; i < type.length && !valid; i++) {
        var assertedType = assertType(value, type[i], vm);
        expectedTypes.push(assertedType.expectedType || '');
        valid = assertedType.valid;
      }
    }

    var haveExpectedTypes = expectedTypes.some(function (t) {
      return t;
    });

    if (!valid && haveExpectedTypes) {
      warn(getInvalidTypeMessage(name, value, expectedTypes), vm);
      return;
    }

    var validator = prop.validator;

    if (validator) {
      if (!validator(value)) {
        warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
      }
    }
  }

  var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

  function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);

    if (simpleCheckRE.test(expectedType)) {
      var t = _typeof(value);

      valid = t === expectedType.toLowerCase(); // for primitive wrapper objects

      if (!valid && t === 'object') {
        valid = value instanceof type;
      }
    } else if (expectedType === 'Object') {
      valid = isPlainObject(value);
    } else if (expectedType === 'Array') {
      valid = Array.isArray(value);
    } else {
      try {
        valid = value instanceof type;
      } catch (e) {
        warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
        valid = false;
      }
    }

    return {
      valid: valid,
      expectedType: expectedType
    };
  }

  var functionTypeCheckRE = /^\s*function (\w+)/;
  /**
   * Use function string name to check built-in types,
   * because a simple equality check will fail when running
   * across different vms / iframes.
   */

  function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
  }

  function isSameType(a, b) {
    return getType(a) === getType(b);
  }

  function getTypeIndex(type, expectedTypes) {
    if (!Array.isArray(expectedTypes)) {
      return isSameType(expectedTypes, type) ? 0 : -1;
    }

    for (var i = 0, len = expectedTypes.length; i < len; i++) {
      if (isSameType(expectedTypes[i], type)) {
        return i;
      }
    }

    return -1;
  }

  function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"" + name + "\"." + " Expected " + expectedTypes.map(capitalize).join(', ');
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value); // check if we need to specify expected value

    if (expectedTypes.length === 1 && isExplicable(expectedType) && isExplicable(_typeof(value)) && !isBoolean(expectedType, receivedType)) {
      message += " with value " + styleValue(value, expectedType);
    }

    message += ", got " + receivedType + " "; // check if we need to specify received value

    if (isExplicable(receivedType)) {
      message += "with value " + styleValue(value, receivedType) + ".";
    }

    return message;
  }

  function styleValue(value, type) {
    if (type === 'String') {
      return "\"" + value + "\"";
    } else if (type === 'Number') {
      return "" + Number(value);
    } else {
      return "" + value;
    }
  }

  var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];

  function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) {
      return value.toLowerCase() === elem;
    });
  }

  function isBoolean() {
    var args = [],
        len = arguments.length;

    while (len--) {
      args[len] = arguments[len];
    }

    return args.some(function (elem) {
      return elem.toLowerCase() === 'boolean';
    });
  }
  /*  */


  function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();

    try {
      if (vm) {
        var cur = vm;

        while (cur = cur.$parent) {
          var hooks = cur.$options.errorCaptured;

          if (hooks) {
            for (var i = 0; i < hooks.length; i++) {
              try {
                var capture = hooks[i].call(cur, err, vm, info) === false;

                if (capture) {
                  return;
                }
              } catch (e) {
                globalHandleError(e, cur, 'errorCaptured hook');
              }
            }
          }
        }
      }

      globalHandleError(err, vm, info);
    } finally {
      popTarget();
    }
  }

  function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;

    try {
      res = args ? handler.apply(context, args) : handler.call(context);

      if (res && !res._isVue && isPromise(res) && !res._handled) {
        res.catch(function (e) {
          return handleError(e, vm, info + " (Promise/async)");
        }); // issue #9511
        // avoid catch triggering multiple times when nested calls

        res._handled = true;
      }
    } catch (e) {
      handleError(e, vm, info);
    }

    return res;
  }

  function globalHandleError(err, vm, info) {
    if (config.errorHandler) {
      try {
        return config.errorHandler.call(null, err, vm, info);
      } catch (e) {
        // if the user intentionally throws the original error in the handler,
        // do not log it twice
        if (e !== err) {
          logError(e, null, 'config.errorHandler');
        }
      }
    }

    logError(err, vm, info);
  }

  function logError(err, vm, info) {
    {
      warn("Error in " + info + ": \"" + err.toString() + "\"", vm);
    }
    /* istanbul ignore else */


    if ((inBrowser || inWeex) && typeof console !== 'undefined') {
      console.error(err);
    } else {
      throw err;
    }
  }
  /*  */


  var isUsingMicroTask = false;
  var callbacks = [];
  var pending = false;

  function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;

    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  } // Here we have async deferring wrappers using microtasks.
  // In 2.5 we used (macro) tasks (in combination with microtasks).
  // However, it has subtle problems when state is changed right before repaint
  // (e.g. #6813, out-in transitions).
  // Also, using (macro) tasks in event handler would cause some weird behaviors
  // that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
  // So we now use microtasks everywhere, again.
  // A major drawback of this tradeoff is that there are some scenarios
  // where microtasks have too high a priority and fire in between supposedly
  // sequential events (e.g. #4521, #6690, which have workarounds)
  // or even between bubbling of the same event (#6566).


  var timerFunc; // The nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:

  /* istanbul ignore next, $flow-disable-line */

  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();

    timerFunc = function timerFunc() {
      p.then(flushCallbacks); // In problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.

      if (isIOS) {
        setTimeout(noop);
      }
    };

    isUsingMicroTask = true;
  } else if (!isIE && typeof MutationObserver !== 'undefined' && (isNative(MutationObserver) || // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });

    timerFunc = function timerFunc() {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };

    isUsingMicroTask = true;
  } else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function timerFunc() {
      setImmediate(flushCallbacks);
    };
  } else {
    // Fallback to setTimeout.
    timerFunc = function timerFunc() {
      setTimeout(flushCallbacks, 0);
    };
  }

  function nextTick(cb, ctx) {
    var _resolve;

    callbacks.push(function () {
      if (cb) {
        try {
          cb.call(ctx);
        } catch (e) {
          handleError(e, ctx, 'nextTick');
        }
      } else if (_resolve) {
        _resolve(ctx);
      }
    });

    if (!pending) {
      pending = true;
      timerFunc();
    } // $flow-disable-line


    if (!cb && typeof Promise !== 'undefined') {
      return new Promise(function (resolve) {
        _resolve = resolve;
      });
    }
  }
  /*  */


  var mark;
  var measure;

  {
    var perf = inBrowser && window.performance;
    /* istanbul ignore if */

    if (perf && perf.mark && perf.measure && perf.clearMarks && perf.clearMeasures) {
      mark = function mark(tag) {
        return perf.mark(tag);
      };

      measure = function measure(name, startTag, endTag) {
        perf.measure(name, startTag, endTag);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag); // perf.clearMeasures(name)
      };
    }
  }
  /* not type checking this file because flow doesn't play well with Proxy */


  var initProxy;

  {
    var allowedGlobals = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' + 'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' + 'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' + 'require' // for Webpack/Browserify
    );

    var warnNonPresent = function warnNonPresent(target, key) {
      warn("Property or method \"" + key + "\" is not defined on the instance but " + 'referenced during render. Make sure that this property is reactive, ' + 'either in the data option, or for class-based components, by ' + 'initializing the property. ' + 'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };

    var warnReservedPrefix = function warnReservedPrefix(target, key) {
      warn("Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " + 'properties starting with "$" or "_" are not proxied in the Vue instance to ' + 'prevent conflicts with Vue internals. ' + 'See: https://vuejs.org/v2/api/#data', target);
    };

    var hasProxy = typeof Proxy !== 'undefined' && isNative(Proxy);

    if (hasProxy) {
      var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
      config.keyCodes = new Proxy(config.keyCodes, {
        set: function set(target, key, value) {
          if (isBuiltInModifier(key)) {
            warn("Avoid overwriting built-in modifier in config.keyCodes: ." + key);
            return false;
          } else {
            target[key] = value;
            return true;
          }
        }
      });
    }

    var hasHandler = {
      has: function has(target, key) {
        var has = (key in target);
        var isAllowed = allowedGlobals(key) || typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data);

        if (!has && !isAllowed) {
          if (key in target.$data) {
            warnReservedPrefix(target, key);
          } else {
            warnNonPresent(target, key);
          }
        }

        return has || !isAllowed;
      }
    };
    var getHandler = {
      get: function get(target, key) {
        if (typeof key === 'string' && !(key in target)) {
          if (key in target.$data) {
            warnReservedPrefix(target, key);
          } else {
            warnNonPresent(target, key);
          }
        }

        return target[key];
      }
    };

    initProxy = function initProxy(vm) {
      if (hasProxy) {
        // determine which proxy handler to use
        var options = vm.$options;
        var handlers = options.render && options.render._withStripped ? getHandler : hasHandler;
        vm._renderProxy = new Proxy(vm, handlers);
      } else {
        vm._renderProxy = vm;
      }
    };
  }
  /*  */


  var seenObjects = new _Set();
  /**
   * Recursively traverse an object to evoke all converted
   * getters, so that every nested property inside the object
   * is collected as a "deep" dependency.
   */

  function traverse(val) {
    _traverse(val, seenObjects);

    seenObjects.clear();
  }

  function _traverse(val, seen) {
    var i, keys;
    var isA = Array.isArray(val);

    if (!isA && !isObject(val) || Object.isFrozen(val) || val instanceof VNode) {
      return;
    }

    if (val.__ob__) {
      var depId = val.__ob__.dep.id;

      if (seen.has(depId)) {
        return;
      }

      seen.add(depId);
    }

    if (isA) {
      i = val.length;

      while (i--) {
        _traverse(val[i], seen);
      }
    } else {
      keys = Object.keys(val);
      i = keys.length;

      while (i--) {
        _traverse(val[keys[i]], seen);
      }
    }
  }
  /*  */


  var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first

    name = once$$1 ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
      name: name,
      once: once$$1,
      capture: capture,
      passive: passive
    };
  });

  function createFnInvoker(fns, vm) {
    function invoker() {
      var arguments$1 = arguments;
      var fns = invoker.fns;

      if (Array.isArray(fns)) {
        var cloned = fns.slice();

        for (var i = 0; i < cloned.length; i++) {
          invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
        }
      } else {
        // return handler return value for single handlers
        return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
      }
    }

    invoker.fns = fns;
    return invoker;
  }

  function updateListeners(on, oldOn, add, remove$$1, createOnceHandler, vm) {
    var name, def$$1, cur, old, event;

    for (name in on) {
      def$$1 = cur = on[name];
      old = oldOn[name];
      event = normalizeEvent(name);

      if (isUndef(cur)) {
         warn("Invalid handler for event \"" + event.name + "\": got " + String(cur), vm);
      } else if (isUndef(old)) {
        if (isUndef(cur.fns)) {
          cur = on[name] = createFnInvoker(cur, vm);
        }

        if (isTrue(event.once)) {
          cur = on[name] = createOnceHandler(event.name, cur, event.capture);
        }

        add(event.name, cur, event.capture, event.passive, event.params);
      } else if (cur !== old) {
        old.fns = cur;
        on[name] = old;
      }
    }

    for (name in oldOn) {
      if (isUndef(on[name])) {
        event = normalizeEvent(name);
        remove$$1(event.name, oldOn[name], event.capture);
      }
    }
  }
  /*  */


  function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
      def = def.data.hook || (def.data.hook = {});
    }

    var invoker;
    var oldHook = def[hookKey];

    function wrappedHook() {
      hook.apply(this, arguments); // important: remove merged hook to ensure it's called only once
      // and prevent memory leak

      remove(invoker.fns, wrappedHook);
    }

    if (isUndef(oldHook)) {
      // no existing hook
      invoker = createFnInvoker([wrappedHook]);
    } else {
      /* istanbul ignore if */
      if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
        // already a merged invoker
        invoker = oldHook;
        invoker.fns.push(wrappedHook);
      } else {
        // existing plain hook
        invoker = createFnInvoker([oldHook, wrappedHook]);
      }
    }

    invoker.merged = true;
    def[hookKey] = invoker;
  }
  /*  */


  function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;

    if (isUndef(propOptions)) {
      return;
    }

    var res = {};
    var attrs = data.attrs;
    var props = data.props;

    if (isDef(attrs) || isDef(props)) {
      for (var key in propOptions) {
        var altKey = hyphenate(key);

        {
          var keyInLowerCase = key.toLowerCase();

          if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
            tip("Prop \"" + keyInLowerCase + "\" is passed to component " + formatComponentName(tag || Ctor) + ", but the declared prop name is" + " \"" + key + "\". " + "Note that HTML attributes are case-insensitive and camelCased " + "props need to use their kebab-case equivalents when using in-DOM " + "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\".");
          }
        }

        checkProp(res, props, key, altKey, true) || checkProp(res, attrs, key, altKey, false);
      }
    }

    return res;
  }

  function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
      if (hasOwn(hash, key)) {
        res[key] = hash[key];

        if (!preserve) {
          delete hash[key];
        }

        return true;
      } else if (hasOwn(hash, altKey)) {
        res[key] = hash[altKey];

        if (!preserve) {
          delete hash[altKey];
        }

        return true;
      }
    }

    return false;
  }
  /*  */
  // The template compiler attempts to minimize the need for normalization by
  // statically analyzing the template at compile time.
  //
  // For plain HTML markup, normalization can be completely skipped because the
  // generated render function is guaranteed to return Array<VNode>. There are
  // two cases where extra normalization is needed:
  // 1. When the children contains components - because a functional component
  // may return an Array instead of a single root. In this case, just a simple
  // normalization is needed - if any child is an Array, we flatten the whole
  // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
  // because functional components already normalize their own children.


  function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
      if (Array.isArray(children[i])) {
        return Array.prototype.concat.apply([], children);
      }
    }

    return children;
  } // 2. When the children contains constructs that always generated nested Arrays,
  // e.g. <template>, <slot>, v-for, or when the children is provided by user
  // with hand-written render functions / JSX. In such cases a full normalization
  // is needed to cater to all possible types of children values.


  function normalizeChildren(children) {
    return isPrimitive(children) ? [createTextVNode(children)] : Array.isArray(children) ? normalizeArrayChildren(children) : undefined;
  }

  function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
  }

  function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;

    for (i = 0; i < children.length; i++) {
      c = children[i];

      if (isUndef(c) || typeof c === 'boolean') {
        continue;
      }

      lastIndex = res.length - 1;
      last = res[lastIndex]; //  nested

      if (Array.isArray(c)) {
        if (c.length > 0) {
          c = normalizeArrayChildren(c, (nestedIndex || '') + "_" + i); // merge adjacent text nodes

          if (isTextNode(c[0]) && isTextNode(last)) {
            res[lastIndex] = createTextVNode(last.text + c[0].text);
            c.shift();
          }

          res.push.apply(res, c);
        }
      } else if (isPrimitive(c)) {
        if (isTextNode(last)) {
          // merge adjacent text nodes
          // this is necessary for SSR hydration because text nodes are
          // essentially merged when rendered to HTML strings
          res[lastIndex] = createTextVNode(last.text + c);
        } else if (c !== '') {
          // convert primitive to vnode
          res.push(createTextVNode(c));
        }
      } else {
        if (isTextNode(c) && isTextNode(last)) {
          // merge adjacent text nodes
          res[lastIndex] = createTextVNode(last.text + c.text);
        } else {
          // default key for nested array children (likely generated by v-for)
          if (isTrue(children._isVList) && isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
            c.key = "__vlist" + nestedIndex + "_" + i + "__";
          }

          res.push(c);
        }
      }
    }

    return res;
  }
  /*  */


  function initProvide(vm) {
    var provide = vm.$options.provide;

    if (provide) {
      vm._provided = typeof provide === 'function' ? provide.call(vm) : provide;
    }
  }

  function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);

    if (result) {
      toggleObserving(false);
      Object.keys(result).forEach(function (key) {
        /* istanbul ignore else */
        {
          defineReactive$$1(vm, key, result[key], function () {
            warn("Avoid mutating an injected value directly since the changes will be " + "overwritten whenever the provided component re-renders. " + "injection being mutated: \"" + key + "\"", vm);
          });
        }
      });
      toggleObserving(true);
    }
  }

  function resolveInject(inject, vm) {
    if (inject) {
      // inject is :any because flow is not smart enough to figure out cached
      var result = Object.create(null);
      var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i]; // #6574 in case the inject object is observed...

        if (key === '__ob__') {
          continue;
        }

        var provideKey = inject[key].from;
        var source = vm;

        while (source) {
          if (source._provided && hasOwn(source._provided, provideKey)) {
            result[key] = source._provided[provideKey];
            break;
          }

          source = source.$parent;
        }

        if (!source) {
          if ('default' in inject[key]) {
            var provideDefault = inject[key].default;
            result[key] = typeof provideDefault === 'function' ? provideDefault.call(vm) : provideDefault;
          } else {
            warn("Injection \"" + key + "\" not found", vm);
          }
        }
      }

      return result;
    }
  }
  /*  */

  /**
   * Runtime helper for resolving raw children VNodes into a slot object.
   */


  function resolveSlots(children, context) {
    if (!children || !children.length) {
      return {};
    }

    var slots = {};

    for (var i = 0, l = children.length; i < l; i++) {
      var child = children[i];
      var data = child.data; // remove slot attribute if the node is resolved as a Vue slot node

      if (data && data.attrs && data.attrs.slot) {
        delete data.attrs.slot;
      } // named slots should only be respected if the vnode was rendered in the
      // same context.


      if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
        var name = data.slot;
        var slot = slots[name] || (slots[name] = []);

        if (child.tag === 'template') {
          slot.push.apply(slot, child.children || []);
        } else {
          slot.push(child);
        }
      } else {
        (slots.default || (slots.default = [])).push(child);
      }
    } // ignore slots that contains only whitespace


    for (var name$1 in slots) {
      if (slots[name$1].every(isWhitespace)) {
        delete slots[name$1];
      }
    }

    return slots;
  }

  function isWhitespace(node) {
    return node.isComment && !node.asyncFactory || node.text === ' ';
  }
  /*  */


  function isAsyncPlaceholder(node) {
    return node.isComment && node.asyncFactory;
  }
  /*  */


  function normalizeScopedSlots(slots, normalSlots, prevSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = slots ? !!slots.$stable : !hasNormalSlots;
    var key = slots && slots.$key;

    if (!slots) {
      res = {};
    } else if (slots._normalized) {
      // fast path 1: child component re-render only, parent did not change
      return slots._normalized;
    } else if (isStable && prevSlots && prevSlots !== emptyObject && key === prevSlots.$key && !hasNormalSlots && !prevSlots.$hasNormal) {
      // fast path 2: stable scoped slots w/ no normal slots to proxy,
      // only need to normalize once
      return prevSlots;
    } else {
      res = {};

      for (var key$1 in slots) {
        if (slots[key$1] && key$1[0] !== '$') {
          res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
        }
      }
    } // expose normal slots on scopedSlots


    for (var key$2 in normalSlots) {
      if (!(key$2 in res)) {
        res[key$2] = proxyNormalSlot(normalSlots, key$2);
      }
    } // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error


    if (slots && Object.isExtensible(slots)) {
      slots._normalized = res;
    }

    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
  }

  function normalizeScopedSlot(normalSlots, key, fn) {
    var normalized = function normalized() {
      var res = arguments.length ? fn.apply(null, arguments) : fn({});
      res = res && _typeof(res) === 'object' && !Array.isArray(res) ? [res] // single vnode
      : normalizeChildren(res);
      var vnode = res && res[0];
      return res && (!vnode || res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode) // #9658, #10391
      ) ? undefined : res;
    }; // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.


    if (fn.proxy) {
      Object.defineProperty(normalSlots, key, {
        get: normalized,
        enumerable: true,
        configurable: true
      });
    }

    return normalized;
  }

  function proxyNormalSlot(slots, key) {
    return function () {
      return slots[key];
    };
  }
  /*  */

  /**
   * Runtime helper for rendering v-for lists.
   */


  function renderList(val, render) {
    var ret, i, l, keys, key;

    if (Array.isArray(val) || typeof val === 'string') {
      ret = new Array(val.length);

      for (i = 0, l = val.length; i < l; i++) {
        ret[i] = render(val[i], i);
      }
    } else if (typeof val === 'number') {
      ret = new Array(val);

      for (i = 0; i < val; i++) {
        ret[i] = render(i + 1, i);
      }
    } else if (isObject(val)) {
      if (hasSymbol && val[Symbol.iterator]) {
        ret = [];
        var iterator = val[Symbol.iterator]();
        var result = iterator.next();

        while (!result.done) {
          ret.push(render(result.value, ret.length));
          result = iterator.next();
        }
      } else {
        keys = Object.keys(val);
        ret = new Array(keys.length);

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          ret[i] = render(val[key], key, i);
        }
      }
    }

    if (!isDef(ret)) {
      ret = [];
    }

    ret._isVList = true;
    return ret;
  }
  /*  */

  /**
   * Runtime helper for rendering <slot>
   */


  function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;

    if (scopedSlotFn) {
      // scoped slot
      props = props || {};

      if (bindObject) {
        if ( !isObject(bindObject)) {
          warn('slot v-bind without argument expects an Object', this);
        }

        props = extend(extend({}, bindObject), props);
      }

      nodes = scopedSlotFn(props) || (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
    } else {
      nodes = this.$slots[name] || (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
    }

    var target = props && props.slot;

    if (target) {
      return this.$createElement('template', {
        slot: target
      }, nodes);
    } else {
      return nodes;
    }
  }
  /*  */

  /**
   * Runtime helper for resolving filters
   */


  function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
  }
  /*  */


  function isKeyNotMatch(expect, actual) {
    if (Array.isArray(expect)) {
      return expect.indexOf(actual) === -1;
    } else {
      return expect !== actual;
    }
  }
  /**
   * Runtime helper for checking keyCodes from config.
   * exposed as Vue.prototype._k
   * passing in eventKeyName as last argument separately for backwards compat
   */


  function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;

    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
      return isKeyNotMatch(builtInKeyName, eventKeyName);
    } else if (mappedKeyCode) {
      return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    } else if (eventKeyName) {
      return hyphenate(eventKeyName) !== key;
    }

    return eventKeyCode === undefined;
  }
  /*  */

  /**
   * Runtime helper for merging v-bind="object" into a VNode's data.
   */


  function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
      if (!isObject(value)) {
         warn('v-bind without argument expects an Object or Array value', this);
      } else {
        if (Array.isArray(value)) {
          value = toObject(value);
        }

        var hash;

        var loop = function loop(key) {
          if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
            hash = data;
          } else {
            var type = data.attrs && data.attrs.type;
            hash = asProp || config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
          }

          var camelizedKey = camelize(key);
          var hyphenatedKey = hyphenate(key);

          if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
            hash[key] = value[key];

            if (isSync) {
              var on = data.on || (data.on = {});

              on["update:" + key] = function ($event) {
                value[key] = $event;
              };
            }
          }
        };

        for (var key in value) {
          loop(key);
        }
      }
    }

    return data;
  }
  /*  */

  /**
   * Runtime helper for rendering static trees.
   */


  function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index]; // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.

    if (tree && !isInFor) {
      return tree;
    } // otherwise, render a fresh tree.


    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, null, this // for render fns generated for functional component templates
    );
    markStatic(tree, "__static__" + index, false);
    return tree;
  }
  /**
   * Runtime helper for v-once.
   * Effectively it means marking the node as static with a unique key.
   */


  function markOnce(tree, index, key) {
    markStatic(tree, "__once__" + index + (key ? "_" + key : ""), true);
    return tree;
  }

  function markStatic(tree, key, isOnce) {
    if (Array.isArray(tree)) {
      for (var i = 0; i < tree.length; i++) {
        if (tree[i] && typeof tree[i] !== 'string') {
          markStaticNode(tree[i], key + "_" + i, isOnce);
        }
      }
    } else {
      markStaticNode(tree, key, isOnce);
    }
  }

  function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
  }
  /*  */


  function bindObjectListeners(data, value) {
    if (value) {
      if (!isPlainObject(value)) {
         warn('v-on without argument expects an Object value', this);
      } else {
        var on = data.on = data.on ? extend({}, data.on) : {};

        for (var key in value) {
          var existing = on[key];
          var ours = value[key];
          on[key] = existing ? [].concat(existing, ours) : ours;
        }
      }
    }

    return data;
  }
  /*  */


  function resolveScopedSlots(fns, // see flow/vnode
  res, // the following are added in 2.6
  hasDynamicKeys, contentHashKey) {
    res = res || {
      $stable: !hasDynamicKeys
    };

    for (var i = 0; i < fns.length; i++) {
      var slot = fns[i];

      if (Array.isArray(slot)) {
        resolveScopedSlots(slot, res, hasDynamicKeys);
      } else if (slot) {
        // marker for reverse proxying v-slot without scope on this.$slots
        if (slot.proxy) {
          slot.fn.proxy = true;
        }

        res[slot.key] = slot.fn;
      }
    }

    if (contentHashKey) {
      res.$key = contentHashKey;
    }

    return res;
  }
  /*  */


  function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
      var key = values[i];

      if (typeof key === 'string' && key) {
        baseObj[values[i]] = values[i + 1];
      } else if ( key !== '' && key !== null) {
        // null is a special value for explicitly removing a binding
        warn("Invalid value for dynamic directive argument (expected string or null): " + key, this);
      }
    }

    return baseObj;
  } // helper to dynamically append modifier runtime markers to event names.
  // ensure only append when value is already string, otherwise it will be cast
  // to string and cause the type check to miss.


  function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
  }
  /*  */


  function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
  }
  /*  */


  function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var this$1 = this;
    var options = Ctor.options; // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check

    var contextVm;

    if (hasOwn(parent, '_uid')) {
      contextVm = Object.create(parent); // $flow-disable-line

      contextVm._original = parent;
    } else {
      // the context vm passed in is a functional context as well.
      // in this case we want to make sure we are able to get a hold to the
      // real context instance.
      contextVm = parent; // $flow-disable-line

      parent = parent._original;
    }

    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);

    this.slots = function () {
      if (!this$1.$slots) {
        normalizeScopedSlots(data.scopedSlots, this$1.$slots = resolveSlots(children, parent));
      }

      return this$1.$slots;
    };

    Object.defineProperty(this, 'scopedSlots', {
      enumerable: true,
      get: function get() {
        return normalizeScopedSlots(data.scopedSlots, this.slots());
      }
    }); // support for compiled functional template

    if (isCompiled) {
      // exposing $options for renderStatic()
      this.$options = options; // pre-resolve slots for renderSlot()

      this.$slots = this.slots();
      this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
    }

    if (options._scopeId) {
      this._c = function (a, b, c, d) {
        var vnode = createElement(contextVm, a, b, c, d, needNormalization);

        if (vnode && !Array.isArray(vnode)) {
          vnode.fnScopeId = options._scopeId;
          vnode.fnContext = parent;
        }

        return vnode;
      };
    } else {
      this._c = function (a, b, c, d) {
        return createElement(contextVm, a, b, c, d, needNormalization);
      };
    }
  }

  installRenderHelpers(FunctionalRenderContext.prototype);

  function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;

    if (isDef(propOptions)) {
      for (var key in propOptions) {
        props[key] = validateProp(key, propOptions, propsData || emptyObject);
      }
    } else {
      if (isDef(data.attrs)) {
        mergeProps(props, data.attrs);
      }

      if (isDef(data.props)) {
        mergeProps(props, data.props);
      }
    }

    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);

    if (vnode instanceof VNode) {
      return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    } else if (Array.isArray(vnode)) {
      var vnodes = normalizeChildren(vnode) || [];
      var res = new Array(vnodes.length);

      for (var i = 0; i < vnodes.length; i++) {
        res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
      }

      return res;
    }
  }

  function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;

    {
      (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
    }

    if (data.slot) {
      (clone.data || (clone.data = {})).slot = data.slot;
    }

    return clone;
  }

  function mergeProps(to, from) {
    for (var key in from) {
      to[camelize(key)] = from[key];
    }
  }
  /*  */

  /*  */

  /*  */

  /*  */
  // inline hooks to be invoked on component VNodes during patch


  var componentVNodeHooks = {
    init: function init(vnode, hydrating) {
      if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
        // kept-alive components, treat as a patch
        var mountedNode = vnode; // work around flow

        componentVNodeHooks.prepatch(mountedNode, mountedNode);
      } else {
        var child = vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance);
        child.$mount(hydrating ? vnode.elm : undefined, hydrating);
      }
    },
    prepatch: function prepatch(oldVnode, vnode) {
      var options = vnode.componentOptions;
      var child = vnode.componentInstance = oldVnode.componentInstance;
      updateChildComponent(child, options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
      );
    },
    insert: function insert(vnode) {
      var context = vnode.context;
      var componentInstance = vnode.componentInstance;

      if (!componentInstance._isMounted) {
        componentInstance._isMounted = true;
        callHook(componentInstance, 'mounted');
      }

      if (vnode.data.keepAlive) {
        if (context._isMounted) {
          // vue-router#1212
          // During updates, a kept-alive component's child components may
          // change, so directly walking the tree here may call activated hooks
          // on incorrect children. Instead we push them into a queue which will
          // be processed after the whole patch process ended.
          queueActivatedComponent(componentInstance);
        } else {
          activateChildComponent(componentInstance, true
          /* direct */
          );
        }
      }
    },
    destroy: function destroy(vnode) {
      var componentInstance = vnode.componentInstance;

      if (!componentInstance._isDestroyed) {
        if (!vnode.data.keepAlive) {
          componentInstance.$destroy();
        } else {
          deactivateChildComponent(componentInstance, true
          /* direct */
          );
        }
      }
    }
  };
  var hooksToMerge = Object.keys(componentVNodeHooks);

  function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
      return;
    }

    var baseCtor = context.$options._base; // plain options object: turn it into a constructor

    if (isObject(Ctor)) {
      Ctor = baseCtor.extend(Ctor);
    } // if at this stage it's not a constructor or an async component factory,
    // reject.


    if (typeof Ctor !== 'function') {
      {
        warn("Invalid Component definition: " + String(Ctor), context);
      }

      return;
    } // async component


    var asyncFactory;

    if (isUndef(Ctor.cid)) {
      asyncFactory = Ctor;
      Ctor = resolveAsyncComponent(asyncFactory, baseCtor);

      if (Ctor === undefined) {
        // return a placeholder node for async component, which is rendered
        // as a comment node but preserves all the raw information for the node.
        // the information will be used for async server-rendering and hydration.
        return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
      }
    }

    data = data || {}; // resolve constructor options in case global mixins are applied after
    // component constructor creation

    resolveConstructorOptions(Ctor); // transform component v-model data into props & events

    if (isDef(data.model)) {
      transformModel(Ctor.options, data);
    } // extract props


    var propsData = extractPropsFromVNodeData(data, Ctor, tag); // functional component

    if (isTrue(Ctor.options.functional)) {
      return createFunctionalComponent(Ctor, propsData, data, context, children);
    } // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners


    var listeners = data.on; // replace with listeners with .native modifier
    // so it gets processed during parent component patch.

    data.on = data.nativeOn;

    if (isTrue(Ctor.options.abstract)) {
      // abstract components do not keep anything
      // other than props & listeners & slot
      // work around flow
      var slot = data.slot;
      data = {};

      if (slot) {
        data.slot = slot;
      }
    } // install component management hooks onto the placeholder node


    installComponentHooks(data); // return a placeholder vnode

    var name = Ctor.options.name || tag;
    var vnode = new VNode("vue-component-" + Ctor.cid + (name ? "-" + name : ''), data, undefined, undefined, undefined, context, {
      Ctor: Ctor,
      propsData: propsData,
      listeners: listeners,
      tag: tag,
      children: children
    }, asyncFactory);
    return vnode;
  }

  function createComponentInstanceForVnode( // we know it's MountedComponentVNode but flow doesn't
  vnode, // activeInstance in lifecycle state
  parent) {
    var options = {
      _isComponent: true,
      _parentVnode: vnode,
      parent: parent
    }; // check inline-template render functions

    var inlineTemplate = vnode.data.inlineTemplate;

    if (isDef(inlineTemplate)) {
      options.render = inlineTemplate.render;
      options.staticRenderFns = inlineTemplate.staticRenderFns;
    }

    return new vnode.componentOptions.Ctor(options);
  }

  function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});

    for (var i = 0; i < hooksToMerge.length; i++) {
      var key = hooksToMerge[i];
      var existing = hooks[key];
      var toMerge = componentVNodeHooks[key];

      if (existing !== toMerge && !(existing && existing._merged)) {
        hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
      }
    }
  }

  function mergeHook$1(f1, f2) {
    var merged = function merged(a, b) {
      // flow complains about extra args which is why we use any
      f1(a, b);
      f2(a, b);
    };

    merged._merged = true;
    return merged;
  } // transform component v-model info (value and callback) into
  // prop and event handler respectively.


  function transformModel(options, data) {
    var prop = options.model && options.model.prop || 'value';
    var event = options.model && options.model.event || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;

    if (isDef(existing)) {
      if (Array.isArray(existing) ? existing.indexOf(callback) === -1 : existing !== callback) {
        on[event] = [callback].concat(existing);
      }
    } else {
      on[event] = callback;
    }
  }
  /*  */


  var SIMPLE_NORMALIZE = 1;
  var ALWAYS_NORMALIZE = 2; // wrapper function for providing a more flexible interface
  // without getting yelled at by flow

  function createElement(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (Array.isArray(data) || isPrimitive(data)) {
      normalizationType = children;
      children = data;
      data = undefined;
    }

    if (isTrue(alwaysNormalize)) {
      normalizationType = ALWAYS_NORMALIZE;
    }

    return _createElement(context, tag, data, children, normalizationType);
  }

  function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
       warn("Avoid using observed data object as vnode data: " + JSON.stringify(data) + "\n" + 'Always create fresh vnode data objects in each render!', context);
      return createEmptyVNode();
    } // object syntax in v-bind


    if (isDef(data) && isDef(data.is)) {
      tag = data.is;
    }

    if (!tag) {
      // in case of component :is set to falsy value
      return createEmptyVNode();
    } // warn against non-primitive key


    if ( isDef(data) && isDef(data.key) && !isPrimitive(data.key)) {
      {
        warn('Avoid using non-primitive value as key, ' + 'use string/number value instead.', context);
      }
    } // support single function children as default scoped slot


    if (Array.isArray(children) && typeof children[0] === 'function') {
      data = data || {};
      data.scopedSlots = {
        default: children[0]
      };
      children.length = 0;
    }

    if (normalizationType === ALWAYS_NORMALIZE) {
      children = normalizeChildren(children);
    } else if (normalizationType === SIMPLE_NORMALIZE) {
      children = simpleNormalizeChildren(children);
    }

    var vnode, ns;

    if (typeof tag === 'string') {
      var Ctor;
      ns = context.$vnode && context.$vnode.ns || config.getTagNamespace(tag);

      if (config.isReservedTag(tag)) {
        // platform built-in elements
        if ( isDef(data) && isDef(data.nativeOn) && data.tag !== 'component') {
          warn("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">.", context);
        }

        vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
      } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
        // component
        vnode = createComponent(Ctor, data, context, children, tag);
      } else {
        // unknown or unlisted namespaced elements
        // check at runtime because it may get assigned a namespace when its
        // parent normalizes children
        vnode = new VNode(tag, data, children, undefined, undefined, context);
      }
    } else {
      // direct component options / constructor
      vnode = createComponent(tag, data, context, children);
    }

    if (Array.isArray(vnode)) {
      return vnode;
    } else if (isDef(vnode)) {
      if (isDef(ns)) {
        applyNS(vnode, ns);
      }

      if (isDef(data)) {
        registerDeepBindings(data);
      }

      return vnode;
    } else {
      return createEmptyVNode();
    }
  }

  function applyNS(vnode, ns, force) {
    vnode.ns = ns;

    if (vnode.tag === 'foreignObject') {
      // use default namespace inside foreignObject
      ns = undefined;
      force = true;
    }

    if (isDef(vnode.children)) {
      for (var i = 0, l = vnode.children.length; i < l; i++) {
        var child = vnode.children[i];

        if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force) && child.tag !== 'svg')) {
          applyNS(child, ns, force);
        }
      }
    }
  } // ref #5318
  // necessary to ensure parent re-render when deep bindings like :style and
  // :class are used on slot nodes


  function registerDeepBindings(data) {
    if (isObject(data.style)) {
      traverse(data.style);
    }

    if (isObject(data.class)) {
      traverse(data.class);
    }
  }
  /*  */


  function initRender(vm) {
    vm._vnode = null; // the root of the child tree

    vm._staticTrees = null; // v-once cached trees

    var options = vm.$options;
    var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree

    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = emptyObject; // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates

    vm._c = function (a, b, c, d) {
      return createElement(vm, a, b, c, d, false);
    }; // normalization is always applied for the public version, used in
    // user-written render functions.


    vm.$createElement = function (a, b, c, d) {
      return createElement(vm, a, b, c, d, true);
    }; // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated


    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */

    {
      defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
        !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
      }, true);
      defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
        !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
      }, true);
    }
  }

  var currentRenderingInstance = null;

  function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);

    Vue.prototype.$nextTick = function (fn) {
      return nextTick(fn, this);
    };

    Vue.prototype._render = function () {
      var vm = this;
      var ref = vm.$options;
      var render = ref.render;
      var _parentVnode = ref._parentVnode;

      if (_parentVnode) {
        vm.$scopedSlots = normalizeScopedSlots(_parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
      } // set parent vnode. this allows render functions to have access
      // to the data on the placeholder node.


      vm.$vnode = _parentVnode; // render self

      var vnode;

      try {
        // There's no need to maintain a stack because all render fns are called
        // separately from one another. Nested component's render fns are called
        // when parent component is patched.
        currentRenderingInstance = vm;
        vnode = render.call(vm._renderProxy, vm.$createElement);
      } catch (e) {
        handleError(e, vm, "render"); // return error render result,
        // or previous vnode to prevent render error causing blank component

        /* istanbul ignore else */

        if ( vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } finally {
        currentRenderingInstance = null;
      } // if the returned array contains only a single node, allow it


      if (Array.isArray(vnode) && vnode.length === 1) {
        vnode = vnode[0];
      } // return empty vnode in case the render function errored out


      if (!(vnode instanceof VNode)) {
        if ( Array.isArray(vnode)) {
          warn('Multiple root nodes returned from render function. Render function ' + 'should return a single root node.', vm);
        }

        vnode = createEmptyVNode();
      } // set parent


      vnode.parent = _parentVnode;
      return vnode;
    };
  }
  /*  */


  function ensureCtor(comp, base) {
    if (comp.__esModule || hasSymbol && comp[Symbol.toStringTag] === 'Module') {
      comp = comp.default;
    }

    return isObject(comp) ? base.extend(comp) : comp;
  }

  function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = {
      data: data,
      context: context,
      children: children,
      tag: tag
    };
    return node;
  }

  function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
      return factory.errorComp;
    }

    if (isDef(factory.resolved)) {
      return factory.resolved;
    }

    var owner = currentRenderingInstance;

    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
      // already pending
      factory.owners.push(owner);
    }

    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
      return factory.loadingComp;
    }

    if (owner && !isDef(factory.owners)) {
      var owners = factory.owners = [owner];
      var sync = true;
      var timerLoading = null;
      var timerTimeout = null;
      owner.$on('hook:destroyed', function () {
        return remove(owners, owner);
      });

      var forceRender = function forceRender(renderCompleted) {
        for (var i = 0, l = owners.length; i < l; i++) {
          owners[i].$forceUpdate();
        }

        if (renderCompleted) {
          owners.length = 0;

          if (timerLoading !== null) {
            clearTimeout(timerLoading);
            timerLoading = null;
          }

          if (timerTimeout !== null) {
            clearTimeout(timerTimeout);
            timerTimeout = null;
          }
        }
      };

      var resolve = once(function (res) {
        // cache resolved
        factory.resolved = ensureCtor(res, baseCtor); // invoke callbacks only if this is not a synchronous resolve
        // (async resolves are shimmed as synchronous during SSR)

        if (!sync) {
          forceRender(true);
        } else {
          owners.length = 0;
        }
      });
      var reject = once(function (reason) {
         warn("Failed to resolve async component: " + String(factory) + (reason ? "\nReason: " + reason : ''));

        if (isDef(factory.errorComp)) {
          factory.error = true;
          forceRender(true);
        }
      });
      var res = factory(resolve, reject);

      if (isObject(res)) {
        if (isPromise(res)) {
          // () => Promise
          if (isUndef(factory.resolved)) {
            res.then(resolve, reject);
          }
        } else if (isPromise(res.component)) {
          res.component.then(resolve, reject);

          if (isDef(res.error)) {
            factory.errorComp = ensureCtor(res.error, baseCtor);
          }

          if (isDef(res.loading)) {
            factory.loadingComp = ensureCtor(res.loading, baseCtor);

            if (res.delay === 0) {
              factory.loading = true;
            } else {
              timerLoading = setTimeout(function () {
                timerLoading = null;

                if (isUndef(factory.resolved) && isUndef(factory.error)) {
                  factory.loading = true;
                  forceRender(false);
                }
              }, res.delay || 200);
            }
          }

          if (isDef(res.timeout)) {
            timerTimeout = setTimeout(function () {
              timerTimeout = null;

              if (isUndef(factory.resolved)) {
                reject( "timeout (" + res.timeout + "ms)" );
              }
            }, res.timeout);
          }
        }
      }

      sync = false; // return in case resolved synchronously

      return factory.loading ? factory.loadingComp : factory.resolved;
    }
  }
  /*  */


  function getFirstComponentChild(children) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; i++) {
        var c = children[i];

        if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
          return c;
        }
      }
    }
  }
  /*  */

  /*  */


  function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false; // init parent attached events

    var listeners = vm.$options._parentListeners;

    if (listeners) {
      updateComponentListeners(vm, listeners);
    }
  }

  var target;

  function add(event, fn) {
    target.$on(event, fn);
  }

  function remove$1(event, fn) {
    target.$off(event, fn);
  }

  function createOnceHandler(event, fn) {
    var _target = target;
    return function onceHandler() {
      var res = fn.apply(null, arguments);

      if (res !== null) {
        _target.$off(event, onceHandler);
      }
    };
  }

  function updateComponentListeners(vm, listeners, oldListeners) {
    target = vm;
    updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
    target = undefined;
  }

  function eventsMixin(Vue) {
    var hookRE = /^hook:/;

    Vue.prototype.$on = function (event, fn) {
      var vm = this;

      if (Array.isArray(event)) {
        for (var i = 0, l = event.length; i < l; i++) {
          vm.$on(event[i], fn);
        }
      } else {
        (vm._events[event] || (vm._events[event] = [])).push(fn); // optimize hook:event cost by using a boolean flag marked at registration
        // instead of a hash lookup

        if (hookRE.test(event)) {
          vm._hasHookEvent = true;
        }
      }

      return vm;
    };

    Vue.prototype.$once = function (event, fn) {
      var vm = this;

      function on() {
        vm.$off(event, on);
        fn.apply(vm, arguments);
      }

      on.fn = fn;
      vm.$on(event, on);
      return vm;
    };

    Vue.prototype.$off = function (event, fn) {
      var vm = this; // all

      if (!arguments.length) {
        vm._events = Object.create(null);
        return vm;
      } // array of events


      if (Array.isArray(event)) {
        for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
          vm.$off(event[i$1], fn);
        }

        return vm;
      } // specific event


      var cbs = vm._events[event];

      if (!cbs) {
        return vm;
      }

      if (!fn) {
        vm._events[event] = null;
        return vm;
      } // specific handler


      var cb;
      var i = cbs.length;

      while (i--) {
        cb = cbs[i];

        if (cb === fn || cb.fn === fn) {
          cbs.splice(i, 1);
          break;
        }
      }

      return vm;
    };

    Vue.prototype.$emit = function (event) {
      var vm = this;

      {
        var lowerCaseEvent = event.toLowerCase();

        if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
          tip("Event \"" + lowerCaseEvent + "\" is emitted in component " + formatComponentName(vm) + " but the handler is registered for \"" + event + "\". " + "Note that HTML attributes are case-insensitive and you cannot use " + "v-on to listen to camelCase events when using in-DOM templates. " + "You should probably use \"" + hyphenate(event) + "\" instead of \"" + event + "\".");
        }
      }

      var cbs = vm._events[event];

      if (cbs) {
        cbs = cbs.length > 1 ? toArray(cbs) : cbs;
        var args = toArray(arguments, 1);
        var info = "event handler for \"" + event + "\"";

        for (var i = 0, l = cbs.length; i < l; i++) {
          invokeWithErrorHandling(cbs[i], vm, args, vm, info);
        }
      }

      return vm;
    };
  }
  /*  */


  var activeInstance = null;
  var isUpdatingChildComponent = false;

  function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
      activeInstance = prevActiveInstance;
    };
  }

  function initLifecycle(vm) {
    var options = vm.$options; // locate first non-abstract parent

    var parent = options.parent;

    if (parent && !options.abstract) {
      while (parent.$options.abstract && parent.$parent) {
        parent = parent.$parent;
      }

      parent.$children.push(vm);
    }

    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
  }

  function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
      var vm = this;
      var prevEl = vm.$el;
      var prevVnode = vm._vnode;
      var restoreActiveInstance = setActiveInstance(vm);
      vm._vnode = vnode; // Vue.prototype.__patch__ is injected in entry points
      // based on the rendering backend used.

      if (!prevVnode) {
        // initial render
        vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false
        /* removeOnly */
        );
      } else {
        // updates
        vm.$el = vm.__patch__(prevVnode, vnode);
      }

      restoreActiveInstance(); // update __vue__ reference

      if (prevEl) {
        prevEl.__vue__ = null;
      }

      if (vm.$el) {
        vm.$el.__vue__ = vm;
      } // if parent is an HOC, update its $el as well


      if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
        vm.$parent.$el = vm.$el;
      } // updated hook is called by the scheduler to ensure that children are
      // updated in a parent's updated hook.

    };

    Vue.prototype.$forceUpdate = function () {
      var vm = this;

      if (vm._watcher) {
        vm._watcher.update();
      }
    };

    Vue.prototype.$destroy = function () {
      var vm = this;

      if (vm._isBeingDestroyed) {
        return;
      }

      callHook(vm, 'beforeDestroy');
      vm._isBeingDestroyed = true; // remove self from parent

      var parent = vm.$parent;

      if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
        remove(parent.$children, vm);
      } // teardown watchers


      if (vm._watcher) {
        vm._watcher.teardown();
      }

      var i = vm._watchers.length;

      while (i--) {
        vm._watchers[i].teardown();
      } // remove reference from data ob
      // frozen object may not have observer.


      if (vm._data.__ob__) {
        vm._data.__ob__.vmCount--;
      } // call the last hook...


      vm._isDestroyed = true; // invoke destroy hooks on current rendered tree

      vm.__patch__(vm._vnode, null); // fire destroyed hook


      callHook(vm, 'destroyed'); // turn off all instance listeners.

      vm.$off(); // remove __vue__ reference

      if (vm.$el) {
        vm.$el.__vue__ = null;
      } // release circular reference (#6759)


      if (vm.$vnode) {
        vm.$vnode.parent = null;
      }
    };
  }

  function mountComponent(vm, el, hydrating) {
    vm.$el = el;

    if (!vm.$options.render) {
      vm.$options.render = createEmptyVNode;

      {
        /* istanbul ignore if */
        if (vm.$options.template && vm.$options.template.charAt(0) !== '#' || vm.$options.el || el) {
          warn('You are using the runtime-only build of Vue where the template ' + 'compiler is not available. Either pre-compile the templates into ' + 'render functions, or use the compiler-included build.', vm);
        } else {
          warn('Failed to mount component: template or render function not defined.', vm);
        }
      }
    }

    callHook(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */

    if ( config.performance && mark) {
      updateComponent = function updateComponent() {
        var name = vm._name;
        var id = vm._uid;
        var startTag = "vue-perf-start:" + id;
        var endTag = "vue-perf-end:" + id;
        mark(startTag);

        var vnode = vm._render();

        mark(endTag);
        measure("vue " + name + " render", startTag, endTag);
        mark(startTag);

        vm._update(vnode, hydrating);

        mark(endTag);
        measure("vue " + name + " patch", startTag, endTag);
      };
    } else {
      updateComponent = function updateComponent() {
        vm._update(vm._render(), hydrating);
      };
    } // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined


    new Watcher(vm, updateComponent, noop, {
      before: function before() {
        if (vm._isMounted && !vm._isDestroyed) {
          callHook(vm, 'beforeUpdate');
        }
      }
    }, true
    /* isRenderWatcher */
    );
    hydrating = false; // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook

    if (vm.$vnode == null) {
      vm._isMounted = true;
      callHook(vm, 'mounted');
    }

    return vm;
  }

  function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    {
      isUpdatingChildComponent = true;
    } // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.


    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!(newScopedSlots && !newScopedSlots.$stable || oldScopedSlots !== emptyObject && !oldScopedSlots.$stable || newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key || !newScopedSlots && vm.$scopedSlots.$key); // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.

    var needsForceUpdate = !!(renderChildren || // has new static slots
    vm.$options._renderChildren || // has old static slots
    hasDynamicScopedSlot);
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render

    if (vm._vnode) {
      // update child tree's parent
      vm._vnode.parent = parentVnode;
    }

    vm.$options._renderChildren = renderChildren; // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render

    vm.$attrs = parentVnode.data.attrs || emptyObject;
    vm.$listeners = listeners || emptyObject; // update props

    if (propsData && vm.$options.props) {
      toggleObserving(false);
      var props = vm._props;
      var propKeys = vm.$options._propKeys || [];

      for (var i = 0; i < propKeys.length; i++) {
        var key = propKeys[i];
        var propOptions = vm.$options.props; // wtf flow?

        props[key] = validateProp(key, propOptions, propsData, vm);
      }

      toggleObserving(true); // keep a copy of raw propsData

      vm.$options.propsData = propsData;
    } // update listeners


    listeners = listeners || emptyObject;
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners); // resolve slots + force update if has children

    if (needsForceUpdate) {
      vm.$slots = resolveSlots(renderChildren, parentVnode.context);
      vm.$forceUpdate();
    }

    {
      isUpdatingChildComponent = false;
    }
  }

  function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
      if (vm._inactive) {
        return true;
      }
    }

    return false;
  }

  function activateChildComponent(vm, direct) {
    if (direct) {
      vm._directInactive = false;

      if (isInInactiveTree(vm)) {
        return;
      }
    } else if (vm._directInactive) {
      return;
    }

    if (vm._inactive || vm._inactive === null) {
      vm._inactive = false;

      for (var i = 0; i < vm.$children.length; i++) {
        activateChildComponent(vm.$children[i]);
      }

      callHook(vm, 'activated');
    }
  }

  function deactivateChildComponent(vm, direct) {
    if (direct) {
      vm._directInactive = true;

      if (isInInactiveTree(vm)) {
        return;
      }
    }

    if (!vm._inactive) {
      vm._inactive = true;

      for (var i = 0; i < vm.$children.length; i++) {
        deactivateChildComponent(vm.$children[i]);
      }

      callHook(vm, 'deactivated');
    }
  }

  function callHook(vm, hook) {
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var handlers = vm.$options[hook];
    var info = hook + " hook";

    if (handlers) {
      for (var i = 0, j = handlers.length; i < j; i++) {
        invokeWithErrorHandling(handlers[i], vm, null, vm, info);
      }
    }

    if (vm._hasHookEvent) {
      vm.$emit('hook:' + hook);
    }

    popTarget();
  }
  /*  */


  var MAX_UPDATE_COUNT = 100;
  var queue = [];
  var activatedChildren = [];
  var has = {};
  var circular = {};
  var waiting = false;
  var flushing = false;
  var index = 0;
  /**
   * Reset the scheduler's state.
   */

  function resetSchedulerState() {
    index = queue.length = activatedChildren.length = 0;
    has = {};

    {
      circular = {};
    }

    waiting = flushing = false;
  } // Async edge case #6566 requires saving the timestamp when event listeners are
  // attached. However, calling performance.now() has a perf overhead especially
  // if the page has thousands of event listeners. Instead, we take a timestamp
  // every time the scheduler flushes and use that for all event listeners
  // attached during that flush.


  var currentFlushTimestamp = 0; // Async edge case fix requires storing an event listener's attach timestamp.

  var getNow = Date.now; // Determine what event timestamp the browser is using. Annoyingly, the
  // timestamp can either be hi-res (relative to page load) or low-res
  // (relative to UNIX epoch), so in order to compare time we have to use the
  // same timestamp type when saving the flush timestamp.
  // All IE versions use low-res event timestamps, and have problematic clock
  // implementations (#9632)

  if (inBrowser && !isIE) {
    var performance$1 = window.performance;

    if (performance$1 && typeof performance$1.now === 'function' && getNow() > document.createEvent('Event').timeStamp) {
      // if the event timestamp, although evaluated AFTER the Date.now(), is
      // smaller than it, it means the event is using a hi-res timestamp,
      // and we need to use the hi-res version for event listener timestamps as
      // well.
      getNow = function getNow() {
        return performance$1.now();
      };
    }
  }
  /**
   * Flush both queues and run the watchers.
   */


  function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id; // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.

    queue.sort(function (a, b) {
      return a.id - b.id;
    }); // do not cache length because more watchers might be pushed
    // as we run existing watchers

    for (index = 0; index < queue.length; index++) {
      watcher = queue[index];

      if (watcher.before) {
        watcher.before();
      }

      id = watcher.id;
      has[id] = null;
      watcher.run(); // in dev build, check and stop circular updates.

      if ( has[id] != null) {
        circular[id] = (circular[id] || 0) + 1;

        if (circular[id] > MAX_UPDATE_COUNT) {
          warn('You may have an infinite update loop ' + (watcher.user ? "in watcher with expression \"" + watcher.expression + "\"" : "in a component render function."), watcher.vm);
          break;
        }
      }
    } // keep copies of post queues before resetting state


    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState(); // call component updated and activated hooks

    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue); // devtool hook

    /* istanbul ignore if */

    if (devtools && config.devtools) {
      devtools.emit('flush');
    }
  }

  function callUpdatedHooks(queue) {
    var i = queue.length;

    while (i--) {
      var watcher = queue[i];
      var vm = watcher.vm;

      if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'updated');
      }
    }
  }
  /**
   * Queue a kept-alive component that was activated during patch.
   * The queue will be processed after the entire tree has been patched.
   */


  function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
  }

  function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
      queue[i]._inactive = true;
      activateChildComponent(queue[i], true
      /* true */
      );
    }
  }
  /**
   * Push a watcher into the watcher queue.
   * Jobs with duplicate IDs will be skipped unless it's
   * pushed when the queue is being flushed.
   */


  function queueWatcher(watcher) {
    var id = watcher.id;

    if (has[id] == null) {
      has[id] = true;

      if (!flushing) {
        queue.push(watcher);
      } else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;

        while (i > index && queue[i].id > watcher.id) {
          i--;
        }

        queue.splice(i + 1, 0, watcher);
      } // queue the flush


      if (!waiting) {
        waiting = true;

        if ( !config.async) {
          flushSchedulerQueue();
          return;
        }

        nextTick(flushSchedulerQueue);
      }
    }
  }
  /*  */


  var uid$2 = 0;
  /**
   * A watcher parses an expression, collects dependencies,
   * and fires callback when the expression value changes.
   * This is used for both the $watch() api and directives.
   */

  var Watcher = function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
    this.vm = vm;

    if (isRenderWatcher) {
      vm._watcher = this;
    }

    vm._watchers.push(this); // options


    if (options) {
      this.deep = !!options.deep;
      this.user = !!options.user;
      this.lazy = !!options.lazy;
      this.sync = !!options.sync;
      this.before = options.before;
    } else {
      this.deep = this.user = this.lazy = this.sync = false;
    }

    this.cb = cb;
    this.id = ++uid$2; // uid for batching

    this.active = true;
    this.dirty = this.lazy; // for lazy watchers

    this.deps = [];
    this.newDeps = [];
    this.depIds = new _Set();
    this.newDepIds = new _Set();
    this.expression =  expOrFn.toString() ; // parse expression for getter

    if (typeof expOrFn === 'function') {
      this.getter = expOrFn;
    } else {
      this.getter = parsePath(expOrFn);

      if (!this.getter) {
        this.getter = noop;
         warn("Failed watching path: \"" + expOrFn + "\" " + 'Watcher only accepts simple dot-delimited paths. ' + 'For full control, use a function instead.', vm);
      }
    }

    this.value = this.lazy ? undefined : this.get();
  };
  /**
   * Evaluate the getter, and re-collect dependencies.
   */


  Watcher.prototype.get = function get() {
    pushTarget(this);
    var value;
    var vm = this.vm;

    try {
      value = this.getter.call(vm, vm);
    } catch (e) {
      if (this.user) {
        handleError(e, vm, "getter for watcher \"" + this.expression + "\"");
      } else {
        throw e;
      }
    } finally {
      // "touch" every property so they are all tracked as
      // dependencies for deep watching
      if (this.deep) {
        traverse(value);
      }

      popTarget();
      this.cleanupDeps();
    }

    return value;
  };
  /**
   * Add a dependency to this directive.
   */


  Watcher.prototype.addDep = function addDep(dep) {
    var id = dep.id;

    if (!this.newDepIds.has(id)) {
      this.newDepIds.add(id);
      this.newDeps.push(dep);

      if (!this.depIds.has(id)) {
        dep.addSub(this);
      }
    }
  };
  /**
   * Clean up for dependency collection.
   */


  Watcher.prototype.cleanupDeps = function cleanupDeps() {
    var i = this.deps.length;

    while (i--) {
      var dep = this.deps[i];

      if (!this.newDepIds.has(dep.id)) {
        dep.removeSub(this);
      }
    }

    var tmp = this.depIds;
    this.depIds = this.newDepIds;
    this.newDepIds = tmp;
    this.newDepIds.clear();
    tmp = this.deps;
    this.deps = this.newDeps;
    this.newDeps = tmp;
    this.newDeps.length = 0;
  };
  /**
   * Subscriber interface.
   * Will be called when a dependency changes.
   */


  Watcher.prototype.update = function update() {
    /* istanbul ignore else */
    if (this.lazy) {
      this.dirty = true;
    } else if (this.sync) {
      this.run();
    } else {
      queueWatcher(this);
    }
  };
  /**
   * Scheduler job interface.
   * Will be called by the scheduler.
   */


  Watcher.prototype.run = function run() {
    if (this.active) {
      var value = this.get();

      if (value !== this.value || // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) || this.deep) {
        // set new value
        var oldValue = this.value;
        this.value = value;

        if (this.user) {
          var info = "callback for watcher \"" + this.expression + "\"";
          invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
        } else {
          this.cb.call(this.vm, value, oldValue);
        }
      }
    }
  };
  /**
   * Evaluate the value of the watcher.
   * This only gets called for lazy watchers.
   */


  Watcher.prototype.evaluate = function evaluate() {
    this.value = this.get();
    this.dirty = false;
  };
  /**
   * Depend on all deps collected by this watcher.
   */


  Watcher.prototype.depend = function depend() {
    var i = this.deps.length;

    while (i--) {
      this.deps[i].depend();
    }
  };
  /**
   * Remove self from all dependencies' subscriber list.
   */


  Watcher.prototype.teardown = function teardown() {
    if (this.active) {
      // remove self from vm's watcher list
      // this is a somewhat expensive operation so we skip it
      // if the vm is being destroyed.
      if (!this.vm._isBeingDestroyed) {
        remove(this.vm._watchers, this);
      }

      var i = this.deps.length;

      while (i--) {
        this.deps[i].removeSub(this);
      }

      this.active = false;
    }
  };
  /*  */


  var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
  };

  function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
      return this[sourceKey][key];
    };

    sharedPropertyDefinition.set = function proxySetter(val) {
      this[sourceKey][key] = val;
    };

    Object.defineProperty(target, key, sharedPropertyDefinition);
  }

  function initState(vm) {
    vm._watchers = [];
    var opts = vm.$options;

    if (opts.props) {
      initProps(vm, opts.props);
    }

    if (opts.methods) {
      initMethods(vm, opts.methods);
    }

    if (opts.data) {
      initData(vm);
    } else {
      observe(vm._data = {}, true
      /* asRootData */
      );
    }

    if (opts.computed) {
      initComputed(vm, opts.computed);
    }

    if (opts.watch && opts.watch !== nativeWatch) {
      initWatch(vm, opts.watch);
    }
  }

  function initProps(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = vm._props = {}; // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.

    var keys = vm.$options._propKeys = [];
    var isRoot = !vm.$parent; // root instance props should be converted

    if (!isRoot) {
      toggleObserving(false);
    }

    var loop = function loop(key) {
      keys.push(key);
      var value = validateProp(key, propsOptions, propsData, vm);
      /* istanbul ignore else */

      {
        var hyphenatedKey = hyphenate(key);

        if (isReservedAttribute(hyphenatedKey) || config.isReservedAttr(hyphenatedKey)) {
          warn("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop.", vm);
        }

        defineReactive$$1(props, key, value, function () {
          if (!isRoot && !isUpdatingChildComponent) {
            warn("Avoid mutating a prop directly since the value will be " + "overwritten whenever the parent component re-renders. " + "Instead, use a data or computed property based on the prop's " + "value. Prop being mutated: \"" + key + "\"", vm);
          }
        });
      } // static props are already proxied on the component's prototype
      // during Vue.extend(). We only need to proxy props defined at
      // instantiation here.


      if (!(key in vm)) {
        proxy(vm, "_props", key);
      }
    };

    for (var key in propsOptions) {
      loop(key);
    }

    toggleObserving(true);
  }

  function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = typeof data === 'function' ? getData(data, vm) : data || {};

    if (!isPlainObject(data)) {
      data = {};
       warn('data functions should return an object:\n' + 'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
    } // proxy data on instance


    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;

    while (i--) {
      var key = keys[i];

      {
        if (methods && hasOwn(methods, key)) {
          warn("Method \"" + key + "\" has already been defined as a data property.", vm);
        }
      }

      if (props && hasOwn(props, key)) {
         warn("The data property \"" + key + "\" is already declared as a prop. " + "Use prop default value instead.", vm);
      } else if (!isReserved(key)) {
        proxy(vm, "_data", key);
      }
    } // observe data


    observe(data, true
    /* asRootData */
    );
  }

  function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();

    try {
      return data.call(vm, vm);
    } catch (e) {
      handleError(e, vm, "data()");
      return {};
    } finally {
      popTarget();
    }
  }

  var computedWatcherOptions = {
    lazy: true
  };

  function initComputed(vm, computed) {
    // $flow-disable-line
    var watchers = vm._computedWatchers = Object.create(null); // computed properties are just getters during SSR

    var isSSR = isServerRendering();

    for (var key in computed) {
      var userDef = computed[key];
      var getter = typeof userDef === 'function' ? userDef : userDef.get;

      if ( getter == null) {
        warn("Getter is missing for computed property \"" + key + "\".", vm);
      }

      if (!isSSR) {
        // create internal watcher for the computed property.
        watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
      } // component-defined computed properties are already defined on the
      // component prototype. We only need to define computed properties defined
      // at instantiation here.


      if (!(key in vm)) {
        defineComputed(vm, key, userDef);
      } else {
        if (key in vm.$data) {
          warn("The computed property \"" + key + "\" is already defined in data.", vm);
        } else if (vm.$options.props && key in vm.$options.props) {
          warn("The computed property \"" + key + "\" is already defined as a prop.", vm);
        } else if (vm.$options.methods && key in vm.$options.methods) {
          warn("The computed property \"" + key + "\" is already defined as a method.", vm);
        }
      }
    }
  }

  function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();

    if (typeof userDef === 'function') {
      sharedPropertyDefinition.get = shouldCache ? createComputedGetter(key) : createGetterInvoker(userDef);
      sharedPropertyDefinition.set = noop;
    } else {
      sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? createComputedGetter(key) : createGetterInvoker(userDef.get) : noop;
      sharedPropertyDefinition.set = userDef.set || noop;
    }

    if ( sharedPropertyDefinition.set === noop) {
      sharedPropertyDefinition.set = function () {
        warn("Computed property \"" + key + "\" was assigned to but it has no setter.", this);
      };
    }

    Object.defineProperty(target, key, sharedPropertyDefinition);
  }

  function createComputedGetter(key) {
    return function computedGetter() {
      var watcher = this._computedWatchers && this._computedWatchers[key];

      if (watcher) {
        if (watcher.dirty) {
          watcher.evaluate();
        }

        if (Dep.target) {
          watcher.depend();
        }

        return watcher.value;
      }
    };
  }

  function createGetterInvoker(fn) {
    return function computedGetter() {
      return fn.call(this, this);
    };
  }

  function initMethods(vm, methods) {
    var props = vm.$options.props;

    for (var key in methods) {
      {
        if (typeof methods[key] !== 'function') {
          warn("Method \"" + key + "\" has type \"" + _typeof(methods[key]) + "\" in the component definition. " + "Did you reference the function correctly?", vm);
        }

        if (props && hasOwn(props, key)) {
          warn("Method \"" + key + "\" has already been defined as a prop.", vm);
        }

        if (key in vm && isReserved(key)) {
          warn("Method \"" + key + "\" conflicts with an existing Vue instance method. " + "Avoid defining component methods that start with _ or $.");
        }
      }

      vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
    }
  }

  function initWatch(vm, watch) {
    for (var key in watch) {
      var handler = watch[key];

      if (Array.isArray(handler)) {
        for (var i = 0; i < handler.length; i++) {
          createWatcher(vm, key, handler[i]);
        }
      } else {
        createWatcher(vm, key, handler);
      }
    }
  }

  function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
      options = handler;
      handler = handler.handler;
    }

    if (typeof handler === 'string') {
      handler = vm[handler];
    }

    return vm.$watch(expOrFn, handler, options);
  }

  function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};

    dataDef.get = function () {
      return this._data;
    };

    var propsDef = {};

    propsDef.get = function () {
      return this._props;
    };

    {
      dataDef.set = function () {
        warn('Avoid replacing instance root $data. ' + 'Use nested data properties instead.', this);
      };

      propsDef.set = function () {
        warn("$props is readonly.", this);
      };
    }

    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;

    Vue.prototype.$watch = function (expOrFn, cb, options) {
      var vm = this;

      if (isPlainObject(cb)) {
        return createWatcher(vm, expOrFn, cb, options);
      }

      options = options || {};
      options.user = true;
      var watcher = new Watcher(vm, expOrFn, cb, options);

      if (options.immediate) {
        var info = "callback for immediate watcher \"" + watcher.expression + "\"";
        pushTarget();
        invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
        popTarget();
      }

      return function unwatchFn() {
        watcher.teardown();
      };
    };
  }
  /*  */


  var uid$3 = 0;

  function initMixin(Vue) {
    Vue.prototype._init = function (options) {
      var vm = this; // a uid

      vm._uid = uid$3++;
      var startTag, endTag;
      /* istanbul ignore if */

      if ( config.performance && mark) {
        startTag = "vue-perf-start:" + vm._uid;
        endTag = "vue-perf-end:" + vm._uid;
        mark(startTag);
      } // a flag to avoid this being observed


      vm._isVue = true; // merge options

      if (options && options._isComponent) {
        // optimize internal component instantiation
        // since dynamic options merging is pretty slow, and none of the
        // internal component options needs special treatment.
        initInternalComponent(vm, options);
      } else {
        vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
      }
      /* istanbul ignore else */


      {
        initProxy(vm);
      } // expose real self


      vm._self = vm;
      initLifecycle(vm);
      initEvents(vm);
      initRender(vm);
      callHook(vm, 'beforeCreate');
      initInjections(vm); // resolve injections before data/props

      initState(vm);
      initProvide(vm); // resolve provide after data/props

      callHook(vm, 'created');
      /* istanbul ignore if */

      if ( config.performance && mark) {
        vm._name = formatComponentName(vm, false);
        mark(endTag);
        measure("vue " + vm._name + " init", startTag, endTag);
      }

      if (vm.$options.el) {
        vm.$mount(vm.$options.el);
      }
    };
  }

  function initInternalComponent(vm, options) {
    var opts = vm.$options = Object.create(vm.constructor.options); // doing this because it's faster than dynamic enumeration.

    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;

    if (options.render) {
      opts.render = options.render;
      opts.staticRenderFns = options.staticRenderFns;
    }
  }

  function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;

    if (Ctor.super) {
      var superOptions = resolveConstructorOptions(Ctor.super);
      var cachedSuperOptions = Ctor.superOptions;

      if (superOptions !== cachedSuperOptions) {
        // super option changed,
        // need to resolve new options.
        Ctor.superOptions = superOptions; // check if there are any late-modified/attached options (#4976)

        var modifiedOptions = resolveModifiedOptions(Ctor); // update base extend options

        if (modifiedOptions) {
          extend(Ctor.extendOptions, modifiedOptions);
        }

        options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);

        if (options.name) {
          options.components[options.name] = Ctor;
        }
      }
    }

    return options;
  }

  function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;

    for (var key in latest) {
      if (latest[key] !== sealed[key]) {
        if (!modified) {
          modified = {};
        }

        modified[key] = latest[key];
      }
    }

    return modified;
  }

  function Vue(options) {
    if ( !(this instanceof Vue)) {
      warn('Vue is a constructor and should be called with the `new` keyword');
    }

    this._init(options);
  }

  initMixin(Vue);
  stateMixin(Vue);
  eventsMixin(Vue);
  lifecycleMixin(Vue);
  renderMixin(Vue);
  /*  */

  function initUse(Vue) {
    Vue.use = function (plugin) {
      var installedPlugins = this._installedPlugins || (this._installedPlugins = []);

      if (installedPlugins.indexOf(plugin) > -1) {
        return this;
      } // additional parameters


      var args = toArray(arguments, 1);
      args.unshift(this);

      if (typeof plugin.install === 'function') {
        plugin.install.apply(plugin, args);
      } else if (typeof plugin === 'function') {
        plugin.apply(null, args);
      }

      installedPlugins.push(plugin);
      return this;
    };
  }
  /*  */


  function initMixin$1(Vue) {
    Vue.mixin = function (mixin) {
      this.options = mergeOptions(this.options, mixin);
      return this;
    };
  }
  /*  */


  function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */

    Vue.extend = function (extendOptions) {
      extendOptions = extendOptions || {};
      var Super = this;
      var SuperId = Super.cid;
      var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});

      if (cachedCtors[SuperId]) {
        return cachedCtors[SuperId];
      }

      var name = extendOptions.name || Super.options.name;

      if ( name) {
        validateComponentName(name);
      }

      var Sub = function VueComponent(options) {
        this._init(options);
      };

      Sub.prototype = Object.create(Super.prototype);
      Sub.prototype.constructor = Sub;
      Sub.cid = cid++;
      Sub.options = mergeOptions(Super.options, extendOptions);
      Sub['super'] = Super; // For props and computed properties, we define the proxy getters on
      // the Vue instances at extension time, on the extended prototype. This
      // avoids Object.defineProperty calls for each instance created.

      if (Sub.options.props) {
        initProps$1(Sub);
      }

      if (Sub.options.computed) {
        initComputed$1(Sub);
      } // allow further extension/mixin/plugin usage


      Sub.extend = Super.extend;
      Sub.mixin = Super.mixin;
      Sub.use = Super.use; // create asset registers, so extended classes
      // can have their private assets too.

      ASSET_TYPES.forEach(function (type) {
        Sub[type] = Super[type];
      }); // enable recursive self-lookup

      if (name) {
        Sub.options.components[name] = Sub;
      } // keep a reference to the super options at extension time.
      // later at instantiation we can check if Super's options have
      // been updated.


      Sub.superOptions = Super.options;
      Sub.extendOptions = extendOptions;
      Sub.sealedOptions = extend({}, Sub.options); // cache constructor

      cachedCtors[SuperId] = Sub;
      return Sub;
    };
  }

  function initProps$1(Comp) {
    var props = Comp.options.props;

    for (var key in props) {
      proxy(Comp.prototype, "_props", key);
    }
  }

  function initComputed$1(Comp) {
    var computed = Comp.options.computed;

    for (var key in computed) {
      defineComputed(Comp.prototype, key, computed[key]);
    }
  }
  /*  */


  function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
      Vue[type] = function (id, definition) {
        if (!definition) {
          return this.options[type + 's'][id];
        } else {
          /* istanbul ignore if */
          if ( type === 'component') {
            validateComponentName(id);
          }

          if (type === 'component' && isPlainObject(definition)) {
            definition.name = definition.name || id;
            definition = this.options._base.extend(definition);
          }

          if (type === 'directive' && typeof definition === 'function') {
            definition = {
              bind: definition,
              update: definition
            };
          }

          this.options[type + 's'][id] = definition;
          return definition;
        }
      };
    });
  }
  /*  */


  function getComponentName(opts) {
    return opts && (opts.Ctor.options.name || opts.tag);
  }

  function matches(pattern, name) {
    if (Array.isArray(pattern)) {
      return pattern.indexOf(name) > -1;
    } else if (typeof pattern === 'string') {
      return pattern.split(',').indexOf(name) > -1;
    } else if (isRegExp(pattern)) {
      return pattern.test(name);
    }
    /* istanbul ignore next */


    return false;
  }

  function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache;
    var keys = keepAliveInstance.keys;
    var _vnode = keepAliveInstance._vnode;

    for (var key in cache) {
      var entry = cache[key];

      if (entry) {
        var name = entry.name;

        if (name && !filter(name)) {
          pruneCacheEntry(cache, key, keys, _vnode);
        }
      }
    }
  }

  function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];

    if (entry && (!current || entry.tag !== current.tag)) {
      entry.componentInstance.$destroy();
    }

    cache[key] = null;
    remove(keys, key);
  }

  var patternTypes = [String, RegExp, Array];
  var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
      include: patternTypes,
      exclude: patternTypes,
      max: [String, Number]
    },
    methods: {
      cacheVNode: function cacheVNode() {
        var ref = this;
        var cache = ref.cache;
        var keys = ref.keys;
        var vnodeToCache = ref.vnodeToCache;
        var keyToCache = ref.keyToCache;

        if (vnodeToCache) {
          var tag = vnodeToCache.tag;
          var componentInstance = vnodeToCache.componentInstance;
          var componentOptions = vnodeToCache.componentOptions;
          cache[keyToCache] = {
            name: getComponentName(componentOptions),
            tag: tag,
            componentInstance: componentInstance
          };
          keys.push(keyToCache); // prune oldest entry

          if (this.max && keys.length > parseInt(this.max)) {
            pruneCacheEntry(cache, keys[0], keys, this._vnode);
          }

          this.vnodeToCache = null;
        }
      }
    },
    created: function created() {
      this.cache = Object.create(null);
      this.keys = [];
    },
    destroyed: function destroyed() {
      for (var key in this.cache) {
        pruneCacheEntry(this.cache, key, this.keys);
      }
    },
    mounted: function mounted() {
      var this$1 = this;
      this.cacheVNode();
      this.$watch('include', function (val) {
        pruneCache(this$1, function (name) {
          return matches(val, name);
        });
      });
      this.$watch('exclude', function (val) {
        pruneCache(this$1, function (name) {
          return !matches(val, name);
        });
      });
    },
    updated: function updated() {
      this.cacheVNode();
    },
    render: function render() {
      var slot = this.$slots.default;
      var vnode = getFirstComponentChild(slot);
      var componentOptions = vnode && vnode.componentOptions;

      if (componentOptions) {
        // check pattern
        var name = getComponentName(componentOptions);
        var ref = this;
        var include = ref.include;
        var exclude = ref.exclude;

        if ( // not included
        include && (!name || !matches(include, name)) || // excluded
        exclude && name && matches(exclude, name)) {
          return vnode;
        }

        var ref$1 = this;
        var cache = ref$1.cache;
        var keys = ref$1.keys;
        var key = vnode.key == null // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? "::" + componentOptions.tag : '') : vnode.key;

        if (cache[key]) {
          vnode.componentInstance = cache[key].componentInstance; // make current key freshest

          remove(keys, key);
          keys.push(key);
        } else {
          // delay setting the cache until update
          this.vnodeToCache = vnode;
          this.keyToCache = key;
        }

        vnode.data.keepAlive = true;
      }

      return vnode || slot && slot[0];
    }
  };
  var builtInComponents = {
    KeepAlive: KeepAlive
  };
  /*  */

  function initGlobalAPI(Vue) {
    // config
    var configDef = {};

    configDef.get = function () {
      return config;
    };

    {
      configDef.set = function () {
        warn('Do not replace the Vue.config object, set individual fields instead.');
      };
    }

    Object.defineProperty(Vue, 'config', configDef); // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.

    Vue.util = {
      warn: warn,
      extend: extend,
      mergeOptions: mergeOptions,
      defineReactive: defineReactive$$1
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick; // 2.6 explicit observable API

    Vue.observable = function (obj) {
      observe(obj);
      return obj;
    };

    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
      Vue.options[type + 's'] = Object.create(null);
    }); // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.

    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin$1(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
  }

  initGlobalAPI(Vue);
  Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
  });
  Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function get() {
      /* istanbul ignore next */
      return this.$vnode && this.$vnode.ssrContext;
    }
  }); // expose FunctionalRenderContext for ssr runtime helper installation

  Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
  });
  Vue.version = '2.6.14';
  /*  */
  // these are reserved for web because they are directly compiled away
  // during template compilation

  var isReservedAttr = makeMap('style,class'); // attributes that should be using props for binding

  var acceptValue = makeMap('input,textarea,option,select,progress');

  var mustUseProp = function mustUseProp(tag, type, attr) {
    return attr === 'value' && acceptValue(tag) && type !== 'button' || attr === 'selected' && tag === 'option' || attr === 'checked' && tag === 'input' || attr === 'muted' && tag === 'video';
  };

  var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
  var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

  var convertEnumeratedValue = function convertEnumeratedValue(key, value) {
    return isFalsyAttrValue(value) || value === 'false' ? 'false' // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value) ? value : 'true';
  };

  var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' + 'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' + 'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' + 'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' + 'required,reversed,scoped,seamless,selected,sortable,' + 'truespeed,typemustmatch,visible');
  var xlinkNS = 'http://www.w3.org/1999/xlink';

  var isXlink = function isXlink(name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
  };

  var getXlinkProp = function getXlinkProp(name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
  };

  var isFalsyAttrValue = function isFalsyAttrValue(val) {
    return val == null || val === false;
  };
  /*  */


  function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;

    while (isDef(childNode.componentInstance)) {
      childNode = childNode.componentInstance._vnode;

      if (childNode && childNode.data) {
        data = mergeClassData(childNode.data, data);
      }
    }

    while (isDef(parentNode = parentNode.parent)) {
      if (parentNode && parentNode.data) {
        data = mergeClassData(data, parentNode.data);
      }
    }

    return renderClass(data.staticClass, data.class);
  }

  function mergeClassData(child, parent) {
    return {
      staticClass: concat(child.staticClass, parent.staticClass),
      class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
  }

  function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
      return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */


    return '';
  }

  function concat(a, b) {
    return a ? b ? a + ' ' + b : a : b || '';
  }

  function stringifyClass(value) {
    if (Array.isArray(value)) {
      return stringifyArray(value);
    }

    if (isObject(value)) {
      return stringifyObject(value);
    }

    if (typeof value === 'string') {
      return value;
    }
    /* istanbul ignore next */


    return '';
  }

  function stringifyArray(value) {
    var res = '';
    var stringified;

    for (var i = 0, l = value.length; i < l; i++) {
      if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
        if (res) {
          res += ' ';
        }

        res += stringified;
      }
    }

    return res;
  }

  function stringifyObject(value) {
    var res = '';

    for (var key in value) {
      if (value[key]) {
        if (res) {
          res += ' ';
        }

        res += key;
      }
    }

    return res;
  }
  /*  */


  var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
  };
  var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' + 'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' + 'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' + 'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' + 's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' + 'embed,object,param,source,canvas,script,noscript,del,ins,' + 'caption,col,colgroup,table,thead,tbody,td,th,tr,' + 'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' + 'output,progress,select,textarea,' + 'details,dialog,menu,menuitem,summary,' + 'content,element,shadow,template,blockquote,iframe,tfoot'); // this map is intentionally selective, only covering SVG elements that may
  // contain child elements.

  var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' + 'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' + 'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);

  var isPreTag = function isPreTag(tag) {
    return tag === 'pre';
  };

  var isReservedTag = function isReservedTag(tag) {
    return isHTMLTag(tag) || isSVG(tag);
  };

  function getTagNamespace(tag) {
    if (isSVG(tag)) {
      return 'svg';
    } // basic support for MathML
    // note it doesn't support other MathML elements being component roots


    if (tag === 'math') {
      return 'math';
    }
  }

  var unknownElementCache = Object.create(null);

  function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
      return true;
    }

    if (isReservedTag(tag)) {
      return false;
    }

    tag = tag.toLowerCase();
    /* istanbul ignore if */

    if (unknownElementCache[tag] != null) {
      return unknownElementCache[tag];
    }

    var el = document.createElement(tag);

    if (tag.indexOf('-') > -1) {
      // http://stackoverflow.com/a/28210364/1070244
      return unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    } else {
      return unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
    }
  }

  var isTextInputType = makeMap('text,number,password,search,email,tel,url');
  /*  */

  /**
   * Query an element selector if it's not an element already.
   */

  function query(el) {
    if (typeof el === 'string') {
      var selected = document.querySelector(el);

      if (!selected) {
         warn('Cannot find element: ' + el);
        return document.createElement('div');
      }

      return selected;
    } else {
      return el;
    }
  }
  /*  */


  function createElement$1(tagName, vnode) {
    var elm = document.createElement(tagName);

    if (tagName !== 'select') {
      return elm;
    } // false or null will remove the attribute but undefined will not


    if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
      elm.setAttribute('multiple', 'multiple');
    }

    return elm;
  }

  function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
  }

  function createTextNode(text) {
    return document.createTextNode(text);
  }

  function createComment(text) {
    return document.createComment(text);
  }

  function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
  }

  function removeChild(node, child) {
    node.removeChild(child);
  }

  function appendChild(node, child) {
    node.appendChild(child);
  }

  function parentNode(node) {
    return node.parentNode;
  }

  function nextSibling(node) {
    return node.nextSibling;
  }

  function tagName(node) {
    return node.tagName;
  }

  function setTextContent(node, text) {
    node.textContent = text;
  }

  function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
  }

  var nodeOps = /*#__PURE__*/Object.freeze({
    createElement: createElement$1,
    createElementNS: createElementNS,
    createTextNode: createTextNode,
    createComment: createComment,
    insertBefore: insertBefore,
    removeChild: removeChild,
    appendChild: appendChild,
    parentNode: parentNode,
    nextSibling: nextSibling,
    tagName: tagName,
    setTextContent: setTextContent,
    setStyleScope: setStyleScope
  });
  /*  */

  var ref = {
    create: function create(_, vnode) {
      registerRef(vnode);
    },
    update: function update(oldVnode, vnode) {
      if (oldVnode.data.ref !== vnode.data.ref) {
        registerRef(oldVnode, true);
        registerRef(vnode);
      }
    },
    destroy: function destroy(vnode) {
      registerRef(vnode, true);
    }
  };

  function registerRef(vnode, isRemoval) {
    var key = vnode.data.ref;

    if (!isDef(key)) {
      return;
    }

    var vm = vnode.context;
    var ref = vnode.componentInstance || vnode.elm;
    var refs = vm.$refs;

    if (isRemoval) {
      if (Array.isArray(refs[key])) {
        remove(refs[key], ref);
      } else if (refs[key] === ref) {
        refs[key] = undefined;
      }
    } else {
      if (vnode.data.refInFor) {
        if (!Array.isArray(refs[key])) {
          refs[key] = [ref];
        } else if (refs[key].indexOf(ref) < 0) {
          // $flow-disable-line
          refs[key].push(ref);
        }
      } else {
        refs[key] = ref;
      }
    }
  }
  /**
   * Virtual DOM patching algorithm based on Snabbdom by
   * Simon Friis Vindum (@paldepind)
   * Licensed under the MIT License
   * https://github.com/paldepind/snabbdom/blob/master/LICENSE
   *
   * modified by Evan You (@yyx990803)
   *
   * Not type-checking this because this file is perf-critical and the cost
   * of making flow understand it is not worth it.
   */


  var emptyNode = new VNode('', {}, []);
  var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

  function sameVnode(a, b) {
    return a.key === b.key && a.asyncFactory === b.asyncFactory && (a.tag === b.tag && a.isComment === b.isComment && isDef(a.data) === isDef(b.data) && sameInputType(a, b) || isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error));
  }

  function sameInputType(a, b) {
    if (a.tag !== 'input') {
      return true;
    }

    var i;
    var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
    var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
    return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB);
  }

  function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};

    for (i = beginIdx; i <= endIdx; ++i) {
      key = children[i].key;

      if (isDef(key)) {
        map[key] = i;
      }
    }

    return map;
  }

  function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules;
    var nodeOps = backend.nodeOps;

    for (i = 0; i < hooks.length; ++i) {
      cbs[hooks[i]] = [];

      for (j = 0; j < modules.length; ++j) {
        if (isDef(modules[j][hooks[i]])) {
          cbs[hooks[i]].push(modules[j][hooks[i]]);
        }
      }
    }

    function emptyNodeAt(elm) {
      return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }

    function createRmCb(childElm, listeners) {
      function remove$$1() {
        if (--remove$$1.listeners === 0) {
          removeNode(childElm);
        }
      }

      remove$$1.listeners = listeners;
      return remove$$1;
    }

    function removeNode(el) {
      var parent = nodeOps.parentNode(el); // element may have already been removed due to v-html / v-text

      if (isDef(parent)) {
        nodeOps.removeChild(parent, el);
      }
    }

    function isUnknownElement$$1(vnode, inVPre) {
      return !inVPre && !vnode.ns && !(config.ignoredElements.length && config.ignoredElements.some(function (ignore) {
        return isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
      })) && config.isUnknownElement(vnode.tag);
    }

    var creatingElmInVPre = 0;

    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
      if (isDef(vnode.elm) && isDef(ownerArray)) {
        // This vnode was used in a previous render!
        // now it's used as a new node, overwriting its elm would cause
        // potential patch errors down the road when it's used as an insertion
        // reference node. Instead, we clone the node on-demand before creating
        // associated DOM element for it.
        vnode = ownerArray[index] = cloneVNode(vnode);
      }

      vnode.isRootInsert = !nested; // for transition enter check

      if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
        return;
      }

      var data = vnode.data;
      var children = vnode.children;
      var tag = vnode.tag;

      if (isDef(tag)) {
        {
          if (data && data.pre) {
            creatingElmInVPre++;
          }

          if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
            warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.', vnode.context);
          }
        }

        vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
        setScope(vnode);
        /* istanbul ignore if */

        {
          createChildren(vnode, children, insertedVnodeQueue);

          if (isDef(data)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
          }

          insert(parentElm, vnode.elm, refElm);
        }

        if ( data && data.pre) {
          creatingElmInVPre--;
        }
      } else if (isTrue(vnode.isComment)) {
        vnode.elm = nodeOps.createComment(vnode.text);
        insert(parentElm, vnode.elm, refElm);
      } else {
        vnode.elm = nodeOps.createTextNode(vnode.text);
        insert(parentElm, vnode.elm, refElm);
      }
    }

    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
      var i = vnode.data;

      if (isDef(i)) {
        var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;

        if (isDef(i = i.hook) && isDef(i = i.init)) {
          i(vnode, false
          /* hydrating */
          );
        } // after calling the init hook, if the vnode is a child component
        // it should've created a child instance and mounted it. the child
        // component also has set the placeholder vnode's elm.
        // in that case we can just return the element and be done.


        if (isDef(vnode.componentInstance)) {
          initComponent(vnode, insertedVnodeQueue);
          insert(parentElm, vnode.elm, refElm);

          if (isTrue(isReactivated)) {
            reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
          }

          return true;
        }
      }
    }

    function initComponent(vnode, insertedVnodeQueue) {
      if (isDef(vnode.data.pendingInsert)) {
        insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
        vnode.data.pendingInsert = null;
      }

      vnode.elm = vnode.componentInstance.$el;

      if (isPatchable(vnode)) {
        invokeCreateHooks(vnode, insertedVnodeQueue);
        setScope(vnode);
      } else {
        // empty component root.
        // skip all element-related modules except for ref (#3455)
        registerRef(vnode); // make sure to invoke the insert hook

        insertedVnodeQueue.push(vnode);
      }
    }

    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
      var i; // hack for #4339: a reactivated component with inner transition
      // does not trigger because the inner node's created hooks are not called
      // again. It's not ideal to involve module-specific logic in here but
      // there doesn't seem to be a better way to do it.

      var innerNode = vnode;

      while (innerNode.componentInstance) {
        innerNode = innerNode.componentInstance._vnode;

        if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
          for (i = 0; i < cbs.activate.length; ++i) {
            cbs.activate[i](emptyNode, innerNode);
          }

          insertedVnodeQueue.push(innerNode);
          break;
        }
      } // unlike a newly created component,
      // a reactivated keep-alive component doesn't insert itself


      insert(parentElm, vnode.elm, refElm);
    }

    function insert(parent, elm, ref$$1) {
      if (isDef(parent)) {
        if (isDef(ref$$1)) {
          if (nodeOps.parentNode(ref$$1) === parent) {
            nodeOps.insertBefore(parent, elm, ref$$1);
          }
        } else {
          nodeOps.appendChild(parent, elm);
        }
      }
    }

    function createChildren(vnode, children, insertedVnodeQueue) {
      if (Array.isArray(children)) {
        {
          checkDuplicateKeys(children);
        }

        for (var i = 0; i < children.length; ++i) {
          createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
        }
      } else if (isPrimitive(vnode.text)) {
        nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
      }
    }

    function isPatchable(vnode) {
      while (vnode.componentInstance) {
        vnode = vnode.componentInstance._vnode;
      }

      return isDef(vnode.tag);
    }

    function invokeCreateHooks(vnode, insertedVnodeQueue) {
      for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
        cbs.create[i$1](emptyNode, vnode);
      }

      i = vnode.data.hook; // Reuse variable

      if (isDef(i)) {
        if (isDef(i.create)) {
          i.create(emptyNode, vnode);
        }

        if (isDef(i.insert)) {
          insertedVnodeQueue.push(vnode);
        }
      }
    } // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.


    function setScope(vnode) {
      var i;

      if (isDef(i = vnode.fnScopeId)) {
        nodeOps.setStyleScope(vnode.elm, i);
      } else {
        var ancestor = vnode;

        while (ancestor) {
          if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
          }

          ancestor = ancestor.parent;
        }
      } // for slot content they should also get the scopeId from the host instance.


      if (isDef(i = activeInstance) && i !== vnode.context && i !== vnode.fnContext && isDef(i = i.$options._scopeId)) {
        nodeOps.setStyleScope(vnode.elm, i);
      }
    }

    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
      for (; startIdx <= endIdx; ++startIdx) {
        createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
      }
    }

    function invokeDestroyHook(vnode) {
      var i, j;
      var data = vnode.data;

      if (isDef(data)) {
        if (isDef(i = data.hook) && isDef(i = i.destroy)) {
          i(vnode);
        }

        for (i = 0; i < cbs.destroy.length; ++i) {
          cbs.destroy[i](vnode);
        }
      }

      if (isDef(i = vnode.children)) {
        for (j = 0; j < vnode.children.length; ++j) {
          invokeDestroyHook(vnode.children[j]);
        }
      }
    }

    function removeVnodes(vnodes, startIdx, endIdx) {
      for (; startIdx <= endIdx; ++startIdx) {
        var ch = vnodes[startIdx];

        if (isDef(ch)) {
          if (isDef(ch.tag)) {
            removeAndInvokeRemoveHook(ch);
            invokeDestroyHook(ch);
          } else {
            // Text node
            removeNode(ch.elm);
          }
        }
      }
    }

    function removeAndInvokeRemoveHook(vnode, rm) {
      if (isDef(rm) || isDef(vnode.data)) {
        var i;
        var listeners = cbs.remove.length + 1;

        if (isDef(rm)) {
          // we have a recursively passed down rm callback
          // increase the listeners count
          rm.listeners += listeners;
        } else {
          // directly removing
          rm = createRmCb(vnode.elm, listeners);
        } // recursively invoke hooks on child component root node


        if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
          removeAndInvokeRemoveHook(i, rm);
        }

        for (i = 0; i < cbs.remove.length; ++i) {
          cbs.remove[i](vnode, rm);
        }

        if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
          i(vnode, rm);
        } else {
          rm();
        }
      } else {
        removeNode(vnode.elm);
      }
    }

    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
      var oldStartIdx = 0;
      var newStartIdx = 0;
      var oldEndIdx = oldCh.length - 1;
      var oldStartVnode = oldCh[0];
      var oldEndVnode = oldCh[oldEndIdx];
      var newEndIdx = newCh.length - 1;
      var newStartVnode = newCh[0];
      var newEndVnode = newCh[newEndIdx];
      var oldKeyToIdx, idxInOld, vnodeToMove, refElm; // removeOnly is a special flag used only by <transition-group>
      // to ensure removed elements stay in correct relative positions
      // during leaving transitions

      var canMove = !removeOnly;

      {
        checkDuplicateKeys(newCh);
      }

      while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
        if (isUndef(oldStartVnode)) {
          oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
        } else if (isUndef(oldEndVnode)) {
          oldEndVnode = oldCh[--oldEndIdx];
        } else if (sameVnode(oldStartVnode, newStartVnode)) {
          patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
          oldStartVnode = oldCh[++oldStartIdx];
          newStartVnode = newCh[++newStartIdx];
        } else if (sameVnode(oldEndVnode, newEndVnode)) {
          patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
          oldEndVnode = oldCh[--oldEndIdx];
          newEndVnode = newCh[--newEndIdx];
        } else if (sameVnode(oldStartVnode, newEndVnode)) {
          // Vnode moved right
          patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
          canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
          oldStartVnode = oldCh[++oldStartIdx];
          newEndVnode = newCh[--newEndIdx];
        } else if (sameVnode(oldEndVnode, newStartVnode)) {
          // Vnode moved left
          patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
          canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
          oldEndVnode = oldCh[--oldEndIdx];
          newStartVnode = newCh[++newStartIdx];
        } else {
          if (isUndef(oldKeyToIdx)) {
            oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
          }

          idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);

          if (isUndef(idxInOld)) {
            // New element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          } else {
            vnodeToMove = oldCh[idxInOld];

            if (sameVnode(vnodeToMove, newStartVnode)) {
              patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
              oldCh[idxInOld] = undefined;
              canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
            } else {
              // same key but different element. treat as new element
              createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
            }
          }

          newStartVnode = newCh[++newStartIdx];
        }
      }

      if (oldStartIdx > oldEndIdx) {
        refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
        addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
      } else if (newStartIdx > newEndIdx) {
        removeVnodes(oldCh, oldStartIdx, oldEndIdx);
      }
    }

    function checkDuplicateKeys(children) {
      var seenKeys = {};

      for (var i = 0; i < children.length; i++) {
        var vnode = children[i];
        var key = vnode.key;

        if (isDef(key)) {
          if (seenKeys[key]) {
            warn("Duplicate keys detected: '" + key + "'. This may cause an update error.", vnode.context);
          } else {
            seenKeys[key] = true;
          }
        }
      }
    }

    function findIdxInOld(node, oldCh, start, end) {
      for (var i = start; i < end; i++) {
        var c = oldCh[i];

        if (isDef(c) && sameVnode(node, c)) {
          return i;
        }
      }
    }

    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
      if (oldVnode === vnode) {
        return;
      }

      if (isDef(vnode.elm) && isDef(ownerArray)) {
        // clone reused vnode
        vnode = ownerArray[index] = cloneVNode(vnode);
      }

      var elm = vnode.elm = oldVnode.elm;

      if (isTrue(oldVnode.isAsyncPlaceholder)) {
        if (isDef(vnode.asyncFactory.resolved)) {
          hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
        } else {
          vnode.isAsyncPlaceholder = true;
        }

        return;
      } // reuse element for static trees.
      // note we only do this if the vnode is cloned -
      // if the new node is not cloned it means the render functions have been
      // reset by the hot-reload-api and we need to do a proper re-render.


      if (isTrue(vnode.isStatic) && isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
        vnode.componentInstance = oldVnode.componentInstance;
        return;
      }

      var i;
      var data = vnode.data;

      if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
        i(oldVnode, vnode);
      }

      var oldCh = oldVnode.children;
      var ch = vnode.children;

      if (isDef(data) && isPatchable(vnode)) {
        for (i = 0; i < cbs.update.length; ++i) {
          cbs.update[i](oldVnode, vnode);
        }

        if (isDef(i = data.hook) && isDef(i = i.update)) {
          i(oldVnode, vnode);
        }
      }

      if (isUndef(vnode.text)) {
        if (isDef(oldCh) && isDef(ch)) {
          if (oldCh !== ch) {
            updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
          }
        } else if (isDef(ch)) {
          {
            checkDuplicateKeys(ch);
          }

          if (isDef(oldVnode.text)) {
            nodeOps.setTextContent(elm, '');
          }

          addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
        } else if (isDef(oldCh)) {
          removeVnodes(oldCh, 0, oldCh.length - 1);
        } else if (isDef(oldVnode.text)) {
          nodeOps.setTextContent(elm, '');
        }
      } else if (oldVnode.text !== vnode.text) {
        nodeOps.setTextContent(elm, vnode.text);
      }

      if (isDef(data)) {
        if (isDef(i = data.hook) && isDef(i = i.postpatch)) {
          i(oldVnode, vnode);
        }
      }
    }

    function invokeInsertHook(vnode, queue, initial) {
      // delay insert hooks for component root nodes, invoke them after the
      // element is really inserted
      if (isTrue(initial) && isDef(vnode.parent)) {
        vnode.parent.data.pendingInsert = queue;
      } else {
        for (var i = 0; i < queue.length; ++i) {
          queue[i].data.hook.insert(queue[i]);
        }
      }
    }

    var hydrationBailed = false; // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).

    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key'); // Note: this is a browser-only function so we can assume elms are DOM nodes.

    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
      var i;
      var tag = vnode.tag;
      var data = vnode.data;
      var children = vnode.children;
      inVPre = inVPre || data && data.pre;
      vnode.elm = elm;

      if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
        vnode.isAsyncPlaceholder = true;
        return true;
      } // assert node match


      {
        if (!assertNodeMatch(elm, vnode, inVPre)) {
          return false;
        }
      }

      if (isDef(data)) {
        if (isDef(i = data.hook) && isDef(i = i.init)) {
          i(vnode, true
          /* hydrating */
          );
        }

        if (isDef(i = vnode.componentInstance)) {
          // child component. it should have hydrated its own tree.
          initComponent(vnode, insertedVnodeQueue);
          return true;
        }
      }

      if (isDef(tag)) {
        if (isDef(children)) {
          // empty element, allow client to pick up and populate children
          if (!elm.hasChildNodes()) {
            createChildren(vnode, children, insertedVnodeQueue);
          } else {
            // v-html and domProps: innerHTML
            if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
              if (i !== elm.innerHTML) {
                /* istanbul ignore if */
                if ( typeof console !== 'undefined' && !hydrationBailed) {
                  hydrationBailed = true;
                  console.warn('Parent: ', elm);
                  console.warn('server innerHTML: ', i);
                  console.warn('client innerHTML: ', elm.innerHTML);
                }

                return false;
              }
            } else {
              // iterate and compare children lists
              var childrenMatch = true;
              var childNode = elm.firstChild;

              for (var i$1 = 0; i$1 < children.length; i$1++) {
                if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                  childrenMatch = false;
                  break;
                }

                childNode = childNode.nextSibling;
              } // if childNode is not null, it means the actual childNodes list is
              // longer than the virtual children list.


              if (!childrenMatch || childNode) {
                /* istanbul ignore if */
                if ( typeof console !== 'undefined' && !hydrationBailed) {
                  hydrationBailed = true;
                  console.warn('Parent: ', elm);
                  console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                }

                return false;
              }
            }
          }
        }

        if (isDef(data)) {
          var fullInvoke = false;

          for (var key in data) {
            if (!isRenderedModule(key)) {
              fullInvoke = true;
              invokeCreateHooks(vnode, insertedVnodeQueue);
              break;
            }
          }

          if (!fullInvoke && data['class']) {
            // ensure collecting deps for deep class bindings for future updates
            traverse(data['class']);
          }
        }
      } else if (elm.data !== vnode.text) {
        elm.data = vnode.text;
      }

      return true;
    }

    function assertNodeMatch(node, vnode, inVPre) {
      if (isDef(vnode.tag)) {
        return vnode.tag.indexOf('vue-component') === 0 || !isUnknownElement$$1(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
      } else {
        return node.nodeType === (vnode.isComment ? 8 : 3);
      }
    }

    return function patch(oldVnode, vnode, hydrating, removeOnly) {
      if (isUndef(vnode)) {
        if (isDef(oldVnode)) {
          invokeDestroyHook(oldVnode);
        }

        return;
      }

      var isInitialPatch = false;
      var insertedVnodeQueue = [];

      if (isUndef(oldVnode)) {
        // empty mount (likely as component), create new root element
        isInitialPatch = true;
        createElm(vnode, insertedVnodeQueue);
      } else {
        var isRealElement = isDef(oldVnode.nodeType);

        if (!isRealElement && sameVnode(oldVnode, vnode)) {
          // patch existing root node
          patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
        } else {
          if (isRealElement) {
            // mounting to a real element
            // check if this is server-rendered content and if we can perform
            // a successful hydration.
            if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
              oldVnode.removeAttribute(SSR_ATTR);
              hydrating = true;
            }

            if (isTrue(hydrating)) {
              if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                invokeInsertHook(vnode, insertedVnodeQueue, true);
                return oldVnode;
              } else {
                warn('The client-side rendered virtual DOM tree is not matching ' + 'server-rendered content. This is likely caused by incorrect ' + 'HTML markup, for example nesting block-level elements inside ' + '<p>, or missing <tbody>. Bailing hydration and performing ' + 'full client-side render.');
              }
            } // either not server-rendered, or hydration failed.
            // create an empty node and replace it


            oldVnode = emptyNodeAt(oldVnode);
          } // replacing existing element


          var oldElm = oldVnode.elm;
          var parentElm = nodeOps.parentNode(oldElm); // create new node

          createElm(vnode, insertedVnodeQueue, // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm)); // update parent placeholder node element, recursively

          if (isDef(vnode.parent)) {
            var ancestor = vnode.parent;
            var patchable = isPatchable(vnode);

            while (ancestor) {
              for (var i = 0; i < cbs.destroy.length; ++i) {
                cbs.destroy[i](ancestor);
              }

              ancestor.elm = vnode.elm;

              if (patchable) {
                for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                  cbs.create[i$1](emptyNode, ancestor);
                } // #6513
                // invoke insert hooks that may have been merged by create hooks.
                // e.g. for directives that uses the "inserted" hook.


                var insert = ancestor.data.hook.insert;

                if (insert.merged) {
                  // start at index 1 to avoid re-invoking component mounted hook
                  for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                    insert.fns[i$2]();
                  }
                }
              } else {
                registerRef(ancestor);
              }

              ancestor = ancestor.parent;
            }
          } // destroy old node


          if (isDef(parentElm)) {
            removeVnodes([oldVnode], 0, 0);
          } else if (isDef(oldVnode.tag)) {
            invokeDestroyHook(oldVnode);
          }
        }
      }

      invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
      return vnode.elm;
    };
  }
  /*  */


  var directives = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
      updateDirectives(vnode, emptyNode);
    }
  };

  function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
      _update(oldVnode, vnode);
    }
  }

  function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;

    for (key in newDirs) {
      oldDir = oldDirs[key];
      dir = newDirs[key];

      if (!oldDir) {
        // new directive, bind
        callHook$1(dir, 'bind', vnode, oldVnode);

        if (dir.def && dir.def.inserted) {
          dirsWithInsert.push(dir);
        }
      } else {
        // existing directive, update
        dir.oldValue = oldDir.value;
        dir.oldArg = oldDir.arg;
        callHook$1(dir, 'update', vnode, oldVnode);

        if (dir.def && dir.def.componentUpdated) {
          dirsWithPostpatch.push(dir);
        }
      }
    }

    if (dirsWithInsert.length) {
      var callInsert = function callInsert() {
        for (var i = 0; i < dirsWithInsert.length; i++) {
          callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
        }
      };

      if (isCreate) {
        mergeVNodeHook(vnode, 'insert', callInsert);
      } else {
        callInsert();
      }
    }

    if (dirsWithPostpatch.length) {
      mergeVNodeHook(vnode, 'postpatch', function () {
        for (var i = 0; i < dirsWithPostpatch.length; i++) {
          callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
        }
      });
    }

    if (!isCreate) {
      for (key in oldDirs) {
        if (!newDirs[key]) {
          // no longer present, unbind
          callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
        }
      }
    }
  }

  var emptyModifiers = Object.create(null);

  function normalizeDirectives$1(dirs, vm) {
    var res = Object.create(null);

    if (!dirs) {
      // $flow-disable-line
      return res;
    }

    var i, dir;

    for (i = 0; i < dirs.length; i++) {
      dir = dirs[i];

      if (!dir.modifiers) {
        // $flow-disable-line
        dir.modifiers = emptyModifiers;
      }

      res[getRawDirName(dir)] = dir;
      dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
    } // $flow-disable-line


    return res;
  }

  function getRawDirName(dir) {
    return dir.rawName || dir.name + "." + Object.keys(dir.modifiers || {}).join('.');
  }

  function callHook$1(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];

    if (fn) {
      try {
        fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
      } catch (e) {
        handleError(e, vnode.context, "directive " + dir.name + " " + hook + " hook");
      }
    }
  }

  var baseModules = [ref, directives];
  /*  */

  function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;

    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
      return;
    }

    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
      return;
    }

    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {}; // clone observed objects, as the user probably wants to mutate it

    if (isDef(attrs.__ob__)) {
      attrs = vnode.data.attrs = extend({}, attrs);
    }

    for (key in attrs) {
      cur = attrs[key];
      old = oldAttrs[key];

      if (old !== cur) {
        setAttr(elm, key, cur, vnode.data.pre);
      }
    } // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max

    /* istanbul ignore if */


    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
      setAttr(elm, 'value', attrs.value);
    }

    for (key in oldAttrs) {
      if (isUndef(attrs[key])) {
        if (isXlink(key)) {
          elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
        } else if (!isEnumeratedAttr(key)) {
          elm.removeAttribute(key);
        }
      }
    }
  }

  function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
      baseSetAttr(el, key, value);
    } else if (isBooleanAttr(key)) {
      // set attribute for blank value
      // e.g. <option disabled>Select one</option>
      if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
      } else {
        // technically allowfullscreen is a boolean attribute for <iframe>,
        // but Flash expects a value of "true" when used on <embed> tag
        value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
        el.setAttribute(key, value);
      }
    } else if (isEnumeratedAttr(key)) {
      el.setAttribute(key, convertEnumeratedValue(key, value));
    } else if (isXlink(key)) {
      if (isFalsyAttrValue(value)) {
        el.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else {
        el.setAttributeNS(xlinkNS, key, value);
      }
    } else {
      baseSetAttr(el, key, value);
    }
  }

  function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.

      /* istanbul ignore if */
      if (isIE && !isIE9 && el.tagName === 'TEXTAREA' && key === 'placeholder' && value !== '' && !el.__ieph) {
        var blocker = function blocker(e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };

        el.addEventListener('input', blocker); // $flow-disable-line

        el.__ieph = true;
        /* IE placeholder patched */
      }

      el.setAttribute(key, value);
    }
  }

  var attrs = {
    create: updateAttrs,
    update: updateAttrs
  };
  /*  */

  function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;

    if (isUndef(data.staticClass) && isUndef(data.class) && (isUndef(oldData) || isUndef(oldData.staticClass) && isUndef(oldData.class))) {
      return;
    }

    var cls = genClassForVnode(vnode); // handle transition classes

    var transitionClass = el._transitionClasses;

    if (isDef(transitionClass)) {
      cls = concat(cls, stringifyClass(transitionClass));
    } // set the class


    if (cls !== el._prevClass) {
      el.setAttribute('class', cls);
      el._prevClass = cls;
    }
  }

  var klass = {
    create: updateClass,
    update: updateClass
  };
  /*  */

  var validDivisionCharRE = /[\w).+\-_$\]]/;

  function parseFilters(exp) {
    var inSingle = false;
    var inDouble = false;
    var inTemplateString = false;
    var inRegex = false;
    var curly = 0;
    var square = 0;
    var paren = 0;
    var lastFilterIndex = 0;
    var c, prev, i, expression, filters;

    for (i = 0; i < exp.length; i++) {
      prev = c;
      c = exp.charCodeAt(i);

      if (inSingle) {
        if (c === 0x27 && prev !== 0x5C) {
          inSingle = false;
        }
      } else if (inDouble) {
        if (c === 0x22 && prev !== 0x5C) {
          inDouble = false;
        }
      } else if (inTemplateString) {
        if (c === 0x60 && prev !== 0x5C) {
          inTemplateString = false;
        }
      } else if (inRegex) {
        if (c === 0x2f && prev !== 0x5C) {
          inRegex = false;
        }
      } else if (c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C && exp.charCodeAt(i - 1) !== 0x7C && !curly && !square && !paren) {
        if (expression === undefined) {
          // first filter, end of expression
          lastFilterIndex = i + 1;
          expression = exp.slice(0, i).trim();
        } else {
          pushFilter();
        }
      } else {
        switch (c) {
          case 0x22:
            inDouble = true;
            break;
          // "

          case 0x27:
            inSingle = true;
            break;
          // '

          case 0x60:
            inTemplateString = true;
            break;
          // `

          case 0x28:
            paren++;
            break;
          // (

          case 0x29:
            paren--;
            break;
          // )

          case 0x5B:
            square++;
            break;
          // [

          case 0x5D:
            square--;
            break;
          // ]

          case 0x7B:
            curly++;
            break;
          // {

          case 0x7D:
            curly--;
            break;
          // }
        }

        if (c === 0x2f) {
          // /
          var j = i - 1;
          var p = void 0; // find first non-whitespace prev char

          for (; j >= 0; j--) {
            p = exp.charAt(j);

            if (p !== ' ') {
              break;
            }
          }

          if (!p || !validDivisionCharRE.test(p)) {
            inRegex = true;
          }
        }
      }
    }

    if (expression === undefined) {
      expression = exp.slice(0, i).trim();
    } else if (lastFilterIndex !== 0) {
      pushFilter();
    }

    function pushFilter() {
      (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
      lastFilterIndex = i + 1;
    }

    if (filters) {
      for (i = 0; i < filters.length; i++) {
        expression = wrapFilter(expression, filters[i]);
      }
    }

    return expression;
  }

  function wrapFilter(exp, filter) {
    var i = filter.indexOf('(');

    if (i < 0) {
      // _f: resolveFilter
      return "_f(\"" + filter + "\")(" + exp + ")";
    } else {
      var name = filter.slice(0, i);
      var args = filter.slice(i + 1);
      return "_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args);
    }
  }
  /*  */

  /* eslint-disable no-unused-vars */


  function baseWarn(msg, range) {
    console.error("[Vue compiler]: " + msg);
  }
  /* eslint-enable no-unused-vars */


  function pluckModuleFunction(modules, key) {
    return modules ? modules.map(function (m) {
      return m[key];
    }).filter(function (_) {
      return _;
    }) : [];
  }

  function addProp(el, name, value, range, dynamic) {
    (el.props || (el.props = [])).push(rangeSetItem({
      name: name,
      value: value,
      dynamic: dynamic
    }, range));
    el.plain = false;
  }

  function addAttr(el, name, value, range, dynamic) {
    var attrs = dynamic ? el.dynamicAttrs || (el.dynamicAttrs = []) : el.attrs || (el.attrs = []);
    attrs.push(rangeSetItem({
      name: name,
      value: value,
      dynamic: dynamic
    }, range));
    el.plain = false;
  } // add a raw attr (use this in preTransforms)


  function addRawAttr(el, name, value, range) {
    el.attrsMap[name] = value;
    el.attrsList.push(rangeSetItem({
      name: name,
      value: value
    }, range));
  }

  function addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
    (el.directives || (el.directives = [])).push(rangeSetItem({
      name: name,
      rawName: rawName,
      value: value,
      arg: arg,
      isDynamicArg: isDynamicArg,
      modifiers: modifiers
    }, range));
    el.plain = false;
  }

  function prependModifierMarker(symbol, name, dynamic) {
    return dynamic ? "_p(" + name + ",\"" + symbol + "\")" : symbol + name; // mark the event as captured
  }

  function addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
    modifiers = modifiers || emptyObject; // warn prevent and passive modifier

    /* istanbul ignore if */

    if ( warn && modifiers.prevent && modifiers.passive) {
      warn('passive and prevent can\'t be used together. ' + 'Passive handler can\'t prevent default event.', range);
    } // normalize click.right and click.middle since they don't actually fire
    // this is technically browser-specific, but at least for now browsers are
    // the only target envs that have right/middle clicks.


    if (modifiers.right) {
      if (dynamic) {
        name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
      } else if (name === 'click') {
        name = 'contextmenu';
        delete modifiers.right;
      }
    } else if (modifiers.middle) {
      if (dynamic) {
        name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
      } else if (name === 'click') {
        name = 'mouseup';
      }
    } // check capture modifier


    if (modifiers.capture) {
      delete modifiers.capture;
      name = prependModifierMarker('!', name, dynamic);
    }

    if (modifiers.once) {
      delete modifiers.once;
      name = prependModifierMarker('~', name, dynamic);
    }
    /* istanbul ignore if */


    if (modifiers.passive) {
      delete modifiers.passive;
      name = prependModifierMarker('&', name, dynamic);
    }

    var events;

    if (modifiers.native) {
      delete modifiers.native;
      events = el.nativeEvents || (el.nativeEvents = {});
    } else {
      events = el.events || (el.events = {});
    }

    var newHandler = rangeSetItem({
      value: value.trim(),
      dynamic: dynamic
    }, range);

    if (modifiers !== emptyObject) {
      newHandler.modifiers = modifiers;
    }

    var handlers = events[name];
    /* istanbul ignore if */

    if (Array.isArray(handlers)) {
      important ? handlers.unshift(newHandler) : handlers.push(newHandler);
    } else if (handlers) {
      events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
    } else {
      events[name] = newHandler;
    }

    el.plain = false;
  }

  function getRawBindingAttr(el, name) {
    return el.rawAttrsMap[':' + name] || el.rawAttrsMap['v-bind:' + name] || el.rawAttrsMap[name];
  }

  function getBindingAttr(el, name, getStatic) {
    var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);

    if (dynamicValue != null) {
      return parseFilters(dynamicValue);
    } else if (getStatic !== false) {
      var staticValue = getAndRemoveAttr(el, name);

      if (staticValue != null) {
        return JSON.stringify(staticValue);
      }
    }
  } // note: this only removes the attr from the Array (attrsList) so that it
  // doesn't get processed by processAttrs.
  // By default it does NOT remove it from the map (attrsMap) because the map is
  // needed during codegen.


  function getAndRemoveAttr(el, name, removeFromMap) {
    var val;

    if ((val = el.attrsMap[name]) != null) {
      var list = el.attrsList;

      for (var i = 0, l = list.length; i < l; i++) {
        if (list[i].name === name) {
          list.splice(i, 1);
          break;
        }
      }
    }

    if (removeFromMap) {
      delete el.attrsMap[name];
    }

    return val;
  }

  function getAndRemoveAttrByRegex(el, name) {
    var list = el.attrsList;

    for (var i = 0, l = list.length; i < l; i++) {
      var attr = list[i];

      if (name.test(attr.name)) {
        list.splice(i, 1);
        return attr;
      }
    }
  }

  function rangeSetItem(item, range) {
    if (range) {
      if (range.start != null) {
        item.start = range.start;
      }

      if (range.end != null) {
        item.end = range.end;
      }
    }

    return item;
  }
  /*  */

  /**
   * Cross-platform code generation for component v-model
   */


  function genComponentModel(el, value, modifiers) {
    var ref = modifiers || {};
    var number = ref.number;
    var trim = ref.trim;
    var baseValueExpression = '$$v';
    var valueExpression = baseValueExpression;

    if (trim) {
      valueExpression = "(typeof " + baseValueExpression + " === 'string'" + "? " + baseValueExpression + ".trim()" + ": " + baseValueExpression + ")";
    }

    if (number) {
      valueExpression = "_n(" + valueExpression + ")";
    }

    var assignment = genAssignmentCode(value, valueExpression);
    el.model = {
      value: "(" + value + ")",
      expression: JSON.stringify(value),
      callback: "function (" + baseValueExpression + ") {" + assignment + "}"
    };
  }
  /**
   * Cross-platform codegen helper for generating v-model value assignment code.
   */


  function genAssignmentCode(value, assignment) {
    var res = parseModel(value);

    if (res.key === null) {
      return value + "=" + assignment;
    } else {
      return "$set(" + res.exp + ", " + res.key + ", " + assignment + ")";
    }
  }
  /**
   * Parse a v-model expression into a base path and a final key segment.
   * Handles both dot-path and possible square brackets.
   *
   * Possible cases:
   *
   * - test
   * - test[key]
   * - test[test1[key]]
   * - test["a"][key]
   * - xxx.test[a[a].test1[key]]
   * - test.xxx.a["asa"][test1[key]]
   *
   */


  var len, str, chr, index$1, expressionPos, expressionEndPos;

  function parseModel(val) {
    // Fix https://github.com/vuejs/vue/pull/7730
    // allow v-model="obj.val " (trailing whitespace)
    val = val.trim();
    len = val.length;

    if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
      index$1 = val.lastIndexOf('.');

      if (index$1 > -1) {
        return {
          exp: val.slice(0, index$1),
          key: '"' + val.slice(index$1 + 1) + '"'
        };
      } else {
        return {
          exp: val,
          key: null
        };
      }
    }

    str = val;
    index$1 = expressionPos = expressionEndPos = 0;

    while (!eof()) {
      chr = next();
      /* istanbul ignore if */

      if (isStringStart(chr)) {
        parseString(chr);
      } else if (chr === 0x5B) {
        parseBracket(chr);
      }
    }

    return {
      exp: val.slice(0, expressionPos),
      key: val.slice(expressionPos + 1, expressionEndPos)
    };
  }

  function next() {
    return str.charCodeAt(++index$1);
  }

  function eof() {
    return index$1 >= len;
  }

  function isStringStart(chr) {
    return chr === 0x22 || chr === 0x27;
  }

  function parseBracket(chr) {
    var inBracket = 1;
    expressionPos = index$1;

    while (!eof()) {
      chr = next();

      if (isStringStart(chr)) {
        parseString(chr);
        continue;
      }

      if (chr === 0x5B) {
        inBracket++;
      }

      if (chr === 0x5D) {
        inBracket--;
      }

      if (inBracket === 0) {
        expressionEndPos = index$1;
        break;
      }
    }
  }

  function parseString(chr) {
    var stringQuote = chr;

    while (!eof()) {
      chr = next();

      if (chr === stringQuote) {
        break;
      }
    }
  }
  /*  */


  var warn$1; // in some cases, the event used has to be determined at runtime
  // so we used some reserved tokens during compile.

  var RANGE_TOKEN = '__r';
  var CHECKBOX_RADIO_TOKEN = '__c';

  function model(el, dir, _warn) {
    warn$1 = _warn;
    var value = dir.value;
    var modifiers = dir.modifiers;
    var tag = el.tag;
    var type = el.attrsMap.type;

    {
      // inputs with type="file" are read only and setting the input's
      // value will throw an error.
      if (tag === 'input' && type === 'file') {
        warn$1("<" + el.tag + " v-model=\"" + value + "\" type=\"file\">:\n" + "File inputs are read only. Use a v-on:change listener instead.", el.rawAttrsMap['v-model']);
      }
    }

    if (el.component) {
      genComponentModel(el, value, modifiers); // component v-model doesn't need extra runtime

      return false;
    } else if (tag === 'select') {
      genSelect(el, value, modifiers);
    } else if (tag === 'input' && type === 'checkbox') {
      genCheckboxModel(el, value, modifiers);
    } else if (tag === 'input' && type === 'radio') {
      genRadioModel(el, value, modifiers);
    } else if (tag === 'input' || tag === 'textarea') {
      genDefaultModel(el, value, modifiers);
    } else if (!config.isReservedTag(tag)) {
      genComponentModel(el, value, modifiers); // component v-model doesn't need extra runtime

      return false;
    } else {
      warn$1("<" + el.tag + " v-model=\"" + value + "\">: " + "v-model is not supported on this element type. " + 'If you are working with contenteditable, it\'s recommended to ' + 'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
    } // ensure runtime directive metadata


    return true;
  }

  function genCheckboxModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
    var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
    addProp(el, 'checked', "Array.isArray(" + value + ")" + "?_i(" + value + "," + valueBinding + ")>-1" + (trueValueBinding === 'true' ? ":(" + value + ")" : ":_q(" + value + "," + trueValueBinding + ")"));
    addHandler(el, 'change', "var $$a=" + value + "," + '$$el=$event.target,' + "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" + 'if(Array.isArray($$a)){' + "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," + '$$i=_i($$a,$$v);' + "if($$el.checked){$$i<0&&(" + genAssignmentCode(value, '$$a.concat([$$v])') + ")}" + "else{$$i>-1&&(" + genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))') + ")}" + "}else{" + genAssignmentCode(value, '$$c') + "}", null, true);
  }

  function genRadioModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    valueBinding = number ? "_n(" + valueBinding + ")" : valueBinding;
    addProp(el, 'checked', "_q(" + value + "," + valueBinding + ")");
    addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
  }

  function genSelect(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var selectedVal = "Array.prototype.filter" + ".call($event.target.options,function(o){return o.selected})" + ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" + "return " + (number ? '_n(val)' : 'val') + "})";
    var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
    var code = "var $$selectedVal = " + selectedVal + ";";
    code = code + " " + genAssignmentCode(value, assignment);
    addHandler(el, 'change', code, null, true);
  }

  function genDefaultModel(el, value, modifiers) {
    var type = el.attrsMap.type; // warn if v-bind:value conflicts with v-model
    // except for inputs with v-bind:type

    {
      var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
      var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];

      if (value$1 && !typeBinding) {
        var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
        warn$1(binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " + 'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
      }
    }

    var ref = modifiers || {};
    var lazy = ref.lazy;
    var number = ref.number;
    var trim = ref.trim;
    var needCompositionGuard = !lazy && type !== 'range';
    var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';
    var valueExpression = '$event.target.value';

    if (trim) {
      valueExpression = "$event.target.value.trim()";
    }

    if (number) {
      valueExpression = "_n(" + valueExpression + ")";
    }

    var code = genAssignmentCode(value, valueExpression);

    if (needCompositionGuard) {
      code = "if($event.target.composing)return;" + code;
    }

    addProp(el, 'value', "(" + value + ")");
    addHandler(el, event, code, null, true);

    if (trim || number) {
      addHandler(el, 'blur', '$forceUpdate()');
    }
  }
  /*  */
  // normalize v-model event tokens that can only be determined at runtime.
  // it's important to place the event as the first in the array because
  // the whole point is ensuring the v-model callback gets called before
  // user-attached handlers.


  function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
      // IE input[type=range] only supports `change` event
      var event = isIE ? 'change' : 'input';
      on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
      delete on[RANGE_TOKEN];
    } // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4

    /* istanbul ignore if */


    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
      on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
      delete on[CHECKBOX_RADIO_TOKEN];
    }
  }

  var target$1;

  function createOnceHandler$1(event, handler, capture) {
    var _target = target$1; // save current target element in closure

    return function onceHandler() {
      var res = handler.apply(null, arguments);

      if (res !== null) {
        remove$2(event, onceHandler, capture, _target);
      }
    };
  } // #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
  // implementation and does not fire microtasks in between event propagation, so
  // safe to exclude.


  var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

  function add$1(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
      var attachedTimestamp = currentFlushTimestamp;
      var original = handler;

      handler = original._wrapper = function (e) {
        if ( // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget || // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp || // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 || // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document) {
          return original.apply(this, arguments);
        }
      };
    }

    target$1.addEventListener(name, handler, supportsPassive ? {
      capture: capture,
      passive: passive
    } : capture);
  }

  function remove$2(name, handler, capture, _target) {
    (_target || target$1).removeEventListener(name, handler._wrapper || handler, capture);
  }

  function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
      return;
    }

    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    target$1 = vnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
    target$1 = undefined;
  }

  var events = {
    create: updateDOMListeners,
    update: updateDOMListeners
  };
  /*  */

  var svgContainer;

  function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
      return;
    }

    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {}; // clone observed objects, as the user probably wants to mutate it

    if (isDef(props.__ob__)) {
      props = vnode.data.domProps = extend({}, props);
    }

    for (key in oldProps) {
      if (!(key in props)) {
        elm[key] = '';
      }
    }

    for (key in props) {
      cur = props[key]; // ignore children if the node has textContent or innerHTML,
      // as these will throw away existing DOM nodes and cause removal errors
      // on subsequent patches (#3360)

      if (key === 'textContent' || key === 'innerHTML') {
        if (vnode.children) {
          vnode.children.length = 0;
        }

        if (cur === oldProps[key]) {
          continue;
        } // #6601 work around Chrome version <= 55 bug where single textNode
        // replaced by innerHTML/textContent retains its parentNode property


        if (elm.childNodes.length === 1) {
          elm.removeChild(elm.childNodes[0]);
        }
      }

      if (key === 'value' && elm.tagName !== 'PROGRESS') {
        // store value as _value as well since
        // non-string values will be stringified
        elm._value = cur; // avoid resetting cursor position when value is the same

        var strCur = isUndef(cur) ? '' : String(cur);

        if (shouldUpdateValue(elm, strCur)) {
          elm.value = strCur;
        }
      } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
        // IE doesn't support innerHTML for SVG elements
        svgContainer = svgContainer || document.createElement('div');
        svgContainer.innerHTML = "<svg>" + cur + "</svg>";
        var svg = svgContainer.firstChild;

        while (elm.firstChild) {
          elm.removeChild(elm.firstChild);
        }

        while (svg.firstChild) {
          elm.appendChild(svg.firstChild);
        }
      } else if ( // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]) {
        // some property updates can throw
        // e.g. `value` on <progress> w/ non-finite value
        try {
          elm[key] = cur;
        } catch (e) {}
      }
    }
  } // check platforms/web/util/attrs.js acceptValue


  function shouldUpdateValue(elm, checkVal) {
    return !elm.composing && (elm.tagName === 'OPTION' || isNotInFocusAndDirty(elm, checkVal) || isDirtyWithModifiers(elm, checkVal));
  }

  function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true; // #6157
    // work around IE bug when accessing document.activeElement in an iframe

    try {
      notInFocus = document.activeElement !== elm;
    } catch (e) {}

    return notInFocus && elm.value !== checkVal;
  }

  function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime

    if (isDef(modifiers)) {
      if (modifiers.number) {
        return toNumber(value) !== toNumber(newVal);
      }

      if (modifiers.trim) {
        return value.trim() !== newVal.trim();
      }
    }

    return value !== newVal;
  }

  var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
  };
  /*  */

  var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
      if (item) {
        var tmp = item.split(propertyDelimiter);
        tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
      }
    });
    return res;
  }); // merge static and dynamic style data on the same vnode

  function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style); // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it

    return data.staticStyle ? extend(data.staticStyle, style) : style;
  } // normalize possible array / string values into Object


  function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
      return toObject(bindingStyle);
    }

    if (typeof bindingStyle === 'string') {
      return parseStyleText(bindingStyle);
    }

    return bindingStyle;
  }
  /**
   * parent component style should be after child's
   * so that parent component's style could override it
   */


  function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;

    if (checkChild) {
      var childNode = vnode;

      while (childNode.componentInstance) {
        childNode = childNode.componentInstance._vnode;

        if (childNode && childNode.data && (styleData = normalizeStyleData(childNode.data))) {
          extend(res, styleData);
        }
      }
    }

    if (styleData = normalizeStyleData(vnode.data)) {
      extend(res, styleData);
    }

    var parentNode = vnode;

    while (parentNode = parentNode.parent) {
      if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
        extend(res, styleData);
      }
    }

    return res;
  }
  /*  */


  var cssVarRE = /^--/;
  var importantRE = /\s*!important$/;

  var setProp = function setProp(el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
      el.style.setProperty(name, val);
    } else if (importantRE.test(val)) {
      el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    } else {
      var normalizedName = normalize(name);

      if (Array.isArray(val)) {
        // Support values array created by autoprefixer, e.g.
        // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
        // Set them one by one, and the browser will only set those it can recognize
        for (var i = 0, len = val.length; i < len; i++) {
          el.style[normalizedName] = val[i];
        }
      } else {
        el.style[normalizedName] = val;
      }
    }
  };

  var vendorNames = ['Webkit', 'Moz', 'ms'];
  var emptyStyle;
  var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);

    if (prop !== 'filter' && prop in emptyStyle) {
      return prop;
    }

    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);

    for (var i = 0; i < vendorNames.length; i++) {
      var name = vendorNames[i] + capName;

      if (name in emptyStyle) {
        return name;
      }
    }
  });

  function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;

    if (isUndef(data.staticStyle) && isUndef(data.style) && isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
      return;
    }

    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {}; // if static style exists, stylebinding already merged into it when doing normalizeStyleData

    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {}; // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.

    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);

    for (name in oldStyle) {
      if (isUndef(newStyle[name])) {
        setProp(el, name, '');
      }
    }

    for (name in newStyle) {
      cur = newStyle[name];

      if (cur !== oldStyle[name]) {
        // ie9 setting to null has no effect, must use empty string
        setProp(el, name, cur == null ? '' : cur);
      }
    }
  }

  var style = {
    create: updateStyle,
    update: updateStyle
  };
  /*  */

  var whitespaceRE = /\s+/;
  /**
   * Add class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */

  function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
      return;
    }
    /* istanbul ignore else */


    if (el.classList) {
      if (cls.indexOf(' ') > -1) {
        cls.split(whitespaceRE).forEach(function (c) {
          return el.classList.add(c);
        });
      } else {
        el.classList.add(cls);
      }
    } else {
      var cur = " " + (el.getAttribute('class') || '') + " ";

      if (cur.indexOf(' ' + cls + ' ') < 0) {
        el.setAttribute('class', (cur + cls).trim());
      }
    }
  }
  /**
   * Remove class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */


  function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
      return;
    }
    /* istanbul ignore else */


    if (el.classList) {
      if (cls.indexOf(' ') > -1) {
        cls.split(whitespaceRE).forEach(function (c) {
          return el.classList.remove(c);
        });
      } else {
        el.classList.remove(cls);
      }

      if (!el.classList.length) {
        el.removeAttribute('class');
      }
    } else {
      var cur = " " + (el.getAttribute('class') || '') + " ";
      var tar = ' ' + cls + ' ';

      while (cur.indexOf(tar) >= 0) {
        cur = cur.replace(tar, ' ');
      }

      cur = cur.trim();

      if (cur) {
        el.setAttribute('class', cur);
      } else {
        el.removeAttribute('class');
      }
    }
  }
  /*  */


  function resolveTransition(def$$1) {
    if (!def$$1) {
      return;
    }
    /* istanbul ignore else */


    if (_typeof(def$$1) === 'object') {
      var res = {};

      if (def$$1.css !== false) {
        extend(res, autoCssTransition(def$$1.name || 'v'));
      }

      extend(res, def$$1);
      return res;
    } else if (typeof def$$1 === 'string') {
      return autoCssTransition(def$$1);
    }
  }

  var autoCssTransition = cached(function (name) {
    return {
      enterClass: name + "-enter",
      enterToClass: name + "-enter-to",
      enterActiveClass: name + "-enter-active",
      leaveClass: name + "-leave",
      leaveToClass: name + "-leave-to",
      leaveActiveClass: name + "-leave-active"
    };
  });
  var hasTransition = inBrowser && !isIE9;
  var TRANSITION = 'transition';
  var ANIMATION = 'animation'; // Transition property/event sniffing

  var transitionProp = 'transition';
  var transitionEndEvent = 'transitionend';
  var animationProp = 'animation';
  var animationEndEvent = 'animationend';

  if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
      transitionProp = 'WebkitTransition';
      transitionEndEvent = 'webkitTransitionEnd';
    }

    if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
      animationProp = 'WebkitAnimation';
      animationEndEvent = 'webkitAnimationEnd';
    }
  } // binding to window is necessary to make hot reload work in IE in strict mode


  var raf = inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout :
  /* istanbul ignore next */
  function (fn) {
    return fn();
  };

  function nextFrame(fn) {
    raf(function () {
      raf(fn);
    });
  }

  function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);

    if (transitionClasses.indexOf(cls) < 0) {
      transitionClasses.push(cls);
      addClass(el, cls);
    }
  }

  function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
      remove(el._transitionClasses, cls);
    }

    removeClass(el, cls);
  }

  function whenTransitionEnds(el, expectedType, cb) {
    var ref = getTransitionInfo(el, expectedType);
    var type = ref.type;
    var timeout = ref.timeout;
    var propCount = ref.propCount;

    if (!type) {
      return cb();
    }

    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;

    var end = function end() {
      el.removeEventListener(event, onEnd);
      cb();
    };

    var onEnd = function onEnd(e) {
      if (e.target === el) {
        if (++ended >= propCount) {
          end();
        }
      }
    };

    setTimeout(function () {
      if (ended < propCount) {
        end();
      }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
  }

  var transformRE = /\b(transform|all)(,|$)/;

  function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el); // JSDOM may return undefined for transition properties

    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */

    if (expectedType === TRANSITION) {
      if (transitionTimeout > 0) {
        type = TRANSITION;
        timeout = transitionTimeout;
        propCount = transitionDurations.length;
      }
    } else if (expectedType === ANIMATION) {
      if (animationTimeout > 0) {
        type = ANIMATION;
        timeout = animationTimeout;
        propCount = animationDurations.length;
      }
    } else {
      timeout = Math.max(transitionTimeout, animationTimeout);
      type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
      propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }

    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
      type: type,
      timeout: timeout,
      propCount: propCount,
      hasTransform: hasTransform
    };
  }

  function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
      delays = delays.concat(delays);
    }

    return Math.max.apply(null, durations.map(function (d, i) {
      return toMs(d) + toMs(delays[i]);
    }));
  } // Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
  // in a locale-dependent way, using a comma instead of a dot.
  // If comma is not replaced with a dot, the input will be rounded down (i.e. acting
  // as a floor function) causing unexpected behaviors


  function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
  }
  /*  */


  function enter(vnode, toggleDisplay) {
    var el = vnode.elm; // call leave callback now

    if (isDef(el._leaveCb)) {
      el._leaveCb.cancelled = true;

      el._leaveCb();
    }

    var data = resolveTransition(vnode.data.transition);

    if (isUndef(data)) {
      return;
    }
    /* istanbul ignore if */


    if (isDef(el._enterCb) || el.nodeType !== 1) {
      return;
    }

    var css = data.css;
    var type = data.type;
    var enterClass = data.enterClass;
    var enterToClass = data.enterToClass;
    var enterActiveClass = data.enterActiveClass;
    var appearClass = data.appearClass;
    var appearToClass = data.appearToClass;
    var appearActiveClass = data.appearActiveClass;
    var beforeEnter = data.beforeEnter;
    var enter = data.enter;
    var afterEnter = data.afterEnter;
    var enterCancelled = data.enterCancelled;
    var beforeAppear = data.beforeAppear;
    var appear = data.appear;
    var afterAppear = data.afterAppear;
    var appearCancelled = data.appearCancelled;
    var duration = data.duration; // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.

    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;

    while (transitionNode && transitionNode.parent) {
      context = transitionNode.context;
      transitionNode = transitionNode.parent;
    }

    var isAppear = !context._isMounted || !vnode.isRootInsert;

    if (isAppear && !appear && appear !== '') {
      return;
    }

    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? typeof appear === 'function' ? appear : enter : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);

    if ( explicitEnterDuration != null) {
      checkDuration(explicitEnterDuration, 'enter', vnode);
    }

    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = el._enterCb = once(function () {
      if (expectsCSS) {
        removeTransitionClass(el, toClass);
        removeTransitionClass(el, activeClass);
      }

      if (cb.cancelled) {
        if (expectsCSS) {
          removeTransitionClass(el, startClass);
        }

        enterCancelledHook && enterCancelledHook(el);
      } else {
        afterEnterHook && afterEnterHook(el);
      }

      el._enterCb = null;
    });

    if (!vnode.data.show) {
      // remove pending leave element on enter by injecting an insert hook
      mergeVNodeHook(vnode, 'insert', function () {
        var parent = el.parentNode;
        var pendingNode = parent && parent._pending && parent._pending[vnode.key];

        if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) {
          pendingNode.elm._leaveCb();
        }

        enterHook && enterHook(el, cb);
      });
    } // start enter transition


    beforeEnterHook && beforeEnterHook(el);

    if (expectsCSS) {
      addTransitionClass(el, startClass);
      addTransitionClass(el, activeClass);
      nextFrame(function () {
        removeTransitionClass(el, startClass);

        if (!cb.cancelled) {
          addTransitionClass(el, toClass);

          if (!userWantsControl) {
            if (isValidDuration(explicitEnterDuration)) {
              setTimeout(cb, explicitEnterDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }

    if (vnode.data.show) {
      toggleDisplay && toggleDisplay();
      enterHook && enterHook(el, cb);
    }

    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }

  function leave(vnode, rm) {
    var el = vnode.elm; // call enter callback now

    if (isDef(el._enterCb)) {
      el._enterCb.cancelled = true;

      el._enterCb();
    }

    var data = resolveTransition(vnode.data.transition);

    if (isUndef(data) || el.nodeType !== 1) {
      return rm();
    }
    /* istanbul ignore if */


    if (isDef(el._leaveCb)) {
      return;
    }

    var css = data.css;
    var type = data.type;
    var leaveClass = data.leaveClass;
    var leaveToClass = data.leaveToClass;
    var leaveActiveClass = data.leaveActiveClass;
    var beforeLeave = data.beforeLeave;
    var leave = data.leave;
    var afterLeave = data.afterLeave;
    var leaveCancelled = data.leaveCancelled;
    var delayLeave = data.delayLeave;
    var duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);

    if ( isDef(explicitLeaveDuration)) {
      checkDuration(explicitLeaveDuration, 'leave', vnode);
    }

    var cb = el._leaveCb = once(function () {
      if (el.parentNode && el.parentNode._pending) {
        el.parentNode._pending[vnode.key] = null;
      }

      if (expectsCSS) {
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
      }

      if (cb.cancelled) {
        if (expectsCSS) {
          removeTransitionClass(el, leaveClass);
        }

        leaveCancelled && leaveCancelled(el);
      } else {
        rm();
        afterLeave && afterLeave(el);
      }

      el._leaveCb = null;
    });

    if (delayLeave) {
      delayLeave(performLeave);
    } else {
      performLeave();
    }

    function performLeave() {
      // the delayed leave may have already been cancelled
      if (cb.cancelled) {
        return;
      } // record leaving element


      if (!vnode.data.show && el.parentNode) {
        (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
      }

      beforeLeave && beforeLeave(el);

      if (expectsCSS) {
        addTransitionClass(el, leaveClass);
        addTransitionClass(el, leaveActiveClass);
        nextFrame(function () {
          removeTransitionClass(el, leaveClass);

          if (!cb.cancelled) {
            addTransitionClass(el, leaveToClass);

            if (!userWantsControl) {
              if (isValidDuration(explicitLeaveDuration)) {
                setTimeout(cb, explicitLeaveDuration);
              } else {
                whenTransitionEnds(el, type, cb);
              }
            }
          }
        });
      }

      leave && leave(el, cb);

      if (!expectsCSS && !userWantsControl) {
        cb();
      }
    }
  } // only used in dev mode


  function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
      warn("<transition> explicit " + name + " duration is not a valid number - " + "got " + JSON.stringify(val) + ".", vnode.context);
    } else if (isNaN(val)) {
      warn("<transition> explicit " + name + " duration is NaN - " + 'the duration expression might be incorrect.', vnode.context);
    }
  }

  function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
  }
  /**
   * Normalize a transition hook's argument length. The hook may be:
   * - a merged hook (invoker) with the original in .fns
   * - a wrapped component method (check ._length)
   * - a plain function (.length)
   */


  function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
      return false;
    }

    var invokerFns = fn.fns;

    if (isDef(invokerFns)) {
      // invoker
      return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    } else {
      return (fn._length || fn.length) > 1;
    }
  }

  function _enter(_, vnode) {
    if (vnode.data.show !== true) {
      enter(vnode);
    }
  }

  var transition = inBrowser ? {
    create: _enter,
    activate: _enter,
    remove: function remove$$1(vnode, rm) {
      /* istanbul ignore else */
      if (vnode.data.show !== true) {
        leave(vnode, rm);
      } else {
        rm();
      }
    }
  } : {};
  var platformModules = [attrs, klass, events, domProps, style, transition];
  /*  */
  // the directive module should be applied last, after all
  // built-in modules have been applied.

  var modules = platformModules.concat(baseModules);
  var patch = createPatchFunction({
    nodeOps: nodeOps,
    modules: modules
  });
  /**
   * Not type checking this file because flow doesn't like attaching
   * properties to Elements.
   */

  /* istanbul ignore if */

  if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
      var el = document.activeElement;

      if (el && el.vmodel) {
        trigger(el, 'input');
      }
    });
  }

  var directive = {
    inserted: function inserted(el, binding, vnode, oldVnode) {
      if (vnode.tag === 'select') {
        // #6903
        if (oldVnode.elm && !oldVnode.elm._vOptions) {
          mergeVNodeHook(vnode, 'postpatch', function () {
            directive.componentUpdated(el, binding, vnode);
          });
        } else {
          setSelected(el, binding, vnode.context);
        }

        el._vOptions = [].map.call(el.options, getValue);
      } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
        el._vModifiers = binding.modifiers;

        if (!binding.modifiers.lazy) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd); // Safari < 10.2 & UIWebView doesn't fire compositionend when
          // switching focus before confirming composition choice
          // this also fixes the issue where some browsers e.g. iOS Chrome
          // fires "change" instead of "input" on autocomplete.

          el.addEventListener('change', onCompositionEnd);
          /* istanbul ignore if */

          if (isIE9) {
            el.vmodel = true;
          }
        }
      }
    },
    componentUpdated: function componentUpdated(el, binding, vnode) {
      if (vnode.tag === 'select') {
        setSelected(el, binding, vnode.context); // in case the options rendered by v-for have changed,
        // it's possible that the value is out-of-sync with the rendered options.
        // detect such cases and filter out values that no longer has a matching
        // option in the DOM.

        var prevOptions = el._vOptions;
        var curOptions = el._vOptions = [].map.call(el.options, getValue);

        if (curOptions.some(function (o, i) {
          return !looseEqual(o, prevOptions[i]);
        })) {
          // trigger change event if
          // no matching option found for at least one value
          var needReset = el.multiple ? binding.value.some(function (v) {
            return hasNoMatchingOption(v, curOptions);
          }) : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);

          if (needReset) {
            trigger(el, 'change');
          }
        }
      }
    }
  };

  function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */

    if (isIE || isEdge) {
      setTimeout(function () {
        actuallySetSelected(el, binding, vm);
      }, 0);
    }
  }

  function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;

    if (isMultiple && !Array.isArray(value)) {
       warn("<select multiple v-model=\"" + binding.expression + "\"> " + "expects an Array value for its binding, but got " + Object.prototype.toString.call(value).slice(8, -1), vm);
      return;
    }

    var selected, option;

    for (var i = 0, l = el.options.length; i < l; i++) {
      option = el.options[i];

      if (isMultiple) {
        selected = looseIndexOf(value, getValue(option)) > -1;

        if (option.selected !== selected) {
          option.selected = selected;
        }
      } else {
        if (looseEqual(getValue(option), value)) {
          if (el.selectedIndex !== i) {
            el.selectedIndex = i;
          }

          return;
        }
      }
    }

    if (!isMultiple) {
      el.selectedIndex = -1;
    }
  }

  function hasNoMatchingOption(value, options) {
    return options.every(function (o) {
      return !looseEqual(o, value);
    });
  }

  function getValue(option) {
    return '_value' in option ? option._value : option.value;
  }

  function onCompositionStart(e) {
    e.target.composing = true;
  }

  function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing) {
      return;
    }

    e.target.composing = false;
    trigger(e.target, 'input');
  }

  function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
  }
  /*  */
  // recursively search for possible transition defined inside the component root


  function locateNode(vnode) {
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? locateNode(vnode.componentInstance._vnode) : vnode;
  }

  var show = {
    bind: function bind(el, ref, vnode) {
      var value = ref.value;
      vnode = locateNode(vnode);
      var transition$$1 = vnode.data && vnode.data.transition;
      var originalDisplay = el.__vOriginalDisplay = el.style.display === 'none' ? '' : el.style.display;

      if (value && transition$$1) {
        vnode.data.show = true;
        enter(vnode, function () {
          el.style.display = originalDisplay;
        });
      } else {
        el.style.display = value ? originalDisplay : 'none';
      }
    },
    update: function update(el, ref, vnode) {
      var value = ref.value;
      var oldValue = ref.oldValue;
      /* istanbul ignore if */

      if (!value === !oldValue) {
        return;
      }

      vnode = locateNode(vnode);
      var transition$$1 = vnode.data && vnode.data.transition;

      if (transition$$1) {
        vnode.data.show = true;

        if (value) {
          enter(vnode, function () {
            el.style.display = el.__vOriginalDisplay;
          });
        } else {
          leave(vnode, function () {
            el.style.display = 'none';
          });
        }
      } else {
        el.style.display = value ? el.__vOriginalDisplay : 'none';
      }
    },
    unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
      if (!isDestroy) {
        el.style.display = el.__vOriginalDisplay;
      }
    }
  };
  var platformDirectives = {
    model: directive,
    show: show
  };
  /*  */

  var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
  }; // in case the child is also an abstract component, e.g. <keep-alive>
  // we want to recursively retrieve the real component to be rendered

  function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;

    if (compOptions && compOptions.Ctor.options.abstract) {
      return getRealChild(getFirstComponentChild(compOptions.children));
    } else {
      return vnode;
    }
  }

  function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options; // props

    for (var key in options.propsData) {
      data[key] = comp[key];
    } // events.
    // extract listeners and pass them directly to the transition methods


    var listeners = options._parentListeners;

    for (var key$1 in listeners) {
      data[camelize(key$1)] = listeners[key$1];
    }

    return data;
  }

  function placeholder(h, rawChild) {
    if (/\d-keep-alive$/.test(rawChild.tag)) {
      return h('keep-alive', {
        props: rawChild.componentOptions.propsData
      });
    }
  }

  function hasParentTransition(vnode) {
    while (vnode = vnode.parent) {
      if (vnode.data.transition) {
        return true;
      }
    }
  }

  function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
  }

  var isNotTextNode = function isNotTextNode(c) {
    return c.tag || isAsyncPlaceholder(c);
  };

  var isVShowDirective = function isVShowDirective(d) {
    return d.name === 'show';
  };

  var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function render(h) {
      var this$1 = this;
      var children = this.$slots.default;

      if (!children) {
        return;
      } // filter out text nodes (possible whitespaces)


      children = children.filter(isNotTextNode);
      /* istanbul ignore if */

      if (!children.length) {
        return;
      } // warn multiple elements


      if ( children.length > 1) {
        warn('<transition> can only be used on a single element. Use ' + '<transition-group> for lists.', this.$parent);
      }

      var mode = this.mode; // warn invalid mode

      if ( mode && mode !== 'in-out' && mode !== 'out-in') {
        warn('invalid <transition> mode: ' + mode, this.$parent);
      }

      var rawChild = children[0]; // if this is a component root node and the component's
      // parent container node also has transition, skip.

      if (hasParentTransition(this.$vnode)) {
        return rawChild;
      } // apply transition data to child
      // use getRealChild() to ignore abstract components e.g. keep-alive


      var child = getRealChild(rawChild);
      /* istanbul ignore if */

      if (!child) {
        return rawChild;
      }

      if (this._leaving) {
        return placeholder(h, rawChild);
      } // ensure a key that is unique to the vnode type and to this transition
      // component instance. This key will be used to remove pending leaving nodes
      // during entering.


      var id = "__transition-" + this._uid + "-";
      child.key = child.key == null ? child.isComment ? id + 'comment' : id + child.tag : isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;
      var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
      var oldRawChild = this._vnode;
      var oldChild = getRealChild(oldRawChild); // mark v-show
      // so that the transition module can hand over the control to the directive

      if (child.data.directives && child.data.directives.some(isVShowDirective)) {
        child.data.show = true;
      }

      if (oldChild && oldChild.data && !isSameChild(child, oldChild) && !isAsyncPlaceholder(oldChild) && // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
        // replace old child transition data with fresh one
        // important for dynamic transitions!
        var oldData = oldChild.data.transition = extend({}, data); // handle transition mode

        if (mode === 'out-in') {
          // return placeholder node and queue update when leave finishes
          this._leaving = true;
          mergeVNodeHook(oldData, 'afterLeave', function () {
            this$1._leaving = false;
            this$1.$forceUpdate();
          });
          return placeholder(h, rawChild);
        } else if (mode === 'in-out') {
          if (isAsyncPlaceholder(child)) {
            return oldRawChild;
          }

          var delayedLeave;

          var performLeave = function performLeave() {
            delayedLeave();
          };

          mergeVNodeHook(data, 'afterEnter', performLeave);
          mergeVNodeHook(data, 'enterCancelled', performLeave);
          mergeVNodeHook(oldData, 'delayLeave', function (leave) {
            delayedLeave = leave;
          });
        }
      }

      return rawChild;
    }
  };
  /*  */

  var props = extend({
    tag: String,
    moveClass: String
  }, transitionProps);
  delete props.mode;
  var TransitionGroup = {
    props: props,
    beforeMount: function beforeMount() {
      var this$1 = this;
      var update = this._update;

      this._update = function (vnode, hydrating) {
        var restoreActiveInstance = setActiveInstance(this$1); // force removing pass

        this$1.__patch__(this$1._vnode, this$1.kept, false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
        );

        this$1._vnode = this$1.kept;
        restoreActiveInstance();
        update.call(this$1, vnode, hydrating);
      };
    },
    render: function render(h) {
      var tag = this.tag || this.$vnode.data.tag || 'span';
      var map = Object.create(null);
      var prevChildren = this.prevChildren = this.children;
      var rawChildren = this.$slots.default || [];
      var children = this.children = [];
      var transitionData = extractTransitionData(this);

      for (var i = 0; i < rawChildren.length; i++) {
        var c = rawChildren[i];

        if (c.tag) {
          if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
            children.push(c);
            map[c.key] = c;
            (c.data || (c.data = {})).transition = transitionData;
          } else {
            var opts = c.componentOptions;
            var name = opts ? opts.Ctor.options.name || opts.tag || '' : c.tag;
            warn("<transition-group> children must be keyed: <" + name + ">");
          }
        }
      }

      if (prevChildren) {
        var kept = [];
        var removed = [];

        for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
          var c$1 = prevChildren[i$1];
          c$1.data.transition = transitionData;
          c$1.data.pos = c$1.elm.getBoundingClientRect();

          if (map[c$1.key]) {
            kept.push(c$1);
          } else {
            removed.push(c$1);
          }
        }

        this.kept = h(tag, null, kept);
        this.removed = removed;
      }

      return h(tag, null, children);
    },
    updated: function updated() {
      var children = this.prevChildren;
      var moveClass = this.moveClass || (this.name || 'v') + '-move';

      if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
        return;
      } // we divide the work into three loops to avoid mixing DOM reads and writes
      // in each iteration - which helps prevent layout thrashing.


      children.forEach(callPendingCbs);
      children.forEach(recordPosition);
      children.forEach(applyTranslation); // force reflow to put everything in position
      // assign to this to avoid being removed in tree-shaking
      // $flow-disable-line

      this._reflow = document.body.offsetHeight;
      children.forEach(function (c) {
        if (c.data.moved) {
          var el = c.elm;
          var s = el.style;
          addTransitionClass(el, moveClass);
          s.transform = s.WebkitTransform = s.transitionDuration = '';
          el.addEventListener(transitionEndEvent, el._moveCb = function cb(e) {
            if (e && e.target !== el) {
              return;
            }

            if (!e || /transform$/.test(e.propertyName)) {
              el.removeEventListener(transitionEndEvent, cb);
              el._moveCb = null;
              removeTransitionClass(el, moveClass);
            }
          });
        }
      });
    },
    methods: {
      hasMove: function hasMove(el, moveClass) {
        /* istanbul ignore if */
        if (!hasTransition) {
          return false;
        }
        /* istanbul ignore if */


        if (this._hasMove) {
          return this._hasMove;
        } // Detect whether an element with the move class applied has
        // CSS transitions. Since the element may be inside an entering
        // transition at this very moment, we make a clone of it and remove
        // all other transition classes applied to ensure only the move class
        // is applied.


        var clone = el.cloneNode();

        if (el._transitionClasses) {
          el._transitionClasses.forEach(function (cls) {
            removeClass(clone, cls);
          });
        }

        addClass(clone, moveClass);
        clone.style.display = 'none';
        this.$el.appendChild(clone);
        var info = getTransitionInfo(clone);
        this.$el.removeChild(clone);
        return this._hasMove = info.hasTransform;
      }
    }
  };

  function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
      c.elm._moveCb();
    }
    /* istanbul ignore if */


    if (c.elm._enterCb) {
      c.elm._enterCb();
    }
  }

  function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
  }

  function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;

    if (dx || dy) {
      c.data.moved = true;
      var s = c.elm.style;
      s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
      s.transitionDuration = '0s';
    }
  }

  var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
  };
  /*  */
  // install platform specific utils

  Vue.config.mustUseProp = mustUseProp;
  Vue.config.isReservedTag = isReservedTag;
  Vue.config.isReservedAttr = isReservedAttr;
  Vue.config.getTagNamespace = getTagNamespace;
  Vue.config.isUnknownElement = isUnknownElement; // install platform runtime directives & components

  extend(Vue.options.directives, platformDirectives);
  extend(Vue.options.components, platformComponents); // install platform patch function

  Vue.prototype.__patch__ = inBrowser ? patch : noop; // public mount method

  Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
  }; // devtools global hook

  /* istanbul ignore next */


  if (inBrowser) {
    setTimeout(function () {
      if (config.devtools) {
        if (devtools) {
          devtools.emit('init', Vue);
        } else {
          console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
        }
      }

      if ( config.productionTip !== false && typeof console !== 'undefined') {
        console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" + "Make sure to turn on production mode when deploying for production.\n" + "See more tips at https://vuejs.org/guide/deployment.html");
      }
    }, 0);
  }
  /*  */


  var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
  var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
  var buildRegex = cached(function (delimiters) {
    var open = delimiters[0].replace(regexEscapeRE, '\\$&');
    var close = delimiters[1].replace(regexEscapeRE, '\\$&');
    return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
  });

  function parseText(text, delimiters) {
    var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;

    if (!tagRE.test(text)) {
      return;
    }

    var tokens = [];
    var rawTokens = [];
    var lastIndex = tagRE.lastIndex = 0;
    var match, index, tokenValue;

    while (match = tagRE.exec(text)) {
      index = match.index; // push text token

      if (index > lastIndex) {
        rawTokens.push(tokenValue = text.slice(lastIndex, index));
        tokens.push(JSON.stringify(tokenValue));
      } // tag token


      var exp = parseFilters(match[1].trim());
      tokens.push("_s(" + exp + ")");
      rawTokens.push({
        '@binding': exp
      });
      lastIndex = index + match[0].length;
    }

    if (lastIndex < text.length) {
      rawTokens.push(tokenValue = text.slice(lastIndex));
      tokens.push(JSON.stringify(tokenValue));
    }

    return {
      expression: tokens.join('+'),
      tokens: rawTokens
    };
  }
  /*  */


  function transformNode(el, options) {
    var warn = options.warn || baseWarn;
    var staticClass = getAndRemoveAttr(el, 'class');

    if ( staticClass) {
      var res = parseText(staticClass, options.delimiters);

      if (res) {
        warn("class=\"" + staticClass + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
      }
    }

    if (staticClass) {
      el.staticClass = JSON.stringify(staticClass);
    }

    var classBinding = getBindingAttr(el, 'class', false
    /* getStatic */
    );

    if (classBinding) {
      el.classBinding = classBinding;
    }
  }

  function genData(el) {
    var data = '';

    if (el.staticClass) {
      data += "staticClass:" + el.staticClass + ",";
    }

    if (el.classBinding) {
      data += "class:" + el.classBinding + ",";
    }

    return data;
  }

  var klass$1 = {
    staticKeys: ['staticClass'],
    transformNode: transformNode,
    genData: genData
  };
  /*  */

  function transformNode$1(el, options) {
    var warn = options.warn || baseWarn;
    var staticStyle = getAndRemoveAttr(el, 'style');

    if (staticStyle) {
      /* istanbul ignore if */
      {
        var res = parseText(staticStyle, options.delimiters);

        if (res) {
          warn("style=\"" + staticStyle + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
        }
      }

      el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
    }

    var styleBinding = getBindingAttr(el, 'style', false
    /* getStatic */
    );

    if (styleBinding) {
      el.styleBinding = styleBinding;
    }
  }

  function genData$1(el) {
    var data = '';

    if (el.staticStyle) {
      data += "staticStyle:" + el.staticStyle + ",";
    }

    if (el.styleBinding) {
      data += "style:(" + el.styleBinding + "),";
    }

    return data;
  }

  var style$1 = {
    staticKeys: ['staticStyle'],
    transformNode: transformNode$1,
    genData: genData$1
  };
  /*  */

  var decoder;
  var he = {
    decode: function decode(html) {
      decoder = decoder || document.createElement('div');
      decoder.innerHTML = html;
      return decoder.textContent;
    }
  };
  /*  */

  var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' + 'link,meta,param,source,track,wbr'); // Elements that you can, intentionally, leave open
  // (and which close themselves)

  var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'); // HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
  // Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content

  var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' + 'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' + 'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' + 'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' + 'title,tr,track');
  /**
   * Not type-checking this file because it's mostly vendor code.
   */
  // Regular Expressions for parsing tags and attributes

  var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
  var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
  var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + unicodeRegExp.source + "]*";
  var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
  var startTagOpen = new RegExp("^<" + qnameCapture);
  var startTagClose = /^\s*(\/?)>/;
  var endTag = new RegExp("^<\\/" + qnameCapture + "[^>]*>");
  var doctype = /^<!DOCTYPE [^>]+>/i; // #7298: escape - to avoid being passed as HTML comment when inlined in page

  var comment = /^<!\--/;
  var conditionalComment = /^<!\[/; // Special Elements (can contain anything)

  var isPlainTextElement = makeMap('script,style,textarea', true);
  var reCache = {};
  var decodingMap = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&amp;': '&',
    '&#10;': '\n',
    '&#9;': '\t',
    '&#39;': "'"
  };
  var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
  var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g; // #5992

  var isIgnoreNewlineTag = makeMap('pre,textarea', true);

  var shouldIgnoreFirstNewline = function shouldIgnoreFirstNewline(tag, html) {
    return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
  };

  function decodeAttr(value, shouldDecodeNewlines) {
    var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
    return value.replace(re, function (match) {
      return decodingMap[match];
    });
  }

  function parseHTML(html, options) {
    var stack = [];
    var expectHTML = options.expectHTML;
    var isUnaryTag$$1 = options.isUnaryTag || no;
    var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
    var index = 0;
    var last, lastTag;

    while (html) {
      last = html; // Make sure we're not in a plaintext content element like script/style

      if (!lastTag || !isPlainTextElement(lastTag)) {
        var textEnd = html.indexOf('<');

        if (textEnd === 0) {
          // Comment:
          if (comment.test(html)) {
            var commentEnd = html.indexOf('-->');

            if (commentEnd >= 0) {
              if (options.shouldKeepComment) {
                options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
              }

              advance(commentEnd + 3);
              continue;
            }
          } // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment


          if (conditionalComment.test(html)) {
            var conditionalEnd = html.indexOf(']>');

            if (conditionalEnd >= 0) {
              advance(conditionalEnd + 2);
              continue;
            }
          } // Doctype:


          var doctypeMatch = html.match(doctype);

          if (doctypeMatch) {
            advance(doctypeMatch[0].length);
            continue;
          } // End tag:


          var endTagMatch = html.match(endTag);

          if (endTagMatch) {
            var curIndex = index;
            advance(endTagMatch[0].length);
            parseEndTag(endTagMatch[1], curIndex, index);
            continue;
          } // Start tag:


          var startTagMatch = parseStartTag();

          if (startTagMatch) {
            handleStartTag(startTagMatch);

            if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
              advance(1);
            }

            continue;
          }
        }

        var text = void 0,
            rest = void 0,
            next = void 0;

        if (textEnd >= 0) {
          rest = html.slice(textEnd);

          while (!endTag.test(rest) && !startTagOpen.test(rest) && !comment.test(rest) && !conditionalComment.test(rest)) {
            // < in plain text, be forgiving and treat it as text
            next = rest.indexOf('<', 1);

            if (next < 0) {
              break;
            }

            textEnd += next;
            rest = html.slice(textEnd);
          }

          text = html.substring(0, textEnd);
        }

        if (textEnd < 0) {
          text = html;
        }

        if (text) {
          advance(text.length);
        }

        if (options.chars && text) {
          options.chars(text, index - text.length, index);
        }
      } else {
        var endTagLength = 0;
        var stackedTag = lastTag.toLowerCase();
        var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
        var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
          endTagLength = endTag.length;

          if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
            text = text.replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
          }

          if (shouldIgnoreFirstNewline(stackedTag, text)) {
            text = text.slice(1);
          }

          if (options.chars) {
            options.chars(text);
          }

          return '';
        });
        index += html.length - rest$1.length;
        html = rest$1;
        parseEndTag(stackedTag, index - endTagLength, index);
      }

      if (html === last) {
        options.chars && options.chars(html);

        if ( !stack.length && options.warn) {
          options.warn("Mal-formatted tag at end of template: \"" + html + "\"", {
            start: index + html.length
          });
        }

        break;
      }
    } // Clean up any remaining tags


    parseEndTag();

    function advance(n) {
      index += n;
      html = html.substring(n);
    }

    function parseStartTag() {
      var start = html.match(startTagOpen);

      if (start) {
        var match = {
          tagName: start[1],
          attrs: [],
          start: index
        };
        advance(start[0].length);
        var end, attr;

        while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
          attr.start = index;
          advance(attr[0].length);
          attr.end = index;
          match.attrs.push(attr);
        }

        if (end) {
          match.unarySlash = end[1];
          advance(end[0].length);
          match.end = index;
          return match;
        }
      }
    }

    function handleStartTag(match) {
      var tagName = match.tagName;
      var unarySlash = match.unarySlash;

      if (expectHTML) {
        if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
          parseEndTag(lastTag);
        }

        if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
          parseEndTag(tagName);
        }
      }

      var unary = isUnaryTag$$1(tagName) || !!unarySlash;
      var l = match.attrs.length;
      var attrs = new Array(l);

      for (var i = 0; i < l; i++) {
        var args = match.attrs[i];
        var value = args[3] || args[4] || args[5] || '';
        var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href' ? options.shouldDecodeNewlinesForHref : options.shouldDecodeNewlines;
        attrs[i] = {
          name: args[1],
          value: decodeAttr(value, shouldDecodeNewlines)
        };

        if ( options.outputSourceRange) {
          attrs[i].start = args.start + args[0].match(/^\s*/).length;
          attrs[i].end = args.end;
        }
      }

      if (!unary) {
        stack.push({
          tag: tagName,
          lowerCasedTag: tagName.toLowerCase(),
          attrs: attrs,
          start: match.start,
          end: match.end
        });
        lastTag = tagName;
      }

      if (options.start) {
        options.start(tagName, attrs, unary, match.start, match.end);
      }
    }

    function parseEndTag(tagName, start, end) {
      var pos, lowerCasedTagName;

      if (start == null) {
        start = index;
      }

      if (end == null) {
        end = index;
      } // Find the closest opened tag of the same type


      if (tagName) {
        lowerCasedTagName = tagName.toLowerCase();

        for (pos = stack.length - 1; pos >= 0; pos--) {
          if (stack[pos].lowerCasedTag === lowerCasedTagName) {
            break;
          }
        }
      } else {
        // If no tag name is provided, clean shop
        pos = 0;
      }

      if (pos >= 0) {
        // Close all the open elements, up the stack
        for (var i = stack.length - 1; i >= pos; i--) {
          if ( (i > pos || !tagName) && options.warn) {
            options.warn("tag <" + stack[i].tag + "> has no matching end tag.", {
              start: stack[i].start,
              end: stack[i].end
            });
          }

          if (options.end) {
            options.end(stack[i].tag, start, end);
          }
        } // Remove the open elements from the stack


        stack.length = pos;
        lastTag = pos && stack[pos - 1].tag;
      } else if (lowerCasedTagName === 'br') {
        if (options.start) {
          options.start(tagName, [], true, start, end);
        }
      } else if (lowerCasedTagName === 'p') {
        if (options.start) {
          options.start(tagName, [], false, start, end);
        }

        if (options.end) {
          options.end(tagName, start, end);
        }
      }
    }
  }
  /*  */


  var onRE = /^@|^v-on:/;
  var dirRE = /^v-|^@|^:|^#/;
  var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
  var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
  var stripParensRE = /^\(|\)$/g;
  var dynamicArgRE = /^\[.*\]$/;
  var argRE = /:(.*)$/;
  var bindRE = /^:|^\.|^v-bind:/;
  var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
  var slotRE = /^v-slot(:|$)|^#/;
  var lineBreakRE = /[\r\n]/;
  var whitespaceRE$1 = /[ \f\t\r\n]+/g;
  var invalidAttributeRE = /[\s"'<>\/=]/;
  var decodeHTMLCached = cached(he.decode);
  var emptySlotScopeToken = "_empty_"; // configurable state

  var warn$2;
  var delimiters;
  var transforms;
  var preTransforms;
  var postTransforms;
  var platformIsPreTag;
  var platformMustUseProp;
  var platformGetTagNamespace;
  var maybeComponent;

  function createASTElement(tag, attrs, parent) {
    return {
      type: 1,
      tag: tag,
      attrsList: attrs,
      attrsMap: makeAttrsMap(attrs),
      rawAttrsMap: {},
      parent: parent,
      children: []
    };
  }
  /**
   * Convert HTML string to AST.
   */


  function parse(template, options) {
    warn$2 = options.warn || baseWarn;
    platformIsPreTag = options.isPreTag || no;
    platformMustUseProp = options.mustUseProp || no;
    platformGetTagNamespace = options.getTagNamespace || no;
    var isReservedTag = options.isReservedTag || no;

    maybeComponent = function maybeComponent(el) {
      return !!(el.component || el.attrsMap[':is'] || el.attrsMap['v-bind:is'] || !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
    };

    transforms = pluckModuleFunction(options.modules, 'transformNode');
    preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
    postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
    delimiters = options.delimiters;
    var stack = [];
    var preserveWhitespace = options.preserveWhitespace !== false;
    var whitespaceOption = options.whitespace;
    var root;
    var currentParent;
    var inVPre = false;
    var inPre = false;
    var warned = false;

    function warnOnce(msg, range) {
      if (!warned) {
        warned = true;
        warn$2(msg, range);
      }
    }

    function closeElement(element) {
      trimEndingWhitespace(element);

      if (!inVPre && !element.processed) {
        element = processElement(element, options);
      } // tree management


      if (!stack.length && element !== root) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          {
            checkRootConstraints(element);
          }

          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else {
          warnOnce("Component template should contain exactly one root element. " + "If you are using v-if on multiple elements, " + "use v-else-if to chain them instead.", {
            start: element.start
          });
        }
      }

      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else {
          if (element.slotScope) {
            // scoped slot
            // keep it in the children list so that v-else(-if) conditions can
            // find it as the prev node.
            var name = element.slotTarget || '"default"';
            (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
          }

          currentParent.children.push(element);
          element.parent = currentParent;
        }
      } // final children cleanup
      // filter out scoped slots


      element.children = element.children.filter(function (c) {
        return !c.slotScope;
      }); // remove trailing whitespace node again

      trimEndingWhitespace(element); // check pre state

      if (element.pre) {
        inVPre = false;
      }

      if (platformIsPreTag(element.tag)) {
        inPre = false;
      } // apply post-transforms


      for (var i = 0; i < postTransforms.length; i++) {
        postTransforms[i](element, options);
      }
    }

    function trimEndingWhitespace(el) {
      // remove trailing whitespace node
      if (!inPre) {
        var lastNode;

        while ((lastNode = el.children[el.children.length - 1]) && lastNode.type === 3 && lastNode.text === ' ') {
          el.children.pop();
        }
      }
    }

    function checkRootConstraints(el) {
      if (el.tag === 'slot' || el.tag === 'template') {
        warnOnce("Cannot use <" + el.tag + "> as component root element because it may " + 'contain multiple nodes.', {
          start: el.start
        });
      }

      if (el.attrsMap.hasOwnProperty('v-for')) {
        warnOnce('Cannot use v-for on stateful component root element because ' + 'it renders multiple elements.', el.rawAttrsMap['v-for']);
      }
    }

    parseHTML(template, {
      warn: warn$2,
      expectHTML: options.expectHTML,
      isUnaryTag: options.isUnaryTag,
      canBeLeftOpenTag: options.canBeLeftOpenTag,
      shouldDecodeNewlines: options.shouldDecodeNewlines,
      shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
      shouldKeepComment: options.comments,
      outputSourceRange: options.outputSourceRange,
      start: function start(tag, attrs, unary, start$1, end) {
        // check namespace.
        // inherit parent ns if there is one
        var ns = currentParent && currentParent.ns || platformGetTagNamespace(tag); // handle IE svg bug

        /* istanbul ignore if */

        if (isIE && ns === 'svg') {
          attrs = guardIESVGBug(attrs);
        }

        var element = createASTElement(tag, attrs, currentParent);

        if (ns) {
          element.ns = ns;
        }

        {
          if (options.outputSourceRange) {
            element.start = start$1;
            element.end = end;
            element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
              cumulated[attr.name] = attr;
              return cumulated;
            }, {});
          }

          attrs.forEach(function (attr) {
            if (invalidAttributeRE.test(attr.name)) {
              warn$2("Invalid dynamic argument expression: attribute names cannot contain " + "spaces, quotes, <, >, / or =.", {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              });
            }
          });
        }

        if (isForbiddenTag(element) && !isServerRendering()) {
          element.forbidden = true;
           warn$2('Templates should only be responsible for mapping the state to the ' + 'UI. Avoid placing tags with side-effects in your templates, such as ' + "<" + tag + ">" + ', as they will not be parsed.', {
            start: element.start
          });
        } // apply pre-transforms


        for (var i = 0; i < preTransforms.length; i++) {
          element = preTransforms[i](element, options) || element;
        }

        if (!inVPre) {
          processPre(element);

          if (element.pre) {
            inVPre = true;
          }
        }

        if (platformIsPreTag(element.tag)) {
          inPre = true;
        }

        if (inVPre) {
          processRawAttrs(element);
        } else if (!element.processed) {
          // structural directives
          processFor(element);
          processIf(element);
          processOnce(element);
        }

        if (!root) {
          root = element;

          {
            checkRootConstraints(root);
          }
        }

        if (!unary) {
          currentParent = element;
          stack.push(element);
        } else {
          closeElement(element);
        }
      },
      end: function end(tag, start, end$1) {
        var element = stack[stack.length - 1]; // pop stack

        stack.length -= 1;
        currentParent = stack[stack.length - 1];

        if ( options.outputSourceRange) {
          element.end = end$1;
        }

        closeElement(element);
      },
      chars: function chars(text, start, end) {
        if (!currentParent) {
          {
            if (text === template) {
              warnOnce('Component template requires a root element, rather than just text.', {
                start: start
              });
            } else if (text = text.trim()) {
              warnOnce("text \"" + text + "\" outside root element will be ignored.", {
                start: start
              });
            }
          }

          return;
        } // IE textarea placeholder bug

        /* istanbul ignore if */


        if (isIE && currentParent.tag === 'textarea' && currentParent.attrsMap.placeholder === text) {
          return;
        }

        var children = currentParent.children;

        if (inPre || text.trim()) {
          text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
        } else if (!children.length) {
          // remove the whitespace-only node right after an opening tag
          text = '';
        } else if (whitespaceOption) {
          if (whitespaceOption === 'condense') {
            // in condense mode, remove the whitespace node if it contains
            // line break, otherwise condense to a single space
            text = lineBreakRE.test(text) ? '' : ' ';
          } else {
            text = ' ';
          }
        } else {
          text = preserveWhitespace ? ' ' : '';
        }

        if (text) {
          if (!inPre && whitespaceOption === 'condense') {
            // condense consecutive whitespaces into single space
            text = text.replace(whitespaceRE$1, ' ');
          }

          var res;
          var child;

          if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
            child = {
              type: 2,
              expression: res.expression,
              tokens: res.tokens,
              text: text
            };
          } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
            child = {
              type: 3,
              text: text
            };
          }

          if (child) {
            if ( options.outputSourceRange) {
              child.start = start;
              child.end = end;
            }

            children.push(child);
          }
        }
      },
      comment: function comment(text, start, end) {
        // adding anything as a sibling to the root node is forbidden
        // comments should still be allowed, but ignored
        if (currentParent) {
          var child = {
            type: 3,
            text: text,
            isComment: true
          };

          if ( options.outputSourceRange) {
            child.start = start;
            child.end = end;
          }

          currentParent.children.push(child);
        }
      }
    });
    return root;
  }

  function processPre(el) {
    if (getAndRemoveAttr(el, 'v-pre') != null) {
      el.pre = true;
    }
  }

  function processRawAttrs(el) {
    var list = el.attrsList;
    var len = list.length;

    if (len) {
      var attrs = el.attrs = new Array(len);

      for (var i = 0; i < len; i++) {
        attrs[i] = {
          name: list[i].name,
          value: JSON.stringify(list[i].value)
        };

        if (list[i].start != null) {
          attrs[i].start = list[i].start;
          attrs[i].end = list[i].end;
        }
      }
    } else if (!el.pre) {
      // non root node in pre blocks with no attributes
      el.plain = true;
    }
  }

  function processElement(element, options) {
    processKey(element); // determine whether this is a plain element after
    // removing structural attributes

    element.plain = !element.key && !element.scopedSlots && !element.attrsList.length;
    processRef(element);
    processSlotContent(element);
    processSlotOutlet(element);
    processComponent(element);

    for (var i = 0; i < transforms.length; i++) {
      element = transforms[i](element, options) || element;
    }

    processAttrs(element);
    return element;
  }

  function processKey(el) {
    var exp = getBindingAttr(el, 'key');

    if (exp) {
      {
        if (el.tag === 'template') {
          warn$2("<template> cannot be keyed. Place the key on real elements instead.", getRawBindingAttr(el, 'key'));
        }

        if (el.for) {
          var iterator = el.iterator2 || el.iterator1;
          var parent = el.parent;

          if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
            warn$2("Do not use v-for index as key on <transition-group> children, " + "this is the same as not using keys.", getRawBindingAttr(el, 'key'), true
            /* tip */
            );
          }
        }
      }

      el.key = exp;
    }
  }

  function processRef(el) {
    var ref = getBindingAttr(el, 'ref');

    if (ref) {
      el.ref = ref;
      el.refInFor = checkInFor(el);
    }
  }

  function processFor(el) {
    var exp;

    if (exp = getAndRemoveAttr(el, 'v-for')) {
      var res = parseFor(exp);

      if (res) {
        extend(el, res);
      } else {
        warn$2("Invalid v-for expression: " + exp, el.rawAttrsMap['v-for']);
      }
    }
  }

  function parseFor(exp) {
    var inMatch = exp.match(forAliasRE);

    if (!inMatch) {
      return;
    }

    var res = {};
    res.for = inMatch[2].trim();
    var alias = inMatch[1].trim().replace(stripParensRE, '');
    var iteratorMatch = alias.match(forIteratorRE);

    if (iteratorMatch) {
      res.alias = alias.replace(forIteratorRE, '').trim();
      res.iterator1 = iteratorMatch[1].trim();

      if (iteratorMatch[2]) {
        res.iterator2 = iteratorMatch[2].trim();
      }
    } else {
      res.alias = alias;
    }

    return res;
  }

  function processIf(el) {
    var exp = getAndRemoveAttr(el, 'v-if');

    if (exp) {
      el.if = exp;
      addIfCondition(el, {
        exp: exp,
        block: el
      });
    } else {
      if (getAndRemoveAttr(el, 'v-else') != null) {
        el.else = true;
      }

      var elseif = getAndRemoveAttr(el, 'v-else-if');

      if (elseif) {
        el.elseif = elseif;
      }
    }
  }

  function processIfConditions(el, parent) {
    var prev = findPrevElement(parent.children);

    if (prev && prev.if) {
      addIfCondition(prev, {
        exp: el.elseif,
        block: el
      });
    } else {
      warn$2("v-" + (el.elseif ? 'else-if="' + el.elseif + '"' : 'else') + " " + "used on element <" + el.tag + "> without corresponding v-if.", el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
    }
  }

  function findPrevElement(children) {
    var i = children.length;

    while (i--) {
      if (children[i].type === 1) {
        return children[i];
      } else {
        if ( children[i].text !== ' ') {
          warn$2("text \"" + children[i].text.trim() + "\" between v-if and v-else(-if) " + "will be ignored.", children[i]);
        }

        children.pop();
      }
    }
  }

  function addIfCondition(el, condition) {
    if (!el.ifConditions) {
      el.ifConditions = [];
    }

    el.ifConditions.push(condition);
  }

  function processOnce(el) {
    var once$$1 = getAndRemoveAttr(el, 'v-once');

    if (once$$1 != null) {
      el.once = true;
    }
  } // handle content being passed to a component as slot,
  // e.g. <template slot="xxx">, <div slot-scope="xxx">


  function processSlotContent(el) {
    var slotScope;

    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */

      if ( slotScope) {
        warn$2("the \"scope\" attribute for scoped slots have been deprecated and " + "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " + "can also be used on plain elements in addition to <template> to " + "denote scoped slots.", el.rawAttrsMap['scope'], true);
      }

      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if (slotScope = getAndRemoveAttr(el, 'slot-scope')) {
      /* istanbul ignore if */
      if ( el.attrsMap['v-for']) {
        warn$2("Ambiguous combined usage of slot-scope and v-for on <" + el.tag + "> " + "(v-for takes higher priority). Use a wrapper <template> for the " + "scoped slot to make it clearer.", el.rawAttrsMap['slot-scope'], true);
      }

      el.slotScope = slotScope;
    } // slot="xxx"


    var slotTarget = getBindingAttr(el, 'slot');

    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']); // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.

      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
      }
    } // 2.6 v-slot syntax


    {
      if (el.tag === 'template') {
        // v-slot on <template>
        var slotBinding = getAndRemoveAttrByRegex(el, slotRE);

        if (slotBinding) {
          {
            if (el.slotTarget || el.slotScope) {
              warn$2("Unexpected mixed usage of different slot syntaxes.", el);
            }

            if (el.parent && !maybeComponent(el.parent)) {
              warn$2("<template v-slot> can only appear at the root level inside " + "the receiving component", el);
            }
          }

          var ref = getSlotName(slotBinding);
          var name = ref.name;
          var dynamic = ref.dynamic;
          el.slotTarget = name;
          el.slotTargetDynamic = dynamic;
          el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
        }
      } else {
        // v-slot on component, denotes default slot
        var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);

        if (slotBinding$1) {
          {
            if (!maybeComponent(el)) {
              warn$2("v-slot can only be used on components or <template>.", slotBinding$1);
            }

            if (el.slotScope || el.slotTarget) {
              warn$2("Unexpected mixed usage of different slot syntaxes.", el);
            }

            if (el.scopedSlots) {
              warn$2("To avoid scope ambiguity, the default slot should also use " + "<template> syntax when there are other named slots.", slotBinding$1);
            }
          } // add the component's children to its default slot


          var slots = el.scopedSlots || (el.scopedSlots = {});
          var ref$1 = getSlotName(slotBinding$1);
          var name$1 = ref$1.name;
          var dynamic$1 = ref$1.dynamic;
          var slotContainer = slots[name$1] = createASTElement('template', [], el);
          slotContainer.slotTarget = name$1;
          slotContainer.slotTargetDynamic = dynamic$1;
          slotContainer.children = el.children.filter(function (c) {
            if (!c.slotScope) {
              c.parent = slotContainer;
              return true;
            }
          });
          slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken; // remove children as they are returned from scopedSlots now

          el.children = []; // mark el non-plain so data gets generated

          el.plain = false;
        }
      }
    }
  }

  function getSlotName(binding) {
    var name = binding.name.replace(slotRE, '');

    if (!name) {
      if (binding.name[0] !== '#') {
        name = 'default';
      } else {
        warn$2("v-slot shorthand syntax requires a slot name.", binding);
      }
    }

    return dynamicArgRE.test(name) // dynamic [name]
    ? {
      name: name.slice(1, -1),
      dynamic: true
    } // static name
    : {
      name: "\"" + name + "\"",
      dynamic: false
    };
  } // handle <slot/> outlets


  function processSlotOutlet(el) {
    if (el.tag === 'slot') {
      el.slotName = getBindingAttr(el, 'name');

      if ( el.key) {
        warn$2("`key` does not work on <slot> because slots are abstract outlets " + "and can possibly expand into multiple elements. " + "Use the key on a wrapping element instead.", getRawBindingAttr(el, 'key'));
      }
    }
  }

  function processComponent(el) {
    var binding;

    if (binding = getBindingAttr(el, 'is')) {
      el.component = binding;
    }

    if (getAndRemoveAttr(el, 'inline-template') != null) {
      el.inlineTemplate = true;
    }
  }

  function processAttrs(el) {
    var list = el.attrsList;
    var i, l, name, rawName, value, modifiers, syncGen, isDynamic;

    for (i = 0, l = list.length; i < l; i++) {
      name = rawName = list[i].name;
      value = list[i].value;

      if (dirRE.test(name)) {
        // mark element as dynamic
        el.hasBindings = true; // modifiers

        modifiers = parseModifiers(name.replace(dirRE, '')); // support .foo shorthand syntax for the .prop modifier

        if (modifiers) {
          name = name.replace(modifierRE, '');
        }

        if (bindRE.test(name)) {
          // v-bind
          name = name.replace(bindRE, '');
          value = parseFilters(value);
          isDynamic = dynamicArgRE.test(name);

          if (isDynamic) {
            name = name.slice(1, -1);
          }

          if ( value.trim().length === 0) {
            warn$2("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"");
          }

          if (modifiers) {
            if (modifiers.prop && !isDynamic) {
              name = camelize(name);

              if (name === 'innerHtml') {
                name = 'innerHTML';
              }
            }

            if (modifiers.camel && !isDynamic) {
              name = camelize(name);
            }

            if (modifiers.sync) {
              syncGen = genAssignmentCode(value, "$event");

              if (!isDynamic) {
                addHandler(el, "update:" + camelize(name), syncGen, null, false, warn$2, list[i]);

                if (hyphenate(name) !== camelize(name)) {
                  addHandler(el, "update:" + hyphenate(name), syncGen, null, false, warn$2, list[i]);
                }
              } else {
                // handler w/ dynamic event name
                addHandler(el, "\"update:\"+(" + name + ")", syncGen, null, false, warn$2, list[i], true // dynamic
                );
              }
            }
          }

          if (modifiers && modifiers.prop || !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
            addProp(el, name, value, list[i], isDynamic);
          } else {
            addAttr(el, name, value, list[i], isDynamic);
          }
        } else if (onRE.test(name)) {
          // v-on
          name = name.replace(onRE, '');
          isDynamic = dynamicArgRE.test(name);

          if (isDynamic) {
            name = name.slice(1, -1);
          }

          addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
        } else {
          // normal directives
          name = name.replace(dirRE, ''); // parse arg

          var argMatch = name.match(argRE);
          var arg = argMatch && argMatch[1];
          isDynamic = false;

          if (arg) {
            name = name.slice(0, -(arg.length + 1));

            if (dynamicArgRE.test(arg)) {
              arg = arg.slice(1, -1);
              isDynamic = true;
            }
          }

          addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);

          if ( name === 'model') {
            checkForAliasModel(el, value);
          }
        }
      } else {
        // literal attribute
        {
          var res = parseText(value, delimiters);

          if (res) {
            warn$2(name + "=\"" + value + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
          }
        }

        addAttr(el, name, JSON.stringify(value), list[i]); // #6887 firefox doesn't update muted state if set via attribute
        // even immediately after element creation

        if (!el.component && name === 'muted' && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
          addProp(el, name, 'true', list[i]);
        }
      }
    }
  }

  function checkInFor(el) {
    var parent = el;

    while (parent) {
      if (parent.for !== undefined) {
        return true;
      }

      parent = parent.parent;
    }

    return false;
  }

  function parseModifiers(name) {
    var match = name.match(modifierRE);

    if (match) {
      var ret = {};
      match.forEach(function (m) {
        ret[m.slice(1)] = true;
      });
      return ret;
    }
  }

  function makeAttrsMap(attrs) {
    var map = {};

    for (var i = 0, l = attrs.length; i < l; i++) {
      if ( map[attrs[i].name] && !isIE && !isEdge) {
        warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
      }

      map[attrs[i].name] = attrs[i].value;
    }

    return map;
  } // for script (e.g. type="x/template") or style, do not decode content


  function isTextTag(el) {
    return el.tag === 'script' || el.tag === 'style';
  }

  function isForbiddenTag(el) {
    return el.tag === 'style' || el.tag === 'script' && (!el.attrsMap.type || el.attrsMap.type === 'text/javascript');
  }

  var ieNSBug = /^xmlns:NS\d+/;
  var ieNSPrefix = /^NS\d+:/;
  /* istanbul ignore next */

  function guardIESVGBug(attrs) {
    var res = [];

    for (var i = 0; i < attrs.length; i++) {
      var attr = attrs[i];

      if (!ieNSBug.test(attr.name)) {
        attr.name = attr.name.replace(ieNSPrefix, '');
        res.push(attr);
      }
    }

    return res;
  }

  function checkForAliasModel(el, value) {
    var _el = el;

    while (_el) {
      if (_el.for && _el.alias === value) {
        warn$2("<" + el.tag + " v-model=\"" + value + "\">: " + "You are binding v-model directly to a v-for iteration alias. " + "This will not be able to modify the v-for source array because " + "writing to the alias is like modifying a function local variable. " + "Consider using an array of objects and use v-model on an object property instead.", el.rawAttrsMap['v-model']);
      }

      _el = _el.parent;
    }
  }
  /*  */


  function preTransformNode(el, options) {
    if (el.tag === 'input') {
      var map = el.attrsMap;

      if (!map['v-model']) {
        return;
      }

      var typeBinding;

      if (map[':type'] || map['v-bind:type']) {
        typeBinding = getBindingAttr(el, 'type');
      }

      if (!map.type && !typeBinding && map['v-bind']) {
        typeBinding = "(" + map['v-bind'] + ").type";
      }

      if (typeBinding) {
        var ifCondition = getAndRemoveAttr(el, 'v-if', true);
        var ifConditionExtra = ifCondition ? "&&(" + ifCondition + ")" : "";
        var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
        var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true); // 1. checkbox

        var branch0 = cloneASTElement(el); // process for on the main node

        processFor(branch0);
        addRawAttr(branch0, 'type', 'checkbox');
        processElement(branch0, options);
        branch0.processed = true; // prevent it from double-processed

        branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
        addIfCondition(branch0, {
          exp: branch0.if,
          block: branch0
        }); // 2. add radio else-if condition

        var branch1 = cloneASTElement(el);
        getAndRemoveAttr(branch1, 'v-for', true);
        addRawAttr(branch1, 'type', 'radio');
        processElement(branch1, options);
        addIfCondition(branch0, {
          exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
          block: branch1
        }); // 3. other

        var branch2 = cloneASTElement(el);
        getAndRemoveAttr(branch2, 'v-for', true);
        addRawAttr(branch2, ':type', typeBinding);
        processElement(branch2, options);
        addIfCondition(branch0, {
          exp: ifCondition,
          block: branch2
        });

        if (hasElse) {
          branch0.else = true;
        } else if (elseIfCondition) {
          branch0.elseif = elseIfCondition;
        }

        return branch0;
      }
    }
  }

  function cloneASTElement(el) {
    return createASTElement(el.tag, el.attrsList.slice(), el.parent);
  }

  var model$1 = {
    preTransformNode: preTransformNode
  };
  var modules$1 = [klass$1, style$1, model$1];
  /*  */

  function text(el, dir) {
    if (dir.value) {
      addProp(el, 'textContent', "_s(" + dir.value + ")", dir);
    }
  }
  /*  */


  function html(el, dir) {
    if (dir.value) {
      addProp(el, 'innerHTML', "_s(" + dir.value + ")", dir);
    }
  }

  var directives$1 = {
    model: model,
    text: text,
    html: html
  };
  /*  */

  var baseOptions = {
    expectHTML: true,
    modules: modules$1,
    directives: directives$1,
    isPreTag: isPreTag,
    isUnaryTag: isUnaryTag,
    mustUseProp: mustUseProp,
    canBeLeftOpenTag: canBeLeftOpenTag,
    isReservedTag: isReservedTag,
    getTagNamespace: getTagNamespace,
    staticKeys: genStaticKeys(modules$1)
  };
  /*  */

  var isStaticKey;
  var isPlatformReservedTag;
  var genStaticKeysCached = cached(genStaticKeys$1);
  /**
   * Goal of the optimizer: walk the generated template AST tree
   * and detect sub-trees that are purely static, i.e. parts of
   * the DOM that never needs to change.
   *
   * Once we detect these sub-trees, we can:
   *
   * 1. Hoist them into constants, so that we no longer need to
   *    create fresh nodes for them on each re-render;
   * 2. Completely skip them in the patching process.
   */

  function optimize(root, options) {
    if (!root) {
      return;
    }

    isStaticKey = genStaticKeysCached(options.staticKeys || '');
    isPlatformReservedTag = options.isReservedTag || no; // first pass: mark all non-static nodes.

    markStatic$1(root); // second pass: mark static roots.

    markStaticRoots(root, false);
  }

  function genStaticKeys$1(keys) {
    return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' + (keys ? ',' + keys : ''));
  }

  function markStatic$1(node) {
    node.static = isStatic(node);

    if (node.type === 1) {
      // do not make component slot content static. this avoids
      // 1. components not able to mutate slot nodes
      // 2. static slot content fails for hot-reloading
      if (!isPlatformReservedTag(node.tag) && node.tag !== 'slot' && node.attrsMap['inline-template'] == null) {
        return;
      }

      for (var i = 0, l = node.children.length; i < l; i++) {
        var child = node.children[i];
        markStatic$1(child);

        if (!child.static) {
          node.static = false;
        }
      }

      if (node.ifConditions) {
        for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
          var block = node.ifConditions[i$1].block;
          markStatic$1(block);

          if (!block.static) {
            node.static = false;
          }
        }
      }
    }
  }

  function markStaticRoots(node, isInFor) {
    if (node.type === 1) {
      if (node.static || node.once) {
        node.staticInFor = isInFor;
      } // For a node to qualify as a static root, it should have children that
      // are not just static text. Otherwise the cost of hoisting out will
      // outweigh the benefits and it's better off to just always render it fresh.


      if (node.static && node.children.length && !(node.children.length === 1 && node.children[0].type === 3)) {
        node.staticRoot = true;
        return;
      } else {
        node.staticRoot = false;
      }

      if (node.children) {
        for (var i = 0, l = node.children.length; i < l; i++) {
          markStaticRoots(node.children[i], isInFor || !!node.for);
        }
      }

      if (node.ifConditions) {
        for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
          markStaticRoots(node.ifConditions[i$1].block, isInFor);
        }
      }
    }
  }

  function isStatic(node) {
    if (node.type === 2) {
      // expression
      return false;
    }

    if (node.type === 3) {
      // text
      return true;
    }

    return !!(node.pre || !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) && Object.keys(node).every(isStaticKey));
  }

  function isDirectChildOfTemplateFor(node) {
    while (node.parent) {
      node = node.parent;

      if (node.tag !== 'template') {
        return false;
      }

      if (node.for) {
        return true;
      }
    }

    return false;
  }
  /*  */


  var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
  var fnInvokeRE = /\([^)]*?\);*$/;
  var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/; // KeyboardEvent.keyCode aliases

  var keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    'delete': [8, 46]
  }; // KeyboardEvent.key aliases

  var keyNames = {
    // #7880: IE11 and Edge use `Esc` for Escape key name.
    esc: ['Esc', 'Escape'],
    tab: 'Tab',
    enter: 'Enter',
    // #9112: IE11 uses `Spacebar` for Space key name.
    space: [' ', 'Spacebar'],
    // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
    up: ['Up', 'ArrowUp'],
    left: ['Left', 'ArrowLeft'],
    right: ['Right', 'ArrowRight'],
    down: ['Down', 'ArrowDown'],
    // #9112: IE11 uses `Del` for Delete key name.
    'delete': ['Backspace', 'Delete', 'Del']
  }; // #4868: modifiers that prevent the execution of the listener
  // need to explicitly return null so that we can determine whether to remove
  // the listener for .once

  var genGuard = function genGuard(condition) {
    return "if(" + condition + ")return null;";
  };

  var modifierCode = {
    stop: '$event.stopPropagation();',
    prevent: '$event.preventDefault();',
    self: genGuard("$event.target !== $event.currentTarget"),
    ctrl: genGuard("!$event.ctrlKey"),
    shift: genGuard("!$event.shiftKey"),
    alt: genGuard("!$event.altKey"),
    meta: genGuard("!$event.metaKey"),
    left: genGuard("'button' in $event && $event.button !== 0"),
    middle: genGuard("'button' in $event && $event.button !== 1"),
    right: genGuard("'button' in $event && $event.button !== 2")
  };

  function genHandlers(events, isNative) {
    var prefix = isNative ? 'nativeOn:' : 'on:';
    var staticHandlers = "";
    var dynamicHandlers = "";

    for (var name in events) {
      var handlerCode = genHandler(events[name]);

      if (events[name] && events[name].dynamic) {
        dynamicHandlers += name + "," + handlerCode + ",";
      } else {
        staticHandlers += "\"" + name + "\":" + handlerCode + ",";
      }
    }

    staticHandlers = "{" + staticHandlers.slice(0, -1) + "}";

    if (dynamicHandlers) {
      return prefix + "_d(" + staticHandlers + ",[" + dynamicHandlers.slice(0, -1) + "])";
    } else {
      return prefix + staticHandlers;
    }
  }

  function genHandler(handler) {
    if (!handler) {
      return 'function(){}';
    }

    if (Array.isArray(handler)) {
      return "[" + handler.map(function (handler) {
        return genHandler(handler);
      }).join(',') + "]";
    }

    var isMethodPath = simplePathRE.test(handler.value);
    var isFunctionExpression = fnExpRE.test(handler.value);
    var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

    if (!handler.modifiers) {
      if (isMethodPath || isFunctionExpression) {
        return handler.value;
      }

      return "function($event){" + (isFunctionInvocation ? "return " + handler.value : handler.value) + "}"; // inline statement
    } else {
      var code = '';
      var genModifierCode = '';
      var keys = [];

      for (var key in handler.modifiers) {
        if (modifierCode[key]) {
          genModifierCode += modifierCode[key]; // left/right

          if (keyCodes[key]) {
            keys.push(key);
          }
        } else if (key === 'exact') {
          var modifiers = handler.modifiers;
          genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta'].filter(function (keyModifier) {
            return !modifiers[keyModifier];
          }).map(function (keyModifier) {
            return "$event." + keyModifier + "Key";
          }).join('||'));
        } else {
          keys.push(key);
        }
      }

      if (keys.length) {
        code += genKeyFilter(keys);
      } // Make sure modifiers like prevent and stop get executed after key filtering


      if (genModifierCode) {
        code += genModifierCode;
      }

      var handlerCode = isMethodPath ? "return " + handler.value + ".apply(null, arguments)" : isFunctionExpression ? "return (" + handler.value + ").apply(null, arguments)" : isFunctionInvocation ? "return " + handler.value : handler.value;
      return "function($event){" + code + handlerCode + "}";
    }
  }

  function genKeyFilter(keys) {
    return (// make sure the key filters only apply to KeyboardEvents
      // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
      // key events that do not have keyCode property...
      "if(!$event.type.indexOf('key')&&" + keys.map(genFilterCode).join('&&') + ")return null;"
    );
  }

  function genFilterCode(key) {
    var keyVal = parseInt(key, 10);

    if (keyVal) {
      return "$event.keyCode!==" + keyVal;
    }

    var keyCode = keyCodes[key];
    var keyName = keyNames[key];
    return "_k($event.keyCode," + JSON.stringify(key) + "," + JSON.stringify(keyCode) + "," + "$event.key," + "" + JSON.stringify(keyName) + ")";
  }
  /*  */


  function on(el, dir) {
    if ( dir.modifiers) {
      warn("v-on without argument does not support modifiers.");
    }

    el.wrapListeners = function (code) {
      return "_g(" + code + "," + dir.value + ")";
    };
  }
  /*  */


  function bind$1(el, dir) {
    el.wrapData = function (code) {
      return "_b(" + code + ",'" + el.tag + "'," + dir.value + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")";
    };
  }
  /*  */


  var baseDirectives = {
    on: on,
    bind: bind$1,
    cloak: noop
  };
  /*  */

  var CodegenState = function CodegenState(options) {
    this.options = options;
    this.warn = options.warn || baseWarn;
    this.transforms = pluckModuleFunction(options.modules, 'transformCode');
    this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
    this.directives = extend(extend({}, baseDirectives), options.directives);
    var isReservedTag = options.isReservedTag || no;

    this.maybeComponent = function (el) {
      return !!el.component || !isReservedTag(el.tag);
    };

    this.onceId = 0;
    this.staticRenderFns = [];
    this.pre = false;
  };

  function generate(ast, options) {
    var state = new CodegenState(options); // fix #11483, Root level <script> tags should not be rendered.

    var code = ast ? ast.tag === 'script' ? 'null' : genElement(ast, state) : '_c("div")';
    return {
      render: "with(this){return " + code + "}",
      staticRenderFns: state.staticRenderFns
    };
  }

  function genElement(el, state) {
    if (el.parent) {
      el.pre = el.pre || el.parent.pre;
    }

    if (el.staticRoot && !el.staticProcessed) {
      return genStatic(el, state);
    } else if (el.once && !el.onceProcessed) {
      return genOnce(el, state);
    } else if (el.for && !el.forProcessed) {
      return genFor(el, state);
    } else if (el.if && !el.ifProcessed) {
      return genIf(el, state);
    } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
      return genChildren(el, state) || 'void 0';
    } else if (el.tag === 'slot') {
      return genSlot(el, state);
    } else {
      // component or element
      var code;

      if (el.component) {
        code = genComponent(el.component, el, state);
      } else {
        var data;

        if (!el.plain || el.pre && state.maybeComponent(el)) {
          data = genData$2(el, state);
        }

        var children = el.inlineTemplate ? null : genChildren(el, state, true);
        code = "_c('" + el.tag + "'" + (data ? "," + data : '') + (children ? "," + children : '') + ")";
      } // module transforms


      for (var i = 0; i < state.transforms.length; i++) {
        code = state.transforms[i](el, code);
      }

      return code;
    }
  } // hoist static sub-trees out


  function genStatic(el, state) {
    el.staticProcessed = true; // Some elements (templates) need to behave differently inside of a v-pre
    // node.  All pre nodes are static roots, so we can use this as a location to
    // wrap a state change and reset it upon exiting the pre node.

    var originalPreState = state.pre;

    if (el.pre) {
      state.pre = el.pre;
    }

    state.staticRenderFns.push("with(this){return " + genElement(el, state) + "}");
    state.pre = originalPreState;
    return "_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")";
  } // v-once


  function genOnce(el, state) {
    el.onceProcessed = true;

    if (el.if && !el.ifProcessed) {
      return genIf(el, state);
    } else if (el.staticInFor) {
      var key = '';
      var parent = el.parent;

      while (parent) {
        if (parent.for) {
          key = parent.key;
          break;
        }

        parent = parent.parent;
      }

      if (!key) {
         state.warn("v-once can only be used inside v-for that is keyed. ", el.rawAttrsMap['v-once']);
        return genElement(el, state);
      }

      return "_o(" + genElement(el, state) + "," + state.onceId++ + "," + key + ")";
    } else {
      return genStatic(el, state);
    }
  }

  function genIf(el, state, altGen, altEmpty) {
    el.ifProcessed = true; // avoid recursion

    return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
  }

  function genIfConditions(conditions, state, altGen, altEmpty) {
    if (!conditions.length) {
      return altEmpty || '_e()';
    }

    var condition = conditions.shift();

    if (condition.exp) {
      return "(" + condition.exp + ")?" + genTernaryExp(condition.block) + ":" + genIfConditions(conditions, state, altGen, altEmpty);
    } else {
      return "" + genTernaryExp(condition.block);
    } // v-if with v-once should generate code like (a)?_m(0):_m(1)


    function genTernaryExp(el) {
      return altGen ? altGen(el, state) : el.once ? genOnce(el, state) : genElement(el, state);
    }
  }

  function genFor(el, state, altGen, altHelper) {
    var exp = el.for;
    var alias = el.alias;
    var iterator1 = el.iterator1 ? "," + el.iterator1 : '';
    var iterator2 = el.iterator2 ? "," + el.iterator2 : '';

    if ( state.maybeComponent(el) && el.tag !== 'slot' && el.tag !== 'template' && !el.key) {
      state.warn("<" + el.tag + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " + "v-for should have explicit keys. " + "See https://vuejs.org/guide/list.html#key for more info.", el.rawAttrsMap['v-for'], true
      /* tip */
      );
    }

    el.forProcessed = true; // avoid recursion

    return (altHelper || '_l') + "((" + exp + ")," + "function(" + alias + iterator1 + iterator2 + "){" + "return " + (altGen || genElement)(el, state) + '})';
  }

  function genData$2(el, state) {
    var data = '{'; // directives first.
    // directives may mutate the el's other properties before they are generated.

    var dirs = genDirectives(el, state);

    if (dirs) {
      data += dirs + ',';
    } // key


    if (el.key) {
      data += "key:" + el.key + ",";
    } // ref


    if (el.ref) {
      data += "ref:" + el.ref + ",";
    }

    if (el.refInFor) {
      data += "refInFor:true,";
    } // pre


    if (el.pre) {
      data += "pre:true,";
    } // record original tag name for components using "is" attribute


    if (el.component) {
      data += "tag:\"" + el.tag + "\",";
    } // module data generation functions


    for (var i = 0; i < state.dataGenFns.length; i++) {
      data += state.dataGenFns[i](el);
    } // attributes


    if (el.attrs) {
      data += "attrs:" + genProps(el.attrs) + ",";
    } // DOM props


    if (el.props) {
      data += "domProps:" + genProps(el.props) + ",";
    } // event handlers


    if (el.events) {
      data += genHandlers(el.events, false) + ",";
    }

    if (el.nativeEvents) {
      data += genHandlers(el.nativeEvents, true) + ",";
    } // slot target
    // only for non-scoped slots


    if (el.slotTarget && !el.slotScope) {
      data += "slot:" + el.slotTarget + ",";
    } // scoped slots


    if (el.scopedSlots) {
      data += genScopedSlots(el, el.scopedSlots, state) + ",";
    } // component v-model


    if (el.model) {
      data += "model:{value:" + el.model.value + ",callback:" + el.model.callback + ",expression:" + el.model.expression + "},";
    } // inline-template


    if (el.inlineTemplate) {
      var inlineTemplate = genInlineTemplate(el, state);

      if (inlineTemplate) {
        data += inlineTemplate + ",";
      }
    }

    data = data.replace(/,$/, '') + '}'; // v-bind dynamic argument wrap
    // v-bind with dynamic arguments must be applied using the same v-bind object
    // merge helper so that class/style/mustUseProp attrs are handled correctly.

    if (el.dynamicAttrs) {
      data = "_b(" + data + ",\"" + el.tag + "\"," + genProps(el.dynamicAttrs) + ")";
    } // v-bind data wrap


    if (el.wrapData) {
      data = el.wrapData(data);
    } // v-on data wrap


    if (el.wrapListeners) {
      data = el.wrapListeners(data);
    }

    return data;
  }

  function genDirectives(el, state) {
    var dirs = el.directives;

    if (!dirs) {
      return;
    }

    var res = 'directives:[';
    var hasRuntime = false;
    var i, l, dir, needRuntime;

    for (i = 0, l = dirs.length; i < l; i++) {
      dir = dirs[i];
      needRuntime = true;
      var gen = state.directives[dir.name];

      if (gen) {
        // compile-time directive that manipulates AST.
        // returns true if it also needs a runtime counterpart.
        needRuntime = !!gen(el, dir, state.warn);
      }

      if (needRuntime) {
        hasRuntime = true;
        res += "{name:\"" + dir.name + "\",rawName:\"" + dir.rawName + "\"" + (dir.value ? ",value:(" + dir.value + "),expression:" + JSON.stringify(dir.value) : '') + (dir.arg ? ",arg:" + (dir.isDynamicArg ? dir.arg : "\"" + dir.arg + "\"") : '') + (dir.modifiers ? ",modifiers:" + JSON.stringify(dir.modifiers) : '') + "},";
      }
    }

    if (hasRuntime) {
      return res.slice(0, -1) + ']';
    }
  }

  function genInlineTemplate(el, state) {
    var ast = el.children[0];

    if ( (el.children.length !== 1 || ast.type !== 1)) {
      state.warn('Inline-template components must have exactly one child element.', {
        start: el.start
      });
    }

    if (ast && ast.type === 1) {
      var inlineRenderFns = generate(ast, state.options);
      return "inlineTemplate:{render:function(){" + inlineRenderFns.render + "},staticRenderFns:[" + inlineRenderFns.staticRenderFns.map(function (code) {
        return "function(){" + code + "}";
      }).join(',') + "]}";
    }
  }

  function genScopedSlots(el, slots, state) {
    // by default scoped slots are considered "stable", this allows child
    // components with only scoped slots to skip forced updates from parent.
    // but in some cases we have to bail-out of this optimization
    // for example if the slot contains dynamic names, has v-if or v-for on them...
    var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
      var slot = slots[key];
      return slot.slotTargetDynamic || slot.if || slot.for || containsSlotChild(slot) // is passing down slot from parent which may be dynamic
      ;
    }); // #9534: if a component with scoped slots is inside a conditional branch,
    // it's possible for the same component to be reused but with different
    // compiled slot content. To avoid that, we generate a unique key based on
    // the generated code of all the slot contents.

    var needsKey = !!el.if; // OR when it is inside another scoped slot or v-for (the reactivity may be
    // disconnected due to the intermediate scope variable)
    // #9438, #9506
    // TODO: this can be further optimized by properly analyzing in-scope bindings
    // and skip force updating ones that do not actually use scope variables.

    if (!needsForceUpdate) {
      var parent = el.parent;

      while (parent) {
        if (parent.slotScope && parent.slotScope !== emptySlotScopeToken || parent.for) {
          needsForceUpdate = true;
          break;
        }

        if (parent.if) {
          needsKey = true;
        }

        parent = parent.parent;
      }
    }

    var generatedSlots = Object.keys(slots).map(function (key) {
      return genScopedSlot(slots[key], state);
    }).join(',');
    return "scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? ",null,false," + hash(generatedSlots) : "") + ")";
  }

  function hash(str) {
    var hash = 5381;
    var i = str.length;

    while (i) {
      hash = hash * 33 ^ str.charCodeAt(--i);
    }

    return hash >>> 0;
  }

  function containsSlotChild(el) {
    if (el.type === 1) {
      if (el.tag === 'slot') {
        return true;
      }

      return el.children.some(containsSlotChild);
    }

    return false;
  }

  function genScopedSlot(el, state) {
    var isLegacySyntax = el.attrsMap['slot-scope'];

    if (el.if && !el.ifProcessed && !isLegacySyntax) {
      return genIf(el, state, genScopedSlot, "null");
    }

    if (el.for && !el.forProcessed) {
      return genFor(el, state, genScopedSlot);
    }

    var slotScope = el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
    var fn = "function(" + slotScope + "){" + "return " + (el.tag === 'template' ? el.if && isLegacySyntax ? "(" + el.if + ")?" + (genChildren(el, state) || 'undefined') + ":undefined" : genChildren(el, state) || 'undefined' : genElement(el, state)) + "}"; // reverse proxy v-slot without scope on this.$slots

    var reverseProxy = slotScope ? "" : ",proxy:true";
    return "{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}";
  }

  function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
    var children = el.children;

    if (children.length) {
      var el$1 = children[0]; // optimize single v-for

      if (children.length === 1 && el$1.for && el$1.tag !== 'template' && el$1.tag !== 'slot') {
        var normalizationType = checkSkip ? state.maybeComponent(el$1) ? ",1" : ",0" : "";
        return "" + (altGenElement || genElement)(el$1, state) + normalizationType;
      }

      var normalizationType$1 = checkSkip ? getNormalizationType(children, state.maybeComponent) : 0;
      var gen = altGenNode || genNode;
      return "[" + children.map(function (c) {
        return gen(c, state);
      }).join(',') + "]" + (normalizationType$1 ? "," + normalizationType$1 : '');
    }
  } // determine the normalization needed for the children array.
  // 0: no normalization needed
  // 1: simple normalization needed (possible 1-level deep nested array)
  // 2: full normalization needed


  function getNormalizationType(children, maybeComponent) {
    var res = 0;

    for (var i = 0; i < children.length; i++) {
      var el = children[i];

      if (el.type !== 1) {
        continue;
      }

      if (needsNormalization(el) || el.ifConditions && el.ifConditions.some(function (c) {
        return needsNormalization(c.block);
      })) {
        res = 2;
        break;
      }

      if (maybeComponent(el) || el.ifConditions && el.ifConditions.some(function (c) {
        return maybeComponent(c.block);
      })) {
        res = 1;
      }
    }

    return res;
  }

  function needsNormalization(el) {
    return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
  }

  function genNode(node, state) {
    if (node.type === 1) {
      return genElement(node, state);
    } else if (node.type === 3 && node.isComment) {
      return genComment(node);
    } else {
      return genText(node);
    }
  }

  function genText(text) {
    return "_v(" + (text.type === 2 ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")";
  }

  function genComment(comment) {
    return "_e(" + JSON.stringify(comment.text) + ")";
  }

  function genSlot(el, state) {
    var slotName = el.slotName || '"default"';
    var children = genChildren(el, state);
    var res = "_t(" + slotName + (children ? ",function(){return " + children + "}" : '');
    var attrs = el.attrs || el.dynamicAttrs ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) {
      return {
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      };
    })) : null;
    var bind$$1 = el.attrsMap['v-bind'];

    if ((attrs || bind$$1) && !children) {
      res += ",null";
    }

    if (attrs) {
      res += "," + attrs;
    }

    if (bind$$1) {
      res += (attrs ? '' : ',null') + "," + bind$$1;
    }

    return res + ')';
  } // componentName is el.component, take it as argument to shun flow's pessimistic refinement


  function genComponent(componentName, el, state) {
    var children = el.inlineTemplate ? null : genChildren(el, state, true);
    return "_c(" + componentName + "," + genData$2(el, state) + (children ? "," + children : '') + ")";
  }

  function genProps(props) {
    var staticProps = "";
    var dynamicProps = "";

    for (var i = 0; i < props.length; i++) {
      var prop = props[i];
      var value = transformSpecialNewlines(prop.value);

      if (prop.dynamic) {
        dynamicProps += prop.name + "," + value + ",";
      } else {
        staticProps += "\"" + prop.name + "\":" + value + ",";
      }
    }

    staticProps = "{" + staticProps.slice(0, -1) + "}";

    if (dynamicProps) {
      return "_d(" + staticProps + ",[" + dynamicProps.slice(0, -1) + "])";
    } else {
      return staticProps;
    }
  } // #3895, #4268


  function transformSpecialNewlines(text) {
    return text.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
  }
  /*  */
  // these keywords should not appear inside expressions, but operators like
  // typeof, instanceof and in are allowed


  var prohibitedKeywordRE = new RegExp('\\b' + ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' + 'super,throw,while,yield,delete,export,import,return,switch,default,' + 'extends,finally,continue,debugger,function,arguments').split(',').join('\\b|\\b') + '\\b'); // these unary operators should not be used as property/method names

  var unaryOperatorsRE = new RegExp('\\b' + 'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)'); // strip strings in expressions

  var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g; // detect problematic expressions in a template

  function detectErrors(ast, warn) {
    if (ast) {
      checkNode(ast, warn);
    }
  }

  function checkNode(node, warn) {
    if (node.type === 1) {
      for (var name in node.attrsMap) {
        if (dirRE.test(name)) {
          var value = node.attrsMap[name];

          if (value) {
            var range = node.rawAttrsMap[name];

            if (name === 'v-for') {
              checkFor(node, "v-for=\"" + value + "\"", warn, range);
            } else if (name === 'v-slot' || name[0] === '#') {
              checkFunctionParameterExpression(value, name + "=\"" + value + "\"", warn, range);
            } else if (onRE.test(name)) {
              checkEvent(value, name + "=\"" + value + "\"", warn, range);
            } else {
              checkExpression(value, name + "=\"" + value + "\"", warn, range);
            }
          }
        }
      }

      if (node.children) {
        for (var i = 0; i < node.children.length; i++) {
          checkNode(node.children[i], warn);
        }
      }
    } else if (node.type === 2) {
      checkExpression(node.expression, node.text, warn, node);
    }
  }

  function checkEvent(exp, text, warn, range) {
    var stripped = exp.replace(stripStringRE, '');
    var keywordMatch = stripped.match(unaryOperatorsRE);

    if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
      warn("avoid using JavaScript unary operator as property name: " + "\"" + keywordMatch[0] + "\" in expression " + text.trim(), range);
    }

    checkExpression(exp, text, warn, range);
  }

  function checkFor(node, text, warn, range) {
    checkExpression(node.for || '', text, warn, range);
    checkIdentifier(node.alias, 'v-for alias', text, warn, range);
    checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
    checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
  }

  function checkIdentifier(ident, type, text, warn, range) {
    if (typeof ident === 'string') {
      try {
        new Function("var " + ident + "=_");
      } catch (e) {
        warn("invalid " + type + " \"" + ident + "\" in expression: " + text.trim(), range);
      }
    }
  }

  function checkExpression(exp, text, warn, range) {
    try {
      new Function("return " + exp);
    } catch (e) {
      var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);

      if (keywordMatch) {
        warn("avoid using JavaScript keyword as property name: " + "\"" + keywordMatch[0] + "\"\n  Raw expression: " + text.trim(), range);
      } else {
        warn("invalid expression: " + e.message + " in\n\n" + "    " + exp + "\n\n" + "  Raw expression: " + text.trim() + "\n", range);
      }
    }
  }

  function checkFunctionParameterExpression(exp, text, warn, range) {
    try {
      new Function(exp, '');
    } catch (e) {
      warn("invalid function parameter expression: " + e.message + " in\n\n" + "    " + exp + "\n\n" + "  Raw expression: " + text.trim() + "\n", range);
    }
  }
  /*  */


  var range = 2;

  function generateCodeFrame(source, start, end) {
    if (start === void 0) start = 0;
    if (end === void 0) end = source.length;
    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];

    for (var i = 0; i < lines.length; i++) {
      count += lines[i].length + 1;

      if (count >= start) {
        for (var j = i - range; j <= i + range || end > count; j++) {
          if (j < 0 || j >= lines.length) {
            continue;
          }

          res.push("" + (j + 1) + repeat$1(" ", 3 - String(j + 1).length) + "|  " + lines[j]);
          var lineLength = lines[j].length;

          if (j === i) {
            // push underline
            var pad = start - (count - lineLength) + 1;
            var length = end > count ? lineLength - pad : end - start;
            res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
          } else if (j > i) {
            if (end > count) {
              var length$1 = Math.min(end - count, lineLength);
              res.push("   |  " + repeat$1("^", length$1));
            }

            count += lineLength + 1;
          }
        }

        break;
      }
    }

    return res.join('\n');
  }

  function repeat$1(str, n) {
    var result = '';

    if (n > 0) {
      while (true) {
        // eslint-disable-line
        if (n & 1) {
          result += str;
        }

        n >>>= 1;

        if (n <= 0) {
          break;
        }

        str += str;
      }
    }

    return result;
  }
  /*  */


  function createFunction(code, errors) {
    try {
      return new Function(code);
    } catch (err) {
      errors.push({
        err: err,
        code: code
      });
      return noop;
    }
  }

  function createCompileToFunctionFn(compile) {
    var cache = Object.create(null);
    return function compileToFunctions(template, options, vm) {
      options = extend({}, options);
      var warn$$1 = options.warn || warn;
      delete options.warn;
      /* istanbul ignore if */

      {
        // detect possible CSP restriction
        try {
          new Function('return 1');
        } catch (e) {
          if (e.toString().match(/unsafe-eval|CSP/)) {
            warn$$1('It seems you are using the standalone build of Vue.js in an ' + 'environment with Content Security Policy that prohibits unsafe-eval. ' + 'The template compiler cannot work in this environment. Consider ' + 'relaxing the policy to allow unsafe-eval or pre-compiling your ' + 'templates into render functions.');
          }
        }
      } // check cache


      var key = options.delimiters ? String(options.delimiters) + template : template;

      if (cache[key]) {
        return cache[key];
      } // compile


      var compiled = compile(template, options); // check compilation errors/tips

      {
        if (compiled.errors && compiled.errors.length) {
          if (options.outputSourceRange) {
            compiled.errors.forEach(function (e) {
              warn$$1("Error compiling template:\n\n" + e.msg + "\n\n" + generateCodeFrame(template, e.start, e.end), vm);
            });
          } else {
            warn$$1("Error compiling template:\n\n" + template + "\n\n" + compiled.errors.map(function (e) {
              return "- " + e;
            }).join('\n') + '\n', vm);
          }
        }

        if (compiled.tips && compiled.tips.length) {
          if (options.outputSourceRange) {
            compiled.tips.forEach(function (e) {
              return tip(e.msg, vm);
            });
          } else {
            compiled.tips.forEach(function (msg) {
              return tip(msg, vm);
            });
          }
        }
      } // turn code into functions


      var res = {};
      var fnGenErrors = [];
      res.render = createFunction(compiled.render, fnGenErrors);
      res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
        return createFunction(code, fnGenErrors);
      }); // check function generation errors.
      // this should only happen if there is a bug in the compiler itself.
      // mostly for codegen development use

      /* istanbul ignore if */

      {
        if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
          warn$$1("Failed to generate render function:\n\n" + fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;
            return err.toString() + " in\n\n" + code + "\n";
          }).join('\n'), vm);
        }
      }

      return cache[key] = res;
    };
  }
  /*  */


  function createCompilerCreator(baseCompile) {
    return function createCompiler(baseOptions) {
      function compile(template, options) {
        var finalOptions = Object.create(baseOptions);
        var errors = [];
        var tips = [];

        var warn = function warn(msg, range, tip) {
          (tip ? tips : errors).push(msg);
        };

        if (options) {
          if ( options.outputSourceRange) {
            // $flow-disable-line
            var leadingSpaceLength = template.match(/^\s*/)[0].length;

            warn = function warn(msg, range, tip) {
              var data = {
                msg: msg
              };

              if (range) {
                if (range.start != null) {
                  data.start = range.start + leadingSpaceLength;
                }

                if (range.end != null) {
                  data.end = range.end + leadingSpaceLength;
                }
              }

              (tip ? tips : errors).push(data);
            };
          } // merge custom modules


          if (options.modules) {
            finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
          } // merge custom directives


          if (options.directives) {
            finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
          } // copy other options


          for (var key in options) {
            if (key !== 'modules' && key !== 'directives') {
              finalOptions[key] = options[key];
            }
          }
        }

        finalOptions.warn = warn;
        var compiled = baseCompile(template.trim(), finalOptions);

        {
          detectErrors(compiled.ast, warn);
        }

        compiled.errors = errors;
        compiled.tips = tips;
        return compiled;
      }

      return {
        compile: compile,
        compileToFunctions: createCompileToFunctionFn(compile)
      };
    };
  }
  /*  */
  // `createCompilerCreator` allows creating compilers that use alternative
  // parser/optimizer/codegen, e.g the SSR optimizing compiler.
  // Here we just export a default compiler using the default parts.


  var createCompiler = createCompilerCreator(function baseCompile(template, options) {
    var ast = parse(template.trim(), options);

    if (options.optimize !== false) {
      optimize(ast, options);
    }

    var code = generate(ast, options);
    return {
      ast: ast,
      render: code.render,
      staticRenderFns: code.staticRenderFns
    };
  });
  /*  */

  var ref$1 = createCompiler(baseOptions);
  var compileToFunctions = ref$1.compileToFunctions;
  /*  */
  // check whether current browser encodes a char inside attribute values

  var div;

  function getShouldDecode(href) {
    div = div || document.createElement('div');
    div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
    return div.innerHTML.indexOf('&#10;') > 0;
  } // #3663: IE encodes newlines inside attribute values while other browsers don't


  var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false; // #6828: chrome encodes content in a[href]

  var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;
  /*  */

  var idToTemplate = cached(function (id) {
    var el = query(id);
    return el && el.innerHTML;
  });
  var mount = Vue.prototype.$mount;

  Vue.prototype.$mount = function (el, hydrating) {
    el = el && query(el);
    /* istanbul ignore if */

    if (el === document.body || el === document.documentElement) {
       warn("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
      return this;
    }

    var options = this.$options; // resolve template/el and convert to render function

    if (!options.render) {
      var template = options.template;

      if (template) {
        if (typeof template === 'string') {
          if (template.charAt(0) === '#') {
            template = idToTemplate(template);
            /* istanbul ignore if */

            if ( !template) {
              warn("Template element not found or is empty: " + options.template, this);
            }
          }
        } else if (template.nodeType) {
          template = template.innerHTML;
        } else {
          {
            warn('invalid template option:' + template, this);
          }

          return this;
        }
      } else if (el) {
        template = getOuterHTML(el);
      }

      if (template) {
        /* istanbul ignore if */
        if ( config.performance && mark) {
          mark('compile');
        }

        var ref = compileToFunctions(template, {
          outputSourceRange: "development" !== 'production',
          shouldDecodeNewlines: shouldDecodeNewlines,
          shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
          delimiters: options.delimiters,
          comments: options.comments
        }, this);
        var render = ref.render;
        var staticRenderFns = ref.staticRenderFns;
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        /* istanbul ignore if */

        if ( config.performance && mark) {
          mark('compile end');
          measure("vue " + this._name + " compile", 'compile', 'compile end');
        }
      }
    }

    return mount.call(this, el, hydrating);
  };
  /**
   * Get outerHTML of elements, taking care
   * of SVG elements in IE as well.
   */


  function getOuterHTML(el) {
    if (el.outerHTML) {
      return el.outerHTML;
    } else {
      var container = document.createElement('div');
      container.appendChild(el.cloneNode(true));
      return container.innerHTML;
    }
  }

  Vue.compile = compileToFunctions;

  /*!
   * vuex v3.6.2
   * (c) 2021 Evan You
   * @license MIT
   */
  function applyMixin(Vue) {
    var version = Number(Vue.version.split('.')[0]);

    if (version >= 2) {
      Vue.mixin({
        beforeCreate: vuexInit
      });
    } else {
      // override init and inject vuex init procedure
      // for 1.x backwards compatibility.
      var _init = Vue.prototype._init;

      Vue.prototype._init = function (options) {
        if (options === void 0) options = {};
        options.init = options.init ? [vuexInit].concat(options.init) : vuexInit;

        _init.call(this, options);
      };
    }
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */


    function vuexInit() {
      var options = this.$options; // store injection

      if (options.store) {
        this.$store = typeof options.store === 'function' ? options.store() : options.store;
      } else if (options.parent && options.parent.$store) {
        this.$store = options.parent.$store;
      }
    }
  }

  var target$2 = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
  var devtoolHook = target$2.__VUE_DEVTOOLS_GLOBAL_HOOK__;

  function devtoolPlugin(store) {
    if (!devtoolHook) {
      return;
    }

    store._devtoolHook = devtoolHook;
    devtoolHook.emit('vuex:init', store);
    devtoolHook.on('vuex:travel-to-state', function (targetState) {
      store.replaceState(targetState);
    });
    store.subscribe(function (mutation, state) {
      devtoolHook.emit('vuex:mutation', mutation, state);
    }, {
      prepend: true
    });
    store.subscribeAction(function (action, state) {
      devtoolHook.emit('vuex:action', action, state);
    }, {
      prepend: true
    });
  }
  /**
   * Get the first item that pass the test
   * by second argument function
   *
   * @param {Array} list
   * @param {Function} f
   * @return {*}
   */


  function find(list, f) {
    return list.filter(f)[0];
  }
  /**
   * Deep copy the given object considering circular structure.
   * This function caches all nested objects and its copies.
   * If it detects circular structure, use cached copy to avoid infinite loop.
   *
   * @param {*} obj
   * @param {Array<Object>} cache
   * @return {*}
   */


  function deepCopy(obj, cache) {
    if (cache === void 0) cache = []; // just return if obj is immutable value

    if (obj === null || _typeof(obj) !== 'object') {
      return obj;
    } // if obj is hit, it is in circular structure


    var hit = find(cache, function (c) {
      return c.original === obj;
    });

    if (hit) {
      return hit.copy;
    }

    var copy = Array.isArray(obj) ? [] : {}; // put the copy into cache at first
    // because we want to refer it in recursive deepCopy

    cache.push({
      original: obj,
      copy: copy
    });
    Object.keys(obj).forEach(function (key) {
      copy[key] = deepCopy(obj[key], cache);
    });
    return copy;
  }
  /**
   * forEach for object
   */


  function forEachValue(obj, fn) {
    Object.keys(obj).forEach(function (key) {
      return fn(obj[key], key);
    });
  }

  function isObject$1(obj) {
    return obj !== null && _typeof(obj) === 'object';
  }

  function isPromise$1(val) {
    return val && typeof val.then === 'function';
  }

  function assert(condition, msg) {
    if (!condition) {
      throw new Error("[vuex] " + msg);
    }
  }

  function partial(fn, arg) {
    return function () {
      return fn(arg);
    };
  } // Base data struct for store's module, package with some attribute and method


  var Module = function Module(rawModule, runtime) {
    this.runtime = runtime; // Store some children item

    this._children = Object.create(null); // Store the origin module object which passed by programmer

    this._rawModule = rawModule;
    var rawState = rawModule.state; // Store the origin module's state

    this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
  };

  var prototypeAccessors$1 = {
    namespaced: {
      configurable: true
    }
  };

  prototypeAccessors$1.namespaced.get = function () {
    return !!this._rawModule.namespaced;
  };

  Module.prototype.addChild = function addChild(key, module) {
    this._children[key] = module;
  };

  Module.prototype.removeChild = function removeChild(key) {
    delete this._children[key];
  };

  Module.prototype.getChild = function getChild(key) {
    return this._children[key];
  };

  Module.prototype.hasChild = function hasChild(key) {
    return key in this._children;
  };

  Module.prototype.update = function update(rawModule) {
    this._rawModule.namespaced = rawModule.namespaced;

    if (rawModule.actions) {
      this._rawModule.actions = rawModule.actions;
    }

    if (rawModule.mutations) {
      this._rawModule.mutations = rawModule.mutations;
    }

    if (rawModule.getters) {
      this._rawModule.getters = rawModule.getters;
    }
  };

  Module.prototype.forEachChild = function forEachChild(fn) {
    forEachValue(this._children, fn);
  };

  Module.prototype.forEachGetter = function forEachGetter(fn) {
    if (this._rawModule.getters) {
      forEachValue(this._rawModule.getters, fn);
    }
  };

  Module.prototype.forEachAction = function forEachAction(fn) {
    if (this._rawModule.actions) {
      forEachValue(this._rawModule.actions, fn);
    }
  };

  Module.prototype.forEachMutation = function forEachMutation(fn) {
    if (this._rawModule.mutations) {
      forEachValue(this._rawModule.mutations, fn);
    }
  };

  Object.defineProperties(Module.prototype, prototypeAccessors$1);

  var ModuleCollection = function ModuleCollection(rawRootModule) {
    // register root module (Vuex.Store options)
    this.register([], rawRootModule, false);
  };

  ModuleCollection.prototype.get = function get(path) {
    return path.reduce(function (module, key) {
      return module.getChild(key);
    }, this.root);
  };

  ModuleCollection.prototype.getNamespace = function getNamespace(path) {
    var module = this.root;
    return path.reduce(function (namespace, key) {
      module = module.getChild(key);
      return namespace + (module.namespaced ? key + '/' : '');
    }, '');
  };

  ModuleCollection.prototype.update = function update$1(rawRootModule) {
    update([], this.root, rawRootModule);
  };

  ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
    var this$1 = this;
    if (runtime === void 0) runtime = true;

    {
      assertRawModule(path, rawModule);
    }

    var newModule = new Module(rawModule, runtime);

    if (path.length === 0) {
      this.root = newModule;
    } else {
      var parent = this.get(path.slice(0, -1));
      parent.addChild(path[path.length - 1], newModule);
    } // register nested modules


    if (rawModule.modules) {
      forEachValue(rawModule.modules, function (rawChildModule, key) {
        this$1.register(path.concat(key), rawChildModule, runtime);
      });
    }
  };

  ModuleCollection.prototype.unregister = function unregister(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    var child = parent.getChild(key);

    if (!child) {
      {
        console.warn("[vuex] trying to unregister module '" + key + "', which is " + "not registered");
      }

      return;
    }

    if (!child.runtime) {
      return;
    }

    parent.removeChild(key);
  };

  ModuleCollection.prototype.isRegistered = function isRegistered(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];

    if (parent) {
      return parent.hasChild(key);
    }

    return false;
  };

  function update(path, targetModule, newModule) {
    {
      assertRawModule(path, newModule);
    } // update target module


    targetModule.update(newModule); // update nested modules

    if (newModule.modules) {
      for (var key in newModule.modules) {
        if (!targetModule.getChild(key)) {
          {
            console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
          }

          return;
        }

        update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
      }
    }
  }

  var functionAssert = {
    assert: function assert(value) {
      return typeof value === 'function';
    },
    expected: 'function'
  };
  var objectAssert = {
    assert: function assert(value) {
      return typeof value === 'function' || _typeof(value) === 'object' && typeof value.handler === 'function';
    },
    expected: 'function or object with "handler" function'
  };
  var assertTypes = {
    getters: functionAssert,
    mutations: functionAssert,
    actions: objectAssert
  };

  function assertRawModule(path, rawModule) {
    Object.keys(assertTypes).forEach(function (key) {
      if (!rawModule[key]) {
        return;
      }

      var assertOptions = assertTypes[key];
      forEachValue(rawModule[key], function (value, type) {
        assert(assertOptions.assert(value), makeAssertionMessage(path, key, type, value, assertOptions.expected));
      });
    });
  }

  function makeAssertionMessage(path, key, type, value, expected) {
    var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";

    if (path.length > 0) {
      buf += " in module \"" + path.join('.') + "\"";
    }

    buf += " is " + JSON.stringify(value) + ".";
    return buf;
  }

  var Vue$1; // bind on install

  var Store = function Store(options) {
    var this$1 = this;
    if (options === void 0) options = {}; // Auto install if it is not done yet and `window` has `Vue`.
    // To allow users to avoid auto-installation in some cases,
    // this code should be placed here. See #731

    if (!Vue$1 && typeof window !== 'undefined' && window.Vue) {
      install(window.Vue);
    }

    {
      assert(Vue$1, "must call Vue.use(Vuex) before creating a store instance.");
      assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
      assert(this instanceof Store, "store must be called with the new operator.");
    }

    var plugins = options.plugins;
    if (plugins === void 0) plugins = [];
    var strict = options.strict;
    if (strict === void 0) strict = false; // store internal state

    this._committing = false;
    this._actions = Object.create(null);
    this._actionSubscribers = [];
    this._mutations = Object.create(null);
    this._wrappedGetters = Object.create(null);
    this._modules = new ModuleCollection(options);
    this._modulesNamespaceMap = Object.create(null);
    this._subscribers = [];
    this._watcherVM = new Vue$1();
    this._makeLocalGettersCache = Object.create(null); // bind commit and dispatch to self

    var store = this;
    var ref = this;
    var dispatch = ref.dispatch;
    var commit = ref.commit;

    this.dispatch = function boundDispatch(type, payload) {
      return dispatch.call(store, type, payload);
    };

    this.commit = function boundCommit(type, payload, options) {
      return commit.call(store, type, payload, options);
    }; // strict mode


    this.strict = strict;
    var state = this._modules.root.state; // init root module.
    // this also recursively registers all sub-modules
    // and collects all module getters inside this._wrappedGetters

    installModule(this, state, [], this._modules.root); // initialize the store vm, which is responsible for the reactivity
    // (also registers _wrappedGetters as computed properties)

    resetStoreVM(this, state); // apply plugins

    plugins.forEach(function (plugin) {
      return plugin(this$1);
    });
    var useDevtools = options.devtools !== undefined ? options.devtools : Vue$1.config.devtools;

    if (useDevtools) {
      devtoolPlugin(this);
    }
  };

  var prototypeAccessors$1$1 = {
    state: {
      configurable: true
    }
  };

  prototypeAccessors$1$1.state.get = function () {
    return this._vm._data.$$state;
  };

  prototypeAccessors$1$1.state.set = function (v) {
    {
      assert(false, "use store.replaceState() to explicit replace store state.");
    }
  };

  Store.prototype.commit = function commit(_type, _payload, _options) {
    var this$1 = this; // check object-style commit

    var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;
    var mutation = {
      type: type,
      payload: payload
    };
    var entry = this._mutations[type];

    if (!entry) {
      {
        console.error("[vuex] unknown mutation type: " + type);
      }

      return;
    }

    this._withCommit(function () {
      entry.forEach(function commitIterator(handler) {
        handler(payload);
      });
    });

    this._subscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) {
      return sub(mutation, this$1.state);
    });

    if ( options && options.silent) {
      console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
    }
  };

  Store.prototype.dispatch = function dispatch(_type, _payload) {
    var this$1 = this; // check object-style dispatch

    var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;
    var action = {
      type: type,
      payload: payload
    };
    var entry = this._actions[type];

    if (!entry) {
      {
        console.error("[vuex] unknown action type: " + type);
      }

      return;
    }

    try {
      this._actionSubscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) {
        return sub.before;
      }).forEach(function (sub) {
        return sub.before(action, this$1.state);
      });
    } catch (e) {
      {
        console.warn("[vuex] error in before action subscribers: ");
        console.error(e);
      }
    }

    var result = entry.length > 1 ? Promise.all(entry.map(function (handler) {
      return handler(payload);
    })) : entry[0](payload);
    return new Promise(function (resolve, reject) {
      result.then(function (res) {
        try {
          this$1._actionSubscribers.filter(function (sub) {
            return sub.after;
          }).forEach(function (sub) {
            return sub.after(action, this$1.state);
          });
        } catch (e) {
          {
            console.warn("[vuex] error in after action subscribers: ");
            console.error(e);
          }
        }

        resolve(res);
      }, function (error) {
        try {
          this$1._actionSubscribers.filter(function (sub) {
            return sub.error;
          }).forEach(function (sub) {
            return sub.error(action, this$1.state, error);
          });
        } catch (e) {
          {
            console.warn("[vuex] error in error action subscribers: ");
            console.error(e);
          }
        }

        reject(error);
      });
    });
  };

  Store.prototype.subscribe = function subscribe(fn, options) {
    return genericSubscribe(fn, this._subscribers, options);
  };

  Store.prototype.subscribeAction = function subscribeAction(fn, options) {
    var subs = typeof fn === 'function' ? {
      before: fn
    } : fn;
    return genericSubscribe(subs, this._actionSubscribers, options);
  };

  Store.prototype.watch = function watch(getter, cb, options) {
    var this$1 = this;

    {
      assert(typeof getter === 'function', "store.watch only accepts a function.");
    }

    return this._watcherVM.$watch(function () {
      return getter(this$1.state, this$1.getters);
    }, cb, options);
  };

  Store.prototype.replaceState = function replaceState(state) {
    var this$1 = this;

    this._withCommit(function () {
      this$1._vm._data.$$state = state;
    });
  };

  Store.prototype.registerModule = function registerModule(path, rawModule, options) {
    if (options === void 0) options = {};

    if (typeof path === 'string') {
      path = [path];
    }

    {
      assert(Array.isArray(path), "module path must be a string or an Array.");
      assert(path.length > 0, 'cannot register the root module by using registerModule.');
    }

    this._modules.register(path, rawModule);

    installModule(this, this.state, path, this._modules.get(path), options.preserveState); // reset store to update getters...

    resetStoreVM(this, this.state);
  };

  Store.prototype.unregisterModule = function unregisterModule(path) {
    var this$1 = this;

    if (typeof path === 'string') {
      path = [path];
    }

    {
      assert(Array.isArray(path), "module path must be a string or an Array.");
    }

    this._modules.unregister(path);

    this._withCommit(function () {
      var parentState = getNestedState(this$1.state, path.slice(0, -1));
      Vue$1.delete(parentState, path[path.length - 1]);
    });

    resetStore(this);
  };

  Store.prototype.hasModule = function hasModule(path) {
    if (typeof path === 'string') {
      path = [path];
    }

    {
      assert(Array.isArray(path), "module path must be a string or an Array.");
    }

    return this._modules.isRegistered(path);
  };

  Store.prototype.hotUpdate = function hotUpdate(newOptions) {
    this._modules.update(newOptions);

    resetStore(this, true);
  };

  Store.prototype._withCommit = function _withCommit(fn) {
    var committing = this._committing;
    this._committing = true;
    fn();
    this._committing = committing;
  };

  Object.defineProperties(Store.prototype, prototypeAccessors$1$1);

  function genericSubscribe(fn, subs, options) {
    if (subs.indexOf(fn) < 0) {
      options && options.prepend ? subs.unshift(fn) : subs.push(fn);
    }

    return function () {
      var i = subs.indexOf(fn);

      if (i > -1) {
        subs.splice(i, 1);
      }
    };
  }

  function resetStore(store, hot) {
    store._actions = Object.create(null);
    store._mutations = Object.create(null);
    store._wrappedGetters = Object.create(null);
    store._modulesNamespaceMap = Object.create(null);
    var state = store.state; // init all modules

    installModule(store, state, [], store._modules.root, true); // reset vm

    resetStoreVM(store, state, hot);
  }

  function resetStoreVM(store, state, hot) {
    var oldVm = store._vm; // bind store public getters

    store.getters = {}; // reset local getters cache

    store._makeLocalGettersCache = Object.create(null);
    var wrappedGetters = store._wrappedGetters;
    var computed = {};
    forEachValue(wrappedGetters, function (fn, key) {
      // use computed to leverage its lazy-caching mechanism
      // direct inline function use will lead to closure preserving oldVm.
      // using partial to return function with only arguments preserved in closure environment.
      computed[key] = partial(fn, store);
      Object.defineProperty(store.getters, key, {
        get: function get() {
          return store._vm[key];
        },
        enumerable: true // for local getters

      });
    }); // use a Vue instance to store the state tree
    // suppress warnings just in case the user has added
    // some funky global mixins

    var silent = Vue$1.config.silent;
    Vue$1.config.silent = true;
    store._vm = new Vue$1({
      data: {
        $$state: state
      },
      computed: computed
    });
    Vue$1.config.silent = silent; // enable strict mode for new vm

    if (store.strict) {
      enableStrictMode(store);
    }

    if (oldVm) {
      if (hot) {
        // dispatch changes in all subscribed watchers
        // to force getter re-evaluation for hot reloading.
        store._withCommit(function () {
          oldVm._data.$$state = null;
        });
      }

      Vue$1.nextTick(function () {
        return oldVm.$destroy();
      });
    }
  }

  function installModule(store, rootState, path, module, hot) {
    var isRoot = !path.length;

    var namespace = store._modules.getNamespace(path); // register in namespace map


    if (module.namespaced) {
      if (store._modulesNamespaceMap[namespace] && "development" !== 'production') {
        console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join('/'));
      }

      store._modulesNamespaceMap[namespace] = module;
    } // set state


    if (!isRoot && !hot) {
      var parentState = getNestedState(rootState, path.slice(0, -1));
      var moduleName = path[path.length - 1];

      store._withCommit(function () {
        {
          if (moduleName in parentState) {
            console.warn("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + path.join('.') + "\"");
          }
        }

        Vue$1.set(parentState, moduleName, module.state);
      });
    }

    var local = module.context = makeLocalContext(store, namespace, path);
    module.forEachMutation(function (mutation, key) {
      var namespacedType = namespace + key;
      registerMutation(store, namespacedType, mutation, local);
    });
    module.forEachAction(function (action, key) {
      var type = action.root ? key : namespace + key;
      var handler = action.handler || action;
      registerAction(store, type, handler, local);
    });
    module.forEachGetter(function (getter, key) {
      var namespacedType = namespace + key;
      registerGetter(store, namespacedType, getter, local);
    });
    module.forEachChild(function (child, key) {
      installModule(store, rootState, path.concat(key), child, hot);
    });
  }
  /**
   * make localized dispatch, commit, getters and state
   * if there is no namespace, just use root ones
   */


  function makeLocalContext(store, namespace, path) {
    var noNamespace = namespace === '';
    var local = {
      dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
        var args = unifyObjectStyle(_type, _payload, _options);
        var payload = args.payload;
        var options = args.options;
        var type = args.type;

        if (!options || !options.root) {
          type = namespace + type;

          if ( !store._actions[type]) {
            console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
            return;
          }
        }

        return store.dispatch(type, payload);
      },
      commit: noNamespace ? store.commit : function (_type, _payload, _options) {
        var args = unifyObjectStyle(_type, _payload, _options);
        var payload = args.payload;
        var options = args.options;
        var type = args.type;

        if (!options || !options.root) {
          type = namespace + type;

          if ( !store._mutations[type]) {
            console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
            return;
          }
        }

        store.commit(type, payload, options);
      }
    }; // getters and state object must be gotten lazily
    // because they will be changed by vm update

    Object.defineProperties(local, {
      getters: {
        get: noNamespace ? function () {
          return store.getters;
        } : function () {
          return makeLocalGetters(store, namespace);
        }
      },
      state: {
        get: function get() {
          return getNestedState(store.state, path);
        }
      }
    });
    return local;
  }

  function makeLocalGetters(store, namespace) {
    if (!store._makeLocalGettersCache[namespace]) {
      var gettersProxy = {};
      var splitPos = namespace.length;
      Object.keys(store.getters).forEach(function (type) {
        // skip if the target getter is not match this namespace
        if (type.slice(0, splitPos) !== namespace) {
          return;
        } // extract local getter type


        var localType = type.slice(splitPos); // Add a port to the getters proxy.
        // Define as getter property because
        // we do not want to evaluate the getters in this time.

        Object.defineProperty(gettersProxy, localType, {
          get: function get() {
            return store.getters[type];
          },
          enumerable: true
        });
      });
      store._makeLocalGettersCache[namespace] = gettersProxy;
    }

    return store._makeLocalGettersCache[namespace];
  }

  function registerMutation(store, type, handler, local) {
    var entry = store._mutations[type] || (store._mutations[type] = []);
    entry.push(function wrappedMutationHandler(payload) {
      handler.call(store, local.state, payload);
    });
  }

  function registerAction(store, type, handler, local) {
    var entry = store._actions[type] || (store._actions[type] = []);
    entry.push(function wrappedActionHandler(payload) {
      var res = handler.call(store, {
        dispatch: local.dispatch,
        commit: local.commit,
        getters: local.getters,
        state: local.state,
        rootGetters: store.getters,
        rootState: store.state
      }, payload);

      if (!isPromise$1(res)) {
        res = Promise.resolve(res);
      }

      if (store._devtoolHook) {
        return res.catch(function (err) {
          store._devtoolHook.emit('vuex:error', err);

          throw err;
        });
      } else {
        return res;
      }
    });
  }

  function registerGetter(store, type, rawGetter, local) {
    if (store._wrappedGetters[type]) {
      {
        console.error("[vuex] duplicate getter key: " + type);
      }

      return;
    }

    store._wrappedGetters[type] = function wrappedGetter(store) {
      return rawGetter(local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
      );
    };
  }

  function enableStrictMode(store) {
    store._vm.$watch(function () {
      return this._data.$$state;
    }, function () {
      {
        assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
      }
    }, {
      deep: true,
      sync: true
    });
  }

  function getNestedState(state, path) {
    return path.reduce(function (state, key) {
      return state[key];
    }, state);
  }

  function unifyObjectStyle(type, payload, options) {
    if (isObject$1(type) && type.type) {
      options = payload;
      payload = type;
      type = type.type;
    }

    {
      assert(typeof type === 'string', "expects string as the type, but found " + _typeof(type) + ".");
    }

    return {
      type: type,
      payload: payload,
      options: options
    };
  }

  function install(_Vue) {
    if (Vue$1 && _Vue === Vue$1) {
      {
        console.error('[vuex] already installed. Vue.use(Vuex) should be called only once.');
      }

      return;
    }

    Vue$1 = _Vue;
    applyMixin(Vue$1);
  }
  /**
   * Reduce the code which written in Vue.js for getting the state.
   * @param {String} [namespace] - Module's namespace
   * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
   * @param {Object}
   */


  var mapState = normalizeNamespace(function (namespace, states) {
    var res = {};

    if ( !isValidMap(states)) {
      console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
    }

    normalizeMap(states).forEach(function (ref) {
      var key = ref.key;
      var val = ref.val;

      res[key] = function mappedState() {
        var state = this.$store.state;
        var getters = this.$store.getters;

        if (namespace) {
          var module = getModuleByNamespace(this.$store, 'mapState', namespace);

          if (!module) {
            return;
          }

          state = module.context.state;
          getters = module.context.getters;
        }

        return typeof val === 'function' ? val.call(this, state, getters) : state[val];
      }; // mark vuex getter for devtools


      res[key].vuex = true;
    });
    return res;
  });
  /**
   * Reduce the code which written in Vue.js for committing the mutation
   * @param {String} [namespace] - Module's namespace
   * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
   * @return {Object}
   */

  var mapMutations = normalizeNamespace(function (namespace, mutations) {
    var res = {};

    if ( !isValidMap(mutations)) {
      console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
    }

    normalizeMap(mutations).forEach(function (ref) {
      var key = ref.key;
      var val = ref.val;

      res[key] = function mappedMutation() {
        var args = [],
            len = arguments.length;

        while (len--) {
          args[len] = arguments[len];
        } // Get the commit method from store


        var commit = this.$store.commit;

        if (namespace) {
          var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);

          if (!module) {
            return;
          }

          commit = module.context.commit;
        }

        return typeof val === 'function' ? val.apply(this, [commit].concat(args)) : commit.apply(this.$store, [val].concat(args));
      };
    });
    return res;
  });
  /**
   * Reduce the code which written in Vue.js for getting the getters
   * @param {String} [namespace] - Module's namespace
   * @param {Object|Array} getters
   * @return {Object}
   */

  var mapGetters = normalizeNamespace(function (namespace, getters) {
    var res = {};

    if ( !isValidMap(getters)) {
      console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
    }

    normalizeMap(getters).forEach(function (ref) {
      var key = ref.key;
      var val = ref.val; // The namespace has been mutated by normalizeNamespace

      val = namespace + val;

      res[key] = function mappedGetter() {
        if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
          return;
        }

        if ( !(val in this.$store.getters)) {
          console.error("[vuex] unknown getter: " + val);
          return;
        }

        return this.$store.getters[val];
      }; // mark vuex getter for devtools


      res[key].vuex = true;
    });
    return res;
  });
  /**
   * Reduce the code which written in Vue.js for dispatch the action
   * @param {String} [namespace] - Module's namespace
   * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
   * @return {Object}
   */

  var mapActions = normalizeNamespace(function (namespace, actions) {
    var res = {};

    if ( !isValidMap(actions)) {
      console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
    }

    normalizeMap(actions).forEach(function (ref) {
      var key = ref.key;
      var val = ref.val;

      res[key] = function mappedAction() {
        var args = [],
            len = arguments.length;

        while (len--) {
          args[len] = arguments[len];
        } // get dispatch function from store


        var dispatch = this.$store.dispatch;

        if (namespace) {
          var module = getModuleByNamespace(this.$store, 'mapActions', namespace);

          if (!module) {
            return;
          }

          dispatch = module.context.dispatch;
        }

        return typeof val === 'function' ? val.apply(this, [dispatch].concat(args)) : dispatch.apply(this.$store, [val].concat(args));
      };
    });
    return res;
  });
  /**
   * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
   * @param {String} namespace
   * @return {Object}
   */

  var createNamespacedHelpers = function createNamespacedHelpers(namespace) {
    return {
      mapState: mapState.bind(null, namespace),
      mapGetters: mapGetters.bind(null, namespace),
      mapMutations: mapMutations.bind(null, namespace),
      mapActions: mapActions.bind(null, namespace)
    };
  };
  /**
   * Normalize the map
   * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
   * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
   * @param {Array|Object} map
   * @return {Object}
   */


  function normalizeMap(map) {
    if (!isValidMap(map)) {
      return [];
    }

    return Array.isArray(map) ? map.map(function (key) {
      return {
        key: key,
        val: key
      };
    }) : Object.keys(map).map(function (key) {
      return {
        key: key,
        val: map[key]
      };
    });
  }
  /**
   * Validate whether given map is valid or not
   * @param {*} map
   * @return {Boolean}
   */


  function isValidMap(map) {
    return Array.isArray(map) || isObject$1(map);
  }
  /**
   * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
   * @param {Function} fn
   * @return {Function}
   */


  function normalizeNamespace(fn) {
    return function (namespace, map) {
      if (typeof namespace !== 'string') {
        map = namespace;
        namespace = '';
      } else if (namespace.charAt(namespace.length - 1) !== '/') {
        namespace += '/';
      }

      return fn(namespace, map);
    };
  }
  /**
   * Search a special module from store by namespace. if module not exist, print error message.
   * @param {Object} store
   * @param {String} helper
   * @param {String} namespace
   * @return {Object}
   */


  function getModuleByNamespace(store, helper, namespace) {
    var module = store._modulesNamespaceMap[namespace];

    if ( !module) {
      console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
    }

    return module;
  } // Credits: borrowed code from fcomb/redux-logger


  function createLogger(ref) {
    if (ref === void 0) ref = {};
    var collapsed = ref.collapsed;
    if (collapsed === void 0) collapsed = true;
    var filter = ref.filter;
    if (filter === void 0) filter = function filter(mutation, stateBefore, stateAfter) {
      return true;
    };
    var transformer = ref.transformer;
    if (transformer === void 0) transformer = function transformer(state) {
      return state;
    };
    var mutationTransformer = ref.mutationTransformer;
    if (mutationTransformer === void 0) mutationTransformer = function mutationTransformer(mut) {
      return mut;
    };
    var actionFilter = ref.actionFilter;
    if (actionFilter === void 0) actionFilter = function actionFilter(action, state) {
      return true;
    };
    var actionTransformer = ref.actionTransformer;
    if (actionTransformer === void 0) actionTransformer = function actionTransformer(act) {
      return act;
    };
    var logMutations = ref.logMutations;
    if (logMutations === void 0) logMutations = true;
    var logActions = ref.logActions;
    if (logActions === void 0) logActions = true;
    var logger = ref.logger;
    if (logger === void 0) logger = console;
    return function (store) {
      var prevState = deepCopy(store.state);

      if (typeof logger === 'undefined') {
        return;
      }

      if (logMutations) {
        store.subscribe(function (mutation, state) {
          var nextState = deepCopy(state);

          if (filter(mutation, prevState, nextState)) {
            var formattedTime = getFormattedTime();
            var formattedMutation = mutationTransformer(mutation);
            var message = "mutation " + mutation.type + formattedTime;
            startMessage(logger, message, collapsed);
            logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
            logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
            logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
            endMessage(logger);
          }

          prevState = nextState;
        });
      }

      if (logActions) {
        store.subscribeAction(function (action, state) {
          if (actionFilter(action, state)) {
            var formattedTime = getFormattedTime();
            var formattedAction = actionTransformer(action);
            var message = "action " + action.type + formattedTime;
            startMessage(logger, message, collapsed);
            logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
            endMessage(logger);
          }
        });
      }
    };
  }

  function startMessage(logger, message, collapsed) {
    var startMessage = collapsed ? logger.groupCollapsed : logger.group; // render

    try {
      startMessage.call(logger, message);
    } catch (e) {
      logger.log(message);
    }
  }

  function endMessage(logger) {
    try {
      logger.groupEnd();
    } catch (e) {
      logger.log('—— log end ——');
    }
  }

  function getFormattedTime() {
    var time = new Date();
    return " @ " + pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
  }

  function repeat$2(str, times) {
    return new Array(times + 1).join(str);
  }

  function pad(num, maxLength) {
    return repeat$2('0', maxLength - num.toString().length) + num;
  }

  var index$2 = {
    Store: Store,
    install: install,
    version: '3.6.2',
    mapState: mapState,
    mapMutations: mapMutations,
    mapGetters: mapGetters,
    mapActions: mapActions,
    createNamespacedHelpers: createNamespacedHelpers,
    createLogger: createLogger
  };

  var scrollLock = createCommonjsModule(function (module, exports) {
    (function webpackUniversalModuleDefinition(root, factory) {
      module.exports = factory();
    })(commonjsGlobal, function () {
      return (
        /******/
        function (modules) {
          // webpackBootstrap

          /******/
          // The module cache

          /******/
          var installedModules = {};
          /******/

          /******/
          // The require function

          /******/

          function __webpack_require__(moduleId) {
            /******/

            /******/
            // Check if module is in cache

            /******/
            if (installedModules[moduleId]) {
              /******/
              return installedModules[moduleId].exports;
              /******/
            }
            /******/
            // Create a new module (and put it into the cache)

            /******/


            var module = installedModules[moduleId] = {
              /******/
              i: moduleId,

              /******/
              l: false,

              /******/
              exports: {}
              /******/

            };
            /******/

            /******/
            // Execute the module function

            /******/

            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/

            /******/
            // Flag the module as loaded

            /******/

            module.l = true;
            /******/

            /******/
            // Return the exports of the module

            /******/

            return module.exports;
            /******/
          }
          /******/

          /******/

          /******/
          // expose the modules object (__webpack_modules__)

          /******/


          __webpack_require__.m = modules;
          /******/

          /******/
          // expose the module cache

          /******/

          __webpack_require__.c = installedModules;
          /******/

          /******/
          // define getter function for harmony exports

          /******/

          __webpack_require__.d = function (exports, name, getter) {
            /******/
            if (!__webpack_require__.o(exports, name)) {
              /******/
              Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
              });
              /******/
            }
            /******/

          };
          /******/

          /******/
          // define __esModule on exports

          /******/


          __webpack_require__.r = function (exports) {
            /******/
            if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
              /******/
              Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
              });
              /******/
            }
            /******/


            Object.defineProperty(exports, '__esModule', {
              value: true
            });
            /******/
          };
          /******/

          /******/
          // create a fake namespace object

          /******/
          // mode & 1: value is a module id, require it

          /******/
          // mode & 2: merge all properties of value into the ns

          /******/
          // mode & 4: return value when already ns object

          /******/
          // mode & 8|1: behave like require

          /******/


          __webpack_require__.t = function (value, mode) {
            /******/
            if (mode & 1) value = __webpack_require__(value);
            /******/

            if (mode & 8) return value;
            /******/

            if (mode & 4 && _typeof(value) === 'object' && value && value.__esModule) return value;
            /******/

            var ns = Object.create(null);
            /******/

            __webpack_require__.r(ns);
            /******/


            Object.defineProperty(ns, 'default', {
              enumerable: true,
              value: value
            });
            /******/

            if (mode & 2 && typeof value != 'string') for (var key in value) {
              __webpack_require__.d(ns, key, function (key) {
                return value[key];
              }.bind(null, key));
            }
            /******/

            return ns;
            /******/
          };
          /******/

          /******/
          // getDefaultExport function for compatibility with non-harmony modules

          /******/


          __webpack_require__.n = function (module) {
            /******/
            var getter = module && module.__esModule ?
            /******/
            function getDefault() {
              return module['default'];
            } :
            /******/
            function getModuleExports() {
              return module;
            };
            /******/

            __webpack_require__.d(getter, 'a', getter);
            /******/


            return getter;
            /******/
          };
          /******/

          /******/
          // Object.prototype.hasOwnProperty.call

          /******/


          __webpack_require__.o = function (object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
          };
          /******/

          /******/
          // __webpack_public_path__

          /******/


          __webpack_require__.p = "";
          /******/

          /******/

          /******/
          // Load entry module and return exports

          /******/

          return __webpack_require__(__webpack_require__.s = 0);
          /******/
        }
        /************************************************************************/

        /******/
        ([
        /* 0 */

        /***/
        function (module, __webpack_exports__, __webpack_require__) {

          __webpack_require__.r(__webpack_exports__); // CONCATENATED MODULE: ./src/tools.js


          var argumentAsArray = function argumentAsArray(argument) {
            return Array.isArray(argument) ? argument : [argument];
          };

          var isElement = function isElement(target) {
            return target instanceof Node;
          };

          var isElementList = function isElementList(nodeList) {
            return nodeList instanceof NodeList;
          };

          var eachNode = function eachNode(nodeList, callback) {
            if (nodeList && callback) {
              nodeList = isElementList(nodeList) ? nodeList : [nodeList];

              for (var i = 0; i < nodeList.length; i++) {
                if (callback(nodeList[i], i, nodeList.length) === true) {
                  break;
                }
              }
            }
          };

          var throwError = function throwError(message) {
            return console.error("[scroll-lock] ".concat(message));
          };

          var arrayAsSelector = function arrayAsSelector(array) {
            if (Array.isArray(array)) {
              var selector = array.join(', ');
              return selector;
            }
          };

          var nodeListAsArray = function nodeListAsArray(nodeList) {
            var nodes = [];
            eachNode(nodeList, function (node) {
              return nodes.push(node);
            });
            return nodes;
          };

          var findParentBySelector = function findParentBySelector($el, selector) {
            var self = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var $root = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;

            if (self && nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) !== -1) {
              return $el;
            }

            while (($el = $el.parentElement) && nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) === -1) {
            }

            return $el;
          };

          var elementHasSelector = function elementHasSelector($el, selector) {
            var $root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
            var has = nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) !== -1;
            return has;
          };

          var elementHasOverflowHidden = function elementHasOverflowHidden($el) {
            if ($el) {
              var computedStyle = getComputedStyle($el);
              var overflowIsHidden = computedStyle.overflow === 'hidden';
              return overflowIsHidden;
            }
          };

          var elementScrollTopOnStart = function elementScrollTopOnStart($el) {
            if ($el) {
              if (elementHasOverflowHidden($el)) {
                return true;
              }

              var scrollTop = $el.scrollTop;
              return scrollTop <= 0;
            }
          };

          var elementScrollTopOnEnd = function elementScrollTopOnEnd($el) {
            if ($el) {
              if (elementHasOverflowHidden($el)) {
                return true;
              }

              var scrollTop = $el.scrollTop;
              var scrollHeight = $el.scrollHeight;
              var scrollTopWithHeight = scrollTop + $el.offsetHeight;
              return scrollTopWithHeight >= scrollHeight;
            }
          };

          var elementScrollLeftOnStart = function elementScrollLeftOnStart($el) {
            if ($el) {
              if (elementHasOverflowHidden($el)) {
                return true;
              }

              var scrollLeft = $el.scrollLeft;
              return scrollLeft <= 0;
            }
          };

          var elementScrollLeftOnEnd = function elementScrollLeftOnEnd($el) {
            if ($el) {
              if (elementHasOverflowHidden($el)) {
                return true;
              }

              var scrollLeft = $el.scrollLeft;
              var scrollWidth = $el.scrollWidth;
              var scrollLeftWithWidth = scrollLeft + $el.offsetWidth;
              return scrollLeftWithWidth >= scrollWidth;
            }
          };

          var elementIsScrollableField = function elementIsScrollableField($el) {
            var selector = 'textarea, [contenteditable="true"]';
            return elementHasSelector($el, selector);
          };

          var elementIsInputRange = function elementIsInputRange($el) {
            var selector = 'input[type="range"]';
            return elementHasSelector($el, selector);
          }; // CONCATENATED MODULE: ./src/scroll-lock.js

          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "disablePageScroll", function () {
            return disablePageScroll;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "enablePageScroll", function () {
            return enablePageScroll;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "getScrollState", function () {
            return getScrollState;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "clearQueueScrollLocks", function () {
            return clearQueueScrollLocks;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "getTargetScrollBarWidth", function () {
            return scroll_lock_getTargetScrollBarWidth;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "getCurrentTargetScrollBarWidth", function () {
            return scroll_lock_getCurrentTargetScrollBarWidth;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "getPageScrollBarWidth", function () {
            return getPageScrollBarWidth;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "getCurrentPageScrollBarWidth", function () {
            return getCurrentPageScrollBarWidth;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "addScrollableTarget", function () {
            return scroll_lock_addScrollableTarget;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "removeScrollableTarget", function () {
            return scroll_lock_removeScrollableTarget;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "addScrollableSelector", function () {
            return scroll_lock_addScrollableSelector;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "removeScrollableSelector", function () {
            return scroll_lock_removeScrollableSelector;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "addLockableTarget", function () {
            return scroll_lock_addLockableTarget;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "addLockableSelector", function () {
            return scroll_lock_addLockableSelector;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "setFillGapMethod", function () {
            return scroll_lock_setFillGapMethod;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "addFillGapTarget", function () {
            return scroll_lock_addFillGapTarget;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "removeFillGapTarget", function () {
            return scroll_lock_removeFillGapTarget;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "addFillGapSelector", function () {
            return scroll_lock_addFillGapSelector;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "removeFillGapSelector", function () {
            return scroll_lock_removeFillGapSelector;
          });
          /* harmony export (binding) */


          __webpack_require__.d(__webpack_exports__, "refillGaps", function () {
            return refillGaps;
          });

          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              var ownKeys = Object.keys(source);

              if (typeof Object.getOwnPropertySymbols === 'function') {
                ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
                  return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                }));
              }

              ownKeys.forEach(function (key) {
                _defineProperty(target, key, source[key]);
              });
            }

            return target;
          }

          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
              });
            } else {
              obj[key] = value;
            }

            return obj;
          }

          var FILL_GAP_AVAILABLE_METHODS = ['padding', 'margin', 'width', 'max-width', 'none'];
          var TOUCH_DIRECTION_DETECT_OFFSET = 3;
          var state = {
            scroll: true,
            queue: 0,
            scrollableSelectors: ['[data-scroll-lock-scrollable]'],
            lockableSelectors: ['body', '[data-scroll-lock-lockable]'],
            fillGapSelectors: ['body', '[data-scroll-lock-fill-gap]', '[data-scroll-lock-lockable]'],
            fillGapMethod: FILL_GAP_AVAILABLE_METHODS[0],
            //
            startTouchY: 0,
            startTouchX: 0
          };

          var disablePageScroll = function disablePageScroll(target) {
            if (state.queue <= 0) {
              state.scroll = false;
              scroll_lock_hideLockableOverflow();
              fillGaps();
            }

            scroll_lock_addScrollableTarget(target);
            state.queue++;
          };

          var enablePageScroll = function enablePageScroll(target) {
            state.queue > 0 && state.queue--;

            if (state.queue <= 0) {
              state.scroll = true;
              scroll_lock_showLockableOverflow();
              unfillGaps();
            }

            scroll_lock_removeScrollableTarget(target);
          };

          var getScrollState = function getScrollState() {
            return state.scroll;
          };

          var clearQueueScrollLocks = function clearQueueScrollLocks() {
            state.queue = 0;
          };

          var scroll_lock_getTargetScrollBarWidth = function getTargetScrollBarWidth($target) {
            var onlyExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (isElement($target)) {
              var currentOverflowYProperty = $target.style.overflowY;

              if (onlyExists) {
                if (!getScrollState()) {
                  $target.style.overflowY = $target.getAttribute('data-scroll-lock-saved-overflow-y-property');
                }
              } else {
                $target.style.overflowY = 'scroll';
              }

              var width = scroll_lock_getCurrentTargetScrollBarWidth($target);
              $target.style.overflowY = currentOverflowYProperty;
              return width;
            } else {
              return 0;
            }
          };

          var scroll_lock_getCurrentTargetScrollBarWidth = function getCurrentTargetScrollBarWidth($target) {
            if (isElement($target)) {
              if ($target === document.body) {
                var documentWidth = document.documentElement.clientWidth;
                var windowWidth = window.innerWidth;
                var currentWidth = windowWidth - documentWidth;
                return currentWidth;
              } else {
                var borderLeftWidthCurrentProperty = $target.style.borderLeftWidth;
                var borderRightWidthCurrentProperty = $target.style.borderRightWidth;
                $target.style.borderLeftWidth = '0px';
                $target.style.borderRightWidth = '0px';

                var _currentWidth = $target.offsetWidth - $target.clientWidth;

                $target.style.borderLeftWidth = borderLeftWidthCurrentProperty;
                $target.style.borderRightWidth = borderRightWidthCurrentProperty;
                return _currentWidth;
              }
            } else {
              return 0;
            }
          };

          var getPageScrollBarWidth = function getPageScrollBarWidth() {
            var onlyExists = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            return scroll_lock_getTargetScrollBarWidth(document.body, onlyExists);
          };

          var getCurrentPageScrollBarWidth = function getCurrentPageScrollBarWidth() {
            return scroll_lock_getCurrentTargetScrollBarWidth(document.body);
          };

          var scroll_lock_addScrollableTarget = function addScrollableTarget(target) {
            if (target) {
              var targets = argumentAsArray(target);
              targets.map(function ($targets) {
                eachNode($targets, function ($target) {
                  if (isElement($target)) {
                    $target.setAttribute('data-scroll-lock-scrollable', '');
                  } else {
                    throwError("\"".concat($target, "\" is not a Element."));
                  }
                });
              });
            }
          };

          var scroll_lock_removeScrollableTarget = function removeScrollableTarget(target) {
            if (target) {
              var targets = argumentAsArray(target);
              targets.map(function ($targets) {
                eachNode($targets, function ($target) {
                  if (isElement($target)) {
                    $target.removeAttribute('data-scroll-lock-scrollable');
                  } else {
                    throwError("\"".concat($target, "\" is not a Element."));
                  }
                });
              });
            }
          };

          var scroll_lock_addScrollableSelector = function addScrollableSelector(selector) {
            if (selector) {
              var selectors = argumentAsArray(selector);
              selectors.map(function (selector) {
                state.scrollableSelectors.push(selector);
              });
            }
          };

          var scroll_lock_removeScrollableSelector = function removeScrollableSelector(selector) {
            if (selector) {
              var selectors = argumentAsArray(selector);
              selectors.map(function (selector) {
                state.scrollableSelectors = state.scrollableSelectors.filter(function (sSelector) {
                  return sSelector !== selector;
                });
              });
            }
          };

          var scroll_lock_addLockableTarget = function addLockableTarget(target) {
            if (target) {
              var targets = argumentAsArray(target);
              targets.map(function ($targets) {
                eachNode($targets, function ($target) {
                  if (isElement($target)) {
                    $target.setAttribute('data-scroll-lock-lockable', '');
                  } else {
                    throwError("\"".concat($target, "\" is not a Element."));
                  }
                });
              });

              if (!getScrollState()) {
                scroll_lock_hideLockableOverflow();
              }
            }
          };

          var scroll_lock_addLockableSelector = function addLockableSelector(selector) {
            if (selector) {
              var selectors = argumentAsArray(selector);
              selectors.map(function (selector) {
                state.lockableSelectors.push(selector);
              });

              if (!getScrollState()) {
                scroll_lock_hideLockableOverflow();
              }

              scroll_lock_addFillGapSelector(selector);
            }
          };

          var scroll_lock_setFillGapMethod = function setFillGapMethod(method) {
            if (method) {
              if (FILL_GAP_AVAILABLE_METHODS.indexOf(method) !== -1) {
                state.fillGapMethod = method;
                refillGaps();
              } else {
                var methods = FILL_GAP_AVAILABLE_METHODS.join(', ');
                throwError("\"".concat(method, "\" method is not available!\nAvailable fill gap methods: ").concat(methods, "."));
              }
            }
          };

          var scroll_lock_addFillGapTarget = function addFillGapTarget(target) {
            if (target) {
              var targets = argumentAsArray(target);
              targets.map(function ($targets) {
                eachNode($targets, function ($target) {
                  if (isElement($target)) {
                    $target.setAttribute('data-scroll-lock-fill-gap', '');

                    if (!state.scroll) {
                      scroll_lock_fillGapTarget($target);
                    }
                  } else {
                    throwError("\"".concat($target, "\" is not a Element."));
                  }
                });
              });
            }
          };

          var scroll_lock_removeFillGapTarget = function removeFillGapTarget(target) {
            if (target) {
              var targets = argumentAsArray(target);
              targets.map(function ($targets) {
                eachNode($targets, function ($target) {
                  if (isElement($target)) {
                    $target.removeAttribute('data-scroll-lock-fill-gap');

                    if (!state.scroll) {
                      scroll_lock_unfillGapTarget($target);
                    }
                  } else {
                    throwError("\"".concat($target, "\" is not a Element."));
                  }
                });
              });
            }
          };

          var scroll_lock_addFillGapSelector = function addFillGapSelector(selector) {
            if (selector) {
              var selectors = argumentAsArray(selector);
              selectors.map(function (selector) {
                if (state.fillGapSelectors.indexOf(selector) === -1) {
                  state.fillGapSelectors.push(selector);

                  if (!state.scroll) {
                    scroll_lock_fillGapSelector(selector);
                  }
                }
              });
            }
          };

          var scroll_lock_removeFillGapSelector = function removeFillGapSelector(selector) {
            if (selector) {
              var selectors = argumentAsArray(selector);
              selectors.map(function (selector) {
                state.fillGapSelectors = state.fillGapSelectors.filter(function (fSelector) {
                  return fSelector !== selector;
                });

                if (!state.scroll) {
                  scroll_lock_unfillGapSelector(selector);
                }
              });
            }
          };

          var refillGaps = function refillGaps() {
            if (!state.scroll) {
              fillGaps();
            }
          };

          var scroll_lock_hideLockableOverflow = function hideLockableOverflow() {
            var selector = arrayAsSelector(state.lockableSelectors);
            scroll_lock_hideLockableOverflowSelector(selector);
          };

          var scroll_lock_showLockableOverflow = function showLockableOverflow() {
            var selector = arrayAsSelector(state.lockableSelectors);
            scroll_lock_showLockableOverflowSelector(selector);
          };

          var scroll_lock_hideLockableOverflowSelector = function hideLockableOverflowSelector(selector) {
            var $targets = document.querySelectorAll(selector);
            eachNode($targets, function ($target) {
              scroll_lock_hideLockableOverflowTarget($target);
            });
          };

          var scroll_lock_showLockableOverflowSelector = function showLockableOverflowSelector(selector) {
            var $targets = document.querySelectorAll(selector);
            eachNode($targets, function ($target) {
              scroll_lock_showLockableOverflowTarget($target);
            });
          };

          var scroll_lock_hideLockableOverflowTarget = function hideLockableOverflowTarget($target) {
            if (isElement($target) && $target.getAttribute('data-scroll-lock-locked') !== 'true') {
              var computedStyle = window.getComputedStyle($target);
              $target.setAttribute('data-scroll-lock-saved-overflow-y-property', computedStyle.overflowY);
              $target.setAttribute('data-scroll-lock-saved-inline-overflow-property', $target.style.overflow);
              $target.setAttribute('data-scroll-lock-saved-inline-overflow-y-property', $target.style.overflowY);
              $target.style.overflow = 'hidden';
              $target.setAttribute('data-scroll-lock-locked', 'true');
            }
          };

          var scroll_lock_showLockableOverflowTarget = function showLockableOverflowTarget($target) {
            if (isElement($target) && $target.getAttribute('data-scroll-lock-locked') === 'true') {
              $target.style.overflow = $target.getAttribute('data-scroll-lock-saved-inline-overflow-property');
              $target.style.overflowY = $target.getAttribute('data-scroll-lock-saved-inline-overflow-y-property');
              $target.removeAttribute('data-scroll-lock-saved-overflow-property');
              $target.removeAttribute('data-scroll-lock-saved-inline-overflow-property');
              $target.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
              $target.removeAttribute('data-scroll-lock-locked');
            }
          };

          var fillGaps = function fillGaps() {
            state.fillGapSelectors.map(function (selector) {
              scroll_lock_fillGapSelector(selector);
            });
          };

          var unfillGaps = function unfillGaps() {
            state.fillGapSelectors.map(function (selector) {
              scroll_lock_unfillGapSelector(selector);
            });
          };

          var scroll_lock_fillGapSelector = function fillGapSelector(selector) {
            var $targets = document.querySelectorAll(selector);
            var isLockable = state.lockableSelectors.indexOf(selector) !== -1;
            eachNode($targets, function ($target) {
              scroll_lock_fillGapTarget($target, isLockable);
            });
          };

          var scroll_lock_fillGapTarget = function fillGapTarget($target) {
            var isLockable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (isElement($target)) {
              var scrollBarWidth;

              if ($target.getAttribute('data-scroll-lock-lockable') === '' || isLockable) {
                scrollBarWidth = scroll_lock_getTargetScrollBarWidth($target, true);
              } else {
                var $lockableParent = findParentBySelector($target, arrayAsSelector(state.lockableSelectors));
                scrollBarWidth = scroll_lock_getTargetScrollBarWidth($lockableParent, true);
              }

              if ($target.getAttribute('data-scroll-lock-filled-gap') === 'true') {
                scroll_lock_unfillGapTarget($target);
              }

              var computedStyle = window.getComputedStyle($target);
              $target.setAttribute('data-scroll-lock-filled-gap', 'true');
              $target.setAttribute('data-scroll-lock-current-fill-gap-method', state.fillGapMethod);

              if (state.fillGapMethod === 'margin') {
                var currentMargin = parseFloat(computedStyle.marginRight);
                $target.style.marginRight = "".concat(currentMargin + scrollBarWidth, "px");
              } else if (state.fillGapMethod === 'width') {
                $target.style.width = "calc(100% - ".concat(scrollBarWidth, "px)");
              } else if (state.fillGapMethod === 'max-width') {
                $target.style.maxWidth = "calc(100% - ".concat(scrollBarWidth, "px)");
              } else if (state.fillGapMethod === 'padding') {
                var currentPadding = parseFloat(computedStyle.paddingRight);
                $target.style.paddingRight = "".concat(currentPadding + scrollBarWidth, "px");
              }
            }
          };

          var scroll_lock_unfillGapSelector = function unfillGapSelector(selector) {
            var $targets = document.querySelectorAll(selector);
            eachNode($targets, function ($target) {
              scroll_lock_unfillGapTarget($target);
            });
          };

          var scroll_lock_unfillGapTarget = function unfillGapTarget($target) {
            if (isElement($target)) {
              if ($target.getAttribute('data-scroll-lock-filled-gap') === 'true') {
                var currentFillGapMethod = $target.getAttribute('data-scroll-lock-current-fill-gap-method');
                $target.removeAttribute('data-scroll-lock-filled-gap');
                $target.removeAttribute('data-scroll-lock-current-fill-gap-method');

                if (currentFillGapMethod === 'margin') {
                  $target.style.marginRight = "";
                } else if (currentFillGapMethod === 'width') {
                  $target.style.width = "";
                } else if (currentFillGapMethod === 'max-width') {
                  $target.style.maxWidth = "";
                } else if (currentFillGapMethod === 'padding') {
                  $target.style.paddingRight = "";
                }
              }
            }
          };

          var onResize = function onResize(e) {
            refillGaps();
          };

          var onTouchStart = function onTouchStart(e) {
            if (!state.scroll) {
              state.startTouchY = e.touches[0].clientY;
              state.startTouchX = e.touches[0].clientX;
            }
          };

          var scroll_lock_onTouchMove = function onTouchMove(e) {
            if (!state.scroll) {
              var startTouchY = state.startTouchY,
                  startTouchX = state.startTouchX;
              var currentClientY = e.touches[0].clientY;
              var currentClientX = e.touches[0].clientX;

              if (e.touches.length < 2) {
                var selector = arrayAsSelector(state.scrollableSelectors);
                var direction = {
                  up: startTouchY < currentClientY,
                  down: startTouchY > currentClientY,
                  left: startTouchX < currentClientX,
                  right: startTouchX > currentClientX
                };
                var directionWithOffset = {
                  up: startTouchY + TOUCH_DIRECTION_DETECT_OFFSET < currentClientY,
                  down: startTouchY - TOUCH_DIRECTION_DETECT_OFFSET > currentClientY,
                  left: startTouchX + TOUCH_DIRECTION_DETECT_OFFSET < currentClientX,
                  right: startTouchX - TOUCH_DIRECTION_DETECT_OFFSET > currentClientX
                };

                var handle = function handle($el) {
                  var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                  if ($el) {
                    var parentScrollableEl = findParentBySelector($el, selector, false);

                    if (elementIsInputRange($el)) {
                      return false;
                    }

                    if (skip || elementIsScrollableField($el) && findParentBySelector($el, selector) || elementHasSelector($el, selector)) {
                      var prevent = false;

                      if (elementScrollLeftOnStart($el) && elementScrollLeftOnEnd($el)) {
                        if (direction.up && elementScrollTopOnStart($el) || direction.down && elementScrollTopOnEnd($el)) {
                          prevent = true;
                        }
                      } else if (elementScrollTopOnStart($el) && elementScrollTopOnEnd($el)) {
                        if (direction.left && elementScrollLeftOnStart($el) || direction.right && elementScrollLeftOnEnd($el)) {
                          prevent = true;
                        }
                      } else if (directionWithOffset.up && elementScrollTopOnStart($el) || directionWithOffset.down && elementScrollTopOnEnd($el) || directionWithOffset.left && elementScrollLeftOnStart($el) || directionWithOffset.right && elementScrollLeftOnEnd($el)) {
                        prevent = true;
                      }

                      if (prevent) {
                        if (parentScrollableEl) {
                          handle(parentScrollableEl, true);
                        } else {
                          if (e.cancelable) {
                            e.preventDefault();
                          }
                        }
                      }
                    } else {
                      handle(parentScrollableEl);
                    }
                  } else {
                    if (e.cancelable) {
                      e.preventDefault();
                    }
                  }
                };

                handle(e.target);
              }
            }
          };

          var onTouchEnd = function onTouchEnd(e) {
            if (!state.scroll) {
              state.startTouchY = 0;
              state.startTouchX = 0;
            }
          };

          if (typeof window !== 'undefined') {
            window.addEventListener('resize', onResize);
          }

          if (typeof document !== 'undefined') {
            document.addEventListener('touchstart', onTouchStart);
            document.addEventListener('touchmove', scroll_lock_onTouchMove, {
              passive: false
            });
            document.addEventListener('touchend', onTouchEnd);
          }

          var deprecatedMethods = {
            hide: function hide(target) {
              throwError('"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget');
              disablePageScroll(target);
            },
            show: function show(target) {
              throwError('"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget');
              enablePageScroll(target);
            },
            toggle: function toggle(target) {
              throwError('"toggle" is deprecated! Do not use it.');

              if (getScrollState()) {
                disablePageScroll();
              } else {
                enablePageScroll(target);
              }
            },
            getState: function getState() {
              throwError('"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate');
              return getScrollState();
            },
            getWidth: function getWidth() {
              throwError('"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth');
              return getPageScrollBarWidth();
            },
            getCurrentWidth: function getCurrentWidth() {
              throwError('"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth');
              return getCurrentPageScrollBarWidth();
            },
            setScrollableTargets: function setScrollableTargets(target) {
              throwError('"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget');
              scroll_lock_addScrollableTarget(target);
            },
            setFillGapSelectors: function setFillGapSelectors(selector) {
              throwError('"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector');
              scroll_lock_addFillGapSelector(selector);
            },
            setFillGapTargets: function setFillGapTargets(target) {
              throwError('"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget');
              scroll_lock_addFillGapTarget(target);
            },
            clearQueue: function clearQueue() {
              throwError('"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks');
              clearQueueScrollLocks();
            }
          };

          var scrollLock = _objectSpread({
            disablePageScroll: disablePageScroll,
            enablePageScroll: enablePageScroll,
            getScrollState: getScrollState,
            clearQueueScrollLocks: clearQueueScrollLocks,
            getTargetScrollBarWidth: scroll_lock_getTargetScrollBarWidth,
            getCurrentTargetScrollBarWidth: scroll_lock_getCurrentTargetScrollBarWidth,
            getPageScrollBarWidth: getPageScrollBarWidth,
            getCurrentPageScrollBarWidth: getCurrentPageScrollBarWidth,
            addScrollableSelector: scroll_lock_addScrollableSelector,
            removeScrollableSelector: scroll_lock_removeScrollableSelector,
            addScrollableTarget: scroll_lock_addScrollableTarget,
            removeScrollableTarget: scroll_lock_removeScrollableTarget,
            addLockableSelector: scroll_lock_addLockableSelector,
            addLockableTarget: scroll_lock_addLockableTarget,
            addFillGapSelector: scroll_lock_addFillGapSelector,
            removeFillGapSelector: scroll_lock_removeFillGapSelector,
            addFillGapTarget: scroll_lock_addFillGapTarget,
            removeFillGapTarget: scroll_lock_removeFillGapTarget,
            setFillGapMethod: scroll_lock_setFillGapMethod,
            refillGaps: refillGaps,
            _state: state
          }, deprecatedMethods);
          /* harmony default export */


          var scroll_lock = __webpack_exports__["default"] = scrollLock;
          /***/
        }
        /******/
        ])["default"]
      );
    });
  });
  var scrollLock$1 = unwrapExports(scrollLock);

  var breakpoints = {
    'xl-min': 1440,
    'lg-max': 1439,
    'lg-min': 1367,
    'md-max': 1366,
    'md-min': 1201,
    'sm-max': 1200,
    'sm-mid': 1023,
    'sm-min': 768,
    'xs-max': 767,
    'xs-min': 640,
    '2xs-max': 639,
    '2xs-min': 480,
    '3xs-max': 479,
    '3xs-min': 380,
    '4xs-max': 379,
    '4xs-min': 0
  };

  var toggleAccordionGroup = function toggleAccordionGroup() {
    // accordion group
    Array.from(document.querySelectorAll('.js-accordion-group')).forEach(function (group) {
      if (!group.classList.contains('accordion-group-init')) {
        var allAccordions = group.querySelectorAll('.js-accordion-group__item');
        var allContents = group.querySelectorAll('.js-accordion-group__content');
        var allTogglers = group.querySelectorAll('.js-accordion-group__toggler');
        group.classList.add('accordion-group-init'); // перебор аккордионов в группе

        Array.from(allAccordions).forEach(function (accordion) {
          var content = accordion.querySelector('.js-accordion-group__content');
          var toggler = accordion.querySelector('.js-accordion-group__toggler');

          function closeContent() {
            content.style.height = '0';
          } // инициализация начального состояния


          accordion.classList.add('init-accordion');
          if (!accordion.classList.contains('open-accordion')) closeContent(); // переключение аккордиона

          toggler.addEventListener('click', function (e) {
            e.preventDefault(); // закрытие всех кроме активного аккордиона

            closeOtherAccordions(); // переключение аккордиона

            if (accordion.classList.contains('open-accordion')) {
              accordion.classList.remove('open-accordion');
              toggler.classList.remove('open-accordion');
              content.style.height = content.scrollHeight + 'px';
              if (requestAnimationFrame) requestAnimationFrame(closeContent);else setTimeout(closeContent);
            } else {
              content.style.height = content.scrollHeight + 'px';
              toggler.classList.add('open-accordion');
              setTimeout(function () {
                accordion.classList.add('open-accordion');
              }, 300);
            }
          }); // закрытие неактивных аккардионов в группе

          function closeOtherAccordions() {
            Array.from(not(allTogglers, toggler)).forEach(function (accordion) {
              accordion.classList.remove('open-accordion');
            });
            Array.from(not(allAccordions, accordion)).forEach(function (accordion) {
              accordion.classList.remove('open-accordion');
            });
            Array.from(not(allContents, content)).forEach(function (content) {
              content.style.height = '0';
            });
          }
        });
      }
    }); // вернет список без исключеного элемента

    function not($list, $element) {
      var list = Array.from($list);
      var index = list.indexOf($element);

      if (!index) {
        return list.slice(++index);
      } else {
        return list.slice(0, index).concat(list.slice(++index));
      }
    }
  };

  var toggleAccordion = function toggleAccordion() {
    // accordion
    var accordionAll = document.querySelectorAll('.js-accordion');
    Array.from(accordionAll).forEach(function (accordion) {
      if (!accordion.classList.contains('init-accordion')) {
        var closeContent = function closeContent() {
          content.style.height = '0';
        }; // инициализация начального состояния


        var content = accordion.querySelector('.js-accordion__content');
        var toggles = accordion.querySelectorAll('.js-accordion__toggler');
        accordion.classList.add('init-accordion');

        if (content && !accordion.classList.contains('open-accordion')) {
          closeContent();
        }

        if (content && toggles) {
          var open = function open() {
            content.style.height = content.scrollHeight + 'px';
            toggles.forEach(function (toggler) {
              toggler.classList.add('open-accordion');
            });
            setTimeout(function () {
              accordion.classList.add('open-accordion');
            }, 300);
          }; // очистка высоты после завершения анимации открытия


          // переключение аккордиона
          toggles.forEach(function (toggler) {
            toggler.addEventListener('click', function (e) {
              e.preventDefault();

              if (accordion.classList.contains('open-accordion')) {
                accordion.classList.remove('open-accordion');
                toggler.classList.remove('open-accordion');
                content.style.height = content.scrollHeight + 'px'; // нужно для перерендеринга высоты контента

                content.scrollHeight;

                if (requestAnimationFrame) {
                  requestAnimationFrame(closeContent);
                } else {
                  setTimeout(closeContent);
                }
              } else {
                open();
              }
            });
          });
          dataStorage.set(accordion, 'open', open);
          content.addEventListener('transitionend', function (e) {
            if (accordion.classList.contains('open-accordion')) {
              content.style.height = null;
            }
          });
        }
      }
    });
  };

  var printContent = function printContent(scope) {
    if (!scope) {
      return;
    }

    var printButtons = scope.querySelectorAll('.js-print-content');

    if (!printButtons.length) {
      return;
    }

    printButtons.forEach(function (btn) {
      btn.removeEventListener('click', printTargetContent);
      btn.addEventListener('click', printTargetContent);
    });
  };

  function printTargetContent() {
    window.print();
  }

  // навешивание классов при при сдвиге скрола в начала и конец контейнера
  var scrollItems = function scrollItems() {
    Array.from(document.querySelectorAll('.js-scroll-block')).forEach(function (parent) {
      var list = parent.querySelector('.js-scroll-block__list');
      parent.classList.add('scroll-items-start');
      parent.classList.add('scroll-items-end');
      setClassScrollItems();
      list.removeEventListener('scroll', setClassScrollItems);
      list.addEventListener('scroll', setClassScrollItems);

      function setClassScrollItems() {
        if (list.scrollLeft == 0) {
          parent.classList.remove('scroll-items-start');
        } else {
          parent.classList.add('scroll-items-start');
        }

        if (list.scrollWidth == list.scrollLeft + list.clientWidth) {
          parent.classList.remove('scroll-items-end');
        } else {
          parent.classList.add('scroll-items-end');
        }
      }
    });
  };

  function animate(_ref) {
    var timing = _ref.timing,
        draw = _ref.draw,
        duration = _ref.duration;
    var start = performance.now();
    requestAnimationFrame(function animate(time) {
      // timeFraction изменяется от 0 до 1
      var timeFraction = (time - start) / duration;
      if (timeFraction > 1) timeFraction = 1; // вычисление текущего состояния анимации

      var progress = timing(timeFraction);
      draw(progress); // отрисовать её

      if (timeFraction < 1) {
        requestAnimationFrame(animate);
      }
    });
  }

  var scrollToBlock = function scrollToBlock() {
    // скролл к блоку по ссылке
    Array.from(document.querySelectorAll('.js-scroll-to')).forEach(function (item) {
      item.removeEventListener('click', scrollToBlock);
      item.addEventListener('click', scrollToBlock);

      function scrollToBlock(event) {
        event.preventDefault(); // величина недоезда блока до верха в атрибуте ссылки

        var offset = item.getAttribute('offset') || 0; // ID блока до, которого скролить

        var block = document.querySelector(item.getAttribute('href'));

        if (block) {
          var positionBlock = block.getBoundingClientRect().top - offset;
          animate({
            duration: 400,
            timing: function timing(timeFraction) {
              return timeFraction;
            },
            // линейная функция значит, что анимация идёт с одной и той же скоростью
            draw: function draw(progress) {
              document.documentElement.scrollTop += Math.round((block.getBoundingClientRect().top - offset) * progress);
            }
          });
        }
      }
    });
  };

  // показ зафиксированного блока
  function fixedBlockWhenScrollingVanilla(scope) {
    [].slice.apply(document.querySelectorAll('.js-fixed')).forEach(function (block, index) {
      var content = block.querySelector('.js-fixed__content');
      var blockHeight = block.offsetHeight;
      var blockStart = block.getBoundingClientRect().top + pageYOffset;
      var blockEnd = blockStart + blockHeight;
      var winWidth = document.documentElement.clientWidth;
      var newDocScroll = 0;
      block.classList.add('init-fixed');
      block.style.paddingTop = blockHeight + 'px';

      function fixedBlockIfScrollingUp() {
        newDocScroll = pageYOffset; // показ блока если сделан скролл страницы наверх

        if (!block.classList.contains('active-fixed') && blockEnd < newDocScroll) {
          block.classList.add('active-fixed');
          block.style.paddingTop = blockHeight + 'px';
        } else if (block.classList.contains('active-fixed') && blockStart >= newDocScroll) {
          // скрытие блока
          block.classList.remove('active-fixed');
        }
      } // инициализаци с индексом на случай множественных блоков для фиксации


      window.off('resize.fixedBlockIfScrollingUp' + index);
      window.on('resize.fixedBlockIfScrollingUp' + index, function () {
        if (winWidth != document.documentElement.clientWidth) {
          winWidth = document.documentElement.clientWidth;
          blockHeight = content.offsetHeight;
          blockStart = block.getBoundingClientRect().top + pageYOffset;
          block.style.paddingTop = blockHeight + 'px';
          if (requestAnimationFrame) requestAnimationFrame(fixedBlockIfScrollingUp);else fixedBlockIfScrollingUp();
        }
      }); // инициализаци с индексом на случай множественных блоков для фиксации

      document.off('scroll.fixedBlockIfScrollingUp' + index);
      document.on('scroll.fixedBlockIfScrollingUp' + index, function () {
        if (requestAnimationFrame) requestAnimationFrame(fixedBlockIfScrollingUp);else fixedBlockIfScrollingUp();
      });
      fixedBlockIfScrollingUp();
    });
  }

  var toggleTabs = function toggleTabs() {
    // переключение контента по табам нативный
    var parentsAll = document.querySelectorAll('.js-tabs'); // вернет список без исключеного элемента

    Array.from(parentsAll).forEach(function (parent) {
      if (!parent.classList.contains('init-tabs')) {
        var togglers = parent.querySelectorAll('.js-tabs__toggler');
        var tabs = parent.querySelectorAll('.js-tabs__tab'); // инициализация и закрытие всех табов при загрузке, кроме того что с классом active-tab

        parent.classList.add('init-tabs');
        Array.from(tabs).forEach(function (tab) {
          if (!tab.classList.contains('active-tab')) {
            tab.hidden = true;
          }
        });
        Array.from(togglers).forEach(function (toggler) {
          // обработка переключения таба
          toggler.addEventListener('click', function (e) {
            e.preventDefault(); // индекс нажатого таба

            var indexTab = toggler.getAttribute('data-tabs-item'); // активация переключателя при совпадении с индексом переключателя

            Array.from(togglers).forEach(function (togglerItem) {
              togglerItem.classList.remove('active-tab');
            });
            toggler.classList.add('active-tab'); // открытие таба при совпадении с индексом переключателя

            Array.from(tabs).forEach(function (tab) {
              if (tab.getAttribute('data-tabs-item') === indexTab) {
                tab.classList.add('active-tab');
                tab.hidden = false;
              } else {
                tab.classList.remove('active-tab');
                tab.hidden = true;
              }
            });
          });
        });
      }
    });
  };



  var locals = /*#__PURE__*/Object.freeze({
    __proto__: null,
    stikyBlock: fixedBlockWhenScrollingVanilla,
    toggleAccordionGroup: toggleAccordionGroup,
    toggleAccordion: toggleAccordion,
    printContent: printContent,
    scrollItems: scrollItems,
    scrollToBlock: scrollToBlock,
    toggleTabs: toggleTabs
  });

  var focus = function focus() {
    document.addEventListener('keydown', function (e) {
      if (e.keyCode == 9) {
        document.body.classList.add('state--focus-enabled');
      }
    });
    document.addEventListener('mousedown', function () {
      document.body.classList.remove('state--focus-enabled');
    });
  };

  function debounce(callback, wait) {
    var timeoutId = null;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(function () {
        callback.apply(null, args);
      }, wait);
    };
  }

  var scrollTop = function scrollTop() {
    var btn = document.getElementById('scrollTopButton');

    if (btn) {
      btn.addEventListener('click', function () {
        return window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
      window.addEventListener('scroll', debounce(function () {
        return btn.classList[window.pageYOffset < window.innerHeight ? 'add' : 'remove']('hidden');
      }, 50));
    }
  };

  var toggleClassBlock = function toggleClassBlock() {
    // переключение класса по клику
    toggleClassBlock.arrClasses = [];
    var allParents = document.querySelectorAll('.js-class');
    Array.from(allParents).forEach(function (parent) {
      // кастомный класс для переключения либо дефолтный
      var activeClass = parent.getAttribute('data-class') || 'active-class';
      var toggler = parent.querySelector('.js-class__toggler');
      toggler.removeEventListener('click', toggleClassBlockCallback);
      toggler.addEventListener('click', toggleClassBlockCallback);

      function toggleClassBlockCallback(event) {
        event.preventDefault();
        controller.closeAll();

        if (!parent.classList.contains(activeClass)) {
          parent.classList.add(activeClass);
          document.body.classList.add(activeClass);
        } else {
          parent.classList.remove(activeClass);
          document.body.classList.remove(activeClass);
        }
      } // закрытие по клику вне блока


      document.addEventListener('click', function (e) {
        if (!parent.contains(e.target)) {
          parent.classList.remove(activeClass);
          document.body.classList.remove(activeClass);
        }
      });
    });
  };

  var viewportSize = function viewportSize() {
    var initHandler = function initHandler() {
      document.body.style.cssText = "--vw: ".concat(document.body.clientWidth, "px");
      window.addEventListener('resize', function () {
        document.body.style.cssText = "--vw: ".concat(document.body.clientWidth, "px");
      });
    };

    if (document.body) {
      initHandler();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initHandler();
      });
    }
  };



  var globals = /*#__PURE__*/Object.freeze({
    __proto__: null,
    focus: focus,
    scrollTop: scrollTop,
    toggleClassBlock: toggleClassBlock,
    viewportSize: viewportSize
  });

  var view = {
    initAllGlobal: function initAllGlobal() {
      if (globals) {
        for (var fn in globals) {
          if (typeof globals[fn] === 'function') {
            globals[fn]();
          }
        }
      }
    },
    initAllLocal: function initAllLocal(scope) {
      if (locals) {
        for (var fn in locals) {
          if (typeof locals[fn] === 'function') {
            locals[fn](scope);
          }
        }
      }
    }
  };

  // полифил методотов on off аналогов jquery
  var events$1 = {
    on: function on(event, cb, opts) {
      // save the namespaces on the DOM element itself
      if (!this.namespaces) {
        this.namespaces = {};
      }

      this.namespaces[event] = cb;
      var options = opts || false;
      this.addEventListener(event.split('.')[0], cb, options);
      return this;
    },
    off: function off(event) {
      var _this$namespaces;

      if (this !== null && this !== void 0 && (_this$namespaces = this.namespaces) !== null && _this$namespaces !== void 0 && _this$namespaces[event]) {
        this.removeEventListener(event.split('.')[0], this.namespaces[event]);
        delete this.namespaces[event];
        return this;
      }
    }
  }; // Extend the DOM with these above custom methods

  window.on = document.on = Element.prototype.on = events$1.on;
  window.off = document.off = Element.prototype.off = events$1.off;
  window.dataStorage = {
    _storage: new WeakMap(),
    set: function set(element, key, obj) {
      if (!this._storage.has(element)) {
        this._storage.set(element, new Map());
      }

      this._storage.get(element).set(key, obj);
    },
    get: function get(element, key) {
      if (!this._storage.get(element)) {
        return;
      }

      return this._storage.get(element).get(key);
    },
    has: function has(element, key) {
      return this._storage.has(element) && this._storage.get(element).has(key);
    },
    remove: function remove(element, key) {
      var ret = this._storage.get(element).delete(key);

      if (!this._storage.get(element).size === 0) {
        this._storage.delete(element);
      }

      return ret;
    }
  };

  var controller = new Vue({
    store: store,
    data: function data() {
      return {
        touch: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        passiveEventsSupported: function () {
          // passive event listeners support test from MDN
          var result = false;

          try {
            window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
              get: function get() {
                result = true;
              }
            }));
          } catch (err) {}

          return result;
        }(),
        mobileNavData: []
      };
    },
    methods: {
      lockScrolling: function lockScrolling() {
        var scrollWidth = window.innerWidth - document.body.clientWidth;
        document.body.style.paddingRight = scrollWidth + 'px';

        if (window.offsetWidth < breakpoints['sm-max']) {
          document.querySelectorAll('.page-header').style.paddingRight = scrollWidth + 'px';
          scrollLock$1.disablePageScroll(document.querySelectorAll('.modal__surface'));
        }

        document.body.classList.add('state--lock');
      },
      unlockScrolling: function unlockScrolling() {
        document.body.style.paddingRight = '';

        if (window.offsetWidth < breakpoints['sm-max']) {
          document.querySelectorAll('.page-header').style.paddingRight = '';
          scrollLock$1.enablePageScroll(document.querySelectorAll('.modal__surface'));
        }

        document.body.classList.remove('state--lock');
      },
      openMobileNav: function openMobileNav() {
        this.$emit('mobile-nav-open');
      },
      closeMobileNav: function closeMobileNav() {
        this.$emit('mobile-nav-close');
      },
      updateMobileNav: function updateMobileNav(data) {
        this.mobileNavData.push(data);
        this.$emit('mobile-nav-updated', this.mobileNavData);
      },
      openCatalogAside: function openCatalogAside() {
        document.body.classList.add('state--catalog-aside-open');
      },
      closeCatalogAside: function closeCatalogAside() {
        document.body.classList.remove('state--catalog-aside-open');
      },
      openSearchPopup: function openSearchPopup() {
        this.closeAll();
        this.$emit('search-popup-open', {});
      },
      closeSearchPopup: function closeSearchPopup() {
        this.$emit('search-popup-close', {});
      },
      openSearchSmall: function openSearchSmall() {
        this.$emit('search-small-open');
      },
      closeSearchSmall: function closeSearchSmall() {
        this.$emit('search-small-close');
      },
      openQuestionPopup: function openQuestionPopup() {
        this.closeAll();
        this.$emit('question-popup-open', {});
      },
      closeQuestionPopup: function closeQuestionPopup() {
        this.$emit('question-popup-close', {});
      },
      openUserSmall: function openUserSmall() {
        this.closeAll();
        this.$emit('user-small-open', {});
      },
      closeUserSmall: function closeUserSmall() {
        this.$emit('user-small-close', {});
      },
      basketUpdate: function basketUpdate() {
        this.$emit('basket-update', {});
      },
      clearCompare: function clearCompare() {
        this.$emit('clear-compare');
      },
      addCompareMax: function addCompareMax() {
        this.$emit('add-compare-max');
      },
      addCompareItem: function addCompareItem(options) {
        this.$emit('add-compare-item', options);
      },
      removeCompareItem: function removeCompareItem(options) {
        this.$emit('remove-compare-item', options);
      },
      removeCompany: function removeCompany(options) {
        this.$emit('remove-company', options);
      },
      openModal: function openModal(options) {
        if (window.modalController) {
          window.modalController.open(options);
        }
      },
      closeModal: function closeModal(options) {
        if (window.modalController) {
          window.modalController.close();
        }
      },
      closeAllModals: function closeAllModals(options) {
        if (window.modalController) {
          window.modalController.closeAll();
        }
      },
      closeAll: function closeAll() {
        this.closeMobileNav();
        this.closeCatalogAside();
        this.closeSearchSmall();
        this.closeAllModals();
        this.closeUserSmall();
      }
    },
    created: function created() {
      var _this = this;

      document.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
          _this.closeAll();
        }
      });
      var overlay = document.querySelector('.js-overlay');

      if (overlay) {
        overlay.addEventListener('click', function (e) {
          _this.closeAll();
        });
      }

      view.initAllGlobal();
      view.initAllLocal(document.body);
    }
  });

  var basket = {
    namespaced: true,
    state: {
      bxajaxid: null,
      remote: null,
      link: null,
      items: [],
      loading: false
    },
    getters: {
      basketItems: function basketItems(state) {
        return state.items;
      },
      basketPrice: function basketPrice(state) {
        if (state.items && state.items.length) {
          var value = state.items.reduce(function (summ, item) {
            try {
              return summ + item.price.current.value;
            } catch (e) {
              return summ;
            }
          }, 0);
          var currency;

          try {
            currency = state.items[0].price.current.currency;
          } catch (e) {
            currency = null;
          }

          return {
            current: {
              value: value,
              currency: currency
            }
          };
        } else {
          return null;
        }
      },
      basketLink: function basketLink(state) {
        return state.link;
      },
      basketEmpty: function basketEmpty(state) {
        return !state.items || !state.items.length;
      },
      basketLoading: function basketLoading(state) {
        return state.loading;
      },
      basketCount: function basketCount(state) {
        var count = state.items.length > 99 ? '99+' : state.items.length;
        return state.items.length ? count : 0;
      },
      basketCountByItemFull: function basketCountByItemFull(state) {
        return function (_ref) {
          var id = _ref.id;
          var result = state.items.find(function (item) {
            return item.id === id;
          });
          return result ? result.count : 0;
        };
      }
    },
    mutations: {
      set: function set(state, data) {
        if (data.bxajaxid) {
          state.bxajaxid = data.bxajaxid;
        }

        if (data.remote) {
          state.remote = data.remote;
        }

        if (data.link) {
          state.link = data.link;
        }

        if (data.items) {
          state.items = data.items;
        }
      },
      setLoading: function setLoading(state, value) {
        state.loading = value;
      }
    },
    actions: {
      request: function request(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var formattedData, makeFormData, response, data;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  context.commit('setLoading', true); // convert any options.data to transfer as FormData

                  formattedData = new FormData();

                  if (options instanceof FormData) {
                    formattedData = options;
                  } else if (options) {
                    makeFormData = function makeFormData(data, parentKey) {
                      if (data && _typeof(data) === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                        Object.keys(data).forEach(function (key) {
                          makeFormData(data[key], parentKey ? "".concat(parentKey, "[").concat(key, "]") : key);
                        });
                      } else {
                        formattedData.append(parentKey, data == null ? '' : data);
                      }
                    };

                    makeFormData(options);
                  }

                  formattedData.set('bxajaxid', context.state.bxajaxid);
                  _context.next = 6;
                  return fetch(context.state.remote, {
                    method: 'POST',
                    // headers: {
                    // 	'Content-Type': 'application/json'
                    // },
                    body: formattedData
                  });

                case 6:
                  response = _context.sent;
                  data = {};

                  if (response.ok) {
                    _context.next = 12;
                    break;
                  }

                  console.warn('[vuex] basket: AJAX request failed', response);
                  _context.next = 21;
                  break;

                case 12:
                  _context.next = 14;
                  return response.json();

                case 14:
                  data = _context.sent;
                  console.log('[vuex] basket: loaded', data);
                  context.commit('set', data);

                  if (data.modal) {
                    controller.openModal({
                      url: data.modal,
                      className: 'modal--sm'
                    });
                  }

                  if (data.redirect) {
                    window.location.href = data.redirect;
                  }

                  if (data.reload) {
                    window.location.reload(true);
                  }

                  if (data.ecommerce) {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push(data.ecommerce);
                  }

                case 21:
                  if (data.redirect) {
                    document.location.href = data.redirect;
                  }

                  if (!data.redirect && !data.reload) {
                    context.commit('setLoading', false);
                  }

                case 23:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      add: function add(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _options$action;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", context.dispatch('request', {
                    action: (_options$action = options.action) !== null && _options$action !== void 0 ? _options$action : 'add',
                    id: options.id,
                    basketId: options.basketId,
                    giftId: options.giftId,
                    priceId: options.priceId,
                    typeClient: options.typeClient,
                    typeTel: options.typeTel,
                    typePricePeriod: options.typePricePeriod,
                    count: options.count,
                    preorder: options.preorder
                  }));

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      remove: function remove(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", context.dispatch('request', {
                    action: 'remove',
                    id: options.id,
                    basketId: options.basketId,
                    giftId: options.giftId,
                    priceId: options.priceId,
                    typeClient: options.typeClient,
                    typeTel: options.typeTel,
                    typePricePeriod: options.typePricePeriod,
                    count: options.count
                  }));

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },
      update: function update(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", context.dispatch('request', {
                    action: 'update',
                    id: options.id,
                    basketId: options.basketId,
                    giftId: options.giftId,
                    priceId: options.priceId,
                    typeClient: options.typeClient,
                    typeTel: options.typeTel,
                    typePricePeriod: options.typePricePeriod,
                    count: options.count
                  }));

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      }
    }
  };

  var compare = {
    namespaced: true,
    state: {
      bxajaxid: null,
      remote: null,
      link: null,
      activeCategoryId: null,
      items: [],
      loading: false
    },
    getters: {
      compareEmpty: function compareEmpty(state) {
        return !state.items || !state.items.length;
      },
      compareCount: function compareCount(state, getters) {
        return state.items ? getters.currentItems.length : 0;
      },
      comparePresentByItem: function comparePresentByItem(state) {
        return function (id) {
          var result = state.items.find(function (item) {
            return item.activeOfferId === id;
          });
          return !!result;
        };
      },
      currentItems: function currentItems(state) {
        return state.items.filter(function (item) {
          return item.categoryId === state.activeCategoryId;
        });
      },
      link: function link(state) {
        return state.link;
      }
    },
    mutations: {
      set: function set(state, data) {
        if (data.bxajaxid) {
          state.bxajaxid = data.bxajaxid;
        }

        if (data.remote) {
          state.remote = data.remote;
        }

        if (data.link) {
          state.link = data.link;
        }

        if (data.activeCategoryId) {
          state.activeCategoryId = data.activeCategoryId;
        }

        if (data.items) {
          state.items = data.items;
        }
      },
      setLoading: function setLoading(state, value) {
        state.loading = value;
      }
    },
    actions: {
      request: function request(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var response, data;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  context.commit('setLoading', true);
                  _context.next = 3;
                  return fetch(context.state.remote, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(_objectSpread2(_objectSpread2({}, options), {}, {
                      bxajaxid: context.state.bxajaxid
                    }))
                  });

                case 3:
                  response = _context.sent;

                  if (response.ok) {
                    _context.next = 8;
                    break;
                  }

                  console.warn('[vuex] compare: AJAX request failed', response);
                  _context.next = 13;
                  break;

                case 8:
                  _context.next = 10;
                  return response.json();

                case 10:
                  data = _context.sent;
                  console.log('[vuex] compare: loaded', data);
                  context.commit('set', data);

                case 13:
                  context.commit('setLoading', false);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      add: function add(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", context.dispatch('request', {
                    action: 'addcompare',
                    id: options.id
                  }));

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      remove: function remove(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", context.dispatch('request', {
                    action: 'removecompare',
                    id: options.id
                  }));

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }
    }
  };

  var user = {
    namespaced: true,
    state: {
      bxajaxid: null,
      remote: null,
      linkProfile: null,
      id: null,
      name: null,
      signIn: null,
      authorised: false,
      unpList: [],
      unpObjList: [],
      unpActive: null,
      loading: false
    },
    getters: {
      userUnpList: function userUnpList(state) {
        return state.unpList;
      },
      userUnpObjList: function userUnpObjList(state) {
        return state.unpObjList;
      },
      userUnpActive: function userUnpActive(state) {
        return state.unpActive;
      },
      userSignIn: function userSignIn(state) {
        return state.signIn;
      },
      authorised: function authorised(state) {
        return state.authorised;
      }
    },
    mutations: {
      set: function set(state, data) {
        if (data.bxajaxid) {
          state.bxajaxid = data.bxajaxid;
        }

        if (data.remote) {
          state.remote = data.remote;
        }

        if (data.linkProfile) {
          state.linkProfile = data.linkProfile;
        }

        if (data.id) {
          state.id = data.id;
        }

        if (data.name) {
          state.name = data.name;
        }

        if (data.unpActive) {
          state.unpActive = data.unpActive; // если UNP новый то добляем его в список

          if (!~state.unpList.indexOf(data.unpActive)) {
            state.unpList.push(data.unpActive);
          }
        }

        if (data.unpList) {
          state.unpList = data.unpList;
        }

        if (data.authorised) {
          state.authorised = data.authorised;
        }

        if (data.unpObjList) {
          state.unpObjList = data.unpObjList;
        }
      },
      setLoading: function setLoading(state, value) {
        state.loading = value;
      }
    },
    actions: {
      request: function request(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var response;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  context.commit('setLoading', true);
                  _context.next = 3;
                  return fetch(context.state.remote, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(_objectSpread2(_objectSpread2({}, options), {}, {
                      bxajaxid: context.state.bxajaxid
                    }))
                  });

                case 3:
                  response = _context.sent;

                  if (!response.ok) {
                    console.warn('[vuex] user: AJAX request failed', response);
                  } else {
                    console.log('[vuex] user: loaded', data);
                    context.commit('set', data);
                  }

                  context.commit('setLoading', false);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      add: function add(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  context.dispatch('request', {
                    action: 'add',
                    id: options.id,
                    count: options.count
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      remove: function remove(context, options) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  context.dispatch('request', {
                    action: 'remove',
                    id: options.id
                  });

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }
    }
  };

  Vue.use(index$2);
  var store = new index$2.Store({
    modules: {
      basket: basket,
      compare: compare,
      user: user
    }
  });

  var script = {
    render: function render() {
      return this.$scopedSlots.default({});
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  /* script */
  const __vue_script__ = script;

  /* template */

    /* style */
    const __vue_inject_styles__ = undefined;
    /* scoped */
    const __vue_scope_id__ = undefined;
    /* module identifier */
    const __vue_module_identifier__ = undefined;
    /* functional template */
    const __vue_is_functional_template__ = undefined;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__ = /*#__PURE__*/normalizeComponent(
      {},
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1 = {
    props: {
      dataSource: {
        type: [Object, String],
        default: null
      },
      bxajaxid: {
        type: String,
        default: null
      }
    },
    render: function render() {
      return null;
    }
  };

  /* script */
  const __vue_script__$1 = script$1;

  /* template */

    /* style */
    const __vue_inject_styles__$1 = undefined;
    /* scoped */
    const __vue_scope_id__$1 = undefined;
    /* module identifier */
    const __vue_module_identifier__$1 = undefined;
    /* functional template */
    const __vue_is_functional_template__$1 = undefined;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
      {},
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1,
      __vue_module_identifier__$1,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$2 = {
    data: function data() {
      return {
        // bxajaxid which is finally computed after processing props and slots
        localBxajaxid: null,
        // loading state
        loading: false
      };
    },
    props: {
      // link to load data from (String)
      // or data object itself (Object)
      dataSource: {
        default: undefined
      },
      // Bitrix component id
      // required by Bitrix to determine component instance for AJAX requests
      // (dataSource link often simpty refers to page containing multiple components)
      bxajaxid: {
        default: undefined
      },
      // immediately load data on "created" hook
      // if dataSource is a link
      loadOnInit: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      dataSet: function dataSet(data, options) {
        console.info("".concat(this.$options.name, ": warning: v-source-mixin is used but dataSet is not implemented in your component"), data);
      },
      dataLoad: function dataLoad() {
        var _arguments = arguments,
            _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var options, dataSetOptions, formattedData, makeFormData, delayPromise, requestPromise;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                  dataSetOptions = _arguments.length > 1 ? _arguments[1] : undefined;
                  // use this.loading to set preloaders if needed
                  _this.loading = true; // check arguments

                  if (!options || _typeof(options) !== 'object' || !options.url) {
                    console.warn('${this.$options.name}: warning: dataLoad options arg is wrong', options);
                  } // convert any options.data to transfer as FormData


                  formattedData = new FormData();

                  if (options.data instanceof FormData) {
                    formattedData = options.data;
                  } else if (options.data) {
                    makeFormData = function makeFormData(data, parentKey) {
                      if (data && _typeof(data) === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                        Object.keys(data).forEach(function (key) {
                          makeFormData(data[key], parentKey ? "".concat(parentKey, "[").concat(key, "]") : key);
                        });
                      } else {
                        formattedData.append(parentKey, data == null ? '' : data);
                      }
                    };

                    makeFormData(options.data);
                  } // set bxajaxid if present


                  if (_this.localBxajaxid) {
                    formattedData.set('bxajaxid', _this.localBxajaxid);
                  } // set min delay to ensure preloader fadein/fadeout plays fine (<transition name="fade"> speed is 250ms)


                  delayPromise = new Promise(function (resolve) {
                    options.delay ? setTimeout(resolve, 250) : resolve();
                  }); // create request

                  requestPromise = fetch(options.url, {
                    method: 'POST',
                    // headers: {
                    // 	//'Content-Type': 'application/json',
                    // 	'Content-Type': 'application/x-www-form-urlencoded',
                    // },
                    body: formattedData
                  }); // wait for both promises

                  Promise.all([requestPromise, delayPromise]).then(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 1),
                        response = _ref2[0];

                    if (!response.ok) {
                      console.warn("".concat(_this.$options.name, ": AJAX request failed"), response);
                      _this.loading = false;
                    } else {
                      response.json().then(function (data) {
                        console.log("".concat(_this.$options.name, ": AJAX request completed"), data);

                        if (data.ddl) {
                          window.dataLayer = [];
                          dataLayer.push(data.ddl);
                        }

                        if (data.redirect) {
                          window.location.href = data.redirect;
                        }

                        if (data.reload) {
                          window.location.reload(true);
                        }

                        if (data.ecommerce) {
                          window.dataLayer = window.dataLayer || [];
                          dataLayer.push(data.ecommerce);
                        }

                        if (data.modal) {
                          controller.openModal(_objectSpread2({
                            url: data.modal
                          }, data.modalData));
                        }

                        _this.dataSet(data, dataSetOptions);

                        if (!data.redirect && !data.reload) {
                          _this.loading = false;
                        }
                      });
                    }
                  });

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      init: function init(bxajaxid, dataSource) {
        if (typeof bxajaxid !== 'undefined') {
          this.localBxajaxid = bxajaxid;
        }

        if (typeof dataSource === 'string') {
          if (this.loadOnInit) {
            this.dataLoad({
              url: dataSource
            });
          }
        } else if (typeof dataSource !== 'undefined') {
          this.dataSet(dataSource);
        }
      }
    },
    watch: {
      dataSource: function dataSource(newValue, oldValue) {
        // try to load using props
        this.init(this.bxajaxid, this.dataSource);
      }
    },
    created: function created() {
      var _this2 = this;

      // try to load using props
      this.init(this.bxajaxid, this.dataSource); // try to load using slots

      if (this.$slots['source']) {
        this.$slots['source'].forEach(function (item) {
          var bxajaxid = item.componentOptions.propsData.bxajaxid;
          var dataSource = item.componentOptions.propsData.dataSource;

          _this2.init(bxajaxid, dataSource);
        });
      }
    }
  };

  /* script */
  const __vue_script__$2 = script$2;

  /* template */

    /* style */
    const __vue_inject_styles__$2 = undefined;
    /* scoped */
    const __vue_scope_id__$2 = undefined;
    /* module identifier */
    const __vue_module_identifier__$2 = undefined;
    /* functional template */
    const __vue_is_functional_template__$2 = undefined;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
      {},
      __vue_inject_styles__$2,
      __vue_script__$2,
      __vue_scope_id__$2,
      __vue_is_functional_template__$2,
      __vue_module_identifier__$2,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$3 = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        catalog: null
      };
    },
    render: function render() {
      return '';
    },
    methods: {
      dataSet: function dataSet(data) {
        if (data.type === 'basket') {
          this.$store.commit('basket/set', data);
        }

        if (data.type === 'compare') {
          this.$store.commit('compare/set', data);
        }

        if (data.type === 'user') {
          this.$store.commit('user/set', data);
        }
      }
    }
  };

  /* script */
  const __vue_script__$3 = script$3;

  /* template */

    /* style */
    const __vue_inject_styles__$3 = undefined;
    /* scoped */
    const __vue_scope_id__$3 = undefined;
    /* module identifier */
    const __vue_module_identifier__$3 = undefined;
    /* functional template */
    const __vue_is_functional_template__$3 = undefined;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
      {},
      __vue_inject_styles__$3,
      __vue_script__$3,
      __vue_scope_id__$3,
      __vue_is_functional_template__$3,
      __vue_module_identifier__$3,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  var script$4 = {
    props: {
      loading: {
        type: Boolean,
        default: false
      }
    }
  };

  /* script */
  const __vue_script__$4 = script$4;

  /* template */
  var __vue_render__ = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-loader loader",
        class: { "loader--active": _vm.loading },
      },
      [_vm._m(0)]
    )
  };
  var __vue_staticRenderFns__ = [
    function () {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", { staticClass: "loader__container" }, [
        _c("div", { staticClass: "loader__icon-wrap" }, [
          _c("div", { staticClass: "loader__icon loader__icon--main" }),
          _c("div", { staticClass: "loader__icon loader__icon--additional" }),
        ]),
      ])
    },
  ];
  __vue_render__._withStripped = true;

    /* style */
    const __vue_inject_styles__$4 = undefined;
    /* scoped */
    const __vue_scope_id__$4 = undefined;
    /* module identifier */
    const __vue_module_identifier__$4 = undefined;
    /* functional template */
    const __vue_is_functional_template__$4 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__$4,
      __vue_script__$4,
      __vue_scope_id__$4,
      __vue_is_functional_template__$4,
      __vue_module_identifier__$4,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  var script$5 = {
    data: function data() {
      return {
        loaded: false
      };
    },
    props: {
      loading: {
        type: String,
        default: 'lazy'
      },
      src: {
        type: String,
        default: null
      },
      sources: {
        type: Array,
        default: null
      },
      alt: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      }
    },
    computed: {
      computedSrcset: function computedSrcset() {
        if (!this.sources || !this.sources.length) {
          return this.src;
        } else {
          return this.sources.map(function (item) {
            return "".concat(item.src, " ").concat(item.size);
          }).join(', ');
        }
      }
    },
    methods: {
      handleLoad: function handleLoad() {
        this.loaded = true;
        this.$emit('load');
      }
    },
    mounted: function mounted() {
      if (this.$el.complete) {
        this.handleLoad();
      } else {
        this.$el.addEventListener('load', this.handleLoad);
      }
    }
  };

  /* script */
  const __vue_script__$5 = script$5;

  /* template */
  var __vue_render__$1 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("img", {
      staticClass: "v-image image",
      class: { "image--loading": !_vm.loaded },
      attrs: {
        src: _vm.src,
        srcset: _vm.computedSrcset,
        alt: _vm.alt,
        title: _vm.title || _vm.alt,
        loading: _vm.loading,
      },
    })
  };
  var __vue_staticRenderFns__$1 = [];
  __vue_render__$1._withStripped = true;

    /* style */
    const __vue_inject_styles__$5 = undefined;
    /* scoped */
    const __vue_scope_id__$5 = undefined;
    /* module identifier */
    const __vue_module_identifier__$5 = undefined;
    /* functional template */
    const __vue_is_functional_template__$5 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
      __vue_inject_styles__$5,
      __vue_script__$5,
      __vue_scope_id__$5,
      __vue_is_functional_template__$5,
      __vue_module_identifier__$5,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  var script$6 = {
    data: function data() {
      return {
        player: null
      };
    },
    props: {
      src: {
        type: String,
        default: null
      },
      poster: {
        type: String,
        default: null
      }
    },
    methods: {
      pauseVideo: function pauseVideo() {
        this.$el.pause();
      }
    },
    created: function created() {
      this.$on('pause-video', this.pauseVideo);
    }
  };

  /* script */
  const __vue_script__$6 = script$6;

  /* template */
  var __vue_render__$2 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "video",
      {
        staticClass: "v-video video",
        attrs: { controls: "controls", poster: _vm.poster },
      },
      [
        _c("source", {
          staticClass: "video__source",
          attrs: { src: _vm.src, type: "video/mp4" },
        }),
      ]
    )
  };
  var __vue_staticRenderFns__$2 = [];
  __vue_render__$2._withStripped = true;

    /* style */
    const __vue_inject_styles__$6 = undefined;
    /* scoped */
    const __vue_scope_id__$6 = undefined;
    /* module identifier */
    const __vue_module_identifier__$6 = undefined;
    /* functional template */
    const __vue_is_functional_template__$6 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
      __vue_inject_styles__$6,
      __vue_script__$6,
      __vue_scope_id__$6,
      __vue_is_functional_template__$6,
      __vue_module_identifier__$6,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$7 = {
    data: function data() {
      return {
        child: null
      };
    },
    props: {
      component: {
        type: String
      }
    },
    mounted: function mounted() {
      try {
        var _template = this.$el.getElementsByClassName('lazy-component__template')[0].innerHTML;
        var time = new Date();
        var random = Math.round(Math.random() * 10000);
        var comp = new (Vue.component('lazy-' + time.getMilliseconds() + '-' + random, {
          parent: this,
          template: _template
        }))();
        comp.$mount(this.$el.getElementsByClassName('lazy-component__body')[0]);
        this.child = comp;
      } catch (error) {
        console.warn('v-lazy-component: child component initialization error', error);
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.child.$destroy();
      this.$forceUpdate();
    }
  };

  /* script */
  const __vue_script__$7 = script$7;

  /* template */
  var __vue_render__$3 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-lazy-component lazy-component" }, [
      _c("div", { staticClass: "lazy-component__body" }),
      _c(
        "div",
        { staticClass: "lazy-component__template" },
        [_vm._t("default")],
        2
      ),
    ])
  };
  var __vue_staticRenderFns__$3 = [];
  __vue_render__$3._withStripped = true;

    /* style */
    const __vue_inject_styles__$7 = undefined;
    /* scoped */
    const __vue_scope_id__$7 = undefined;
    /* module identifier */
    const __vue_module_identifier__$7 = undefined;
    /* functional template */
    const __vue_is_functional_template__$7 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
      __vue_inject_styles__$7,
      __vue_script__$7,
      __vue_scope_id__$7,
      __vue_is_functional_template__$7,
      __vue_module_identifier__$7,
      false,
      undefined,
      undefined,
      undefined
    );

  var top = 'top';
  var bottom = 'bottom';
  var right = 'right';
  var left = 'left';
  var auto = 'auto';
  var basePlacements = [top, bottom, right, left];
  var start = 'start';
  var end = 'end';
  var clippingParents = 'clippingParents';
  var viewport = 'viewport';
  var popper = 'popper';
  var reference = 'reference';
  var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []); // modifiers that need to read the DOM

  var beforeRead = 'beforeRead';
  var read = 'read';
  var afterRead = 'afterRead'; // pure-logic modifiers

  var beforeMain = 'beforeMain';
  var main = 'main';
  var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

  var beforeWrite = 'beforeWrite';
  var write = 'write';
  var afterWrite = 'afterWrite';
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

  function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
  }

  function getWindow(node) {
    if (node == null) {
      return window;
    }

    if (node.toString() !== '[object Window]') {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView || window : window;
    }

    return node;
  }

  function isElement(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }

  function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }

  function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') {
      return false;
    }

    var OwnElement = getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
  }

  // and applies them to the HTMLElements such as popper and arrow

  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function (name) {
      var style = state.styles[name] || {};
      var attributes = state.attributes[name] || {};
      var element = state.elements[name]; // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe[cannot-write]


      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];

        if (value === false) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, value === true ? '' : value);
        }
      });
    });
  }

  function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }

    return function () {
      Object.keys(state.elements).forEach(function (name) {
        var element = state.elements[name];
        var attributes = state.attributes[name] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

        var style = styleProperties.reduce(function (style, property) {
          style[property] = '';
          return style;
        }, {}); // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        }

        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  } // eslint-disable-next-line import/no-unused-modules


  var applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: ['computeStyles']
  };

  function getBasePlacement(placement) {
    return placement.split('-')[0];
  }

  var max = Math.max;
  var min = Math.min;
  var round = Math.round;

  function getBoundingClientRect(element, includeScale) {
    if (includeScale === void 0) {
      includeScale = false;
    }

    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;

    if (isHTMLElement(element) && includeScale) {
      var offsetHeight = element.offsetHeight;
      var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
      // Fallback to 1 in case both values are `0`

      if (offsetWidth > 0) {
        scaleX = round(rect.width) / offsetWidth || 1;
      }

      if (offsetHeight > 0) {
        scaleY = round(rect.height) / offsetHeight || 1;
      }
    }

    return {
      width: rect.width / scaleX,
      height: rect.height / scaleY,
      top: rect.top / scaleY,
      right: rect.right / scaleX,
      bottom: rect.bottom / scaleY,
      left: rect.left / scaleX,
      x: rect.left / scaleX,
      y: rect.top / scaleY
    };
  }

  // means it doesn't take into account transforms.

  function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223

    var width = element.offsetWidth;
    var height = element.offsetHeight;

    if (Math.abs(clientRect.width - width) <= 1) {
      width = clientRect.width;
    }

    if (Math.abs(clientRect.height - height) <= 1) {
      height = clientRect.height;
    }

    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: width,
      height: height
    };
  }

  function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

    if (parent.contains(child)) {
      return true;
    } // then fallback to custom implementation with Shadow DOM support
    else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


    return false;
  }

  function getComputedStyle$1(element) {
    return getWindow(element).getComputedStyle(element);
  }

  function isTableElement(element) {
    return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
  }

  function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
    element.document) || window.document).documentElement;
  }

  function getParentNode(element) {
    if (getNodeName(element) === 'html') {
      return element;
    }

    return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
      // $FlowFixMe[incompatible-return]
      // $FlowFixMe[prop-missing]
      element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
      element.parentNode || ( // DOM Element detected
      isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
      // $FlowFixMe[incompatible-call]: HTMLElement is a Node
      getDocumentElement(element) // fallback

    );
  }

  function getTrueOffsetParent(element) {
    if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle$1(element).position === 'fixed') {
      return null;
    }

    return element.offsetParent;
  } // `.offsetParent` reports `null` for fixed elements, while absolute elements
  // return the containing block


  function getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
    var isIE = navigator.userAgent.indexOf('Trident') !== -1;

    if (isIE && isHTMLElement(element)) {
      // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
      var elementCss = getComputedStyle$1(element);

      if (elementCss.position === 'fixed') {
        return null;
      }
    }

    var currentNode = getParentNode(element);

    while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
      // create a containing block.
      // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

      if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }

    return null;
  } // Gets the closest ancestor positioned element. Handles some edge cases,
  // such as table ancestors and cross browser bugs.


  function getOffsetParent(element) {
    var window = getWindow(element);
    var offsetParent = getTrueOffsetParent(element);

    while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
      offsetParent = getTrueOffsetParent(offsetParent);
    }

    if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
      return window;
    }

    return offsetParent || getContainingBlock(element) || window;
  }

  function getMainAxisFromPlacement(placement) {
    return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
  }

  function within(min$1, value, max$1) {
    return max(min$1, min(value, max$1));
  }
  function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
  }

  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
  }

  function expandToHashMap(value, keys) {
    return keys.reduce(function (hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }

  var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
      placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  };

  function arrow(_ref) {
    var _state$modifiersData$;

    var state = _ref.state,
        name = _ref.name,
        options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left, right].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';

    if (!arrowElement || !popperOffsets) {
      return;
    }

    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top : left;
    var maxProp = axis === 'y' ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds

    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...

    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
  }

  function effect$1(_ref2) {
    var state = _ref2.state,
        options = _ref2.options;
    var _options$element = options.element,
        arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

    if (arrowElement == null) {
      return;
    } // CSS selector


    if (typeof arrowElement === 'string') {
      arrowElement = state.elements.popper.querySelector(arrowElement);

      if (!arrowElement) {
        return;
      }
    }

    {
      if (!isHTMLElement(arrowElement)) {
        console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
      }
    }

    if (!contains(state.elements.popper, arrowElement)) {
      {
        console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
      }

      return;
    }

    state.elements.arrow = arrowElement;
  } // eslint-disable-next-line import/no-unused-modules


  var arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$1,
    requires: ['popperOffsets'],
    requiresIfExists: ['preventOverflow']
  };

  function getVariation(placement) {
    return placement.split('-')[1];
  }

  var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }; // Round the offsets to the nearest suitable subpixel based on the DPR.
  // Zooming can change the DPR, but it seems to report a value that will
  // cleanly divide the values into the appropriate subpixels.

  function roundOffsetsByDPR(_ref) {
    var x = _ref.x,
        y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: round(x * dpr) / dpr || 0,
      y: round(y * dpr) / dpr || 0
    };
  }

  function mapToStyles(_ref2) {
    var _Object$assign2;

    var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        variation = _ref2.variation,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive,
        roundOffsets = _ref2.roundOffsets,
        isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x,
        x = _offsets$x === void 0 ? 0 : _offsets$x,
        _offsets$y = offsets.y,
        y = _offsets$y === void 0 ? 0 : _offsets$y;

    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };

    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left;
    var sideY = top;
    var win = window;

    if (adaptive) {
      var offsetParent = getOffsetParent(popper);
      var heightProp = 'clientHeight';
      var widthProp = 'clientWidth';

      if (offsetParent === getWindow(popper)) {
        offsetParent = getDocumentElement(popper);

        if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
          heightProp = 'scrollHeight';
          widthProp = 'scrollWidth';
        }
      } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


      offsetParent = offsetParent;

      if (placement === top || (placement === left || placement === right) && variation === end) {
        sideY = bottom;
        var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
        offsetParent[heightProp];
        y -= offsetY - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }

      if (placement === left || (placement === top || placement === bottom) && variation === end) {
        sideX = right;
        var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
        offsetParent[widthProp];
        x -= offsetX - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }

    var commonStyles = Object.assign({
      position: position
    }, adaptive && unsetSides);

    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };

    x = _ref4.x;
    y = _ref4.y;

    if (gpuAcceleration) {
      var _Object$assign;

      return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }

    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
  }

  function computeStyles(_ref5) {
    var state = _ref5.state,
        options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
        _options$roundOffsets = options.roundOffsets,
        roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

    {
      var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

      if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
        return transitionProperty.indexOf(property) >= 0;
      })) {
        console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
      }
    }

    var commonStyles = {
      placement: getBasePlacement(state.placement),
      variation: getVariation(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration: gpuAcceleration,
      isFixed: state.options.strategy === 'fixed'
    };

    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
      })));
    }

    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
      })));
    }

    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-placement': state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
  };

  var passive = {
    passive: true
  };

  function effect$2(_ref) {
    var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
    var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
    var window = getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.addEventListener('resize', instance.update, passive);
    }

    return function () {
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.removeEventListener('scroll', instance.update, passive);
        });
      }

      if (resize) {
        window.removeEventListener('resize', instance.update, passive);
      }
    };
  } // eslint-disable-next-line import/no-unused-modules


  var eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect$2,
    data: {}
  };

  var hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash$1[matched];
    });
  }

  var hash$2 = {
    start: 'end',
    end: 'start'
  };
  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function (matched) {
      return hash$2[matched];
    });
  }

  function getWindowScroll(node) {
    var win = getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }

  function getViewportRect(element) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.

    if (visualViewport) {
      width = visualViewport.width;
      height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
      // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
      // errors due to floating point numbers, so we need to check precision.
      // Safari returns a number <= 0, usually < -1 when pinch-zoomed
      // Feature detection fails in mobile emulation mode in Chrome.
      // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
      // 0.001
      // Fallback here: "Not Safari" userAgent

      if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }

    return {
      width: width,
      height: height,
      x: x + getWindowScrollBarX(element),
      y: y
    };
  }

  // of the `<html>` and `<body>` rect bounds if horizontally scrollable

  function getDocumentRect(element) {
    var _element$ownerDocumen;

    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;

    if (getComputedStyle$1(body || html).direction === 'rtl') {
      x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
    }

    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  }

  function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle$1(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;

    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }

  function getScrollParent(node) {
    if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return node.ownerDocument.body;
    }

    if (isHTMLElement(node) && isScrollParent(node)) {
      return node;
    }

    return getScrollParent(getParentNode(node));
  }

  /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */

  function listScrollParents(element, list) {
    var _element$ownerDocumen;

    if (list === void 0) {
      list = [];
    }

    var scrollParent = getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)));
  }

  function rectToClientRect(rect) {
    return Object.assign({}, rect, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }

  function getInnerBoundingClientRect(element) {
    var rect = getBoundingClientRect(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }

  function getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  } // A "clipping parent" is an overflowable container with the characteristic of
  // clipping (or hiding) overflowing elements with a position different from
  // `initial`


  function getClippingParents(element) {
    var clippingParents = listScrollParents(getParentNode(element));
    var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

    if (!isElement(clipperElement)) {
      return [];
    } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


    return clippingParents.filter(function (clippingParent) {
      return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
    });
  } // Gets the maximum area that the element is visible in due to any number of
  // clipping parents


  function getClippingRect(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent);
      accRect.top = max(rect.top, accRect.top);
      accRect.right = min(rect.right, accRect.right);
      accRect.bottom = min(rect.bottom, accRect.bottom);
      accRect.left = max(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }

  function computeOffsets(_ref) {
    var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;

    switch (basePlacement) {
      case top:
        offsets = {
          x: commonX,
          y: reference.y - element.height
        };
        break;

      case bottom:
        offsets = {
          x: commonX,
          y: reference.y + reference.height
        };
        break;

      case right:
        offsets = {
          x: reference.x + reference.width,
          y: commonY
        };
        break;

      case left:
        offsets = {
          x: reference.x - element.width,
          y: commonY
        };
        break;

      default:
        offsets = {
          x: reference.x,
          y: reference.y
        };
    }

    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

    if (mainAxis != null) {
      var len = mainAxis === 'y' ? 'height' : 'width';

      switch (variation) {
        case start:
          offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
          break;

        case end:
          offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
          break;
      }
    }

    return offsets;
  }

  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$placement = _options.placement,
        placement = _options$placement === void 0 ? state.placement : _options$placement,
        _options$boundary = _options.boundary,
        boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = getBoundingClientRect(state.elements.reference);
    var popperOffsets = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      strategy: 'absolute',
      placement: placement
    });
    var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect

    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

    if (elementContext === popper && offsetData) {
      var offset = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function (key) {
        var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
        overflowOffsets[key] += offset[axis] * multiply;
      });
    }

    return overflowOffsets;
  }

  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
      return getVariation(placement) === variation;
    }) : basePlacements;
    var allowedPlacements = placements$1.filter(function (placement) {
      return allowedAutoPlacements.indexOf(placement) >= 0;
    });

    if (allowedPlacements.length === 0) {
      allowedPlacements = placements$1;

      {
        console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
      }
    } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


    var overflows = allowedPlacements.reduce(function (acc, placement) {
      acc[placement] = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding
      })[getBasePlacement(placement)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function (a, b) {
      return overflows[a] - overflows[b];
    });
  }

  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement(placement) === auto) {
      return [];
    }

    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }

  function flip(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;

    if (state.modifiersData[name]._skip) {
      return;
    }

    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
      return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        flipVariations: flipVariations,
        allowedAutoPlacements: allowedAutoPlacements
      }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];

    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];

      var _basePlacement = getBasePlacement(placement);

      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
      var len = isVertical ? 'width' : 'height';
      var overflow = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        altBoundary: altBoundary,
        padding: padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }

      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];

      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }

      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }

      if (checks.every(function (check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }

      checksMap.set(placement, checks);
    }

    if (makeFallbackChecks) {
      // `2` may be desired in some cases – research later
      var numberOfChecks = flipVariations ? 3 : 1;

      var _loop = function _loop(_i) {
        var fittingPlacement = placements.find(function (placement) {
          var checks = checksMap.get(placement);

          if (checks) {
            return checks.slice(0, _i).every(function (check) {
              return check;
            });
          }
        });

        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };

      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);

        if (_ret === "break") break;
      }
    }

    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  } // eslint-disable-next-line import/no-unused-modules


  var flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: ['offset'],
    data: {
      _skip: false
    }
  };

  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }

    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }

  function isAnySideFullyClipped(overflow) {
    return [top, right, bottom, left].some(function (side) {
      return overflow[side] >= 0;
    });
  }

  function hide(_ref) {
    var state = _ref.state,
        name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
      referenceClippingOffsets: referenceClippingOffsets,
      popperEscapeOffsets: popperEscapeOffsets,
      isReferenceHidden: isReferenceHidden,
      hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-reference-hidden': isReferenceHidden,
      'data-popper-escaped': hasPopperEscaped
    });
  } // eslint-disable-next-line import/no-unused-modules


  var hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: hide
  };

  function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement(placement);
    var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
        skidding = _ref[0],
        distance = _ref[1];

    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left, right].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }

  function offset(_ref2) {
    var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
    var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function (acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;

    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var offset$1 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: offset
  };

  function popperOffsets(_ref) {
    var state = _ref.state,
        name = _ref.name; // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step

    state.modifiersData[name] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      strategy: 'absolute',
      placement: state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
  };

  function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
  }

  function preventOverflow(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
      placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
      mainAxis: tetherOffsetValue,
      altAxis: tetherOffsetValue
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
      x: 0,
      y: 0
    };

    if (!popperOffsets) {
      return;
    }

    if (checkMainAxis) {
      var _offsetModifierState$;

      var mainSide = mainAxis === 'y' ? top : left;
      var altSide = mainAxis === 'y' ? bottom : right;
      var len = mainAxis === 'y' ? 'height' : 'width';
      var offset = popperOffsets[mainAxis];
      var min$1 = offset + overflow[mainSide];
      var max$1 = offset - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
      // outside the reference bounds

      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
      // to include its full size in the calculation. If the reference is small
      // and near the edge of a boundary, the popper can overflow even if the
      // reference is not overflowing as well (e.g. virtual elements with no
      // width or height)

      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
      var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = offset + maxOffset - offsetModifierValue;
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _offsetModifierState$2;

      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _len = altAxis === 'y' ? 'height' : 'width';

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

      var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

      var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

      var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

      var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: ['offset']
  };

  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  function getNodeScroll(node) {
    if (node === getWindow(node) || !isHTMLElement(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }

  function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = round(rect.width) / element.offsetWidth || 1;
    var scaleY = round(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
  } // Returns the composite rect of an element relative to its offsetParent.
  // Composite means it takes into account transforms as well as layout.


  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }

    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };

    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }

      if (isHTMLElement(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent, true);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }

    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }

  function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function (modifier) {
      map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively

    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function (dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);

          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }

    modifiers.forEach(function (modifier) {
      if (!visited.has(modifier.name)) {
        // check for visited object
        sort(modifier);
      }
    });
    return result;
  }

  function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase

    return modifierPhases.reduce(function (acc, phase) {
      return acc.concat(orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }

  function debounce$1(fn) {
    var pending;
    return function () {
      if (!pending) {
        pending = new Promise(function (resolve) {
          Promise.resolve().then(function () {
            pending = undefined;
            resolve(fn());
          });
        });
      }

      return pending;
    };
  }

  function format(str) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return [].concat(args).reduce(function (p, c) {
      return p.replace(/%s/, c);
    }, str);
  }

  var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
  var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
  var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
  function validateModifiers(modifiers) {
    modifiers.forEach(function (modifier) {
      [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
      .filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).forEach(function (key) {
        switch (key) {
          case 'name':
            if (typeof modifier.name !== 'string') {
              console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
            }

            break;

          case 'enabled':
            if (typeof modifier.enabled !== 'boolean') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
            }

            break;

          case 'phase':
            if (modifierPhases.indexOf(modifier.phase) < 0) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
            }

            break;

          case 'fn':
            if (typeof modifier.fn !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'effect':
            if (modifier.effect != null && typeof modifier.effect !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'requires':
            if (modifier.requires != null && !Array.isArray(modifier.requires)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
            }

            break;

          case 'requiresIfExists':
            if (!Array.isArray(modifier.requiresIfExists)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
            }

            break;

          case 'options':
          case 'data':
            break;

          default:
            console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
              return "\"" + s + "\"";
            }).join(', ') + "; but \"" + key + "\" was provided.");
        }

        modifier.requires && modifier.requires.forEach(function (requirement) {
          if (modifiers.find(function (mod) {
            return mod.name === requirement;
          }) == null) {
            console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
          }
        });
      });
    });
  }

  function uniqueBy(arr, fn) {
    var identifiers = new Set();
    return arr.filter(function (item) {
      var identifier = fn(item);

      if (!identifiers.has(identifier)) {
        identifiers.add(identifier);
        return true;
      }
    });
  }

  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function (merged, current) {
      var existing = merged[current.name];
      merged[current.name] = existing ? Object.assign({}, existing, current, {
        options: Object.assign({}, existing.options, current.options),
        data: Object.assign({}, existing.data, current.data)
      }) : current;
      return merged;
    }, {}); // IE11 does not support Object.values

    return Object.keys(merged).map(function (key) {
      return merged[key];
    });
  }

  var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
  var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
  var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
  };

  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return !args.some(function (element) {
      return !(element && typeof element.getBoundingClientRect === 'function');
    });
  }

  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }

    var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var state = {
        placement: 'bottom',
        orderedModifiers: [],
        options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
        modifiersData: {},
        elements: {
          reference: reference,
          popper: popper
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance = {
        state: state,
        setOptions: function setOptions(setOptionsAction) {
          var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
          cleanupModifierEffects();
          state.options = Object.assign({}, defaultOptions, state.options, options);
          state.scrollParents = {
            reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
            popper: listScrollParents(popper)
          }; // Orders the modifiers based on their dependencies and `phase`
          // properties

          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

          state.orderedModifiers = orderedModifiers.filter(function (m) {
            return m.enabled;
          }); // Validate the provided modifiers so that the consumer will get warned
          // if one of the modifiers is invalid for any reason

          {
            var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
              var name = _ref.name;
              return name;
            });
            validateModifiers(modifiers);

            if (getBasePlacement(state.options.placement) === auto) {
              var flipModifier = state.orderedModifiers.find(function (_ref2) {
                var name = _ref2.name;
                return name === 'flip';
              });

              if (!flipModifier) {
                console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
              }
            }

            var _getComputedStyle = getComputedStyle$1(popper),
                marginTop = _getComputedStyle.marginTop,
                marginRight = _getComputedStyle.marginRight,
                marginBottom = _getComputedStyle.marginBottom,
                marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
            // cause bugs with positioning, so we'll warn the consumer


            if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
              return parseFloat(margin);
            })) {
              console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
            }
          }

          runModifierEffects();
          return instance.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }

          var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
          // anymore

          if (!areValidElements(reference, popper)) {
            {
              console.error(INVALID_ELEMENT_ERROR);
            }

            return;
          } // Store the reference and popper rects to be read by modifiers


          state.rects = {
            reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
            popper: getLayoutRect(popper)
          }; // Modifiers have the ability to reset the current update cycle. The
          // most common use case for this is the `flip` modifier changing the
          // placement, which then needs to re-run all the modifiers, because the
          // logic was previously ran for the previous placement and is therefore
          // stale/incorrect

          state.reset = false;
          state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
          // is filled with the initial data specified by the modifier. This means
          // it doesn't persist and is fresh on each update.
          // To ensure persistent data, use `${name}#persistent`

          state.orderedModifiers.forEach(function (modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });
          var __debug_loops__ = 0;

          for (var index = 0; index < state.orderedModifiers.length; index++) {
            {
              __debug_loops__ += 1;

              if (__debug_loops__ > 100) {
                console.error(INFINITE_LOOP_ERROR);
                break;
              }
            }

            if (state.reset === true) {
              state.reset = false;
              index = -1;
              continue;
            }

            var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
                name = _state$orderedModifie.name;

            if (typeof fn === 'function') {
              state = fn({
                state: state,
                options: _options,
                name: name,
                instance: instance
              }) || state;
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: debounce$1(function () {
          return new Promise(function (resolve) {
            instance.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };

      if (!areValidElements(reference, popper)) {
        {
          console.error(INVALID_ELEMENT_ERROR);
        }

        return instance;
      }

      instance.setOptions(options).then(function (state) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state);
        }
      }); // Modifiers have the ability to execute arbitrary code before the first
      // update cycle runs. They will be executed in the same order as the update
      // cycle. This is useful when a modifier adds some persistent data that
      // other modifiers need to use, but the modifier is run after the dependent
      // one.

      function runModifierEffects() {
        state.orderedModifiers.forEach(function (_ref3) {
          var name = _ref3.name,
              _ref3$options = _ref3.options,
              options = _ref3$options === void 0 ? {} : _ref3$options,
              effect = _ref3.effect;

          if (typeof effect === 'function') {
            var cleanupFn = effect({
              state: state,
              name: name,
              instance: instance,
              options: options
            });

            var noopFn = function noopFn() {};

            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }

      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function (fn) {
          return fn();
        });
        effectCleanupFns = [];
      }

      return instance;
    };
  }

  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
  var createPopper = /*#__PURE__*/popperGenerator({
    defaultModifiers: defaultModifiers
  }); // eslint-disable-next-line import/no-unused-modules

  /**!
  * tippy.js v6.3.7
  * (c) 2017-2021 atomiks
  * MIT License
  */
  var BOX_CLASS = "tippy-box";
  var CONTENT_CLASS = "tippy-content";
  var BACKDROP_CLASS = "tippy-backdrop";
  var ARROW_CLASS = "tippy-arrow";
  var SVG_ARROW_CLASS = "tippy-svg-arrow";
  var TOUCH_OPTIONS = {
    passive: true,
    capture: true
  };

  var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
  };

  function hasOwnProperty$1(obj, key) {
    return {}.hasOwnProperty.call(obj, key);
  }

  function getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
      var v = value[index];
      return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }

    return value;
  }

  function isType(value, type) {
    var str = {}.toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
  }

  function invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
  }

  function debounce$2(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) {
      return fn;
    }

    var timeout;
    return function (arg) {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn(arg);
      }, ms);
    };
  }

  function removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function (key) {
      delete clone[key];
    });
    return clone;
  }

  function splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
  }

  function normalizeToArray(value) {
    return [].concat(value);
  }

  function pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }

  function unique(arr) {
    return arr.filter(function (item, index) {
      return arr.indexOf(item) === index;
    });
  }

  function getBasePlacement$1(placement) {
    return placement.split('-')[0];
  }

  function arrayFrom(value) {
    return [].slice.call(value);
  }

  function removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function (acc, key) {
      if (obj[key] !== undefined) {
        acc[key] = obj[key];
      }

      return acc;
    }, {});
  }

  function div$1() {
    return document.createElement('div');
  }

  function isElement$1(value) {
    return ['Element', 'Fragment'].some(function (type) {
      return isType(value, type);
    });
  }

  function isNodeList(value) {
    return isType(value, 'NodeList');
  }

  function isMouseEvent(value) {
    return isType(value, 'MouseEvent');
  }

  function isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
  }

  function getArrayOfElements(value) {
    if (isElement$1(value)) {
      return [value];
    }

    if (isNodeList(value)) {
      return arrayFrom(value);
    }

    if (Array.isArray(value)) {
      return value;
    }

    return arrayFrom(document.querySelectorAll(value));
  }

  function setTransitionDuration(els, value) {
    els.forEach(function (el) {
      if (el) {
        el.style.transitionDuration = value + "ms";
      }
    });
  }

  function setVisibilityState(els, state) {
    els.forEach(function (el) {
      if (el) {
        el.setAttribute('data-state', state);
      }
    });
  }

  function getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;

    var _normalizeToArray = normalizeToArray(elementOrElements),
        element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
  }

  function isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX,
        clientY = event.clientY;
    return popperTreeData.every(function (_ref) {
      var popperRect = _ref.popperRect,
          popperState = _ref.popperState,
          props = _ref.props;
      var interactiveBorder = props.interactiveBorder;
      var basePlacement = getBasePlacement$1(popperState.placement);
      var offsetData = popperState.modifiersData.offset;

      if (!offsetData) {
        return true;
      }

      var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
      var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
      var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
      var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
      var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
      var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
      var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
      var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
      return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
  }

  function updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      box[method](event, listener);
    });
  }
  /**
   * Compared to xxx.contains, this function works for dom structures with shadow
   * dom
   */


  function actualContains(parent, child) {
    var target = child;

    while (target) {
      var _target$getRootNode;

      if (parent.contains(target)) {
        return true;
      }

      target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }

    return false;
  }

  var currentInput = {
    isTouch: false
  };
  var lastMouseMoveTime = 0;
  /**
   * When a `touchstart` event is fired, it's assumed the user is using touch
   * input. We'll bind a `mousemove` event listener to listen for mouse input in
   * the future. This way, the `isTouch` property is fully dynamic and will handle
   * hybrid devices that use a mix of touch + mouse input.
   */

  function onDocumentTouchStart() {
    if (currentInput.isTouch) {
      return;
    }

    currentInput.isTouch = true;

    if (window.performance) {
      document.addEventListener('mousemove', onDocumentMouseMove);
    }
  }
  /**
   * When two `mousemove` event are fired consecutively within 20ms, it's assumed
   * the user is using mouse input again. `mousemove` can fire on touch devices as
   * well, but very rarely that quickly.
   */


  function onDocumentMouseMove() {
    var now = performance.now();

    if (now - lastMouseMoveTime < 20) {
      currentInput.isTouch = false;
      document.removeEventListener('mousemove', onDocumentMouseMove);
    }

    lastMouseMoveTime = now;
  }
  /**
   * When an element is in focus and has a tippy, leaving the tab/window and
   * returning causes it to show again. For mouse users this is unexpected, but
   * for keyboard use it makes sense.
   * TODO: find a better technique to solve this problem
   */


  function onWindowBlur() {
    var activeElement = document.activeElement;

    if (isReferenceElement(activeElement)) {
      var instance = activeElement._tippy;

      if (activeElement.blur && !instance.state.isVisible) {
        activeElement.blur();
      }
    }
  }

  function bindGlobalEventListeners() {
    document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
    window.addEventListener('blur', onWindowBlur);
  }

  var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
  var isIE11 = isBrowser ? // @ts-ignore
  !!window.msCrypto : false;

  function createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
  }

  function clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
  }

  function getDevMessage(message) {
    return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
  }

  function getFormattedMessage(message) {
    return [getDevMessage(message), // title
    'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
    'line-height: 1.5', // footer
    'color: #a6a095;'];
  } // Assume warnings and errors never have the same message


  var visitedMessages;

  {
    resetVisitedMessages();
  }

  function resetVisitedMessages() {
    visitedMessages = new Set();
  }

  function warnWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
      var _console;

      visitedMessages.add(message);

      (_console = console).warn.apply(_console, getFormattedMessage(message));
    }
  }

  function errorWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
      var _console2;

      visitedMessages.add(message);

      (_console2 = console).error.apply(_console2, getFormattedMessage(message));
    }
  }

  function validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
    errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
  }

  var pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
  };
  var renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
  };
  var defaultProps = Object.assign({
    appendTo: TIPPY_DEFAULT_APPEND_TO,
    aria: {
      content: 'auto',
      expanded: 'auto'
    },
    delay: 0,
    duration: [300, 250],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [0, 10],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
  }, pluginProps, renderProps);
  var defaultKeys = Object.keys(defaultProps);

  var setDefaultProps = function setDefaultProps(partialProps) {
    /* istanbul ignore else */
    {
      validateProps(partialProps, []);
    }

    var keys = Object.keys(partialProps);
    keys.forEach(function (key) {
      defaultProps[key] = partialProps[key];
    });
  };

  function getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function (acc, plugin) {
      var name = plugin.name,
          defaultValue = plugin.defaultValue;

      if (name) {
        var _name;

        acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
      }

      return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
  }

  function getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
      plugins: plugins
    }))) : defaultKeys;
    var props = propKeys.reduce(function (acc, key) {
      var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

      if (!valueAsString) {
        return acc;
      }

      if (key === 'content') {
        acc[key] = valueAsString;
      } else {
        try {
          acc[key] = JSON.parse(valueAsString);
        } catch (e) {
          acc[key] = valueAsString;
        }
      }

      return acc;
    }, {});
    return props;
  }

  function evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
      content: invokeWithArgsOrReturn(props.content, [reference])
    }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, defaultProps.aria, out.aria);
    out.aria = {
      expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
      content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
  }

  function validateProps(partialProps, plugins) {
    if (partialProps === void 0) {
      partialProps = {};
    }

    if (plugins === void 0) {
      plugins = [];
    }

    var keys = Object.keys(partialProps);
    keys.forEach(function (prop) {
      var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
      var didPassUnknownProp = !hasOwnProperty$1(nonPluginProps, prop); // Check if the prop exists in `plugins`

      if (didPassUnknownProp) {
        didPassUnknownProp = plugins.filter(function (plugin) {
          return plugin.name === prop;
        }).length === 0;
      }

      warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
    });
  }

  var innerHTML = function innerHTML() {
    return 'innerHTML';
  };

  function dangerouslySetInnerHTML(element, html) {
    element[innerHTML()] = html;
  }

  function createArrowElement(value) {
    var arrow = div$1();

    if (value === true) {
      arrow.className = ARROW_CLASS;
    } else {
      arrow.className = SVG_ARROW_CLASS;

      if (isElement$1(value)) {
        arrow.appendChild(value);
      } else {
        dangerouslySetInnerHTML(arrow, value);
      }
    }

    return arrow;
  }

  function setContent(content, props) {
    if (isElement$1(props.content)) {
      dangerouslySetInnerHTML(content, '');
      content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
      if (props.allowHTML) {
        dangerouslySetInnerHTML(content, props.content);
      } else {
        content.textContent = props.content;
      }
    }
  }

  function getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = arrayFrom(box.children);
    return {
      box: box,
      content: boxChildren.find(function (node) {
        return node.classList.contains(CONTENT_CLASS);
      }),
      arrow: boxChildren.find(function (node) {
        return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
      }),
      backdrop: boxChildren.find(function (node) {
        return node.classList.contains(BACKDROP_CLASS);
      })
    };
  }

  function render(instance) {
    var popper = div$1();
    var box = div$1();
    box.className = BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = div$1();
    content.className = CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);

    function onUpdate(prevProps, nextProps) {
      var _getChildren = getChildren(popper),
          box = _getChildren.box,
          content = _getChildren.content,
          arrow = _getChildren.arrow;

      if (nextProps.theme) {
        box.setAttribute('data-theme', nextProps.theme);
      } else {
        box.removeAttribute('data-theme');
      }

      if (typeof nextProps.animation === 'string') {
        box.setAttribute('data-animation', nextProps.animation);
      } else {
        box.removeAttribute('data-animation');
      }

      if (nextProps.inertia) {
        box.setAttribute('data-inertia', '');
      } else {
        box.removeAttribute('data-inertia');
      }

      box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

      if (nextProps.role) {
        box.setAttribute('role', nextProps.role);
      } else {
        box.removeAttribute('role');
      }

      if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
        setContent(content, instance.props);
      }

      if (nextProps.arrow) {
        if (!arrow) {
          box.appendChild(createArrowElement(nextProps.arrow));
        } else if (prevProps.arrow !== nextProps.arrow) {
          box.removeChild(arrow);
          box.appendChild(createArrowElement(nextProps.arrow));
        }
      } else if (arrow) {
        box.removeChild(arrow);
      }
    }

    return {
      popper: popper,
      onUpdate: onUpdate
    };
  } // Runtime check to identify if the render function is the default one; this
  // way we can apply default CSS transitions logic and it can be tree-shaken away


  render.$$tippy = true;
  var idCounter = 1;
  var mouseMoveListeners = []; // Used by `hideAll()`

  var mountedInstances = [];

  function createTippy(reference, passedProps) {
    var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================

    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = debounce$2(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================

    var id = idCounter++;
    var popperInstance = null;
    var plugins = unique(props.plugins);
    var state = {
      // Is the instance currently enabled?
      isEnabled: true,
      // Is the tippy currently showing and not transitioning out?
      isVisible: false,
      // Has the instance been destroyed?
      isDestroyed: false,
      // Is the tippy currently mounted to the DOM?
      isMounted: false,
      // Has the tippy finished transitioning in?
      isShown: false
    };
    var instance = {
      // properties
      id: id,
      reference: reference,
      popper: div$1(),
      popperInstance: popperInstance,
      props: props,
      state: state,
      plugins: plugins,
      // methods
      clearDelayTimeouts: clearDelayTimeouts,
      setProps: setProps,
      setContent: setContent,
      show: show,
      hide: hide,
      hideWithInteractivity: hideWithInteractivity,
      enable: enable,
      disable: disable,
      unmount: unmount,
      destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser

    /* istanbul ignore if */

    if (!props.render) {
      {
        errorWhen(true, 'render() function has not been supplied.');
      }

      return instance;
    } // ===========================================================================
    // Initial mutations
    // ===========================================================================


    var _props$render = props.render(instance),
        popper = _props$render.popper,
        onUpdate = _props$render.onUpdate;

    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function (plugin) {
      return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [instance]);

    if (props.showOnCreate) {
      scheduleShow();
    } // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding


    popper.addEventListener('mouseenter', function () {
      if (instance.props.interactive && instance.state.isVisible) {
        instance.clearDelayTimeouts();
      }
    });
    popper.addEventListener('mouseleave', function () {
      if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
      }
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================

    function getNormalizedTouchSettings() {
      var touch = instance.props.touch;
      return Array.isArray(touch) ? touch : [touch, 0];
    }

    function getIsCustomTouchBehavior() {
      return getNormalizedTouchSettings()[0] === 'hold';
    }

    function getIsDefaultRenderFn() {
      var _instance$props$rende; // @ts-ignore


      return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }

    function getCurrentTarget() {
      return currentTarget || reference;
    }

    function getDocument() {
      var parent = getCurrentTarget().parentNode;
      return parent ? getOwnerDocument(parent) : document;
    }

    function getDefaultTemplateChildren() {
      return getChildren(popper);
    }

    function getDelay(isShow) {
      // For touch or keyboard input, force `0` delay for UX reasons
      // Also if the instance is mounted but not visible (transitioning out),
      // ignore delay
      if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
        return 0;
      }

      return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
    }

    function handleStyles(fromHide) {
      if (fromHide === void 0) {
        fromHide = false;
      }

      popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
      popper.style.zIndex = "" + instance.props.zIndex;
    }

    function invokeHook(hook, args, shouldInvokePropsHook) {
      if (shouldInvokePropsHook === void 0) {
        shouldInvokePropsHook = true;
      }

      pluginsHooks.forEach(function (pluginHooks) {
        if (pluginHooks[hook]) {
          pluginHooks[hook].apply(pluginHooks, args);
        }
      });

      if (shouldInvokePropsHook) {
        var _instance$props;

        (_instance$props = instance.props)[hook].apply(_instance$props, args);
      }
    }

    function handleAriaContentAttribute() {
      var aria = instance.props.aria;

      if (!aria.content) {
        return;
      }

      var attr = "aria-" + aria.content;
      var id = popper.id;
      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        var currentValue = node.getAttribute(attr);

        if (instance.state.isVisible) {
          node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
        } else {
          var nextValue = currentValue && currentValue.replace(id, '').trim();

          if (nextValue) {
            node.setAttribute(attr, nextValue);
          } else {
            node.removeAttribute(attr);
          }
        }
      });
    }

    function handleAriaExpandedAttribute() {
      if (hasAriaExpanded || !instance.props.aria.expanded) {
        return;
      }

      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        if (instance.props.interactive) {
          node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
        } else {
          node.removeAttribute('aria-expanded');
        }
      });
    }

    function cleanupInteractiveMouseListeners() {
      getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
      mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
        return listener !== debouncedOnMouseMove;
      });
    }

    function onDocumentPress(event) {
      // Moved finger to scroll instead of an intentional tap outside
      if (currentInput.isTouch) {
        if (didTouchMove || event.type === 'mousedown') {
          return;
        }
      }

      var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

      if (instance.props.interactive && actualContains(popper, actualTarget)) {
        return;
      } // Clicked on the event listeners target


      if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
        return actualContains(el, actualTarget);
      })) {
        if (currentInput.isTouch) {
          return;
        }

        if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
          return;
        }
      } else {
        invokeHook('onClickOutside', [instance, event]);
      }

      if (instance.props.hideOnClick === true) {
        instance.clearDelayTimeouts();
        instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
        // currentTarget. This lets a tippy with `focus` trigger know that it
        // should not show

        didHideDueToDocumentMouseDown = true;
        setTimeout(function () {
          didHideDueToDocumentMouseDown = false;
        }); // The listener gets added in `scheduleShow()`, but this may be hiding it
        // before it shows, and hide()'s early bail-out behavior can prevent it
        // from being cleaned up

        if (!instance.state.isMounted) {
          removeDocumentPress();
        }
      }
    }

    function onTouchMove() {
      didTouchMove = true;
    }

    function onTouchStart() {
      didTouchMove = false;
    }

    function addDocumentPress() {
      var doc = getDocument();
      doc.addEventListener('mousedown', onDocumentPress, true);
      doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
      doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
      doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }

    function removeDocumentPress() {
      var doc = getDocument();
      doc.removeEventListener('mousedown', onDocumentPress, true);
      doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
      doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
      doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }

    function onTransitionedOut(duration, callback) {
      onTransitionEnd(duration, function () {
        if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
          callback();
        }
      });
    }

    function onTransitionedIn(duration, callback) {
      onTransitionEnd(duration, callback);
    }

    function onTransitionEnd(duration, callback) {
      var box = getDefaultTemplateChildren().box;

      function listener(event) {
        if (event.target === box) {
          updateTransitionEndListener(box, 'remove', listener);
          callback();
        }
      } // Make callback synchronous if duration is 0
      // `transitionend` won't fire otherwise


      if (duration === 0) {
        return callback();
      }

      updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
      updateTransitionEndListener(box, 'add', listener);
      currentTransitionEndListener = listener;
    }

    function on(eventType, handler, options) {
      if (options === void 0) {
        options = false;
      }

      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        node.addEventListener(eventType, handler, options);
        listeners.push({
          node: node,
          eventType: eventType,
          handler: handler,
          options: options
        });
      });
    }

    function addListeners() {
      if (getIsCustomTouchBehavior()) {
        on('touchstart', onTrigger, {
          passive: true
        });
        on('touchend', onMouseLeave, {
          passive: true
        });
      }

      splitBySpaces(instance.props.trigger).forEach(function (eventType) {
        if (eventType === 'manual') {
          return;
        }

        on(eventType, onTrigger);

        switch (eventType) {
          case 'mouseenter':
            on('mouseleave', onMouseLeave);
            break;

          case 'focus':
            on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
            break;

          case 'focusin':
            on('focusout', onBlurOrFocusOut);
            break;
        }
      });
    }

    function removeListeners() {
      listeners.forEach(function (_ref) {
        var node = _ref.node,
            eventType = _ref.eventType,
            handler = _ref.handler,
            options = _ref.options;
        node.removeEventListener(eventType, handler, options);
      });
      listeners = [];
    }

    function onTrigger(event) {
      var _lastTriggerEvent;

      var shouldScheduleClickHide = false;

      if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
        return;
      }

      var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
      lastTriggerEvent = event;
      currentTarget = event.currentTarget;
      handleAriaExpandedAttribute();

      if (!instance.state.isVisible && isMouseEvent(event)) {
        // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        mouseMoveListeners.forEach(function (listener) {
          return listener(event);
        });
      } // Toggle show/hide when clicking click-triggered tooltips


      if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
        shouldScheduleClickHide = true;
      } else {
        scheduleShow(event);
      }

      if (event.type === 'click') {
        isVisibleFromClick = !shouldScheduleClickHide;
      }

      if (shouldScheduleClickHide && !wasFocused) {
        scheduleHide(event);
      }
    }

    function onMouseMove(event) {
      var target = event.target;
      var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

      if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
        return;
      }

      var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
        var _instance$popperInsta;

        var instance = popper._tippy;
        var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

        if (state) {
          return {
            popperRect: popper.getBoundingClientRect(),
            popperState: state,
            props: props
          };
        }

        return null;
      }).filter(Boolean);

      if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
        cleanupInteractiveMouseListeners();
        scheduleHide(event);
      }
    }

    function onMouseLeave(event) {
      var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

      if (shouldBail) {
        return;
      }

      if (instance.props.interactive) {
        instance.hideWithInteractivity(event);
        return;
      }

      scheduleHide(event);
    }

    function onBlurOrFocusOut(event) {
      if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
        return;
      } // If focus was moved to within the popper


      if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
        return;
      }

      scheduleHide(event);
    }

    function isEventListenerStopped(event) {
      return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }

    function createPopperInstance() {
      destroyPopperInstance();
      var _instance$props2 = instance.props,
          popperOptions = _instance$props2.popperOptions,
          placement = _instance$props2.placement,
          offset = _instance$props2.offset,
          getReferenceClientRect = _instance$props2.getReferenceClientRect,
          moveTransition = _instance$props2.moveTransition;
      var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
      var computedReference = getReferenceClientRect ? {
        getBoundingClientRect: getReferenceClientRect,
        contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
      } : reference;
      var tippyModifier = {
        name: '$$tippy',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: function fn(_ref2) {
          var state = _ref2.state;

          if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh = getDefaultTemplateChildren(),
                box = _getDefaultTemplateCh.box;

            ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
              if (attr === 'placement') {
                box.setAttribute('data-placement', state.placement);
              } else {
                if (state.attributes.popper["data-popper-" + attr]) {
                  box.setAttribute("data-" + attr, '');
                } else {
                  box.removeAttribute("data-" + attr);
                }
              }
            });
            state.attributes.popper = {};
          }
        }
      };
      var modifiers = [{
        name: 'offset',
        options: {
          offset: offset
        }
      }, {
        name: 'preventOverflow',
        options: {
          padding: {
            top: 2,
            bottom: 2,
            left: 5,
            right: 5
          }
        }
      }, {
        name: 'flip',
        options: {
          padding: 5
        }
      }, {
        name: 'computeStyles',
        options: {
          adaptive: !moveTransition
        }
      }, tippyModifier];

      if (getIsDefaultRenderFn() && arrow) {
        modifiers.push({
          name: 'arrow',
          options: {
            element: arrow,
            padding: 3
          }
        });
      }

      modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
      instance.popperInstance = createPopper(computedReference, popper, Object.assign({}, popperOptions, {
        placement: placement,
        onFirstUpdate: onFirstUpdate,
        modifiers: modifiers
      }));
    }

    function destroyPopperInstance() {
      if (instance.popperInstance) {
        instance.popperInstance.destroy();
        instance.popperInstance = null;
      }
    }

    function mount() {
      var appendTo = instance.props.appendTo;
      var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
      // it's directly after the reference element so the elements inside the
      // tippy can be tabbed to
      // If there are clipping issues, the user can specify a different appendTo
      // and ensure focus management is handled correctly manually

      var node = getCurrentTarget();

      if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
        parentNode = node.parentNode;
      } else {
        parentNode = invokeWithArgsOrReturn(appendTo, [node]);
      } // The popper element needs to exist on the DOM before its position can be
      // updated as Popper needs to read its dimensions


      if (!parentNode.contains(popper)) {
        parentNode.appendChild(popper);
      }

      instance.state.isMounted = true;
      createPopperInstance();
      /* istanbul ignore else */

      {
        // Accessibility check
        warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
      }
    }

    function getNestedPopperTree() {
      return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }

    function scheduleShow(event) {
      instance.clearDelayTimeouts();

      if (event) {
        invokeHook('onTrigger', [instance, event]);
      }

      addDocumentPress();
      var delay = getDelay(true);

      var _getNormalizedTouchSe = getNormalizedTouchSettings(),
          touchValue = _getNormalizedTouchSe[0],
          touchDelay = _getNormalizedTouchSe[1];

      if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
        delay = touchDelay;
      }

      if (delay) {
        showTimeout = setTimeout(function () {
          instance.show();
        }, delay);
      } else {
        instance.show();
      }
    }

    function scheduleHide(event) {
      instance.clearDelayTimeouts();
      invokeHook('onUntrigger', [instance, event]);

      if (!instance.state.isVisible) {
        removeDocumentPress();
        return;
      } // For interactive tippies, scheduleHide is added to a document.body handler
      // from onMouseLeave so must intercept scheduled hides from mousemove/leave
      // events when trigger contains mouseenter and click, and the tip is
      // currently shown as a result of a click.


      if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
        return;
      }

      var delay = getDelay(false);

      if (delay) {
        hideTimeout = setTimeout(function () {
          if (instance.state.isVisible) {
            instance.hide();
          }
        }, delay);
      } else {
        // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function () {
          instance.hide();
        });
      }
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================


    function enable() {
      instance.state.isEnabled = true;
    }

    function disable() {
      // Disabling the instance should also hide it
      // https://github.com/atomiks/tippy.js-react/issues/106
      instance.hide();
      instance.state.isEnabled = false;
    }

    function clearDelayTimeouts() {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
      cancelAnimationFrame(scheduleHideAnimationFrame);
    }

    function setProps(partialProps) {
      /* istanbul ignore else */
      {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
      }

      if (instance.state.isDestroyed) {
        return;
      }

      invokeHook('onBeforeUpdate', [instance, partialProps]);
      removeListeners();
      var prevProps = instance.props;
      var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
        ignoreAttributes: true
      }));
      instance.props = nextProps;
      addListeners();

      if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
        cleanupInteractiveMouseListeners();
        debouncedOnMouseMove = debounce$2(onMouseMove, nextProps.interactiveDebounce);
      } // Ensure stale aria-expanded attributes are removed


      if (prevProps.triggerTarget && !nextProps.triggerTarget) {
        normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
          node.removeAttribute('aria-expanded');
        });
      } else if (nextProps.triggerTarget) {
        reference.removeAttribute('aria-expanded');
      }

      handleAriaExpandedAttribute();
      handleStyles();

      if (onUpdate) {
        onUpdate(prevProps, nextProps);
      }

      if (instance.popperInstance) {
        createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
        // and the nested ones get re-rendered first.
        // https://github.com/atomiks/tippyjs-react/issues/177
        // TODO: find a cleaner / more efficient solution(!)

        getNestedPopperTree().forEach(function (nestedPopper) {
          // React (and other UI libs likely) requires a rAF wrapper as it flushes
          // its work in one
          requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
        });
      }

      invokeHook('onAfterUpdate', [instance, partialProps]);
    }

    function setContent(content) {
      instance.setProps({
        content: content
      });
    }

    function show() {
      /* istanbul ignore else */
      {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
      } // Early bail-out


      var isAlreadyVisible = instance.state.isVisible;
      var isDestroyed = instance.state.isDestroyed;
      var isDisabled = !instance.state.isEnabled;
      var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
      var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

      if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
        return;
      } // Normalize `disabled` behavior across browsers.
      // Firefox allows events on disabled elements, but Chrome doesn't.
      // Using a wrapper element (i.e. <span>) is recommended.


      if (getCurrentTarget().hasAttribute('disabled')) {
        return;
      }

      invokeHook('onShow', [instance], false);

      if (instance.props.onShow(instance) === false) {
        return;
      }

      instance.state.isVisible = true;

      if (getIsDefaultRenderFn()) {
        popper.style.visibility = 'visible';
      }

      handleStyles();
      addDocumentPress();

      if (!instance.state.isMounted) {
        popper.style.transition = 'none';
      } // If flipping to the opposite side after hiding at least once, the
      // animation will use the wrong placement without resetting the duration


      if (getIsDefaultRenderFn()) {
        var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh2.box,
            content = _getDefaultTemplateCh2.content;

        setTransitionDuration([box, content], 0);
      }

      onFirstUpdate = function onFirstUpdate() {
        var _instance$popperInsta2;

        if (!instance.state.isVisible || ignoreOnFirstUpdate) {
          return;
        }

        ignoreOnFirstUpdate = true; // reflow

        void popper.offsetHeight;
        popper.style.transition = instance.props.moveTransition;

        if (getIsDefaultRenderFn() && instance.props.animation) {
          var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
              _box = _getDefaultTemplateCh3.box,
              _content = _getDefaultTemplateCh3.content;

          setTransitionDuration([_box, _content], duration);
          setVisibilityState([_box, _content], 'visible');
        }

        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
        // popper has been positioned for the first time

        (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
        invokeHook('onMount', [instance]);

        if (instance.props.animation && getIsDefaultRenderFn()) {
          onTransitionedIn(duration, function () {
            instance.state.isShown = true;
            invokeHook('onShown', [instance]);
          });
        }
      };

      mount();
    }

    function hide() {
      /* istanbul ignore else */
      {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
      } // Early bail-out


      var isAlreadyHidden = !instance.state.isVisible;
      var isDestroyed = instance.state.isDestroyed;
      var isDisabled = !instance.state.isEnabled;
      var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

      if (isAlreadyHidden || isDestroyed || isDisabled) {
        return;
      }

      invokeHook('onHide', [instance], false);

      if (instance.props.onHide(instance) === false) {
        return;
      }

      instance.state.isVisible = false;
      instance.state.isShown = false;
      ignoreOnFirstUpdate = false;
      isVisibleFromClick = false;

      if (getIsDefaultRenderFn()) {
        popper.style.visibility = 'hidden';
      }

      cleanupInteractiveMouseListeners();
      removeDocumentPress();
      handleStyles(true);

      if (getIsDefaultRenderFn()) {
        var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh4.box,
            content = _getDefaultTemplateCh4.content;

        if (instance.props.animation) {
          setTransitionDuration([box, content], duration);
          setVisibilityState([box, content], 'hidden');
        }
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();

      if (instance.props.animation) {
        if (getIsDefaultRenderFn()) {
          onTransitionedOut(duration, instance.unmount);
        }
      } else {
        instance.unmount();
      }
    }

    function hideWithInteractivity(event) {
      /* istanbul ignore else */
      {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
      }

      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
      pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
      debouncedOnMouseMove(event);
    }

    function unmount() {
      /* istanbul ignore else */
      {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
      }

      if (instance.state.isVisible) {
        instance.hide();
      }

      if (!instance.state.isMounted) {
        return;
      }

      destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
      // tree by default. This seems mainly for interactive tippies, but we should
      // find a workaround if possible

      getNestedPopperTree().forEach(function (nestedPopper) {
        nestedPopper._tippy.unmount();
      });

      if (popper.parentNode) {
        popper.parentNode.removeChild(popper);
      }

      mountedInstances = mountedInstances.filter(function (i) {
        return i !== instance;
      });
      instance.state.isMounted = false;
      invokeHook('onHidden', [instance]);
    }

    function destroy() {
      /* istanbul ignore else */
      {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
      }

      if (instance.state.isDestroyed) {
        return;
      }

      instance.clearDelayTimeouts();
      instance.unmount();
      removeListeners();
      delete reference._tippy;
      instance.state.isDestroyed = true;
      invokeHook('onDestroy', [instance]);
    }
  }

  function tippy(targets, optionalProps) {
    if (optionalProps === void 0) {
      optionalProps = {};
    }

    var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
    /* istanbul ignore else */

    {
      validateTargets(targets);
      validateProps(optionalProps, plugins);
    }

    bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
      plugins: plugins
    });
    var elements = getArrayOfElements(targets);
    /* istanbul ignore else */

    {
      var isSingleContentElement = isElement$1(passedProps.content);
      var isMoreThanOneReferenceElement = elements.length > 1;
      warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
    }

    var instances = elements.reduce(function (acc, reference) {
      var instance = reference && createTippy(reference, passedProps);

      if (instance) {
        acc.push(instance);
      }

      return acc;
    }, []);
    return isElement$1(targets) ? instances[0] : instances;
  }

  tippy.defaultProps = defaultProps;
  tippy.setDefaultProps = setDefaultProps;
  tippy.currentInput = currentInput;
  // and causing transitions to break for singletons when the console is open, but
  // most notably for non-transform styles being used, `gpuAcceleration: false`.


  var applyStylesModifier = Object.assign({}, applyStyles$1, {
    effect: function effect(_ref) {
      var state = _ref.state;
      var initialStyles = {
        popper: {
          position: state.options.strategy,
          left: '0',
          top: '0',
          margin: '0'
        },
        arrow: {
          position: 'absolute'
        },
        reference: {}
      };
      Object.assign(state.elements.popper.style, initialStyles.popper);
      state.styles = initialStyles;

      if (state.elements.arrow) {
        Object.assign(state.elements.arrow.style, initialStyles.arrow);
      } // intentionally return no cleanup function
      // return () => { ... }

    }
  });

  tippy.setDefaultProps({
    render: render
  });

  //
  var script$8 = {
    data: function data() {
      return {
        instance: null
      };
    },
    props: {
      tooltip: {
        type: String,
        default: null
      },
      options: {
        type: Object
      }
    },
    computed: {
      computedTooltip: function computedTooltip() {
        return '<div class="tooltip__content">' + this.tooltip + '<div class="tooltip__close js-tooltip-close"></div></div>';
      },
      computedOptions: function computedOptions() {
        var _this = this;

        var result = {
          content: this.computedTooltip,
          allowHTML: true,
          trigger: 'focus click',
          interactive: true,
          theme: 'light',
          animation: 'shift-away',
          maxWidth: 250,
          offset: [0, 10],
          onClickOutside: function onClickOutside(instance, event) {
            instance.hide();
          }
        }; // переопределение параметров слайдера переданных в атрибуте компонента

        if (this.options) {
          Object.keys(this.options).forEach(function (key) {
            if (typeof _this.options[key] !== 'undefined') {
              result[key] = _this.options[key];
            }
          });
        }

        return result;
      }
    },
    methods: {
      closeTooltipWhenClickOutside: function closeTooltipWhenClickOutside(e) {
        if (e.target.closest('.js-tooltip-close') || !e.target.closest('.tippy-box') && e.target != this.$el) {
          this.instance.hide();
        }
      }
    },
    mounted: function mounted() {
      var _this2 = this;

      this.$nextTick(function () {
        var vm = _this2;
        _this2.instance = tippy(_this2.$el, _this2.computedOptions);

        _this2.instance.setProps({
          onShow: function onShow(instance) {
            vm.$emit('show', instance.popper);
          }
        }); // закрыть подсказку


        document.addEventListener('click', _this2.closeTooltipWhenClickOutside);
      });
    },
    destroyed: function destroyed() {
      document.removeEventListener('click', this.closeTooltipWhenClickOutside);
    }
  };

  /* script */
  const __vue_script__$8 = script$8;

  /* template */
  var __vue_render__$4 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm._m(0)
  };
  var __vue_staticRenderFns__$4 = [
    function () {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", { staticClass: "v-tooltip tooltip" }, [
        _c("button", { staticClass: "tooltip__icon" }),
      ])
    },
  ];
  __vue_render__$4._withStripped = true;

    /* style */
    const __vue_inject_styles__$8 = undefined;
    /* scoped */
    const __vue_scope_id__$8 = undefined;
    /* module identifier */
    const __vue_module_identifier__$8 = undefined;
    /* functional template */
    const __vue_is_functional_template__$8 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
      __vue_inject_styles__$8,
      __vue_script__$8,
      __vue_scope_id__$8,
      __vue_is_functional_template__$8,
      __vue_module_identifier__$8,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  var script$9 = {
    name: 'TransitionExpand',
    methods: {
      enter: function enter(element) {
        element.style.width = getComputedStyle(element).width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';
        var height = getComputedStyle(element).height;
        element.style.width = null;
        element.style.position = null;
        element.style.visibility = null;
        element.style.height = 0;
        getComputedStyle(element).height;
        requestAnimationFrame(function () {
          element.style.height = height;
        });
      },
      afterEnter: function afterEnter(element) {
        element.style.height = 'auto';
      },
      leave: function leave(element) {
        element.style.height = getComputedStyle(element).height;
        getComputedStyle(element).height;
        requestAnimationFrame(function () {
          element.style.height = 0;
        });
      }
    }
  };

  /* script */
  const __vue_script__$9 = script$9;

  /* template */
  var __vue_render__$5 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "transition",
      {
        attrs: { name: "expand" },
        on: { enter: _vm.enter, "after-enter": _vm.afterEnter, leave: _vm.leave },
      },
      [_vm._t("default")],
      2
    )
  };
  var __vue_staticRenderFns__$5 = [];
  __vue_render__$5._withStripped = true;

    /* style */
    const __vue_inject_styles__$9 = undefined;
    /* scoped */
    const __vue_scope_id__$9 = undefined;
    /* module identifier */
    const __vue_module_identifier__$9 = undefined;
    /* functional template */
    const __vue_is_functional_template__$9 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
      __vue_inject_styles__$9,
      __vue_script__$9,
      __vue_scope_id__$9,
      __vue_is_functional_template__$9,
      __vue_module_identifier__$9,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$a = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        form: null,
        localFormData: new FormData()
      };
    },
    props: {
      mode: {
        default: null
      }
    },
    methods: {
      proxyFieldName: function proxyFieldName(name) {
        return "state[form][".concat(name, "]");
      },
      dataSet: function dataSet(data) {
        this.form = data;
      },
      submit: function submit() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var namesOfCurrentIteration = [];

        if (this.form && this.form.fields) {
          this.form.fields.forEach(function (field) {
            var key = _this.proxyFieldName(field.name);

            if (field.multiple) {
              key = _this.proxyFieldName(field.name.replace('[]', '')) + '[]';
            }

            if (!field.value) {
              field.value = '';
            }

            if (field.type === 'file') ; else {
              // для отправки файлов придется держать в памяти неизменный localFormData
              // перед отправкой нужно удалить старые значения из localFormData
              // т.к. localFormData.append добавляет новые значения к существующим
              // а localFormData.set не позволила бы работать с массивами типа NAME[]
              if (namesOfCurrentIteration.indexOf(key) < 0) {
                _this.localFormData.delete(key);

                namesOfCurrentIteration.push(key);
              }

              if (Array.isArray(field.value)) {
                field.value.forEach(function (val) {
                  _this.localFormData.append(key, val);
                });
              } else {
                _this.localFormData.append(key, field.value);
              }
            }
          });
        }

        this.localFormData.set('state[action]', options.action || 'submit');
        this.localFormData.set('bxajaxid', this.bxajaxid);
        this.dataLoad({
          url: this.form.remote,
          data: this.localFormData,
          delay: true
        });
      },
      fieldChanged: function fieldChanged(field) {
        if (field.autosubmit) {
          this.submit({
            action: 'autosubmit'
          });
        }
      },
      fileInput: function fileInput(field, e) {
        for (var i = 0; i < e.target.files.length; i++) {
          this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', e.target.files[i].path || e.target.files[i]);
        }

        if (field.autosubmit && !e.nosubmit) {
          this.submit({
            action: 'autosubmit'
          });
        }
      },
      fileRemove: function fileRemove(field, e) {
        this.localFormData.delete(this.proxyFieldName(field.name) + '[' + e.key + ']');

        if (field.autosubmit && !e.nosubmit) {
          this.submit({
            action: 'autosubmit'
          });
        }
      },
      valueRemove: function valueRemove(field, e) {
        // remove error of removed value
        if (field.errors && field.errors.length) {
          field.errors.splice(e, 1);
        }
      }
    }
  };

  /* script */
  const __vue_script__$a = script$a;

  /* template */
  var __vue_render__$6 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "form",
      {
        staticClass: "v-form form",
        class: { "form--card": _vm.mode === "card" },
        attrs: { novalidate: "novalidate", autocomplete: "off" },
        on: {
          submit: function ($event) {
            $event.preventDefault();
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.form
          ? [
              _vm.form.title || _vm.form.note
                ? _c("div", { staticClass: "form__header flc fcc" }, [
                    _vm.form.title
                      ? _c("h2", { staticClass: "form__header-title flc" }, [
                          _vm._v(_vm._s(_vm.form.title)),
                        ])
                      : _vm._e(),
                    _vm.form.note
                      ? _c("div", {
                          staticClass: "form__header-note flc",
                          domProps: { innerHTML: _vm._s(_vm.form.note) },
                        })
                      : _vm._e(),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "form__main flc fcc" }, [
                _c(
                  "div",
                  { staticClass: "form__groups" },
                  _vm._l(_vm.form.groups, function (group) {
                    return _c(
                      "div",
                      {
                        key: group.id,
                        staticClass: "form__group",
                        style: { width: group.width || null },
                      },
                      [
                        group.title
                          ? _c("h3", { staticClass: "form__group-title flc" }, [
                              _vm._v(_vm._s(group.title)),
                            ])
                          : _vm._e(),
                        group.note
                          ? _c("div", {
                              staticClass: "form__group-note flc",
                              domProps: { innerHTML: _vm._s(group.note) },
                            })
                          : _vm._e(),
                        _c("div", { staticClass: "form__group-body flc" }, [
                          _c(
                            "div",
                            { staticClass: "form__fields" },
                            [
                              _vm._l(_vm.form.fields, function (field, index) {
                                return field.groupId === group.id
                                  ? [
                                      field.type === "spacer"
                                        ? _c("div", {
                                            staticClass:
                                              "form__field form__field--spacer",
                                            style: { width: field.width || null },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              key: field.id,
                                              staticClass: "form__field",
                                              style: {
                                                width: field.width || null,
                                              },
                                            },
                                            [
                                              _c("v-field", {
                                                attrs: { field: field },
                                                on: {
                                                  fileinput: function ($event) {
                                                    return _vm.fileInput(
                                                      field,
                                                      $event
                                                    )
                                                  },
                                                  fileremove: function ($event) {
                                                    return _vm.fileRemove(
                                                      field,
                                                      $event
                                                    )
                                                  },
                                                  remove: function ($event) {
                                                    return _vm.valueRemove(
                                                      field,
                                                      $event
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.fieldChanged(
                                                      field,
                                                      $event
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: field.value,
                                                  callback: function ($$v) {
                                                    _vm.$set(field, "value", $$v);
                                                  },
                                                  expression: "field.value",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                    ]
                                  : _vm._e()
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm.form.buttons && _vm.form.buttons.length
                ? _c("div", { staticClass: "form__footer flc" }, [
                    _c(
                      "div",
                      { staticClass: "form__actions" },
                      _vm._l(_vm.form.buttons, function (button, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "form__action" },
                          [
                            _c(
                              "button",
                              {
                                class: button.className || "btn btn--primary",
                                attrs: {
                                  type: button.type || "submit",
                                  "data-modal-url": button.modalUrl,
                                  "data-modal-data": button.modalData,
                                },
                              },
                              [_vm._v(_vm._s(button.text))]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$6 = [];
  __vue_render__$6._withStripped = true;

    /* style */
    const __vue_inject_styles__$a = undefined;
    /* scoped */
    const __vue_scope_id__$a = undefined;
    /* module identifier */
    const __vue_module_identifier__$a = undefined;
    /* functional template */
    const __vue_is_functional_template__$a = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$a = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
      __vue_inject_styles__$a,
      __vue_script__$a,
      __vue_scope_id__$a,
      __vue_is_functional_template__$a,
      __vue_module_identifier__$a,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$b = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        form: null,
        localFormData: new FormData(),
        captcha: null,
        recaptchaError: null,
        field: {
          'name': 'UNP',
          'type': 'text',
          'inputmode': 'numeric',
          'placeholder': 'Введите УНП',
          'errors': null,
          'value': null,
          'maxlength': 9,
          'size': 'sm',
          'notClear': true
        }
      };
    },
    props: {
      mode: {
        default: null
      }
    },
    computed: _objectSpread2({}, mapGetters({
      userUnpActive: 'user/userUnpActive',
      userSignIn: 'user/userSignIn'
    })),
    mounted: function mounted() {
      if (this.form.captcha) {
        var script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js';
        script.async = true;
        this.$el.appendChild(script);
      }
    },
    methods: {
      dataSet: function dataSet(data, options) {
        if (data && !data.success) {
          this.form = data;
        }

        this.field.errors = this.form && this.form.error ? [this.form.error] : null; // закрытие попапа при успешной отправке формы

        if (options && options.submit) {
          // обновление корзины при добавлении товара после ввода унп
          if (data.action == 'basket-add') {
            this.$store.dispatch('basket/request');
          }

          if (data.success) {
            if (!data.reload && !data.redirect) {
              controller.closeAllModals();
              this.$store.commit('user/set', {
                unpActive: this.field.value
              });
            }
          }
        }
      },
      submit: function submit() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (this.form.captcha && this.field.value != '101528843') {
          var _this$captcha, _this$captcha2, _this$form;

          // 1. Получить ответ гугл капчи
          this.captcha = grecaptcha.getResponse(); // 2. Если ответ пустой, то выводим сообщение о том, что пользователь не прошёл тест.
          // Такую форму не будем отправлять на сервер.

          if (!((_this$captcha = this.captcha) !== null && _this$captcha !== void 0 && _this$captcha.length)) {
            // Выводим сообщение об ошибке
            this.recaptchaError = '* Вы не прошли проверку "Я не робот"';
            return;
          } else {
            // получаем элемент, содержащий капчу
            this.recaptchaError = null;
          } // 3. Если форма валидна и длина капчи не равно пустой строке, то отправляем форму на сервер (AJAX)


          if ((_this$captcha2 = this.captcha) !== null && _this$captcha2 !== void 0 && _this$captcha2.length) {
            // добавить в formData значение 'g-recaptcha-response'=значение_recaptcha
            this.localFormData.set('g-recaptcha-response', captcha);
          } // 4. Если сервер вернул ответ error, то делаем следующее...


          if (this !== null && this !== void 0 && (_this$form = this.form) !== null && _this$form !== void 0 && _this$form.captchaError) {
            // Сбрасываем виджет reCaptcha
            this.captcha.reset(); // вывести её в элемент у которого id=recaptchaError

            this.recaptchaError = this.form.captchaError;
          }
        }

        this.localFormData.set('state[action]', options.action || 'submit');
        this.localFormData.set('bxajaxid', this.bxajaxid);
        this.localFormData.set('unpActive', this.field.value);
        this.dataLoad({
          url: this.form.remote,
          data: this.localFormData
        }, {
          submit: true
        });
      }
    }
  };

  /* script */
  const __vue_script__$b = script$b;

  /* template */
  var __vue_render__$7 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "form",
      {
        staticClass: "v-form-unp form-unp",
        attrs: { novalidate: "novalidate", autocomplete: "off" },
        on: {
          submit: function ($event) {
            $event.preventDefault();
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.form && _vm.form.change
          ? [
              _vm.form.note
                ? _c("div", { staticClass: "form-unp__note flc" }, [
                    _vm._v("Ваш текущий УНП " + _vm._s(_vm.userUnpActive)),
                    _c("br"),
                    _vm._v(_vm._s(_vm.form.note)),
                  ])
                : _vm._e(),
            ]
          : [
              _vm.form && _vm.form.note
                ? _c("div", {
                    staticClass: "form-unp__note flc",
                    domProps: { innerHTML: _vm._s(_vm.form.note) },
                  })
                : _vm._e(),
            ],
        _vm.form
          ? _c(
              "div",
              { staticClass: "form-unp__row flc fcc" },
              [
                _c("v-field", {
                  staticClass: "form-unp__input",
                  attrs: { field: _vm.field },
                  model: {
                    value: _vm.field.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.field, "value", $$v);
                    },
                    expression: "field.value",
                  },
                }),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn--md btn--center btn--primary form-unp__submit",
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass:
                          "svg-icon svg-icon--arrow-right agile__nav-button-icon",
                      },
                      [
                        _c("use", {
                          attrs: { "xlink:href": "#svg-icon-arrow-right" },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.form && _vm.form.captcha
          ? _c("div", { staticClass: "form-unp__captcha" }, [
              _c("div", {
                staticClass: "g-recaptcha",
                attrs: { id: "captcha", "data-sitekey": _vm.form.captchaSiteKey },
              }),
              _vm.recaptchaError
                ? _c("div", {
                    staticClass: "form-unp__captcha-error",
                    domProps: { innerHTML: _vm._s(_vm.recaptchaError) },
                  })
                : _vm._e(),
            ])
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$7 = [];
  __vue_render__$7._withStripped = true;

    /* style */
    const __vue_inject_styles__$b = undefined;
    /* scoped */
    const __vue_scope_id__$b = undefined;
    /* module identifier */
    const __vue_module_identifier__$b = undefined;
    /* functional template */
    const __vue_is_functional_template__$b = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$b = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
      __vue_inject_styles__$b,
      __vue_script__$b,
      __vue_scope_id__$b,
      __vue_is_functional_template__$b,
      __vue_module_identifier__$b,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$c = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        form: null,
        localFormData: new FormData(),
        localInputUnp: null
      };
    },
    props: {
      mode: {
        default: null
      }
    },
    computed: _objectSpread2(_objectSpread2({}, mapGetters({
      userUnpObjList: 'user/userUnpObjList',
      userUnpList: 'user/userUnpList',
      userUnpActive: 'user/userUnpActive',
      userSignIn: 'user/userSignIn'
    })), {}, {
      // собрать данные списка Унп в селект
      computedOptions: function computedOptions() {
        return this.userUnpObjList.map(function (unp) {
          return {
            'value': unp.value,
            'text': "<div class=\"field-select__item-subtitle\">\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043B\u0438\u0446\u043E</div>".concat(unp.name, "<div class=\"field-select__item-subtitle in-btn-hide\">\u0423\u041D\u041F</div><div class=\"in-btn-hide\">").concat(unp.value, "</div>")
          };
        }).filter(function (item) {
          return item.value;
        });
      }
    }),
    watch: {
      userUnpObjList: function userUnpObjList() {
        this.form.select.options = this.computedOptions;
      }
    },
    methods: {
      dataSet: function dataSet(data) {
        this.form = data;
        this.form.select.options = this.computedOptions;
      },
      submit: function submit() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.localFormData.set('state[action]', options.action || 'submit');
        this.localFormData.set('bxajaxid', this.bxajaxid);
        this.localFormData.set('unpActive', this.localInputUnp);
        this.dataLoad({
          url: this.form.remote,
          data: this.localFormData,
          delay: false
        }).then(function () {
          if (_this.form.success) {
            _this.$store.commit('user/set', {
              unpActive: _this.localInputUnp
            });

            controller.closeAllModals();
          }
        });
      }
    },
    created: function created() {
      this.localInputUnp = this.$store.getters['user/userUnpActive'];
    }
  };

  /* script */
  const __vue_script__$c = script$c;

  /* template */
  var __vue_render__$8 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "form",
      {
        staticClass: "v-form-unp form-unp",
        attrs: { novalidate: "novalidate", autocomplete: "off" },
        on: {
          submit: function ($event) {
            $event.preventDefault();
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.form && _vm.form.note
          ? _c("div", { staticClass: "form-unp__note flc" }, [
              _vm._v(_vm._s(_vm.form.note)),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "form-unp__row flc fcc" },
          [
            _vm.form && _vm.form.select
              ? _c("v-field", {
                  class: ["field--unp-mode"],
                  attrs: { field: _vm.form.select },
                  on: {
                    input: function ($event) {
                      return _vm.fieldChanged(_vm.form.select, $event)
                    },
                  },
                  model: {
                    value: _vm.localInputUnp,
                    callback: function ($$v) {
                      _vm.localInputUnp = $$v;
                    },
                    expression: "localInputUnp",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "form-unp__action" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--primary btn--full-width",
              attrs: {
                type: "button",
                "aria-label": "Сохранить",
                title: "Сохранить",
              },
              on: { click: _vm.submit },
            },
            [
              _vm._v("Сохранить"),
              _c("svg", { staticClass: "svg-icon svg-icon--arrow-right" }, [
                _c("use", { attrs: { "xlink:href": "#svg-icon-arrow-right" } }),
              ]),
            ]
          ),
        ]),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$8 = [];
  __vue_render__$8._withStripped = true;

    /* style */
    const __vue_inject_styles__$c = undefined;
    /* scoped */
    const __vue_scope_id__$c = undefined;
    /* module identifier */
    const __vue_module_identifier__$c = undefined;
    /* functional template */
    const __vue_is_functional_template__$c = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$c = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
      __vue_inject_styles__$c,
      __vue_script__$c,
      __vue_scope_id__$c,
      __vue_is_functional_template__$c,
      __vue_module_identifier__$c,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$d = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        product: null
      };
    },
    computed: _objectSpread2({}, mapGetters({
      basketItems: 'basket/basketItems'
    })),
    methods: _objectSpread2(_objectSpread2({}, mapActions({
      productRemove: 'basket/remove'
    })), {}, {
      dataSet: function dataSet(data) {
        this.product = data;
      },
      accept: function accept() {
        var _this = this;

        this.productRemove(_objectSpread2({}, this.basketItems.find(function (product) {
          return product.basketId == _this.product.basketId;
        }))).then(function () {
          controller.basketUpdate();
        });
        controller.closeModal();
      },
      cancel: function cancel() {
        controller.closeModal();
      }
    })
  };

  /* script */
  const __vue_script__$d = script$d;

  /* template */
  var __vue_render__$9 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-remove-product remove-product" }, [
      _c("div", { staticClass: "remove-product__title flc" }, [
        _vm._v("Удалить?"),
      ]),
      _vm.product && _vm.product.name
        ? _c("div", { staticClass: "remove-product__text flc" }, [
            _vm._v(_vm._s(_vm.product.name) + " будет удален из корзины"),
          ])
        : _vm._e(),
      _c("div", { staticClass: "remove-product__buttons" }, [
        _c("div", { staticClass: "remove-product__btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--primary btn--block btn--center",
              attrs: { type: "button" },
              on: { click: _vm.accept },
            },
            [_vm._v("Да")]
          ),
        ]),
        _c("div", { staticClass: "remove-product__btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--block btn--center",
              attrs: { type: "button" },
              on: { click: _vm.cancel },
            },
            [_vm._v("Нет")]
          ),
        ]),
      ]),
    ])
  };
  var __vue_staticRenderFns__$9 = [];
  __vue_render__$9._withStripped = true;

    /* style */
    const __vue_inject_styles__$d = undefined;
    /* scoped */
    const __vue_scope_id__$d = undefined;
    /* module identifier */
    const __vue_module_identifier__$d = undefined;
    /* functional template */
    const __vue_is_functional_template__$d = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$d = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
      __vue_inject_styles__$d,
      __vue_script__$d,
      __vue_scope_id__$d,
      __vue_is_functional_template__$d,
      __vue_module_identifier__$d,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$e = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        company: null
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        this.company = data;
      },
      accept: function accept() {
        controller.removeCompany(this.company);
        controller.closeModal();
      },
      cancel: function cancel() {
        controller.closeModal();
      }
    }
  };

  /* script */
  const __vue_script__$e = script$e;

  /* template */
  var __vue_render__$a = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-remove-company remove-company" }, [
      _c("div", { staticClass: "remove-company__title flc" }, [
        _vm._v("Удалить?"),
      ]),
      _vm.company && _vm.company.name
        ? _c("div", { staticClass: "remove-company__text flc" }, [
            _vm._v(
              _vm._s(_vm.company.name) + " будет удалена из вашего профиля."
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "remove-company__buttons" }, [
        _c("div", { staticClass: "remove-company__btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--primary btn--block btn--center",
              attrs: { type: "button" },
              on: { click: _vm.accept },
            },
            [_vm._v("Да")]
          ),
        ]),
        _c("div", { staticClass: "remove-company__btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--block btn--center",
              attrs: { type: "button" },
              on: { click: _vm.cancel },
            },
            [_vm._v("Нет")]
          ),
        ]),
      ]),
    ])
  };
  var __vue_staticRenderFns__$a = [];
  __vue_render__$a._withStripped = true;

    /* style */
    const __vue_inject_styles__$e = undefined;
    /* scoped */
    const __vue_scope_id__$e = undefined;
    /* module identifier */
    const __vue_module_identifier__$e = undefined;
    /* functional template */
    const __vue_is_functional_template__$e = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$e = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
      __vue_inject_styles__$e,
      __vue_script__$e,
      __vue_scope_id__$e,
      __vue_is_functional_template__$e,
      __vue_module_identifier__$e,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$f = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        form: null
      };
    },
    props: {
      mode: {
        default: null
      }
    },
    methods: {
      dataSet: function dataSet(data) {
        this.form = data;
      },
      submit: function submit() {
        console.log('submit');
      }
    }
  };

  /* script */
  const __vue_script__$f = script$f;

  /* template */
  var __vue_render__$b = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "form",
      {
        staticClass: "v-subscription-form subscription-form",
        attrs: { novalidate: "novalidate", autocomplete: "off" },
        on: {
          submit: function ($event) {
            $event.preventDefault();
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.form
          ? [
              _vm._l(_vm.form.fields, function (field) {
                return _c(
                  "div",
                  { staticClass: "subscription-form__field" },
                  [
                    _c("v-field", {
                      attrs: { field: field },
                      model: {
                        value: field.value,
                        callback: function ($$v) {
                          _vm.$set(field, "value", $$v);
                        },
                        expression: "field.value",
                      },
                    }),
                    _vm.form && _vm.form.success && _vm.form.message
                      ? _c("div", {
                          staticClass: "subscription-form__success-message flc",
                          domProps: { innerHTML: _vm._s(_vm.form.message) },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _c(
                "button",
                {
                  staticClass: "subscription-form__btn btn btn--primary",
                  attrs: { type: "submit", "aria-label": "Отправить" },
                },
                [_vm._v("🡢")]
              ),
            ]
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$b = [];
  __vue_render__$b._withStripped = true;

    /* style */
    const __vue_inject_styles__$f = undefined;
    /* scoped */
    const __vue_scope_id__$f = undefined;
    /* module identifier */
    const __vue_module_identifier__$f = undefined;
    /* functional template */
    const __vue_is_functional_template__$f = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$f = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
      __vue_inject_styles__$f,
      __vue_script__$f,
      __vue_scope_id__$f,
      __vue_is_functional_template__$f,
      __vue_module_identifier__$f,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$g = {
    data: function data() {
      return {
        localValue: null
      };
    },
    props: {
      field: {
        default: {
          type: 'text'
        }
      },
      value: {
        default: null
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      fileInput: function fileInput(e) {
        this.$emit('fileinput', e);
      },
      fileRemove: function fileRemove(e) {
        this.$emit('fileremove', e);
      },
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      multipleAdd: function multipleAdd() {
        if (!Array.isArray(this.localValue)) {
          this.localValue = [];
        }

        if (this.localValue.length < this.field.multipleLimit) {
          this.localValue.push(null);
        }
      },
      multipleRemove: function multipleRemove(index) {
        this.localValue.splice(index, 1);

        if (Array.isArray(this.field.errors)) {
          this.field.errors.splice(index, 1);
        }
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      },
      handleBlur: function handleBlur() {
        this.$emit('blur', this.localValue);
      },
      handleFocus: function handleFocus() {
        this.$emit('focus', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$g = script$g;

  /* template */
  var __vue_render__$c = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-field field",
        class: {
          "form-error":
            _vm.field &&
            _vm.field.errors &&
            _vm.field.errors.length &&
            !_vm.field.multiple,
        },
      },
      [
        _vm.field.label && _vm.field.type != "select"
          ? _c("label", { staticClass: "field__label" }, [
              _vm._v(_vm._s(_vm.field.label)),
            ])
          : _vm._e(),
        _vm.field.multiple && _vm.field.type !== "file"
          ? [
              Array.isArray(_vm.localValue) && _vm.localValue.length
                ? _c("div", { staticClass: "field__multiple-list" }, [
                    _c(
                      "div",
                      { staticClass: "field__multiple-list-grid" },
                      _vm._l(_vm.localValue, function (item, index) {
                        return _c(
                          "div",
                          { staticClass: "field__multiple-list-item" },
                          [
                            _c("v-field", {
                              attrs: {
                                field: Object.assign({}, _vm.field, {
                                  multiple: false,
                                  label: null,
                                  errors: _vm.field.errors
                                    ? _vm.field.errors[index]
                                    : null,
                                }),
                              },
                              model: {
                                value: _vm.localValue[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.localValue, index, $$v);
                                },
                                expression: "localValue[index]",
                              },
                            }),
                            _c(
                              "button",
                              {
                                staticClass: "field__multiple-list-remove link",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.multipleRemove(index)
                                  },
                                },
                              },
                              [_vm._v("Удалить")]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _c("transition", { attrs: { name: "fade" } }, [
                !_vm.localValue || _vm.localValue.length < _vm.field.multipleLimit
                  ? _c(
                      "button",
                      {
                        staticClass: "field__multiple-list-add link",
                        attrs: { type: "button" },
                        on: { click: _vm.multipleAdd },
                      },
                      [_vm._v("Добавить")]
                    )
                  : _vm._e(),
              ]),
            ]
          : [
              _vm.field.type == "select"
                ? [
                    _c("v-field-select", {
                      attrs: { field: _vm.field },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "date-range"
                ? [
                    _c("v-field-date-range", {
                      attrs: { field: _vm.field },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "date"
                ? [
                    _c("v-field-date", {
                      attrs: { field: _vm.field },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "check-list"
                ? [
                    _c("v-field-check-list", {
                      attrs: { field: _vm.field },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "tag-list"
                ? [
                    _c("v-field-tag-list", {
                      attrs: { field: _vm.field },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "radio-list"
                ? [
                    _c("v-field-check-list", {
                      attrs: { field: _vm.field, radio: "radio" },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "link-list"
                ? [_c("v-link-list", { attrs: { field: _vm.field } })]
                : _vm.field.type == "radio-blocks"
                ? [
                    _c("v-field-check-blocks", {
                      attrs: { field: _vm.field, radio: "radio" },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "switch"
                ? [
                    _c("v-field-switch-list", {
                      attrs: { field: _vm.field, radio: "radio" },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "tabs"
                ? [
                    _c("v-field-tabs-list", {
                      attrs: { field: _vm.field, radio: "radio" },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "color-list"
                ? [
                    _c("v-field-color-list", {
                      attrs: { field: _vm.field, radio: "radio" },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "count"
                ? [
                    _c("v-field-count", {
                      attrs: { field: _vm.field },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "range"
                ? [
                    _c("v-field-range", {
                      attrs: { field: _vm.field },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "file"
                ? [
                    _c("v-field-file", {
                      attrs: { field: _vm.field },
                      on: {
                        fileinput: _vm.fileInput,
                        fileremove: _vm.fileRemove,
                      },
                    }),
                  ]
                : _vm.field.type == "view-picker"
                ? [
                    _c("v-field-view-picker", {
                      attrs: { field: _vm.field, disabled: _vm.field.disabled },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "range-slider"
                ? [
                    _c("v-field-range-slider", {
                      attrs: { field: _vm.field, disabled: _vm.field.disabled },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : _vm.field.type == "tooltip"
                ? [
                    _c("v-field-tooltip", {
                      attrs: { field: _vm.field, disabled: _vm.field.disabled },
                      on: { input: _vm.handleInput },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ]
                : [
                    _c("v-field-text", {
                      attrs: { field: _vm.field, disabled: _vm.field.disabled },
                      on: {
                        input: _vm.handleInput,
                        blur: _vm.handleBlur,
                        focus: _vm.handleFocus,
                      },
                      model: {
                        value: _vm.localValue,
                        callback: function ($$v) {
                          _vm.localValue = $$v;
                        },
                        expression: "localValue",
                      },
                    }),
                  ],
              Array.isArray(_vm.field.errors) &&
              _vm.field.errors &&
              _vm.field.errors.length
                ? _c(
                    "div",
                    { staticClass: "field__errors" },
                    _vm._l(_vm.field.errors, function (error) {
                      return _c("div", {
                        staticClass: "field__error flc",
                        domProps: { innerHTML: _vm._s(error) },
                      })
                    }),
                    0
                  )
                : _vm._e(),
            ],
      ],
      2
    )
  };
  var __vue_staticRenderFns__$c = [];
  __vue_render__$c._withStripped = true;

    /* style */
    const __vue_inject_styles__$g = undefined;
    /* scoped */
    const __vue_scope_id__$g = undefined;
    /* module identifier */
    const __vue_module_identifier__$g = undefined;
    /* functional template */
    const __vue_is_functional_template__$g = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$g = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
      __vue_inject_styles__$g,
      __vue_script__$g,
      __vue_scope_id__$g,
      __vue_is_functional_template__$g,
      __vue_module_identifier__$g,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$h = {
    data: function data() {
      return {
        localValue: null,
        savedValue: null
      };
    },
    props: {
      field: {
        default: null,
        required: true
      },
      value: {
        default: null
      }
    },
    computed: {
      computedType: function computedType() {
        if (!this.field.type || this.field.type == 'number') {
          return 'text';
        }

        return this.field.type;
      },
      isFieldNumeric: function isFieldNumeric() {
        return !!(this.field.type === 'number' || this.field.inputmode === 'numeric' || this.field.inputmode === 'decimal');
      },
      isFieldDecimal: function isFieldDecimal() {
        return this.field.inputmode === 'decimal';
      }
    },
    watch: {
      'field.errors': {
        immediate: true,
        handler: function handler(newValue) {
          if (newValue && newValue.length && !this.field.notClear) {
            this.localValue = '';
            this.$emit('input', this.localValue);
          }
        }
      },
      value: {
        immediate: true,
        handler: function handler() {
          if (this.isFieldNumeric && this.value) {
            this.localValue = this.savedValue = this.value.toString().replace('.', ',');
          } else {
            this.localValue = this.savedValue = this.value;
          }
        }
      }
    },
    methods: {
      handleKeyup: function handleKeyup() {
        if (this.isFieldNumeric && this.savedValue) {
          this.localValue = this.savedValue.replace('.', ',');
        }
      },
      handleInput: function handleInput(e) {
        if (this.isFieldDecimal) {
          if (~this.localValue.search(/[.|,]/)) {
            this.localValue = this.localValue.substr(0, this.localValue.search(/[.|,]/) + 3);
          }
        }

        if (this.isFieldNumeric) {
          if (!this.localValue || /^-?(?:\d+)(?:(\.|,)(\d+)?)?$/.test(this.localValue)) {
            this.savedValue = this.localValue;
          } else {
            this.localValue = this.savedValue;
          }

          this.$emit('input', this.localValue ? parseFloat(this.localValue.toString().replace(',', '.')) : this.localValue);
        } else {
          this.$emit('input', this.localValue);
        }
      },
      handleBlur: function handleBlur() {
        // форматирование до 2 знаков после запятой
        if (this.field.inputmode === 'decimal' && this.savedValue) {
          this.localValue = this.savedValue.replace(',', '.');
          this.localValue = this.savedValue = parseFloat(this.localValue).toFixed(2);
          this.handleKeyup();
        }

        this.$emit('blur', this.localValue);
      },
      handleFocus: function handleFocus() {
        this.$emit('focus', this.localValue);
      }
    },
    updated: function updated() {
      if (this.field.mask && this.$refs.inputMask) {
        var eventKeyUp = new Event('keyup', {
          bubbles: true,
          cancelable: true
        });
        this.$refs.inputMask.$el.dispatchEvent(eventKeyUp);
      }
    }
  };

  /* script */
  const __vue_script__$h = script$h;

  /* template */
  var __vue_render__$d = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "label",
      {
        staticClass: "v-field-text field-text",
        class: { "field-text__textarea": _vm.field.type === "textarea" },
      },
      [
        _vm.field.type === "textarea"
          ? [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localValue,
                    expression: "localValue",
                  },
                ],
                staticClass: "field-input field-input--textarea-inner",
                class: { "field-input--sm": _vm.field.size === "sm" },
                attrs: {
                  inputmode: _vm.field.inputmode,
                  disabled: _vm.field.disabled,
                  placeholder: _vm.field.placeholder,
                  maxlength: _vm.field.maxlength,
                },
                domProps: { value: _vm.localValue },
                on: {
                  blur: _vm.handleBlur,
                  focus: _vm.handleFocus,
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.localValue = $event.target.value;
                    },
                    _vm.handleInput,
                  ],
                },
              }),
            ]
          : this.field.mask
          ? [
              _c("v-masked-input", {
                ref: "inputMask",
                staticClass: "field-input field-text__input",
                class: { "field-input--sm": _vm.field.size === "sm" },
                attrs: {
                  type: _vm.computedType,
                  inputmode: _vm.field.inputmode,
                  disabled: _vm.field.disabled,
                  maxlength: _vm.field.maxlength,
                  placeholder: _vm.field.placeholder,
                  mask: _vm.field.mask,
                },
                on: { input: _vm.handleInput },
                model: {
                  value: _vm.localValue,
                  callback: function ($$v) {
                    _vm.localValue = $$v;
                  },
                  expression: "localValue",
                },
              }),
            ]
          : [
              _vm.computedType === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.localValue,
                        expression: "localValue",
                      },
                    ],
                    ref: "input",
                    staticClass: "field-input field-text__input",
                    class: { "field-input--sm": _vm.field.size === "sm" },
                    attrs: {
                      inputmode: _vm.field.inputmode,
                      disabled: _vm.field.disabled,
                      placeholder: _vm.field.placeholder,
                      maxlength: _vm.field.maxlength,
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.localValue)
                        ? _vm._i(_vm.localValue, null) > -1
                        : _vm.localValue,
                    },
                    on: {
                      input: _vm.handleInput,
                      blur: _vm.handleBlur,
                      focus: _vm.handleFocus,
                      keyup: _vm.handleKeyup,
                      change: function ($event) {
                        var $$a = _vm.localValue,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false;
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v);
                          if ($$el.checked) {
                            $$i < 0 && (_vm.localValue = $$a.concat([$$v]));
                          } else {
                            $$i > -1 &&
                              (_vm.localValue = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)));
                          }
                        } else {
                          _vm.localValue = $$c;
                        }
                      },
                    },
                  })
                : _vm.computedType === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.localValue,
                        expression: "localValue",
                      },
                    ],
                    ref: "input",
                    staticClass: "field-input field-text__input",
                    class: { "field-input--sm": _vm.field.size === "sm" },
                    attrs: {
                      inputmode: _vm.field.inputmode,
                      disabled: _vm.field.disabled,
                      placeholder: _vm.field.placeholder,
                      maxlength: _vm.field.maxlength,
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.localValue, null) },
                    on: {
                      input: _vm.handleInput,
                      blur: _vm.handleBlur,
                      focus: _vm.handleFocus,
                      keyup: _vm.handleKeyup,
                      change: function ($event) {
                        _vm.localValue = null;
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.localValue,
                        expression: "localValue",
                      },
                    ],
                    ref: "input",
                    staticClass: "field-input field-text__input",
                    class: { "field-input--sm": _vm.field.size === "sm" },
                    attrs: {
                      inputmode: _vm.field.inputmode,
                      disabled: _vm.field.disabled,
                      placeholder: _vm.field.placeholder,
                      maxlength: _vm.field.maxlength,
                      type: _vm.computedType,
                    },
                    domProps: { value: _vm.localValue },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.localValue = $event.target.value;
                        },
                        _vm.handleInput,
                      ],
                      blur: _vm.handleBlur,
                      focus: _vm.handleFocus,
                      keyup: _vm.handleKeyup,
                    },
                  }),
            ],
        _c("span", { staticClass: "field-select__placeholder" }, [
          _vm._v(_vm._s(_vm.field.placeholder)),
        ]),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$d = [];
  __vue_render__$d._withStripped = true;

    /* style */
    const __vue_inject_styles__$h = undefined;
    /* scoped */
    const __vue_scope_id__$h = undefined;
    /* module identifier */
    const __vue_module_identifier__$h = undefined;
    /* functional template */
    const __vue_is_functional_template__$h = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$h = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
      __vue_inject_styles__$h,
      __vue_script__$h,
      __vue_scope_id__$h,
      __vue_is_functional_template__$h,
      __vue_module_identifier__$h,
      false,
      undefined,
      undefined,
      undefined
    );

  var smoothScrollbar = createCommonjsModule(function (module, exports) {
    !function (t, n) {
       module.exports = n() ;
    }(commonjsGlobal, function () {
      return function (t) {
        var n = {};

        function e(r) {
          if (n[r]) return n[r].exports;
          var o = n[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
        }

        return e.m = t, e.c = n, e.d = function (t, n, r) {
          e.o(t, n) || Object.defineProperty(t, n, {
            enumerable: !0,
            get: r
          });
        }, e.r = function (t) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, e.t = function (t, n) {
          if (1 & n && (t = e(t)), 8 & n) return t;
          if (4 & n && "object" == _typeof(t) && t && t.__esModule) return t;
          var r = Object.create(null);
          if (e.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
          }), 2 & n && "string" != typeof t) for (var o in t) {
            e.d(r, o, function (n) {
              return t[n];
            }.bind(null, o));
          }
          return r;
        }, e.n = function (t) {
          var n = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return e.d(n, "a", n), n;
        }, e.o = function (t, n) {
          return Object.prototype.hasOwnProperty.call(t, n);
        }, e.p = "", e(e.s = 58);
      }([function (t, n, e) {
        var r = e(25)("wks"),
            o = e(16),
            i = e(2).Symbol,
            u = "function" == typeof i;
        (t.exports = function (t) {
          return r[t] || (r[t] = u && i[t] || (u ? i : o)("Symbol." + t));
        }).store = r;
      }, function (t, n) {
        t.exports = function (t) {
          return "object" == _typeof(t) ? null !== t : "function" == typeof t;
        };
      }, function (t, n) {
        var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
        "number" == typeof __g && (__g = e);
      }, function (t, n) {
        var e = t.exports = {
          version: "2.6.9"
        };
        "number" == typeof __e && (__e = e);
      }, function (t, n, e) {
        t.exports = !e(13)(function () {
          return 7 != Object.defineProperty({}, "a", {
            get: function get() {
              return 7;
            }
          }).a;
        });
      }, function (t, n, e) {
        var r = e(2),
            o = e(3),
            i = e(11),
            u = e(6),
            c = e(10),
            s = function s(t, n, e) {
          var a,
              f,
              l,
              p,
              h = t & s.F,
              d = t & s.G,
              v = t & s.S,
              y = t & s.P,
              m = t & s.B,
              g = d ? r : v ? r[n] || (r[n] = {}) : (r[n] || {}).prototype,
              b = d ? o : o[n] || (o[n] = {}),
              x = b.prototype || (b.prototype = {});

          for (a in d && (e = n), e) {
            l = ((f = !h && g && void 0 !== g[a]) ? g : e)[a], p = m && f ? c(l, r) : y && "function" == typeof l ? c(Function.call, l) : l, g && u(g, a, l, t & s.U), b[a] != l && i(b, a, p), y && x[a] != l && (x[a] = l);
          }
        };

        r.core = o, s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s;
      }, function (t, n, e) {
        var r = e(2),
            o = e(11),
            i = e(9),
            u = e(16)("src"),
            c = e(60),
            s = ("" + c).split("toString");
        e(3).inspectSource = function (t) {
          return c.call(t);
        }, (t.exports = function (t, n, e, c) {
          var a = "function" == typeof e;
          a && (i(e, "name") || o(e, "name", n)), t[n] !== e && (a && (i(e, u) || o(e, u, t[n] ? "" + t[n] : s.join(String(n)))), t === r ? t[n] = e : c ? t[n] ? t[n] = e : o(t, n, e) : (delete t[n], o(t, n, e)));
        })(Function.prototype, "toString", function () {
          return "function" == typeof this && this[u] || c.call(this);
        });
      }, function (t, n, e) {
        var r = e(8),
            o = e(41),
            i = e(43),
            u = Object.defineProperty;
        n.f = e(4) ? Object.defineProperty : function (t, n, e) {
          if (r(t), n = i(n, !0), r(e), o) try {
            return u(t, n, e);
          } catch (t) {}
          if ("get" in e || "set" in e) throw TypeError("Accessors not supported!");
          return "value" in e && (t[n] = e.value), t;
        };
      }, function (t, n, e) {
        var r = e(1);

        t.exports = function (t) {
          if (!r(t)) throw TypeError(t + " is not an object!");
          return t;
        };
      }, function (t, n) {
        var e = {}.hasOwnProperty;

        t.exports = function (t, n) {
          return e.call(t, n);
        };
      }, function (t, n, e) {
        var r = e(44);

        t.exports = function (t, n, e) {
          if (r(t), void 0 === n) return t;

          switch (e) {
            case 1:
              return function (e) {
                return t.call(n, e);
              };

            case 2:
              return function (e, r) {
                return t.call(n, e, r);
              };

            case 3:
              return function (e, r, o) {
                return t.call(n, e, r, o);
              };
          }

          return function () {
            return t.apply(n, arguments);
          };
        };
      }, function (t, n, e) {
        var r = e(7),
            o = e(17);
        t.exports = e(4) ? function (t, n, e) {
          return r.f(t, n, o(1, e));
        } : function (t, n, e) {
          return t[n] = e, t;
        };
      }, function (t, n, e) {
        var r = e(1);

        t.exports = function (t, n) {
          if (!r(t) || t._t !== n) throw TypeError("Incompatible receiver, " + n + " required!");
          return t;
        };
      }, function (t, n) {
        t.exports = function (t) {
          try {
            return !!t();
          } catch (t) {
            return !0;
          }
        };
      }, function (t, n) {
        t.exports = {};
      }, function (t, n, e) {
        var r = e(10),
            o = e(49),
            i = e(50),
            u = e(8),
            c = e(19),
            s = e(51),
            a = {},
            f = {};
        (n = t.exports = function (t, n, e, l, p) {
          var h,
              d,
              v,
              y,
              m = p ? function () {
            return t;
          } : s(t),
              g = r(e, l, n ? 2 : 1),
              b = 0;
          if ("function" != typeof m) throw TypeError(t + " is not iterable!");

          if (i(m)) {
            for (h = c(t.length); h > b; b++) {
              if ((y = n ? g(u(d = t[b])[0], d[1]) : g(t[b])) === a || y === f) return y;
            }
          } else for (v = m.call(t); !(d = v.next()).done;) {
            if ((y = o(v, g, d.value, n)) === a || y === f) return y;
          }
        }).BREAK = a, n.RETURN = f;
      }, function (t, n) {
        var e = 0,
            r = Math.random();

        t.exports = function (t) {
          return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++e + r).toString(36));
        };
      }, function (t, n) {
        t.exports = function (t, n) {
          return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: n
          };
        };
      }, function (t, n, e) {
        var r = e(31),
            o = e(28);

        t.exports = function (t) {
          return r(o(t));
        };
      }, function (t, n, e) {
        var r = e(27),
            o = Math.min;

        t.exports = function (t) {
          return t > 0 ? o(r(t), 9007199254740991) : 0;
        };
      }, function (t, n, e) {
        var r = e(28);

        t.exports = function (t) {
          return Object(r(t));
        };
      }, function (t, n, e) {
        var r = e(16)("meta"),
            o = e(1),
            i = e(9),
            u = e(7).f,
            c = 0,
            s = Object.isExtensible || function () {
          return !0;
        },
            a = !e(13)(function () {
          return s(Object.preventExtensions({}));
        }),
            f = function f(t) {
          u(t, r, {
            value: {
              i: "O" + ++c,
              w: {}
            }
          });
        },
            l = t.exports = {
          KEY: r,
          NEED: !1,
          fastKey: function fastKey(t, n) {
            if (!o(t)) return "symbol" == _typeof(t) ? t : ("string" == typeof t ? "S" : "P") + t;

            if (!i(t, r)) {
              if (!s(t)) return "F";
              if (!n) return "E";
              f(t);
            }

            return t[r].i;
          },
          getWeak: function getWeak(t, n) {
            if (!i(t, r)) {
              if (!s(t)) return !0;
              if (!n) return !1;
              f(t);
            }

            return t[r].w;
          },
          onFreeze: function onFreeze(t) {
            return a && l.NEED && s(t) && !i(t, r) && f(t), t;
          }
        };
      }, function (t, n, e) {

        var r = e(23),
            o = {};
        o[e(0)("toStringTag")] = "z", o + "" != "[object z]" && e(6)(Object.prototype, "toString", function () {
          return "[object " + r(this) + "]";
        }, !0);
      }, function (t, n, e) {
        var r = e(24),
            o = e(0)("toStringTag"),
            i = "Arguments" == r(function () {
          return arguments;
        }());

        t.exports = function (t) {
          var n, e, u;
          return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (e = function (t, n) {
            try {
              return t[n];
            } catch (t) {}
          }(n = Object(t), o)) ? e : i ? r(n) : "Object" == (u = r(n)) && "function" == typeof n.callee ? "Arguments" : u;
        };
      }, function (t, n) {
        var e = {}.toString;

        t.exports = function (t) {
          return e.call(t).slice(8, -1);
        };
      }, function (t, n, e) {
        var r = e(3),
            o = e(2),
            i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
        (t.exports = function (t, n) {
          return i[t] || (i[t] = void 0 !== n ? n : {});
        })("versions", []).push({
          version: r.version,
          mode: e(40) ? "pure" : "global",
          copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
        });
      }, function (t, n, e) {

        var r = e(61)(!0);
        e(29)(String, "String", function (t) {
          this._t = String(t), this._i = 0;
        }, function () {
          var t,
              n = this._t,
              e = this._i;
          return e >= n.length ? {
            value: void 0,
            done: !0
          } : (t = r(n, e), this._i += t.length, {
            value: t,
            done: !1
          });
        });
      }, function (t, n) {
        var e = Math.ceil,
            r = Math.floor;

        t.exports = function (t) {
          return isNaN(t = +t) ? 0 : (t > 0 ? r : e)(t);
        };
      }, function (t, n) {
        t.exports = function (t) {
          if (null == t) throw TypeError("Can't call method on  " + t);
          return t;
        };
      }, function (t, n, e) {

        var r = e(40),
            o = e(5),
            i = e(6),
            u = e(11),
            c = e(14),
            s = e(62),
            a = e(33),
            f = e(68),
            l = e(0)("iterator"),
            p = !([].keys && "next" in [].keys()),
            h = function h() {
          return this;
        };

        t.exports = function (t, n, e, d, v, y, m) {
          s(e, n, d);

          var g,
              b,
              x,
              _ = function _(t) {
            if (!p && t in O) return O[t];

            switch (t) {
              case "keys":
              case "values":
                return function () {
                  return new e(this, t);
                };
            }

            return function () {
              return new e(this, t);
            };
          },
              w = n + " Iterator",
              E = "values" == v,
              S = !1,
              O = t.prototype,
              T = O[l] || O["@@iterator"] || v && O[v],
              A = T || _(v),
              M = v ? E ? _("entries") : A : void 0,
              P = "Array" == n && O.entries || T;

          if (P && (x = f(P.call(new t()))) !== Object.prototype && x.next && (a(x, w, !0), r || "function" == typeof x[l] || u(x, l, h)), E && T && "values" !== T.name && (S = !0, A = function A() {
            return T.call(this);
          }), r && !m || !p && !S && O[l] || u(O, l, A), c[n] = A, c[w] = h, v) if (g = {
            values: E ? A : _("values"),
            keys: y ? A : _("keys"),
            entries: M
          }, m) for (b in g) {
            b in O || i(O, b, g[b]);
          } else o(o.P + o.F * (p || S), n, g);
          return g;
        };
      }, function (t, n, e) {
        var r = e(64),
            o = e(46);

        t.exports = Object.keys || function (t) {
          return r(t, o);
        };
      }, function (t, n, e) {
        var r = e(24);
        t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
          return "String" == r(t) ? t.split("") : Object(t);
        };
      }, function (t, n, e) {
        var r = e(25)("keys"),
            o = e(16);

        t.exports = function (t) {
          return r[t] || (r[t] = o(t));
        };
      }, function (t, n, e) {
        var r = e(7).f,
            o = e(9),
            i = e(0)("toStringTag");

        t.exports = function (t, n, e) {
          t && !o(t = e ? t : t.prototype, i) && r(t, i, {
            configurable: !0,
            value: n
          });
        };
      }, function (t, n, e) {
        for (var r = e(69), o = e(30), i = e(6), u = e(2), c = e(11), s = e(14), a = e(0), f = a("iterator"), l = a("toStringTag"), p = s.Array, h = {
          CSSRuleList: !0,
          CSSStyleDeclaration: !1,
          CSSValueList: !1,
          ClientRectList: !1,
          DOMRectList: !1,
          DOMStringList: !1,
          DOMTokenList: !0,
          DataTransferItemList: !1,
          FileList: !1,
          HTMLAllCollection: !1,
          HTMLCollection: !1,
          HTMLFormElement: !1,
          HTMLSelectElement: !1,
          MediaList: !0,
          MimeTypeArray: !1,
          NamedNodeMap: !1,
          NodeList: !0,
          PaintRequestList: !1,
          Plugin: !1,
          PluginArray: !1,
          SVGLengthList: !1,
          SVGNumberList: !1,
          SVGPathSegList: !1,
          SVGPointList: !1,
          SVGStringList: !1,
          SVGTransformList: !1,
          SourceBufferList: !1,
          StyleSheetList: !0,
          TextTrackCueList: !1,
          TextTrackList: !1,
          TouchList: !1
        }, d = o(h), v = 0; v < d.length; v++) {
          var y,
              m = d[v],
              g = h[m],
              b = u[m],
              x = b && b.prototype;
          if (x && (x[f] || c(x, f, p), x[l] || c(x, l, m), s[m] = p, g)) for (y in r) {
            x[y] || i(x, y, r[y], !0);
          }
        }
      }, function (t, n, e) {
        var r = e(6);

        t.exports = function (t, n, e) {
          for (var o in n) {
            r(t, o, n[o], e);
          }

          return t;
        };
      }, function (t, n) {
        t.exports = function (t, n, e, r) {
          if (!(t instanceof n) || void 0 !== r && r in t) throw TypeError(e + ": incorrect invocation!");
          return t;
        };
      }, function (t, n, e) {

        var r = e(2),
            o = e(5),
            i = e(6),
            u = e(35),
            c = e(21),
            s = e(15),
            a = e(36),
            f = e(1),
            l = e(13),
            p = e(52),
            h = e(33),
            d = e(73);

        t.exports = function (t, n, e, v, y, m) {
          var g = r[t],
              b = g,
              x = y ? "set" : "add",
              _ = b && b.prototype,
              w = {},
              E = function E(t) {
            var n = _[t];
            i(_, t, "delete" == t || "has" == t ? function (t) {
              return !(m && !f(t)) && n.call(this, 0 === t ? 0 : t);
            } : "get" == t ? function (t) {
              return m && !f(t) ? void 0 : n.call(this, 0 === t ? 0 : t);
            } : "add" == t ? function (t) {
              return n.call(this, 0 === t ? 0 : t), this;
            } : function (t, e) {
              return n.call(this, 0 === t ? 0 : t, e), this;
            });
          };

          if ("function" == typeof b && (m || _.forEach && !l(function () {
            new b().entries().next();
          }))) {
            var S = new b(),
                O = S[x](m ? {} : -0, 1) != S,
                T = l(function () {
              S.has(1);
            }),
                A = p(function (t) {
              new b(t);
            }),
                M = !m && l(function () {
              for (var t = new b(), n = 5; n--;) {
                t[x](n, n);
              }

              return !t.has(-0);
            });
            A || ((b = n(function (n, e) {
              a(n, b, t);
              var r = d(new g(), n, b);
              return null != e && s(e, y, r[x], r), r;
            })).prototype = _, _.constructor = b), (T || M) && (E("delete"), E("has"), y && E("get")), (M || O) && E(x), m && _.clear && delete _.clear;
          } else b = v.getConstructor(n, t, y, x), u(b.prototype, e), c.NEED = !0;

          return h(b, t), w[t] = b, o(o.G + o.W + o.F * (b != g), w), m || v.setStrong(b, t, y), b;
        };
      }, function (t, n, e) {

        var r = e(5);

        t.exports = function (t) {
          r(r.S, t, {
            of: function of() {
              for (var t = arguments.length, n = new Array(t); t--;) {
                n[t] = arguments[t];
              }

              return new this(n);
            }
          });
        };
      }, function (t, n, e) {

        var r = e(5),
            o = e(44),
            i = e(10),
            u = e(15);

        t.exports = function (t) {
          r(r.S, t, {
            from: function from(t) {
              var n,
                  e,
                  r,
                  c,
                  s = arguments[1];
              return o(this), (n = void 0 !== s) && o(s), null == t ? new this() : (e = [], n ? (r = 0, c = i(s, arguments[2], 2), u(t, !1, function (t) {
                e.push(c(t, r++));
              })) : u(t, !1, e.push, e), new this(e));
            }
          });
        };
      }, function (t, n) {
        t.exports = !1;
      }, function (t, n, e) {
        t.exports = !e(4) && !e(13)(function () {
          return 7 != Object.defineProperty(e(42)("div"), "a", {
            get: function get() {
              return 7;
            }
          }).a;
        });
      }, function (t, n, e) {
        var r = e(1),
            o = e(2).document,
            i = r(o) && r(o.createElement);

        t.exports = function (t) {
          return i ? o.createElement(t) : {};
        };
      }, function (t, n, e) {
        var r = e(1);

        t.exports = function (t, n) {
          if (!r(t)) return t;
          var e, o;
          if (n && "function" == typeof (e = t.toString) && !r(o = e.call(t))) return o;
          if ("function" == typeof (e = t.valueOf) && !r(o = e.call(t))) return o;
          if (!n && "function" == typeof (e = t.toString) && !r(o = e.call(t))) return o;
          throw TypeError("Can't convert object to primitive value");
        };
      }, function (t, n) {
        t.exports = function (t) {
          if ("function" != typeof t) throw TypeError(t + " is not a function!");
          return t;
        };
      }, function (t, n, e) {
        var r = e(8),
            o = e(63),
            i = e(46),
            u = e(32)("IE_PROTO"),
            c = function c() {},
            _s = function s() {
          var t,
              n = e(42)("iframe"),
              r = i.length;

          for (n.style.display = "none", e(67).appendChild(n), n.src = "javascript:", (t = n.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _s = t.F; r--;) {
            delete _s.prototype[i[r]];
          }

          return _s();
        };

        t.exports = Object.create || function (t, n) {
          var e;
          return null !== t ? (c.prototype = r(t), e = new c(), c.prototype = null, e[u] = t) : e = _s(), void 0 === n ? e : o(e, n);
        };
      }, function (t, n) {
        t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
      }, function (t, n) {
        t.exports = function (t, n) {
          return {
            value: n,
            done: !!t
          };
        };
      }, function (t, n, e) {

        var r = e(7).f,
            o = e(45),
            i = e(35),
            u = e(10),
            c = e(36),
            s = e(15),
            a = e(29),
            f = e(47),
            l = e(72),
            p = e(4),
            h = e(21).fastKey,
            d = e(12),
            v = p ? "_s" : "size",
            y = function y(t, n) {
          var e,
              r = h(n);
          if ("F" !== r) return t._i[r];

          for (e = t._f; e; e = e.n) {
            if (e.k == n) return e;
          }
        };

        t.exports = {
          getConstructor: function getConstructor(t, n, e, a) {
            var f = t(function (t, r) {
              c(t, f, n, "_i"), t._t = n, t._i = o(null), t._f = void 0, t._l = void 0, t[v] = 0, null != r && s(r, e, t[a], t);
            });
            return i(f.prototype, {
              clear: function clear() {
                for (var t = d(this, n), e = t._i, r = t._f; r; r = r.n) {
                  r.r = !0, r.p && (r.p = r.p.n = void 0), delete e[r.i];
                }

                t._f = t._l = void 0, t[v] = 0;
              },
              delete: function _delete(t) {
                var e = d(this, n),
                    r = y(e, t);

                if (r) {
                  var o = r.n,
                      i = r.p;
                  delete e._i[r.i], r.r = !0, i && (i.n = o), o && (o.p = i), e._f == r && (e._f = o), e._l == r && (e._l = i), e[v]--;
                }

                return !!r;
              },
              forEach: function forEach(t) {
                d(this, n);

                for (var e, r = u(t, arguments.length > 1 ? arguments[1] : void 0, 3); e = e ? e.n : this._f;) {
                  for (r(e.v, e.k, this); e && e.r;) {
                    e = e.p;
                  }
                }
              },
              has: function has(t) {
                return !!y(d(this, n), t);
              }
            }), p && r(f.prototype, "size", {
              get: function get() {
                return d(this, n)[v];
              }
            }), f;
          },
          def: function def(t, n, e) {
            var r,
                o,
                i = y(t, n);
            return i ? i.v = e : (t._l = i = {
              i: o = h(n, !0),
              k: n,
              v: e,
              p: r = t._l,
              n: void 0,
              r: !1
            }, t._f || (t._f = i), r && (r.n = i), t[v]++, "F" !== o && (t._i[o] = i)), t;
          },
          getEntry: y,
          setStrong: function setStrong(t, n, e) {
            a(t, n, function (t, e) {
              this._t = d(t, n), this._k = e, this._l = void 0;
            }, function () {
              for (var t = this._k, n = this._l; n && n.r;) {
                n = n.p;
              }

              return this._t && (this._l = n = n ? n.n : this._t._f) ? f(0, "keys" == t ? n.k : "values" == t ? n.v : [n.k, n.v]) : (this._t = void 0, f(1));
            }, e ? "entries" : "values", !e, !0), l(n);
          }
        };
      }, function (t, n, e) {
        var r = e(8);

        t.exports = function (t, n, e, o) {
          try {
            return o ? n(r(e)[0], e[1]) : n(e);
          } catch (n) {
            var i = t.return;
            throw void 0 !== i && r(i.call(t)), n;
          }
        };
      }, function (t, n, e) {
        var r = e(14),
            o = e(0)("iterator"),
            i = Array.prototype;

        t.exports = function (t) {
          return void 0 !== t && (r.Array === t || i[o] === t);
        };
      }, function (t, n, e) {
        var r = e(23),
            o = e(0)("iterator"),
            i = e(14);

        t.exports = e(3).getIteratorMethod = function (t) {
          if (null != t) return t[o] || t["@@iterator"] || i[r(t)];
        };
      }, function (t, n, e) {
        var r = e(0)("iterator"),
            o = !1;

        try {
          var i = [7][r]();
          i.return = function () {
            o = !0;
          }, Array.from(i, function () {
            throw 2;
          });
        } catch (t) {}

        t.exports = function (t, n) {
          if (!n && !o) return !1;
          var e = !1;

          try {
            var i = [7],
                u = i[r]();
            u.next = function () {
              return {
                done: e = !0
              };
            }, i[r] = function () {
              return u;
            }, t(i);
          } catch (t) {}

          return e;
        };
      }, function (t, n) {
        n.f = {}.propertyIsEnumerable;
      }, function (t, n, e) {
        var r = e(23),
            o = e(77);

        t.exports = function (t) {
          return function () {
            if (r(this) != t) throw TypeError(t + "#toJSON isn't generic");
            return o(this);
          };
        };
      }, function (t, n, e) {
        var r = e(10),
            o = e(31),
            i = e(20),
            u = e(19),
            c = e(87);

        t.exports = function (t, n) {
          var e = 1 == t,
              s = 2 == t,
              a = 3 == t,
              f = 4 == t,
              l = 6 == t,
              p = 5 == t || l,
              h = n || c;
          return function (n, c, d) {
            for (var v, y, m = i(n), g = o(m), b = r(c, d, 3), x = u(g.length), _ = 0, w = e ? h(n, x) : s ? h(n, 0) : void 0; x > _; _++) {
              if ((p || _ in g) && (y = b(v = g[_], _, m), t)) if (e) w[_] = y;else if (y) switch (t) {
                case 3:
                  return !0;

                case 5:
                  return v;

                case 6:
                  return _;

                case 2:
                  w.push(v);
              } else if (f) return !1;
            }

            return l ? -1 : a || f ? f : w;
          };
        };
      }, function (t, n, e) {

        var r = e(4),
            o = e(30),
            i = e(90),
            u = e(53),
            c = e(20),
            s = e(31),
            a = Object.assign;
        t.exports = !a || e(13)(function () {
          var t = {},
              n = {},
              e = Symbol(),
              r = "abcdefghijklmnopqrst";
          return t[e] = 7, r.split("").forEach(function (t) {
            n[t] = t;
          }), 7 != a({}, t)[e] || Object.keys(a({}, n)).join("") != r;
        }) ? function (t, n) {
          for (var e = c(t), a = arguments.length, f = 1, l = i.f, p = u.f; a > f;) {
            for (var h, d = s(arguments[f++]), v = l ? o(d).concat(l(d)) : o(d), y = v.length, m = 0; y > m;) {
              h = v[m++], r && !p.call(d, h) || (e[h] = d[h]);
            }
          }

          return e;
        } : a;
      }, function (t, n, e) {

        (function (t) {
          var e = "object" == _typeof(t) && t && t.Object === Object && t;
          n.a = e;
        }).call(this, e(99));
      }, function (t, n, e) {
        t.exports = e(100);
      }, function (t, n, e) {
        e(22), e(26), e(34), e(71), e(76), e(78), e(79), t.exports = e(3).Map;
      }, function (t, n, e) {
        t.exports = e(25)("native-function-to-string", Function.toString);
      }, function (t, n, e) {
        var r = e(27),
            o = e(28);

        t.exports = function (t) {
          return function (n, e) {
            var i,
                u,
                c = String(o(n)),
                s = r(e),
                a = c.length;
            return s < 0 || s >= a ? t ? "" : void 0 : (i = c.charCodeAt(s)) < 55296 || i > 56319 || s + 1 === a || (u = c.charCodeAt(s + 1)) < 56320 || u > 57343 ? t ? c.charAt(s) : i : t ? c.slice(s, s + 2) : u - 56320 + (i - 55296 << 10) + 65536;
          };
        };
      }, function (t, n, e) {

        var r = e(45),
            o = e(17),
            i = e(33),
            u = {};
        e(11)(u, e(0)("iterator"), function () {
          return this;
        }), t.exports = function (t, n, e) {
          t.prototype = r(u, {
            next: o(1, e)
          }), i(t, n + " Iterator");
        };
      }, function (t, n, e) {
        var r = e(7),
            o = e(8),
            i = e(30);
        t.exports = e(4) ? Object.defineProperties : function (t, n) {
          o(t);

          for (var e, u = i(n), c = u.length, s = 0; c > s;) {
            r.f(t, e = u[s++], n[e]);
          }

          return t;
        };
      }, function (t, n, e) {
        var r = e(9),
            o = e(18),
            i = e(65)(!1),
            u = e(32)("IE_PROTO");

        t.exports = function (t, n) {
          var e,
              c = o(t),
              s = 0,
              a = [];

          for (e in c) {
            e != u && r(c, e) && a.push(e);
          }

          for (; n.length > s;) {
            r(c, e = n[s++]) && (~i(a, e) || a.push(e));
          }

          return a;
        };
      }, function (t, n, e) {
        var r = e(18),
            o = e(19),
            i = e(66);

        t.exports = function (t) {
          return function (n, e, u) {
            var c,
                s = r(n),
                a = o(s.length),
                f = i(u, a);

            if (t && e != e) {
              for (; a > f;) {
                if ((c = s[f++]) != c) return !0;
              }
            } else for (; a > f; f++) {
              if ((t || f in s) && s[f] === e) return t || f || 0;
            }

            return !t && -1;
          };
        };
      }, function (t, n, e) {
        var r = e(27),
            o = Math.max,
            i = Math.min;

        t.exports = function (t, n) {
          return (t = r(t)) < 0 ? o(t + n, 0) : i(t, n);
        };
      }, function (t, n, e) {
        var r = e(2).document;
        t.exports = r && r.documentElement;
      }, function (t, n, e) {
        var r = e(9),
            o = e(20),
            i = e(32)("IE_PROTO"),
            u = Object.prototype;

        t.exports = Object.getPrototypeOf || function (t) {
          return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
        };
      }, function (t, n, e) {

        var r = e(70),
            o = e(47),
            i = e(14),
            u = e(18);
        t.exports = e(29)(Array, "Array", function (t, n) {
          this._t = u(t), this._i = 0, this._k = n;
        }, function () {
          var t = this._t,
              n = this._k,
              e = this._i++;
          return !t || e >= t.length ? (this._t = void 0, o(1)) : o(0, "keys" == n ? e : "values" == n ? t[e] : [e, t[e]]);
        }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
      }, function (t, n, e) {
        var r = e(0)("unscopables"),
            o = Array.prototype;
        null == o[r] && e(11)(o, r, {}), t.exports = function (t) {
          o[r][t] = !0;
        };
      }, function (t, n, e) {

        var r = e(48),
            o = e(12);
        t.exports = e(37)("Map", function (t) {
          return function () {
            return t(this, arguments.length > 0 ? arguments[0] : void 0);
          };
        }, {
          get: function get(t) {
            var n = r.getEntry(o(this, "Map"), t);
            return n && n.v;
          },
          set: function set(t, n) {
            return r.def(o(this, "Map"), 0 === t ? 0 : t, n);
          }
        }, r, !0);
      }, function (t, n, e) {

        var r = e(2),
            o = e(7),
            i = e(4),
            u = e(0)("species");

        t.exports = function (t) {
          var n = r[t];
          i && n && !n[u] && o.f(n, u, {
            configurable: !0,
            get: function get() {
              return this;
            }
          });
        };
      }, function (t, n, e) {
        var r = e(1),
            o = e(74).set;

        t.exports = function (t, n, e) {
          var i,
              u = n.constructor;
          return u !== e && "function" == typeof u && (i = u.prototype) !== e.prototype && r(i) && o && o(t, i), t;
        };
      }, function (t, n, e) {
        var r = e(1),
            o = e(8),
            i = function i(t, n) {
          if (o(t), !r(n) && null !== n) throw TypeError(n + ": can't set as prototype!");
        };

        t.exports = {
          set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, n, r) {
            try {
              (r = e(10)(Function.call, e(75).f(Object.prototype, "__proto__").set, 2))(t, []), n = !(t instanceof Array);
            } catch (t) {
              n = !0;
            }

            return function (t, e) {
              return i(t, e), n ? t.__proto__ = e : r(t, e), t;
            };
          }({}, !1) : void 0),
          check: i
        };
      }, function (t, n, e) {
        var r = e(53),
            o = e(17),
            i = e(18),
            u = e(43),
            c = e(9),
            s = e(41),
            a = Object.getOwnPropertyDescriptor;
        n.f = e(4) ? a : function (t, n) {
          if (t = i(t), n = u(n, !0), s) try {
            return a(t, n);
          } catch (t) {}
          if (c(t, n)) return o(!r.f.call(t, n), t[n]);
        };
      }, function (t, n, e) {
        var r = e(5);
        r(r.P + r.R, "Map", {
          toJSON: e(54)("Map")
        });
      }, function (t, n, e) {
        var r = e(15);

        t.exports = function (t, n) {
          var e = [];
          return r(t, !1, e.push, e, n), e;
        };
      }, function (t, n, e) {
        e(38)("Map");
      }, function (t, n, e) {
        e(39)("Map");
      }, function (t, n, e) {
        e(22), e(26), e(34), e(81), e(82), e(83), e(84), t.exports = e(3).Set;
      }, function (t, n, e) {

        var r = e(48),
            o = e(12);
        t.exports = e(37)("Set", function (t) {
          return function () {
            return t(this, arguments.length > 0 ? arguments[0] : void 0);
          };
        }, {
          add: function add(t) {
            return r.def(o(this, "Set"), t = 0 === t ? 0 : t, t);
          }
        }, r);
      }, function (t, n, e) {
        var r = e(5);
        r(r.P + r.R, "Set", {
          toJSON: e(54)("Set")
        });
      }, function (t, n, e) {
        e(38)("Set");
      }, function (t, n, e) {
        e(39)("Set");
      }, function (t, n, e) {
        e(22), e(34), e(86), e(92), e(93), t.exports = e(3).WeakMap;
      }, function (t, n, e) {

        var r,
            o = e(2),
            i = e(55)(0),
            u = e(6),
            c = e(21),
            s = e(56),
            a = e(91),
            f = e(1),
            l = e(12),
            p = e(12),
            h = !o.ActiveXObject && "ActiveXObject" in o,
            d = c.getWeak,
            v = Object.isExtensible,
            y = a.ufstore,
            m = function m(t) {
          return function () {
            return t(this, arguments.length > 0 ? arguments[0] : void 0);
          };
        },
            g = {
          get: function get(t) {
            if (f(t)) {
              var n = d(t);
              return !0 === n ? y(l(this, "WeakMap")).get(t) : n ? n[this._i] : void 0;
            }
          },
          set: function set(t, n) {
            return a.def(l(this, "WeakMap"), t, n);
          }
        },
            b = t.exports = e(37)("WeakMap", m, g, a, !0, !0);

        p && h && (s((r = a.getConstructor(m, "WeakMap")).prototype, g), c.NEED = !0, i(["delete", "has", "get", "set"], function (t) {
          var n = b.prototype,
              e = n[t];
          u(n, t, function (n, o) {
            if (f(n) && !v(n)) {
              this._f || (this._f = new r());

              var i = this._f[t](n, o);

              return "set" == t ? this : i;
            }

            return e.call(this, n, o);
          });
        }));
      }, function (t, n, e) {
        var r = e(88);

        t.exports = function (t, n) {
          return new (r(t))(n);
        };
      }, function (t, n, e) {
        var r = e(1),
            o = e(89),
            i = e(0)("species");

        t.exports = function (t) {
          var n;
          return o(t) && ("function" != typeof (n = t.constructor) || n !== Array && !o(n.prototype) || (n = void 0), r(n) && null === (n = n[i]) && (n = void 0)), void 0 === n ? Array : n;
        };
      }, function (t, n, e) {
        var r = e(24);

        t.exports = Array.isArray || function (t) {
          return "Array" == r(t);
        };
      }, function (t, n) {
        n.f = Object.getOwnPropertySymbols;
      }, function (t, n, e) {

        var r = e(35),
            o = e(21).getWeak,
            i = e(8),
            u = e(1),
            c = e(36),
            s = e(15),
            a = e(55),
            f = e(9),
            l = e(12),
            p = a(5),
            h = a(6),
            d = 0,
            v = function v(t) {
          return t._l || (t._l = new y());
        },
            y = function y() {
          this.a = [];
        },
            m = function m(t, n) {
          return p(t.a, function (t) {
            return t[0] === n;
          });
        };

        y.prototype = {
          get: function get(t) {
            var n = m(this, t);
            if (n) return n[1];
          },
          has: function has(t) {
            return !!m(this, t);
          },
          set: function set(t, n) {
            var e = m(this, t);
            e ? e[1] = n : this.a.push([t, n]);
          },
          delete: function _delete(t) {
            var n = h(this.a, function (n) {
              return n[0] === t;
            });
            return ~n && this.a.splice(n, 1), !!~n;
          }
        }, t.exports = {
          getConstructor: function getConstructor(t, n, e, i) {
            var a = t(function (t, r) {
              c(t, a, n, "_i"), t._t = n, t._i = d++, t._l = void 0, null != r && s(r, e, t[i], t);
            });
            return r(a.prototype, {
              delete: function _delete(t) {
                if (!u(t)) return !1;
                var e = o(t);
                return !0 === e ? v(l(this, n)).delete(t) : e && f(e, this._i) && delete e[this._i];
              },
              has: function has(t) {
                if (!u(t)) return !1;
                var e = o(t);
                return !0 === e ? v(l(this, n)).has(t) : e && f(e, this._i);
              }
            }), a;
          },
          def: function def(t, n, e) {
            var r = o(i(n), !0);
            return !0 === r ? v(t).set(n, e) : r[t._i] = e, t;
          },
          ufstore: v
        };
      }, function (t, n, e) {
        e(38)("WeakMap");
      }, function (t, n, e) {
        e(39)("WeakMap");
      }, function (t, n, e) {
        e(26), e(95), t.exports = e(3).Array.from;
      }, function (t, n, e) {

        var r = e(10),
            o = e(5),
            i = e(20),
            u = e(49),
            c = e(50),
            s = e(19),
            a = e(96),
            f = e(51);
        o(o.S + o.F * !e(52)(function (t) {
        }), "Array", {
          from: function from(t) {
            var n,
                e,
                o,
                l,
                p = i(t),
                h = "function" == typeof this ? this : Array,
                d = arguments.length,
                v = d > 1 ? arguments[1] : void 0,
                y = void 0 !== v,
                m = 0,
                g = f(p);
            if (y && (v = r(v, d > 2 ? arguments[2] : void 0, 2)), null == g || h == Array && c(g)) for (e = new h(n = s(p.length)); n > m; m++) {
              a(e, m, y ? v(p[m], m) : p[m]);
            } else for (l = g.call(p), e = new h(); !(o = l.next()).done; m++) {
              a(e, m, y ? u(l, v, [o.value, m], !0) : o.value);
            }
            return e.length = m, e;
          }
        });
      }, function (t, n, e) {

        var r = e(7),
            o = e(17);

        t.exports = function (t, n, e) {
          n in t ? r.f(t, n, o(0, e)) : t[n] = e;
        };
      }, function (t, n, e) {
        e(98), t.exports = e(3).Object.assign;
      }, function (t, n, e) {
        var r = e(5);
        r(r.S + r.F, "Object", {
          assign: e(56)
        });
      }, function (t, n) {
        var e;

        e = function () {
          return this;
        }();

        try {
          e = e || new Function("return this")();
        } catch (t) {
          "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (e = window);
        }

        t.exports = e;
      }, function (t, n, e) {

        e.r(n);
        var r = {};
        e.r(r), e.d(r, "keyboardHandler", function () {
          return et;
        }), e.d(r, "mouseHandler", function () {
          return rt;
        }), e.d(r, "resizeHandler", function () {
          return ot;
        }), e.d(r, "selectHandler", function () {
          return it;
        }), e.d(r, "touchHandler", function () {
          return ut;
        }), e.d(r, "wheelHandler", function () {
          return ct;
        });
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation. All rights reserved.
        Licensed under the Apache License, Version 2.0 (the "License"); you may not use
        this file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0
        
        THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
        WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
        MERCHANTABLITY OR NON-INFRINGEMENT.
        
        See the Apache Version 2.0 License for specific language governing permissions
        and limitations under the License.
        ***************************************************************************** */

        var _o = function o(t, n) {
          return (_o = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, n) {
            t.__proto__ = n;
          } || function (t, n) {
            for (var e in n) {
              n.hasOwnProperty(e) && (t[e] = n[e]);
            }
          })(t, n);
        },
            _i = function i() {
          return (_i = Object.assign || function (t) {
            for (var n, e = 1, r = arguments.length; e < r; e++) {
              for (var o in n = arguments[e]) {
                Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
              }
            }

            return t;
          }).apply(this, arguments);
        };

        function u(t, n, e, r) {
          var o,
              i = arguments.length,
              u = i < 3 ? n : null === r ? r = Object.getOwnPropertyDescriptor(n, e) : r;
          if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.decorate) u = Reflect.decorate(t, n, e, r);else for (var c = t.length - 1; c >= 0; c--) {
            (o = t[c]) && (u = (i < 3 ? o(u) : i > 3 ? o(n, e, u) : o(n, e)) || u);
          }
          return i > 3 && u && Object.defineProperty(n, e, u), u;
        }

        e(59), e(80), e(85), e(94), e(97);

        var c = function c(t) {
          var n = _typeof(t);

          return null != t && ("object" == n || "function" == n);
        },
            s = e(57),
            a = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
            f = s.a || a || Function("return this")(),
            l = f.Symbol,
            p = Object.prototype,
            h = p.hasOwnProperty,
            d = p.toString,
            v = l ? l.toStringTag : void 0,
            y = Object.prototype.toString,
            m = l ? l.toStringTag : void 0,
            g = function g(t) {
          return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : m && m in Object(t) ? function (t) {
            var n = h.call(t, v),
                e = t[v];

            try {
              t[v] = void 0;
              var r = !0;
            } catch (t) {}

            var o = d.call(t);
            return r && (n ? t[v] = e : delete t[v]), o;
          }(t) : function (t) {
            return y.call(t);
          }(t);
        },
            b = /^\s+|\s+$/g,
            x = /^[-+]0x[0-9a-f]+$/i,
            _ = /^0b[01]+$/i,
            w = /^0o[0-7]+$/i,
            E = parseInt,
            S = function S(t) {
          if ("number" == typeof t) return t;
          if (function (t) {
            return "symbol" == _typeof(t) || function (t) {
              return null != t && "object" == _typeof(t);
            }(t) && "[object Symbol]" == g(t);
          }(t)) return NaN;

          if (c(t)) {
            var n = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = c(n) ? n + "" : n;
          }

          if ("string" != typeof t) return 0 === t ? t : +t;
          t = t.replace(b, "");

          var e = _.test(t);

          return e || w.test(t) ? E(t.slice(2), e ? 2 : 8) : x.test(t) ? NaN : +t;
        },
            O = function O(t, n, e) {
          return void 0 === e && (e = n, n = void 0), void 0 !== e && (e = (e = S(e)) == e ? e : 0), void 0 !== n && (n = (n = S(n)) == n ? n : 0), function (t, n, e) {
            return t == t && (void 0 !== e && (t = t <= e ? t : e), void 0 !== n && (t = t >= n ? t : n)), t;
          }(S(t), n, e);
        };

        function T(t, n) {
          return void 0 === t && (t = -1 / 0), void 0 === n && (n = 1 / 0), function (e, r) {
            var o = "_" + r;
            Object.defineProperty(e, r, {
              get: function get() {
                return this[o];
              },
              set: function set(e) {
                Object.defineProperty(this, o, {
                  value: O(e, t, n),
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                });
              },
              enumerable: !0,
              configurable: !0
            });
          };
        }

        function A(t, n) {
          var e = "_" + n;
          Object.defineProperty(t, n, {
            get: function get() {
              return this[e];
            },
            set: function set(t) {
              Object.defineProperty(this, e, {
                value: !!t,
                enumerable: !1,
                writable: !0,
                configurable: !0
              });
            },
            enumerable: !0,
            configurable: !0
          });
        }

        var M = function M() {
          return f.Date.now();
        },
            P = Math.max,
            j = Math.min,
            k = function k(t, n, e) {
          var r,
              o,
              i,
              u,
              s,
              a,
              f = 0,
              l = !1,
              p = !1,
              h = !0;
          if ("function" != typeof t) throw new TypeError("Expected a function");

          function d(n) {
            var e = r,
                i = o;
            return r = o = void 0, f = n, u = t.apply(i, e);
          }

          function v(t) {
            var e = t - a;
            return void 0 === a || e >= n || e < 0 || p && t - f >= i;
          }

          function y() {
            var t = M();
            if (v(t)) return m(t);
            s = setTimeout(y, function (t) {
              var e = n - (t - a);
              return p ? j(e, i - (t - f)) : e;
            }(t));
          }

          function m(t) {
            return s = void 0, h && r ? d(t) : (r = o = void 0, u);
          }

          function g() {
            var t = M(),
                e = v(t);

            if (r = arguments, o = this, a = t, e) {
              if (void 0 === s) return function (t) {
                return f = t, s = setTimeout(y, n), l ? d(t) : u;
              }(a);
              if (p) return clearTimeout(s), s = setTimeout(y, n), d(a);
            }

            return void 0 === s && (s = setTimeout(y, n)), u;
          }

          return n = S(n) || 0, c(e) && (l = !!e.leading, i = (p = "maxWait" in e) ? P(S(e.maxWait) || 0, n) : i, h = "trailing" in e ? !!e.trailing : h), g.cancel = function () {
            void 0 !== s && clearTimeout(s), f = 0, r = a = o = s = void 0;
          }, g.flush = function () {
            return void 0 === s ? u : m(M());
          }, g;
        };

        function D() {
          for (var t = [], n = 0; n < arguments.length; n++) {
            t[n] = arguments[n];
          }

          return function (n, e, r) {
            var o = r.value;
            return {
              get: function get() {
                return this.hasOwnProperty(e) || Object.defineProperty(this, e, {
                  value: k.apply(void 0, function () {
                    for (var t = 0, n = 0, e = arguments.length; n < e; n++) {
                      t += arguments[n].length;
                    }

                    var r = Array(t),
                        o = 0;

                    for (n = 0; n < e; n++) {
                      for (var i = arguments[n], u = 0, c = i.length; u < c; u++, o++) {
                        r[o] = i[u];
                      }
                    }

                    return r;
                  }([o], t))
                }), this[e];
              }
            };
          };
        }

        var L,
            N = function () {
          function t(t) {
            var n = this;
            void 0 === t && (t = {}), this.damping = .1, this.thumbMinSize = 20, this.renderByPixels = !0, this.alwaysShowTracks = !1, this.continuousScrolling = !0, this.delegateTo = null, this.plugins = {}, Object.keys(t).forEach(function (e) {
              n[e] = t[e];
            });
          }

          return Object.defineProperty(t.prototype, "wheelEventTarget", {
            get: function get() {
              return this.delegateTo;
            },
            set: function set(t) {
              console.warn("[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead."), this.delegateTo = t;
            },
            enumerable: !0,
            configurable: !0
          }), u([T(0, 1)], t.prototype, "damping", void 0), u([T(0, 1 / 0)], t.prototype, "thumbMinSize", void 0), u([A], t.prototype, "renderByPixels", void 0), u([A], t.prototype, "alwaysShowTracks", void 0), u([A], t.prototype, "continuousScrolling", void 0), t;
        }(),
            z = new WeakMap();

        function C() {
          if (void 0 !== L) return L;
          var t = !1;

          try {
            var n = function n() {},
                e = Object.defineProperty({}, "passive", {
              get: function get() {
                t = !0;
              }
            });

            window.addEventListener("testPassive", n, e), window.removeEventListener("testPassive", n, e);
          } catch (t) {}

          return L = !!t && {
            passive: !1
          };
        }

        function R(t) {
          var n = z.get(t) || [];
          return z.set(t, n), function (t, e, r) {
            function o(t) {
              t.defaultPrevented || r(t);
            }

            e.split(/\s+/g).forEach(function (e) {
              n.push({
                elem: t,
                eventName: e,
                handler: o
              }), t.addEventListener(e, o, C());
            });
          };
        }

        function F(t) {
          var n = function (t) {
            return t.touches ? t.touches[t.touches.length - 1] : t;
          }(t);

          return {
            x: n.clientX,
            y: n.clientY
          };
        }

        function I(t, n) {
          return void 0 === n && (n = []), n.some(function (n) {
            return t === n;
          });
        }

        var W = ["webkit", "moz", "ms", "o"],
            H = new RegExp("^-(?!(?:" + W.join("|") + ")-)");

        function B(t, n) {
          n = function (t) {
            var n = {};
            return Object.keys(t).forEach(function (e) {
              if (H.test(e)) {
                var r = t[e];
                e = e.replace(/^-/, ""), n[e] = r, W.forEach(function (t) {
                  n["-" + t + "-" + e] = r;
                });
              } else n[e] = t[e];
            }), n;
          }(n), Object.keys(n).forEach(function (e) {
            var r = e.replace(/^-/, "").replace(/-([a-z])/g, function (t, n) {
              return n.toUpperCase();
            });
            t.style[r] = n[e];
          });
        }

        var G,
            X = function () {
          function t(t) {
            this.updateTime = Date.now(), this.delta = {
              x: 0,
              y: 0
            }, this.velocity = {
              x: 0,
              y: 0
            }, this.lastPosition = {
              x: 0,
              y: 0
            }, this.lastPosition = F(t);
          }

          return t.prototype.update = function (t) {
            var n = this.velocity,
                e = this.updateTime,
                r = this.lastPosition,
                o = Date.now(),
                i = F(t),
                u = {
              x: -(i.x - r.x),
              y: -(i.y - r.y)
            },
                c = o - e || 16,
                s = u.x / c * 16,
                a = u.y / c * 16;
            n.x = .9 * s + .1 * n.x, n.y = .9 * a + .1 * n.y, this.delta = u, this.updateTime = o, this.lastPosition = i;
          }, t;
        }(),
            V = function () {
          function t() {
            this._touchList = {};
          }

          return Object.defineProperty(t.prototype, "_primitiveValue", {
            get: function get() {
              return {
                x: 0,
                y: 0
              };
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.isActive = function () {
            return void 0 !== this._activeTouchID;
          }, t.prototype.getDelta = function () {
            var t = this._getActiveTracker();

            return t ? _i({}, t.delta) : this._primitiveValue;
          }, t.prototype.getVelocity = function () {
            var t = this._getActiveTracker();

            return t ? _i({}, t.velocity) : this._primitiveValue;
          }, t.prototype.track = function (t) {
            var n = this,
                e = t.targetTouches;
            return Array.from(e).forEach(function (t) {
              n._add(t);
            }), this._touchList;
          }, t.prototype.update = function (t) {
            var n = this,
                e = t.touches,
                r = t.changedTouches;
            return Array.from(e).forEach(function (t) {
              n._renew(t);
            }), this._setActiveID(r), this._touchList;
          }, t.prototype.release = function (t) {
            var n = this;
            delete this._activeTouchID, Array.from(t.changedTouches).forEach(function (t) {
              n._delete(t);
            });
          }, t.prototype._add = function (t) {
            if (!this._has(t)) {
              var n = new X(t);
              this._touchList[t.identifier] = n;
            }
          }, t.prototype._renew = function (t) {
            this._has(t) && this._touchList[t.identifier].update(t);
          }, t.prototype._delete = function (t) {
            delete this._touchList[t.identifier];
          }, t.prototype._has = function (t) {
            return this._touchList.hasOwnProperty(t.identifier);
          }, t.prototype._setActiveID = function (t) {
            this._activeTouchID = t[t.length - 1].identifier;
          }, t.prototype._getActiveTracker = function () {
            return this._touchList[this._activeTouchID];
          }, t;
        }();

        !function (t) {
          t.X = "x", t.Y = "y";
        }(G || (G = {}));

        var U = function () {
          function t(t, n) {
            void 0 === n && (n = 0), this._direction = t, this._minSize = n, this.element = document.createElement("div"), this.displaySize = 0, this.realSize = 0, this.offset = 0, this.element.className = "scrollbar-thumb scrollbar-thumb-" + t;
          }

          return t.prototype.attachTo = function (t) {
            t.appendChild(this.element);
          }, t.prototype.update = function (t, n, e) {
            this.realSize = Math.min(n / e, 1) * n, this.displaySize = Math.max(this.realSize, this._minSize), this.offset = t / e * (n + (this.realSize - this.displaySize)), B(this.element, this._getStyle());
          }, t.prototype._getStyle = function () {
            switch (this._direction) {
              case G.X:
                return {
                  width: this.displaySize + "px",
                  "-transform": "translate3d(" + this.offset + "px, 0, 0)"
                };

              case G.Y:
                return {
                  height: this.displaySize + "px",
                  "-transform": "translate3d(0, " + this.offset + "px, 0)"
                };

              default:
                return null;
            }
          }, t;
        }(),
            Y = function () {
          function t(t, n) {
            void 0 === n && (n = 0), this.element = document.createElement("div"), this._isShown = !1, this.element.className = "scrollbar-track scrollbar-track-" + t, this.thumb = new U(t, n), this.thumb.attachTo(this.element);
          }

          return t.prototype.attachTo = function (t) {
            t.appendChild(this.element);
          }, t.prototype.show = function () {
            this._isShown || (this._isShown = !0, this.element.classList.add("show"));
          }, t.prototype.hide = function () {
            this._isShown && (this._isShown = !1, this.element.classList.remove("show"));
          }, t.prototype.update = function (t, n, e) {
            B(this.element, {
              display: e <= n ? "none" : "block"
            }), this.thumb.update(t, n, e);
          }, t;
        }(),
            q = function () {
          function t(t) {
            this._scrollbar = t;
            var n = t.options.thumbMinSize;
            this.xAxis = new Y(G.X, n), this.yAxis = new Y(G.Y, n), this.xAxis.attachTo(t.containerEl), this.yAxis.attachTo(t.containerEl), t.options.alwaysShowTracks && (this.xAxis.show(), this.yAxis.show());
          }

          return t.prototype.update = function () {
            var t = this._scrollbar,
                n = t.size,
                e = t.offset;
            this.xAxis.update(e.x, n.container.width, n.content.width), this.yAxis.update(e.y, n.container.height, n.content.height);
          }, t.prototype.autoHideOnIdle = function () {
            this._scrollbar.options.alwaysShowTracks || (this.xAxis.hide(), this.yAxis.hide());
          }, u([D(300)], t.prototype, "autoHideOnIdle", null), t;
        }(),
            K = new WeakMap();

        function $(t) {
          return Math.pow(t - 1, 3) + 1;
        }

        var J,
            Q,
            Z,
            tt = function () {
          function t(t, n) {
            var e = this.constructor;
            this.scrollbar = t, this.name = e.pluginName, this.options = _i(_i({}, e.defaultOptions), n);
          }

          return t.prototype.onInit = function () {}, t.prototype.onDestroy = function () {}, t.prototype.onUpdate = function () {}, t.prototype.onRender = function (t) {}, t.prototype.transformDelta = function (t, n) {
            return _i({}, t);
          }, t.pluginName = "", t.defaultOptions = {}, t;
        }(),
            nt = {
          order: new Set(),
          constructors: {}
        };

        function et(t) {
          var n = R(t),
              e = t.containerEl;
          n(e, "keydown", function (n) {
            var r = document.activeElement;

            if ((r === e || e.contains(r)) && !function (t) {
              return !("INPUT" !== t.tagName && "SELECT" !== t.tagName && "TEXTAREA" !== t.tagName && !t.isContentEditable) && !t.disabled;
            }(r)) {
              var o = function (t, n) {
                var e = t.size,
                    r = t.limit,
                    o = t.offset;

                switch (n) {
                  case J.TAB:
                    return function (t) {
                      requestAnimationFrame(function () {
                        t.scrollIntoView(document.activeElement, {
                          offsetTop: t.size.container.height / 2,
                          onlyScrollIfNeeded: !0
                        });
                      });
                    }(t);

                  case J.SPACE:
                    return [0, 200];

                  case J.PAGE_UP:
                    return [0, 40 - e.container.height];

                  case J.PAGE_DOWN:
                    return [0, e.container.height - 40];

                  case J.END:
                    return [0, r.y - o.y];

                  case J.HOME:
                    return [0, -o.y];

                  case J.LEFT:
                    return [-40, 0];

                  case J.UP:
                    return [0, -40];

                  case J.RIGHT:
                    return [40, 0];

                  case J.DOWN:
                    return [0, 40];

                  default:
                    return null;
                }
              }(t, n.keyCode || n.which);

              if (o) {
                var i = o[0],
                    u = o[1];
                t.addTransformableMomentum(i, u, n, function (e) {
                  e ? n.preventDefault() : (t.containerEl.blur(), t.parent && t.parent.containerEl.focus());
                });
              }
            }
          });
        }

        function rt(t) {
          var n,
              e,
              r,
              o,
              i,
              u = R(t),
              c = t.containerEl,
              s = t.track,
              a = s.xAxis,
              f = s.yAxis;

          function l(n, e) {
            var r = t.size;
            return n === Q.X ? e / (r.container.width + (a.thumb.realSize - a.thumb.displaySize)) * r.content.width : n === Q.Y ? e / (r.container.height + (f.thumb.realSize - f.thumb.displaySize)) * r.content.height : 0;
          }

          function p(t) {
            return I(t, [a.element, a.thumb.element]) ? Q.X : I(t, [f.element, f.thumb.element]) ? Q.Y : void 0;
          }

          u(c, "click", function (n) {
            if (!e && I(n.target, [a.element, f.element])) {
              var r = n.target,
                  o = p(r),
                  i = r.getBoundingClientRect(),
                  u = F(n),
                  c = t.offset,
                  s = t.limit;

              if (o === Q.X) {
                var h = u.x - i.left - a.thumb.displaySize / 2;
                t.setMomentum(O(l(o, h) - c.x, -c.x, s.x - c.x), 0);
              }

              o === Q.Y && (h = u.y - i.top - f.thumb.displaySize / 2, t.setMomentum(0, O(l(o, h) - c.y, -c.y, s.y - c.y)));
            }
          }), u(c, "mousedown", function (e) {
            if (I(e.target, [a.thumb.element, f.thumb.element])) {
              n = !0;
              var u = e.target,
                  s = F(e),
                  l = u.getBoundingClientRect();
              o = p(u), r = {
                x: s.x - l.left,
                y: s.y - l.top
              }, i = c.getBoundingClientRect(), B(t.containerEl, {
                "-user-select": "none"
              });
            }
          }), u(window, "mousemove", function (u) {
            if (n) {
              e = !0;
              var c = t.offset,
                  s = F(u);

              if (o === Q.X) {
                var a = s.x - r.x - i.left;
                t.setPosition(l(o, a), c.y);
              }

              o === Q.Y && (a = s.y - r.y - i.top, t.setPosition(c.x, l(o, a)));
            }
          }), u(window, "mouseup blur", function () {
            n = e = !1, B(t.containerEl, {
              "-user-select": ""
            });
          });
        }

        function ot(t) {
          R(t)(window, "resize", k(t.update.bind(t), 300));
        }

        function it(t) {
          var n,
              e = R(t),
              r = t.containerEl,
              o = t.contentEl,
              i = t.offset,
              u = t.limit,
              c = !1;
          e(window, "mousemove", function (e) {
            c && (cancelAnimationFrame(n), function e(r) {
              var o = r.x,
                  c = r.y;
              (o || c) && (t.setMomentum(O(i.x + o, 0, u.x) - i.x, O(i.y + c, 0, u.y) - i.y), n = requestAnimationFrame(function () {
                e({
                  x: o,
                  y: c
                });
              }));
            }(function (t, n) {
              var e = t.bounding,
                  r = e.top,
                  o = e.right,
                  i = e.bottom,
                  u = e.left,
                  c = F(n),
                  s = c.x,
                  a = c.y,
                  f = {
                x: 0,
                y: 0
              };
              return 0 === s && 0 === a || (s > o - 20 ? f.x = s - o + 20 : s < u + 20 && (f.x = s - u - 20), a > i - 20 ? f.y = a - i + 20 : a < r + 20 && (f.y = a - r - 20), f.x *= 2, f.y *= 2), f;
            }(t, e)));
          }), e(o, "selectstart", function (t) {
            t.stopPropagation(), cancelAnimationFrame(n), c = !0;
          }), e(window, "mouseup blur", function () {
            cancelAnimationFrame(n), c = !1;
          }), e(r, "scroll", function (t) {
            t.preventDefault(), r.scrollTop = r.scrollLeft = 0;
          });
        }

        function ut(t) {
          var n,
              e = /Android/.test(navigator.userAgent) ? 3 : 2,
              r = t.options.delegateTo || t.containerEl,
              o = new V(),
              i = R(t),
              u = 0;
          i(r, "touchstart", function (e) {
            o.track(e), t.setMomentum(0, 0), 0 === u && (n = t.options.damping, t.options.damping = Math.max(n, .5)), u++;
          }), i(r, "touchmove", function (n) {
            if (!Z || Z === t) {
              o.update(n);
              var e = o.getDelta(),
                  r = e.x,
                  i = e.y;
              t.addTransformableMomentum(r, i, n, function (e) {
                e && n.cancelable && (n.preventDefault(), Z = t);
              });
            }
          }), i(r, "touchcancel touchend", function (r) {
            var i = o.getVelocity(),
                c = {
              x: 0,
              y: 0
            };
            Object.keys(i).forEach(function (t) {
              var r = i[t] / n;
              c[t] = Math.abs(r) < 50 ? 0 : r * e;
            }), t.addTransformableMomentum(c.x, c.y, r), 0 == --u && (t.options.damping = n), o.release(r), Z = null;
          });
        }

        function ct(t) {
          R(t)(t.options.delegateTo || t.containerEl, "onwheel" in window || document.implementation.hasFeature("Events.wheel", "3.0") ? "wheel" : "mousewheel", function (n) {
            var e = function (t) {
              if ("deltaX" in t) {
                var n = ft(t.deltaMode);
                return {
                  x: t.deltaX / st.STANDARD * n,
                  y: t.deltaY / st.STANDARD * n
                };
              }

              return "wheelDeltaX" in t ? {
                x: t.wheelDeltaX / st.OTHERS,
                y: t.wheelDeltaY / st.OTHERS
              } : {
                x: 0,
                y: t.wheelDelta / st.OTHERS
              };
            }(n),
                r = e.x,
                o = e.y;

            t.addTransformableMomentum(r, o, n, function (t) {
              t && n.preventDefault();
            });
          });
        }

        !function (t) {
          t[t.TAB = 9] = "TAB", t[t.SPACE = 32] = "SPACE", t[t.PAGE_UP = 33] = "PAGE_UP", t[t.PAGE_DOWN = 34] = "PAGE_DOWN", t[t.END = 35] = "END", t[t.HOME = 36] = "HOME", t[t.LEFT = 37] = "LEFT", t[t.UP = 38] = "UP", t[t.RIGHT = 39] = "RIGHT", t[t.DOWN = 40] = "DOWN";
        }(J || (J = {})), function (t) {
          t[t.X = 0] = "X", t[t.Y = 1] = "Y";
        }(Q || (Q = {}));

        var st = {
          STANDARD: 1,
          OTHERS: -3
        },
            at = [1, 28, 500],
            ft = function ft(t) {
          return at[t] || at[0];
        },
            lt = new Map(),
            pt = function () {
          function t(t, n) {
            var e = this;
            this.offset = {
              x: 0,
              y: 0
            }, this.limit = {
              x: 1 / 0,
              y: 1 / 0
            }, this.bounding = {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }, this._plugins = [], this._momentum = {
              x: 0,
              y: 0
            }, this._listeners = new Set(), this.containerEl = t;
            var r = this.contentEl = document.createElement("div");
            this.options = new N(n), t.setAttribute("data-scrollbar", "true"), t.setAttribute("tabindex", "-1"), B(t, {
              overflow: "hidden",
              outline: "none"
            }), window.navigator.msPointerEnabled && (t.style.msTouchAction = "none"), r.className = "scroll-content", Array.from(t.childNodes).forEach(function (t) {
              r.appendChild(t);
            }), t.appendChild(r), this.track = new q(this), this.size = this.getSize(), this._plugins = function (t, n) {
              return Array.from(nt.order).filter(function (t) {
                return !1 !== n[t];
              }).map(function (e) {
                var r = new (nt.constructors[e])(t, n[e]);
                return n[e] = r.options, r;
              });
            }(this, this.options.plugins);
            var o = t.scrollLeft,
                i = t.scrollTop;
            t.scrollLeft = t.scrollTop = 0, this.setPosition(o, i, {
              withoutCallbacks: !0
            });
            var u = window,
                c = u.MutationObserver || u.WebKitMutationObserver || u.MozMutationObserver;
            "function" == typeof c && (this._observer = new c(function () {
              e.update();
            }), this._observer.observe(r, {
              subtree: !0,
              childList: !0
            })), lt.set(t, this), requestAnimationFrame(function () {
              e._init();
            });
          }

          return Object.defineProperty(t.prototype, "parent", {
            get: function get() {
              for (var t = this.containerEl.parentElement; t;) {
                var n = lt.get(t);
                if (n) return n;
                t = t.parentElement;
              }

              return null;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "scrollTop", {
            get: function get() {
              return this.offset.y;
            },
            set: function set(t) {
              this.setPosition(this.scrollLeft, t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "scrollLeft", {
            get: function get() {
              return this.offset.x;
            },
            set: function set(t) {
              this.setPosition(t, this.scrollTop);
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.getSize = function () {
            return function (t) {
              var n = t.containerEl,
                  e = t.contentEl;
              return {
                container: {
                  width: n.clientWidth,
                  height: n.clientHeight
                },
                content: {
                  width: e.offsetWidth - e.clientWidth + e.scrollWidth,
                  height: e.offsetHeight - e.clientHeight + e.scrollHeight
                }
              };
            }(this);
          }, t.prototype.update = function () {
            !function (t) {
              var n = t.getSize(),
                  e = {
                x: Math.max(n.content.width - n.container.width, 0),
                y: Math.max(n.content.height - n.container.height, 0)
              },
                  r = t.containerEl.getBoundingClientRect(),
                  o = {
                top: Math.max(r.top, 0),
                right: Math.min(r.right, window.innerWidth),
                bottom: Math.min(r.bottom, window.innerHeight),
                left: Math.max(r.left, 0)
              };
              t.size = n, t.limit = e, t.bounding = o, t.track.update(), t.setPosition();
            }(this), this._plugins.forEach(function (t) {
              t.onUpdate();
            });
          }, t.prototype.isVisible = function (t) {
            return function (t, n) {
              var e = t.bounding,
                  r = n.getBoundingClientRect(),
                  o = Math.max(e.top, r.top),
                  i = Math.max(e.left, r.left),
                  u = Math.min(e.right, r.right);
              return o < Math.min(e.bottom, r.bottom) && i < u;
            }(this, t);
          }, t.prototype.setPosition = function (t, n, e) {
            var r = this;
            void 0 === t && (t = this.offset.x), void 0 === n && (n = this.offset.y), void 0 === e && (e = {});

            var o = function (t, n, e) {
              var r = t.options,
                  o = t.offset,
                  u = t.limit,
                  c = t.track,
                  s = t.contentEl;
              return r.renderByPixels && (n = Math.round(n), e = Math.round(e)), n = O(n, 0, u.x), e = O(e, 0, u.y), n !== o.x && c.xAxis.show(), e !== o.y && c.yAxis.show(), r.alwaysShowTracks || c.autoHideOnIdle(), n === o.x && e === o.y ? null : (o.x = n, o.y = e, B(s, {
                "-transform": "translate3d(" + -n + "px, " + -e + "px, 0)"
              }), c.update(), {
                offset: _i({}, o),
                limit: _i({}, u)
              });
            }(this, t, n);

            o && !e.withoutCallbacks && this._listeners.forEach(function (t) {
              t.call(r, o);
            });
          }, t.prototype.scrollTo = function (t, n, e, r) {
            void 0 === t && (t = this.offset.x), void 0 === n && (n = this.offset.y), void 0 === e && (e = 0), void 0 === r && (r = {}), function (t, n, e, r, o) {
              void 0 === r && (r = 0);
              var i = void 0 === o ? {} : o,
                  u = i.easing,
                  c = void 0 === u ? $ : u,
                  s = i.callback,
                  a = t.options,
                  f = t.offset,
                  l = t.limit;
              a.renderByPixels && (n = Math.round(n), e = Math.round(e));
              var p = f.x,
                  h = f.y,
                  d = O(n, 0, l.x) - p,
                  v = O(e, 0, l.y) - h,
                  y = Date.now();
              cancelAnimationFrame(K.get(t)), function n() {
                var e = Date.now() - y,
                    o = r ? c(Math.min(e / r, 1)) : 1;
                if (t.setPosition(p + d * o, h + v * o), e >= r) "function" == typeof s && s.call(t);else {
                  var i = requestAnimationFrame(n);
                  K.set(t, i);
                }
              }();
            }(this, t, n, e, r);
          }, t.prototype.scrollIntoView = function (t, n) {
            void 0 === n && (n = {}), function (t, n, e) {
              var r = void 0 === e ? {} : e,
                  o = r.alignToTop,
                  i = void 0 === o || o,
                  u = r.onlyScrollIfNeeded,
                  c = void 0 !== u && u,
                  s = r.offsetTop,
                  a = void 0 === s ? 0 : s,
                  f = r.offsetLeft,
                  l = void 0 === f ? 0 : f,
                  p = r.offsetBottom,
                  h = void 0 === p ? 0 : p,
                  d = t.containerEl,
                  v = t.bounding,
                  y = t.offset,
                  m = t.limit;

              if (n && d.contains(n)) {
                var g = n.getBoundingClientRect();

                if (!c || !t.isVisible(n)) {
                  var b = i ? g.top - v.top - a : g.bottom - v.bottom + h;
                  t.setMomentum(g.left - v.left - l, O(b, -y.y, m.y - y.y));
                }
              }
            }(this, t, n);
          }, t.prototype.addListener = function (t) {
            if ("function" != typeof t) throw new TypeError("[smooth-scrollbar] scrolling listener should be a function");

            this._listeners.add(t);
          }, t.prototype.removeListener = function (t) {
            this._listeners.delete(t);
          }, t.prototype.addTransformableMomentum = function (t, n, e, r) {
            this._updateDebounced();

            var o = this._plugins.reduce(function (t, n) {
              return n.transformDelta(t, e) || t;
            }, {
              x: t,
              y: n
            }),
                i = !this._shouldPropagateMomentum(o.x, o.y);

            i && this.addMomentum(o.x, o.y), r && r.call(this, i);
          }, t.prototype.addMomentum = function (t, n) {
            this.setMomentum(this._momentum.x + t, this._momentum.y + n);
          }, t.prototype.setMomentum = function (t, n) {
            0 === this.limit.x && (t = 0), 0 === this.limit.y && (n = 0), this.options.renderByPixels && (t = Math.round(t), n = Math.round(n)), this._momentum.x = t, this._momentum.y = n;
          }, t.prototype.updatePluginOptions = function (t, n) {
            this._plugins.forEach(function (e) {
              e.name === t && Object.assign(e.options, n);
            });
          }, t.prototype.destroy = function () {
            var t = this.containerEl,
                n = this.contentEl;
            !function (t) {
              var n = z.get(t);
              n && (n.forEach(function (t) {
                var n = t.elem,
                    e = t.eventName,
                    r = t.handler;
                n.removeEventListener(e, r, C());
              }), z.delete(t));
            }(this), this._listeners.clear(), this.setMomentum(0, 0), cancelAnimationFrame(this._renderID), this._observer && this._observer.disconnect(), lt.delete(this.containerEl);

            for (var e = Array.from(n.childNodes); t.firstChild;) {
              t.removeChild(t.firstChild);
            }

            e.forEach(function (n) {
              t.appendChild(n);
            }), B(t, {
              overflow: ""
            }), t.scrollTop = this.scrollTop, t.scrollLeft = this.scrollLeft, this._plugins.forEach(function (t) {
              t.onDestroy();
            }), this._plugins.length = 0;
          }, t.prototype._init = function () {
            var t = this;
            this.update(), Object.keys(r).forEach(function (n) {
              r[n](t);
            }), this._plugins.forEach(function (t) {
              t.onInit();
            }), this._render();
          }, t.prototype._updateDebounced = function () {
            this.update();
          }, t.prototype._shouldPropagateMomentum = function (t, n) {
            void 0 === t && (t = 0), void 0 === n && (n = 0);
            var e = this.options,
                r = this.offset,
                o = this.limit;
            if (!e.continuousScrolling) return !1;
            0 === o.x && 0 === o.y && this._updateDebounced();
            var i = O(t + r.x, 0, o.x),
                u = O(n + r.y, 0, o.y),
                c = !0;
            return (c = (c = c && i === r.x) && u === r.y) && (r.x === o.x || 0 === r.x || r.y === o.y || 0 === r.y);
          }, t.prototype._render = function () {
            var t = this._momentum;

            if (t.x || t.y) {
              var n = this._nextTick("x"),
                  e = this._nextTick("y");

              t.x = n.momentum, t.y = e.momentum, this.setPosition(n.position, e.position);
            }

            var r = _i({}, this._momentum);

            this._plugins.forEach(function (t) {
              t.onRender(r);
            }), this._renderID = requestAnimationFrame(this._render.bind(this));
          }, t.prototype._nextTick = function (t) {
            var n = this.options,
                e = this.offset,
                r = this._momentum,
                o = e[t],
                i = r[t];
            if (Math.abs(i) <= .1) return {
              momentum: 0,
              position: o + i
            };
            var u = i * (1 - n.damping);
            return n.renderByPixels && (u |= 0), {
              momentum: u,
              position: o + i - u
            };
          }, u([D(100, {
            leading: !0
          })], t.prototype, "_updateDebounced", null), t;
        }(),
            ht = "smooth-scrollbar-style",
            dt = !1;

        function vt() {
          if (!dt && "undefined" != typeof window) {
            var t = document.createElement("style");
            t.id = ht, t.textContent = "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: rgba(222, 222, 222, .75);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: rgba(0, 0, 0, .5);\n  border-radius: 4px;\n}\n", document.head && document.head.appendChild(t), dt = !0;
          }
        }

        e.d(n, "ScrollbarPlugin", function () {
          return tt;
        });
        /*!
         * cast `I.Scrollbar` to `Scrollbar` to avoid error
         *
         * `I.Scrollbar` is not assignable to `Scrollbar`:
         *     "privateProp" is missing in `I.Scrollbar`
         *
         * @see https://github.com/Microsoft/TypeScript/issues/2672
         */

        var yt = function (t) {
          function n() {
            return null !== t && t.apply(this, arguments) || this;
          }

          return function (t, n) {
            function e() {
              this.constructor = t;
            }

            _o(t, n), t.prototype = null === n ? Object.create(n) : (e.prototype = n.prototype, new e());
          }(n, t), n.init = function (t, n) {
            if (!t || 1 !== t.nodeType) throw new TypeError("expect element to be DOM Element, but got " + t);
            return vt(), lt.has(t) ? lt.get(t) : new pt(t, n);
          }, n.initAll = function (t) {
            return Array.from(document.querySelectorAll("[data-scrollbar]"), function (e) {
              return n.init(e, t);
            });
          }, n.has = function (t) {
            return lt.has(t);
          }, n.get = function (t) {
            return lt.get(t);
          }, n.getAll = function () {
            return Array.from(lt.values());
          }, n.destroy = function (t) {
            var n = lt.get(t);
            n && n.destroy();
          }, n.destroyAll = function () {
            lt.forEach(function (t) {
              t.destroy();
            });
          }, n.use = function () {
            for (var t = [], n = 0; n < arguments.length; n++) {
              t[n] = arguments[n];
            }

            return function () {
              for (var t = [], n = 0; n < arguments.length; n++) {
                t[n] = arguments[n];
              }

              t.forEach(function (t) {
                var n = t.pluginName;
                if (!n) throw new TypeError("plugin name is required");
                nt.order.add(n), nt.constructors[n] = t;
              });
            }.apply(void 0, t);
          }, n.attachStyle = function () {
            return vt();
          }, n.detachStyle = function () {
            return function () {
              if (dt && "undefined" != typeof window) {
                var t = document.getElementById(ht);
                t && t.parentNode && (t.parentNode.removeChild(t), dt = !1);
              }
            }();
          }, n.version = "8.5.3", n.ScrollbarPlugin = tt, n;
        }(pt);

        n.default = yt;
      }]).default;
    });
  });
  var Scrollbar = unwrapExports(smoothScrollbar);
  var smoothScrollbar_1 = smoothScrollbar.Scrollbar;

  //
  var script$i = {
    data: function data() {
      return {
        localValue: null,
        open: false,
        filteredOptions: null,
        inputValue: this.localValue
      };
    },
    props: {
      field: {
        default: null,
        required: true,
        instanceScroll: null
      },
      value: {
        default: null
      }
    },
    computed: {
      activeOption: function activeOption() {
        var _this = this;

        if (this.field && this.field.options && this.field.options.length) {
          return this.field.options.find(function (option) {
            return option.value === _this.localValue;
          });
        }

        return null;
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      },
      open: function open(oldValue, newValue) {
        var _this2 = this;

        this.$nextTick(function () {
          if (oldValue) {
            _this2.instanceScroll.update();
          }
        });
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
        this.inputValue = this.activeOption ? this.activeOption.text : null;
      },
      handleInput: function handleInput() {
        var _this3 = this;

        this.$emit('input', this.localValue);
        this.$nextTick(function () {
          _this3.filteredOptions = null;
        });
      },
      handleClickOutside: function handleClickOutside(e) {
        if (!this.$el.contains(e.target) && !(this.field.search && this.inputValue.length && this.filteredOptions && !this.filteredOptions.length && controller.touch)) {
          var _this$activeOption;

          this.inputValue = (_this$activeOption = this.activeOption) === null || _this$activeOption === void 0 ? void 0 : _this$activeOption.text;
          this.open = false;
        }
      },
      handleEsc: function handleEsc(e) {
        if (e.keyCode == 27) {
          this.open = false;
        }
      },
      handleSearch: function handleSearch() {
        var _this4 = this;

        this.filteredOptions = this.field.options.filter(function (option) {
          return option.text.toLowerCase().indexOf(_this4.inputValue.toLowerCase()) !== -1;
        }) || null;
      }
    },
    created: function created() {
      this.updateLocalValue();
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleEsc);
    },
    mounted: function mounted() {
      this.instanceScroll = Scrollbar.init(this.$refs.list, {
        continuousScrolling: false
      });
    },
    destroyed: function destroyed() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleEsc);
    }
  };

  /* script */
  const __vue_script__$i = script$i;

  /* template */
  var __vue_render__$e = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-field-select field-select",
        class: {
          "field-select--open": _vm.open,
          "field-select--sm": _vm.field.size === "sm",
        },
      },
      [
        _vm.field.search
          ? _c(
              "div",
              {
                staticClass: "field-select__btn",
                on: {
                  click: function ($event) {
                    _vm.open = !_vm.open;
                  },
                },
              },
              [
                _c("transition", { attrs: { name: "fade", mode: "out-in" } }),
                _vm.field.label
                  ? _c("span", { staticClass: "field-select__btn-label-top" }, [
                      _vm._v(_vm._s(_vm.field.label)),
                    ])
                  : _vm._e(),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputValue,
                      expression: "inputValue",
                    },
                  ],
                  key: "text",
                  staticClass: "field-select__btn-text",
                  attrs: { type: "text", plaseholder: _vm.field.placeholder },
                  domProps: { value: _vm.inputValue },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation();
                      _vm.open = true;
                    },
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.inputValue = $event.target.value;
                      },
                      _vm.handleSearch,
                    ],
                  },
                }),
                _c("svg", { staticClass: "svg-icon field-select__btn-arrow" }, [
                  _c("use", {
                    attrs: { "xlink:href": "#svg-icon-chevron-down-sm" },
                  }),
                ]),
              ],
              1
            )
          : _c(
              "button",
              {
                staticClass: "field-select__btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.open = !_vm.open;
                  },
                },
              },
              [
                _c("transition", { attrs: { name: "fade", mode: "out-in" } }),
                _vm.field.label
                  ? _c("span", { staticClass: "field-select__btn-label-top" }, [
                      _vm._v(_vm._s(_vm.field.label)),
                    ])
                  : _vm._e(),
                !_vm.activeOption && _vm.field.placeholder
                  ? _c(
                      "span",
                      {
                        key: "placeholder",
                        staticClass: "field-select__btn-placeholder",
                      },
                      [_vm._v(_vm._s(_vm.field.placeholder))]
                    )
                  : _vm.activeOption
                  ? _c("span", {
                      key: "text",
                      staticClass: "field-select__btn-text",
                      domProps: { innerHTML: _vm._s(_vm.activeOption.text) },
                    })
                  : _vm._e(),
                _c("svg", { staticClass: "svg-icon field-select__btn-arrow" }, [
                  _c("use", {
                    attrs: { "xlink:href": "#svg-icon-chevron-down-sm" },
                  }),
                ]),
              ],
              1
            ),
        _c(
          "transition",
          {
            attrs: { name: "dropdown" },
            on: {
              "after-leave": function ($event) {
                _vm.filteredOptions = null;
              },
            },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.field && _vm.open,
                    expression: "field && open",
                  },
                ],
                ref: "list",
                staticClass: "field-select__list",
                on: {
                  click: function ($event) {
                    _vm.open = false;
                  },
                },
              },
              [
                _c("transition", { attrs: { name: "dropdown-inner" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.open,
                          expression: "open",
                        },
                      ],
                      staticClass: "field-select__list-container",
                    },
                    [
                      _vm._l(
                        _vm.filteredOptions || _vm.field.options,
                        function (option) {
                          return _c("button", {
                            staticClass: "field-select__list-item",
                            class: {
                              "field-select__list-item--active":
                                option.value === _vm.localValue,
                            },
                            attrs: { type: "button" },
                            domProps: { innerHTML: _vm._s(option.text) },
                            on: {
                              click: function ($event) {
                                _vm.localValue = option.value;
                                _vm.handleInput();
                              },
                            },
                          })
                        }
                      ),
                      _vm._l(_vm.field.modals, function (link) {
                        return _c(
                          "button",
                          {
                            staticClass:
                              "field-select__list-item field-select__list-item--modal js-open-modal",
                            attrs: {
                              type: "button",
                              "data-modal-url": link.url,
                              "data-modal-data": link.attr,
                            },
                          },
                          [
                            _vm._v(_vm._s(link.text)),
                            _c(
                              "svg",
                              { staticClass: "svg-icon svg-icon--arrow-right" },
                              [
                                _c("use", {
                                  attrs: {
                                    "xlink:href": "#svg-icon-arrow-right",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm.field.search &&
                      _vm.inputValue.length &&
                      _vm.filteredOptions &&
                      !_vm.filteredOptions.length
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "field-select__list-item field-select__list-item--no-hover",
                            },
                            [_vm._v("По Вашему запросу ничего не найдено")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ],
              1
            ),
          ]
        ),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$e = [];
  __vue_render__$e._withStripped = true;

    /* style */
    const __vue_inject_styles__$i = undefined;
    /* scoped */
    const __vue_scope_id__$i = undefined;
    /* module identifier */
    const __vue_module_identifier__$i = undefined;
    /* functional template */
    const __vue_is_functional_template__$i = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$i = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
      __vue_inject_styles__$i,
      __vue_script__$i,
      __vue_scope_id__$i,
      __vue_is_functional_template__$i,
      __vue_module_identifier__$i,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$j = {
    data: function data() {
      return {
        localValue: null,
        open: false,
        height: 'auto'
      };
    },
    props: {
      radio: {
        type: Boolean,
        default: false
      },
      field: {
        default: null
      },
      value: {
        default: null
      }
    },
    computed: {
      computedLimit: function computedLimit() {
        return this.field.limit || 1000;
      }
    },
    watch: _defineProperty({
      value: function value() {
        this.updateLocalValue();
      }
    }, 'field.options', function fieldOptions() {
      var _this = this;

      this.$nextTick(function () {
        _this.open = false;

        _this.calculateHeightList(true);
      });
    }),
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      toggleOptions: function toggleOptions() {
        this.open = !this.open;
        this.calculateHeightList();
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      },
      // подсчет лимитированой высоты списка и полной
      calculateHeightList: function calculateHeightList(always) {
        var _this2 = this;

        if (this.$refs.items.length > this.computedLimit || always) {
          var heightItems = 0; // подсчет высоты пунктов в лимите

          Array.from(this.$refs.items).forEach(function (item, index) {
            if (index + 1 < _this2.computedLimit) {
              heightItems += parseFloat(item.offsetHeight) + parseFloat(window.getComputedStyle(item, null).marginBottom);
            } else if (index + 1 == _this2.computedLimit) {
              heightItems += parseFloat(item.offsetHeight);
            }
          });

          if (this.open) {
            this.height = this.$refs.list.scrollHeight + 'px';
          } else {
            this.height = heightItems + 'px';
          }
        }
      }
    },
    created: function created() {
      this.updateLocalValue();
    },
    mounted: function mounted() {
      this.calculateHeightList();
      window.addEventListener('resize', this.calculateHeightList);
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.calculateHeightList);
    }
  };

  /* script */
  const __vue_script__$j = script$j;

  /* template */
  var __vue_render__$f = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-field-check-list field-check-list" }, [
      _c(
        "div",
        {
          ref: "list",
          staticClass: "field-check-list__content",
          style: { height: _vm.height },
        },
        _vm._l(_vm.field.options, function (option, index) {
          return _c(
            "div",
            {
              key: option.value + "-" + index,
              ref: "items",
              refInFor: true,
              staticClass: "field-check-list__item flc",
            },
            [
              _c("v-field-checkbox", {
                attrs: {
                  "true-value": option.value,
                  text: option.text,
                  count: option.count,
                  subtext: option.subtext,
                  disabled: option.disabled || _vm.field.disabled,
                  radio: _vm.radio,
                },
                on: { input: _vm.handleInput },
                model: {
                  value: _vm.localValue,
                  callback: function ($$v) {
                    _vm.localValue = $$v;
                  },
                  expression: "localValue",
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm.field.options.length > _vm.computedLimit
        ? _c(
            "button",
            {
              staticClass: "filter__expand-btn btn-expand-more",
              class: { "btn-expand-more__hide": _vm.open },
              attrs: { type: "button" },
              on: {
                click: _vm.toggleOptions,
                mousedown: function ($event) {
                  $event.preventDefault();
                },
              },
            },
            [
              !_vm.open
                ? _c("span", { staticClass: "btn-expand-more__content" }, [
                    _vm._v("Показать все"),
                  ])
                : _c("span", { staticClass: "btn-expand-more__content" }, [
                    _vm._v("Скрыть все"),
                  ]),
              _c("svg", { staticClass: "svg-icon btn-expand-more__icon" }, [
                _c("use", {
                  attrs: { "xlink:href": "#svg-icon-chevron-down-sm" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$f = [];
  __vue_render__$f._withStripped = true;

    /* style */
    const __vue_inject_styles__$j = undefined;
    /* scoped */
    const __vue_scope_id__$j = undefined;
    /* module identifier */
    const __vue_module_identifier__$j = undefined;
    /* functional template */
    const __vue_is_functional_template__$j = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$j = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
      __vue_inject_styles__$j,
      __vue_script__$j,
      __vue_scope_id__$j,
      __vue_is_functional_template__$j,
      __vue_module_identifier__$j,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  var script$k = {
    data: function data() {
      return {
        localValue: null,
        open: false,
        height: 'auto'
      };
    },
    props: {
      radio: {
        type: Boolean,
        default: false
      },
      field: {
        default: null
      },
      value: {
        default: null
      }
    },
    computed: {
      computedLimit: function computedLimit() {
        return this.field.limit || 1000;
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$k = script$k;

  /* template */
  var __vue_render__$g = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-field-tag-list field-tag-list" }, [
      _c(
        "div",
        { staticClass: "field-tag-list__content" },
        _vm._l(_vm.field.options, function (option, index) {
          return _c(
            "div",
            {
              key: option.value + "-" + index,
              staticClass: "field-tag-list__item flc",
            },
            [
              _c("v-field-tag", {
                attrs: {
                  "true-value": option.value,
                  text: option.text,
                  count: option.count,
                  subtext: option.subtext,
                  disabled: option.disabled || _vm.field.disabled,
                  radio: _vm.radio,
                },
                on: { input: _vm.handleInput },
                model: {
                  value: _vm.localValue,
                  callback: function ($$v) {
                    _vm.localValue = $$v;
                  },
                  expression: "localValue",
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ])
  };
  var __vue_staticRenderFns__$g = [];
  __vue_render__$g._withStripped = true;

    /* style */
    const __vue_inject_styles__$k = undefined;
    /* scoped */
    const __vue_scope_id__$k = undefined;
    /* module identifier */
    const __vue_module_identifier__$k = undefined;
    /* functional template */
    const __vue_is_functional_template__$k = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$k = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
      __vue_inject_styles__$k,
      __vue_script__$k,
      __vue_scope_id__$k,
      __vue_is_functional_template__$k,
      __vue_module_identifier__$k,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$l = {
    data: function data() {
      return {
        open: false,
        height: 'auto'
      };
    },
    props: {
      field: {
        default: null
      }
    },
    computed: {
      computedLimit: function computedLimit() {
        return this.field.limit || 1000;
      }
    },
    watch: {
      field: function field() {
        this.calculateHeightList();
      }
    },
    methods: {
      toggleOptions: function toggleOptions() {
        this.open = !this.open;
        this.calculateHeightList();
      },
      // подсчет лимитированой высоты списка и полной
      calculateHeightList: function calculateHeightList() {
        var _this = this;

        var heightItems = 0;
        Array.from(this.$refs.items).forEach(function (item, index) {
          if (index + 1 < _this.computedLimit) {
            heightItems += parseFloat(item.offsetHeight) + parseFloat(window.getComputedStyle(item, null).marginBottom);
          } else if (index + 1 == _this.computedLimit) {
            heightItems += parseFloat(item.offsetHeight);
          }
        });

        if (this.open) {
          this.height = this.$refs.list.scrollHeight + 'px';
        } else {
          this.height = heightItems + 'px';
        }
      }
    },
    mounted: function mounted() {
      this.calculateHeightList();
      window.addEventListener('resize', this.calculateHeightList);
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.calculateHeightList);
    }
  };

  /* script */
  const __vue_script__$l = script$l;

  /* template */
  var __vue_render__$h = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-link-list link-list" }, [
      _c(
        "div",
        {
          ref: "list",
          staticClass: "link-list__content",
          style: { height: _vm.height },
        },
        _vm._l(_vm.field.links, function (link, index) {
          return _c(
            "div",
            {
              key: link.id,
              ref: "items",
              refInFor: true,
              staticClass: "link-list__item flc",
            },
            [
              _c(
                "a",
                { staticClass: "link-list__link", attrs: { href: link.url } },
                [
                  _c("span", { staticClass: "link-list__link-text" }, [
                    _vm._v(_vm._s(link.text)),
                  ]),
                  link.count
                    ? _c("span", { staticClass: "link-list__link-count" }, [
                        _vm._v(_vm._s(link.count)),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm.field.links.length > _vm.computedLimit
        ? _c(
            "button",
            {
              staticClass: "filter__expand-btn btn-expand-more",
              class: { "btn-expand-more__hide": _vm.open },
              on: { click: _vm.toggleOptions },
            },
            [
              !_vm.open
                ? _c("span", { staticClass: "btn-expand-more__content" }, [
                    _vm._v("Показать все"),
                  ])
                : _c("span", { staticClass: "btn-expand-more__content" }, [
                    _vm._v("Скрыть все"),
                  ]),
              _c("svg", { staticClass: "svg-icon btn-expand-more__icon" }, [
                _c("use", {
                  attrs: { "xlink:href": "#svg-icon-chevron-down-sm" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$h = [];
  __vue_render__$h._withStripped = true;

    /* style */
    const __vue_inject_styles__$l = undefined;
    /* scoped */
    const __vue_scope_id__$l = undefined;
    /* module identifier */
    const __vue_module_identifier__$l = undefined;
    /* functional template */
    const __vue_is_functional_template__$l = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$l = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
      __vue_inject_styles__$l,
      __vue_script__$l,
      __vue_scope_id__$l,
      __vue_is_functional_template__$l,
      __vue_module_identifier__$l,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$m = {
    data: function data() {
      return {
        localValue: null
      };
    },
    props: {
      field: {
        default: null
      },
      text: {
        default: null
      },
      value: {
        default: null
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$m = script$m;

  /* template */
  var __vue_render__$i = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-field-check-blocks field-check-blocks" },
      _vm._l(_vm.field.options, function (option, index) {
        return _vm.field
          ? _c(
              "div",
              {
                key: option.value + "-" + index,
                staticClass: "field-check-blocks__item flc",
              },
              [
                _c("label", { staticClass: "field-check-blocks__label" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.localValue,
                        expression: "localValue",
                      },
                    ],
                    staticClass: "field-check-blocks__input",
                    attrs: { type: "radio" },
                    domProps: {
                      value: option.value,
                      checked: _vm._q(_vm.localValue, option.value),
                    },
                    on: {
                      change: [
                        function ($event) {
                          _vm.localValue = option.value;
                        },
                        _vm.handleInput,
                      ],
                    },
                  }),
                  _c("span", { staticClass: "field-check-blocks__visual" }),
                  _c("span", { staticClass: "field-check-blocks__content" }, [
                    _c("span", { staticClass: "field-check-blocks__icon" }, [
                      _c("svg", { staticClass: "svg-icon svg-icon--full-size" }, [
                        _c("use", {
                          attrs: { "xlink:href": "#svg-icon-" + option.icon },
                        }),
                      ]),
                    ]),
                    _c("span", { staticClass: "field-check-blocks__text" }, [
                      _vm._v(_vm._s(option.text)),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e()
      }),
      0
    )
  };
  var __vue_staticRenderFns__$i = [];
  __vue_render__$i._withStripped = true;

    /* style */
    const __vue_inject_styles__$m = undefined;
    /* scoped */
    const __vue_scope_id__$m = undefined;
    /* module identifier */
    const __vue_module_identifier__$m = undefined;
    /* functional template */
    const __vue_is_functional_template__$m = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$m = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
      __vue_inject_styles__$m,
      __vue_script__$m,
      __vue_scope_id__$m,
      __vue_is_functional_template__$m,
      __vue_module_identifier__$m,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$n = {
    data: function data() {
      return {
        localValue: null,
        open: false
      };
    },
    props: {
      radio: {
        type: Boolean,
        default: false
      },
      text: {
        default: null
      },
      subtext: {
        default: null
      },
      count: {
        default: null
      },
      value: {
        default: null
      },
      trueValue: {
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    },
    mounted: function mounted() {
      var _this = this;

      setTimeout(function () {
        if (_this.radio) {
          _this.$refs.input.checked = _this.$refs.input.value == _this.value;
        }
      });
    }
  };

  /* script */
  const __vue_script__$n = script$n;

  /* template */
  var __vue_render__$j = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "label",
      {
        staticClass: "v-field-checkbox field-checkbox",
        class: {
          "field-checkbox--radio": _vm.radio,
          "field-checkbox--subtext": _vm.subtext,
          "field-checkbox--disabled": _vm.disabled,
        },
      },
      [
        (_vm.radio ? "radio" : "checkbox") === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              ref: "input",
              staticClass: "field-checkbox__input",
              attrs: { disabled: _vm.disabled, type: "checkbox" },
              domProps: {
                value: _vm.trueValue,
                checked: Array.isArray(_vm.localValue)
                  ? _vm._i(_vm.localValue, _vm.trueValue) > -1
                  : _vm.localValue,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.localValue,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false;
                    if (Array.isArray($$a)) {
                      var $$v = _vm.trueValue,
                        $$i = _vm._i($$a, $$v);
                      if ($$el.checked) {
                        $$i < 0 && (_vm.localValue = $$a.concat([$$v]));
                      } else {
                        $$i > -1 &&
                          (_vm.localValue = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)));
                      }
                    } else {
                      _vm.localValue = $$c;
                    }
                  },
                  _vm.handleInput,
                ],
              },
            })
          : (_vm.radio ? "radio" : "checkbox") === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              ref: "input",
              staticClass: "field-checkbox__input",
              attrs: { disabled: _vm.disabled, type: "radio" },
              domProps: {
                value: _vm.trueValue,
                checked: _vm._q(_vm.localValue, _vm.trueValue),
              },
              on: {
                change: [
                  function ($event) {
                    _vm.localValue = _vm.trueValue;
                  },
                  _vm.handleInput,
                ],
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              ref: "input",
              staticClass: "field-checkbox__input",
              attrs: {
                disabled: _vm.disabled,
                type: _vm.radio ? "radio" : "checkbox",
              },
              domProps: { value: _vm.trueValue, value: _vm.localValue },
              on: {
                change: _vm.handleInput,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localValue = $event.target.value;
                },
              },
            }),
        _c("span", { staticClass: "field-checkbox__visual" }),
        _c("span", { staticClass: "field-checkbox__content" }, [
          _c("span", { staticClass: "field-checkbox__top" }, [
            _c("span", {
              staticClass: "field-checkbox__text",
              domProps: { innerHTML: _vm._s(_vm.text) },
            }),
            _vm.count
              ? _c("span", { staticClass: "field-checkbox__count" }, [
                  _vm._v(_vm._s(_vm.count)),
                ])
              : _vm._e(),
          ]),
          _vm.subtext
            ? _c("span", { staticClass: "field-checkbox__bottom" }, [
                _c("span", {
                  staticClass: "field-checkbox__subtext",
                  domProps: { innerHTML: _vm._s(_vm.subtext) },
                }),
              ])
            : _vm._e(),
        ]),
      ]
    )
  };
  var __vue_staticRenderFns__$j = [];
  __vue_render__$j._withStripped = true;

    /* style */
    const __vue_inject_styles__$n = undefined;
    /* scoped */
    const __vue_scope_id__$n = undefined;
    /* module identifier */
    const __vue_module_identifier__$n = undefined;
    /* functional template */
    const __vue_is_functional_template__$n = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$n = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
      __vue_inject_styles__$n,
      __vue_script__$n,
      __vue_scope_id__$n,
      __vue_is_functional_template__$n,
      __vue_module_identifier__$n,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$o = {
    data: function data() {
      return {
        localValue: null,
        open: false
      };
    },
    props: {
      radio: {
        type: Boolean,
        default: false
      },
      text: {
        default: null
      },
      subtext: {
        default: null
      },
      count: {
        default: null
      },
      value: {
        default: null
      },
      trueValue: {
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    },
    mounted: function mounted() {
      var _this = this;

      setTimeout(function () {
        if (_this.radio) {
          _this.$refs.input.checked = _this.$refs.input.value == _this.value;
        }
      });
    }
  };

  /* script */
  const __vue_script__$o = script$o;

  /* template */
  var __vue_render__$k = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("label", { staticClass: "v-field-tag field-tag" }, [
      (_vm.radio ? "radio" : "checkbox") === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue",
              },
            ],
            ref: "input",
            staticClass: "field-tag__input",
            attrs: { disabled: _vm.disabled, type: "checkbox" },
            domProps: {
              value: _vm.trueValue,
              checked: Array.isArray(_vm.localValue)
                ? _vm._i(_vm.localValue, _vm.trueValue) > -1
                : _vm.localValue,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.localValue,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false;
                  if (Array.isArray($$a)) {
                    var $$v = _vm.trueValue,
                      $$i = _vm._i($$a, $$v);
                    if ($$el.checked) {
                      $$i < 0 && (_vm.localValue = $$a.concat([$$v]));
                    } else {
                      $$i > -1 &&
                        (_vm.localValue = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)));
                    }
                  } else {
                    _vm.localValue = $$c;
                  }
                },
                _vm.handleInput,
              ],
            },
          })
        : (_vm.radio ? "radio" : "checkbox") === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue",
              },
            ],
            ref: "input",
            staticClass: "field-tag__input",
            attrs: { disabled: _vm.disabled, type: "radio" },
            domProps: {
              value: _vm.trueValue,
              checked: _vm._q(_vm.localValue, _vm.trueValue),
            },
            on: {
              change: [
                function ($event) {
                  _vm.localValue = _vm.trueValue;
                },
                _vm.handleInput,
              ],
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue",
              },
            ],
            ref: "input",
            staticClass: "field-tag__input",
            attrs: {
              disabled: _vm.disabled,
              type: _vm.radio ? "radio" : "checkbox",
            },
            domProps: { value: _vm.trueValue, value: _vm.localValue },
            on: {
              change: _vm.handleInput,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localValue = $event.target.value;
              },
            },
          }),
      _c("span", { staticClass: "field-tag__content" }, [
        _c("span", {
          staticClass: "field-tag__text",
          domProps: { innerHTML: _vm._s(_vm.text) },
        }),
        _vm.count
          ? _c("span", { staticClass: "field-tag__count" }, [
              _vm._v("(" + _vm._s(_vm.count) + ")"),
            ])
          : _vm._e(),
      ]),
    ])
  };
  var __vue_staticRenderFns__$k = [];
  __vue_render__$k._withStripped = true;

    /* style */
    const __vue_inject_styles__$o = undefined;
    /* scoped */
    const __vue_scope_id__$o = undefined;
    /* module identifier */
    const __vue_module_identifier__$o = undefined;
    /* functional template */
    const __vue_is_functional_template__$o = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$o = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
      __vue_inject_styles__$o,
      __vue_script__$o,
      __vue_scope_id__$o,
      __vue_is_functional_template__$o,
      __vue_module_identifier__$o,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  var script$p = {
    data: function data() {
      return {
        localValue: null,
        savedValue: null,
        timeout: null,
        timeoutMessage: null,
        showMessage: false
      };
    },
    props: {
      field: {
        default: null
      },
      value: {
        default: null
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
        this.savedValue = this.localValue;
      },
      changeValue: function changeValue() {
        this.localValue = parseFloat(this.localValue);

        if (!this.localValue) {
          this.localValue = 0;
        }

        if (this.field) {
          if ((typeof this.field.max == 'number' || typeof this.field.max == 'string') && this.field.max !== Infinity) {
            // показ сообщения, если превышен максимум
            if (this.localValue > this.field.max) {
              this.getShowMessage();
            }

            this.localValue = Math.min(this.localValue, this.field.max);
          }

          if ((typeof this.field.min == 'number' || typeof this.field.min == 'string') && this.field.min !== -Infinity) {
            this.localValue = Math.max(this.localValue, this.field.min);
          }
        }
      },
      writeInput: function writeInput() {
        var _this = this;

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.changeValue();

          if (_this.savedValue != _this.localValue) {
            _this.$emit('input', _this.localValue);
          }

          _this.savedValue = _this.localValue;
        }, 1000);
      },
      btnInput: function btnInput() {
        var _this2 = this;

        this.changeValue();
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          if (_this2.savedValue != _this2.localValue) {
            _this2.$emit('input', _this2.localValue);
          }

          _this2.savedValue = _this2.localValue;
        }, 500);
      },
      validate: function validate(e) {
        if (!~e.key.search(/\d/)) {
          e.preventDefault();
        }
      },
      // показ сообщения
      getShowMessage: function getShowMessage() {
        var _this3 = this;

        this.showMessage = true;
        clearTimeout(this.timeoutMessage);
        this.timeoutMessage = setTimeout(function () {
          return _this3.showMessage = false;
        }, 3000);
      },
      closeMessage: function closeMessage(e) {
        if (!this.$el.contains(e.target)) {
          clearTimeout(this.timeoutMessage);
          this.showMessage = false;
        }
      }
    },
    created: function created() {
      this.updateLocalValue();
    },
    mounted: function mounted() {
      document.addEventListener('click', this.closeMessage);
    },
    destroyed: function destroyed() {
      document.removeEventListener('click', this.closeMessage);
    }
  };

  /* script */
  const __vue_script__$p = script$p;

  /* template */
  var __vue_render__$l = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-field-count field-count" }, [
      _c("button", {
        staticClass: "field-count__btn field-count__btn--sub",
        attrs: { type: "button", tabindex: "-1" },
        on: {
          click: function ($event) {
            _vm.localValue--;
            _vm.btnInput();
          },
        },
      }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localValue,
            expression: "localValue",
          },
        ],
        staticClass: "field-count__input field-input",
        attrs: { disabled: _vm.field.disabled },
        domProps: { value: _vm.localValue },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localValue = $event.target.value;
            },
            _vm.writeInput,
          ],
          keypress: _vm.validate,
        },
      }),
      _c("button", {
        staticClass: "field-count__btn field-count__btn--add",
        attrs: { type: "button", tabindex: "-1" },
        on: {
          click: function ($event) {
            _vm.localValue++;
            _vm.btnInput();
          },
        },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMessage,
              expression: "showMessage",
            },
          ],
          staticClass: "field-count__message",
        },
        [_vm._v("Выбрано максимально доступное количество")]
      ),
    ])
  };
  var __vue_staticRenderFns__$l = [];
  __vue_render__$l._withStripped = true;

    /* style */
    const __vue_inject_styles__$p = undefined;
    /* scoped */
    const __vue_scope_id__$p = undefined;
    /* module identifier */
    const __vue_module_identifier__$p = undefined;
    /* functional template */
    const __vue_is_functional_template__$p = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$p = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
      __vue_inject_styles__$p,
      __vue_script__$p,
      __vue_scope_id__$p,
      __vue_is_functional_template__$p,
      __vue_module_identifier__$p,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$q = {
    data: function data() {
      return {
        localValue: null,
        debounceTimeout: null,
        blurTimeout: null,
        tempValue: {
          max: null,
          min: null
        }
      };
    },
    props: {
      field: {
        default: null,
        required: true
      },
      value: {
        default: null
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value || {
          min: this.field.min || 0,
          max: this.field.max || 0
        };
        this.localValue.min = typeof this.localValue.min == 'number' ? this.localValue.min.toFixed(2) : this.localValue.min;
        this.localValue.max = typeof this.localValue.max == 'number' ? this.localValue.max.toFixed(2) : this.localValue.max;
      },
      handleInput: function handleInput() {//clearTimeout(this.debounceTimeout);
        //this.debounceTimeout = setTimeout(this.emitInput, 1000);
      },
      handleBlur: function handleBlur() {
        this.blurTimeout = setTimeout(this.emitInput, 100);
      },
      handleFocus: function handleFocus() {
        clearTimeout(this.blurTimeout);
      },
      emitInput: function emitInput() {
        clearTimeout(this.debounceTimeout);

        if (this.field) {
          if (this.localValue.max !== null && this.localValue.min !== null) {
            if ((parseFloat(this.localValue.min) || null) > (parseFloat(this.localValue.max) || null)) {
              this.localValue.max = parseFloat(this.localValue.min).toFixed(2);
            }
          }

          if (this.localValue.max !== Infinity && this.localValue.max !== null && this.field.max !== Infinity && this.field.max !== null) {
            this.localValue.max = Math.min(this.localValue.max, this.field.max);
            this.localValue.max = Math.max(this.localValue.max, this.field.min);
          }

          if (this.localValue.min !== -Infinity && this.localValue.min !== null && this.field.min !== -Infinity && this.field.min !== null) {
            this.localValue.min = Math.max(this.localValue.min, this.field.min);
            this.localValue.min = Math.min(this.localValue.min, this.field.max);
          }
        }

        if (this.tempValue.min != (parseFloat(this.localValue.min) || null) || this.tempValue.max != (parseFloat(this.localValue.max) || null)) {
          this.tempValue.min = parseFloat(this.localValue.min) || null;
          this.tempValue.max = parseFloat(this.localValue.max) || null;
          this.$emit('input', this.localValue);
        }

        this.localValue.min = this.localValue.min.toFixed(2);
        this.localValue.max = this.localValue.max.toFixed(2);
      }
    },
    created: function created() {
      this.updateLocalValue();
      this.tempValue.min = parseFloat(this.localValue.min) || null;
      this.tempValue.max = parseFloat(this.localValue.max) || null;
    }
  };

  /* script */
  const __vue_script__$q = script$q;

  /* template */
  var __vue_render__$m = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-field-range field-range",
        class: { "field-range--sm": _vm.field.size === "sm" },
      },
      [
        _c(
          "div",
          { staticClass: "field-range__cell" },
          [
            _c("v-field", {
              staticClass: "field-range__input",
              attrs: {
                field: {
                  type: "text",
                  inputmode: "decimal",
                  disabled: _vm.field.disabled,
                  precision: _vm.field.precision,
                  placeholder: _vm.field.placeholderMin,
                },
              },
              on: {
                input: _vm.handleInput,
                blur: _vm.handleBlur,
                focus: _vm.handleFocus,
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.emitInput.apply(null, arguments)
                },
              },
              model: {
                value: _vm.localValue.min,
                callback: function ($$v) {
                  _vm.$set(_vm.localValue, "min", $$v);
                },
                expression: "localValue.min",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "field-range__cell" },
          [
            _c("v-field", {
              staticClass: "field-range__input",
              attrs: {
                field: {
                  type: "text",
                  inputmode: "decimal",
                  disabled: _vm.field.disabled,
                  precision: _vm.field.precision,
                  placeholder: _vm.field.placeholderMax,
                },
              },
              on: {
                input: _vm.handleInput,
                blur: _vm.handleBlur,
                focus: _vm.handleFocus,
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.emitInput.apply(null, arguments)
                },
              },
              model: {
                value: _vm.localValue.max,
                callback: function ($$v) {
                  _vm.$set(_vm.localValue, "max", $$v);
                },
                expression: "localValue.max",
              },
            }),
          ],
          1
        ),
      ]
    )
  };
  var __vue_staticRenderFns__$m = [];
  __vue_render__$m._withStripped = true;

    /* style */
    const __vue_inject_styles__$q = undefined;
    /* scoped */
    const __vue_scope_id__$q = undefined;
    /* module identifier */
    const __vue_module_identifier__$q = undefined;
    /* functional template */
    const __vue_is_functional_template__$q = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$q = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
      __vue_inject_styles__$q,
      __vue_script__$q,
      __vue_scope_id__$q,
      __vue_is_functional_template__$q,
      __vue_module_identifier__$q,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$r = {
    data: function data() {
      return {
        localValue: null,
        localFiles: [],
        rerenderKey: 0
      };
    },
    props: {
      value: {
        default: null
      },
      note: {
        default: null
      },
      field: {
        default: null
      }
    },
    watch: {
      value: function value() {
        this.initLocalValueFromValue();
      }
    },
    methods: {
      getKey: function getKey() {
        return Date.now().toString() + Math.round(Math.random() * 100000);
      },
      fileInput: function fileInput(e) {
        var newKey = this.getKey();

        if (!this.field.multiple) {
          this.localFiles.forEach(this.remove);
        } // always 1 file per event! (no multiple <input>)


        if (e.target.files) {
          console.log('file input', e.target.files, e.target.files[0]);

          for (var i = 0; i < e.target.files.length; i++) {
            this.localFiles.push({
              name: e.target.files[i].name,
              size: e.target.files[i].size,
              key: newKey
            });
          }

          e.key = newKey;
          this.$emit('fileinput', e);
        }

        this.rerenderKey = this.getKey();
      },
      remove: function remove(file) {
        this.localFiles.splice(this.localFiles.indexOf(file), 1);
        this.$emit('fileremove', file);
      },
      initLocalValueFromValue: function initLocalValueFromValue(initial) {
        var _this = this;

        if (this.field.files && initial) {
          this.localFiles = [];
          this.field.files.forEach(function (file) {
            var newKey = _this.getKey();

            _this.localFiles.push({
              name: file.name,
              size: file.size,
              key: newKey
            });

            _this.$emit('fileinput', {
              key: newKey,
              target: {
                files: [file]
              }
            });
          });
        }
      }
    },
    created: function created() {
      this.initLocalValueFromValue(true);
    }
  };

  /* script */
  const __vue_script__$r = script$r;

  /* template */
  var __vue_render__$n = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-field-file field-file" },
      [
        _c(
          "transition",
          { attrs: { name: "fade" } },
          [
            _vm.localFiles.length
              ? _c(
                  "transition-group",
                  {
                    staticClass: "field-file__list flc",
                    attrs: { tag: "div", name: "content-fade" },
                  },
                  _vm._l(_vm.localFiles, function (file) {
                    return _c(
                      "div",
                      { key: file.key, staticClass: "field-file__item" },
                      [
                        _c("div", { staticClass: "field-file__item-start" }, [
                          _vm._v(_vm._s(file.name)),
                        ]),
                        _c("div", { staticClass: "field-file__item-end" }, [
                          _c(
                            "button",
                            {
                              staticClass: "field-file__item-remove link",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.remove(file)
                                },
                              },
                            },
                            [_vm._v("Удалить")]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "field-file__main" }, [
          _c("div", { staticClass: "field-file__cell-input" }, [
            _c("label", { staticClass: "field-file__input-block" }, [
              _c("input", {
                key: _vm.rerenderKey,
                ref: "input",
                staticClass: "field-file__input",
                attrs: { type: "file" },
                on: { change: _vm.fileInput },
              }),
              _c(
                "span",
                {
                  staticClass: "field-file__btn btn",
                  attrs: { tabindex: "0" },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.$refs["input"].click()
                    },
                  },
                },
                [_vm._v("Добавить файл")]
              ),
            ]),
          ]),
          _vm.note
            ? _c("div", { staticClass: "field-file__cell-note" }, [
                _c("div", { staticClass: "field-file__note" }, [
                  _vm._v(_vm._s(_vm.note)),
                ]),
              ])
            : _vm._e(),
        ]),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$n = [];
  __vue_render__$n._withStripped = true;

    /* style */
    const __vue_inject_styles__$r = undefined;
    /* scoped */
    const __vue_scope_id__$r = undefined;
    /* module identifier */
    const __vue_module_identifier__$r = undefined;
    /* functional template */
    const __vue_is_functional_template__$r = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$r = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
      __vue_inject_styles__$r,
      __vue_script__$r,
      __vue_scope_id__$r,
      __vue_is_functional_template__$r,
      __vue_module_identifier__$r,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  var script$s = {
    props: {
      field: {
        default: null
      },
      value: {
        default: null
      }
    }
  };

  /* script */
  const __vue_script__$s = script$s;

  /* template */
  var __vue_render__$o = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-field-view-picker view-picker" }, [
      _c(
        "div",
        { staticClass: "view-picker__grid" },
        _vm._l(_vm.field.options, function (option) {
          return _c(
            "button",
            {
              staticClass: "view-picker__item",
              class: { "view-picker__item--active": option.value === _vm.value },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("input", option.value)
                },
              },
            },
            [
              _c("svg", { staticClass: "svg-icon view-picker__icon" }, [
                _c("use", {
                  attrs: { "xlink:href": "#svg-icon-view-" + option.value },
                }),
              ]),
            ]
          )
        }),
        0
      ),
    ])
  };
  var __vue_staticRenderFns__$o = [];
  __vue_render__$o._withStripped = true;

    /* style */
    const __vue_inject_styles__$s = undefined;
    /* scoped */
    const __vue_scope_id__$s = undefined;
    /* module identifier */
    const __vue_module_identifier__$s = undefined;
    /* functional template */
    const __vue_is_functional_template__$s = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$s = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
      __vue_inject_styles__$s,
      __vue_script__$s,
      __vue_scope_id__$s,
      __vue_is_functional_template__$s,
      __vue_module_identifier__$s,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  var script$t = {
    data: function data() {
      return {
        localValue: null,
        open: false
      };
    },
    props: {
      radio: {
        type: Boolean,
        default: false
      },
      hex: {
        default: null
      },
      text: {
        default: null
      },
      value: {
        default: null
      },
      trueValue: {
        default: null
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$t = script$t;

  /* template */
  var __vue_render__$p = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "label",
      { staticClass: "v-field-color field-checkbox field-checkbox--color" },
      [
        (_vm.radio ? "radio" : "checkbox") === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              staticClass: "field-checkbox__input",
              attrs: { type: "checkbox" },
              domProps: {
                value: _vm.trueValue,
                checked: Array.isArray(_vm.localValue)
                  ? _vm._i(_vm.localValue, _vm.trueValue) > -1
                  : _vm.localValue,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.localValue,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false;
                    if (Array.isArray($$a)) {
                      var $$v = _vm.trueValue,
                        $$i = _vm._i($$a, $$v);
                      if ($$el.checked) {
                        $$i < 0 && (_vm.localValue = $$a.concat([$$v]));
                      } else {
                        $$i > -1 &&
                          (_vm.localValue = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)));
                      }
                    } else {
                      _vm.localValue = $$c;
                    }
                  },
                  _vm.handleInput,
                ],
              },
            })
          : (_vm.radio ? "radio" : "checkbox") === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              staticClass: "field-checkbox__input",
              attrs: { type: "radio" },
              domProps: {
                value: _vm.trueValue,
                checked: _vm._q(_vm.localValue, _vm.trueValue),
              },
              on: {
                change: [
                  function ($event) {
                    _vm.localValue = _vm.trueValue;
                  },
                  _vm.handleInput,
                ],
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              staticClass: "field-checkbox__input",
              attrs: { type: _vm.radio ? "radio" : "checkbox" },
              domProps: { value: _vm.trueValue, value: _vm.localValue },
              on: {
                change: _vm.handleInput,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localValue = $event.target.value;
                },
              },
            }),
        _c("span", {
          staticClass: "field-checkbox__visual",
          style: { color: _vm.hex },
          attrs: { title: _vm.text },
        }),
      ]
    )
  };
  var __vue_staticRenderFns__$p = [];
  __vue_render__$p._withStripped = true;

    /* style */
    const __vue_inject_styles__$t = undefined;
    /* scoped */
    const __vue_scope_id__$t = undefined;
    /* module identifier */
    const __vue_module_identifier__$t = undefined;
    /* functional template */
    const __vue_is_functional_template__$t = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$t = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
      __vue_inject_styles__$t,
      __vue_script__$t,
      __vue_scope_id__$t,
      __vue_is_functional_template__$t,
      __vue_module_identifier__$t,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  var script$u = {
    data: function data() {
      return {
        localValue: null,
        open: false
      };
    },
    props: {
      radio: {
        type: Boolean,
        default: false
      },
      field: {
        default: null
      },
      value: {
        default: null
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        return this.field.options.sort(function (a, b) {
          return a.sort - b.sort;
        });
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$u = script$u;

  /* template */
  var __vue_render__$q = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-field-color-list field-color-list" },
      _vm._l(_vm.computedOptions, function (option, index) {
        return _vm.field
          ? _c(
              "div",
              {
                key: option.value + "-" + index,
                staticClass: "field-color-list__item",
              },
              [
                _c("v-field-color", {
                  attrs: {
                    "true-value": option.value,
                    text: option.text,
                    disabled: option.disabled,
                    radio: _vm.radio,
                    hex: option.hex,
                  },
                  on: { input: _vm.handleInput },
                  model: {
                    value: _vm.localValue,
                    callback: function ($$v) {
                      _vm.localValue = $$v;
                    },
                    expression: "localValue",
                  },
                }),
              ],
              1
            )
          : _vm._e()
      }),
      0
    )
  };
  var __vue_staticRenderFns__$q = [];
  __vue_render__$q._withStripped = true;

    /* style */
    const __vue_inject_styles__$u = undefined;
    /* scoped */
    const __vue_scope_id__$u = undefined;
    /* module identifier */
    const __vue_module_identifier__$u = undefined;
    /* functional template */
    const __vue_is_functional_template__$u = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$u = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
      __vue_inject_styles__$u,
      __vue_script__$u,
      __vue_scope_id__$u,
      __vue_is_functional_template__$u,
      __vue_module_identifier__$u,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  var script$v = {
    data: function data() {
      return {
        localValue: null,
        open: false
      };
    },
    props: {
      radio: {
        type: Boolean,
        default: false
      },
      field: {
        default: null
      },
      value: {
        default: null
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        return this.field.options.sort(function (a, b) {
          return a.sort - b.sort;
        });
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$v = script$v;

  /* template */
  var __vue_render__$r = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-field-switch-list field-switch-list" },
      _vm._l(_vm.computedOptions, function (option, index) {
        return _vm.field
          ? _c(
              "div",
              {
                key: option.value + "-" + index,
                staticClass: "field-switch-list__item",
              },
              [
                _c("v-field-switch", {
                  attrs: {
                    "true-value": option.value,
                    text: option.text,
                    disabled: option.disabled,
                    radio: _vm.radio,
                  },
                  on: { input: _vm.handleInput },
                  model: {
                    value: _vm.localValue,
                    callback: function ($$v) {
                      _vm.localValue = $$v;
                    },
                    expression: "localValue",
                  },
                }),
              ],
              1
            )
          : _vm._e()
      }),
      0
    )
  };
  var __vue_staticRenderFns__$r = [];
  __vue_render__$r._withStripped = true;

    /* style */
    const __vue_inject_styles__$v = undefined;
    /* scoped */
    const __vue_scope_id__$v = undefined;
    /* module identifier */
    const __vue_module_identifier__$v = undefined;
    /* functional template */
    const __vue_is_functional_template__$v = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$v = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
      __vue_inject_styles__$v,
      __vue_script__$v,
      __vue_scope_id__$v,
      __vue_is_functional_template__$v,
      __vue_module_identifier__$v,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  var script$w = {
    data: function data() {
      return {
        localValue: null,
        open: false
      };
    },
    props: {
      radio: {
        type: Boolean,
        default: false
      },
      text: {
        default: null
      },
      value: {
        default: null
      },
      trueValue: {
        default: null
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$w = script$w;

  /* template */
  var __vue_render__$s = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "label",
      { staticClass: "v-field-switch field-checkbox field-checkbox--switch" },
      [
        (_vm.radio ? "radio" : "checkbox") === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              staticClass: "field-checkbox__input",
              attrs: { type: "checkbox" },
              domProps: {
                value: _vm.trueValue,
                checked: Array.isArray(_vm.localValue)
                  ? _vm._i(_vm.localValue, _vm.trueValue) > -1
                  : _vm.localValue,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.localValue,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false;
                    if (Array.isArray($$a)) {
                      var $$v = _vm.trueValue,
                        $$i = _vm._i($$a, $$v);
                      if ($$el.checked) {
                        $$i < 0 && (_vm.localValue = $$a.concat([$$v]));
                      } else {
                        $$i > -1 &&
                          (_vm.localValue = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)));
                      }
                    } else {
                      _vm.localValue = $$c;
                    }
                  },
                  _vm.handleInput,
                ],
              },
            })
          : (_vm.radio ? "radio" : "checkbox") === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              staticClass: "field-checkbox__input",
              attrs: { type: "radio" },
              domProps: {
                value: _vm.trueValue,
                checked: _vm._q(_vm.localValue, _vm.trueValue),
              },
              on: {
                change: [
                  function ($event) {
                    _vm.localValue = _vm.trueValue;
                  },
                  _vm.handleInput,
                ],
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              staticClass: "field-checkbox__input",
              attrs: { type: _vm.radio ? "radio" : "checkbox" },
              domProps: { value: _vm.trueValue, value: _vm.localValue },
              on: {
                change: _vm.handleInput,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localValue = $event.target.value;
                },
              },
            }),
        _c("span", { staticClass: "field-checkbox__text" }, [
          _vm._v(_vm._s(_vm.text)),
        ]),
      ]
    )
  };
  var __vue_staticRenderFns__$s = [];
  __vue_render__$s._withStripped = true;

    /* style */
    const __vue_inject_styles__$w = undefined;
    /* scoped */
    const __vue_scope_id__$w = undefined;
    /* module identifier */
    const __vue_module_identifier__$w = undefined;
    /* functional template */
    const __vue_is_functional_template__$w = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$w = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
      __vue_inject_styles__$w,
      __vue_script__$w,
      __vue_scope_id__$w,
      __vue_is_functional_template__$w,
      __vue_module_identifier__$w,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$x = {
    data: function data() {
      return {
        localValue: null,
        open: false
      };
    },
    props: {
      field: {
        default: null
      },
      value: {
        default: null
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        var vm = this;
        var slidesWidth = 0;
        var oldProgress = 2; // если слайды не влезают в контейнер добавляем тень

        function setShadow() {
          if (oldProgress != this.progress) {
            if (this.progress <= 0) {
              vm.$refs.shadow.classList.remove('start');
              vm.$refs.shadow.classList.add('end');
            } else if (this.progress >= 1) {
              vm.$refs.shadow.classList.remove('end');
              vm.$refs.shadow.classList.add('start');
            } else {
              vm.$refs.shadow.classList.add('end');
              vm.$refs.shadow.classList.add('start');
            }

            oldProgress = this.progress;
          }
        }

        return {
          slidesPerView: 'auto',
          touchReleaseOnEdges: true,
          threshold: 60,
          initialSlide: this.value,
          // если родительский контейнер не виден (display none)
          observer: true,
          observeParents: true,
          on: {
            init: function init() {
              slidesWidth = 0;
              Array.from(this.slides).forEach(function (slide) {
                slidesWidth += slide.offsetWidth;
              });

              if (slidesWidth > this.wrapperEl.offsetWidth + 1) {
                setShadow.bind(this);
              } else {
                vm.$refs.shadow.classList.remove('start');
                vm.$refs.shadow.classList.remove('end');
              }
            },
            resize: function resize() {
              slidesWidth = 0;
              Array.from(this.slides).forEach(function (slide) {
                slidesWidth += slide.offsetWidth;
              });

              if (slidesWidth > this.wrapperEl.offsetWidth + 1) {
                setShadow.bind(this);
              } else {
                vm.$refs.shadow.classList.remove('start');
                vm.$refs.shadow.classList.remove('end');
              }
            },
            progress: setShadow,
            reachBeginning: function reachBeginning() {
              if (slidesWidth > this.wrapperEl.offsetWidth) {
                vm.$refs.shadow.classList.remove('start');
                vm.$refs.shadow.classList.add('end');
              }
            },
            reachEnd: function reachEnd() {
              if (slidesWidth > this.wrapperEl.offsetWidth) {
                vm.$refs.shadow.classList.remove('end');
                vm.$refs.shadow.classList.add('start');
              }
            }
          }
        };
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      },
      localValue: function localValue(state) {
        try {
          var idx = this.field.options.findIndex(function (option) {
            return option.value === state;
          });
          this.$refs.carousel.$swiper.slideTo(idx || 0);
        } catch (e) {
          console.warn(e);
        }
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$x = script$x;

  /* template */
  var __vue_render__$t = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-field-tabs-list" }, [
      _c("div", { ref: "shadow", staticClass: "field-tabs-list__shadow" }),
      _c(
        "div",
        { staticClass: "field-tabs-list" },
        [
          _c(
            "v-swiper",
            { ref: "carousel", attrs: { options: _vm.computedOptions } },
            _vm._l(_vm.field.options, function (option, index) {
              return _vm.field
                ? _c(
                    "v-swiper-slide",
                    {
                      key: option.value + "-" + index,
                      staticClass: "field-tabs-list__item flc",
                    },
                    [
                      _c("v-field-tab", {
                        attrs: {
                          "true-value": option.value,
                          text: option.text,
                          disabled: option.disabled,
                          radio: "radio",
                        },
                        on: { input: _vm.handleInput },
                        model: {
                          value: _vm.localValue,
                          callback: function ($$v) {
                            _vm.localValue = $$v;
                          },
                          expression: "localValue",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e()
            }),
            1
          ),
        ],
        1
      ),
    ])
  };
  var __vue_staticRenderFns__$t = [];
  __vue_render__$t._withStripped = true;

    /* style */
    const __vue_inject_styles__$x = undefined;
    /* scoped */
    const __vue_scope_id__$x = undefined;
    /* module identifier */
    const __vue_module_identifier__$x = undefined;
    /* functional template */
    const __vue_is_functional_template__$x = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$x = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
      __vue_inject_styles__$x,
      __vue_script__$x,
      __vue_scope_id__$x,
      __vue_is_functional_template__$x,
      __vue_module_identifier__$x,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  var script$y = {
    data: function data() {
      return {
        localValue: null,
        open: false
      };
    },
    props: {
      radio: {
        type: Boolean,
        default: false
      },
      text: {
        default: null
      },
      value: {
        default: null
      },
      trueValue: {
        default: null
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    },
    mounted: function mounted() {
      var _this = this;

      setTimeout(function () {
        if (_this.radio) {
          _this.$refs.input.checked = _this.$refs.input.value == _this.value;
        }
      });
    }
  };

  /* script */
  const __vue_script__$y = script$y;

  /* template */
  var __vue_render__$u = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "label",
      { staticClass: "v-field-checkbox field-checkbox field-checkbox--tab" },
      [
        (_vm.radio ? "radio" : "checkbox") === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              ref: "input",
              staticClass: "field-checkbox__input",
              attrs: { type: "checkbox" },
              domProps: {
                value: _vm.trueValue,
                checked: Array.isArray(_vm.localValue)
                  ? _vm._i(_vm.localValue, _vm.trueValue) > -1
                  : _vm.localValue,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.localValue,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false;
                    if (Array.isArray($$a)) {
                      var $$v = _vm.trueValue,
                        $$i = _vm._i($$a, $$v);
                      if ($$el.checked) {
                        $$i < 0 && (_vm.localValue = $$a.concat([$$v]));
                      } else {
                        $$i > -1 &&
                          (_vm.localValue = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)));
                      }
                    } else {
                      _vm.localValue = $$c;
                    }
                  },
                  _vm.handleInput,
                ],
              },
            })
          : (_vm.radio ? "radio" : "checkbox") === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              ref: "input",
              staticClass: "field-checkbox__input",
              attrs: { type: "radio" },
              domProps: {
                value: _vm.trueValue,
                checked: _vm._q(_vm.localValue, _vm.trueValue),
              },
              on: {
                change: [
                  function ($event) {
                    _vm.localValue = _vm.trueValue;
                  },
                  _vm.handleInput,
                ],
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localValue,
                  expression: "localValue",
                },
              ],
              ref: "input",
              staticClass: "field-checkbox__input",
              attrs: { type: _vm.radio ? "radio" : "checkbox" },
              domProps: { value: _vm.trueValue, value: _vm.localValue },
              on: {
                change: _vm.handleInput,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localValue = $event.target.value;
                },
              },
            }),
        _c("span", { staticClass: "field-checkbox__text" }, [
          _vm._v(_vm._s(_vm.text)),
        ]),
      ]
    )
  };
  var __vue_staticRenderFns__$u = [];
  __vue_render__$u._withStripped = true;

    /* style */
    const __vue_inject_styles__$y = undefined;
    /* scoped */
    const __vue_scope_id__$y = undefined;
    /* module identifier */
    const __vue_module_identifier__$y = undefined;
    /* functional template */
    const __vue_is_functional_template__$y = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$y = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
      __vue_inject_styles__$y,
      __vue_script__$y,
      __vue_scope_id__$y,
      __vue_is_functional_template__$y,
      __vue_module_identifier__$y,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$z = {
    data: function data() {
      return {
        localText: null,
        localValue: null,
        savedValue: null,
        options: [],
        open: false,
        timeoutRequest: null
      };
    },
    props: {
      field: {
        default: null,
        required: true
      },
      value: {
        default: null
      }
    },
    computed: {
      computedType: function computedType() {
        if (!this.field.type || this.field.type == 'number') {
          return 'text';
        }

        return this.field.type;
      },
      isFieldNumeric: function isFieldNumeric() {
        return !!(this.field.type === 'number' || this.field.inputmode === 'numeric' || this.field.inputmode === 'decimal');
      }
    },
    watch: {
      value: function value(newVal) {
        if (!newVal || newVal && !newVal.length) {
          this.localText = '';
        }
      },
      'field.errors': {
        immediate: true,
        handler: function handler(newValue) {
          if (newValue && newValue.length) {
            this.localValue = '';
            this.localText = '';
          }
        }
      },
      'field.text': {
        immediate: true,
        handler: function handler() {
          if (this.isFieldNumeric && this.field.text) {
            this.localText = this.savedValue = this.field.text.toString().replace('.', ',');
          } else {
            this.localText = this.savedValue = this.field.text;
          }
        }
      }
    },
    methods: {
      handleKeyup: function handleKeyup() {
        if (this.isFieldNumeric && this.savedValue) {
          this.localText = this.savedValue.replace('.', ',');
        }
      },
      handleInput: function handleInput() {
        var _this$localText;

        if (this.isFieldNumeric) {
          if (!this.localText || /^-?(?:\d+)(?:(\.|,)(\d+)?)?$/.test(this.localText)) {
            this.savedValue = this.localText;
          } else {
            this.localText = this.savedValue;
          } // this.$emit('input', this.localText ? parseFloat(this.localText.toString().replace(',', '.')) : this.localText);

        }

        if (this.localValue || !((_this$localText = this.localText) !== null && _this$localText !== void 0 && _this$localText.length)) {
          this.localValue = '';
          this.options = [];
          this.$emit('input', this.localValue);
        }
      },
      sendRequest: function sendRequest() {
        var _this = this;

        if (this.localText.length >= this.field.minStringForRequest) {
          clearTimeout(this.timeoutRequest);
          this.timeoutRequest = setTimeout(function () {
            var formData = new FormData();
            formData.set('field', _this.field.name);
            formData.set('value', _this.localText);
            var requestPromise = fetch(_this.field.tooltip, {
              method: 'POST',
              body: formData
            });
            requestPromise.then(function (response) {
              if (!response.ok) {
                console.warn("".concat(_this.$options.name, ": AJAX request failed"), response);
              } else {
                response.json().then(function (data) {
                  console.log("".concat(_this.$options.name, ": AJAX request completed"), data);
                  _this.options = data.options; // сортировка по алфавиту
                  // if (this.options instanceof Array) {
                  // 	this.options = this.options.sort((a, b) => {
                  // 		if (a.text < b.text) {
                  // 			return -1
                  // 		} else if (a.text > b.text) {
                  // 			return 1
                  // 		} else {
                  // 			return 0
                  // 		}
                  // 	})
                  // }

                  _this.open = true;
                });
              }
            });
          }, 800);
        }
      },
      emitInput: function emitInput() {
        this.$emit('input', this.localValue);
      },
      handleClickOutside: function handleClickOutside(e) {
        if (!this.$el.contains(e.target)) {
          this.open = false;
        }
      },
      handleEsc: function handleEsc(e) {
        if (e.keyCode == 27) {
          this.open = false;
        }
      }
    },
    created: function created() {
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleEsc);
    },
    destroyed: function destroyed() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleEsc);
    }
  };

  /* script */
  const __vue_script__$z = script$z;

  /* template */
  var __vue_render__$v = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "label",
      {
        staticClass: "v-field-tooltip field-tooltip",
        class: { "field-tooltip--open": _vm.open },
      },
      [
        _vm.computedType === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localText,
                  expression: "localText",
                },
              ],
              ref: "input",
              staticClass: "field-input field-tooltip__input",
              class: { "field-input--sm": _vm.field.size === "sm" },
              attrs: {
                inputmode: _vm.field.inputmode,
                disabled: _vm.field.disabled,
                placeholder: _vm.field.placeholder,
                maxlength: _vm.field.maxlength,
                type: "checkbox",
              },
              domProps: {
                checked: Array.isArray(_vm.localText)
                  ? _vm._i(_vm.localText, null) > -1
                  : _vm.localText,
              },
              on: {
                input: function ($event) {
                  _vm.handleInput();
                  _vm.sendRequest();
                },
                keyup: _vm.handleKeyup,
                change: function ($event) {
                  var $$a = _vm.localText,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false;
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v);
                    if ($$el.checked) {
                      $$i < 0 && (_vm.localText = $$a.concat([$$v]));
                    } else {
                      $$i > -1 &&
                        (_vm.localText = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)));
                    }
                  } else {
                    _vm.localText = $$c;
                  }
                },
              },
            })
          : _vm.computedType === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localText,
                  expression: "localText",
                },
              ],
              ref: "input",
              staticClass: "field-input field-tooltip__input",
              class: { "field-input--sm": _vm.field.size === "sm" },
              attrs: {
                inputmode: _vm.field.inputmode,
                disabled: _vm.field.disabled,
                placeholder: _vm.field.placeholder,
                maxlength: _vm.field.maxlength,
                type: "radio",
              },
              domProps: { checked: _vm._q(_vm.localText, null) },
              on: {
                input: function ($event) {
                  _vm.handleInput();
                  _vm.sendRequest();
                },
                keyup: _vm.handleKeyup,
                change: function ($event) {
                  _vm.localText = null;
                },
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localText,
                  expression: "localText",
                },
              ],
              ref: "input",
              staticClass: "field-input field-tooltip__input",
              class: { "field-input--sm": _vm.field.size === "sm" },
              attrs: {
                inputmode: _vm.field.inputmode,
                disabled: _vm.field.disabled,
                placeholder: _vm.field.placeholder,
                maxlength: _vm.field.maxlength,
                type: _vm.computedType,
              },
              domProps: { value: _vm.localText },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.localText = $event.target.value;
                  },
                  function ($event) {
                    _vm.handleInput();
                    _vm.sendRequest();
                  },
                ],
                keyup: _vm.handleKeyup,
              },
            }),
        _c("span", { staticClass: "field-select__placeholder" }, [
          _vm._v(_vm._s(_vm.field.placeholder)),
        ]),
        _c("transition", { attrs: { name: "dropdown" } }, [
          _vm.field && _vm.open && _vm.options.length
            ? _c(
                "div",
                {
                  staticClass: "field-tooltip__list",
                  on: {
                    click: function ($event) {
                      _vm.open = false;
                    },
                  },
                },
                [
                  _c("transition", { attrs: { name: "dropdown-inner" } }, [
                    _vm.open
                      ? _c(
                          "div",
                          { staticClass: "field-tooltip__list-container" },
                          _vm._l(_vm.options, function (option) {
                            return _c("button", {
                              staticClass: "field-tooltip__list-item",
                              class: {
                                "field-tooltip__list-item--active":
                                  option.value === _vm.localValue,
                              },
                              attrs: { type: "button" },
                              domProps: { innerHTML: _vm._s(option.text) },
                              on: {
                                click: function ($event) {
                                  _vm.localText = option.text;
                                  _vm.localValue = option.value;
                                  _vm.emitInput();
                                },
                              },
                            })
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$v = [];
  __vue_render__$v._withStripped = true;

    /* style */
    const __vue_inject_styles__$z = undefined;
    /* scoped */
    const __vue_scope_id__$z = undefined;
    /* module identifier */
    const __vue_module_identifier__$z = undefined;
    /* functional template */
    const __vue_is_functional_template__$z = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$z = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
      __vue_inject_styles__$z,
      __vue_script__$z,
      __vue_scope_id__$z,
      __vue_is_functional_template__$z,
      __vue_module_identifier__$z,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$A = {
    data: function data() {
      var _ranges;

      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);
      return {
        opens: 'left',
        localValue: {
          startDate: null,
          endDate: null
        },
        showDropdowns: true,
        linkedCalendars: false,
        disabled: false,
        readonly: false,
        closeOnEsc: true,
        localeData: {
          direction: 'ltr',
          format: 'dd.mm.yyyy',
          separator: ' - ',
          applyLabel: 'Применить',
          cancelLabel: 'Отменить',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
          monthNames: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
          firstDay: 1
        },
        ranges: (_ranges = {}, _defineProperty(_ranges, 'Сегодня', [today, today]), _defineProperty(_ranges, 'Вчера', [yesterday, yesterday]), _defineProperty(_ranges, 'Текущий месяц', [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0)]), _defineProperty(_ranges, 'Прошлый месяц', [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)]), _defineProperty(_ranges, 'Текущий год', [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)]), _ranges)
      };
    },
    props: {
      field: {
        default: null,
        required: true
      },
      value: {
        default: null
      }
    },
    filters: {
      textDate: function textDate(date) {
        return new Intl.DateTimeFormat('ru-RU').format(date);
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function handler() {
          if (this.value && this.value.min) {
            this.localValue.startDate = new Date(this.value.min);
          } else if (this.field.min) {
            this.localValue.startDate = new Date(this.field.min);
          }

          if (this.value && this.value.max) {
            this.localValue.endDate = new Date(this.value.max);
          } else if (this.field.max) {
            this.localValue.endDate = new Date(this.field.max);
          }
        }
      }
    },
    methods: {
      isoDate: function isoDate(date) {
        date = date.toString().replace(/GMT\+\d{4}/, 'GMT+0000');
        return new Date(date).toISOString().substr(0, 10);
      },
      handleInput: function handleInput(e) {
        var payload = {
          min: this.isoDate(this.localValue.startDate),
          max: this.isoDate(this.localValue.endDate)
        };
        this.$emit('input', payload);
      },
      togglePicker: function togglePicker(status) {
        var _this = this;

        if (status) {
          this.$nextTick(function () {
            var items = _this.$el.querySelectorAll('[data-range-key]');

            items.forEach(function (item) {
              item.addEventListener('click', function () {
                items.forEach(function (item) {
                  item.classList.remove('active');
                });
                item.classList.add('active');
              });
            });
          });
        }
      },
      selectDate: function selectDate(status) {
        var items = this.$el.querySelectorAll('[data-range-key]');
        items.forEach(function (item) {
          item.classList.remove('active');
        });
      }
    },
    mounted: function mounted() {}
  };

  /* script */
  const __vue_script__$A = script$A;

  /* template */
  var __vue_render__$w = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "label",
      { staticClass: "v-field-date-range field-date-range" },
      [
        _c("v-date-range-picker", {
          ref: "picker",
          attrs: {
            opens: _vm.opens,
            localeData: _vm.localeData,
            minDate: _vm.field.min,
            maxDate: _vm.field.max,
            readonly: _vm.readonly,
            showDropdowns: _vm.showDropdowns,
            linkedCalendars: _vm.linkedCalendars,
            disabled: _vm.disabled,
            ranges: _vm.ranges,
          },
          on: {
            update: _vm.handleInput,
            toggle: _vm.togglePicker,
            "start-selection": _vm.selectDate,
          },
          scopedSlots: _vm._u([
            {
              key: "input",
              fn: function (picker) {
                return [
                  _vm._v(
                    _vm._s(_vm._f("textDate")(_vm.localValue.startDate)) +
                      " - " +
                      _vm._s(_vm._f("textDate")(_vm.localValue.endDate))
                  ),
                  _c("svg", { staticClass: "svg-icon svg-icon--calendar" }, [
                    _c("use", { attrs: { "xlink:href": "#svg-icon-calendar" } }),
                  ]),
                ]
              },
            },
          ]),
          model: {
            value: _vm.localValue,
            callback: function ($$v) {
              _vm.localValue = $$v;
            },
            expression: "localValue",
          },
        }),
        _c("span", { staticClass: "field-date-range__placeholder" }, [
          _vm._v(_vm._s(_vm.field.placeholder)),
        ]),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$w = [];
  __vue_render__$w._withStripped = true;

    /* style */
    const __vue_inject_styles__$A = undefined;
    /* scoped */
    const __vue_scope_id__$A = undefined;
    /* module identifier */
    const __vue_module_identifier__$A = undefined;
    /* functional template */
    const __vue_is_functional_template__$A = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$A = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
      __vue_inject_styles__$A,
      __vue_script__$A,
      __vue_scope_id__$A,
      __vue_is_functional_template__$A,
      __vue_module_identifier__$A,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$B = {
    data: function data() {
      return {
        localValue: null,
        rulerWidth: 0,
        drag: false,
        touch: controller.touch
      };
    },
    props: {
      field: {
        default: null,
        required: true
      },
      value: {
        default: null
      }
    },
    computed: {
      position: function position() {
        return {
          min: (this.localValue.min - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
          max: (this.localValue.max - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
          maxReverse: 100 - (this.localValue.max - this.field.min) / (this.field.max - this.field.min) * 100 + '%'
        };
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value || {
          min: this.field.min || 0,
          max: this.field.max || 0
        };
      },
      updateRulerSize: function updateRulerSize() {
        this.rulerWidth = this.$refs['ruler'] && this.$refs['ruler'].offsetWidth;
      },
      mousedown: function mousedown(handle) {
        this.drag = handle;
      },
      mouseup: function mouseup() {
        this.drag = false;
      },
      mousemove: function mousemove(e) {
        if (this.drag && !this.field.disabled) {
          var ruler = this.$refs['ruler'];
          var rect = ruler.getBoundingClientRect();
          var diff = ((e.pageX || e.touches[0].pageX) - rect.left) / rect.width;
          diff = Math.max(0, Math.min(1, diff));
          var val;
          var precision = this.field.precision || 1;
          var precisionString = precision.toString();
          var precisionPointIndex = precisionString.indexOf('.');

          if (this.drag === 'min') {
            val = Math.min(this.localValue.max, (this.field.max - this.field.min) * diff + this.field.min);
            val = Math.round(val / precision) * precision; // fix JS round bugs

            if (precisionPointIndex >= 0) {
              val = parseFloat(val.toFixed(precisionString.slice(precisionPointIndex).length));
            }

            this.localValue.min = val;
          } else if (this.drag === 'max') {
            val = Math.max(this.localValue.min, (this.field.max - this.field.min) * diff + this.field.min);
            val = Math.round(val / precision) * precision; // fix JS round bugs

            if (precisionPointIndex >= 0) {
              val = parseFloat(val.toFixed(precisionString.slice(precisionPointIndex).length));
            }

            this.localValue.max = val;
          }

          this.$emit('input', this.localValue);
        }
      }
    },
    created: function created() {
      this.updateLocalValue();
      this.updateRulerSize();
      window.addEventListener('resize', this.updateRulerSize);
      document.addEventListener('mouseup', this.mouseup);
      document.addEventListener('mousemove', this.mousemove);
      document.addEventListener('touchend', this.mouseup);
      document.addEventListener('touchmove', this.mousemove);
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.updateRulerSize);
      document.removeEventListener('mouseup', this.mouseup);
      document.removeEventListener('mousemove', this.mousemove);
      document.removeEventListener('touchend', this.mouseup);
      document.removeEventListener('touchmove', this.mousemove);
    }
  };

  /* script */
  const __vue_script__$B = script$B;

  /* template */
  var __vue_render__$x = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-field-range-slider field-range-slider",
        class: { "field-range-slider--disabled": _vm.field.disabled },
      },
      [
        _c("div", { staticClass: "field-range-slider__labels" }, [
          _c(
            "div",
            {
              staticClass:
                "field-range-slider__label field-range-slider__label--min",
            },
            [_vm._v(_vm._s(_vm.localValue.min))]
          ),
          _c(
            "div",
            {
              staticClass:
                "field-range-slider__label field-range-slider__label--max",
            },
            [_vm._v(_vm._s(_vm.localValue.max))]
          ),
        ]),
        _c("div", { staticClass: "field-range-slider__controls" }, [
          _c("div", { ref: "ruler", staticClass: "field-range-slider__ruler" }),
          _c("div", {
            staticClass: "field-range-slider__active",
            style: { left: _vm.position.min, right: _vm.position.maxReverse },
          }),
          _c("div", {
            staticClass: "field-range-slider__handle",
            class: {
              "field-range-slider__handle--z-bump": _vm.position.min === "100%",
            },
            style: { left: _vm.position.min },
            on: {
              mousedown: function ($event) {
                _vm.touch ? null : _vm.mousedown("min");
              },
              touchstart: function ($event) {
                _vm.touch ? _vm.mousedown("min") : null;
              },
            },
          }),
          _c("div", {
            staticClass: "field-range-slider__handle",
            style: { left: _vm.position.max },
            on: {
              mousedown: function ($event) {
                _vm.touch ? null : _vm.mousedown("max");
              },
              touchstart: function ($event) {
                _vm.touch ? _vm.mousedown("max") : null;
              },
            },
          }),
        ]),
      ]
    )
  };
  var __vue_staticRenderFns__$x = [];
  __vue_render__$x._withStripped = true;

    /* style */
    const __vue_inject_styles__$B = undefined;
    /* scoped */
    const __vue_scope_id__$B = undefined;
    /* module identifier */
    const __vue_module_identifier__$B = undefined;
    /* functional template */
    const __vue_is_functional_template__$B = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$B = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
      __vue_inject_styles__$B,
      __vue_script__$B,
      __vue_scope_id__$B,
      __vue_is_functional_template__$B,
      __vue_module_identifier__$B,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$C = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        localFormData: new FormData(),
        order: null
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        var _this = this;

        this.order = data;
        this.$nextTick(function () {
          var fieldsWithErrors = _this.order.fields.filter(function (field) {
            return field.errors && field.errors.length;
          });

          if (fieldsWithErrors.length) {
            setTimeout(function () {
              animate({
                duration: 1000,
                timing: function timing(timeFraction) {
                  return timeFraction;
                },
                // линейная функция значит, что анимация идёт с одной и той же скоростью
                draw: function draw(progress) {
                  document.documentElement.scrollTop += Math.round(document.querySelector('.field.form-error').getBoundingClientRect().top * progress);
                }
              });
            }, 300);
          }
        });
      },
      autoSubmitField: function autoSubmitField(field) {
        // при наличии параметра у поля отправляем форму
        if (field.autosubmit) {
          this.submitForm('autosubmit');
        }
      },
      submitForm: function submitForm(action) {
        var _this2 = this;

        this.localFormData.set('state[action]', action || 'submit');
        this.localFormData.set('bxajaxid', this.bxajaxid);
        this.order.fields.forEach(function (field) {
          _this2.localFormData.set(field.name, field.value);
        });
        this.dataLoad({
          url: this.order.remote,
          data: this.localFormData,
          delay: true
        }).then(function () {
          _this2.$forceUpdate();
        });
      },
      handleInput: function handleInput(value, field) {
        if (value) {
          field.errors = null;
        }
      }
    }
  };

  /* script */
  const __vue_script__$C = script$C;

  /* template */
  var __vue_render__$y = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-change-account change-account" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.order
          ? _c(
              "form",
              {
                staticClass: "container",
                on: {
                  submit: function ($event) {
                    $event.preventDefault();
                    return _vm.submitForm("submit")
                  },
                },
              },
              [
                _vm.order.title
                  ? _c("div", { staticClass: "page-title" }, [
                      _c("h1", { staticClass: "h2 page-title__value" }, [
                        _vm._v(_vm._s(_vm.order.title)),
                      ]),
                      _vm.order.text
                        ? _c("div", { staticClass: "change-account__subtitle" }, [
                            _vm._v(_vm._s(_vm.order.text)),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "form__main flc fcc" }, [
                  _c(
                    "div",
                    { staticClass: "form__groups" },
                    _vm._l(_vm.order.groups, function (group) {
                      return _c(
                        "div",
                        {
                          key: group.id,
                          ref: group.id,
                          refInFor: true,
                          staticClass: "form__group page-content__section flc",
                          style: { width: group.width || null },
                          attrs: { id: group.id },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "page-content__section-header" },
                            [
                              group.title
                                ? _c(
                                    "h4",
                                    { staticClass: "form__group-title flc" },
                                    [_vm._v(_vm._s(group.title))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c("div", { staticClass: "form__group-body" }, [
                            _c(
                              "div",
                              { staticClass: "form__fields" },
                              [
                                _vm._l(_vm.order.fields, function (field, index) {
                                  return field.groupId === group.id
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            key: field.id,
                                            staticClass: "form__field",
                                            style: { width: field.width || null },
                                          },
                                          [
                                            field.type == "tooltip"
                                              ? _c("v-field", {
                                                  attrs: { field: field },
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.autoSubmitField(
                                                        field
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: field.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        field,
                                                        "value",
                                                        $$v
                                                      );
                                                    },
                                                    expression: "field.value",
                                                  },
                                                })
                                              : _c("v-field", {
                                                  attrs: { field: field },
                                                  on: {
                                                    blur: function ($event) {
                                                      return _vm.autoSubmitField(
                                                        field
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.handleInput(
                                                        $event,
                                                        field
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: field.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        field,
                                                        "value",
                                                        $$v
                                                      );
                                                    },
                                                    expression: "field.value",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e()
                                }),
                              ],
                              2
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm.order.buttons && _vm.order.buttons.length
                  ? _c("div", { staticClass: "form__footer flc" }, [
                      _c(
                        "div",
                        { staticClass: "form__actions" },
                        _vm._l(_vm.order.buttons, function (button, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "form__action" },
                            [
                              button.link
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn",
                                      class: button.className,
                                      attrs: { href: button.link },
                                    },
                                    [_vm._v(_vm._s(button.text))]
                                  )
                                : _c(
                                    "button",
                                    {
                                      class:
                                        button.className || "btn btn--primary",
                                      attrs: { type: button.type || "submit" },
                                    },
                                    [_vm._v(_vm._s(button.text))]
                                  ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$y = [];
  __vue_render__$y._withStripped = true;

    /* style */
    const __vue_inject_styles__$C = undefined;
    /* scoped */
    const __vue_scope_id__$C = undefined;
    /* module identifier */
    const __vue_module_identifier__$C = undefined;
    /* functional template */
    const __vue_is_functional_template__$C = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$C = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
      __vue_inject_styles__$C,
      __vue_script__$C,
      __vue_scope_id__$C,
      __vue_is_functional_template__$C,
      __vue_module_identifier__$C,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$D = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        localFormData: new FormData(),
        order: null
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        var _this = this;

        this.order = data;
        this.$nextTick(function () {
          var fieldsWithErrors = _this.order.fields.filter(function (field) {
            return field.errors && field.errors.length;
          });

          if (fieldsWithErrors.length) {
            setTimeout(function () {
              animate({
                duration: 1000,
                timing: function timing(timeFraction) {
                  return timeFraction;
                },
                // линейная функция значит, что анимация идёт с одной и той же скоростью
                draw: function draw(progress) {
                  document.documentElement.scrollTop += Math.round(document.querySelector('.field.form-error').getBoundingClientRect().top * progress);
                }
              });
            }, 300);
          }
        });
      },
      autoSubmitField: function autoSubmitField(field) {
        // при наличии параметра у поля отправляем форму
        if (field.autosubmit) {
          this.submitForm('autosubmit');
        }
      },
      submitForm: function submitForm(action) {
        var _this2 = this;

        this.localFormData.set('state[action]', action || 'submit');
        this.localFormData.set('bxajaxid', this.bxajaxid);
        this.order.fields.forEach(function (field) {
          _this2.localFormData.set(field.name, field.value);
        });
        this.dataLoad({
          url: this.order.remote,
          data: this.localFormData,
          delay: true
        });
      },
      handleInput: function handleInput(value, field) {
        if (value) {
          field.errors = null;
        }
      }
    }
  };

  /* script */
  const __vue_script__$D = script$D;

  /* template */
  var __vue_render__$z = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-add-company add-company" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.order
          ? _c(
              "form",
              {
                ref: "form",
                staticClass: "container",
                on: {
                  submit: function ($event) {
                    $event.preventDefault();
                    return _vm.submitForm.apply(null, arguments)
                  },
                },
              },
              [
                _vm.order.title
                  ? _c("div", { staticClass: "page-title" }, [
                      _c("h1", { staticClass: "h2 page-title__value" }, [
                        _vm._v(_vm._s(_vm.order.title)),
                      ]),
                      _vm.order.text
                        ? _c("div", { staticClass: "add-company__subtitle" }, [
                            _vm._v(_vm._s(_vm.order.text)),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "form__main flc fcc" }, [
                  _c(
                    "div",
                    { staticClass: "form__groups" },
                    _vm._l(_vm.order.groups, function (group) {
                      return _c(
                        "div",
                        {
                          key: group.id,
                          ref: group.id,
                          refInFor: true,
                          staticClass: "form__group page-content__section flc",
                          style: { width: group.width || null },
                          attrs: { id: group.id },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "page-content__section-header" },
                            [
                              group.title
                                ? _c(
                                    "h4",
                                    { staticClass: "form__group-title flc" },
                                    [_vm._v(_vm._s(group.title))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c("div", { staticClass: "form__group-body" }, [
                            _c(
                              "div",
                              { staticClass: "form__fields" },
                              [
                                _vm._l(_vm.order.fields, function (field, index) {
                                  return field.groupId === group.id
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            key: field.id,
                                            staticClass: "form__field",
                                            style: { width: field.width || null },
                                          },
                                          [
                                            field.type == "radio-blocks" ||
                                            field.type == "select"
                                              ? _c("v-field", {
                                                  attrs: { field: field },
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.autoSubmitField(
                                                        field
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: field.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        field,
                                                        "value",
                                                        $$v
                                                      );
                                                    },
                                                    expression: "field.value",
                                                  },
                                                })
                                              : field.type == "tooltip"
                                              ? _c("v-field", {
                                                  attrs: { field: field },
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.autoSubmitField(
                                                        field
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: field.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        field,
                                                        "value",
                                                        $$v
                                                      );
                                                    },
                                                    expression: "field.value",
                                                  },
                                                })
                                              : _c("v-field", {
                                                  attrs: { field: field },
                                                  on: {
                                                    blur: function ($event) {
                                                      return _vm.autoSubmitField(
                                                        field
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.handleInput(
                                                        $event,
                                                        field
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: field.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        field,
                                                        "value",
                                                        $$v
                                                      );
                                                    },
                                                    expression: "field.value",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e()
                                }),
                              ],
                              2
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm.order.buttons && _vm.order.buttons.length
                  ? _c("div", { staticClass: "form__footer flc" }, [
                      _c(
                        "div",
                        { staticClass: "form__actions" },
                        _vm._l(_vm.order.buttons, function (button, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "form__action" },
                            [
                              button.link
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn",
                                      class: button.className,
                                      attrs: { href: button.link },
                                    },
                                    [_vm._v(_vm._s(button.text))]
                                  )
                                : _c(
                                    "button",
                                    {
                                      class:
                                        button.className || "btn btn--primary",
                                      attrs: { type: button.type || "submit" },
                                    },
                                    [_vm._v(_vm._s(button.text))]
                                  ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$z = [];
  __vue_render__$z._withStripped = true;

    /* style */
    const __vue_inject_styles__$D = undefined;
    /* scoped */
    const __vue_scope_id__$D = undefined;
    /* module identifier */
    const __vue_module_identifier__$D = undefined;
    /* functional template */
    const __vue_is_functional_template__$D = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$D = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
      __vue_inject_styles__$D,
      __vue_script__$D,
      __vue_scope_id__$D,
      __vue_is_functional_template__$D,
      __vue_module_identifier__$D,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$E = {
    data: function data() {
      return {
        opens: 'right',
        localValue: {
          startDate: null,
          endDate: null
        },
        inputValue: this.inputValueFormat,
        ranges: false,
        singleDatePicker: true,
        showDropdowns: false,
        linkedCalendars: false,
        disabled: false,
        readonly: false,
        closeOnEsc: true,
        localError: null,
        localeData: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: '/',
          applyLabel: 'Применить',
          cancelLabel: 'Отменить',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
          monthNames: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
          firstDay: 1
        }
      };
    },
    props: {
      field: {
        default: null,
        required: true
      },
      value: {
        default: null
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function handler() {
          if (this.value) {
            this.localValue.startDate = this.value ? new Date(this.value) : null;
            this.localValue.endDate = this.localValue.startDate;
          } else if (this.field.value) {
            this.localValue.startDate = this.field.value ? new Date(this.field.value) : null;
            this.localValue.endDate = this.localValue.startDate;
          }

          this.inputValue = this.localValue.startDate ? this.inputMaskTextDate(this.localValue.startDate) : null;
        }
      }
    },
    computed: {
      inputValueFormat: function inputValueFormat() {
        return this.inputMaskTextDate(this.localValue.startDate);
      }
    },
    methods: {
      isoDate: function isoDate(date) {
        date = date.toString().replace(/GMT\+\d{4}/, 'GMT+0000');
        return new Date(date).toISOString().substr(0, 10);
      },
      inputMaskTextDate: function inputMaskTextDate(dateString) {
        return this.textDate(dateString).replaceAll('/', '.');
      },
      textDate: function textDate(dateString) {
        return new Intl.DateTimeFormat('ru-RU').format(new Date(dateString));
      },
      handleInput: function handleInput() {
        this.inputValue = this.inputMaskTextDate(this.localValue.startDate);
        this.$emit('input', this.localValue.startDate);
        this.$refs.picker.togglePicker(false);
        this.localError = null;
      },
      handleMaskInput: function handleMaskInput() {
        this.localError = null;

        if (this.inputValue && this.field.mask && this.inputValue.replaceAll(/[^0-9]/g, '').length === this.field.mask.replaceAll(/[^0-9]/g, '').length) {
          var dateParts = this.inputValue.split('.');
          var date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

          if (isNaN(date) || date.getTime() < new Date(this.field.min).getTime() || date.getTime() > new Date(this.field.max).getTime()) {
            this.localError = true;
            this.$refs.picker.togglePicker(false);
          } else {
            this.localValue.startDate = date;
            this.handleInput();
          }
        }
      },
      togglePicker: function togglePicker(status) {
        var _this = this;

        if (status) {
          this.$nextTick(function () {
            var items = _this.$el.querySelectorAll('[data-range-key]');

            items.forEach(function (item) {
              item.addEventListener('click', function () {
                items.forEach(function (item) {
                  item.classList.remove('active');
                });
                item.classList.add('active');
              });
            });
          });

          if (this.localError) {
            this.localError = null;
            this.localValue.startDate = null;
            this.inputValue = null;
          }
        }
      },
      selectDate: function selectDate() {
        var items = this.$el.querySelectorAll('[data-range-key]');
        items.forEach(function (item) {
          item.classList.remove('active');
        });
      }
    }
  };

  /* script */
  const __vue_script__$E = script$E;

  /* template */
  var __vue_render__$A = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-field-date field-date" },
      [
        _c("v-date-range-picker", {
          ref: "picker",
          attrs: {
            singleDatePicker: _vm.singleDatePicker,
            opens: _vm.opens,
            localeData: _vm.localeData,
            readonly: _vm.readonly,
            showDropdowns: _vm.showDropdowns,
            linkedCalendars: _vm.linkedCalendars,
            disabled: _vm.disabled,
            ranges: _vm.ranges,
            minDate: _vm.field.min,
            maxDate: _vm.field.max,
          },
          on: {
            update: _vm.handleInput,
            toggle: _vm.togglePicker,
            "start-selection": _vm.selectDate,
          },
          scopedSlots: _vm._u([
            {
              key: "input",
              fn: function (picker) {
                return [
                  _c("v-masked-input", {
                    staticClass: "field-date__input",
                    attrs: { type: "text", mask: _vm.field.mask },
                    on: { input: _vm.handleMaskInput },
                    model: {
                      value: _vm.inputValue,
                      callback: function ($$v) {
                        _vm.inputValue = $$v;
                      },
                      expression: "inputValue",
                    },
                  }),
                  _c("svg", { staticClass: "svg-icon svg-icon--calendar" }, [
                    _c("use", { attrs: { "xlink:href": "#svg-icon-calendar" } }),
                  ]),
                ]
              },
            },
          ]),
          model: {
            value: _vm.localValue,
            callback: function ($$v) {
              _vm.localValue = $$v;
            },
            expression: "localValue",
          },
        }),
        _c("span", { staticClass: "field-date__placeholder" }, [
          _vm._v(_vm._s(_vm.field.placeholder)),
        ]),
        _c("transition", { attrs: { name: "dropdown" } }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.field.error || _vm.localError,
                  expression: " field.error || localError",
                },
              ],
              staticClass: "field-date__error",
            },
            [_vm._v(_vm._s(_vm.field.error || "Введена некорректная дата"))]
          ),
        ]),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$A = [];
  __vue_render__$A._withStripped = true;

    /* style */
    const __vue_inject_styles__$E = undefined;
    /* scoped */
    const __vue_scope_id__$E = undefined;
    /* module identifier */
    const __vue_module_identifier__$E = undefined;
    /* functional template */
    const __vue_is_functional_template__$E = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$E = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
      __vue_inject_styles__$E,
      __vue_script__$E,
      __vue_scope_id__$E,
      __vue_is_functional_template__$E,
      __vue_module_identifier__$E,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$F = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        section: null
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        this.section = data;
      }
    }
  };

  /* script */
  const __vue_script__$F = script$F;

  /* template */
  var __vue_render__$B = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("section", { staticClass: "v-page-section page-section flc" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.section
            ? _c("v-page-section-header", {
                attrs: { "data-source": _vm.section },
              })
            : _vm._e(),
          _vm._t("default"),
        ],
        2
      ),
    ])
  };
  var __vue_staticRenderFns__$B = [];
  __vue_render__$B._withStripped = true;

    /* style */
    const __vue_inject_styles__$F = undefined;
    /* scoped */
    const __vue_scope_id__$F = undefined;
    /* module identifier */
    const __vue_module_identifier__$F = undefined;
    /* functional template */
    const __vue_is_functional_template__$F = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$F = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
      __vue_inject_styles__$F,
      __vue_script__$F,
      __vue_scope_id__$F,
      __vue_is_functional_template__$F,
      __vue_module_identifier__$F,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$G = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        section: null
      };
    },
    props: {
      activeLink: {
        default: 0
      }
    },
    methods: {
      dataSet: function dataSet(data) {
        this.section = data;

        if (this.section.links && this.section.links.length == 1) {
          this.section.links[0].id = 0;
        }
      }
    }
  };

  /* script */
  const __vue_script__$G = script$G;

  /* template */
  var __vue_render__$C = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-page-section-header page-section-header flc" },
      [
        _c("div", { staticClass: "page-section-header__main" }, [
          _vm.section.title
            ? _c(
                "h2",
                { staticClass: "page-section-header__title" },
                [
                  _vm.section.title.link
                    ? [
                        _c(
                          "a",
                          {
                            staticClass: "page-section-header__title-link link",
                            attrs: { href: _vm.section.title.link },
                          },
                          [_vm._v(_vm._s(_vm.section.title.text))]
                        ),
                      ]
                    : [_vm._v(_vm._s(_vm.section.title.text))],
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm.section.links && _vm.section.links.length
          ? _c("div", { staticClass: "page-section-header__aside" }, [
              _c(
                "div",
                {
                  staticClass: "page-section-header__aside-links",
                  class: {
                    "page-section-header__aside-links--col": _vm.section.allLinks,
                  },
                },
                _vm._l(_vm.section.links, function (link, index) {
                  return _vm.section.allLinks ||
                    (!_vm.section.allLinks && link.id == _vm.activeLink)
                    ? _c(
                        "div",
                        { staticClass: "page-section-header__aside-links-item" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "page-section-header__aside-link link",
                              class: link.class,
                              attrs: {
                                href: link.link,
                                target: link.openCurrentPage ? "_self" : "_blank",
                              },
                            },
                            [
                              _c(
                                "span",
                                { class: { "hide-xs": link.textShort } },
                                [_vm._v(_vm._s(link.text))]
                              ),
                              link.textShort
                                ? _c(
                                    "span",
                                    { staticClass: "hide-lg hide-md hide-sm" },
                                    [_vm._v(_vm._s(link.textShort))]
                                  )
                                : _vm._e(),
                              _c(
                                "svg",
                                { staticClass: "svg-icon svg-icon--arrow-right" },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xlink:href": "#svg-icon-arrow-right",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e()
                }),
                0
              ),
            ])
          : _vm._e(),
      ]
    )
  };
  var __vue_staticRenderFns__$C = [];
  __vue_render__$C._withStripped = true;

    /* style */
    const __vue_inject_styles__$G = undefined;
    /* scoped */
    const __vue_scope_id__$G = undefined;
    /* module identifier */
    const __vue_module_identifier__$G = undefined;
    /* functional template */
    const __vue_is_functional_template__$G = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$G = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
      __vue_inject_styles__$G,
      __vue_script__$G,
      __vue_scope_id__$G,
      __vue_is_functional_template__$G,
      __vue_module_identifier__$G,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$H = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        slide: null,
        winWidth: window.innerWidth,
        breakpoints: breakpoints
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        this.slide = data;
      },
      setBreakpoint: function setBreakpoint() {
        this.winWidth = window.innerWidth;
      }
    },
    mounted: function mounted() {
      window.addEventListener('resize', this.setBreakpoint);
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.setBreakpoint);
    }
  };

  /* script */
  const __vue_script__$H = script$H;

  /* template */
  var __vue_render__$D = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-hero-block hero-block",
        class: {
          "hero-block--dark": _vm.slide && _vm.slide.dark,
          "hero-block--right": _vm.slide && _vm.slide.position == "right",
        },
      },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.slide
          ? [
              _vm.slide.link
                ? _c("a", {
                    staticClass: "hero-block__link",
                    attrs: { href: _vm.slide.link },
                  })
                : _vm._e(),
              _vm.slide.imageSources
                ? _c("div", { staticClass: "hero-block__bg-layer" }, [
                    _vm.slide.imageSources.large
                      ? _c(
                          "div",
                          { staticClass: "hero-block__bg hero-block__bg--large" },
                          [
                            _c("div", {
                              staticClass: "hero-block__bg-image",
                              style: {
                                "background-image":
                                  "url(" + _vm.slide.imageSources.large + ")",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.slide.imageSources.medium
                      ? _c(
                          "div",
                          {
                            staticClass: "hero-block__bg hero-block__bg--medium",
                          },
                          [
                            _c("div", {
                              staticClass: "hero-block__bg-image",
                              style: {
                                "background-image":
                                  "url(" + _vm.slide.imageSources.medium + ")",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.slide.imageSources.small
                      ? _c(
                          "div",
                          { staticClass: "hero-block__bg hero-block__bg--small" },
                          [
                            _c("div", {
                              staticClass: "hero-block__bg-image",
                              style: {
                                "background-image":
                                  "url(" + _vm.slide.imageSources.small + ")",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "hero-block__fg-layer" }, [
                _c("div", { staticClass: "hero-block__container container" }, [
                  _c("div", { staticClass: "hero-block__content" }, [
                    _vm.slide.title
                      ? _c("h2", {
                          staticClass: "hero-block__title h1 flc",
                          style: {
                            color:
                              _vm.breakpoints["xs-max"] >= _vm.winWidth
                                ? _vm.slide.title_color_mob
                                : _vm.slide.title_color,
                          },
                          domProps: { innerHTML: _vm._s(_vm.slide.title) },
                        })
                      : _vm._e(),
                    _vm.slide.subtitle
                      ? _c("div", {
                          staticClass: "hero-block__subtitle flc",
                          style: {
                            color:
                              _vm.breakpoints["xs-max"] >= _vm.winWidth
                                ? _vm.slide.subtitle_color_mob
                                : _vm.slide.subtitle_color,
                          },
                          domProps: { innerHTML: _vm._s(_vm.slide.subtitle) },
                        })
                      : _vm._e(),
                    _vm.slide.text
                      ? _c("div", {
                          staticClass: "hero-block__text flc",
                          domProps: { innerHTML: _vm._s(_vm.slide.text) },
                        })
                      : _vm._e(),
                    _vm.slide.buttons && _vm.slide.buttons.length
                      ? _c("div", { staticClass: "hero-block__actions flc" }, [
                          _c(
                            "div",
                            { staticClass: "hero-block__actions-grid" },
                            _vm._l(_vm.slide.buttons, function (button) {
                              return _c(
                                "div",
                                { staticClass: "hero-block__actions-cell" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "hero-block__action btn btn--icon",
                                      class: {
                                        "btn--primary":
                                          !_vm.slide.dark &&
                                          button.type === "primary",
                                        "btn--white":
                                          _vm.slide.dark &&
                                          button.type === "default",
                                        "btn--primary-white":
                                          _vm.slide.dark &&
                                          button.type === "primary",
                                      },
                                      attrs: { href: button.link },
                                    },
                                    [
                                      _c("span", [_vm._v(_vm._s(button.text))]),
                                      button.icon
                                        ? _c(
                                            "svg",
                                            {
                                              staticClass: "svg-icon",
                                              class: "svg-icon--" + button.icon,
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    "#svg-icon-" + button.icon,
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$D = [];
  __vue_render__$D._withStripped = true;

    /* style */
    const __vue_inject_styles__$H = undefined;
    /* scoped */
    const __vue_scope_id__$H = undefined;
    /* module identifier */
    const __vue_module_identifier__$H = undefined;
    /* functional template */
    const __vue_is_functional_template__$H = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$H = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
      __vue_inject_styles__$H,
      __vue_script__$H,
      __vue_scope_id__$H,
      __vue_is_functional_template__$H,
      __vue_module_identifier__$H,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$I = {
    methods: {
      // wordEndings[0] - 1, wordEndings[1] - 2-4, wordEndings[2] - 0, 5-9
      pluralize: function pluralize(value, wordBase, wordEndings, approx) {
        // тыс. просмотрОВ, млн. просмотрОВ
        if (approx && value >= 1000) {
          return wordBase + wordEndings[2];
        } // *надцать (11-19) - всегда вариант 3


        if (value % 100 > 10 && value % 100 < 20) {
          return wordBase + wordEndings[2];
        }

        var ending = value % 10;

        if (ending == 0 || ending >= 5) {
          return wordBase + wordEndings[2];
        } else if (ending == 1) {
          return wordBase + wordEndings[0];
        } else {
          return wordBase + wordEndings[1];
        }
      }
    },
    filters: {
      price: function price(_price) {
        if (!_price && _price !== 0 && _price !== '0') {
          console.log('Ошибка цены');
          return ' - ';
        }

        return parseFloat(_price).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      },
      integer: function integer(price) {
        if (!price && price !== 0 && price !== '0') {
          console.log('Ошибка цены', price);
          return ' - ';
        }

        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      },
      dateShort: function dateShort(text) {
        if (!/^\d+$/.test(text)) {
          return text;
        }

        try {
          var date = new Date(text);
          var day = date.getDate();
          var month = date.getMonth();
          var year = date.getFullYear();
          return '' + day + ' ' + ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'][month] + ' ' + year;
        } catch (e) {
          return '';
        }
      },
      numberAppr: function numberAppr(text) {

        if (text > 100000) {
          return Math.round(text / 100000) + ' млн.';
        } else if (text > 1000) {
          return Math.round(text / 100) + ' тыс.';
        } else {
          return text;
        }
      }
    }
  };

  /* script */
  const __vue_script__$I = script$I;

  /* template */

    /* style */
    const __vue_inject_styles__$I = undefined;
    /* scoped */
    const __vue_scope_id__$I = undefined;
    /* module identifier */
    const __vue_module_identifier__$I = undefined;
    /* functional template */
    const __vue_is_functional_template__$I = undefined;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$I = /*#__PURE__*/normalizeComponent(
      {},
      __vue_inject_styles__$I,
      __vue_script__$I,
      __vue_scope_id__$I,
      __vue_is_functional_template__$I,
      __vue_module_identifier__$I,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$J = {
    mixins: [__vue_component__$I],
    props: {
      price: {
        default: null
      },
      size: {
        default: 'md'
      }
    }
  };

  /* script */
  const __vue_script__$J = script$J;

  /* template */
  var __vue_render__$E = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-price price", class: "price--" + _vm.size },
      [
        _vm.price
          ? [
              _vm.price.current
                ? _c(
                    "div",
                    {
                      staticClass: "price__group",
                      class: { "price__group--new": _vm.price.pricePeriod },
                    },
                    [
                      _vm.price.current.prefix
                        ? _c("span", { staticClass: "price__prefix" }, [
                            _vm._v(_vm._s(_vm.price.current.prefix) + " "),
                          ])
                        : _vm._e(),
                      _vm.price.current.value
                        ? _c("span", { staticClass: "price__value" }, [
                            _vm._v(
                              _vm._s(_vm._f("price")(_vm.price.current.value)) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.price.current.currency
                        ? _c("span", { staticClass: "price__currency" }, [
                            _vm._v(_vm._s(_vm.price.current.currency)),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.price.pricePeriod
                ? _c(
                    "div",
                    { staticClass: "price__group price__group--installments" },
                    [
                      _vm.price.pricePeriod.prefix
                        ? _c("span", { staticClass: "price__prefix" }, [
                            _vm._v(_vm._s(_vm.price.pricePeriod.prefix) + "  "),
                          ])
                        : _vm._e(),
                      _vm.price.pricePeriod.value
                        ? _c("span", { staticClass: "price__value" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("price")(_vm.price.pricePeriod.value)
                              ) + " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.price.pricePeriod.currency && _vm.price.pricePeriod.unit
                        ? _c("span", { staticClass: "price__currency" }, [
                            _vm._v(
                              _vm._s(_vm.price.pricePeriod.currency) +
                                "/" +
                                _vm._s(_vm.price.pricePeriod.unit) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.price.pricePeriod.unit && _vm.price.pricePeriod.period
                        ? _c("span", { staticClass: "price__currency" }, [
                            _vm._v(
                              "- " +
                                _vm._s(_vm.price.pricePeriod.period) +
                                " " +
                                _vm._s(_vm.price.pricePeriod.unit) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$E = [];
  __vue_render__$E._withStripped = true;

    /* style */
    const __vue_inject_styles__$J = undefined;
    /* scoped */
    const __vue_scope_id__$J = undefined;
    /* module identifier */
    const __vue_module_identifier__$J = undefined;
    /* functional template */
    const __vue_is_functional_template__$J = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$J = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
      __vue_inject_styles__$J,
      __vue_script__$J,
      __vue_scope_id__$J,
      __vue_is_functional_template__$J,
      __vue_module_identifier__$J,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$K = {
    props: {
      statuses: {
        type: Array,
        default: null
      }
    }
  };

  /* script */
  const __vue_script__$K = script$K;

  /* template */
  var __vue_render__$F = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-status status" },
      [
        _vm.statuses
          ? [
              _c(
                "div",
                { staticClass: "status__list" },
                _vm._l(_vm.statuses, function (status, index) {
                  return _c(
                    "div",
                    {
                      staticClass: "status__item",
                      class: { "status__item--action": index == 1 },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "status-label",
                          class: { "status-label--action": index == 1 },
                        },
                        [
                          _c("span", { staticClass: "status-label__content" }, [
                            _vm._v(_vm._s(status.text)),
                          ]),
                          status.description
                            ? _c("span", { staticClass: "status__item__link" })
                            : _vm._e(),
                        ]
                      ),
                      status.description
                        ? _c(
                            "div",
                            { staticClass: "status__action-tooltip" },
                            [
                              index == 1
                                ? _c("v-tooltip", {
                                    staticClass: "tooltip--no-icon",
                                    attrs: {
                                      tooltip: status.description,
                                      options: { offset: [-65, 25] },
                                    },
                                  })
                                : _c("v-tooltip", {
                                    staticClass: "tooltip--no-icon",
                                    attrs: {
                                      tooltip: status.description,
                                      options: { offset: [-65, 10] },
                                    },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$F = [];
  __vue_render__$F._withStripped = true;

    /* style */
    const __vue_inject_styles__$K = undefined;
    /* scoped */
    const __vue_scope_id__$K = undefined;
    /* module identifier */
    const __vue_module_identifier__$K = undefined;
    /* functional template */
    const __vue_is_functional_template__$K = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$K = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
      __vue_inject_styles__$K,
      __vue_script__$K,
      __vue_scope_id__$K,
      __vue_is_functional_template__$K,
      __vue_module_identifier__$K,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$L = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        catalog: null,
        state: {
          page: null,
          sort: null,
          view: null,
          filter: null
        },
        changedFilters: null,
        asideOpen: false,
        foldedAsideMode: undefined
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (options.append && this.catalog && this.catalog.items) {
          var oldItems = this.catalog.items;
          this.catalog = data;
          this.catalog.items = oldItems.concat(this.catalog.items);
        } else {
          this.catalog = data;
        }

        this.state.sort = this.catalog.sort ? this.catalog.sort.value : null;
        this.state.page = this.catalog.page;
        this.state.view = this.state.view || this.catalog.view && this.catalog.view.value || 'grid';
      },
      navigate: function navigate(page) {
        this.state.page.offset = page.offset;
        this.state.page.limit = page.limit;
        this.requestDataLoad({
          append: page.append
        });
        animate({
          duration: 1000,
          timing: function timing(timeFraction) {
            return timeFraction;
          },
          // линейная функция значит, что анимация идёт с одной и той же скоростью
          draw: function draw(progress) {
            document.documentElement.scrollTop = document.documentElement.scrollTop - progress * document.documentElement.scrollTop;
          }
        });
      },
      filterUpdated: function filterUpdated(filterValue, changedFilters) {
        this.state.filter = filterValue;
        this.changedFilters = JSON.parse(JSON.stringify(changedFilters));

        if (window.location.pathname.indexOf('/local/') < 0 && !this.catalog.notChangeUrl) {
          window.history.replaceState(null, null, this.catalog.remote);
        }

        console.log('filterUpdated');
      },
      filterChanged: function filterChanged(filterValue) {
        this.state.filter = filterValue;
        this.requestDataLoad();
        console.log('filterChanged');
      },
      requestDataLoad: function requestDataLoad(dataSetOptions) {
        this.dataLoad({
          url: this.catalog.remote,
          delay: true,
          data: {
            page: this.state.page,
            sort: this.state.sort,
            filter: this.state.filter
          }
        }, dataSetOptions);
      },
      tagLinkFilter: function tagLinkFilter(link) {
        this.dataLoad({
          url: link,
          delay: true,
          data: {
            sort: this.state.sort
          }
        });
      },
      openAside: function openAside() {
        controller.openCatalogAside();
      },
      closeAside: function closeAside() {
        controller.closeCatalogAside();
      },
      updateFoldedAsideState: function updateFoldedAsideState() {
        this.foldedAsideMode = window.innerWidth <= breakpoints['sm-max'];
      }
    },
    created: function created() {
      window.addEventListener('resize', this.updateFoldedAsideState);
      this.updateFoldedAsideState();
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.updateFoldedAsideState);
    }
  };

  /* script */
  const __vue_script__$L = script$L;

  /* template */
  var __vue_render__$G = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-catalog catalog" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _c(
          "div",
          { staticClass: "container" },
          [
            !_vm.catalog
              ? [_c("div", { staticClass: "catalog__placeholder" })]
              : _vm._e(),
            _vm.catalog
              ? [
                  _vm.catalog.page.count && _vm.catalog.type == "search"
                    ? _c("div", { staticClass: "catalog__count" }, [
                        _c("div", { staticClass: "catalog__count-text" }, [
                          _vm._v(
                            "Найдено товаров: " + _vm._s(_vm.catalog.page.count)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "catalog__top-navigation flc" },
                    [
                      _c("v-filter", {
                        attrs: { "top-links": _vm.catalog.topLinks },
                        on: {
                          "filter-changed": _vm.filterChanged,
                          "filter-updated": _vm.filterUpdated,
                        },
                      }),
                      _vm.catalog.tagLinks
                        ? _c("v-filter", {
                            staticClass: "filter--bg",
                            attrs: {
                              "tag-links": _vm.catalog.tagLinks,
                              "other-filters": _vm.catalog.filters,
                            },
                            on: {
                              "filter-changed": _vm.filterChanged,
                              "filter-updated": _vm.filterUpdated,
                            },
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "catalog__layout" }, [
                        _c("div", { staticClass: "catalog__layout-aside" }, [
                          _c(
                            "div",
                            { staticClass: "catalog__layout-aside-container" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "catalog__aside-close",
                                  attrs: { type: "button" },
                                  on: { click: _vm.closeAside },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon catalog__aside-close-icon",
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#svg-icon-close",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "catalog__layout-aside-container-inner",
                                },
                                [
                                  _vm.catalog.filters
                                    ? _c(
                                        "div",
                                        { staticClass: "catalog__filter flc" },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "catalog__filter-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.catalog.filterTitle)
                                              ),
                                            ]
                                          ),
                                          _c("v-filter", {
                                            ref: "filter",
                                            attrs: {
                                              filters: _vm.catalog.filters,
                                              "other-tags": _vm.catalog.tagLinks,
                                            },
                                            on: {
                                              "filter-changed": _vm.filterChanged,
                                              "filter-updated": _vm.filterUpdated,
                                            },
                                          }),
                                          _vm.catalog.filters
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "catalog__layout-aside--bottom-fixed",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "container" },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn--primary btn--md btn--full-width",
                                                          on: {
                                                            click: _vm.closeAside,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.catalog
                                                                .showResultBtnText
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "catalog__layout-main" }, [
                          _vm.catalog.sort ||
                          (_vm.changedFilters && _vm.changedFilters.length) ||
                          (_vm.foldedAsideMode &&
                            (_vm.catalog.filters || _vm.catalog.links))
                            ? _c("div", { staticClass: "catalog__top-nav" }, [
                                _c(
                                  "div",
                                  { staticClass: "catalog__top-nav-grid" },
                                  [
                                    _vm.catalog.sort ||
                                    (_vm.foldedAsideMode &&
                                      (_vm.catalog.filters || _vm.catalog.links))
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "catalog__top-nav-group-cell",
                                          },
                                          [
                                            _vm.catalog.sort
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "catalog__top-nav-cell catalog__top-nav-cell--select",
                                                  },
                                                  [
                                                    _c("v-field", {
                                                      attrs: {
                                                        field: {
                                                          type: "select",
                                                          options:
                                                            _vm.catalog.sort
                                                              .options,
                                                          label: "Сортировка",
                                                        },
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.requestDataLoad,
                                                      },
                                                      model: {
                                                        value: _vm.state.sort,
                                                        callback: function ($$v) {
                                                          _vm.$set(
                                                            _vm.state,
                                                            "sort",
                                                            $$v
                                                          );
                                                        },
                                                        expression: "state.sort",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.foldedAsideMode &&
                                            (_vm.catalog.filters ||
                                              _vm.catalog.links)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "catalog__top-nav-cell catalog__top-nav-cell--aside-toggle",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "catalog__aside-toggle",
                                                        attrs: { type: "button" },
                                                        on: {
                                                          click: _vm.openAside,
                                                        },
                                                      },
                                                      [
                                                        _vm._m(0),
                                                        _vm.changedFilters &&
                                                        _vm.changedFilters.length
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "catalog__aside-badge badge badge--fix badge--primary",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .changedFilters
                                                                      .length
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.changedFilters &&
                                    _vm.changedFilters.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "catalog__top-nav-cell catalog__top-nav-cell--active-filters",
                                          },
                                          [
                                            _c("v-filter-active-items", {
                                              attrs: {
                                                filters: _vm.changedFilters,
                                              },
                                              on: {
                                                "reset-filter": function (
                                                  $event
                                                ) {
                                                  return _vm.$refs[
                                                    "filter"
                                                  ].$emit("request-reset", $event)
                                                },
                                                "reset-all-filters": function (
                                                  $event
                                                ) {
                                                  return _vm.$refs[
                                                    "filter"
                                                  ].$emit(
                                                    "request-reset-all",
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "catalog__list flc" },
                            [
                              _c(
                                "transition",
                                { attrs: { name: "fade", mode: "out-in" } },
                                [
                                  !_vm.catalog.items || !_vm.catalog.items.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "catalog__list-message flc",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "catalog__list-message-title h3 flc",
                                            },
                                            [_vm._v("Ничего не найдено")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "catalog__list-message-body flc",
                                            },
                                            [
                                              _vm._v(
                                                "Попробуйте изменить параметры поиска или перейдите на главную страницу."
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "catalog__list-message-actions flc",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "catalog__list-message-actions-grid",
                                                },
                                                [
                                                  _vm.changedFilters &&
                                                  _vm.changedFilters.length
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "catalog__list-message-action",
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass: "btn",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$refs[
                                                                    "filter"
                                                                  ].$emit(
                                                                    "request-reset-all"
                                                                  )
                                                                },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Очистить фильтр"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "catalog__list-message-action",
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass: "btn",
                                                          attrs: { href: "/" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "На главную страницу"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : (_vm.state.view == "grid" &&
                                        _vm.catalog.type == "products") ||
                                      (_vm.state.view == "grid" &&
                                        _vm.catalog.type == "search")
                                    ? _c("v-product-grid", {
                                        attrs: {
                                          items: _vm.catalog.items,
                                          banner: _vm.catalog.banner,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "catalog__nav flc" },
                            [
                              _c("v-page-nav", {
                                attrs: { page: _vm.catalog.page },
                                on: { navigate: _vm.navigate },
                              }),
                            ],
                            1
                          ),
                          _vm.catalog.description
                            ? _c("div", {
                                staticClass: "catalog__description text-guide",
                                domProps: {
                                  innerHTML: _vm._s(_vm.catalog.description),
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$G = [
    function () {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", { staticClass: "hamburger-box catalog__hamburger-box" }, [
        _c("div", { staticClass: "hamburger-inner" }),
      ])
    },
  ];
  __vue_render__$G._withStripped = true;

    /* style */
    const __vue_inject_styles__$L = undefined;
    /* scoped */
    const __vue_scope_id__$L = undefined;
    /* module identifier */
    const __vue_module_identifier__$L = undefined;
    /* functional template */
    const __vue_is_functional_template__$L = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$L = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
      __vue_inject_styles__$L,
      __vue_script__$L,
      __vue_scope_id__$L,
      __vue_is_functional_template__$L,
      __vue_module_identifier__$L,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$M = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        localFilters: [],
        filterDebounceTimeout: null,
        lastChangedFilterId: null
      };
    },
    state: {
      sort: null
    },
    computed: {
      computedOptions: function computedOptions() {
        var vm = this;
        var slidesWidth = 0; // если слайды не влезают в контейнер добавляем тень

        function setShadow() {
          slidesWidth = 0;
          Array.from(this.slides).forEach(function (slide) {
            slidesWidth += slide.offsetWidth;
          });

          if (slidesWidth > this.wrapperEl.offsetWidth + 1) {
            if (this.progress === 0) {
              vm.$refs.list.classList.remove('scroll-items-start');
              vm.$refs.list.classList.add('scroll-items-end');
            } else if (this.progress === 1) {
              vm.$refs.list.classList.remove('scroll-items-end');
              vm.$refs.list.classList.add('scroll-items-start');
            } else {
              vm.$refs.list.classList.add('scroll-items-end');
              vm.$refs.list.classList.add('scroll-items-start');
            }
          } else {
            vm.$refs.list.classList.remove('scroll-items-start');
            vm.$refs.list.classList.remove('scroll-items-end');
          }
        }

        return {
          slidesPerView: 'auto',
          // Индексный номер начального слайда.
          initialSlide: this.topLinks.findIndex(function (link) {
            return link.current;
          }),
          // инертность свайпа слайдов
          freeMode: true,
          // Разрешить отпускать сенсорные события в положении края ползунка (начало, конец) также блочит скролл не полного слайдера
          touchReleaseOnEdges: true,
          // дистанция при движении мыши после которой сработает событие перетаскивания
          // threshold: 60,
          on: {
            init: setShadow,
            resize: setShadow,
            reachBeginning: function reachBeginning() {
              if (slidesWidth > this.wrapperEl.offsetWidth) {
                vm.$refs.list.classList.remove('scroll-items-start');
                vm.$refs.list.classList.add('scroll-items-end');
              }
            },
            reachEnd: function reachEnd() {
              if (slidesWidth > this.wrapperEl.offsetWidth) {
                vm.$refs.list.classList.remove('scroll-items-end');
                vm.$refs.list.classList.add('scroll-items-start');
              }
            }
          }
        };
      }
    },
    props: {
      tagLinks: {
        type: [Object, Number, Boolean],
        default: null
      },
      otherTags: {
        type: Object,
        default: null
      },
      topLinks: {
        type: Array,
        default: null
      },
      filters: {
        type: Array,
        default: null
      },
      otherFilters: {
        type: Array,
        default: null
      },
      rowFilters: {
        type: Array,
        default: null
      }
    },
    watch: {
      filters: function filters() {
        this.applyNewFilters();
      }
    },
    methods: {
      // фильтры с заполненым значением
      getChangedFilters: function getChangedFilters() {
        var _this = this;

        var result = [];
        this.localFilters.forEach(function (filter) {
          if (_this.isFilterChanged(filter)) {
            result.push(filter);
          }
        });

        if (this.tagLinks) {
          if (this.isFilterChanged(this.tagLinks)) {
            result.push(this.tagLinks);
          }
        } // добавка недостающих данных для верхнега фильтра


        if (this.otherFilters) {
          this.otherFilters.forEach(function (filter) {
            if (_this.isFilterChanged(filter)) {
              result.push(filter);
            }
          });
        } // добавка недостающих данных для бокового фильтра


        if (this.otherTags) {
          if (this.isFilterChanged(this.otherTags)) {
            result.push(this.otherTags);
          }
        }

        console.log('rrrrrrrrrrrr', result);
        return result;
      },
      // значение фильтра отличное от дефолтного
      isFilterChanged: function isFilterChanged(filter) {
        if (typeof filter.value == 'number' || filter.value && filter.value.length && filter.value.length > 0 || filter.type === 'range' && filter.value && (filter.value.min !== null && filter.value.min > filter.min || filter.value.max !== null && filter.value.max < filter.max) || filter.type === 'range-slider' && filter.value && (filter.value.min !== null && filter.value.min > filter.min || filter.value.max !== null && filter.value.max < filter.max) || filter.type === 'date-range' && filter.value && (filter.value.min !== null && filter.value.min > filter.min || filter.value.max !== null && filter.value.max < filter.max)) {
          return true;
        }

        return false;
      },
      isFilterBlocked: function isFilterBlocked(filterId) {
        return this.lastChangedFilterId && this.lastChangedFilterId !== filterId;
      },
      applyNewFilters: function applyNewFilters() {
        var _this2 = this;

        var tmpFilters = [];

        if (this.filters) {
          this.filters.forEach(function (filter) {
            var oldFilter = _this2.localFilters.find(function (item) {
              return item.id === filter.id;
            });

            filter.open = oldFilter ? oldFilter.open : !!filter.open;
            tmpFilters.push(filter);
          });
        }

        if (this.rowFilters) {
          this.rowFilters.forEach(function (filter) {
            var oldFilter = _this2.localFilters.find(function (item) {
              return item.id === filter.id;
            });

            filter.open = oldFilter ? oldFilter.open : !!filter.open;
            tmpFilters.push(filter);
          });
        }

        this.localFilters = JSON.parse(JSON.stringify(tmpFilters));
        this.$emit('filter-updated', this.createValue(), this.getChangedFilters());
      },
      resetFilter: function resetFilter(options) {
        var _ref, _this$localFilters$fi, _this$otherTags, _this$rowFilters;

        var filter = (_ref = (_this$localFilters$fi = this.localFilters.find(function (filter) {
          return filter.id === options.id;
        })) !== null && _this$localFilters$fi !== void 0 ? _this$localFilters$fi : (this === null || this === void 0 ? void 0 : (_this$otherTags = this.otherTags) === null || _this$otherTags === void 0 ? void 0 : _this$otherTags.id) === options.id ? this.otherTags : null) !== null && _ref !== void 0 ? _ref : (this === null || this === void 0 ? void 0 : (_this$rowFilters = this.rowFilters) === null || _this$rowFilters === void 0 ? void 0 : _this$rowFilters.id) === options.id ? this.rowFilters : null;

        if (!filter) {
          return;
        }

        if (filter.type == 'range') {
          filter.value.min = null;
          filter.value.max = null;
        } else if (filter.type == 'range-slider') {
          filter.value.min = filter.min;
          filter.value.max = filter.max;
        } else if (filter.type == 'select') {
          filter.value = filter.options[0].value;
        } else {
          if (options.value && Array.isArray(filter.value)) {
            filter.value.splice(filter.value.indexOf(options.value), 1);
          } else {
            filter.value = [];
          }
        }

        if (!options.silent) {
          this.filterChange();
        }
      },
      resetAll: function resetAll() {
        var _this3 = this;

        console.log('reset all filters'); // если фильтры выбраны очищаем их

        this.getChangedFilters().forEach(function (filter) {
          _this3.resetFilter({
            id: filter.id,
            text: filter.text,
            silent: true
          });
        });
        this.filterChange();
      },
      // создание обекта измененных фильтров с их типом и значением
      createValue: function createValue() {
        var result = {};
        this.getChangedFilters().forEach(function (filter) {
          result[filter.id] = {
            value: filter.value,
            type: filter.type
          };
        });
        return result;
      },
      filterChange: function filterChange(filter) {
        var _this4 = this;

        var delay = 1000;

        if (filter) {
          if (filter.type === 'range') {
            delay = 0;
          } else if (filter.type === 'range-slider') {
            delay = 2500;
          }
        }

        this.lastChangedFilterId = filter ? filter.id : null;
        clearTimeout(this.filterDebounceTimeout);
        this.filterDebounceTimeout = setTimeout(function () {
          _this4.lastChangedFilterId = null;

          _this4.$emit('filter-changed', _this4.createValue(), _this4.getChangedFilters());
        }, delay);
      }
    },
    created: function created() {
      this.applyNewFilters();
      this.$on('request-reset', this.resetFilter);
      this.$on('request-reset-all', this.resetAll);
    },
    updated: function updated() {
      var _this5 = this;

      this.$nextTick(function () {
        view.initAllLocal(_this5.$el);
      });
    },
    mounted: function mounted() {
      var _this6 = this;

      this.$nextTick(function () {
        view.initAllLocal(_this6.$el);
      });
    }
  };

  /* script */
  const __vue_script__$M = script$M;

  /* template */
  var __vue_render__$H = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-filter filter" }, [
      _vm.rowFilters
        ? _c(
            "div",
            { ref: "row", staticClass: "filter__row" },
            [
              _c("div", { staticClass: "filter__cell filter__cell--action" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--remove",
                    attrs: {
                      type: "button",
                      "aria-label": "Сбросить все фильтры",
                      title: "Сбросить все фильтры",
                    },
                    on: { click: _vm.resetAll },
                  },
                  [_vm._v("Сбросить все фильтры")]
                ),
              ]),
              _vm._l(_vm.localFilters, function (filter) {
                return _c(
                  "div",
                  { staticClass: "filter__cell" },
                  [
                    _c("v-field", {
                      attrs: {
                        field: Object.assign({}, filter, {
                          disabled: _vm.isFilterBlocked(filter.id),
                        }),
                      },
                      on: {
                        input: function ($event) {
                          return _vm.filterChange(filter)
                        },
                      },
                      model: {
                        value: filter.value,
                        callback: function ($$v) {
                          _vm.$set(filter, "value", $$v);
                        },
                        expression: "filter.value",
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.topLinks || _vm.tagLinks
        ? _c("div", { ref: "list", staticClass: "filter__top-links-wrapper" }, [
            _vm.topLinks
              ? _c(
                  "div",
                  { staticClass: "filter__top-links fcc" },
                  [
                    _c(
                      "v-swiper",
                      {
                        ref: "carousel",
                        attrs: { options: _vm.computedOptions },
                      },
                      _vm._l(_vm.topLinks, function (link) {
                        return _c(
                          "v-swiper-slide",
                          { staticClass: "filter__tab-list-item" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "filter__tab-link",
                                class: {
                                  "filter__tab-link--current": link.current,
                                },
                                attrs: { href: link.current ? null : link.link },
                              },
                              [
                                _vm._v(_vm._s(link.text)),
                                link.count
                                  ? _c(
                                      "span",
                                      { staticClass: "filter__tab-link-count" },
                                      [_vm._v("(" + _vm._s(link.count) + ")")]
                                    )
                                  : _vm._e(),
                                _vm.tagLinks
                                  ? _c("div", {
                                      staticClass:
                                        "filter__tag-links-wrapper fcc",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.tagLinks
              ? _c(
                  "div",
                  { staticClass: "filter__tag-links" },
                  [
                    _c("v-field", {
                      attrs: { field: Object.assign({}, _vm.tagLinks) },
                      on: {
                        input: function ($event) {
                          return _vm.filterChange(_vm.tagLinks)
                        },
                      },
                      model: {
                        value: _vm.tagLinks.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.tagLinks, "value", $$v);
                        },
                        expression: "tagLinks.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.localFilters && !_vm.rowFilters
        ? _c(
            "div",
            {
              staticClass: "filter__wrapper",
              class: { "filter__wrapper--border": _vm.filters },
            },
            _vm._l(_vm.localFilters, function (filter) {
              return _vm.localFilters
                ? _c(
                    "div",
                    {
                      staticClass:
                        "filter__group filter__group--filter flc fcc accordion open-accordion js-accordion",
                    },
                    [
                      filter.title
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter__group-title js-accordion__toggler open-accordion accordion__title-link flc",
                            },
                            [
                              _c(
                                "a",
                                { staticClass: "filter__group-title-content" },
                                [_vm._v(_vm._s(filter.title))]
                              ),
                              _c("div", {
                                staticClass:
                                  "filter__accordion-plus accordion__plus",
                              }),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "accordion__content js-accordion__content",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "filter__group-body" },
                            [
                              _c("v-field", {
                                attrs: {
                                  field: Object.assign({}, filter, {
                                    limit: 4,
                                    disabled: _vm.isFilterBlocked(filter.id),
                                  }),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.filterChange(filter)
                                  },
                                },
                                model: {
                                  value: filter.value,
                                  callback: function ($$v) {
                                    _vm.$set(filter, "value", $$v);
                                  },
                                  expression: "filter.value",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$H = [];
  __vue_render__$H._withStripped = true;

    /* style */
    const __vue_inject_styles__$M = undefined;
    /* scoped */
    const __vue_scope_id__$M = undefined;
    /* module identifier */
    const __vue_module_identifier__$M = undefined;
    /* functional template */
    const __vue_is_functional_template__$M = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$M = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
      __vue_inject_styles__$M,
      __vue_script__$M,
      __vue_scope_id__$M,
      __vue_is_functional_template__$M,
      __vue_module_identifier__$M,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$N = {
    props: {
      filters: {
        type: Array,
        default: null
      }
    },
    computed: {
      activeFilters: function activeFilters() {
        var result = [];

        if (!this.filters) {
          return result;
        }

        this.filters.forEach(function (filter) {
          if (filter.options) {
            filter.options.forEach(function (option) {
              if (Array.isArray(filter.value) && filter.value.indexOf(option.value) >= 0 || option.value === filter.value) {
                result.push({
                  id: filter.id,
                  value: option.value,
                  text: option.text || option.value
                });
              }
            });
          } else {
            var text;

            if (filter.type == 'range' || filter.type == 'range-slider') {
              text = "";

              if (typeof filter.value.min == 'number' && !filter.value.max) {
                text += " ".concat(filter.prefixMin || '', " ").concat(filter.value.min.toFixed(2).toString().replace('.', ','), " ").concat(filter.postfixMin || '');
              }

              if (!filter.value.min && typeof filter.value.max == 'number') {
                text += " ".concat(filter.prefixMax || '', " ").concat(filter.value.max.toFixed(2).toString().replace('.', ','), " ").concat(filter.postfixMax || '');
              }

              if (typeof filter.value.min == 'number' && typeof filter.value.max == 'number') {
                text += "".concat(filter.value.min.toFixed(2).toString().replace('.', ','), " - ").concat(filter.value.max.toFixed(2).toString().replace('.', ','), " ").concat(filter.postfixMax || '');
              }

              if (filter.value.min || filter.value.max) {
                result.push({
                  id: filter.id,
                  value: filter.value,
                  text: text
                });
              }
            } else {
              text = "".concat(filter.title, " ").concat(filter.value);

              if (filter.value) {
                result.push({
                  id: filter.id,
                  value: filter.value,
                  text: text
                });
              }
            }
          }
        });
        return result;
      }
    },
    methods: {
      resetFilter: function resetFilter(filter) {
        this.$emit('reset-filter', filter);
      },
      resetAllFilters: function resetAllFilters(filter) {
        this.$emit('reset-all-filters', filter);
      }
    }
  };

  /* script */
  const __vue_script__$N = script$N;

  /* template */
  var __vue_render__$I = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-filter-active-items active-filters" },
      [
        _c(
          "transition-group",
          {
            staticClass: "active-filters__grid",
            attrs: { name: "flip", tag: "div" },
          },
          [
            _vm._l(_vm.activeFilters, function (filter, index) {
              return _c(
                "div",
                {
                  key: filter.id + "-" + filter.value || index,
                  staticClass: "active-filters__cell",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--md btn--remove active-filters__btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.resetFilter(filter)
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(filter.text)),
                      _c(
                        "svg",
                        {
                          staticClass:
                            "btn__icon btn__icon--right btn__icon--close",
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#svg-icon-close-new" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            _vm.activeFilters.length
              ? _c(
                  "div",
                  { key: "reset_all", staticClass: "active-filters__cell" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn--md btn--remove active-filters__btn",
                        attrs: { type: "button" },
                        on: { click: _vm.resetAllFilters },
                      },
                      [_vm._v("Сбросить все фильтры")]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$I = [];
  __vue_render__$I._withStripped = true;

    /* style */
    const __vue_inject_styles__$N = undefined;
    /* scoped */
    const __vue_scope_id__$N = undefined;
    /* module identifier */
    const __vue_module_identifier__$N = undefined;
    /* functional template */
    const __vue_is_functional_template__$N = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$N = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
      __vue_inject_styles__$N,
      __vue_script__$N,
      __vue_scope_id__$N,
      __vue_is_functional_template__$N,
      __vue_module_identifier__$N,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$O = {
    data: function data() {
      return {
        localPage: {
          offset: 0,
          limit: 0,
          default: 0
        },
        short: false
      };
    },
    props: {
      page: {
        default: function _default() {
          return {
            offset: 0,
            limit: 0,
            count: 0
          };
        }
      }
    },
    computed: {
      pageNumber: function pageNumber() {
        return Math.ceil(this.localPage.offset / this.localPage.limit) + 1;
      },
      lastPageNumber: function lastPageNumber() {
        return Math.ceil(this.localPage.count / this.localPage.limit);
      },
      pageOptions: function pageOptions() {
        var result = [];

        if (this.localPage.limit) {
          var pageDispersion = this.pageNumber > 2 ? 1 : 2; // show last 10

          if (this.lastPageNumber - this.pageNumber < 2) {
            pageDispersion = 3 - this.lastPageNumber + this.pageNumber;
          } // short mode for 3xs screen


          if (this.short) {
            pageDispersion -= 1;
          } // build array of page


          for (var i = 1; i <= this.lastPageNumber; i++) {
            if (i - Math.max(pageDispersion, this.pageNumber) <= pageDispersion && i - Math.max(pageDispersion, this.pageNumber) >= -pageDispersion) {
              result.push({
                value: i,
                text: i
              });
            }
          }
        }

        return result;
      }
    },
    watch: {
      page: {
        handler: function handler() {
          this.initLocalPage();
        },
        deep: true
      }
    },
    methods: {
      initLocalPage: function initLocalPage() {
        this.localPage = {
          offset: parseInt(this.page.offset) || 0,
          limit: parseInt(this.page.limit) || 0,
          count: parseInt(this.page.count) || 0
        };
      },
      navigateToAppend: function navigateToAppend() {
        var vm = this;
        this.$emit('navigate', {
          offset: vm.localPage.offset + this.localPage.limit,
          limit: vm.localPage.limit,
          append: true
        });
      },
      navigateToPage: function navigateToPage(page) {
        var vm = this;
        this.$emit('navigate', {
          offset: vm.localPage.limit * (page - 1),
          limit: vm.localPage.limit,
          append: false
        });
      },
      getPageLink: function getPageLink(page) {
        return window.location.href + (window.location.href.indexOf('?') > -1 ? '&' : '?') + 'state[page][limit]=' + this.localPage.limit + '&state[page][offset]=' + this.localPage.limit * (page - 1);
      },
      handleResize: function handleResize() {
        // this.short = window.innerWidth <= breakpoints['3xs-max'];
        this.short = false;
      }
    },
    created: function created() {
      this.initLocalPage();
      window.addEventListener('resize', this.handleResize);
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.handleResize);
    }
  };

  /* script */
  const __vue_script__$O = script$O;

  /* template */
  var __vue_render__$J = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-page-nav page-nav" }, [
      _vm.pageOptions && _vm.pageOptions.length
        ? _c(
            "div",
            { staticClass: "page-nav__links" },
            [
              _vm.pageNumber === 1
                ? _c(
                    "span",
                    {
                      staticClass:
                        "page-nav__link page-nav__arrow page-nav__arrow--prev page-nav__link--disabled",
                    },
                    [
                      _c(
                        "svg",
                        { staticClass: "svg-icon page-nav__arrow-icon" },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#svg-icon-chevron-down-sm" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _c(
                    "a",
                    {
                      staticClass:
                        "page-nav__link page-nav__arrow page-nav__arrow--prev",
                      attrs: { href: _vm.getPageLink(_vm.pageNumber - 1) },
                      on: {
                        click: function ($event) {
                          $event.preventDefault();
                          return _vm.navigateToPage(_vm.pageNumber - 1)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        { staticClass: "svg-icon page-nav__arrow-icon" },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#svg-icon-chevron-down-sm" },
                          }),
                        ]
                      ),
                    ]
                  ),
              _vm.pageOptions[0].value > 1
                ? _c(
                    "a",
                    {
                      staticClass: "page-nav__link",
                      attrs: { href: _vm.getPageLink(1) },
                      on: {
                        click: function ($event) {
                          $event.preventDefault();
                          return _vm.navigateToPage(1)
                        },
                      },
                    },
                    [_vm._v("1")]
                  )
                : _vm._e(),
              _vm.pageOptions[0].value > 2
                ? _c("span", { staticClass: "page-nav__link-spacer" }, [
                    _vm._v("..."),
                  ])
                : _vm._e(),
              _vm._l(_vm.pageOptions, function (option) {
                return _c(
                  "a",
                  {
                    key: option.value,
                    staticClass: "page-nav__link",
                    class: {
                      "page-nav__link--active": option.value == _vm.pageNumber,
                    },
                    attrs: {
                      href:
                        option.value == _vm.pageNumber
                          ? null
                          : _vm.getPageLink(option.value),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault();
                        option.value == _vm.pageNumber
                          ? null
                          : _vm.navigateToPage(option.value);
                      },
                    },
                  },
                  [_vm._v(_vm._s(option.text))]
                )
              }),
              _vm.pageOptions[_vm.pageOptions.length - 1].value <
              _vm.lastPageNumber - 1
                ? _c("span", { staticClass: "page-nav__link-spacer" }, [
                    _vm._v("..."),
                  ])
                : _vm._e(),
              _vm.pageOptions[_vm.pageOptions.length - 1].value <
              _vm.lastPageNumber
                ? _c(
                    "a",
                    {
                      staticClass: "page-nav__link",
                      attrs: { href: _vm.getPageLink(_vm.lastPageNumber) },
                      on: {
                        click: function ($event) {
                          $event.preventDefault();
                          return _vm.navigateToPage(_vm.lastPageNumber)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.lastPageNumber))]
                  )
                : _vm._e(),
              _vm.pageNumber === _vm.lastPageNumber
                ? _c(
                    "span",
                    {
                      staticClass:
                        "page-nav__link page-nav__arrow page-nav__arrow--next page-nav__link--disabled",
                    },
                    [
                      _c(
                        "svg",
                        { staticClass: "svg-icon page-nav__arrow-icon" },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#svg-icon-chevron-down-sm" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _c(
                    "a",
                    {
                      staticClass:
                        "page-nav__link page-nav__arrow page-nav__arrow--next",
                      attrs: { href: _vm.getPageLink(_vm.pageNumber + 1) },
                      on: {
                        click: function ($event) {
                          $event.preventDefault();
                          return _vm.navigateToPage(_vm.pageNumber + 1)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        { staticClass: "svg-icon page-nav__arrow-icon" },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#svg-icon-chevron-down-sm" },
                          }),
                        ]
                      ),
                    ]
                  ),
            ],
            2
          )
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$J = [];
  __vue_render__$J._withStripped = true;

    /* style */
    const __vue_inject_styles__$O = undefined;
    /* scoped */
    const __vue_scope_id__$O = undefined;
    /* module identifier */
    const __vue_module_identifier__$O = undefined;
    /* functional template */
    const __vue_is_functional_template__$O = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$O = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$J, staticRenderFns: __vue_staticRenderFns__$J },
      __vue_inject_styles__$O,
      __vue_script__$O,
      __vue_scope_id__$O,
      __vue_is_functional_template__$O,
      __vue_module_identifier__$O,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$P = {
    props: {
      availability: {
        default: null
      }
    }
  };

  /* script */
  const __vue_script__$P = script$P;

  /* template */
  var __vue_render__$K = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-availability availability",
        class: {
          "availability--available":
            _vm.availability && _vm.availability.value === 1,
          "availability--unavailable":
            _vm.availability && _vm.availability.value === 0,
        },
      },
      [
        _vm.availability &&
        _vm.availability.quantity &&
        _vm.availability.value === "available"
          ? _c("div", { staticClass: "availability__quatity" }, [
              _vm._v(
                "Осталось " +
                  _vm._s(_vm.availability.quantity) +
                  " " +
                  _vm._s(_vm.availability.unit)
              ),
            ])
          : _vm._e(),
      ]
    )
  };
  var __vue_staticRenderFns__$K = [];
  __vue_render__$K._withStripped = true;

    /* style */
    const __vue_inject_styles__$P = undefined;
    /* scoped */
    const __vue_scope_id__$P = undefined;
    /* module identifier */
    const __vue_module_identifier__$P = undefined;
    /* functional template */
    const __vue_is_functional_template__$P = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$P = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$K, staticRenderFns: __vue_staticRenderFns__$K },
      __vue_inject_styles__$P,
      __vue_script__$P,
      __vue_scope_id__$P,
      __vue_is_functional_template__$P,
      __vue_module_identifier__$P,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$Q = {
    data: function data() {
      return {
        localCount: 0
      };
    },
    props: {
      basket: {
        default: null
      },
      id: {
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: null
      },
      productUrl: {
        type: String,
        default: null
      },
      parentProductId: {
        type: String,
        default: null
      },
      basketUrl: {
        type: String,
        default: null
      },
      buttons: {
        type: Object
      },
      productParams: {
        type: Object
      }
    },
    computed: _objectSpread2(_objectSpread2({}, mapGetters({
      basketItems: 'basket/basketItems'
    })), {}, {
      basketPricesByItem: function basketPricesByItem() {
        var _this = this;

        var result = [];
        this.basketItems.forEach(function (item) {
          if (item.id === _this.id) {
            result.push(item);
          }
        });
        return result;
      },
      basketCount: function basketCount() {
        var result = 0;
        this.basketPricesByItem.forEach(function (item) {
          result += item.count || 0;
        });
        return result;
      },
      // количество подарков в корзине к текущему продукту
      basketGiftCount: function basketGiftCount() {
        var _this2 = this;

        var count = 0; // товары в корзине соответствующие текущему продукту

        var basketItems = [];
        this.basketItems.forEach(function (item) {
          if (item.id === _this2.parentProductId) {
            basketItems.push(item);
          }
        }); // все подарки к текущему продукту

        var giftItemsId = [];
        basketItems.forEach(function (item) {
          if (item.giftId) {
            giftItemsId = giftItemsId.concat(item.giftId);
          }
        });
        giftItemsId.forEach(function (giftId) {
          if (giftId === _this2.id) {
            ++count;
          }
        });
        return count;
      }
    }),
    watch: {
      basketCount: function basketCount() {
        this.localCount = this.basketCount;
      }
    },
    methods: {
      setBasketCount: function setBasketCount() {
        this.$store.dispatch('basket/add', {
          id: this.id,
          count: this.localCount,
          priceId: this.productParams.priceId,
          typeClient: this.productParams.typeClient,
          typeTel: this.productParams.typeTel,
          typePricePeriod: this.productParams.typePricePeriod
        });
      },
      addToBasketAccessory: function addToBasketAccessory() {
        this.$store.dispatch('basket/add', {
          action: 'add-accessory',
          id: this.id,
          count: this.localCount,
          priceId: this.productParams.priceId,
          typeClient: this.productParams.typeClient,
          typeTel: this.productParams.typeTel,
          typePricePeriod: this.productParams.typePricePeriod
        });
      },
      addToBasketAccessoryGift: function addToBasketAccessoryGift() {
        this.$store.dispatch('basket/add', {
          action: 'add-gift',
          id: this.id,
          giftId: this.id,
          count: this.localCount
        });
      }
    },
    created: function created() {
      this.localCount = this.basketCount;
    }
  };

  /* script */
  const __vue_script__$Q = script$Q;

  /* template */
  var __vue_render__$L = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-basket-action basket-action",
        class: {
          "basket-action--active": _vm.basketCount,
          "basket-action--disabled": _vm.disabled,
        },
      },
      [
        _c("div", { staticClass: "basket-action__widget" }, [
          _c(
            "div",
            { staticClass: "basket-action__cell-main" },
            [
              _vm.basket.value === "not-available"
                ? [
                    _c("div", { staticClass: "basket-action__no-available" }, [
                      _c(
                        "i",
                        { staticClass: "basket-action__no-available-btn-icon" },
                        [
                          _c(
                            "svg",
                            { staticClass: "svg-icon svg-icon--full-size" },
                            [
                              _c("use", {
                                attrs: {
                                  "xlink:href": "#svg-icon-cart-no-available",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "basket-action__no-available-text" },
                        [_vm._v("Продукта нет в наличии в виртуальном магазине")]
                      ),
                    ]),
                  ]
                : _vm.basketCount &&
                  _vm.type !== "gift" &&
                  _vm.type !== "accessory-gift"
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "basket-action__btn btn",
                        attrs: { href: _vm.basketUrl },
                      },
                      [_c("span", [_vm._v("В корзине")])]
                    ),
                  ]
                : _vm.type == "gift"
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "basket-action__btn btn btn--primary",
                        attrs: { href: _vm.basketUrl || _vm.productUrl },
                      },
                      [
                        _c(
                          "span",
                          [
                            _vm.buttons && _vm.buttons.availableText
                              ? [_vm._v(_vm._s(_vm.buttons.availableText))]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]
                : _vm.type == "accessory"
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "basket-action__btn btn btn--primary",
                        attrs: { type: "button", disabled: _vm.disabled },
                        on: { click: _vm.addToBasketAccessory },
                      },
                      [_c("span", [_vm._v("Добавить в корзину")])]
                    ),
                  ]
                : _vm.type == "accessory-gift" && _vm.basketGiftCount
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "basket-action__btn btn",
                        attrs: { href: _vm.basketUrl },
                      },
                      [_c("span", [_vm._v("Подарок в корзине")])]
                    ),
                  ]
                : _vm.type == "accessory-gift"
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "basket-action__btn btn btn--primary",
                        attrs: { type: "button", disabled: _vm.disabled },
                        on: { click: _vm.addToBasketAccessoryGift },
                      },
                      [_c("span", [_vm._v("Поменять подарок")])]
                    ),
                  ]
                : _vm.type == "catalog-product" || _vm.type == "compare-product"
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "basket-action__btn btn btn--primary",
                        attrs: { href: _vm.productUrl },
                      },
                      [
                        _vm.basket.value === "available"
                          ? _c(
                              "span",
                              [
                                _vm.buttons && _vm.buttons.availableText
                                  ? [_vm._v(_vm._s(_vm.buttons.availableText))]
                                  : [_vm._v("Перейти к покупке")],
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.basket.value === "wait-order"
                          ? _c("span", [_vm._v("Оставить заявку")])
                          : _vm._e(),
                        _vm.basket.value === "order"
                          ? _c("span", [_vm._v("Сделать предзаказ")])
                          : _vm._e(),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "button",
                      {
                        staticClass: "basket-action__btn btn btn--primary",
                        attrs: { type: "button", disabled: _vm.disabled },
                        on: { click: _vm.setBasketCount },
                      },
                      [
                        _vm.basket.value === "available"
                          ? _c(
                              "span",
                              [
                                _vm.buttons && _vm.buttons.availableText
                                  ? [_vm._v(_vm._s(_vm.buttons.availableText))]
                                  : [_vm._v("Перейти к покупке")],
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.basket.value === "wait-order"
                          ? _c("span", [_vm._v("Оставить заявку")])
                          : _vm._e(),
                        _vm.basket.value === "order"
                          ? _c("span", [_vm._v("Сделать предзаказ")])
                          : _vm._e(),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ]),
      ]
    )
  };
  var __vue_staticRenderFns__$L = [];
  __vue_render__$L._withStripped = true;

    /* style */
    const __vue_inject_styles__$Q = undefined;
    /* scoped */
    const __vue_scope_id__$Q = undefined;
    /* module identifier */
    const __vue_module_identifier__$Q = undefined;
    /* functional template */
    const __vue_is_functional_template__$Q = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$Q = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$L, staticRenderFns: __vue_staticRenderFns__$L },
      __vue_inject_styles__$Q,
      __vue_script__$Q,
      __vue_scope_id__$Q,
      __vue_is_functional_template__$Q,
      __vue_module_identifier__$Q,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$R = {
    data: function data() {
      return {
        localCount: 1,
        timeoutMessage: null,
        showMessage: false
      };
    },
    props: {
      productInfo: {
        default: null
      },
      availability: {
        default: null
      },
      price: {
        default: null
      },
      modalInputUnp: {
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: _objectSpread2(_objectSpread2({}, mapGetters({
      userUnpList: 'user/userUnpList',
      userUnpActive: 'user/userUnpActive',
      basketLink: 'basket/basketLink',
      basketItems: 'basket/basketItems'
    })), {}, {
      basketPricesByItem: function basketPricesByItem() {
        var _this = this;

        var result = [];
        this.basketItems.forEach(function (item) {
          if (item.id === _this.productInfo.id) {
            result.push(item);
          }
        });
        return result;
      },
      basketCountByItem: function basketCountByItem() {
        var result = 0;
        this.basketPricesByItem.forEach(function (item) {
          result += item.count || 0;
        });
        return result;
      },
      basketCountByPrice: function basketCountByPrice() {
        var _this2 = this;

        var result = this.basketPricesByItem.find(function (item) {
          return item.priceId === _this2.productInfo.priceId;
        });
        return result ? result.count : 0;
      },
      computedBtnText: function computedBtnText() {
        switch (this.availability.value) {
          case 'order':
            return 'Сделать предзаказ';

          case 'wait-order':
            return 'Оставить заявку';

          default:
            return 'Купить';
        }
      },
      computedMaxCount: function computedMaxCount() {
        if (this.availability.value === 'available') {
          return this.availability.quantity;
        } else if (this.availability.value === 'wait-order' || this.availability.value === 'order') {
          return 999;
        } else {
          return 0;
        }
      },
      maxQuantity: function maxQuantity() {
        return this.availability.value === 'wait-order' || this.availability.value === 'order' ? 999 : this.availability.quantity;
      }
    }),
    watch: {
      basketCountByItem: function basketCountByItem() {
        this.localCount = this.productInfo.count || this.basketCountByItem || 1;
      },
      productInfo: function productInfo() {
        this.localCount = this.productInfo.count || this.basketCountByItem || 1;
      }
    },
    methods: {
      changeCount: function changeCount() {
        this.$emit('change-count', this.localCount);
      },
      // показ сообщения
      getShowMessage: function getShowMessage() {
        var _this3 = this;

        this.showMessage = true;
        clearTimeout(this.timeoutMessage);
        this.timeoutMessage = setTimeout(function () {
          return _this3.showMessage = false;
        }, 3000);
      },
      addToBasket: function addToBasket() {
        if (this.basketCountByItem < this.maxQuantity) {
          this.$store.dispatch('basket/add', _objectSpread2(_objectSpread2({}, this.productInfo), {}, {
            count: this.localCount
          })).then(function () {// window.location.href = this.basketLink + '?basket-id=' + this.productInfo.basketId
          });
        } else {
          this.getShowMessage();
        }
      }
    },
    created: function created() {
      this.localCount = this.productInfo.count || this.basketCountByItem || 1;
    }
  };

  /* script */
  const __vue_script__$R = script$R;

  /* template */
  var __vue_render__$M = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-basket-action-big basket-action-big",
        class: {
          "basket-action-big--active": _vm.basketCountByItem,
          "basket-action-big--disabled": _vm.disabled,
        },
      },
      [
        _c(
          "div",
          { staticClass: "basket-action-big__input" },
          [
            _c("v-field", {
              attrs: {
                field: { type: "count", min: 1, max: _vm.computedMaxCount },
              },
              on: { input: _vm.changeCount },
              model: {
                value: _vm.localCount,
                callback: function ($$v) {
                  _vm.localCount = $$v;
                },
                expression: "localCount",
              },
            }),
          ],
          1
        ),
        _c("v-availability", { attrs: { availability: _vm.availability } }),
        _c("div", { staticClass: "basket-action-big__main" }, [
          _vm.price.note && _vm.price.tel.value == "new"
            ? _c("div", { staticClass: "basket-action-big__note" }, [
                _vm._v(_vm._s(_vm.price.note)),
              ])
            : _vm._e(),
          _c("div", { staticClass: "basket-action-big__buttons" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMessage,
                    expression: "showMessage",
                  },
                ],
                staticClass: "basket-action-big__message",
              },
              [_vm._v("В корзину добавлено максимально доступное количество")]
            ),
            _vm.basketCountByPrice
              ? _c(
                  "a",
                  {
                    staticClass:
                      "basket-action-big__btn btn btn--block btn--center btn--lg",
                    attrs: {
                      href: _vm.basketLink,
                      "aria-label": "Перейти в корзину",
                    },
                  },
                  [_vm._v("В корзине")]
                )
              : _c(
                  "button",
                  {
                    staticClass:
                      "basket-action-big__btn btn btn--block btn--center btn--lg btn--primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.disabled,
                      "aria-label": "Добавить в корзину",
                    },
                    on: { click: _vm.addToBasket },
                  },
                  [_vm._v(_vm._s(_vm.computedBtnText))]
                ),
          ]),
        ]),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$M = [];
  __vue_render__$M._withStripped = true;

    /* style */
    const __vue_inject_styles__$R = undefined;
    /* scoped */
    const __vue_scope_id__$R = undefined;
    /* module identifier */
    const __vue_module_identifier__$R = undefined;
    /* functional template */
    const __vue_is_functional_template__$R = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$R = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$M, staticRenderFns: __vue_staticRenderFns__$M },
      __vue_inject_styles__$R,
      __vue_script__$R,
      __vue_scope_id__$R,
      __vue_is_functional_template__$R,
      __vue_module_identifier__$R,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$S = {
    props: {
      items: {
        type: Array,
        default: null
      },
      banner: {
        type: Object,
        default: null
      }
    },
    methods: {
      calcNameHeight: function calcNameHeight() {
        var nameHeights = []; // заполнение массива высот имен товаров

        Array.from(this.$refs.cell).forEach(function (cell, index) {
          var name = cell.querySelector('.js-product-name');
          name.style.height = 'auto';
          nameHeights.push(name.clientHeight);
        });
        Array.from(this.$refs.cell).forEach(function (cell, index) {
          var name = cell.querySelector('.js-product-name');
          var countCellInGroup = null;
          var indexArrForGroup = [];
          var maxHeightName = null;

          if (window.innerWidth >= 1024) {
            countCellInGroup = 3;
            calcHeight();
          } else if (window.innerWidth >= 628) {
            countCellInGroup = 2;
            calcHeight();
          } else {
            return;
          }

          name.style.height = maxHeightName + 'px'; // подсчет максимального имени товара в ряду

          function calcHeight() {
            var indexGroup = Math.floor(index / countCellInGroup);

            for (var i = 0; i < countCellInGroup; i++) {
              indexArrForGroup.push(indexGroup * countCellInGroup + i);
            }

            maxHeightName = Math.max.apply(Math, _toConsumableArray(indexArrForGroup.map(function (item) {
              return nameHeights[item];
            })));
          }
        });
      }
    },
    mounted: function mounted() {
      var _this = this;

      this.$nextTick(function () {
        _this.calcNameHeight();

        setTimeout(function () {}, 2000);
      });
      window.addEventListener('resize', this.calcNameHeight);
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.calcNameHeight);
    }
  };

  /* script */
  const __vue_script__$S = script$S;

  /* template */
  var __vue_render__$N = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-product-grid product-grid" }, [
      _c(
        "div",
        { staticClass: "product-grid__grid" },
        [
          _vm._l(_vm.items, function (item) {
            return _c(
              "div",
              { ref: "cell", refInFor: true, staticClass: "product-grid__cell" },
              [_c("v-product", { attrs: { template: "grid", product: item } })],
              1
            )
          }),
          _vm.banner
            ? _c(
                "div",
                { staticClass: "product-grid__cell product-grid__cell--banner" },
                [
                  _c("div", { staticClass: "banner-teaser" }, [
                    _vm.banner.link
                      ? _c(
                          "a",
                          {
                            staticClass: "banner-teaser__link",
                            attrs: {
                              href: _vm.banner.link,
                              target: _vm.banner.openCurrentPage
                                ? "_self"
                                : "_blank",
                            },
                          },
                          [
                            _c("picture", [
                              _c("source", {
                                attrs: {
                                  srcset: _vm.banner.img.mobile,
                                  media: "(max-width: 627px)",
                                },
                              }),
                              _c("img", {
                                staticClass: "banner-teaser__img",
                                attrs: {
                                  src: _vm.banner.img.desktop,
                                  alt: _vm.banner.alt,
                                  title: _vm.banner.title,
                                },
                              }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ])
  };
  var __vue_staticRenderFns__$N = [];
  __vue_render__$N._withStripped = true;

    /* style */
    const __vue_inject_styles__$S = undefined;
    /* scoped */
    const __vue_scope_id__$S = undefined;
    /* module identifier */
    const __vue_module_identifier__$S = undefined;
    /* functional template */
    const __vue_is_functional_template__$S = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$S = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$N, staticRenderFns: __vue_staticRenderFns__$N },
      __vue_inject_styles__$S,
      __vue_script__$S,
      __vue_scope_id__$S,
      __vue_is_functional_template__$S,
      __vue_module_identifier__$S,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  var script$T = {
    props: {
      items: {
        type: Array,
        default: null
      },
      quickView: {
        type: Boolean,
        default: false
      }
    }
  };

  /* script */
  const __vue_script__$T = script$T;

  /* template */
  var __vue_render__$O = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-product-list product-list" }, [
      _c(
        "div",
        { staticClass: "product-list__grid" },
        _vm._l(_vm.items, function (item) {
          return _c(
            "div",
            { staticClass: "product-list__cell" },
            [
              _c("v-product", {
                attrs: {
                  template: "list",
                  product: item,
                  "quick-view": _vm.quickView,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ])
  };
  var __vue_staticRenderFns__$O = [];
  __vue_render__$O._withStripped = true;

    /* style */
    const __vue_inject_styles__$T = undefined;
    /* scoped */
    const __vue_scope_id__$T = undefined;
    /* module identifier */
    const __vue_module_identifier__$T = undefined;
    /* functional template */
    const __vue_is_functional_template__$T = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$T = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$O, staticRenderFns: __vue_staticRenderFns__$O },
      __vue_inject_styles__$T,
      __vue_script__$T,
      __vue_scope_id__$T,
      __vue_is_functional_template__$T,
      __vue_module_identifier__$T,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$U = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        catalog: {}
      };
    },
    props: {
      quickView: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      dataSet: function dataSet(data) {
        this.catalog = data;
      }
    }
  };

  /* script */
  const __vue_script__$U = script$U;

  /* template */
  var __vue_render__$P = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-product-line product-line" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _c("div", { staticClass: "product-line__block" }, [
          _vm.catalog && _vm.catalog.items && _vm.catalog.items.length
            ? _c(
                "div",
                { staticClass: "product-line__grid" },
                _vm._l(_vm.catalog.items, function (item, index) {
                  return _c(
                    "div",
                    { key: item.id || index, staticClass: "product-line__cell" },
                    [
                      _vm.catalog.type === "products"
                        ? _c("v-product", {
                            attrs: { product: item, "quick-view": _vm.quickView },
                          })
                        : _vm.catalog.type === "articles"
                        ? _c("v-article-poster", { attrs: { article: item } })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$P = [];
  __vue_render__$P._withStripped = true;

    /* style */
    const __vue_inject_styles__$U = undefined;
    /* scoped */
    const __vue_scope_id__$U = undefined;
    /* module identifier */
    const __vue_module_identifier__$U = undefined;
    /* functional template */
    const __vue_is_functional_template__$U = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$U = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$P, staticRenderFns: __vue_staticRenderFns__$P },
      __vue_inject_styles__$U,
      __vue_script__$U,
      __vue_scope_id__$U,
      __vue_is_functional_template__$U,
      __vue_module_identifier__$U,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$V = {
    data: function data() {
      return {
        colorFilters: null,
        paramsFilters: null,
        activeOfferId: null,
        productSelectedParams: null,
        currentPrice: null
      };
    },
    props: {
      product: {
        type: Object,
        default: null
      },
      template: {
        type: String,
        default: 'grid'
      }
    },
    computed: {
      computedDataSourcePricePanel: function computedDataSourcePricePanel() {
        return {
          initialValues: this.activeOffer.initialValues,
          prices: this.activeOffer.prices
        };
      },
      activeOffer: function activeOffer() {
        var _this = this;

        return this.product.offers.find(function (offer) {
          return offer.id === _this.activeOfferId;
        });
      }
    },
    watch: {
      product: function product() {
        this.updateFilter();
      }
    },
    methods: {
      updateFilter: function updateFilter() {
        var _this2 = this;

        this.colorFilters = [];
        this.paramsFilters = [];
        this.linkOffer = {};
        var filters = {};
        this.activeOfferId = this.product.activeOfferId; // собираем уникальные фильтры из ценовых предложений

        this.product.offers.forEach(function (offer) {
          if (offer.params) {
            offer.params.forEach(function (param) {
              if (!filters[param.id]) {
                filters[param.id] = [];
              }

              var found = !!filters[param.id].find(function (option) {
                return option.id === param.id && option.value === param.value;
              });

              if (!found) {
                filters[param.id].push(param);
              }
            });
          }
        });

        var _loop = function _loop(key) {
          // определяем начальные значения фильтров из ценового предложения
          var activeFilterValue = _this2.activeOffer.params.find(function (param) {
            if (filters[key][0].type === param.type) {
              return true;
            }
          });

          if (typeof activeFilterValue !== 'undefined') {
            activeFilterValue = activeFilterValue.value;
          } // формируем список опций для фильтров


          if (filters[key][0].type === 'color') {
            _this2.colorFilters.push({
              options: filters[key],
              value: activeFilterValue,
              id: key,
              type: filters[key][0].type
            });
          } else {
            _this2.paramsFilters.push({
              options: filters[key],
              value: activeFilterValue,
              id: key,
              type: filters[key][0].type
            });
          }
        };

        for (var key in filters) {
          _loop(key);
        }
      },
      filterUpdated: function filterUpdated(filter) {
        var _this3 = this,
            _this$colorFilters$,
            _this$paramsFilters$;

        // находим ценовые предложения в которых совпадает значение выбранного фильтра
        var matchingOffers = this.product.offers.filter(function (offer) {
          var param = offer.params.find(function (param) {
            return param.id === filter.id;
          });
          return param && param.value === filter.value;
        }); // ищем активное ценовое предложение, если совпадают все значения текущих фильтров

        var foundActiveOffer = matchingOffers.find(function (offer) {
          var mismatchingParam = offer.params.find(function (param) {
            var resultFilters = _this3.colorFilters.find(function (filter) {
              return filter.id === param.id;
            });

            if (!resultFilters) {
              resultFilters = _this3.paramsFilters.find(function (filter) {
                return filter.id === param.id;
              });
            }

            return resultFilters.value !== param.value;
          });
          return !mismatchingParam;
        }); // если найдено активное ценовое предложение переключаем его, иначе выбираем первое из списка

        this.activeOfferId = foundActiveOffer ? foundActiveOffer.id : matchingOffers[0].id; // устанвливаем значение выбранного цвета, если пользователем переключался другой фильтр

        if (filter.type != ((_this$colorFilters$ = this.colorFilters[0]) === null || _this$colorFilters$ === void 0 ? void 0 : _this$colorFilters$.type)) {
          this.colorFilters.forEach(function (filter) {
            var getParam = _this3.activeOffer.params.find(function (param) {
              return param.id === filter.id;
            });

            filter.value = getParam ? getParam.value : null;
          });
        } // устанвливаем значение выбранной памяти, если пользователем переключался другой фильтр


        if (filter.type != ((_this$paramsFilters$ = this.paramsFilters[0]) === null || _this$paramsFilters$ === void 0 ? void 0 : _this$paramsFilters$.type)) {
          this.paramsFilters.forEach(function (filter) {
            var getParam = _this3.activeOffer.params.find(function (param) {
              return param.id === filter.id;
            });

            filter.value = getParam ? getParam.value : null;
          });
        }
      },
      // при уходе курсора с карточки ставим дефолтный оффер и парметры цвета и памяти
      setDefaultOffer: function setDefaultOffer(event) {
        if (this.product.type == 'catalog-product') {
          if (this.$el.getBoundingClientRect().top > event.clientY || this.$el.getBoundingClientRect().bottom < event.clientY || this.$el.getBoundingClientRect().left > event.clientX || this.$el.getBoundingClientRect().right < event.clientX) {
            this.updateFilter();
          }
        }
      },
      // обработка события обновления параметров товара
      updateProductOptions: function updateProductOptions(productSelectedParams) {
        this.productSelectedParams = productSelectedParams;
      },
      // удалить из сравнения
      removeCompare: function removeCompare() {
        this.$emit('remove-compare', this.activeOffer.id);
      },
      activePrice: function activePrice(price) {
        this.currentPrice = price;
      }
    },
    created: function created() {
      this.updateFilter();
    }
  };

  /* script */
  const __vue_script__$V = script$V;

  /* template */
  var __vue_render__$Q = function () {
    var _obj;
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-product product", on: { mouseout: _vm.setDefaultOffer } },
      [
        _vm.template === "grid"
          ? [
              _c(
                "div",
                {
                  staticClass: "product-t-grid",
                  class:
                    ((_obj = {}),
                    (_obj["product-t-grid--" + _vm.product.type] =
                      _vm.product.type),
                    (_obj["product-t-grid--compare"] = _vm.product.compare),
                    _obj),
                },
                [
                  _c("div", { staticClass: "product-t-grid__card" }, [
                    _vm.activeOffer.link
                      ? _c("a", {
                          staticClass: "product-t-grid__link",
                          attrs: { href: _vm.activeOffer.link },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "product-t-grid__top" },
                      [
                        _vm.product.type === "compare-product"
                          ? _c(
                              "button",
                              {
                                staticClass: "product-t-grid__remove",
                                attrs: { type: "button" },
                                on: { click: _vm.removeCompare },
                              },
                              [
                                _c(
                                  "svg",
                                  { staticClass: "svg-icon svg-icon--garbage" },
                                  [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#svg-icon-garbage",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.activeOffer.category
                          ? _c(
                              "div",
                              {
                                staticClass: "product-t-grid__category-name flc",
                              },
                              [_vm._v(_vm._s(_vm.activeOffer.category))]
                            )
                          : _vm._e(),
                        _vm.activeOffer.name
                          ? _c(
                              "div",
                              {
                                ref: "name",
                                staticClass:
                                  "product-t-grid__name js-product-name flc",
                              },
                              [_vm._v(_vm._s(_vm.activeOffer.name))]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "product-t-grid__visual flc" },
                          [
                            _vm._l(_vm.colorFilters, function (filter) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "product-t-grid__colors product-colors flc",
                                },
                                [
                                  _c("v-product-colors", {
                                    attrs: {
                                      field: filter,
                                      link: _vm.activeOffer.link,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.filterUpdated(filter)
                                      },
                                    },
                                    model: {
                                      value: filter.value,
                                      callback: function ($$v) {
                                        _vm.$set(filter, "value", $$v);
                                      },
                                      expression: "filter.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            _c("v-product-image", {
                              staticClass: "product-t-grid__image",
                              attrs: {
                                src: _vm.activeOffer.image,
                                sources: _vm.activeOffer.imageSources,
                              },
                            }),
                            _vm.activeOffer.statuses &&
                            _vm.activeOffer.statuses.length
                              ? _c(
                                  "div",
                                  { staticClass: "product-t-grid__status" },
                                  [
                                    _c("v-status", {
                                      attrs: {
                                        statuses: _vm.activeOffer.statuses,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._l(_vm.paramsFilters, function (filter) {
                          return _c(
                            "div",
                            { staticClass: "product-t-grid__switch flc" },
                            [
                              _c("v-switch", {
                                attrs: {
                                  field: filter,
                                  link: _vm.activeOffer.link,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.filterUpdated(filter)
                                  },
                                },
                                model: {
                                  value: filter.value,
                                  callback: function ($$v) {
                                    _vm.$set(filter, "value", $$v);
                                  },
                                  expression: "filter.value",
                                },
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                    _vm.product.compare
                      ? _c(
                          "div",
                          { staticClass: "product-t-grid__add-compare flc" },
                          [
                            _c("v-compare-action", {
                              attrs: {
                                id: _vm.activeOffer.id,
                                name: _vm.activeOffer.name,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.activeOffer.prices
                      ? _c(
                          "div",
                          { staticClass: "product-t-grid__price-panel" },
                          [
                            _c("v-price-panel", {
                              attrs: {
                                type: "short",
                                "price-panel-data":
                                  _vm.computedDataSourcePricePanel,
                              },
                              on: {
                                "update-product-options":
                                  _vm.updateProductOptions,
                                "active-price": _vm.activePrice,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "product-t-grid__bottom" }, [
                      _vm.activeOffer.price
                        ? _c(
                            "div",
                            { staticClass: "product-t-grid__price" },
                            [
                              _c("v-price", {
                                attrs: { price: _vm.activeOffer.price },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.activeOffer.availability
                        ? _c(
                            "div",
                            {
                              staticClass: "product-t-grid__action",
                              class: {
                                "product-t-grid__action--inactive":
                                  _vm.activeOffer.availability.value ==
                                  "not-available",
                              },
                            },
                            [
                              _c("v-basket-action", {
                                attrs: {
                                  id: _vm.activeOffer.id,
                                  "product-params": _vm.productSelectedParams,
                                  basket: _vm.activeOffer.availability,
                                  "product-url": _vm.activeOffer.link,
                                  type: _vm.product.type,
                                  disabled:
                                    _vm.currentPrice && _vm.currentPrice.disabled,
                                  "basket-url": _vm.product.basketUrl,
                                  buttons: _vm.product.buttons,
                                  "parent-product-id":
                                    _vm.product.parentProductId,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.activeOffer.availability.value === "wait-order"
                        ? _c(
                            "div",
                            { staticClass: "basket-action__wait-order-text" },
                            [_vm._v("Ожидаем поставку в скором времени")]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$Q = [];
  __vue_render__$Q._withStripped = true;

    /* style */
    const __vue_inject_styles__$V = undefined;
    /* scoped */
    const __vue_scope_id__$V = undefined;
    /* module identifier */
    const __vue_module_identifier__$V = undefined;
    /* functional template */
    const __vue_is_functional_template__$V = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$V = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$Q, staticRenderFns: __vue_staticRenderFns__$Q },
      __vue_inject_styles__$V,
      __vue_script__$V,
      __vue_scope_id__$V,
      __vue_is_functional_template__$V,
      __vue_module_identifier__$V,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  var script$W = {
    data: function data() {
      return {};
    },
    props: {
      src: {
        type: String,
        default: null
      },
      sources: {
        type: Array,
        default: null
      },
      alt: {
        type: String,
        default: ''
      }
    }
  };

  /* script */
  const __vue_script__$W = script$W;

  /* template */
  var __vue_render__$R = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-product-image product-image" },
      [
        _vm.src
          ? _c("v-image", {
              staticClass: "product-image__image",
              attrs: {
                src: _vm.src,
                sources: _vm.sources,
                alt: _vm.alt,
                loading: "auto",
              },
            })
          : _c("div", { staticClass: "product-image__placeholder" }, [
              _c(
                "svg",
                { staticClass: "svg-icon product-image__placeholder-icon" },
                [_c("use", { attrs: { "xlink:href": "#svg-icon-no-photo" } })]
              ),
            ]),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$R = [];
  __vue_render__$R._withStripped = true;

    /* style */
    const __vue_inject_styles__$W = undefined;
    /* scoped */
    const __vue_scope_id__$W = undefined;
    /* module identifier */
    const __vue_module_identifier__$W = undefined;
    /* functional template */
    const __vue_is_functional_template__$W = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$W = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$R, staticRenderFns: __vue_staticRenderFns__$R },
      __vue_inject_styles__$W,
      __vue_script__$W,
      __vue_scope_id__$W,
      __vue_is_functional_template__$W,
      __vue_module_identifier__$W,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  var script$X = {
    props: {
      items: {
        type: Array,
        default: null
      }
    }
  };

  /* script */
  const __vue_script__$X = script$X;

  /* template */
  var __vue_render__$S = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-article-grid article-grid" }, [
      _c(
        "div",
        { staticClass: "article-grid__grid" },
        _vm._l(_vm.items, function (item) {
          return _c(
            "div",
            { staticClass: "article-grid__cell" },
            [_c("v-article-poster", { attrs: { article: item } })],
            1
          )
        }),
        0
      ),
    ])
  };
  var __vue_staticRenderFns__$S = [];
  __vue_render__$S._withStripped = true;

    /* style */
    const __vue_inject_styles__$X = undefined;
    /* scoped */
    const __vue_scope_id__$X = undefined;
    /* module identifier */
    const __vue_module_identifier__$X = undefined;
    /* functional template */
    const __vue_is_functional_template__$X = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$X = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$S, staticRenderFns: __vue_staticRenderFns__$S },
      __vue_inject_styles__$X,
      __vue_script__$X,
      __vue_scope_id__$X,
      __vue_is_functional_template__$X,
      __vue_module_identifier__$X,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$Y = {
    props: {
      article: {
        type: Object,
        default: null
      }
    }
  };

  /* script */
  const __vue_script__$Y = script$Y;

  /* template */
  var __vue_render__$T = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-article-poster article-poster" }, [
      _vm.article.link
        ? _c("a", {
            staticClass: "article-poster__link",
            attrs: { href: _vm.article.link },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "article-poster__visual flc" },
        [
          _c("v-product-image", {
            staticClass: "article-poster__image",
            attrs: { src: _vm.article.image },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "article-poster__content" }, [
        _vm.article.name
          ? _c("h4", { staticClass: "article-poster__title flc" }, [
              _vm._v(_vm._s(_vm.article.name)),
            ])
          : _vm._e(),
        _vm.article.text
          ? _c("div", { staticClass: "article-poster__text flc" }, [
              _vm._v(_vm._s(_vm.article.text)),
            ])
          : _vm._e(),
      ]),
    ])
  };
  var __vue_staticRenderFns__$T = [];
  __vue_render__$T._withStripped = true;

    /* style */
    const __vue_inject_styles__$Y = undefined;
    /* scoped */
    const __vue_scope_id__$Y = undefined;
    /* module identifier */
    const __vue_module_identifier__$Y = undefined;
    /* functional template */
    const __vue_is_functional_template__$Y = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$Y = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$T, staticRenderFns: __vue_staticRenderFns__$T },
      __vue_inject_styles__$Y,
      __vue_script__$Y,
      __vue_scope_id__$Y,
      __vue_is_functional_template__$Y,
      __vue_module_identifier__$Y,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$Z = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        catalog: null,
        type: null,
        state: {
          filter: null
        }
      };
    },
    computed: _objectSpread2(_objectSpread2({}, mapGetters({
      basketLoading: 'basket/basketLoading'
    })), {}, {
      allLoading: function allLoading() {
        return this.basketLoading && !window.modalController.modals.length || this.loading && !window.modalController.modals.length;
      },
      currentTab: function currentTab() {
        return this.catalog.item.tabs.forEach(function (accum, curr) {
          return curr.active ? curr : accum;
        }, {});
      }
    }),
    watch: {
      catalog: function catalog() {
        this.applyNewFilters();
      }
    },
    methods: {
      dataSet: function dataSet(data) {
        this.catalog = data;
      },
      // сбор фильтров в объект для отправки
      createFilterValue: function createFilterValue(filter) {
        if (filter) {
          var result = {};
          result[filter.name] = filter.value;
          return result;
        } else {
          return null;
        }
      },
      filterChanged: function filterChanged(filter) {
        this.requestDataLoad({}, filter);
        this.createFilterValue(filter);
      },
      // отправка данных фильтров
      requestDataLoad: function requestDataLoad(dataSetOptions, filter) {
        this.dataLoad({
          url: this.catalog.remote,
          delay: true,
          data: {
            filter: this.createFilterValue(filter)
          }
        }, dataSetOptions);
      },
      setActiveTab: function setActiveTab(tab) {
        this.catalog.item.tabs.forEach(function (el) {
          el.active = el === tab;
        });
      },
      applyNewFilters: function applyNewFilters() {
        if (this.catalog && this.catalog.remote) {
          if (!~window.location.href.indexOf('/local/') && !this.catalog.notChangeUrl) {
            window.history.replaceState(null, null, this.catalog.remote);
          }

          console.log('applyNewFilters');
        }
      }
    },
    updated: function updated() {
      var _this = this;

      this.$nextTick(function () {
        view.initAllLocal(_this.$el); // запись типа передаваемых данных в компонент

        if (_this.catalog && _this.catalog.item) {
          _this.type = _this.catalog.item.type;
        }
      });
    },
    created: function created() {
      this.applyNewFilters();
    }
  };

  /* script */
  const __vue_script__$Z = script$Z;

  /* template */
  var __vue_render__$U = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-catalog-item catalog-item",
        class: ["catalog-item--" + _vm.type],
      },
      [
        _c("v-loader", { attrs: { loading: _vm.allLoading } }),
        _c(
          "transition",
          { attrs: { name: "message-toggle" } },
          [
            _vm.catalog && _vm.catalog.messages && _vm.catalog.messages.length
              ? _c("v-message", {
                  attrs: { messages: _vm.catalog.messages },
                  on: {
                    "update:messages": function ($event) {
                      return _vm.$set(_vm.catalog, "messages", $event)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm.catalog && _vm.catalog.item && _vm.catalog.item.name
          ? _c("div", { staticClass: "page-title" }, [
              _c("div", { staticClass: "container" }, [
                _c("h1", {
                  staticClass: "h2 page-title__value",
                  domProps: { innerHTML: _vm._s(_vm.catalog.item.name) },
                }),
              ]),
            ])
          : _vm._e(),
        !_vm.catalog ? [_vm._m(0)] : _vm._e(),
        _vm.catalog
          ? [
              _c("div", { staticClass: "container" }, [
                _vm.catalog.item.code
                  ? _c("div", { staticClass: "catalog-item__code" }, [
                      _vm._v("Код товара: " + _vm._s(_vm.catalog.item.code)),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "catalog-item__wrap" }, [
                  _c("div", { staticClass: "catalog-item__aside" }, [
                    _c(
                      "div",
                      { staticClass: "catalog-item__visual" },
                      [
                        _vm.catalog.item.statuses &&
                        _vm.catalog.item.statuses.length
                          ? _c(
                              "div",
                              { staticClass: "catalog-item__status" },
                              [
                                _c("v-status", {
                                  staticClass: "status--inverse",
                                  attrs: { statuses: _vm.catalog.item.statuses },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.catalog.item &&
                        _vm.catalog.item.images &&
                        _vm.catalog.item.images.length == 1
                          ? _c("div", { staticClass: "catalog-item__img" }, [
                              _vm.catalog.item.images[0].src
                                ? _c("img", {
                                    staticClass: "js-gallery-img",
                                    attrs: {
                                      src: _vm.catalog.item.images[0].src,
                                      "data-src": _vm.catalog.item.images[0].src,
                                      alt: _vm.catalog.item.name,
                                      title: _vm.catalog.item.name,
                                    },
                                  })
                                : _c(
                                    "div",
                                    { staticClass: "product-image__placeholder" },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "svg-icon product-image__placeholder-icon",
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": "#svg-icon-no-photo",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                            ])
                          : _vm._e(),
                        _vm.catalog.item &&
                        _vm.catalog.item.images &&
                        _vm.catalog.item.images.length > 1
                          ? _c(
                              "v-slider-thumbs",
                              [
                                _vm._l(
                                  _vm.catalog.item.images,
                                  function (slide, index) {
                                    return _c(
                                      "v-swiper-slide",
                                      {
                                        key: slide.id || index,
                                        attrs: { slot: "thumbs" },
                                        slot: "thumbs",
                                      },
                                      [
                                        slide.src
                                          ? _c("img", {
                                              attrs: {
                                                src: slide.src,
                                                alt: "catalog.item.name",
                                                title: "catalog.item.name",
                                                loading: "lazy",
                                              },
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "product-image__placeholder",
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "svg-icon product-image__placeholder-icon",
                                                  },
                                                  [
                                                    _c("use", {
                                                      attrs: {
                                                        "xlink:href":
                                                          "#svg-icon-no-photo",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._l(
                                  _vm.catalog.item.images,
                                  function (slide, index) {
                                    return _c(
                                      "v-swiper-slide",
                                      { key: slide.id || index },
                                      [
                                        slide.src
                                          ? _c("img", {
                                              staticClass: "js-gallery-img",
                                              attrs: {
                                                src: slide.src,
                                                "data-src": slide.src,
                                                alt: _vm.catalog.item.name,
                                                title: _vm.catalog.item.name,
                                              },
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "product-image__placeholder",
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "svg-icon product-image__placeholder-icon",
                                                  },
                                                  [
                                                    _c("use", {
                                                      attrs: {
                                                        "xlink:href":
                                                          "#svg-icon-no-photo",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  (_vm.catalog.item.params && _vm.catalog.item.params.length) ||
                  (_vm.catalog.filters && _vm.catalog.filters.length)
                    ? _c(
                        "div",
                        { staticClass: "catalog-item__main" },
                        [
                          _vm.catalog.item.params &&
                          _vm.catalog.item.params.length
                            ? _c(
                                "div",
                                { staticClass: "catalog-item__category" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "catalog-item__category-caption",
                                    },
                                    [_vm._v("Основные характеристики")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "catalog-item__params flc" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "key-value-list flc" },
                                        _vm._l(
                                          _vm.catalog.item.params,
                                          function (param) {
                                            return _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "key-value-list__item",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "key-value-list__item-bullet",
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "svg-icon svg-icon--list-bullet",
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xlink:href":
                                                              "#svg-icon-list-bullet",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c("div", {
                                                  staticClass:
                                                    "key-value-list__item-start",
                                                  domProps: {
                                                    innerHTML: _vm._s(param.name),
                                                  },
                                                }),
                                                _c("div", {
                                                  staticClass:
                                                    "key-value-list__item-end",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      param.value
                                                    ),
                                                  },
                                                }),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._l(_vm.catalog.filters, function (filter) {
                            return _vm.catalog.filters &&
                              _vm.catalog.filters.length
                              ? _c(
                                  "div",
                                  { staticClass: "catalog-item__category" },
                                  [
                                    filter.filterText
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "catalog-item__category-caption",
                                          },
                                          [_vm._v(_vm._s(filter.filterText))]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "catalog-item__filter-togglers flc",
                                      },
                                      [
                                        _c("v-field", {
                                          attrs: { field: filter },
                                          on: {
                                            input: function ($event) {
                                              return _vm.filterChanged(filter)
                                            },
                                          },
                                          model: {
                                            value: filter.value,
                                            callback: function ($$v) {
                                              _vm.$set(filter, "value", $$v);
                                            },
                                            expression: "filter.value",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm.type != "gift"
                            ? _c(
                                "div",
                                { staticClass: "catalog-item__compare" },
                                [
                                  _c("v-compare-action", {
                                    attrs: {
                                      id: _vm.catalog.item.id,
                                      name: _vm.catalog.item.name,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.catalog.item.stock
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "catalog-item__category catalog-item__stock",
                                },
                                [
                                  _vm.catalog.item.stock.active
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "catalog-item__stock-btn btn js-open-modal",
                                          attrs: {
                                            type: "button",
                                            "data-modal-data":
                                              '{"className": "modal--xl"}',
                                            "data-modal-url":
                                              _vm.catalog.item.stock.modalUrl,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.catalog.item.stock.button.text
                                            )
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "catalog-item__stock-empty",
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "catalog-item__stock-empty-icon",
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    "#svg-icon-no-stock",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(
                                            _vm._s(
                                              _vm.catalog.item.stock.button
                                                .emptyText
                                            )
                                          ),
                                        ]
                                      ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.catalog.item.type == "product" &&
                  _vm.catalog.item.prices &&
                  _vm.catalog.item.prices.length
                    ? _c(
                        "div",
                        { staticClass: "catalog-item__panel" },
                        [
                          _c("v-price-panel", {
                            attrs: {
                              "price-panel-data": _vm.catalog.item,
                              type: "product",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.catalog.item.type == "gift" && _vm.catalog.items
                    ? _c(
                        "div",
                        { staticClass: "catalog-item__products" },
                        [
                          _c(
                            "div",
                            { staticClass: "catalog-item__products-caption" },
                            [_vm._v("Подарок к покупке")]
                          ),
                          _c(
                            "v-slider-carousel",
                            {
                              attrs: {
                                options: { breakpoints: {} },
                                customClassName: "products",
                                navigation: "navigation",
                              },
                            },
                            _vm._l(_vm.catalog.items, function (product, index) {
                              return _c(
                                "v-swiper-slide",
                                {
                                  key: product.id || index,
                                  staticClass: "swiper-slide--stretch",
                                },
                                [
                                  _c("v-product", {
                                    attrs: { template: "grid", product: product },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm.catalog && _vm.catalog.productSlider
                ? _c(
                    "v-page-section",
                    {
                      staticClass: "page-section--margin-small-top",
                      attrs: {
                        "data-source": {
                          title: { text: "Добавь к покупке", link: null },
                        },
                      },
                    },
                    [
                      _c("v-tabs-slider", {
                        attrs: { "data-source": _vm.catalog.productSlider },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.catalog.item.tabs && _vm.catalog.item.tabs.length
                ? _c("div", { staticClass: "catalog-item__tabs" }, [
                    _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "tabs init-tabs" }, [
                        _c("div", { staticClass: "tabs__navigation-wrap" }, [
                          _c(
                            "div",
                            { staticClass: "tabs__navigation" },
                            _vm._l(_vm.catalog.item.tabs, function (tab) {
                              return _c(
                                "div",
                                {
                                  staticClass: "tabs__toggler",
                                  class: { "active-tab": tab.active },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setActiveTab(tab)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(tab.title))]
                              )
                            }),
                            0
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "tabs__list" },
                          _vm._l(_vm.catalog.item.tabs, function (tab) {
                            return _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: tab.active,
                                    expression: "tab.active",
                                  },
                                ],
                                staticClass: "tabs__content",
                                class: { "active-tab": tab.active },
                              },
                              [
                                tab.name == "specification"
                                  ? _c(
                                      "div",
                                      { staticClass: "specification" },
                                      [
                                        _vm._l(tab.value, function (group) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "specification__group accordion js-accordion",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "specification__caption accordion__toggler js-accordion__toggler",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " " + _vm._s(group.name)
                                                    ),
                                                  ]),
                                                  _c("div", {
                                                    staticClass:
                                                      "accordion__plus",
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "accordion__content js-accordion__content",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "specification__table",
                                                    },
                                                    _vm._l(
                                                      group.props,
                                                      function (prop) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "specification__row",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "specification__cell",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    prop.name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "specification__cell",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    prop.value
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }),
                                        tab.note
                                          ? _c("div", {
                                              staticClass: "specification__note",
                                              domProps: {
                                                innerHTML: _vm._s(tab.note),
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : tab.content
                                  ? _c(
                                      "div",
                                      { staticClass: "catalog-item__about" },
                                      [
                                        _c("div", {
                                          staticClass: "text-guide",
                                          domProps: {
                                            innerHTML: _vm._s(tab.content),
                                          },
                                        }),
                                      ]
                                    )
                                  : tab.name == "about"
                                  ? _c("div", {
                                      staticClass: "catalog-item__about",
                                      domProps: { innerHTML: _vm._s(tab.value) },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$U = [
    function () {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "catalog__placeholder" }),
      ])
    },
  ];
  __vue_render__$U._withStripped = true;

    /* style */
    const __vue_inject_styles__$Z = undefined;
    /* scoped */
    const __vue_scope_id__$Z = undefined;
    /* module identifier */
    const __vue_module_identifier__$Z = undefined;
    /* functional template */
    const __vue_is_functional_template__$Z = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$Z = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$U, staticRenderFns: __vue_staticRenderFns__$U },
      __vue_inject_styles__$Z,
      __vue_script__$Z,
      __vue_scope_id__$Z,
      __vue_is_functional_template__$Z,
      __vue_module_identifier__$Z,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$_ = {
    methods: {
      // Устанавливает куки с именем name и значением value, с настройкой path=/ по умолчанию
      // Пример использования: setCookie('user', 'John', {secure: true, 'max-age': 3600});
      setCookie: function setCookie(name, value) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        options = _objectSpread2({
          path: '/'
        }, options);

        if (options.expires instanceof Date) {
          options.expires = options.expires.toUTCString();
        }

        var updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

        for (var optionKey in options) {
          updatedCookie += '; ' + optionKey;
          var optionValue = options[optionKey];

          if (optionValue !== true) {
            updatedCookie += '=' + optionValue;
          }
        }

        document.cookie = updatedCookie;
      },
      // возвращает куки с указанным name, или undefined, если ничего не найдено
      getCookie: function getCookie(name) {
        var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
        return matches ? decodeURIComponent(matches[1]) : undefined;
      },
      // удалить куки установив отрицательную дату истечения срока действия
      deleteCookie: function deleteCookie(name) {
        setCookie(name, '', {
          'max-age': -1
        });
      }
    }
  };

  /* script */
  const __vue_script__$_ = script$_;

  /* template */

    /* style */
    const __vue_inject_styles__$_ = undefined;
    /* scoped */
    const __vue_scope_id__$_ = undefined;
    /* module identifier */
    const __vue_module_identifier__$_ = undefined;
    /* functional template */
    const __vue_is_functional_template__$_ = undefined;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$_ = /*#__PURE__*/normalizeComponent(
      {},
      __vue_inject_styles__$_,
      __vue_script__$_,
      __vue_scope_id__$_,
      __vue_is_functional_template__$_,
      __vue_module_identifier__$_,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$$ = {
    mixins: [__vue_component__$_],
    data: function data() {
      return {
        modals: [],
        loading: null,
        closeTimeout: null,
        historyEventIsHashChange: false,
        historyEventIsManual: false
      };
    },
    computed: {
      topModal: function topModal() {
        return this.modals.length ? this.modals[this.modals.length - 1] : null;
      }
    },
    methods: {
      open: function open() {
        var _arguments = arguments,
            _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var options, response;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};

                  if (!options.url) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 4;
                  return fetch(options.url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'text/plain;charset=UTF-8'
                    }
                  });

                case 4:
                  response = _context.sent;
                  _context.next = 7;
                  return response.text();

                case 7:
                  options.content = _context.sent;

                case 8:
                  if (_this.closeTimeout) {
                    clearTimeout(_this.closeTimeout);
                    _this.closeTimeout = null;

                    _this.modals.pop();
                  }

                  options.key = Math.random() + '-' + new Date().getMilliseconds();

                  _this.modals.push(options); // window.history.pushState({component: 'v-modal'}, '', options.historyUrl || window.location.href);


                  document.body.classList.add('state--modal-open');
                  controller.lockScrolling();

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      close: function close() {
        var _arguments2 = arguments,
            _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var options;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  options = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
                  return _context2.abrupt("return", new Promise(function (resolve) {
                    if (_this2.topModal.reloadAfterClose) {
                      window.location.reload(true);
                    }

                    if (_this2.modals.length > 1) {
                      _this2.modals.pop();

                      if (!options.fromHistory) {
                        _this2.historyEventIsManual = true; // window.history.back();
                      }

                      resolve();
                    } else {
                      if (_this2.modals.length <= 1 && (!options || !options.replace)) {
                        document.body.classList.remove('state--modal-open');
                      } // if modal is the last add 250ms delay to prevent jump to small-white-brick-empty-modal and let transition play


                      // if modal is the last add 250ms delay to prevent jump to small-white-brick-empty-modal and let transition play
                      _this2.closeTimeout = setTimeout(function () {
                        if (_this2.modals.length <= 1 && (!options || !options.replace)) {
                          controller.unlockScrolling();
                        } // установка куков при закрыти попапа "продолжить как"


                        // установка куков при закрыти попапа "продолжить как"
                        if (_this2.topModal.name == "continue-as") {
                          _this2.setCookie('continue-as-legal-entity', true);
                        }

                        _this2.modals.pop();

                        if (!options.fromHistory) {
                          _this2.historyEventIsManual = true; // window.history.back();
                        }

                        resolve();
                      }, 250);
                    }
                  }));

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      closeAll: function closeAll() {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(_this3.modals.length > 0)) {
                    _context3.next = 5;
                    break;
                  }

                  _context3.next = 3;
                  return _this3.close();

                case 3:
                  _context3.next = 0;
                  break;

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },
      openModal: function openModal(element) {
        var modalURL = element.el.getAttribute('data-modal-url');
        var modalData;

        try {
          modalData = JSON.parse(element.el.getAttribute('data-modal-data'));
        } catch (e) {
          modalData = null;

          if (!modalURL) {
            console.warn('v-modal: wrong modalData on .js-open-modal', e);
          }
        }

        if (modalData || modalURL) {
          var options = modalData || {};

          if (modalURL) {
            options.url = modalURL;
          }

          this.open(options);
        }
      },
      overlayClick: function overlayClick(e) {
        var $target = e.target;

        if (!$target.closest('.modal__content-slot') && $target.closest('body')) {
          this.close();
        }
      },
      handlePopState: function handlePopState(e) {
        if (this.historyEventIsHashChange) {
          this.historyEventIsHashChange = false;
          return;
        }

        if (this.historyEventIsManual) {
          this.historyEventIsManual = false;
          return;
        }

        console.log('v-modal: pop state', e.state);

        if (this.topModal) {
          this.close({
            fromHistory: true
          });
        }
      },
      handleHashChange: function handleHashChange() {
        this.historyEventIsHashChange = true;
      }
    },
    created: function created() {
      var _this4 = this;

      window.modalController = this;

      var matches = function matches(el, selector) {
        try {
          return (el.matches || el.matchesSelector || el.msMatchesSelector).call(el, selector);
        } catch (e) {
          return false;
        }
      };

      var closestMatch = function closestMatch(el, selectors) {
        while (el) {
          for (var i = 0; i < selectors.length; i++) {
            if (matches(el, selectors[i])) {
              return {
                el: el,
                selector: selectors[i]
              };
            }
          }

          el = el.parentNode;
        }

        return null;
      }; // event delegation


      document.addEventListener('click', function (e) {
        var button = closestMatch(e.target, ['.js-replace-modal', '.js-open-modal', '.js-close-modal', '.js-open-modal-gallery']);

        if (!button) {
          return;
        }

        if (button.selector === '.js-replace-modal') {
          _this4.close().then(function () {
            _this4.openModal(button);
          });
        } else if (button.selector === '.js-open-modal') {
          _this4.openModal(button);
        } else if (button.selector === '.js-close-modal') {
          _this4.close();
        } else if (button.selector === '.js-open-modal-gallery') {
          var dataSource = button.el.dataset.gallery;
          var initialIndex = parseInt(button.el.dataset.initialIndex) || 0;

          _this4.open({
            className: 'modal--gallery',
            content: "<v-gallery :data-source='".concat(dataSource ? JSON.stringify(dataSource) : null, "' :initial-index=\"").concat(initialIndex, "\"></v-gallery>")
          });
        }
      });
      document.addEventListener('keyup', this.handleEsc);
      window.addEventListener('popstate', this.handlePopState);
      window.addEventListener('hashchange', this.handleHashChange);
    },
    mounted: function mounted() {
      var _this5 = this;

      // открытие попапа при загрузке старницы
      Array.from(document.querySelectorAll('.js-open-modal-on-load-page')).forEach(function (modalOpener) {
        var _modalOpener$dataset, _modalOpener$dataset2, _modalOpener$dataset3;

        if ((modalOpener === null || modalOpener === void 0 ? void 0 : (_modalOpener$dataset = modalOpener.dataset) === null || _modalOpener$dataset === void 0 ? void 0 : _modalOpener$dataset.id) === 'add-to-basket') {
          _this5.openModal({
            el: modalOpener,
            selector: '.js-open-modal'
          });
        }

        if ((modalOpener === null || modalOpener === void 0 ? void 0 : (_modalOpener$dataset2 = modalOpener.dataset) === null || _modalOpener$dataset2 === void 0 ? void 0 : _modalOpener$dataset2.id) === 'login-phone') {
          _this5.openModal({
            el: modalOpener,
            selector: '.js-open-modal'
          });
        }

        if ((modalOpener === null || modalOpener === void 0 ? void 0 : (_modalOpener$dataset3 = modalOpener.dataset) === null || _modalOpener$dataset3 === void 0 ? void 0 : _modalOpener$dataset3.id) === 'continue-as' && !_this5.getCookie('continue-as-legal-entity')) {
          _this5.openModal({
            el: modalOpener,
            selector: '.js-open-modal'
          });
        }
      });
    },
    destroyed: function destroyed() {
      document.body.classList.remove('state--modal-open');
      document.removeEventListener('keyup', this.handleEsc);
      window.removeEventListener('popstate', this.handlePopState);
      window.removeEventListener('hashchange', this.handleHashChange);
    }
  };

  /* script */
  const __vue_script__$$ = script$$;

  /* template */
  var __vue_render__$V = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-modal modal",
        class: _vm.topModal ? _vm.topModal.className : "",
      },
      [
        _c(
          "div",
          { staticClass: "modal__surface", on: { click: _vm.overlayClick } },
          _vm._l(_vm.modals, function (modal, index) {
            return _c(
              modal.content ? "v-lazy-component" : "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: index === _vm.modals.length - 1,
                    expression: "index === modals.length - 1",
                  },
                ],
                key: modal.key,
                tag: "component",
                staticClass: "modal__container",
              },
              [
                modal.content
                  ? _c("div", {
                      staticClass: "modal__content-slot",
                      domProps: { innerHTML: _vm._s(modal.content) },
                    })
                  : _c(
                      "div",
                      { staticClass: "modal__content-slot" },
                      [
                        _c(
                          "v-modal-window",
                          { attrs: { "show-close": modal.showClose } },
                          [
                            _c(
                              modal.component.name,
                              _vm._b(
                                { tag: "component" },
                                "component",
                                modal.component.props,
                                false
                              )
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
              ]
            )
          }),
          1
        ),
      ]
    )
  };
  var __vue_staticRenderFns__$V = [];
  __vue_render__$V._withStripped = true;

    /* style */
    const __vue_inject_styles__$$ = undefined;
    /* scoped */
    const __vue_scope_id__$$ = undefined;
    /* module identifier */
    const __vue_module_identifier__$$ = undefined;
    /* functional template */
    const __vue_is_functional_template__$$ = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$$ = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$V, staticRenderFns: __vue_staticRenderFns__$V },
      __vue_inject_styles__$$,
      __vue_script__$$,
      __vue_scope_id__$$,
      __vue_is_functional_template__$$,
      __vue_module_identifier__$$,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$10 = {
    mixins: [__vue_component__$_],
    props: {
      messages: {
        default: null
      }
    },
    watch: {
      messages: {
        handler: function handler() {
          if (this.messages && this.messages.length) {
            document.body.classList.add('state--messages-open');
          } else {
            document.body.classList.remove('state--messages-open');
          }
        },
        immediate: true
      }
    },
    methods: {
      closeMessage: function closeMessage(event, options) {
        var vm = this;
        this.$emit('update:messages', vm.messages.filter(function (el, index) {
          return index !== options.index;
        }));
      },
      setPosition: function setPosition() {
        if (document.body.classList.contains('state--messages-open')) {
          var headerPosition = document.querySelector('.page-header').getBoundingClientRect().bottom;

          if (headerPosition < 0) {
            this.$el.style.top = 0;
          } else {
            this.$el.style.top = headerPosition + 'px';
          }
        }
      }
    },
    mounted: function mounted() {
      this.setPosition();
      window.addEventListener('scroll', this.setPosition);
    },
    destroyed: function destroyed() {
      document.body.classList.remove('state--messages-open');
      window.removeEventListener('scroll', this.setPosition);
    }
  };

  /* script */
  const __vue_script__$10 = script$10;

  /* template */
  var __vue_render__$W = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-message message" }, [
      _c("div", { staticClass: "message__wrapper container" }, [
        _c(
          "div",
          { staticClass: "message__list-wrapper" },
          [
            _c(
              "transition-group",
              {
                staticClass: "message__list",
                attrs: { tag: "div", name: "message-toggle" },
              },
              _vm._l(_vm.messages, function (message, index) {
                return _c(
                  "div",
                  {
                    key: message.id,
                    staticClass: "message__item js-message-item",
                    class: message.classList,
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "message__close",
                        on: {
                          click: function ($event) {
                            return _vm.closeMessage($event, {
                              message: message,
                              index: index,
                            })
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          { staticClass: "svg-icon message__close-icon" },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#svg-icon-close" },
                            }),
                          ]
                        ),
                      ]
                    ),
                    message.caption
                      ? _c("div", {
                          staticClass: "message__caption",
                          domProps: { innerHTML: _vm._s(message.caption) },
                        })
                      : _vm._e(),
                    message.text
                      ? _c("div", {
                          staticClass: "message__text",
                          domProps: { innerHTML: _vm._s(message.text) },
                        })
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
    ])
  };
  var __vue_staticRenderFns__$W = [];
  __vue_render__$W._withStripped = true;

    /* style */
    const __vue_inject_styles__$10 = undefined;
    /* scoped */
    const __vue_scope_id__$10 = undefined;
    /* module identifier */
    const __vue_module_identifier__$10 = undefined;
    /* functional template */
    const __vue_is_functional_template__$10 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$10 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$W, staticRenderFns: __vue_staticRenderFns__$W },
      __vue_inject_styles__$10,
      __vue_script__$10,
      __vue_scope_id__$10,
      __vue_is_functional_template__$10,
      __vue_module_identifier__$10,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$11 = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        remote: null,
        gallery: null,
        loading: false,
        loadingMinTimeout: null,
        touchMode: controller.touch,
        currentIndex: 0,
        resizeTimeout: null,
        setPositionQueue: false,
        setScaleQueue: false,
        touchActive: false,
        touchStartPoint: null,
        touchStartPoint2: null,
        touchIntentMinOffset: 0,
        touchIntent: 0,
        debug: null,
        dragOffset: 0,
        scaleActive: false,
        scaleRatio: 1,
        scaleRatioPrevious: 1,
        scaleOffset: {
          x: 0,
          y: 0
        },
        scaleOffsetPrevious: {
          x: 0,
          y: 0
        }
      };
    },
    props: {
      initialIndex: {
        default: 0
      }
    },
    watch: {
      gallery: function gallery() {
        this.setPosition(true);
      }
    },
    methods: {
      pauseVideo: function pauseVideo() {
        this.$refs.video.forEach(function (item) {
          item.pauseVideo();
        });
      },
      goTo: function goTo(index) {
        if (index != this.currentIndex) {
          this.currentIndex = Math.max(0, Math.min(this.gallery.items.length - 1, index));
          this.scaleActive = false;
          this.scaleRatio = 1;
          this.scaleOffsetPrevious.x = 0;
          this.scaleOffsetPrevious.y = 0;
        }

        this.setPosition();
      },
      setPosition: function setPosition(silent) {
        var _this = this;

        // if list is not rendered yet
        if (!this.$refs['view-list']) {
          return;
        }

        cancelAnimationFrame(this.setPositionQueue);
        this.setPositionQueue = requestAnimationFrame(function () {
          if (silent) {
            _this.$refs['view-list'].style.transition = '0s';
          }

          _this.$refs['view-list'].style.transform = 'translate3d(' + (-_this.$refs['view-list'].offsetWidth * _this.currentIndex + _this.dragOffset) + 'px,0,0)';

          if (silent) {
            requestAnimationFrame(function () {
              _this.$refs['view-list'].style.transition = '';
            });
          }
        });
      },
      setScale: function setScale(silent) {
        var _this2 = this;

        // if list is not rendered yet
        if (!this.$refs['view-item-wrapper']) {
          return;
        }

        cancelAnimationFrame(this.setScaleQueue);
        this.setScaleQueue = requestAnimationFrame(function () {
          for (var i = 0; i < _this2.$refs['view-item-wrapper'].length; i++) {
            if (i != _this2.currentIndex) {
              _this2.$refs['view-item-wrapper'][i].style.transform = '';
            }
          }

          if (silent) {
            _this2.$refs['view-item-wrapper'][_this2.currentIndex].style.transition = '0s';
          }

          _this2.$refs['view-item-wrapper'][_this2.currentIndex].style.transform = _this2.scaleActive ? 'translate3d(' + _this2.scaleOffset.x + 'px,' + _this2.scaleOffset.y + 'px,0) scale(' + _this2.scaleRatio + ')' : '';

          if (silent) {
            requestAnimationFrame(function () {
              _this2.$refs['view-item-wrapper'][_this2.currentIndex].style.transition = '';
            });
          }
        });
      },
      startTouchAction: function startTouchAction(e) {
        this.touchActive = true;
        this.touchStartPoint = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };

        if (e.touches.length == 2) {
          this.scaleActive = true;
          this.touchStartPoint2 = {
            x: e.touches[1].pageX,
            y: e.touches[1].pageY
          };
        }
      },
      stopTouchAction: function stopTouchAction(e) {
        // when last touch ended
        if (this.touchActive && !e.touches.length) {
          this.touchActive = false;
          this.dragOffset = 0;
          this.goTo(this.currentIndex + this.touchIntent);
        }

        if (this.scaleActive) {
          if (e.touches.length < 2) {
            this.touchActive = false;
            this.scaleRatio = Math.max(1, Math.min(2, this.scaleRatio));
            this.scaleActive = this.scaleRatio != 1;
            this.scaleRatioPrevious = this.scaleRatio;
          }

          if (this.scaleActive) {
            this.scaleOffsetPrevious.x = this.scaleOffset.x;
            this.scaleOffsetPrevious.y = this.scaleOffset.y;
          } else {
            this.scaleOffsetPrevious.x = 0;
            this.scaleOffsetPrevious.y = 0;
          }
        }

        this.setScale();
      },
      handleTouchAction: function handleTouchAction(e) {
        if (this.touchActive) {
          // scale mode is active, scale != 1
          // scale or move active image
          if (this.scaleActive) {
            // multitouch - change scale
            if (e.touches.length > 1) {
              // scale (Pythagoras)
              var initialDistance = Math.sqrt(Math.pow(this.touchStartPoint.x - this.touchStartPoint2.x, 2) + Math.pow(this.touchStartPoint.y - this.touchStartPoint2.y, 2));
              var currentDistance = Math.sqrt(Math.pow(e.touches[0].pageX - e.touches[1].pageX, 2) + Math.pow(e.touches[0].pageY - e.touches[1].pageY, 2));
              this.scaleRatio = Math.max(0.9, Math.min(2.2, this.scaleRatioPrevious * currentDistance / initialDistance)); // drag inside scaled slide

              this.scaleOffset.x = this.scaleOffsetPrevious.x + e.touches[0].pageX - this.touchStartPoint.x + (e.touches[1].pageX - this.touchStartPoint2.x) / 2;
              this.scaleOffset.y = this.scaleOffsetPrevious.y + e.touches[0].pageY - this.touchStartPoint.y + (e.touches[1].pageY - this.touchStartPoint2.y) / 2;
            } else {
              // non-multitouch - drag inside scaled slide
              this.debug = this.scaleOffsetPrevious; // drag inside scaled slide

              this.scaleOffset.x = this.scaleOffsetPrevious.x + e.touches[0].pageX - this.touchStartPoint.x;
              this.scaleOffset.y = this.scaleOffsetPrevious.y + e.touches[0].pageY - this.touchStartPoint.y;
            }

            this.dragOffset = 0;
            this.touchIntent = 0;
            this.setScale(true);
          } else {
            // else - drag slide list
            // multitouch drag - never works because of scaleActive but...
            if (e.touches.length > 1) {
              this.dragOffset = e.touches[0].pageX - this.touchStartPoint.x + (e.touches[1].pageX - this.touchStartPoint2.x) / 2;
            } else {
              // non-multitouch drag
              this.dragOffset = e.touches[0].pageX - this.touchStartPoint.x;
            } // rubber effect at the ends


            if (this.currentIndex == 0 && this.dragOffset > 0 || this.currentIndex == this.gallery.items.length - 1 && this.dragOffset < 0) {
              this.dragOffset = Math.sign(this.dragOffset) * Math.pow(Math.abs(this.dragOffset), .75);
            }

            this.setPosition(true); // determine intended swipe direction

            if (this.dragOffset >= this.touchIntentMinOffset) {
              this.touchIntent = -1;
            } else if (this.dragOffset <= -this.touchIntentMinOffset) {
              this.touchIntent = 1;
            } else {
              this.touchIntent = 0;
            }
          }
        }
      },
      updateIntentOffset: function updateIntentOffset() {
        // min drag offset to consider it as slide
        // is 25% of gallery width but inbetween 50 and 200
        this.touchIntentMinOffset = Math.min(200, Math.max(50, (this.$refs['view-list'] || document.body).offsetWidth * 0.25));
      },
      dataSet: function dataSet(data) {
        var _this3 = this;

        this.gallery = data;
        Vue.nextTick(function () {
          _this3.setPosition(true);
        });
      },
      handleResize: function handleResize() {
        var _this4 = this;

        if (!this.resizeTimeout) {
          this.resizeTimeout = setTimeout(function () {
            _this4.updateIntentOffset();

            _this4.setPosition(true);

            _this4.resizeTimeout = null;
          }, 100);
        }
      }
    },
    created: function created() {
      this.currentIndex = this.initialIndex;
      this.updateIntentOffset();
      window.addEventListener('resize', this.handleResize, controller.passiveEventsSupported ? {
        passive: true
      } : undefined);

      if (controller.touch) {
        document.addEventListener('touchend', this.stopTouchAction, controller.passiveEventsSupported ? {
          passive: true
        } : undefined);
        document.addEventListener('touchmove', this.handleTouchAction, controller.passiveEventsSupported ? {
          passive: true
        } : undefined);
      }
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.handleResize);

      if (controller.touch) {
        document.removeEventListener('touchend', this.stopTouchAction);
        document.addEventListener('touchmove', this.handleTouchAction);
      }
    }
  };

  /* script */
  const __vue_script__$11 = script$11;

  /* template */
  var __vue_render__$X = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-gallery gallery" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _c(
          "button",
          {
            staticClass: "gallery__close js-close-modal",
            attrs: { type: "button" },
          },
          [
            _c("svg", { staticClass: "svg-icon" }, [
              _c("use", { attrs: { "xlink:href": "#svg-icon-close" } }),
            ]),
          ]
        ),
        _vm.gallery
          ? [
              _c(
                "div",
                {
                  staticClass: "gallery__view",
                  on: { touchstart: _vm.startTouchAction },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "gallery__arrow gallery__arrow--prev js-pause-button",
                      class: { disabled: _vm.currentIndex == 0 },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.goTo(_vm.currentIndex - 1)
                        },
                      },
                    },
                    [
                      _c("svg", { staticClass: "svg-icon gallery__arrow-icon" }, [
                        _c("use", {
                          attrs: { "xlink:href": "#svg-icon-slide-left" },
                        }),
                      ]),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass:
                        "gallery__arrow gallery__arrow--next js-pause-button",
                      class: {
                        disabled:
                          _vm.currentIndex == _vm.gallery.items.length - 1,
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.goTo(_vm.currentIndex + 1)
                        },
                      },
                    },
                    [
                      _c("svg", { staticClass: "svg-icon gallery__arrow-icon" }, [
                        _c("use", {
                          attrs: { "xlink:href": "#svg-icon-slide-right" },
                        }),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { ref: "view-list", staticClass: "gallery__view-list" },
                    _vm._l(_vm.gallery.items, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "gallery__view-item" },
                        [
                          item.type === "image"
                            ? _c(
                                "a",
                                {
                                  ref: "view-item-wrapper",
                                  refInFor: true,
                                  staticClass: "gallery__view-item-wrapper",
                                  attrs: {
                                    href: _vm.touchMode
                                      ? null
                                      : item.srcFull || item.src || item.poster,
                                    target: "_blank",
                                    tabindex: "-1",
                                  },
                                },
                                [
                                  _c("v-image", {
                                    attrs: {
                                      src:
                                        item.src || item.srcFull || item.poster,
                                      alt: "",
                                      title: "",
                                    },
                                  }),
                                ],
                                1
                              )
                            : item.type === "iframe"
                            ? _c(
                                "div",
                                { staticClass: "gallery__iframe-wrapper" },
                                [
                                  _c("iframe", {
                                    key: index == _vm.currentIndex ? 1 : 2,
                                    attrs: {
                                      src: item.src,
                                      allow:
                                        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                      allowfullscreen: "allowfullscreen",
                                    },
                                  }),
                                ]
                              )
                            : item.type === "video"
                            ? _c(
                                "div",
                                { staticClass: "gallery__video-wrapper" },
                                [
                                  _c("v-video", {
                                    key: index == _vm.currentIndex ? 1 : 2,
                                    attrs: {
                                      src: item.src,
                                      poster: item.videoPoster || item.poster,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.note
                            ? _c(
                                "div",
                                { staticClass: "gallery__view-item-note" },
                                [
                                  _c("div", {
                                    staticClass: "gallery__view-item-note-box",
                                    domProps: { innerHTML: _vm._s(item.note) },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _c("div", { staticClass: "gallery__previews" }, [
                _c("div", { staticClass: "gallery__previews-container" }, [
                  _c(
                    "div",
                    { staticClass: "gallery__previews-list" },
                    _vm._l(_vm.gallery.items, function (item, index) {
                      return _c("a", {
                        staticClass: "gallery__previews-item",
                        class: { active: index == _vm.currentIndex },
                        style: {
                          "background-image":
                            "url(" +
                            (item.poster || item.src || item.srcFull) +
                            ")",
                        },
                        attrs: { tabindex: "0" },
                        on: {
                          click: function ($event) {
                            return _vm.goTo(index)
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.goTo(index)
                          },
                        },
                      })
                    }),
                    0
                  ),
                ]),
              ]),
            ]
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$X = [];
  __vue_render__$X._withStripped = true;

    /* style */
    const __vue_inject_styles__$11 = undefined;
    /* scoped */
    const __vue_scope_id__$11 = undefined;
    /* module identifier */
    const __vue_module_identifier__$11 = undefined;
    /* functional template */
    const __vue_is_functional_template__$11 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$11 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$X, staticRenderFns: __vue_staticRenderFns__$X },
      __vue_inject_styles__$11,
      __vue_script__$11,
      __vue_scope_id__$11,
      __vue_is_functional_template__$11,
      __vue_module_identifier__$11,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$12 = {
    props: {
      showClose: {
        type: Boolean,
        default: true
      }
    }
  };

  /* script */
  const __vue_script__$12 = script$12;

  /* template */
  var __vue_render__$Y = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-modal-window modal-window" }, [
      _c("div", { staticClass: "modal-window__header" }, [
        _vm.showClose
          ? _c(
              "button",
              {
                staticClass: "modal-window__close js-close-modal",
                attrs: { type: "button" },
              },
              [
                _c("svg", { staticClass: "svg-icon modal-window__close-icon" }, [
                  _c("use", { attrs: { "xlink:href": "#svg-icon-close" } }),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "modal-window__body" }, [_vm._t("default")], 2),
    ])
  };
  var __vue_staticRenderFns__$Y = [];
  __vue_render__$Y._withStripped = true;

    /* style */
    const __vue_inject_styles__$12 = undefined;
    /* scoped */
    const __vue_scope_id__$12 = undefined;
    /* module identifier */
    const __vue_module_identifier__$12 = undefined;
    /* functional template */
    const __vue_is_functional_template__$12 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$12 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$Y, staticRenderFns: __vue_staticRenderFns__$Y },
      __vue_inject_styles__$12,
      __vue_script__$12,
      __vue_scope_id__$12,
      __vue_is_functional_template__$12,
      __vue_module_identifier__$12,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$13 = {
    mixins: [__vue_component__$2, __vue_component__$I],
    data: function data() {
      return {
        product: null,
        priceId: null,
        initFilters: false,
        filters: {
          filterClient: {
            'id': 'FIELD_TYPE_CLIENT',
            'name': 'FIELD_TYPE_CLIENT',
            'type': 'tabs',
            'label': null,
            'value': 'present',
            'options': [],
            'errors': null
          },
          filterTel: {
            'id': 'FIELD_TYPE_PHONE_NUMBER',
            'name': 'FIELD_TYPE_PHONE_NUMBER',
            'type': 'radio-list',
            'label': null,
            'value': 'new',
            'options': [],
            'errors': null
          },
          filterPricePeriod: {
            'id': 'FIELD_TIME_PAY',
            'name': 'FIELD_TIME_PAY',
            'label': 'Варианты оплаты',
            'placeholder': 'Выберите ценовое предложение',
            'type': 'select',
            'value': null,
            'options': [],
            'errors': null
          }
        },
        optionsPricePeriod: {},
        errorEmptyPrice: 'Ценовое предложение не может быть пустым'
      };
    },
    props: {
      type: {
        type: String
      },
      pricePanelData: {
        type: Object,
        default: function _default() {
          return {};
        }
      }
    },
    computed: {
      productInfo: function productInfo() {
        return {
          id: this.product.id,
          basketId: this.product.basketId,
          giftId: this.product.giftId,
          priceId: this.computedPrice.id,
          count: this.product.initialValues.count,
          typeClient: this.filters.filterClient.value,
          typeTel: this.filters.filterTel.value,
          typePricePeriod: this.filters.filterPricePeriod.value,
          preorder: this.product.preorder
        };
      },
      computedPrice: function computedPrice() {
        var _this = this;

        var result;

        if (this.priceId) {
          result = this.product.prices.find(function (price) {
            return price.id == _this.priceId;
          });
        } else {
          result = {
            'priceTotal': {
              'value': 0,
              'currency': 'руб'
            },
            'priceFirst': {
              'value': 0,
              'currency': 'руб'
            },
            'pricePeriod': {
              'value': 0,
              'currency': 'руб',
              'unit': 'мес'
            }
          };
        }

        return result;
      },
      computedDisableBtn: function computedDisableBtn() {
        var _this$computedPrice;

        return this.product.availability.value == 'not-available' || (this === null || this === void 0 ? void 0 : (_this$computedPrice = this.computedPrice) === null || _this$computedPrice === void 0 ? void 0 : _this$computedPrice.disabled);
      }
    },
    watch: {
      pricePanelData: function pricePanelData() {
        this.product = this.pricePanelData; // сбор опций для фильтров из данных

        this.buildFilterOptionsData(); // установка подходящей под фильтры цены

        this.setPrice('init'); // только при первоначальной загрузке

        if (!this.initFilters) {
          this.initFilters = true;
        }
      },
      computedPrice: {
        immediate: true,
        handler: function handler(newValue) {
          this.$emit('active-price', newValue);
        }
      }
    },
    methods: _objectSpread2(_objectSpread2({}, mapActions({
      productUpdate: 'basket/update'
    })), {}, {
      // смена количества товара
      changeCount: function changeCount(count) {
        this.product.initialValues.count = count;
      },
      // сбор опций для фильтров из данных
      buildFilterOptionsData: function buildFilterOptionsData() {
        var _this2 = this;

        // сброс значений периода
        this.optionsPricePeriod = {}; // сбор опций

        this.product.prices.forEach(function (price) {
          if (price.client) {
            // добавляем если такого еще нет
            if (!~_this2.filters.filterClient.options.findIndex(function (option) {
              return option.value == price.client.value;
            })) {
              _this2.filters.filterClient.options.push(price.client);
            }
          }

          if (price.tel) {
            // добавляем если такого еще нет
            if (!~_this2.filters.filterTel.options.findIndex(function (option) {
              return option.value == price.tel.value;
            })) {
              _this2.filters.filterTel.options.push(price.tel);
            }
          }

          if (price.pricePeriod) {
            // опции рассрочки для комбинации типа клиента и типа номера телефона
            if (!_this2.optionsPricePeriod[price.client.value + price.tel.value]) {
              _this2.optionsPricePeriod[price.client.value + price.tel.value] = [];
            } // перестройка данных под селект


            var optionObject = {};
            optionObject.value = price.pricePeriod.period + ';' + price.pricePeriod.value;
            optionObject.price = price.pricePeriod.value;

            if (price.pricePeriod.period != '0') {
              optionObject.text = price.pricePeriod.period + ' ' + price.pricePeriod.unit + ' по' + ' ' + _this2.$options.filters.price(price.pricePeriod.value) + ' ' + price.pricePeriod.currency + '/' + price.pricePeriod.unit;
              optionObject.sort = price.pricePeriod.value;
            } else {
              // вычисление начального текста для единоразовой цены
              var discountPrice = _this2.product.prices.some(function (secondaryPrice) {
                return secondaryPrice.pricePeriod.period === price.pricePeriod.period && secondaryPrice.pricePeriod.value > price.pricePeriod.value;
              });

              var text = discountPrice ? 'Цена со скидкой ' : 'Полная цена ';
              optionObject.text = text + _this2.$options.filters.price(price.pricePeriod.value) + ' ' + price.pricePeriod.currency;
              optionObject.sort = 9999999999 + price.pricePeriod.value;
            }

            if (price.pricePeriod.note) {
              optionObject.text += '<small>' + price.pricePeriod.note + '</small>';
            }

            _this2.optionsPricePeriod[price.client.value + price.tel.value].push(optionObject);
          }
        }); // сортировка текста по убыванию

        function sortText(a, b) {
          if (b.value.toLowerCase() < a.value.toLowerCase()) return -1;else if (b.value.toLowerCase() > a.value.toLowerCase()) return 1;else return 0;
        } // сортировка опций


        this.filters.filterClient.options.sort(sortText);
        this.filters.filterTel.options.sort(sortText);

        for (var key in this.optionsPricePeriod) {
          this.optionsPricePeriod[key].sort(function (a, b) {
            return a.sort - b.sort;
          });
        } // установка опций и начальных значений для фильтров и цены


        this.setFilterValues('init');
      },
      // поиск и установка подходящей под фильтры цены и рассрочки
      setPrice: function setPrice(setFilterValuesTypeEvent) {
        var _this3 = this;

        this.priceId = null; // установка опций и начальных значений для фильтров и цены

        this.setFilterValues(setFilterValuesTypeEvent); // перебор цен

        this.product.prices.find(function (price, index) {
          var arrFiltersCheck = [];

          if (price.client) {
            if (price.client.value == _this3.filters.filterClient.value) arrFiltersCheck.push(true);else arrFiltersCheck.push(false);
          }

          if (price.tel) {
            if (price.tel.value == _this3.filters.filterTel.value) arrFiltersCheck.push(true);else arrFiltersCheck.push(false);
          }

          if (price.pricePeriod) {
            if (_this3.filters.filterPricePeriod.value && price.pricePeriod.period == _this3.filters.filterPricePeriod.value.slice(0, _this3.filters.filterPricePeriod.value.indexOf(';')) && price.pricePeriod.value == _this3.filters.filterPricePeriod.value.slice(_this3.filters.filterPricePeriod.value.indexOf(';') + 1)) {
              arrFiltersCheck.push(true);
            } else arrFiltersCheck.push(false);
          } // установка цены где все параметры совпали


          if (arrFiltersCheck.every(function (check) {
            return check;
          })) {
            _this3.priceId = price.id;
            return true;
          }
        });
        if (!this.priceId) console.log('not find price for product'); // сбрасываем ошибки у селекта периода если его значение задано

        if (this.computedPrice.pricePeriod && this.computedPrice.pricePeriod.period) {
          this.filters.filterPricePeriod.errors = null;
        }
      },
      // установка опций и начальных значений для фильтров и цены
      setFilterValues: function setFilterValues(typeEvent) {
        // обработка разных типов событий
        switch (typeEvent) {
          case 'init':
            this.priceId = this.product.initialValues.priceId;
            this.filters.filterClient.value = this.product.initialValues.filterClient;
            this.filters.filterTel.value = this.product.initialValues.filterTel;
            this.filters.filterPricePeriod.errors = [];

            if (this.computedPrice && this.computedPrice.pricePeriod && typeof this.computedPrice.pricePeriod.period == 'number' || this.computedPrice && this.computedPrice.pricePeriod && typeof this.computedPrice.pricePeriod.period == 'string') {
              this.filters.filterPricePeriod.value = this.computedPrice.pricePeriod.period + ';' + this.computedPrice.pricePeriod.value;
            } else {
              this.filters.filterPricePeriod.errors = [this.errorEmptyPrice];
            }

            if (this.optionsPricePeriod[this.filters.filterClient.value + this.filters.filterTel.value]) {
              this.filters.filterPricePeriod.options = this.optionsPricePeriod[this.filters.filterClient.value + this.filters.filterTel.value];
            } else {
              // если парметры инициализации типа клиента и номера не имеются в доступных ценовых предложениях устанавливаем активным первое ценовое предложение
              this.filters.filterClient.value = this.product.prices[0].client.value;
              this.filters.filterTel.value = this.product.prices[0].tel.value;
              this.filters.filterPricePeriod.options = this.optionsPricePeriod[this.filters.filterClient.value + this.filters.filterTel.value];

              if (!this.filters.filterPricePeriod.value && this.filters.filterPricePeriod.value !== 0) {
                this.filters.filterPricePeriod.errors = [this.errorEmptyPrice];
              }
            }

            this.setOptionsTelType();
            break;

          case 'typeClient':
            // при установго типа нового клиента ставим тим новый номер
            if (this.filters.filterClient.value === 'new') {
              this.filters.filterTel.value = 'new';
            }

          case 'typeTel':
            this.filters.filterPricePeriod.value = this.filters.filterPricePeriod.options[0].value;

            if (this.optionsPricePeriod[this.filters.filterClient.value + this.filters.filterTel.value]) {
              this.filters.filterPricePeriod.options = this.optionsPricePeriod[this.filters.filterClient.value + this.filters.filterTel.value];
            } else {
              console.log('нет ценовых предложений для текущего типа номера и клиента');
            } // при отсутствии совпадения текущего значения с обновленными опциями обнуляем выбор
            // if (!this.filters.filterPricePeriod.options.find((option) => option.value == this.filters.filterPricePeriod.value)) {
            // this.filters.filterPricePeriod.value = null
            // }


            break;

          case 'typePeriod':
            this.filters.filterPricePeriod.errors = null;
            break;
        }
      },
      // инициализация события наружу с текущими параметрами
      updateProductOptions: function updateProductOptions() {
        if (this.type == 'basket' && this.computedPrice) {
          this.productUpdate(this.productInfo).then(function () {
            return controller.basketUpdate();
          });
        }

        if (this.type == 'short' && this.computedPrice) {
          this.$emit('update-product-options', this.productInfo);
        }
      },
      // устанавливаем тип новый номер, если выбран тип новый клиент
      changeClientType: function changeClientType() {
        if (this.filters.filterClient.value == 'new') {
          this.filters.filterTel.value = 'new';
        }

        this.setOptionsTelType();
      },
      // собираем опции номера телефона доступные для указанного типа клиента
      setOptionsTelType: function setOptionsTelType() {
        var _this4 = this,
            _this$product$initial;

        this.filters.filterTel.options = [];
        this.product.prices.forEach(function (price) {
          if (price.client.value === _this4.filters.filterClient.value && !~_this4.filters.filterTel.options.findIndex(function (option) {
            return option.value == price.tel.value;
          })) {
            _this4.filters.filterTel.options.push(price.tel);
          }
        });
        this.filters.filterTel.value = (_this$product$initial = this.product.initialValues.filterTel) !== null && _this$product$initial !== void 0 ? _this$product$initial : this.filters.filterTel.options[0].value;
      },
      handlerPriceDetail: function handlerPriceDetail() {
        var _this5 = this;

        this.updateProductOptions();

        try {
          var _this$product;

          var item = (_this$product = this.product) === null || _this$product === void 0 ? void 0 : _this$product.prices.find(function (price) {
            var _price$pricePeriod, _price$pricePeriod2, _price$tel, _price$client;

            return ((_price$pricePeriod = price.pricePeriod) === null || _price$pricePeriod === void 0 ? void 0 : _price$pricePeriod.period) + ';' + ((_price$pricePeriod2 = price.pricePeriod) === null || _price$pricePeriod2 === void 0 ? void 0 : _price$pricePeriod2.value) === _this5.filters.filterPricePeriod.value && ((_price$tel = price.tel) === null || _price$tel === void 0 ? void 0 : _price$tel.value) === _this5.filters.filterTel.value && ((_price$client = price.client) === null || _price$client === void 0 ? void 0 : _price$client.value) === _this5.filters.filterClient.value;
          });

          if (item) {
            this.setUrlParam('price', item.id);
          }
        } catch (e) {
          console.log(e);
        }
      },
      setUrlParam: function setUrlParam(key, value) {
        var params = new URLSearchParams(window.location.search);
        params.set(key, value);
        var newUrl = window.location.origin + window.location.pathname + (Array.from(params.entries()).length ? '?' + params : '');
        window.history.replaceState(null, null, newUrl);
      }
    }),
    created: function created() {
      var _this6 = this;

      this.product = this.pricePanelData; // сбор опций для фильтров из данных

      this.buildFilterOptionsData(); // установка подходящей под фильтры цены

      this.setPrice('init'); // только при первоначальной загрузке

      if (!this.initFilters) {
        this.initFilters = true;
      }

      this.$on('change-count', function (count) {
        _this6.changeCount(count);

        _this6.updateProductOptions();
      });

      if (this.type == 'short') {
        this.updateProductOptions();
      }
    }
  };

  /* script */
  const __vue_script__$13 = script$13;

  /* template */
  var __vue_render__$Z = function () {
    var _obj, _obj$1;
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-price-panel price-panel",
        class: ((_obj = {}), (_obj["price-panel--" + _vm.type] = _vm.type), _obj),
      },
      [
        _vm.filters.filterClient && _vm.type != "short"
          ? _c(
              "div",
              {
                staticClass: "price-panel__filter-client flc",
                class:
                  ((_obj$1 = {}),
                  (_obj$1[
                    "price-panel__filter-client--" +
                      _vm.filters.filterClient.value
                  ] = _vm.filters.filterClient.value),
                  (_obj$1["price-panel__filter-client--single"] =
                    _vm.filters.filterClient.options.length == 1),
                  _obj$1),
              },
              [
                _c("v-field", {
                  attrs: { field: _vm.filters.filterClient },
                  on: {
                    input: function ($event) {
                      _vm.changeClientType();
                      _vm.setPrice("typeClient");
                      _vm.handlerPriceDetail();
                    },
                  },
                  model: {
                    value: _vm.filters.filterClient.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters.filterClient, "value", $$v);
                    },
                    expression: "filters.filterClient.value",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.filters.filterTel &&
        _vm.type != "short" &&
        _vm.filters.filterClient.value != "new"
          ? _c(
              "div",
              { staticClass: "price-panel__filter-phone flc" },
              [
                _c("v-field", {
                  attrs: { field: Object.assign({}, _vm.filters.filterTel) },
                  on: {
                    input: function ($event) {
                      _vm.setPrice("typeTel");
                      _vm.handlerPriceDetail();
                    },
                  },
                  model: {
                    value: _vm.filters.filterTel.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters.filterTel, "value", $$v);
                    },
                    expression: "filters.filterTel.value",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.type == "product" && _vm.computedPrice
          ? [
              _c(
                "div",
                { staticClass: "price-panel__price flc" },
                [
                  _vm.computedPrice.pricePeriod &&
                  _vm.computedPrice.pricePeriod.period != "0"
                    ? [
                        _vm.computedPrice.pricePeriod
                          ? _c(
                              "div",
                              { staticClass: "price-panel__price-main" },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.computedPrice.pricePeriod.value *
                                          _vm.product.initialValues.count
                                      )
                                    )
                                  ),
                                ]),
                                _c("sup", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.computedPrice.pricePeriod.currency
                                    ) +
                                      "/" +
                                      _vm._s(_vm.computedPrice.pricePeriod.unit)
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : [
                        _vm.computedPrice.priceTotal
                          ? _c(
                              "div",
                              { staticClass: "price-panel__price-main" },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.computedPrice.priceTotal.value *
                                          _vm.product.initialValues.count
                                      )
                                    )
                                  ),
                                ]),
                                _c("sup", [
                                  _vm._v(
                                    _vm._s(_vm.computedPrice.priceTotal.currency)
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm.computedPrice.priceOld
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "price-panel__price-main price-panel__price-main--old",
                              },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.computedPrice.priceOld.value *
                                          _vm.product.initialValues.count
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "sup",
                                  {
                                    staticClass:
                                      "price-panel__price-main-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceOld.currency
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                  _vm.computedPrice.priceFirst
                    ? _c("div", { staticClass: "price-panel__price-second" }, [
                        _c("b", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("price")(
                                  _vm.computedPrice.priceFirst.value *
                                    _vm.product.initialValues.count
                                )
                              ) +
                              " " +
                              _vm._s(_vm.computedPrice.priceFirst.currency)
                          ),
                        ]),
                        _c("span", [_vm._v(" первоначальный платеж")]),
                      ])
                    : _vm._e(),
                  _vm.computedPrice.pricePeriod &&
                  _vm.computedPrice.pricePeriod.period != "0"
                    ? [
                        _vm.computedPrice.priceTotal
                          ? _c(
                              "div",
                              { staticClass: "price-panel__price-second" },
                              [
                                _c("b", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(
                                          _vm.computedPrice.priceTotal.value *
                                            _vm.product.initialValues.count
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.computedPrice.priceTotal.currency
                                      )
                                  ),
                                ]),
                                _c("span", [_vm._v(" итоговая стоимость")]),
                              ]
                            )
                          : _vm._e(),
                        _vm.computedPrice.priceOld
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "price-panel__price-second price-panel__price-second--old",
                              },
                              [
                                _c("b", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(
                                          _vm.computedPrice.priceOld.value *
                                            _vm.product.initialValues.count
                                        )
                                      )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-second-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceOld.currency
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.computedPrice.priceNote
                ? _c(
                    "div",
                    { staticClass: "price-panel__note" },
                    [
                      _vm._v(_vm._s(_vm.computedPrice.priceNote)),
                      _vm.computedPrice.priceTip
                        ? _c("v-tooltip", {
                            attrs: { tooltip: _vm.computedPrice.priceTip },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          : _vm._e(),
        _vm.filters.filterPricePeriod.options &&
        _vm.filters.filterPricePeriod.options.length >= 1
          ? _c(
              "div",
              { staticClass: "price-panel__filter-pay" },
              [
                _c("v-field", {
                  attrs: {
                    field: Object.assign({}, _vm.filters.filterPricePeriod, {
                      label: _vm.filters.filterPricePeriod.label,
                    }),
                  },
                  on: {
                    input: function ($event) {
                      _vm.setPrice("typePeriod");
                      _vm.handlerPriceDetail();
                    },
                  },
                  model: {
                    value: _vm.filters.filterPricePeriod.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters.filterPricePeriod, "value", $$v);
                    },
                    expression: "filters.filterPricePeriod.value",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.type == "short" && _vm.computedPrice
          ? [
              _c(
                "div",
                { staticClass: "price-panel__price flc" },
                [
                  _vm.computedPrice.priceFirst
                    ? _c("div", { staticClass: "price-panel__price-second" }, [
                        _c("b", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("price")(
                                  _vm.computedPrice.priceFirst.value *
                                    _vm.product.initialValues.count
                                )
                              )
                          ),
                        ]),
                        _c(
                          "span",
                          { staticClass: "price-panel__price-second-currency" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.computedPrice.priceFirst.currency)
                            ),
                          ]
                        ),
                        _c("span", [_vm._v(" первоначальный платеж")]),
                      ])
                    : _vm._e(),
                  _vm.computedPrice.pricePeriod &&
                  _vm.computedPrice.pricePeriod.period != "0"
                    ? [
                        _vm.computedPrice.pricePeriod
                          ? _c(
                              "div",
                              { staticClass: "price-panel__price-main" },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.computedPrice.pricePeriod.value *
                                          _vm.product.initialValues.count
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-main-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.pricePeriod.currency
                                        )
                                    ),
                                  ]
                                ),
                                _c("span", [_vm._v(" ежемесячный платеж")]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : [
                        _vm.computedPrice.priceTotal
                          ? _c(
                              "div",
                              { staticClass: "price-panel__price-main" },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.computedPrice.priceTotal.value *
                                          _vm.product.initialValues.count
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-main-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceTotal.currency
                                        )
                                    ),
                                  ]
                                ),
                                _c("span", [_vm._v(" к оплате")]),
                              ]
                            )
                          : _vm._e(),
                        _vm.computedPrice.priceOld
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "price-panel__price-main price-panel__price-main--old",
                              },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.computedPrice.priceOld.value *
                                          _vm.product.initialValues.count
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-main-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceOld.currency
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                  _vm.computedPrice.pricePeriod &&
                  _vm.computedPrice.pricePeriod.period != "0"
                    ? [
                        _vm.computedPrice.priceTotal
                          ? _c(
                              "div",
                              { staticClass: "price-panel__price-second" },
                              [
                                _c("b", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(
                                          _vm.computedPrice.priceTotal.value *
                                            _vm.product.initialValues.count
                                        )
                                      )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-second-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceTotal.currency
                                        )
                                    ),
                                  ]
                                ),
                                _c("span", [_vm._v(" итоговая стоимость")]),
                              ]
                            )
                          : _vm._e(),
                        _vm.computedPrice.priceOld
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "price-panel__price-second price-panel__price-second--old",
                              },
                              [
                                _c("b", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(
                                          _vm.computedPrice.priceOld.value *
                                            _vm.product.initialValues.count
                                        )
                                      )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-second-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceOld.currency
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.computedPrice.priceNote
                ? _c(
                    "div",
                    { staticClass: "price-panel__note" },
                    [
                      _vm._v(_vm._s(_vm.computedPrice.priceNote)),
                      _vm.computedPrice.priceTip
                        ? _c("v-tooltip", {
                            attrs: { tooltip: _vm.computedPrice.priceTip },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          : _vm._e(),
        _vm.type == "basket" && _vm.computedPrice
          ? [
              _c(
                "div",
                { staticClass: "price-panel__price flc" },
                [
                  _vm.computedPrice.pricePeriod &&
                  _vm.computedPrice.pricePeriod.period != "0"
                    ? [
                        _vm.computedPrice.pricePeriod
                          ? _c(
                              "div",
                              { staticClass: "price-panel__price-main" },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.computedPrice.pricePeriod.value *
                                          _vm.product.initialValues.count
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-main-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.pricePeriod.currency
                                        )
                                    ),
                                  ]
                                ),
                                _c("span", [_vm._v(" ежемесячный платеж")]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : [
                        _vm.computedPrice.priceTotal
                          ? _c(
                              "div",
                              { staticClass: "price-panel__price-main" },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.computedPrice.priceTotal.value *
                                          _vm.product.initialValues.count
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-main-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceTotal.currency
                                        )
                                    ),
                                  ]
                                ),
                                _c("span", [_vm._v(" к оплате")]),
                              ]
                            )
                          : _vm._e(),
                        _vm.computedPrice.priceOld
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "price-panel__price-main price-panel__price-main--old",
                              },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.computedPrice.priceOld.value *
                                          _vm.product.initialValues.count
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-main-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceOld.currency
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                  _vm.computedPrice.priceFirst
                    ? _c("div", { staticClass: "price-panel__price-second" }, [
                        _c("b", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("price")(
                                  _vm.computedPrice.priceFirst.value *
                                    _vm.product.initialValues.count
                                )
                              )
                          ),
                        ]),
                        _c(
                          "span",
                          { staticClass: "price-panel__price-second-currency" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.computedPrice.priceFirst.currency)
                            ),
                          ]
                        ),
                        _c("span", [_vm._v(" первоначальный платеж")]),
                      ])
                    : _vm._e(),
                  _vm.computedPrice.pricePeriod &&
                  _vm.computedPrice.pricePeriod.period != "0"
                    ? [
                        _vm.computedPrice.priceTotal
                          ? _c(
                              "div",
                              { staticClass: "price-panel__price-second" },
                              [
                                _c("b", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(
                                          _vm.computedPrice.priceTotal.value *
                                            _vm.product.initialValues.count
                                        )
                                      )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-second-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceTotal.currency
                                        )
                                    ),
                                  ]
                                ),
                                _c("span", [_vm._v(" итоговая стоимость")]),
                              ]
                            )
                          : _vm._e(),
                        _vm.computedPrice.priceOld
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "price-panel__price-second price-panel__price-second--old",
                              },
                              [
                                _c("b", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(
                                          _vm.computedPrice.priceOld.value *
                                            _vm.product.initialValues.count
                                        )
                                      )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "price-panel__price-second-currency",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.computedPrice.priceOld.currency
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.computedPrice.priceNote
                ? _c(
                    "div",
                    { staticClass: "price-panel__note" },
                    [
                      _vm._v(_vm._s(_vm.computedPrice.priceNote)),
                      _vm.computedPrice.priceTip
                        ? _c("v-tooltip", {
                            attrs: { tooltip: _vm.computedPrice.priceTip },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.product.giftId
                ? _c(
                    "button",
                    {
                      staticClass:
                        "basket-item__gift-btn flc js-accordion__toggler",
                      attrs: { type: "button" },
                    },
                    [
                      _c("span", [_vm._v("Подарок")]),
                      _c(
                        "svg",
                        { staticClass: "svg-icon svg-icon--arrow-down" },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#svg-icon-arrow-down" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          : _vm._e(),
        _vm.type == "product" && _vm.computedPrice && !_vm.product.hide_button
          ? _c(
              "div",
              { staticClass: "price-panel__basket-action flc" },
              [
                _c("v-basket-action-big", {
                  attrs: {
                    productInfo: _vm.productInfo,
                    availability: _vm.product.availability,
                    price: _vm.computedPrice,
                    disabled: _vm.computedDisableBtn,
                    modalInputUnp: _vm.product.modalInputUnp,
                    basketLink: _vm.product.basketLink,
                  },
                  on: { "change-count": _vm.changeCount },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.type == "product" &&
        _vm.product.availability.value == "not-available" &&
        !_vm.product.hide_button
          ? _c("div", { staticClass: "price-panel__notice" }, [
              _vm._v("Нет в наличии в виртуальном магазине"),
            ])
          : _vm._e(),
        _vm.product.hide_button
          ? _c(
              "div",
              { staticClass: "price-panel__notice price-panel__notice--offline" },
              [
                _vm._v(
                  "*для покупки этого товара обращайтесь в ближайшие магазины А1"
                ),
              ]
            )
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$Z = [];
  __vue_render__$Z._withStripped = true;

    /* style */
    const __vue_inject_styles__$13 = undefined;
    /* scoped */
    const __vue_scope_id__$13 = undefined;
    /* module identifier */
    const __vue_module_identifier__$13 = undefined;
    /* functional template */
    const __vue_is_functional_template__$13 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$13 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$Z, staticRenderFns: __vue_staticRenderFns__$Z },
      __vue_inject_styles__$13,
      __vue_script__$13,
      __vue_scope_id__$13,
      __vue_is_functional_template__$13,
      __vue_module_identifier__$13,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$14 = {
    mixins: [__vue_component__$2, __vue_component__$I],
    data: function data() {
      return {
        basket: null
      };
    },
    computed: _objectSpread2(_objectSpread2({}, mapGetters({
      userUnpActive: 'user/userUnpActive',
      basketPrice: 'basket/basketPrice',
      basketEmpty: 'basket/basketEmpty',
      basketCount: 'basket/basketCount',
      basketLoading: 'basket/basketLoading'
    })), {}, {
      basketVuex: function basketVuex() {
        return this.$store.state.basket;
      }
    }),
    methods: {
      dataSet: function dataSet(data) {
        this.basket = data;
      },
      requestDataLoad: function requestDataLoad(dataSetOptions) {
        this.dataLoad({
          url: this.basket.remote,
          delay: false,
          data: {}
        }, dataSetOptions);
      }
    },
    created: function created() {
      controller.$on('basket-update', this.requestDataLoad);
    },
    updated: function updated() {
      var _this = this;

      this.$nextTick(function () {
        view.initAllLocal(); // переключение видимости залипающей общей цены товаров

        window.addEventListener('scroll', function () {
          if (window.innerHeight - 80 < _this.$refs.pays.getBoundingClientRect().top) {
            _this.$refs.pays.classList.add('fixed');
          } else {
            _this.$refs.pays.classList.remove('fixed');
          }
        });
      });
    }
  };

  /* script */
  const __vue_script__$14 = script$14;

  /* template */
  var __vue_render__$_ = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-basket-big basket-big",
        class: { "basket-big--empty": _vm.basketEmpty },
      },
      [
        _c("v-loader", { attrs: { loading: _vm.basketLoading || _vm.loading } }),
        _c(
          "transition",
          { attrs: { name: "message-toggle" } },
          [
            _vm.basket && _vm.basket.messages && _vm.basket.messages.length
              ? _c("v-message", {
                  attrs: { messages: _vm.basket.messages },
                  on: {
                    "update:messages": function ($event) {
                      return _vm.$set(_vm.basket, "messages", $event)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "basket-big__wrapper container" },
          [
            _vm.basketCount && _vm.basket
              ? [
                  _c("div", { staticClass: "basket-big__total-count" }, [
                    _vm._v("Всего позиций: " + _vm._s(_vm.basketCount)),
                  ]),
                  _vm.basket.items
                    ? _c("div", { staticClass: "basket-big__list" }, [
                        _c(
                          "div",
                          { staticClass: "basket-big__grid" },
                          _vm._l(_vm.basket.items, function (item) {
                            return _c(
                              "div",
                              { key: item.id, staticClass: "basket-big__cell" },
                              [
                                _c("v-basket-item", {
                                  attrs: {
                                    product: item,
                                    gift: _vm.basket.gifts.find(function (gift) {
                                      return gift.id == item.giftId
                                    }),
                                  },
                                  on: { "basket-update": _vm.requestDataLoad },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { ref: "pays", staticClass: "basket-big__pay-list-wrap" },
                    [
                      _vm.basket.payList
                        ? _c("div", { staticClass: "basket-big__pay-list" }, [
                            _vm.basket.payList.first
                              ? _c("div", { staticClass: "basket-big__first" }, [
                                  _c(
                                    "div",
                                    { staticClass: "basket-big__first-text" },
                                    [_vm._v("Первый взнос:")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "basket-big__first-pay" },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("price")(
                                              _vm.basket.payList.first.value
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.basket.payList.first.currency
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.basket.payList.total
                              ? _c("div", { staticClass: "basket-big__total" }, [
                                  _c(
                                    "div",
                                    { staticClass: "basket-big__total-text" },
                                    [_vm._v("Итого к оплате:")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "basket-big__total-price" },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("price")(
                                              _vm.basket.payList.total.value
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.basket.payList.total.currency
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm.basket.payList
                    ? _c("div", { staticClass: "basket-big__pay-list" }, [
                        _c("div", { staticClass: "basket-big__prices" }, [
                          _vm.basket.payList.first
                            ? _c("div", { staticClass: "basket-big__first" }, [
                                _c(
                                  "div",
                                  { staticClass: "basket-big__first-text" },
                                  [_vm._v("Итого к оплате (первым взносом):")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "basket-big__first-pay" },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("price")(
                                            _vm.basket.payList.first.value
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.basket.payList.first.currency
                                          )
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm.basket.payList.total
                          ? _c("div", { staticClass: "basket-big__total" }, [
                              _c(
                                "div",
                                { staticClass: "basket-big__total-text" },
                                [_vm._v("Общая стоимость заказа:")]
                              ),
                              _c(
                                "div",
                                { staticClass: "basket-big__total-price" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("price")(
                                          _vm.basket.payList.total.value
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.basket.payList.total.currency)
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm.basket.payList && _vm.basket.payList.pays
                    ? _c(
                        "div",
                        {
                          staticClass: "basket-big__pays accordion js-accordion",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "accordion__toggler js-accordion__toggler",
                            },
                            [
                              _c("span", [
                                _vm._v("Расчет платежей по рассрочке"),
                              ]),
                              _c(
                                "svg",
                                { staticClass: "svg-icon svg-icon--arrow-down" },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xlink:href": "#svg-icon-arrow-down",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "accordion__content js-accordion__content",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "key-value-list flc" },
                                _vm._l(_vm.basket.payList.pays, function (pay) {
                                  return _c(
                                    "div",
                                    {
                                      key: pay.id,
                                      staticClass: "key-value-list__item",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "key-value-list__item-bullet",
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "svg-icon svg-icon--list-bullet",
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    "#svg-icon-list-bullet",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "key-value-list__item-start",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(pay.period) +
                                              " - " +
                                              _vm._s(
                                                _vm._f("price")(pay.price.value)
                                              ) +
                                              " " +
                                              _vm._s(pay.price.currency)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.basket.submit
                    ? _c("div", { staticClass: "basket-big__submit" }, [
                        _vm.basket.submit.btn
                          ? _c("div", { staticClass: "basket-big__submit-btn" }, [
                              _vm.basket.submit.btn.disabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn--primary btn--disabled",
                                    },
                                    [_vm._v(_vm._s(_vm.basket.submit.btn.text))]
                                  )
                                : !_vm.basket.submit.btn.disabled &&
                                  _vm.userUnpActive
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn btn--primary",
                                      attrs: { href: _vm.basket.submit.btn.link },
                                    },
                                    [_vm._v(_vm._s(_vm.basket.submit.btn.text))]
                                  )
                                : !_vm.basket.submit.btn.disabled &&
                                  !_vm.userUnpActive
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn--primary js-open-modal",
                                      attrs: {
                                        type: "button",
                                        "data-modal-url":
                                          _vm.basket.submit.btn.modal,
                                        "data-modal-data":
                                          _vm.basket.submit.btn.modalData,
                                        "aria-label": "Оформить",
                                        title: "Оформить",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.basket.submit.btn.text))]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm.basket.submit.text
                          ? _c("div", {
                              staticClass: "basket-big__submit-message",
                              domProps: {
                                innerHTML: _vm._s(_vm.basket.submit.text),
                              },
                            })
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              : [
                  _vm.basket && _vm.basket.empty
                    ? _c("div", { staticClass: "basket-big__empty" }, [
                        _vm.basket.empty.text
                          ? _c("div", {
                              staticClass: "basket-big__empty-message",
                              domProps: {
                                innerHTML: _vm._s(_vm.basket.empty.text),
                              },
                            })
                          : _vm._e(),
                        _vm.basket.empty.btn
                          ? _c("div", { staticClass: "basket-big__empty-btn" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn--primary",
                                  attrs: {
                                    href: _vm.basket.empty.btn.link,
                                    title: _vm.basket.empty.btn.text,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.basket.empty.btn.text))]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
          ],
          2
        ),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$_ = [];
  __vue_render__$_._withStripped = true;

    /* style */
    const __vue_inject_styles__$14 = undefined;
    /* scoped */
    const __vue_scope_id__$14 = undefined;
    /* module identifier */
    const __vue_module_identifier__$14 = undefined;
    /* functional template */
    const __vue_is_functional_template__$14 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$14 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$_, staticRenderFns: __vue_staticRenderFns__$_ },
      __vue_inject_styles__$14,
      __vue_script__$14,
      __vue_scope_id__$14,
      __vue_is_functional_template__$14,
      __vue_module_identifier__$14,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$15 = {
    props: {
      product: {
        type: Object,
        default: null
      },
      gift: {
        type: Object,
        default: null
      }
    },
    computed: {
      basket: function basket() {
        return this.$store.state.basket;
      },
      computedMaxCount: function computedMaxCount() {
        if (this.product.availability.value === 'available') {
          return this.product.availability.quantity;
        } else if (this.product.availability.value === 'wait-order' || this.product.availability.value === 'order') {
          return 999;
        } else {
          return 0;
        }
      }
    },
    methods: {
      changeCount: function changeCount() {
        this.$refs.panel.$emit('change-count', this.product.initialValues.count);
      },
      removeProduct: function removeProduct() {
        controller.openModal({
          className: 'modal--sm  modal--no-header',
          historyUrl: 'remove-product-' + this.product.basketId,
          component: {
            name: 'v-remove-product',
            props: {
              dataSource: {
                id: this.product.id,
                name: this.product.name,
                basketId: this.product.basketId
              }
            }
          }
        });
      }
    },
    mounted: function mounted() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.gift) {
          view.initAllLocal();
        }
      });
    },
    updated: function updated() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.gift) {
          view.initAllLocal();
        }
      });
    }
  };

  /* script */
  const __vue_script__$15 = script$15;

  /* template */
  var __vue_render__$$ = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-basket-item basket-item accordion js-accordion" },
      [
        _vm.product
          ? _c("div", { staticClass: "basket-item__card" }, [
              _vm.product.link
                ? _c("a", {
                    staticClass: "basket-item__link",
                    attrs: { href: _vm.product.link },
                  })
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "basket-item__remove",
                  on: { click: _vm.removeProduct },
                },
                [
                  _c("svg", { staticClass: "svg-icon svg-icon--garbage" }, [
                    _c("use", { attrs: { "xlink:href": "#svg-icon-garbage" } }),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "basket-item__cell-visual basket-item__cell-visual--desktop",
                },
                [
                  _c(
                    "div",
                    { staticClass: "basket-item__visual flc" },
                    [
                      _c("v-product-image", {
                        staticClass: "basket-item__image",
                        attrs: { src: _vm.product.image },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("div", { staticClass: "basket-item__cell-info" }, [
                _vm.product.category
                  ? _c("div", { staticClass: "basket-item__category flc" }, [
                      _vm._v(_vm._s(_vm.product.category)),
                    ])
                  : _vm._e(),
                _vm.product.name
                  ? _c("h4", { staticClass: "basket-item__name flc" }, [
                      _vm.product.link
                        ? _c(
                            "a",
                            {
                              attrs: { href: _vm.product.link, target: "_blank" },
                            },
                            [_vm._v(_vm._s(_vm.product.name))]
                          )
                        : _c("span", [_vm._v(_vm._s(_vm.product.name))]),
                    ])
                  : _vm._e(),
                _vm.product.availability && _vm.product.availability.text
                  ? _c("div", { staticClass: "basket-item__status flc" }, [
                      _vm._v(_vm._s(_vm.product.availability.text)),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "basket-item__cell-visual basket-item__cell-visual--mobile",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "basket-item__visual flc" },
                      [
                        _c("v-product-image", {
                          staticClass: "basket-item__image",
                          attrs: { src: _vm.product.image },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm.product.availability
                  ? _c(
                      "div",
                      { staticClass: "basket-item__counter flc" },
                      [
                        _c("v-field", {
                          attrs: {
                            field: {
                              type: "count",
                              min: 1,
                              max: _vm.computedMaxCount,
                            },
                          },
                          on: { input: _vm.changeCount },
                          model: {
                            value: _vm.product.initialValues.count,
                            callback: function ($$v) {
                              _vm.$set(_vm.product.initialValues, "count", $$v);
                            },
                            expression: "product.initialValues.count",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.product.availability
                  ? _c(
                      "div",
                      { staticClass: "basket-item__avail flc" },
                      [
                        _c("v-availability", {
                          attrs: { availability: _vm.product.availability },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.gift
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "basket-item__gift-btn flc js-accordion__toggler",
                        attrs: { type: "button" },
                      },
                      [
                        _c("span", [_vm._v("Подарок")]),
                        _c(
                          "svg",
                          { staticClass: "svg-icon svg-icon--arrow-down" },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#svg-icon-arrow-down" },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm.product.prices && _vm.product.prices.length
                ? _c(
                    "div",
                    { staticClass: "basket-item__cell-price-action" },
                    [
                      _c("v-price-panel", {
                        ref: "panel",
                        attrs: {
                          "price-panel-data": _vm.product,
                          type: "basket",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm.gift
          ? _c(
              "div",
              { staticClass: "accordion__content js-accordion__content" },
              [
                _c(
                  "div",
                  { staticClass: "basket-item__card basket-item__card--gift" },
                  [
                    _vm.gift.link
                      ? _c("a", {
                          staticClass: "basket-item__link",
                          attrs: { href: _vm.gift.link },
                        })
                      : _vm._e(),
                    _c("div", { staticClass: "basket-item__cell-visual" }, [
                      _c(
                        "div",
                        { staticClass: "basket-item__visual flc" },
                        [
                          _c("v-product-image", {
                            staticClass: "basket-item__image",
                            attrs: { src: _vm.gift.image },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "basket-item__cell-info" }, [
                      _vm.gift.category
                        ? _c(
                            "div",
                            { staticClass: "basket-item__category flc" },
                            [_vm._v(_vm._s(_vm.gift.category))]
                          )
                        : _vm._e(),
                      _vm.gift.name
                        ? _c("h4", { staticClass: "basket-item__name flc" }, [
                            _vm._v(_vm._s(_vm.gift.name)),
                          ])
                        : _vm._e(),
                      _vm.gift.availability && _vm.gift.availability.text
                        ? _c("div", { staticClass: "basket-item__status flc" }, [
                            _vm._v(_vm._s(_vm.gift.availability.text)),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]
    )
  };
  var __vue_staticRenderFns__$$ = [];
  __vue_render__$$._withStripped = true;

    /* style */
    const __vue_inject_styles__$15 = undefined;
    /* scoped */
    const __vue_scope_id__$15 = undefined;
    /* module identifier */
    const __vue_module_identifier__$15 = undefined;
    /* functional template */
    const __vue_is_functional_template__$15 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$15 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$$, staticRenderFns: __vue_staticRenderFns__$$ },
      __vue_inject_styles__$15,
      __vue_script__$15,
      __vue_scope_id__$15,
      __vue_is_functional_template__$15,
      __vue_module_identifier__$15,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  var script$16 = {
    data: function data() {
      return {
        localValue: null
      };
    },
    props: {
      field: {
        default: null
      },
      link: {
        default: null
      },
      value: {
        default: null
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        return this.field.options.slice().sort(function (a, b) {
          return a.sort - b.sort;
        });
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$16 = script$16;

  /* template */
  var __vue_render__$10 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-product-colors" },
      _vm._l(_vm.computedOptions, function (option, index) {
        return _vm.field
          ? _c(
              "div",
              {
                key: option.value + "-" + index,
                staticClass: "product-colors__item",
                class: {
                  "product-colors__item--active": _vm.localValue === option.value,
                },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "product-colors__item-link",
                    attrs: { href: _vm.link },
                    on: {
                      mouseenter: function ($event) {
                        _vm.localValue = option.value;
                        _vm.handleInput();
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "product-colors__item-color",
                      style: { background: option.value },
                    }),
                  ]
                ),
              ]
            )
          : _vm._e()
      }),
      0
    )
  };
  var __vue_staticRenderFns__$10 = [];
  __vue_render__$10._withStripped = true;

    /* style */
    const __vue_inject_styles__$16 = undefined;
    /* scoped */
    const __vue_scope_id__$16 = undefined;
    /* module identifier */
    const __vue_module_identifier__$16 = undefined;
    /* functional template */
    const __vue_is_functional_template__$16 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$16 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$10, staticRenderFns: __vue_staticRenderFns__$10 },
      __vue_inject_styles__$16,
      __vue_script__$16,
      __vue_scope_id__$16,
      __vue_is_functional_template__$16,
      __vue_module_identifier__$16,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  var script$17 = {
    data: function data() {
      return {
        localValue: null,
        open: false
      };
    },
    props: {
      field: {
        default: null
      },
      link: {
        default: null
      },
      value: {
        default: null
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        return this.field.options.slice().sort(function (a, b) {
          return a.sort - b.sort;
        });
      }
    },
    watch: {
      value: function value() {
        this.updateLocalValue();
      }
    },
    methods: {
      updateLocalValue: function updateLocalValue() {
        this.localValue = this.value;
      },
      handleInput: function handleInput() {
        this.$emit('input', this.localValue);
      }
    },
    created: function created() {
      this.updateLocalValue();
    }
  };

  /* script */
  const __vue_script__$17 = script$17;

  /* template */
  var __vue_render__$11 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-switch product-switch" }, [
      _c(
        "div",
        { staticClass: "product-switch__list" },
        _vm._l(_vm.computedOptions, function (option, index) {
          return _vm.field
            ? _c(
                "div",
                {
                  key: option.value + "-" + index,
                  staticClass: "product-switch__item",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "product-switch__btn",
                      class: {
                        "product-switch__btn--active":
                          _vm.localValue === option.value,
                      },
                      on: {
                        mouseenter: function ($event) {
                          _vm.localValue = option.value;
                          _vm.handleInput();
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "product-switch__link",
                          attrs: { href: _vm.link },
                        },
                        [_vm._v(_vm._s(option.text))]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e()
        }),
        0
      ),
    ])
  };
  var __vue_staticRenderFns__$11 = [];
  __vue_render__$11._withStripped = true;

    /* style */
    const __vue_inject_styles__$17 = undefined;
    /* scoped */
    const __vue_scope_id__$17 = undefined;
    /* module identifier */
    const __vue_module_identifier__$17 = undefined;
    /* functional template */
    const __vue_is_functional_template__$17 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$17 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$11, staticRenderFns: __vue_staticRenderFns__$11 },
      __vue_inject_styles__$17,
      __vue_script__$17,
      __vue_scope_id__$17,
      __vue_is_functional_template__$17,
      __vue_module_identifier__$17,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$18 = {
    data: function data() {
      return {
        localChecked: []
      };
    },
    props: {
      id: {
        type: [String, Number],
        default: null
      },
      name: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      comparePresentByItem: function comparePresentByItem() {
        return this.$store.getters['compare/comparePresentByItem'](this.id);
      },
      compareItems: function compareItems() {
        return this.$store.getters['compare/items'];
      },
      compareCount: function compareCount() {
        return this.$store.getters['compare/compareCount'];
      }
    },
    watch: {
      compareItems: {
        immediate: true,
        handler: function handler() {
          this.localChecked = this.comparePresentByItem ? [true] : [];
        }
      },
      id: {
        immediate: true,
        handler: function handler() {
          this.localChecked = this.comparePresentByItem ? [true] : [];
        }
      }
    },
    methods: {
      setCompare: function setCompare() {
        var _this = this;

        if (this.localChecked.length) {
          if (this.compareCount < 3) {
            this.$store.dispatch('compare/add', {
              id: this.id
            }).then(function () {
              controller.addCompareItem({
                id: _this.id,
                name: _this.name
              });
            });
          } else {
            controller.addCompareMax();
            setTimeout(function () {
              _this.localChecked = [];
            }, 500);
          }
        } else {
          this.$store.dispatch('compare/remove', {
            id: this.id
          }).then(function () {
            controller.removeCompareItem({
              id: _this.id,
              name: _this.name
            });
          });
        }
      }
    },
    created: function created() {
      var _this2 = this;

      this.localChecked = this.comparePresentByItem ? [true] : [];
      controller.$on('clear-compare', function () {
        _this2.localChecked = [];
      });
    }
  };

  /* script */
  const __vue_script__$18 = script$18;

  /* template */
  var __vue_render__$12 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-comapare-action compare-action" },
      [
        _c("v-field", {
          attrs: {
            field: {
              type: "check-list",
              options: [{ value: true, text: "Добавить в сравнение" }],
              disabled: _vm.disabled,
            },
          },
          on: { input: _vm.setCompare },
          model: {
            value: _vm.localChecked,
            callback: function ($$v) {
              _vm.localChecked = $$v;
            },
            expression: "localChecked",
          },
        }),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$12 = [];
  __vue_render__$12._withStripped = true;

    /* style */
    const __vue_inject_styles__$18 = undefined;
    /* scoped */
    const __vue_scope_id__$18 = undefined;
    /* module identifier */
    const __vue_module_identifier__$18 = undefined;
    /* functional template */
    const __vue_is_functional_template__$18 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$18 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$12, staticRenderFns: __vue_staticRenderFns__$12 },
      __vue_inject_styles__$18,
      __vue_script__$18,
      __vue_scope_id__$18,
      __vue_is_functional_template__$18,
      __vue_module_identifier__$18,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$19 = {
    data: function data() {
      return {
        comparePanel: null
      };
    },
    props: {
      id: {
        default: null
      }
    },
    computed: {},
    watch: {},
    methods: {}
  };

  /* script */
  const __vue_script__$19 = script$19;

  /* template */
  var __vue_render__$13 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-comapare-panel" }, [
      _c("div", { staticClass: "compare-panel" }, [
        _c("a", { staticClass: "compare-panel__link", attrs: { href: "#" } }, [
          _c("div", { staticClass: "compare-panel__content" }, [
            _c("span", [_vm._v("Перейти к сравнению 1 /3")]),
            _c("button", { staticClass: "compare-panel__button-remove" }, [
              _c("svg", { staticClass: "svg-icon compare-panel__icon" }, [
                _c("use", { attrs: { "xlink:href": "#svg-icon-cart" } }),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  };
  var __vue_staticRenderFns__$13 = [];
  __vue_render__$13._withStripped = true;

    /* style */
    const __vue_inject_styles__$19 = undefined;
    /* scoped */
    const __vue_scope_id__$19 = undefined;
    /* module identifier */
    const __vue_module_identifier__$19 = undefined;
    /* functional template */
    const __vue_is_functional_template__$19 = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$19 = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$13, staticRenderFns: __vue_staticRenderFns__$13 },
      __vue_inject_styles__$19,
      __vue_script__$19,
      __vue_scope_id__$19,
      __vue_is_functional_template__$19,
      __vue_module_identifier__$19,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1a = {
    mixins: [__vue_component__$2, __vue_component__$I],
    data: function data() {
      return {
        localFormData: new FormData(),
        order: null,
        localCount: 0,
        enableSubmit: false
      };
    },
    computed: _objectSpread2(_objectSpread2({}, mapGetters({
      basketItems: 'basket/basketItems'
    })), {}, {
      basketCountByItems: function basketCountByItems() {
        var result = 0;

        if (this.basketItems && this.basketItems.length) {
          result = this.basketItems.reduce(function (summ, item) {
            return summ + (item.count || 0);
          }, 0);
        }

        return result;
      },
      // выбранный тип доставки
      computedTypeDelivery: function computedTypeDelivery() {
        var _this$order, _this$order$fields;

        var orderField = (_this$order = this.order) === null || _this$order === void 0 ? void 0 : (_this$order$fields = _this$order.fields) === null || _this$order$fields === void 0 ? void 0 : _this$order$fields.find(function (field) {
          return field.id == 'FIELD_DELIVERY';
        });
        return orderField.options.find(function (option) {
          return option.value == orderField.value;
        }).text;
      },
      // введенное название организации
      computedNamePayer: function computedNamePayer() {
        var _this$order2, _this$order2$fields;

        return (_this$order2 = this.order) === null || _this$order2 === void 0 ? void 0 : (_this$order2$fields = _this$order2.fields) === null || _this$order2$fields === void 0 ? void 0 : _this$order2$fields.find(function (field) {
          return field.id == 'FIELD_NAME_PAYER';
        }).value;
      },
      // введенное название организации
      computedUnp: function computedUnp() {
        var _this$order3, _this$order3$fields;

        return (_this$order3 = this.order) === null || _this$order3 === void 0 ? void 0 : (_this$order3$fields = _this$order3.fields) === null || _this$order3$fields === void 0 ? void 0 : _this$order3$fields.find(function (field) {
          return field.id == 'FIELD_UNP';
        }).value;
      }
    }),
    methods: {
      dataSet: function dataSet(data) {
        var _this = this;

        this.order = data;
        this.checkAgree();
        this.$nextTick(function () {
          var fieldsWithErrors = _this.order.fields.filter(function (field) {
            return field.errors && field.errors.length;
          });

          if (fieldsWithErrors.length) {
            _this.openAccordionsWithErrors();

            setTimeout(function () {
              animate({
                duration: 1000,
                timing: function timing(timeFraction) {
                  return timeFraction;
                },
                // линейная функция значит, что анимация идёт с одной и той же скоростью
                draw: function draw(progress) {
                  document.documentElement.scrollTop += Math.round(document.querySelector('.field.form-error').getBoundingClientRect().top * progress);
                }
              });
            }, 300);
          }
        });

        if (data.modal) {
          controller.openModal(_objectSpread2({
            url: data.modal
          }, data.modalData));
        }
      },
      autoSubmitField: function autoSubmitField(field) {
        // при наличии параметра у поля отправляем форму
        if (field.autosubmit) {
          this.submitForm('autosubmit');
        }
      },
      submitForm: function submitForm(action) {
        var _this2 = this;

        this.localFormData.set('state[action]', action || 'submit');
        this.localFormData.set('bxajaxid', this.bxajaxid);
        this.order.fields.forEach(function (field) {
          _this2.localFormData.set(field.name, field.value);
        });
        this.order.items.forEach(function (item) {
          var _item$bank;

          if (item !== null && item !== void 0 && (_item$bank = item.bank) !== null && _item$bank !== void 0 && _item$bank.field) {
            var _item$bank2, _item$bank3;

            _this2.localFormData.set(item === null || item === void 0 ? void 0 : (_item$bank2 = item.bank) === null || _item$bank2 === void 0 ? void 0 : _item$bank2.field.name, item === null || item === void 0 ? void 0 : (_item$bank3 = item.bank) === null || _item$bank3 === void 0 ? void 0 : _item$bank3.field.value);
          }
        });
        this.dataLoad({
          url: this.order.remote,
          data: this.localFormData,
          delay: true
        });
      },
      checkAgree: function checkAgree() {
        var result = this.order.fields.filter(function (field) {
          return field.id == 'FIELD_AGREE_CONTRACT' || field.id == 'FIELD_AGREE';
        });
        this.enableSubmit = result.every(function (field) {
          return field.value;
        });
      },
      openAccordion: function openAccordion(accordionId) {
        window.dataStorage.get(document.querySelector(accordionId), 'open')();
      },
      openAccordionsWithErrors: function openAccordionsWithErrors() {
        var about = document.querySelector('#about');

        if (about && about.querySelectorAll('.field__errors').length && window.dataStorage.get(document.querySelector('#about'), 'open')) {
          window.dataStorage.get(document.querySelector('#about'), 'open')();
        }

        var delivery = document.querySelector('#delivery');

        if (delivery && delivery.querySelectorAll('.field__errors').length && window.dataStorage.get(delivery, 'open')) {
          window.dataStorage.get(delivery, 'open')();
        }
      },
      handleInput: function handleInput(value, field) {//if (value) {
        //field.errors = null
        //}
      },
      changeUnp: function changeUnp() {
        controller.openModal({
          url: this.order.changeUnpModal,
          className: 'modal--sm'
        });
      }
    },
    mounted: function mounted() {
      this.$nextTick(function () {
        view.initAllLocal();
      });
    },
    updated: function updated() {
      this.$nextTick(function () {
        view.initAllLocal();
      });
    }
  };

  /* script */
  const __vue_script__$1a = script$1a;

  /* template */
  var __vue_render__$14 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-order order" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _c(
          "div",
          { staticClass: "container" },
          [
            !_vm.order
              ? [_c("div", { staticClass: "order__placeholder" })]
              : _vm._e(),
            _vm.order
              ? [
                  _c("div", { staticClass: "page-content" }, [
                    _c("div", { staticClass: "page-content__center" }, [
                      _c(
                        "div",
                        {
                          ref: "items",
                          staticClass:
                            "page-content__section accordion open-accordion js-accordion",
                          attrs: { id: "items" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "page-content__section-header" },
                            [
                              _c("h4", { staticClass: "flc" }, [
                                _vm._v("Состав заказа"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "link accordion__toggler js-accordion__toggler",
                                },
                                [
                                  _c("div", { staticClass: "accordion__open" }, [
                                    _vm._v("Развернуть"),
                                  ]),
                                  _c("div", { staticClass: "accordion__close" }, [
                                    _vm._v("Свернуть"),
                                  ]),
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon svg-icon--arrow-down accordion__toggler-arrow-down",
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#svg-icon-arrow-down",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "accordion__content js-accordion__content",
                            },
                            [
                              _vm.order.items
                                ? _c(
                                    "div",
                                    { staticClass: "order-items" },
                                    _vm._l(_vm.order.items, function (item) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "order-items__item order-item flc",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "order-item__visual" },
                                            [
                                              item.image || item.imageSources
                                                ? _c("v-image", {
                                                    attrs: {
                                                      src: item.image,
                                                      sources: item.imageSources,
                                                      alt: item.name,
                                                      title: item.name,
                                                    },
                                                  })
                                                : _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "svg-icon order-item__svg",
                                                    },
                                                    [
                                                      _c("use", {
                                                        attrs: {
                                                          "xlink:href":
                                                            "#svg-icon-no-photo",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "order-item__content",
                                            },
                                            [
                                              item.name
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order-item__title h4",
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  )
                                                : _vm._e(),
                                              _c("div", {
                                                staticClass:
                                                  "order-item__month-installment",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    item.price.monthInstallment
                                                  ),
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "order-item__price",
                                                },
                                                [
                                                  item.price.firstPrice
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order-item__price-item flc",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order-item__group-title-key",
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "price"
                                                                    )(
                                                                      item.price
                                                                        .firstPrice
                                                                        .value
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.price
                                                                      .firstPrice
                                                                      .currency
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order-item__group-title-value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " первоначальный платеж"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  item.price.totalPrice
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order-item__price-item flc",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order-item__group-title-key",
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "price"
                                                                    )(
                                                                      item.price
                                                                        .totalPrice
                                                                        .value
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.price
                                                                      .totalPrice
                                                                      .currency
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          !item.price.firstPrice
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "order-item__group-title-value",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " к оплате"
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "order-item__group-title-value",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " итоговая стоимость"
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              item.bank
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order-item__bank",
                                                    },
                                                    [
                                                      item.bank.title
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "order-item__bank-title",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.bank.title
                                                                )
                                                              ),
                                                              item.bank.require
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "order-item__bank-require",
                                                                    },
                                                                    [_vm._v("*")]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      item.bank.text
                                                        ? _c("div", {
                                                            staticClass:
                                                              "order-item__bank-text",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                item.bank.text
                                                              ),
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      item.bank.field
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "oder-item__bank-field",
                                                            },
                                                            [
                                                              _c("v-field", {
                                                                attrs: {
                                                                  field:
                                                                    item.bank
                                                                      .field,
                                                                },
                                                                on: {
                                                                  input:
                                                                    _vm.checkAgree,
                                                                },
                                                                model: {
                                                                  value:
                                                                    item.bank
                                                                      .field
                                                                      .value,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item.bank
                                                                          .field,
                                                                        "value",
                                                                        $$v
                                                                      );
                                                                    },
                                                                  expression:
                                                                    "item.bank.field.value",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "form__main flc fcc" }, [
                        _c(
                          "div",
                          { staticClass: "form__groups" },
                          _vm._l(_vm.order.groups, function (group) {
                            return _c(
                              "div",
                              {
                                key: group.id,
                                ref: group.id,
                                refInFor: true,
                                staticClass:
                                  "form__group page-content__section flc accordion open-accordion js-accordion",
                                style: { width: group.width || null },
                                attrs: { id: group.id },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "page-content__section-header" },
                                  [
                                    group.title
                                      ? _c(
                                          "h4",
                                          {
                                            staticClass: "form__group-title flc",
                                          },
                                          [_vm._v(_vm._s(group.title))]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "link accordion__toggler js-accordion__toggler",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "accordion__open" },
                                          [_vm._v("Развернуть")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "accordion__close" },
                                          [_vm._v("Свернуть")]
                                        ),
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "svg-icon svg-icon--arrow-down accordion__toggler-arrow-down",
                                          },
                                          [
                                            _c("use", {
                                              attrs: {
                                                "xlink:href":
                                                  "#svg-icon-arrow-down",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "accordion__content js-accordion__content",
                                  },
                                  [
                                    _vm.order.pay.groupId === group.id
                                      ? _c("div", { staticClass: "form__pay" }, [
                                          _vm._m(0, true),
                                          _c(
                                            "div",
                                            { staticClass: "form__pay-cashless" },
                                            [
                                              _c("b", [_vm._v("Способ оплаты:")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.order.pay.cashless)
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form__group-body",
                                        class: {
                                          "form__group-body--no-bg":
                                            group.id === "advanced",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form__fields" },
                                          [
                                            _vm._l(
                                              _vm.order.fields,
                                              function (field, index) {
                                                return field.groupId === group.id
                                                  ? [
                                                      _c(
                                                        "div",
                                                        {
                                                          key: field.id,
                                                          staticClass:
                                                            "form__field",
                                                          style: {
                                                            width:
                                                              field.width || null,
                                                          },
                                                        },
                                                        [
                                                          field.type ==
                                                            "radio-blocks" ||
                                                          field.type ==
                                                            "select" ||
                                                          field.type == "tooltip"
                                                            ? _c("v-field", {
                                                                attrs: {
                                                                  field: field,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.autoSubmitField(
                                                                        field
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    field.value,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        field,
                                                                        "value",
                                                                        $$v
                                                                      );
                                                                    },
                                                                  expression:
                                                                    "field.value",
                                                                },
                                                              })
                                                            : _c("v-field", {
                                                                attrs: {
                                                                  field: field,
                                                                },
                                                                on: {
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.autoSubmitField(
                                                                      field
                                                                    )
                                                                  },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleInput(
                                                                        $event,
                                                                        field
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    field.value,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        field,
                                                                        "value",
                                                                        $$v
                                                                      );
                                                                    },
                                                                  expression:
                                                                    "field.value",
                                                                },
                                                              }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : _vm._e()
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.order.fields,
                                      function (field, index) {
                                        return field.groupId === "save" &&
                                          group.id === "about"
                                          ? [
                                              _c("v-field", {
                                                attrs: { field: field },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.autoSubmitField(
                                                      field
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.handleInput(
                                                      $event,
                                                      field
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: field.value,
                                                  callback: function ($$v) {
                                                    _vm.$set(field, "value", $$v);
                                                  },
                                                  expression: "field.value",
                                                },
                                              }),
                                            ]
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "page-content-aside page-content-aside--right",
                      },
                      [
                        _c("div", { staticClass: "order-aside" }, [
                          _c("h4", { staticClass: "order-aside__title" }, [
                            _vm._v("Информация о заказе"),
                          ]),
                          _c("div", { staticClass: "order-aside__content" }, [
                            _c("div", { staticClass: "order-aside__group" }, [
                              _c(
                                "div",
                                { staticClass: "order-aside__group-title" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "order-aside__group-title-key",
                                    },
                                    [_vm._v("Товаров: ")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "order-aside__group-title-value",
                                    },
                                    [_vm._v(_vm._s(_vm.basketCountByItems))]
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "order-aside__price" }, [
                                _vm.order.price.firstPrice
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "order-aside__price-item flc",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "order-aside__group-title-key",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("price")(
                                                  _vm.order.price.firstPrice.value
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "order-aside__group-title-value",
                                          },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                "  " +
                                                  _vm._s(
                                                    _vm.order.price.firstPrice
                                                      .currency
                                                  )
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.order.price.firstPrice
                                                    .postFix
                                                )
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                " итого к оплате (первым взносом)"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.order.price.totalPrice
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "order-aside__price-item flc",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "order-aside__group-title-key",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("price")(
                                                  _vm.order.price.totalPrice.value
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "order-aside__group-title-value",
                                          },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                "  " +
                                                  _vm._s(
                                                    _vm.order.price.totalPrice
                                                      .currency
                                                  )
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.order.price.totalPrice
                                                    .postFix
                                                )
                                            ),
                                            _c("span", [
                                              _vm._v(" общая стоимость заказа"),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _c(
                                "a",
                                {
                                  staticClass: "order-aside__changed-link",
                                  attrs: { href: _vm.order.price.linkBasket },
                                },
                                [
                                  _vm._v("Изменить"),
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon svg-icon--arrow-right",
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#svg-icon-arrow-right",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "order-aside__group" }, [
                              _c(
                                "div",
                                { staticClass: "order-aside__group-title" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "order-aside__group-title-key",
                                    },
                                    [_vm._v("Способ доставки:")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "order-aside__group-title-value",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.computedTypeDelivery)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "order-aside__changed-link js-scroll-to",
                                  attrs: { href: "#delivery" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openAccordion("#delivery")
                                    },
                                  },
                                },
                                [
                                  _vm._v("Изменить"),
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon svg-icon--arrow-right",
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#svg-icon-arrow-right",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "order-aside__group" }, [
                              _c(
                                "div",
                                { staticClass: "order-aside__group-title" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "order-aside__group-title-key",
                                    },
                                    [_vm._v("Организация: ")]
                                  ),
                                  _vm.computedNamePayer
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "order-aside__group-title-value",
                                        },
                                        [_vm._v(_vm._s(_vm.computedNamePayer))]
                                      )
                                    : _vm._e(),
                                  _vm.computedUnp
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "order-aside__group-title-value",
                                        },
                                        [
                                          _vm._v(
                                            "УНП: " + _vm._s(_vm.computedUnp)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "order-aside__changed-link js-scroll-to",
                                  on: { click: _vm.changeUnp },
                                },
                                [
                                  _vm._v("Изменить"),
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon svg-icon--arrow-right",
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#svg-icon-arrow-right",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm.enableSubmit
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn--primary btn--full-width order-aside__btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.submitForm("submit")
                                      },
                                    },
                                  },
                                  [_vm._v("Оформить заказ")]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn--primary btn--disabled btn--full-width order-aside__btn",
                                    attrs: { type: "button" },
                                  },
                                  [_vm._v("Оформить заказ")]
                                ),
                            _c(
                              "div",
                              { staticClass: "order-aside__agree" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "order-aside__agree-text" },
                                  [_vm._v("Нажимая кнопку «Оформить заказ»")]
                                ),
                                _vm._l(_vm.order.fields, function (field) {
                                  return field.id == "FIELD_AGREE"
                                    ? _c("v-field", {
                                        attrs: { field: field },
                                        on: { input: _vm.checkAgree },
                                        model: {
                                          value: field.value,
                                          callback: function ($$v) {
                                            _vm.$set(field, "value", $$v);
                                          },
                                          expression: "field.value",
                                        },
                                      })
                                    : _vm._e()
                                }),
                                _vm._l(_vm.order.fields, function (field) {
                                  return field.id == "FIELD_AGREE_CONTRACT"
                                    ? _c("v-field", {
                                        attrs: { field: field },
                                        on: { input: _vm.checkAgree },
                                        model: {
                                          value: field.value,
                                          callback: function ($$v) {
                                            _vm.$set(field, "value", $$v);
                                          },
                                          expression: "field.value",
                                        },
                                      })
                                    : _vm._e()
                                }),
                              ],
                              2
                            ),
                          ]),
                          _c("div", { staticClass: "order-aside__bottom-text" }, [
                            _vm._v(
                              "Обращаем Ваше внимание, что компания вправе отказать клиенту в приобретении товара либо запросить дополнительные данные на любом этапе оформления покупки, не объясняя причин."
                            ),
                          ]),
                          _c("div", { staticClass: "order-aside__bottom-text" }, [
                            _vm._v(
                              "Цены на товары указаны в белорусских рублях с учетом НДС."
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$14 = [
    function () {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", { staticClass: "form__pay-currency" }, [
        _c("b", [_vm._v("Оплата")]),
      ])
    },
  ];
  __vue_render__$14._withStripped = true;

    /* style */
    const __vue_inject_styles__$1a = undefined;
    /* scoped */
    const __vue_scope_id__$1a = undefined;
    /* module identifier */
    const __vue_module_identifier__$1a = undefined;
    /* functional template */
    const __vue_is_functional_template__$1a = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1a = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$14, staticRenderFns: __vue_staticRenderFns__$14 },
      __vue_inject_styles__$1a,
      __vue_script__$1a,
      __vue_scope_id__$1a,
      __vue_is_functional_template__$1a,
      __vue_module_identifier__$1a,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1b = {
    mixins: [__vue_component__$2, __vue_component__$_],
    data: function data() {
      return {
        cookies: null,
        show: false
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        this.cookies = data;
      },
      hide: function hide() {
        this.show = false;
        this.setCookie('hide-cookies-message', true);
        this.$el.style.paddingTop = 0;
      },
      calcHeightCookies: function calcHeightCookies() {
        if (this.$refs.modal) {
          this.$el.style.paddingTop = this.$refs.modal.clientHeight + 'px';
        }
      }
    },
    mounted: function mounted() {
      var _this = this;

      if (!this.getCookie('hide-cookies-message')) {
        this.show = true;
        this.$nextTick(function () {
          _this.calcHeightCookies();

          window.addEventListener('resize', _this.calcHeightCookies);
        });
      }
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.calcHeightCookies);
    }
  };

  /* script */
  const __vue_script__$1b = script$1b;

  /* template */
  var __vue_render__$15 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-cookies cookies" }, [
      _vm.show
        ? _c("div", { ref: "modal", staticClass: "cookies__modal" }, [
            _vm.cookies
              ? _c("div", { staticClass: "cookies__wrapper container" }, [
                  _c("div", { staticClass: "cookies__content" }, [
                    _vm.cookies.text
                      ? _c("div", { staticClass: "cookies__text" }, [
                          _vm._v(_vm._s(_vm.cookies.text)),
                          _vm.cookies.link
                            ? _c(
                                "a",
                                {
                                  staticClass: "cookies__link link",
                                  attrs: {
                                    href: _vm.cookies.link,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.cookies.linkText || "Подробнее")
                                  ),
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon svg-icon--arrow-right",
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#svg-icon-arrow-right",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "cookies__action" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--primary",
                        attrs: { type: "button" },
                        on: { click: _vm.hide },
                      },
                      [_vm._v("Закрыть")]
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$15 = [];
  __vue_render__$15._withStripped = true;

    /* style */
    const __vue_inject_styles__$1b = undefined;
    /* scoped */
    const __vue_scope_id__$1b = undefined;
    /* module identifier */
    const __vue_module_identifier__$1b = undefined;
    /* functional template */
    const __vue_is_functional_template__$1b = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1b = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$15, staticRenderFns: __vue_staticRenderFns__$15 },
      __vue_inject_styles__$1b,
      __vue_script__$1b,
      __vue_scope_id__$1b,
      __vue_is_functional_template__$1b,
      __vue_module_identifier__$1b,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1c = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        catalog: null,
        activeCategoryId: null,
        paramGroups: null,
        excludeSimilar: false,
        slidesToShow: undefined,
        currentSlide: 0,
        maxCountSlides: 3,
        dragOn: false,
        dragStartPosition: undefined,
        dragOffsetReal: 0,
        dragOffset: 0,
        touchstartX: 0,
        touchstartY: 0,
        touchendX: 0,
        touchendY: 0,
        deg: 0,
        computedTransition: 'none',
        widthOfItem: undefined
      };
    },
    computed: {
      currentSlideOffset: function currentSlideOffset() {
        return -this.currentSlide * 100 / this.slidesToShow + '%';
      },
      itemsCount: function itemsCount() {
        var _this = this;

        return this.catalog.items.reduce(function (memo, item) {
          if (item.categoryId == _this.activeCategoryId) return memo + 1;else return memo;
        }, 0);
      },
      // группы товаров в табах
      computedSections: function computedSections() {
        var sections = [];
        this.catalog.items.forEach(function (item) {
          var findSection = sections.find(function (section) {
            return section.id === item.categoryId;
          });

          if (findSection) {
            ++findSection.count;
          } else {
            sections.push({
              id: item.categoryId,
              text: item.categoryName,
              count: 1
            });
          }
        });
        return sections;
      },
      computedOptions: function computedOptions() {
        var vm = this;
        var slidesWidth = 0; // если слайды не влезают в контейнер добавляем тень

        function setShadow() {
          slidesWidth = 0;
          Array.from(this.slides).forEach(function (slide) {
            slidesWidth += slide.offsetWidth;
          });

          if (slidesWidth > this.wrapperEl.offsetWidth + 1) {
            if (this.progress === 0) {
              vm.$refs.list.classList.remove('scroll-items-start');
              vm.$refs.list.classList.add('scroll-items-end');
            } else if (this.progress === 1) {
              vm.$refs.list.classList.remove('scroll-items-end');
              vm.$refs.list.classList.add('scroll-items-start');
            } else {
              vm.$refs.list.classList.add('scroll-items-end');
              vm.$refs.list.classList.add('scroll-items-start');
            }
          } else {
            vm.$refs.list.classList.remove('scroll-items-start');
            vm.$refs.list.classList.remove('scroll-items-end');
          }
        }

        return {
          slidesPerView: 'auto',
          // Индексный номер начального слайда.
          //initialSlide: this.topLinks.findIndex((link) => link.current),
          // инертность свайпа слайдов
          freeMode: true,
          // Разрешить отпускать сенсорные события в положении края ползунка (начало, конец) также блочит скролл не полного слайдера
          touchReleaseOnEdges: true,
          // дистанция при движении мыши после которой сработает событие перетаскивания
          // threshold: 60,
          on: {
            init: setShadow,
            resize: setShadow,
            reachBeginning: function reachBeginning() {
              if (slidesWidth > this.wrapperEl.offsetWidth) {
                vm.$refs.list.classList.remove('scroll-items-start');
                vm.$refs.list.classList.add('scroll-items-end');
              }
            },
            reachEnd: function reachEnd() {
              if (slidesWidth > this.wrapperEl.offsetWidth) {
                vm.$refs.list.classList.remove('scroll-items-end');
                vm.$refs.list.classList.add('scroll-items-start');
              }
            }
          }
        };
      },
      computedLinkAddProduct: function computedLinkAddProduct() {
        var _this2 = this;

        if (this.activeCategoryId) {
          if (this.catalog.items.filter(function (item) {
            return item.categoryId === _this2.activeCategoryId;
          }).length < 3) {
            return this.catalog.categories.filter(function (category) {
              return category.id === _this2.activeCategoryId;
            })[0].link;
          }
        }
      }
    },
    methods: _objectSpread2(_objectSpread2({}, mapActions({
      removeCompareItem: 'compare/remove'
    })), {}, {
      dataSet: function dataSet(data) {
        var _this3 = this,
            _this$catalog,
            _this$catalog$exclude;

        this.catalog = data; // устанавливаем актуальную активную секцию если ее нет

        if (!this.computedSections.filter(function (section) {
          return section.id === _this3.activeCategoryId;
        })) {
          this.activeCategoryId = this.catalog.items[0].categoryId;
        }

        if ((_this$catalog = this.catalog) !== null && _this$catalog !== void 0 && (_this$catalog$exclude = _this$catalog.excludeSimilar) !== null && _this$catalog$exclude !== void 0 && _this$catalog$exclude.value) {
          this.excludeSimilar = catalog.excludeSimilar.value;
        }

        this.$nextTick(function () {
          _this3.handleResize();

          _this3.recalcParams();

          view.initAllLocal();
        });
      },
      recalcParams: function recalcParams() {
        var _this4 = this;

        var vm = this;

        if (!this.catalog || !this.catalog.items || !this.catalog.items.length) {
          vm.paramGroups = null;
          return;
        }

        if (this.computedSections.length && (!this.activeCategoryId || !this.computedSections.find(function (section) {
          return section.id === _this4.activeCategoryId;
        }))) {
          this.activeCategoryId = this.computedSections[0].id;
        }

        var result = {}; // создание пустой матрицы парметров

        this.catalog.items.forEach(function (item) {
          if (item.categoryId != _this4.activeCategoryId) return;
          item.params.forEach(function (paramGroup) {
            // создание групп параметров
            if (!result[paramGroup.id]) {
              result[paramGroup.id] = {
                id: paramGroup.id,
                title: paramGroup.title,
                open: paramGroup.open,
                sort: paramGroup.sort,
                params: {}
              };
            } // создание строк параметров


            paramGroup.params.forEach(function (param) {
              if (!result[paramGroup.id].params[param.id]) {
                result[paramGroup.id].params[param.id] = {
                  id: param.id,
                  title: param.title,
                  values: []
                };
              }
            });
          });
        }); // fill params matrix (fill gaps with null)

        Object.values(result).forEach(function (resultParamGroup) {
          Object.values(resultParamGroup.params).forEach(function (resultParam) {
            // создание массива значений для параметров товара
            _this4.catalog.items.forEach(function (item) {
              if (item.categoryId != _this4.activeCategoryId) return;
              var empty = {
                title: null,
                text: '—'
              }; // поиск у товара парметров относящихся к текущей группе параметров

              var itemParamsGroup = item.params.find(function (param) {
                return param.id === resultParamGroup.id;
              });
              var itemParamsValue = empty;

              if (itemParamsGroup) {
                var findValue = itemParamsGroup.params.find(function (param) {
                  return param.id === resultParam.id;
                });
                itemParamsValue = findValue ? findValue : empty;
              }

              resultParam.values.push(itemParamsValue);
            }); // поиск максимального значения параметра товара
            // let maxParamValue = {text: 0}
            // resultParam.values.forEach((value) => {
            // 	if (parseFloat(value.text) > parseFloat(maxParamValue.text)) {
            // 		maxParamValue = value
            // 	}
            // })
            // const selectedMaxValue = resultParam.values.filter((value) => value.id === maxParamValue.id)
            // if (selectedMaxValue instanceof Array && selectedMaxValue.length) {
            // 	console.log('ssssssssssssssss',selectedMaxValue)
            // 	selectedMaxValue[0].max = true
            // }
            // console.log('mmmmmmmmmmmmmmm', maxParamValue)

          });
        }); // exclude similar

        if (vm.excludeSimilar) {
          result = Object.values(result).filter(function (resultParamGroup) {
            resultParamGroup.params = Object.values(resultParamGroup.params).filter(function (resultParam) {
              var testValue;
              var diffFound = false;

              _this4.catalog.items.forEach(function (item) {
                if (item.categoryId != _this4.activeCategoryId) return;
                if (!resultParamGroup || !resultParam) return;
                var itemParamsGroup = item.params.find(function (param) {
                  return param.id === resultParamGroup.id;
                });
                var itemParamsValue = itemParamsGroup ? itemParamsGroup.params.find(function (group) {
                  return group.id === resultParam.id;
                }) : null;
                if (typeof testValue == 'undefined') testValue = itemParamsValue;else if (!itemParamsValue || testValue.text != itemParamsValue.text) diffFound = true;
              });

              return diffFound;
            });
            return resultParamGroup && resultParamGroup.params.length;
          });
        }

        result = Object.values(result).sort(function (a, b) {
          return a.sort - b.sort;
        });
        vm.paramGroups = result;
      },
      toggleSimilar: function toggleSimilar(value) {
        this.excludeSimilar = value;
        this.recalcParams();
      },
      changeSection: function changeSection(categoryId) {
        this.activeCategoryId = categoryId;
        this.recalcParams();
      },
      removeItem: function removeItem(productId) {
        var _this5 = this;

        this.removeCompareItem({
          id: productId
        }).then(function () {
          _this5.dataLoad({
            url: _this5.catalog.remote,
            delay: true,
            data: null
          }, {});
        });
      },
      slideItemsBack: function slideItemsBack() {
        if (!this.isPrevArrowDisabled()) this.currentSlide--;
        this.computedTransition = '.3s';
      },
      slideItemsForward: function slideItemsForward() {
        if (!this.isNextArrowDisabled()) this.currentSlide++;
        this.computedTransition = '.3s';
      },
      isPrevArrowDisabled: function isPrevArrowDisabled() {
        return this.currentSlide == 0;
      },
      isNextArrowDisabled: function isNextArrowDisabled() {
        return this.currentSlide + this.slidesToShow >= this.maxCountSlides;
      },
      dragStart: function dragStart(e) {
        // if (window.innerWidth <= breakpoints['2xs-max'])
        // 	return;
        this.touchstartX = e.changedTouches[0].screenX;
        this.touchstartY = e.changedTouches[0].screenY;
        this.dragOn = true;
        this.dragStartPosition = e.touches[0].pageX;
        this.computedTransition = 'none';
        this.widthOfItem = this.$el.querySelector('.compare__item').offsetWidth;
      },
      dragEnd: function dragEnd() {
        // if (window.innerWidth <= breakpoints['2xs-max'])
        // 	return;
        this.dragOn = false;
        this.computedTransition = '.3s';
        this.currentSlide = Math.round((this.widthOfItem * this.currentSlide - this.dragOffset) / this.widthOfItem);
        if (this.currentSlide + this.slidesToShow >= this.maxCountSlides) this.currentSlide = this.maxCountSlides - this.slidesToShow;
        if (this.currentSlide < 0) this.currentSlide = 0;
        this.dragOffset = 0;
      },
      dragMove: function dragMove(e) {
        if (!this.dragOn) return; // защита от скролла крайнего правого слайда

        if (this.dragStartPosition > e.touches[0].pageX && this.currentSlide + this.slidesToShow === this.maxCountSlides) return; // защита от вертикального свайпа

        this.touchendX = e.changedTouches[0].screenX;
        this.touchendY = e.changedTouches[0].screenY;
        this.calcDeg();
        if (this.deg < -65 || this.deg > 65) return;
        this.dragOffsetReal = e.touches[0].pageX - this.dragStartPosition;
        if (this.widthOfItem * this.currentSlide - this.dragOffsetReal < 0) this.dragOffset = this.widthOfItem * this.currentSlide;else this.dragOffset = this.dragOffsetReal;
      },
      // расчет угла свайпа
      calcDeg: function calcDeg() {
        var rads = Math.atan((this.touchstartY - this.touchendY) / (this.touchstartX - this.touchendX));
        this.deg = rads * (180 / 3.14);
      },
      handleResize: function handleResize() {
        this.slidesToShow = window.innerWidth > breakpoints['sm-max'] ? 3 : 2;
      },
      slideDown: function slideDown(element) {
        var slideDown = function slideDown(target) {
          var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
          target.style.removeProperty('display');
          var display = window.getComputedStyle(target).display;
          if (display === 'none') display = 'block';
          target.style.display = display;
          var height = target.offsetHeight;
          target.style.overflow = 'hidden';
          target.style.height = 0;
          target.style.paddingTop = 0;
          target.style.paddingBottom = 0;
          target.style.marginTop = 0;
          target.style.marginBottom = 0;
          target.offsetHeight;
          target.style.boxSizing = 'border-box';
          target.style.transitionProperty = 'height, margin, padding';
          target.style.transitionDuration = duration + 'ms';
          target.style.height = height + 'px';
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          window.setTimeout(function () {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
          }, duration);
        };

        slideDown(element, 200);
      },
      slideUp: function slideUp(element) {
        var slideUp = function slideUp(target) {
          var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
          target.style.transitionProperty = 'height, margin, padding';
          target.style.transitionDuration = duration + 'ms';
          target.style.boxSizing = 'border-box';
          target.style.height = target.offsetHeight + 'px';
          target.offsetHeight;
          target.style.overflow = 'hidden';
          target.style.height = 0;
          target.style.paddingTop = 0;
          target.style.paddingBottom = 0;
          target.style.marginTop = 0;
          target.style.marginBottom = 0;
          window.setTimeout(function () {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property'); //alert("!");
          }, duration);
        };

        slideUp(element, 200);
      }
    }),
    created: function created() {
      // window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize); // window.addEventListener('popstate', this.handlePopState);
    },
    destroyed: function destroyed() {
      // window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }
  };

  /* script */
  const __vue_script__$1c = script$1c;

  /* template */
  var __vue_render__$16 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-compare compare" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.catalog
          ? _c("div", { staticClass: "compare__wrapper container" }, [
              !_vm.catalog.items || !_vm.catalog.items.length
                ? _c("div", { staticClass: "compare__layout" }, [
                    _vm.catalog.empty
                      ? _c("div", { staticClass: "compare__empty" }, [
                          _vm.catalog.empty.text
                            ? _c("div", { staticClass: "compare__text" }, [
                                _vm._v(_vm._s(_vm.catalog.empty.text)),
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "compare__action" },
                            [
                              _vm._l(_vm.catalog.empty.buttons, function (btn) {
                                return [
                                  btn.link
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "btn",
                                          class: btn.elementClass,
                                          attrs: { href: btn.link },
                                        },
                                        [_vm._v(_vm._s(btn.text))]
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _c("div", { staticClass: "compare__layout" }, [
                    _c(
                      "div",
                      { ref: "list", staticClass: "compare__navigation" },
                      [
                        _c(
                          "div",
                          { staticClass: "compare__navigation-list" },
                          [
                            _c(
                              "v-swiper",
                              {
                                ref: "carousel",
                                attrs: { options: _vm.computedOptions },
                              },
                              _vm._l(_vm.computedSections, function (section) {
                                return _c(
                                  "v-swiper-slide",
                                  { staticClass: "compare__navigation-item" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "compare__navigation-toggle",
                                        class: {
                                          "compare__navigation-toggle--current":
                                            _vm.activeCategoryId === section.id,
                                        },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeSection(section.id)
                                          },
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(section.text)),
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "compare__navigation-toggle-count",
                                          },
                                          [
                                            _vm._v(
                                              "(" + _vm._s(section.count) + ")"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "compare__items-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "compare__aside" },
                        [
                          _vm.catalog.excludeSimilar
                            ? _c("v-field-checkbox", {
                                attrs: { text: _vm.catalog.excludeSimilar.text },
                                on: { input: _vm.toggleSimilar },
                                model: {
                                  value: _vm.catalog.excludeSimilar.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.catalog.excludeSimilar,
                                      "value",
                                      $$v
                                    );
                                  },
                                  expression: "catalog.excludeSimilar.value",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "compare__items-slider" }, [
                        _c(
                          "button",
                          {
                            staticClass: "slider__prev",
                            class: { disabled: _vm.isPrevArrowDisabled() },
                            attrs: { type: "button" },
                            on: { click: _vm.slideItemsBack },
                          },
                          [
                            _c("svg", { staticClass: "svg-icon" }, [
                              _c("use", {
                                attrs: { "xlink:href": "#svg-icon-arrow-left" },
                              }),
                            ]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "slider__next",
                            class: { disabled: _vm.isNextArrowDisabled() },
                            attrs: { type: "button" },
                            on: { click: _vm.slideItemsForward },
                          },
                          [
                            _c("svg", { staticClass: "svg-icon" }, [
                              _c("use", {
                                attrs: { "xlink:href": "#svg-icon-arrow-right" },
                              }),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "compare__items",
                            on: {
                              touchstart: _vm.dragStart,
                              touchend: _vm.dragEnd,
                              touchmove: _vm.dragMove,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "compare__items-grid",
                                style: {
                                  transform:
                                    "translate3d(" +
                                    _vm.currentSlideOffset +
                                    ",0,0) translateX(" +
                                    _vm.dragOffset +
                                    "px)",
                                  transition: _vm.computedTransition,
                                },
                              },
                              [
                                _vm._l(_vm.catalog.items, function (item) {
                                  return _vm.activeCategoryId === item.categoryId
                                    ? _c(
                                        "div",
                                        { staticClass: "compare__item" },
                                        [
                                          _c("v-product", {
                                            attrs: {
                                              template: "grid",
                                              product: item,
                                            },
                                            on: {
                                              "remove-compare": _vm.removeItem,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }),
                                _vm.computedLinkAddProduct
                                  ? _c("div", { staticClass: "compare__item" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "compare__add-product",
                                          attrs: {
                                            href: _vm.computedLinkAddProduct,
                                          },
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: "/local/assets/images/add-product.png",
                                              loading: "lazy",
                                              alt: "",
                                              title: "",
                                              width: "95",
                                              height: "91",
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              "Добавить из этой же категории"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "compare__items-wrapper fixed-block js-fixed",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fixed-block__content js-fixed__content",
                          },
                          [
                            _c("div", { staticClass: "container" }, [
                              _c(
                                "div",
                                { staticClass: "compare__aside" },
                                [
                                  _vm.catalog.excludeSimilar
                                    ? _c("v-field-checkbox", {
                                        attrs: {
                                          text: _vm.catalog.excludeSimilar.text,
                                        },
                                        on: { input: _vm.toggleSimilar },
                                        model: {
                                          value: _vm.catalog.excludeSimilar.value,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.catalog.excludeSimilar,
                                              "value",
                                              $$v
                                            );
                                          },
                                          expression:
                                            "catalog.excludeSimilar.value",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "compare__items-slider" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "slider__prev",
                                      class: {
                                        disabled: _vm.isPrevArrowDisabled(),
                                      },
                                      attrs: { type: "button" },
                                      on: { click: _vm.slideItemsBack },
                                    },
                                    [
                                      _c("svg", { staticClass: "svg-icon" }, [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg-icon-arrow-left",
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "slider__next",
                                      class: {
                                        disabled: _vm.isNextArrowDisabled(),
                                      },
                                      attrs: { type: "button" },
                                      on: { click: _vm.slideItemsForward },
                                    },
                                    [
                                      _c("svg", { staticClass: "svg-icon" }, [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg-icon-arrow-right",
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "compare__items",
                                      on: {
                                        touchstart: _vm.dragStart,
                                        touchend: _vm.dragEnd,
                                        touchmove: _vm.dragMove,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "compare__items-grid",
                                          style: {
                                            transform:
                                              "translate3d(" +
                                              _vm.currentSlideOffset +
                                              ",0,0) translateX(" +
                                              _vm.dragOffset +
                                              "px)",
                                            transition: _vm.computedTransition,
                                          },
                                        },
                                        [
                                          _vm._l(
                                            _vm.catalog.items,
                                            function (item) {
                                              return _vm.activeCategoryId ===
                                                item.categoryId
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "compare__item",
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "compare__product",
                                                          attrs: {
                                                            href: item.offers[0]
                                                              .link,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "compare__product-visual",
                                                            },
                                                            [
                                                              item.offers[0].image
                                                                ? _c("img", {
                                                                    attrs: {
                                                                      src: item
                                                                        .offers[0]
                                                                        .image,
                                                                      loading:
                                                                        "lazy",
                                                                      alt: item
                                                                        .offers[0]
                                                                        .name,
                                                                      title:
                                                                        item
                                                                          .offers[0]
                                                                          .name,
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "compare__product-name h4",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.offers[0]
                                                                    .name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          _vm.computedLinkAddProduct
                                            ? _c(
                                                "div",
                                                { staticClass: "compare__item" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "compare__add-product compare__add-product--min",
                                                      attrs: {
                                                        href: _vm.computedLinkAddProduct,
                                                      },
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: "/local/assets/images/add-product.png",
                                                          loading: "lazy",
                                                          alt: "",
                                                          title: "",
                                                          width: "95",
                                                          height: "91",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        ref: "compareBody",
                        staticClass: "compare__body",
                        on: {
                          touchstart: _vm.dragStart,
                          touchend: _vm.dragEnd,
                          touchmove: _vm.dragMove,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "container" },
                          _vm._l(_vm.paramGroups, function (paramGroup) {
                            return _c(
                              "div",
                              {
                                staticClass: "compare__group",
                                class: { open: paramGroup.open },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "compare__group-header",
                                    class: { "open-accordion": paramGroup.open },
                                    on: {
                                      click: function ($event) {
                                        paramGroup.open = !paramGroup.open;
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "compare__group-title" },
                                      [_vm._v(_vm._s(paramGroup.title))]
                                    ),
                                    _c("div", { staticClass: "accordion__plus" }),
                                  ]
                                ),
                                _c(
                                  "transition",
                                  {
                                    attrs: { name: "content-fade" },
                                    on: {
                                      enter: _vm.slideDown,
                                      leave: _vm.slideUp,
                                    },
                                  },
                                  [
                                    paramGroup.open
                                      ? _c(
                                          "div",
                                          { staticClass: "compare__table" },
                                          _vm._l(
                                            paramGroup.params,
                                            function (param) {
                                              return _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "compare__table-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "compare__table-aside",
                                                    },
                                                    [
                                                      _vm._v(_vm._s(param.title)),
                                                      param.tip
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "inline-tooltip-wrap",
                                                              attrs: {
                                                                "aria-label":
                                                                  "Подсказка",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "inline-tooltip dropdown-owner js-dropdown",
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "inline-tooltip__btn js-dropdown__btn",
                                                                  }),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "inline-tooltip__body dropdown js-dropdown__body js-tooltip-position",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          param.tip
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "compare__table-main",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "compare__table-main-grid",
                                                          style: {
                                                            transform:
                                                              "translate3d(" +
                                                              _vm.currentSlideOffset +
                                                              ",0,0) translateX(" +
                                                              _vm.dragOffset +
                                                              "px)",
                                                            transition:
                                                              _vm.computedTransition,
                                                          },
                                                        },
                                                        _vm._l(
                                                          param.values,
                                                          function (value) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "compare__table-main-cell",
                                                                class: {
                                                                  "compare__table-main-cell--mark":
                                                                    value.max,
                                                                },
                                                              },
                                                              [
                                                                value
                                                                  ? [
                                                                      value.title
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "compare__table-main-cell-title",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  value.title
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "compare__table-main-cell-value",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              value
                                                                                ? value.text
                                                                                : "—"
                                                                            )
                                                                          ),
                                                                          value.max
                                                                            ? _c(
                                                                                "svg",
                                                                                {
                                                                                  staticClass:
                                                                                    "svg-icon svg-icon--list-bullet",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "use",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          "xlink:href":
                                                                                            "#svg-icon-list-bullet",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  : [
                                                                      value.title
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "compare__table-main-cell-title",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  value.title
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "compare__table-main-cell-value",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "—"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                              ],
                                                              2
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
            ])
          : _vm._e(),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$16 = [];
  __vue_render__$16._withStripped = true;

    /* style */
    const __vue_inject_styles__$1c = undefined;
    /* scoped */
    const __vue_scope_id__$1c = undefined;
    /* module identifier */
    const __vue_module_identifier__$1c = undefined;
    /* functional template */
    const __vue_is_functional_template__$1c = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1c = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$16, staticRenderFns: __vue_staticRenderFns__$16 },
      __vue_inject_styles__$1c,
      __vue_script__$1c,
      __vue_scope_id__$1c,
      __vue_is_functional_template__$1c,
      __vue_module_identifier__$1c,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1d = {
    data: function data() {
      return {
        text: '',
        timeout: null,
        show: false,
        showAction: true,
        attention: false
      };
    },
    computed: _objectSpread2({}, mapGetters({
      count: 'compare/compareCount',
      link: 'compare/link'
    })),
    watch: {
      count: {
        immediate: true,
        handler: function handler(newValue) {
          this.text = "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D".concat(newValue > 1 ? 'о' : '', " ").concat(newValue, " \u0442\u043E\u0432\u0430\u0440").concat(newValue > 1 ? 'а' : '', " \u0438\u0437 3-\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0445");

          if (newValue) {
            this.show = true;
          }
        }
      }
    },
    methods: {
      cleanAll: function cleanAll() {
        var _this = this;

        this.$store.dispatch('compare/remove', {
          id: 'all'
        }).then(function () {
          _this.text = 'Список сравнения очищен.';
          clearTimeout(_this.timeout);
          _this.timeout = setTimeout(function () {
            _this.show = false;
          }, 3000);
        }).then(function () {
          controller.clearCompare();
        });
      }
    },
    created: function created() {
      var _this2 = this;

      controller.$on('add-compare-max', function () {
        _this2.showAction = false;
        _this2.text = 'Добавлено максимально количество товаров для сравнения';
        clearTimeout(_this2.timeout);
        _this2.timeout = setTimeout(function () {
          _this2.text = "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D".concat(_this2.count > 1 ? 'о' : '', " ").concat(_this2.count, " \u0442\u043E\u0432\u0430\u0440").concat(_this2.count > 1 ? 'а' : '', " \u0438\u0437 3-\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0445");
          _this2.showAction = true;
        }, 3000);
      });
      controller.$on('add-compare-item', function (options) {
        _this2.show = true;
        _this2.attention = true;
        _this2.showAction = false;
        _this2.text = "".concat(options.name, " \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0432 \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u0435");
        clearTimeout(_this2.timeout);
        _this2.timeout = setTimeout(function () {
          _this2.text = "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D".concat(_this2.count > 1 ? 'о' : '', " ").concat(_this2.count, " \u0442\u043E\u0432\u0430\u0440").concat(_this2.count > 1 ? 'а' : '', " \u0438\u0437 3-\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0445");
          _this2.showAction = true;
          _this2.attention = false;
        }, 3000);
      });
      controller.$on('remove-compare-item', function (options) {
        _this2.attention = true;
        _this2.showAction = false;
        _this2.text = "".concat(options.name, " \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F");
        clearTimeout(_this2.timeout);
        _this2.timeout = setTimeout(function () {
          _this2.text = "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D".concat(_this2.count > 1 ? 'о' : '', " ").concat(_this2.count, " \u0442\u043E\u0432\u0430\u0440").concat(_this2.count > 1 ? 'а' : '', " \u0438\u0437 3-\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0445");
          _this2.showAction = true;
          _this2.attention = false;

          if (!_this2.count) {
            _this2.text = '';
            _this2.showAction = false;
            _this2.show = false;
          }
        }, 3000);
      });
    }
  };

  /* script */
  const __vue_script__$1d = script$1d;

  /* template */
  var __vue_render__$17 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-compare-bar compare-bar" },
      [
        _c("transition", { attrs: { name: "compare-bar" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show,
                  expression: "show",
                },
              ],
              staticClass: "compare-bar__wrapper",
              class: {
                "compare-bar__wrapper--action": _vm.showAction,
                "compare-bar__wrapper--attention": _vm.attention,
              },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "compare-bar__text" }, [
                  _vm._v(_vm._s(_vm.text)),
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showAction,
                        expression: "showAction",
                      },
                    ],
                    staticClass: "compare-bar__action",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn--white",
                        attrs: { href: _vm.link },
                      },
                      [_vm._v("Перейти к сравнению")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "compare-bar__clean",
                        attrs: {
                          type: "button",
                          "aria-label": "Очистить сравнение",
                          title: "Очистить сравнение",
                        },
                        on: { click: _vm.cleanAll },
                      },
                      [
                        _c("svg", { staticClass: "svg-icon svg-icon--garbage" }, [
                          _c("use", {
                            attrs: { "xlink:href": "#svg-icon-garbage" },
                          }),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$17 = [];
  __vue_render__$17._withStripped = true;

    /* style */
    const __vue_inject_styles__$1d = undefined;
    /* scoped */
    const __vue_scope_id__$1d = undefined;
    /* module identifier */
    const __vue_module_identifier__$1d = undefined;
    /* functional template */
    const __vue_is_functional_template__$1d = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1d = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$17, staticRenderFns: __vue_staticRenderFns__$17 },
      __vue_inject_styles__$1d,
      __vue_script__$1d,
      __vue_scope_id__$1d,
      __vue_is_functional_template__$1d,
      __vue_module_identifier__$1d,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1e = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        tabs: {},
        activeTab: null
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        this.tabs = data;
        this.setActiveTab(this.tabs.tabsToggler.value);
      },
      setActiveTab: function setActiveTab(value) {
        var _this = this;

        var url = new URL(window.location.href);
        url.searchParams.set('tab', value);
        window.history.replaceState({}, '', url);
        this.activeTab = this.tabs.tabs.find(function (item) {
          return _this.tabs.tabsToggler.value == item.id;
        });
      }
    }
  };

  /* script */
  const __vue_script__$1e = script$1e;

  /* template */
  var __vue_render__$18 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-account account" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.activeTab
          ? _c("div", { staticClass: "account__wrapper container" }, [
              _vm.activeTab.breadcrumbs && _vm.activeTab.breadcrumbs.length
                ? _c("div", { staticClass: "breadcrumbs xs" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "breadcrumbs__list",
                        attrs: { "xmlns:v": "http://rdf.data-vocabulary.org/#" },
                      },
                      _vm._l(_vm.activeTab.breadcrumbs, function (item, index) {
                        return _c(
                          "li",
                          {
                            staticClass: "breadcrumbs__item",
                            attrs: { typeof: "v:Breadcrumb" },
                          },
                          [
                            index < _vm.activeTab.breadcrumbs.length - 1
                              ? [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "breadcrumbs__link",
                                      attrs: {
                                        href: item.link,
                                        rel: "v:url",
                                        property: "v:title",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _c(
                                    "svg",
                                    { staticClass: "breadcrumbs__separator" },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href":
                                            "#svg-icon-chevron-right-sm",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              : [
                                  _c(
                                    "span",
                                    { staticClass: "breadcrumbs__current" },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                ],
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "account__title page-title" }, [
                _c("h1", { staticClass: "h2 page-title__value" }, [
                  _vm._v(_vm._s(_vm.activeTab.title)),
                ]),
              ]),
              _c("div", { staticClass: "account__navigation-wrap" }, [
                _vm.tabs.tabsToggler
                  ? _c(
                      "div",
                      { staticClass: "account__navigation" },
                      [
                        _c("v-field", {
                          attrs: { field: _vm.tabs.tabsToggler },
                          on: { input: _vm.setActiveTab },
                          model: {
                            value: _vm.tabs.tabsToggler.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.tabs.tabsToggler, "value", $$v);
                            },
                            expression: "tabs.tabsToggler.value",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "account__content" }, [
                "data" == _vm.activeTab.name
                  ? _c("div", { staticClass: "account__item" }, [
                      _vm.activeTab.data && _vm.activeTab.data.length
                        ? _c("div", { staticClass: "user-data" }, [
                            _vm.activeTab.editData
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "user-data__edit",
                                    attrs: { href: _vm.activeTab.editData },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      { staticClass: "svg-icon svg-icon--edit" },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#svg-icon-edit",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "user-data__wrapper" },
                              _vm._l(_vm.activeTab.data, function (item) {
                                return _c(
                                  "div",
                                  {
                                    key: item.id,
                                    staticClass: "user-data__prop flc",
                                  },
                                  [
                                    item.name
                                      ? _c(
                                          "div",
                                          { staticClass: "user-data__prop-name" },
                                          [_vm._v(_vm._s(item.name))]
                                        )
                                      : _vm._e(),
                                    item.value
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "user-data__prop-value",
                                          },
                                          [_vm._v(_vm._s(item.value))]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                "companies" == _vm.activeTab.name
                  ? _c(
                      "div",
                      { staticClass: "account__item" },
                      [_vm._t("companies")],
                      2
                    )
                  : _vm._e(),
                "orders" == _vm.activeTab.name
                  ? _c(
                      "div",
                      { staticClass: "account__item" },
                      [_vm._t("orders")],
                      2
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$18 = [];
  __vue_render__$18._withStripped = true;

    /* style */
    const __vue_inject_styles__$1e = undefined;
    /* scoped */
    const __vue_scope_id__$1e = undefined;
    /* module identifier */
    const __vue_module_identifier__$1e = undefined;
    /* functional template */
    const __vue_is_functional_template__$1e = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1e = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$18, staticRenderFns: __vue_staticRenderFns__$18 },
      __vue_inject_styles__$1e,
      __vue_script__$1e,
      __vue_scope_id__$1e,
      __vue_is_functional_template__$1e,
      __vue_module_identifier__$1e,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1f = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        content: {}
      };
    },
    created: function created() {
      var _this = this;

      controller.$on('remove-company', function (options) {
        _this.dataLoad({
          url: _this.content.remote,
          data: {
            action: 'deleteCompany',
            id: options.id
          },
          delay: true
        });
      });
    },
    methods: {
      dataSet: function dataSet(data) {
        this.content = data;
      },
      deleteCompany: function deleteCompany(id) {
        var currentCompany = this.content.list.filter(function (item) {
          return item.id == id;
        })[0];
        controller.openModal({
          className: 'modal--sm  modal--no-header',
          component: {
            name: 'v-remove-company',
            props: {
              dataSource: {
                id: id,
                name: currentCompany.data[0].name + ' ' + currentCompany.data[0].value
              }
            }
          }
        });
      }
    }
  };

  /* script */
  const __vue_script__$1f = script$1f;

  /* template */
  var __vue_render__$19 = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-companies companies" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.content.list && _vm.content.list.length
          ? _c(
              "div",
              { staticClass: "companies__list" },
              _vm._l(_vm.content.list, function (listItem) {
                return _c(
                  "div",
                  { key: listItem.id, staticClass: "companies__item flc" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "companies__delete",
                        on: {
                          click: function ($event) {
                            return _vm.deleteCompany(listItem.id)
                          },
                        },
                      },
                      [
                        _c("svg", { staticClass: "svg-icon svg-icon--garbage" }, [
                          _c("use", {
                            attrs: { "xlink:href": "#svg-icon-garbage" },
                          }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "companies__wrapper" },
                      _vm._l(listItem.data, function (item) {
                        return _c(
                          "div",
                          { key: item.id, staticClass: "companies__prop flc" },
                          [
                            item.name
                              ? _c(
                                  "div",
                                  { staticClass: "companies__prop-name" },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              : _vm._e(),
                            item.value
                              ? _c(
                                  "div",
                                  { staticClass: "companies__prop-value" },
                                  [_vm._v(_vm._s(item.value))]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "companies__action" },
          [
            _vm._l(_vm.content.buttons, function (btn) {
              return [
                btn.link
                  ? _c(
                      "a",
                      {
                        staticClass: "btn",
                        class: btn.elementClass,
                        attrs: { href: btn.link },
                      },
                      [_vm._v(_vm._s(btn.text))]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$19 = [];
  __vue_render__$19._withStripped = true;

    /* style */
    const __vue_inject_styles__$1f = undefined;
    /* scoped */
    const __vue_scope_id__$1f = undefined;
    /* module identifier */
    const __vue_module_identifier__$1f = undefined;
    /* functional template */
    const __vue_is_functional_template__$1f = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1f = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$19, staticRenderFns: __vue_staticRenderFns__$19 },
      __vue_inject_styles__$1f,
      __vue_script__$1f,
      __vue_scope_id__$1f,
      __vue_is_functional_template__$1f,
      __vue_module_identifier__$1f,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1g = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        catalog: null,
        state: {
          page: null,
          sort: null,
          view: null,
          filter: null
        },
        changedFilters: null,
        asideOpen: false,
        foldedAsideMode: undefined
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (options.append && this.catalog && this.catalog.items) {
          var oldItems = this.catalog.items;
          this.catalog = data;
          this.catalog.items = oldItems.concat(this.catalog.items);
        } else {
          this.catalog = data;
        }

        this.state.sort = this.catalog.sort ? this.catalog.sort.value : null;
        this.state.page = this.catalog.page;
        this.state.view = this.state.view || this.catalog.view && this.catalog.view.value || 'grid';
      },
      navigate: function navigate(page) {
        this.state.page.offset = page.offset;
        this.state.page.limit = page.limit;
        this.requestDataLoad({
          append: page.append
        });
        animate({
          duration: 1000,
          timing: function timing(timeFraction) {
            return timeFraction;
          },
          // линейная функция значит, что анимация идёт с одной и той же скоростью
          draw: function draw(progress) {
            document.documentElement.scrollTop = document.documentElement.scrollTop - progress * document.documentElement.scrollTop;
          }
        });
      },
      filterUpdated: function filterUpdated(filterValue, changedFilters) {
        this.state.filter = filterValue;
        this.changedFilters = JSON.parse(JSON.stringify(changedFilters));

        if (window.location.pathname.indexOf('/local/') < 0 && !this.catalog.notChangeUrl) {
          window.history.replaceState(null, null, this.catalog.remote);
        }

        console.log('filterUpdated');
      },
      filterChanged: function filterChanged(filterValue) {
        this.state.filter = filterValue;
        this.requestDataLoad();
        console.log('filterChanged');
      },
      requestDataLoad: function requestDataLoad(dataSetOptions) {
        this.dataLoad({
          url: this.catalog.remote,
          delay: true,
          data: {
            page: this.state.page,
            sort: this.state.sort,
            filter: this.state.filter
          }
        }, dataSetOptions);
      },
      tagLinkFilter: function tagLinkFilter(link) {
        this.dataLoad({
          url: link,
          delay: true,
          data: {
            sort: this.state.sort
          }
        });
      },
      openAside: function openAside() {
        controller.openCatalogAside();
      },
      closeAside: function closeAside() {
        controller.closeCatalogAside();
      },
      updateFoldedAsideState: function updateFoldedAsideState() {
        this.foldedAsideMode = window.innerWidth <= breakpoints['sm-max'];
      }
    },
    created: function created() {
      window.addEventListener('resize', this.updateFoldedAsideState);
      this.updateFoldedAsideState();
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.updateFoldedAsideState);
    }
  };

  /* script */
  const __vue_script__$1g = script$1g;

  /* template */
  var __vue_render__$1a = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-catalog catalog" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        !_vm.catalog
          ? [_c("div", { staticClass: "catalog__placeholder" })]
          : _vm._e(),
        _vm.catalog
          ? [
              _c(
                "div",
                { staticClass: "catalog__top-navigation flc" },
                [
                  _c("v-filter", {
                    attrs: { "row-filters": _vm.catalog.filters },
                    on: {
                      "filter-changed": _vm.filterChanged,
                      "filter-updated": _vm.filterUpdated,
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "catalog__layout" }, [
                _c("div", { staticClass: "catalog__layout-main" }, [
                  _c(
                    "div",
                    { staticClass: "catalog__list flc" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          !_vm.catalog.items || !_vm.catalog.items.length
                            ? _c(
                                "div",
                                { staticClass: "catalog__list-message flc" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "catalog__list-message-title h3 flc",
                                    },
                                    [_vm._v("Ничего не найдено")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "catalog__list-message-body flc",
                                    },
                                    [
                                      _vm._v(
                                        "Попробуйте изменить параметры поиска или перейдите на главную страницу."
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "catalog__list-message-actions flc",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "catalog__list-message-actions-grid",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "catalog__list-message-action",
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "btn",
                                                  attrs: { href: "/" },
                                                },
                                                [_vm._v("На главную страницу")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "catalog__grid" },
                                _vm._l(_vm.catalog.items, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.id,
                                      staticClass: "catalog__cell",
                                    },
                                    [
                                      _c("v-order-list-item", {
                                        attrs: { order: item },
                                      }),
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "catalog__nav flc" },
                    [
                      _c("v-page-nav", {
                        attrs: { page: _vm.catalog.page },
                        on: { navigate: _vm.navigate },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          : _vm._e(),
      ],
      2
    )
  };
  var __vue_staticRenderFns__$1a = [];
  __vue_render__$1a._withStripped = true;

    /* style */
    const __vue_inject_styles__$1g = undefined;
    /* scoped */
    const __vue_scope_id__$1g = undefined;
    /* module identifier */
    const __vue_module_identifier__$1g = undefined;
    /* functional template */
    const __vue_is_functional_template__$1g = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1g = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1a, staticRenderFns: __vue_staticRenderFns__$1a },
      __vue_inject_styles__$1g,
      __vue_script__$1g,
      __vue_scope_id__$1g,
      __vue_is_functional_template__$1g,
      __vue_module_identifier__$1g,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$1h = {
    props: {
      order: {
        type: Object,
        default: null
      }
    }
  };

  /* script */
  const __vue_script__$1h = script$1h;

  /* template */
  var __vue_render__$1b = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-order-list-item order-list-item" }, [
      _vm.order.props && _vm.order.props.length
        ? _c(
            "div",
            { staticClass: "order-list-item__props" },
            _vm._l(_vm.order.props, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "order-list-item__prop flc" },
                [
                  item.name
                    ? _c("div", { staticClass: "order-list-item__prop-name" }, [
                        _vm._v(_vm._s(item.name)),
                      ])
                    : _vm._e(),
                  item.value
                    ? _c("div", { staticClass: "order-list-item__prop-value" }, [
                        _vm._v(_vm._s(item.value)),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.order.detail
        ? _c("div", { staticClass: "order-list-item__action" }, [
            _c(
              "a",
              {
                staticClass: "order-list-item__detail",
                attrs: { href: _vm.order.detail.link },
              },
              [_vm._v(_vm._s(_vm.order.detail.text))]
            ),
          ])
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$1b = [];
  __vue_render__$1b._withStripped = true;

    /* style */
    const __vue_inject_styles__$1h = undefined;
    /* scoped */
    const __vue_scope_id__$1h = undefined;
    /* module identifier */
    const __vue_module_identifier__$1h = undefined;
    /* functional template */
    const __vue_is_functional_template__$1h = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1h = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1b, staticRenderFns: __vue_staticRenderFns__$1b },
      __vue_inject_styles__$1h,
      __vue_script__$1h,
      __vue_scope_id__$1h,
      __vue_is_functional_template__$1h,
      __vue_module_identifier__$1h,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1i = {
    mixins: [__vue_component__$2, __vue_component__$I],
    data: function data() {
      return {
        order: null
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        this.order = data;
      },
      openAccordion: function openAccordion(accordionId) {
        window.dataStorage.get(document.querySelector(accordionId), 'open')();
      },
      handleInput: function handleInput(value, field) {
        if (value) {
          field.errors = null;
        }
      }
    },
    mounted: function mounted() {
      this.$nextTick(function () {
        view.initAllLocal();
      });
    },
    updated: function updated() {
      this.$nextTick(function () {
        view.initAllLocal();
      });
    }
  };

  /* script */
  const __vue_script__$1i = script$1i;

  /* template */
  var __vue_render__$1c = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-order-detail order" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _c(
          "div",
          { staticClass: "container" },
          [
            !_vm.order
              ? [_c("div", { staticClass: "order__placeholder" })]
              : _vm._e(),
            _vm.order
              ? [
                  _c("div", { staticClass: "page-content" }, [
                    _c("div", { staticClass: "page-content__center" }, [
                      _c(
                        "div",
                        {
                          ref: "items",
                          staticClass: "accordion open-accordion js-accordion",
                          attrs: { id: "items" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "page-content__section-header" },
                            [
                              _c("h4", { staticClass: "flc" }, [
                                _vm._v("Состав заказа"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "link accordion__toggler hide-lg hide-md hide-sm js-accordion__toggler",
                                },
                                [
                                  _c("div", { staticClass: "accordion__open" }, [
                                    _vm._v("Развернуть"),
                                  ]),
                                  _c("div", { staticClass: "accordion__close" }, [
                                    _vm._v("Свернуть"),
                                  ]),
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon svg-icon--arrow-down accordion__toggler-arrow-down",
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#svg-icon-arrow-down",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "accordion__content js-accordion__content",
                            },
                            [
                              _vm.order.items
                                ? _c(
                                    "div",
                                    { staticClass: "order-items" },
                                    _vm._l(_vm.order.items, function (item) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "order-items__item order-item flc",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "order-item__visual" },
                                            [
                                              item.image || item.imageSources
                                                ? _c("v-image", {
                                                    attrs: {
                                                      src: item.image,
                                                      sources: item.imageSources,
                                                      alt: item.name,
                                                      title: item.name,
                                                    },
                                                  })
                                                : _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "svg-icon order-item__svg",
                                                    },
                                                    [
                                                      _c("use", {
                                                        attrs: {
                                                          "xlink:href":
                                                            "#svg-icon-no-photo",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "order-item__content",
                                            },
                                            [
                                              item.name && item.link
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "order-item__title h4",
                                                      attrs: { href: item.link },
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  )
                                                : _vm._e(),
                                              item.name && !item.link
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order-item__title h4",
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  )
                                                : _vm._e(),
                                              item.code
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order-item__code",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Код товара: " +
                                                          _vm._s(item.code)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              item.quantity
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order-item__quantity",
                                                    },
                                                    [
                                                      _vm._v("Количество:"),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.quantity)
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "order-item__price",
                                                },
                                                [
                                                  item.price.monthPrice
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order-item__price-item flc",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order-item__group-title-key",
                                                            },
                                                            [
                                                              item.price
                                                                .monthPrice.value
                                                                ? _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "price"
                                                                        )(
                                                                          item
                                                                            .price
                                                                            .monthPrice
                                                                            .value
                                                                        )
                                                                      )
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.price
                                                                      .monthPrice
                                                                      .currency
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order-item__group-title-value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.price
                                                                    .monthPrice
                                                                    .postFix
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  item.price.firstPrice
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order-item__price-item flc",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order-item__group-title-key",
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "price"
                                                                    )(
                                                                      item.price
                                                                        .firstPrice
                                                                        .value
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.price
                                                                      .firstPrice
                                                                      .currency
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order-item__group-title-value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.price
                                                                      .firstPrice
                                                                      .postFix
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  item.price.totalPrice
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order-item__price-item flc",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order-item__group-title-key",
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "price"
                                                                    )(
                                                                      item.price
                                                                        .totalPrice
                                                                        .value
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.price
                                                                      .totalPrice
                                                                      .currency
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order-item__group-title-value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.price
                                                                      .totalPrice
                                                                      .postFix
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "page-content-aside page-content-aside--right",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-aside accordion open-accordion js-accordion",
                          },
                          [
                            _c("div", { staticClass: "order-aside__header" }, [
                              _c("h4", { staticClass: "order-aside__title" }, [
                                _vm._v("Информация о заказе"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "link accordion__toggler hide-lg hide-md hide-sm js-accordion__toggler",
                                },
                                [
                                  _c("div", { staticClass: "accordion__open" }, [
                                    _vm._v("Развернуть"),
                                  ]),
                                  _c("div", { staticClass: "accordion__close" }, [
                                    _vm._v("Свернуть"),
                                  ]),
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon svg-icon--arrow-down accordion__toggler-arrow-down",
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#svg-icon-arrow-down",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "accordion__content js-accordion__content",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "order-aside__content" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "order-aside__group" },
                                      [
                                        _vm.order.status
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "order-aside__group-title",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "order-aside__group-title-key",
                                                  },
                                                  [_vm._v("Статус выполнения: ")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "order-aside__group-title-value",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.order.status.text
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(_vm.order.props, function (item) {
                                          return [
                                            item.title
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "order-aside__props-title",
                                                  },
                                                  [_vm._v(_vm._s(item.title))]
                                                )
                                              : _vm._e(),
                                            item.items.length
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "order-aside__props",
                                                  },
                                                  _vm._l(
                                                    item.items,
                                                    function (prop) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order-aside__prop",
                                                        },
                                                        [
                                                          prop.name
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "order-aside__prop-name",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      prop.name
                                                                    ) + ": "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          prop.value
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "order-aside__prop-value",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      prop.value
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ]
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "order-aside__props-title",
                                          },
                                          [_vm._v("Сумма заказа")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "order-aside__price" },
                                          [
                                            _vm.order.price.firstPrice
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "order-aside__price-item flc",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "order-aside__group-title-key",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("price")(
                                                              _vm.order.price
                                                                .firstPrice.value
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "order-aside__group-title-value",
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "  " +
                                                              _vm._s(
                                                                _vm.order.price
                                                                  .firstPrice
                                                                  .currency
                                                              )
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.order.price
                                                                .firstPrice
                                                                .postFix
                                                            )
                                                        ),
                                                        _c("span", [
                                                          _vm._v(
                                                            " итого к оплате (первым взносом)"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.order.price.totalPrice
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "order-aside__price-item flc",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "order-aside__group-title-key",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("price")(
                                                              _vm.order.price
                                                                .totalPrice.value
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "order-aside__group-title-value",
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "  " +
                                                              _vm._s(
                                                                _vm.order.price
                                                                  .totalPrice
                                                                  .currency
                                                              )
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.order.price
                                                                .totalPrice
                                                                .postFix
                                                            )
                                                        ),
                                                        _c("span", [
                                                          _vm._v(
                                                            " общая стоимость заказа"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$1c = [];
  __vue_render__$1c._withStripped = true;

    /* style */
    const __vue_inject_styles__$1i = undefined;
    /* scoped */
    const __vue_scope_id__$1i = undefined;
    /* module identifier */
    const __vue_module_identifier__$1i = undefined;
    /* functional template */
    const __vue_is_functional_template__$1i = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1i = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1c, staticRenderFns: __vue_staticRenderFns__$1c },
      __vue_inject_styles__$1i,
      __vue_script__$1i,
      __vue_scope_id__$1i,
      __vue_is_functional_template__$1i,
      __vue_module_identifier__$1i,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1j = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        type: null,
        items: null
      };
    },
    props: {
      three: {
        type: Boolean,
        default: false
      },
      moreBtn: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      dataSet: function dataSet(data) {
        this.type = data.type;
        this.items = data.items;
      },
      requestMore: function requestMore() {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var data, currentArr;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return fetch('/local/assets/dist/fixtures/support-b2b-level-2.json').then(function (res) {
                    return res.json();
                  });

                case 2:
                  data = _context.sent;

                  if (data.items) {
                    currentArr = _this.items;
                    _this.items = currentArr.concat(data.items);
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    }
  };

  /* script */
  const __vue_script__$1j = script$1j;

  /* template */
  var __vue_render__$1d = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-tiles tiles", class: ["tiles--" + _vm.type] },
      [
        _c(
          "div",
          { staticClass: "tiles__items", class: { "tiles--three": _vm.three } },
          _vm._l(_vm.items, function (item, i) {
            return _c("v-tiles-item", {
              key: i,
              attrs: { item: item, type: _vm.type },
            })
          }),
          1
        ),
        _vm.moreBtn
          ? _c("div", { staticClass: "tiles__more" }, [
              _c(
                "button",
                {
                  staticClass: "tiles__more-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.requestMore },
                },
                [
                  _vm._v("Показать еще"),
                  _c("svg", { staticClass: "tiles__more-btn-icon" }, [
                    _c("use", { attrs: { href: "#svg-icon-arrow-down" } }),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
      ]
    )
  };
  var __vue_staticRenderFns__$1d = [];
  __vue_render__$1d._withStripped = true;

    /* style */
    const __vue_inject_styles__$1j = undefined;
    /* scoped */
    const __vue_scope_id__$1j = undefined;
    /* module identifier */
    const __vue_module_identifier__$1j = undefined;
    /* functional template */
    const __vue_is_functional_template__$1j = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1j = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1d, staticRenderFns: __vue_staticRenderFns__$1d },
      __vue_inject_styles__$1j,
      __vue_script__$1j,
      __vue_scope_id__$1j,
      __vue_is_functional_template__$1j,
      __vue_module_identifier__$1j,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$1k = {
    data: function data() {
      return {
        open: false
      };
    },
    props: {
      type: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
      item: {
        type: Object,
        default: null
      }
    },
    methods: {
      slideDown: function slideDown(element) {
        var slideDown = function slideDown(target) {
          var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
          target.style.removeProperty('display');
          var display = window.getComputedStyle(target).display;
          if (display === 'none') display = 'block';
          target.style.display = display;
          var height = target.offsetHeight;
          target.style.overflow = 'hidden';
          target.style.height = 0;
          target.style.paddingTop = 0;
          target.style.paddingBottom = 0;
          target.style.marginTop = 0;
          target.style.marginBottom = 0;
          target.offsetHeight;
          target.style.boxSizing = 'border-box';
          target.style.transitionProperty = 'height, margin, padding';
          target.style.transitionDuration = duration + 'ms';
          target.style.height = height + 'px';
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          window.setTimeout(function () {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
          }, duration);
        };

        slideDown(element, 200);
      },
      slideUp: function slideUp(element) {
        var slideUp = function slideUp(target) {
          var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
          target.style.transitionProperty = 'height, margin, padding';
          target.style.transitionDuration = duration + 'ms';
          target.style.boxSizing = 'border-box';
          target.style.height = target.offsetHeight + 'px';
          target.offsetHeight;
          target.style.overflow = 'hidden';
          target.style.height = 0;
          target.style.paddingTop = 0;
          target.style.paddingBottom = 0;
          target.style.marginTop = 0;
          target.style.marginBottom = 0;
          window.setTimeout(function () {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
          }, duration);
        };

        slideUp(element, 200);
      }
    }
  };

  /* script */
  const __vue_script__$1k = script$1k;

  /* template */
  var __vue_render__$1e = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "tiles__item",
        class: [
          "tiles__item--" + _vm.type,
          _vm.item.drop ? "tiles__item--drop" : "",
        ],
      },
      [
        _c(
          "a",
          { staticClass: "tiles__item-link", attrs: { href: _vm.item.link } },
          [
            _vm.item.title
              ? _c("div", { staticClass: "tiles__item-title flc" }, [
                  _vm._v(_vm._s(_vm.item.title)),
                ])
              : _vm._e(),
            _vm.item.text
              ? _c("div", { staticClass: "tiles__item-text flc" }, [
                  _vm._v(_vm._s(_vm.item.text)),
                ])
              : _vm._e(),
            _vm.item.icon
              ? _c("img", {
                  staticClass: "tiles__item-icon flc",
                  attrs: { src: _vm.item.icon, alt: "alt" },
                })
              : _vm._e(),
            _vm.item.label
              ? _c("div", { staticClass: "tiles__item-label flc" }, [
                  _vm._v(_vm._s(_vm.item.label)),
                ])
              : _vm._e(),
          ]
        ),
        _vm.item.drop
          ? _c(
              "div",
              { staticClass: "tiles__drop", class: { open: _vm.open } },
              [
                _c(
                  "div",
                  {
                    staticClass: "tiles__drop-toggle",
                    on: {
                      click: function ($event) {
                        _vm.open = !_vm.open;
                      },
                    },
                  },
                  [
                    _c("svg", { staticClass: "tiles__drop-toggle-icon" }, [
                      _c("use", { attrs: { href: "#svg-icon-arrow-down-big" } }),
                    ]),
                  ]
                ),
                _c(
                  "transition",
                  {
                    attrs: { name: "content-fade" },
                    on: { enter: _vm.slideDown, leave: _vm.slideUp },
                  },
                  [
                    _vm.item.drop && _vm.open
                      ? _c(
                          "div",
                          { staticClass: "tiles__drop-list" },
                          _vm._l(_vm.item.drop, function (drop) {
                            return _c(
                              "a",
                              {
                                staticClass: "tiles__drop-link",
                                attrs: { href: drop.link },
                              },
                              [
                                _vm._v(_vm._s(drop.text)),
                                _c(
                                  "svg",
                                  { staticClass: "tiles__drop-btn-icon" },
                                  [
                                    _c("use", {
                                      attrs: { href: "#svg-icon-arrow-right" },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]
    )
  };
  var __vue_staticRenderFns__$1e = [];
  __vue_render__$1e._withStripped = true;

    /* style */
    const __vue_inject_styles__$1k = undefined;
    /* scoped */
    const __vue_scope_id__$1k = undefined;
    /* module identifier */
    const __vue_module_identifier__$1k = undefined;
    /* functional template */
    const __vue_is_functional_template__$1k = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1k = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1e, staticRenderFns: __vue_staticRenderFns__$1e },
      __vue_inject_styles__$1k,
      __vue_script__$1k,
      __vue_scope_id__$1k,
      __vue_is_functional_template__$1k,
      __vue_module_identifier__$1k,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1l = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        value: '',
        isOpen: false,
        resultItems: null,
        resultCount: null,
        resultLink: null,
        searchTimeout: null
      };
    },
    props: {
      remote: null
    },
    methods: {
      submitSearch: function submitSearch() {
        if (this.value && this.value.length > 1 && this.resultLink) {
          window.location = this.resultLink;
        }
      },
      clearSearch: function clearSearch() {
        this.value = '';
        this.resultItems = null;
        this.resultTotal = null;
        this.resultLink = null;
      },
      searchInput: function searchInput() {
        clearTimeout(this.searchTimeout);

        if (this.value && this.value.length > 1) {
          this.searchTimeout = setTimeout(this.requestDataLoad, 200);
        } else if (this.value && this.value.length == 1) {
          this.resultItems = null;
          this.resultTotal = null;
          this.dataSet({
            "items": 0,
            "resultCount": 0,
            "resultLink": '/search/?q=' + this.value
          });
        } else if (!this.value) {
          this.clearSearch();
        } else {
          this.resultItems = null;
          this.resultTotal = null;
          this.resultLink = null;
        }
      },
      requestDataLoad: function requestDataLoad() {
        this.dataLoad({
          url: this.remote,
          delay: true,
          data: {
            query: this.value,
            bxajaxid: this.bxajaxid
          }
        });
      },
      dataSet: function dataSet(data) {
        this.resultItems = data.items;
        this.resultCount = data.resultCount;
        this.resultLink = data.resultLink;
      },
      clickOutside: function clickOutside(e) {
        if (!this.$el.contains(e.target)) {
          this.clearSearch();
        }
      }
    },
    created: function created() {
      document.addEventListener('click', this.clickOutside);
    },
    destroyed: function destroyed() {
      document.removeEventListener('click', this.clickOutside);
    }
  };

  /* script */
  const __vue_script__$1l = script$1l;

  /* template */
  var __vue_render__$1f = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-search search" }, [
      _c(
        "form",
        {
          staticClass: "search__field",
          on: {
            submit: function ($event) {
              $event.preventDefault();
              return _vm.submitSearch.apply(null, arguments)
            },
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value",
              },
            ],
            staticClass: "search__input",
            attrs: { type: "text", placeholder: "Что будем искать?" },
            domProps: { value: _vm.value },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.value = $event.target.value;
                },
                _vm.searchInput,
              ],
            },
          }),
          _c(
            "button",
            {
              staticClass: "search__submit",
              attrs: { type: "submit", "aria-label": "Найти" },
            },
            [
              _c("svg", { staticClass: "svg-icon search__submit-icon" }, [
                _c("use", { attrs: { "xlink:href": "#svg-icon-lens" } }),
              ]),
            ]
          ),
          _vm.value && _vm.value.length > 1
            ? _c(
                "button",
                {
                  staticClass: "search__clear",
                  attrs: { type: "button", "aria-label": "Очистить" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation();
                      return _vm.clearSearch.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("svg", { staticClass: "svg-icon search__clear-icon" }, [
                    _c("use", { attrs: { "xlink:href": "#svg-icon-close-sm" } }),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm.resultLink
        ? _c("div", { staticClass: "search__result" }, [
            _vm.resultItems.length || _vm.resultCount
              ? _c(
                  "div",
                  { staticClass: "search__result-list" },
                  [
                    _vm._l(_vm.resultItems, function (item) {
                      return _c("div", { staticClass: "search__result-item" }, [
                        _c("a", {
                          staticClass: "search__result-item-link",
                          attrs: { href: item.link },
                          domProps: { innerHTML: _vm._s(item.text) },
                        }),
                        _c("svg", { staticClass: "search__result-item-arrow" }, [
                          _c("use", { attrs: { href: "#svg-icon-arrow-right" } }),
                        ]),
                      ])
                    }),
                    _c("div", { staticClass: "search__result-total" }, [
                      _c(
                        "a",
                        {
                          staticClass: "search__result-total-link",
                          attrs: { href: _vm.resultLink },
                        },
                        [
                          _vm._v(
                            "Смотреть все результаты (" +
                              _vm._s(_vm.resultCount) +
                              ")"
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "search__result-total-label",
                          attrs: { href: _vm.resultLink },
                        },
                        [_vm._v("Всего найдено: " + _vm._s(_vm.resultCount))]
                      ),
                    ]),
                  ],
                  2
                )
              : _c("div", { staticClass: "search__result-empty" }, [
                  _vm._v("По запросу «"),
                  _c("b", [_vm._v(_vm._s(_vm.value))]),
                  _vm._v("» ничего не найдено"),
                ]),
          ])
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$1f = [];
  __vue_render__$1f._withStripped = true;

    /* style */
    const __vue_inject_styles__$1l = undefined;
    /* scoped */
    const __vue_scope_id__$1l = undefined;
    /* module identifier */
    const __vue_module_identifier__$1l = undefined;
    /* functional template */
    const __vue_is_functional_template__$1l = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1l = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1f, staticRenderFns: __vue_staticRenderFns__$1f },
      __vue_inject_styles__$1l,
      __vue_script__$1l,
      __vue_scope_id__$1l,
      __vue_is_functional_template__$1l,
      __vue_module_identifier__$1l,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1m = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        page: null,
        items: null,
        remote: null
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        console.log(data);
        this.items = data.items;
        this.page = data.page;
        this.remote = data.remote;
      },
      navigate: function navigate(page) {
        this.page.offset = page.offset;
        this.page.limit = page.limit;
        this.requestDataLoad();
        animate({
          duration: 1000,
          timing: function timing(timeFraction) {
            return timeFraction;
          },
          // линейная функция значит, что анимация идёт с одной и той же скоростью
          draw: function draw(progress) {
            document.documentElement.scrollTop = document.documentElement.scrollTop - progress * document.documentElement.scrollTop;
          }
        });
      },
      requestDataLoad: function requestDataLoad(dataSetOptions) {
        this.dataLoad({
          url: this.remote,
          delay: true,
          data: {
            page: this.page
          }
        }, dataSetOptions);
      }
    }
  };

  /* script */
  const __vue_script__$1m = script$1m;

  /* template */
  var __vue_render__$1g = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "faq-result" }, [
      _vm.items
        ? _c(
            "div",
            { staticClass: "faq-result__list" },
            _vm._l(_vm.items, function (item) {
              return _c("div", { staticClass: "faq-result__item" }, [
                _c("a", {
                  staticClass: "faq-result__item-link",
                  attrs: { href: item.link },
                  domProps: { innerHTML: _vm._s(item.title) },
                }),
                item.text
                  ? _c("div", {
                      staticClass: "faq-result__item-text",
                      domProps: { innerHTML: _vm._s(item.text) },
                    })
                  : _vm._e(),
                item.path
                  ? _c(
                      "div",
                      { staticClass: "faq-result__path" },
                      _vm._l(item.path, function (path) {
                        return _c(
                          "a",
                          {
                            staticClass: "faq-result__path-item",
                            attrs: { href: path.link },
                          },
                          [
                            _vm._v(_vm._s(path.text)),
                            _c("svg", { staticClass: "faq-result__path-arrow" }, [
                              _c("use", {
                                attrs: { href: "#svg-icon-arrow-right" },
                              }),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm.page
        ? _c(
            "div",
            { staticClass: "faq-result__nav" },
            [
              _c("v-page-nav", {
                attrs: { page: _vm.page },
                on: { navigate: _vm.navigate },
              }),
            ],
            1
          )
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$1g = [];
  __vue_render__$1g._withStripped = true;

    /* style */
    const __vue_inject_styles__$1m = undefined;
    /* scoped */
    const __vue_scope_id__$1m = undefined;
    /* module identifier */
    const __vue_module_identifier__$1m = undefined;
    /* functional template */
    const __vue_is_functional_template__$1m = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1m = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1g, staticRenderFns: __vue_staticRenderFns__$1g },
      __vue_inject_styles__$1m,
      __vue_script__$1m,
      __vue_scope_id__$1m,
      __vue_is_functional_template__$1m,
      __vue_module_identifier__$1m,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$1n = {
    data: function data() {
      return {};
    },
    props: {
      items: {
        type: Array,
        default: null
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        var vm = this;
        var slidesWidth = 0;
        var oldProgress = 2; // если слайды не влезают в контейнер добавляем тень

        function setShadow() {
          if (oldProgress != this.progress) {
            if (this.progress <= 0) {
              vm.$refs.shadow.classList.remove('start');
              vm.$refs.shadow.classList.add('end');
            } else if (this.progress >= 1) {
              vm.$refs.shadow.classList.remove('end');
              vm.$refs.shadow.classList.add('start');
            } else {
              vm.$refs.shadow.classList.add('end');
              vm.$refs.shadow.classList.add('start');
            }

            oldProgress = this.progress;
          }
        }

        return {
          slidesPerView: 'auto',
          touchReleaseOnEdges: true,
          spaceBetween: 12,
          threshold: 60,
          initialSlide: this.items.findIndex(function (item) {
            return item.active;
          }),
          // если родительский контейнер не виден (display none)
          observer: true,
          observeParents: true,
          freeMode: true,
          on: {
            init: function init() {
              slidesWidth = 0;
              Array.from(this.slides).forEach(function (slide) {
                slidesWidth += slide.offsetWidth;
              });

              if (slidesWidth > this.wrapperEl.offsetWidth + 1) {
                setShadow.bind(this);
              } else {
                vm.$refs.shadow.classList.remove('start');
                vm.$refs.shadow.classList.remove('end');
              }
            },
            resize: function resize() {
              slidesWidth = 0;
              Array.from(this.slides).forEach(function (slide) {
                slidesWidth += slide.offsetWidth;
              });

              if (slidesWidth > this.wrapperEl.offsetWidth + 1) {
                setShadow.bind(this);
              } else {
                vm.$refs.shadow.classList.remove('start');
                vm.$refs.shadow.classList.remove('end');
              }
            },
            progress: setShadow,
            reachBeginning: function reachBeginning() {
              if (slidesWidth > this.wrapperEl.offsetWidth) {
                vm.$refs.shadow.classList.remove('start');
                vm.$refs.shadow.classList.add('end');
              }
            },
            reachEnd: function reachEnd() {
              if (slidesWidth > this.wrapperEl.offsetWidth) {
                vm.$refs.shadow.classList.remove('end');
                vm.$refs.shadow.classList.add('start');
              }
            }
          }
        };
      }
    }
  };

  /* script */
  const __vue_script__$1n = script$1n;

  /* template */
  var __vue_render__$1h = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "tags" }, [
      _c("div", { ref: "shadow", staticClass: "tags__shadow" }),
      _c(
        "div",
        { staticClass: "tags__items" },
        [
          _vm.items && _vm.items.length
            ? _c(
                "v-swiper",
                { ref: "carousel", attrs: { options: _vm.computedOptions } },
                _vm._l(_vm.items, function (item, index) {
                  return _c("v-swiper-slide", { key: item.link + "-" + index }, [
                    _c(
                      "a",
                      {
                        ref: item.active ? "activeTag" : null,
                        refInFor: true,
                        staticClass: "tags__item",
                        class: { active: item.active },
                        attrs: { href: item.link },
                      },
                      [
                        _c("span", { staticClass: "tags__item-text" }, [
                          _vm._v(_vm._s(item.text)),
                        ]),
                      ]
                    ),
                  ])
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ])
  };
  var __vue_staticRenderFns__$1h = [];
  __vue_render__$1h._withStripped = true;

    /* style */
    const __vue_inject_styles__$1n = undefined;
    /* scoped */
    const __vue_scope_id__$1n = undefined;
    /* module identifier */
    const __vue_module_identifier__$1n = undefined;
    /* functional template */
    const __vue_is_functional_template__$1n = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1n = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1h, staticRenderFns: __vue_staticRenderFns__$1h },
      __vue_inject_styles__$1n,
      __vue_script__$1n,
      __vue_scope_id__$1n,
      __vue_is_functional_template__$1n,
      __vue_module_identifier__$1n,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$1o = {
    data: function data() {
      return {
        active: {}
      };
    },
    props: {
      items: {
        type: Array,
        default: null
      }
    },
    mounted: function mounted() {
      var _this = this;

      var urlParam = this.checkParams('faq');

      if (urlParam) {
        this.items.forEach(function (item) {
          if (item.id === urlParam) {
            _this.active = item;

            _this.$nextTick(function () {
              _this.scrollToOpen(item.id);
            });
          }
        });
      }
    },
    methods: {
      toggle: function toggle(item) {
        if (this.active && item.id === this.active.id) {
          this.active = {};
          this.removeParam();
        } else {
          this.active = item;
          this.updateURL('faq', item.id);
        }
      },
      checkParams: function checkParams(key) {
        key = key.replace(/[*+?^$.[\]{}()|\\/]/g, '\\$&');
        var match = location.search.match(new RegExp('[?&]' + key + '=([^&]+)(&|$)'));
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
      },
      updateURL: function updateURL(key, value) {
        if (history.pushState) {
          var baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
          var newUrl = baseUrl + "?".concat(key, "=").concat(value);
          history.pushState(null, null, newUrl);
        }
      },
      removeParam: function removeParam() {
        if (history.pushState) {
          var baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
          history.pushState(null, null, baseUrl);
        }
      },
      scrollToOpen: function scrollToOpen(id) {
        if (id) {
          var el = document.getElementById(id);
          var top = el.getBoundingClientRect().top;
          window.scrollTo(0, top - window.innerHeight / 2);
        }
      }
    }
  };

  /* script */
  const __vue_script__$1o = script$1o;

  /* template */
  var __vue_render__$1i = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm.items
      ? _c(
          "div",
          { staticClass: "specification specification--alt" },
          _vm._l(_vm.items, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "specification__group accordion",
                class: { "open-accordion": item.id === _vm.active.id },
                attrs: { id: item.id },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "specification__caption accordion__toggler",
                    on: {
                      click: function ($event) {
                        return _vm.toggle(item)
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(item.title))]),
                    _c("div", { staticClass: "accordion__plus" }),
                  ]
                ),
                _c("v-transition-expand", [
                  item.id === _vm.active.id
                    ? _c("div", { staticClass: "accordion__body" }, [
                        _c("div", { staticClass: "specification__table" }, [
                          _c("div", {
                            staticClass: "specification__text-row",
                            domProps: { innerHTML: _vm._s(item.text) },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            )
          }),
          0
        )
      : _vm._e()
  };
  var __vue_staticRenderFns__$1i = [];
  __vue_render__$1i._withStripped = true;

    /* style */
    const __vue_inject_styles__$1o = undefined;
    /* scoped */
    const __vue_scope_id__$1o = undefined;
    /* module identifier */
    const __vue_module_identifier__$1o = undefined;
    /* functional template */
    const __vue_is_functional_template__$1o = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1o = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1i, staticRenderFns: __vue_staticRenderFns__$1i },
      __vue_inject_styles__$1o,
      __vue_script__$1o,
      __vue_scope_id__$1o,
      __vue_is_functional_template__$1o,
      __vue_module_identifier__$1o,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1p = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        workListData: null,
        loading: false,
        localFormData: {},
        state: {
          page: null,
          sort: null,
          view: null
        }
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (options.append && this.workListData && this.workListData.items) {
          var oldItems = this.workListData.items;
          this.workListData = data;
          this.workListData.items = oldItems.concat(this.workListData.items);
        } else {
          this.workListData = data;
        }

        this.state.page = this.workListData.page;
        document.activeElement.blur();
        setTimeout(function () {
          animate({
            duration: 1000,
            timing: function timing(timeFraction) {
              return timeFraction;
            },
            draw: function draw(progress) {
              document.documentElement.scrollTop += Math.round(document.body.getBoundingClientRect().top * progress);
            }
          });
        }, 300);
      },
      fieldChanged: function fieldChanged(field) {
        this.localFormData[field.id] = field.value;
        this.requestDataLoad();
      },
      requestDataLoad: function requestDataLoad(dataSetOptions) {
        this.dataLoad({
          url: this.workListData.remote,
          delay: true,
          data: {
            page: this.state.page,
            filter: this.localFormData
          }
        }, dataSetOptions);
      },
      navigate: function navigate(page) {
        this.state.page.offset = page.offset;
        this.state.page.limit = page.limit;
        this.requestDataLoad();
      }
    }
  };

  /* script */
  const __vue_script__$1p = script$1p;

  /* template */
  var __vue_render__$1j = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm.workListData
      ? _c(
          "div",
          { ref: "workList", staticClass: "v-work-list work-list" },
          [
            _c("v-loader", { attrs: { loading: _vm.loading } }),
            _vm.workListData.filters
              ? _c(
                  "div",
                  { staticClass: "work-list__filters" },
                  _vm._l(_vm.workListData.filters, function (filter) {
                    return _c("v-field", {
                      key: filter.id,
                      staticClass: "work-list__filter",
                      attrs: { field: filter },
                      on: {
                        input: function ($event) {
                          return _vm.fieldChanged(filter, $event)
                        },
                      },
                      model: {
                        value: filter.value,
                        callback: function ($$v) {
                          _vm.$set(filter, "value", $$v);
                        },
                        expression: "filter.value",
                      },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm.workListData.items && _vm.workListData.items.length
              ? [
                  _c(
                    "div",
                    { staticClass: "work-list__items" },
                    _vm._l(_vm.workListData.items, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "work-list__item" },
                        [
                          item.features
                            ? _c(
                                "div",
                                { staticClass: "work-list__item-features" },
                                _vm._l(item.features, function (feature, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: i,
                                      staticClass: "work-list__item-feature",
                                    },
                                    [
                                      feature.label
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "work-list__item-feature-label",
                                            },
                                            [_vm._v(_vm._s(feature.label) + ": ")]
                                          )
                                        : _vm._e(),
                                      feature.text
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "work-list__item-feature-text",
                                            },
                                            [_vm._v(_vm._s(feature.text))]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          item.text
                            ? _c("div", { staticClass: "work-list__item-text" }, [
                                _vm._v(_vm._s(item.text)),
                              ])
                            : _vm._e(),
                          item.date
                            ? _c(
                                "div",
                                { staticClass: "work-list__item-features" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "work-list__item-feature" },
                                    [
                                      item.date.label
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "work-list__item-feature-label",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.date.label) + ": "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      item.date.text
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "work-list__item-feature-text",
                                            },
                                            [_vm._v(_vm._s(item.date.text))]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm.workListData.page
                    ? _c(
                        "div",
                        { staticClass: "work-list__nav" },
                        [
                          _c("v-page-nav", {
                            attrs: { page: _vm.workListData.page },
                            on: { navigate: _vm.navigate },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              : [
                  _c("div", { staticClass: "work-list__message" }, [
                    _vm._v(_vm._s(_vm.workListData.message)),
                  ]),
                ],
          ],
          2
        )
      : _vm._e()
  };
  var __vue_staticRenderFns__$1j = [];
  __vue_render__$1j._withStripped = true;

    /* style */
    const __vue_inject_styles__$1p = undefined;
    /* scoped */
    const __vue_scope_id__$1p = undefined;
    /* module identifier */
    const __vue_module_identifier__$1p = undefined;
    /* functional template */
    const __vue_is_functional_template__$1p = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1p = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1j, staticRenderFns: __vue_staticRenderFns__$1j },
      __vue_inject_styles__$1p,
      __vue_script__$1p,
      __vue_scope_id__$1p,
      __vue_is_functional_template__$1p,
      __vue_module_identifier__$1p,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1q = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        data: null,
        loading: false,
        localFormData: {}
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        this.data = data;
      },
      fieldChanged: function fieldChanged(field) {
        this.localFormData[field.id] = field.value;
        this.requestDataLoad();
      },
      requestDataLoad: function requestDataLoad(dataSetOptions) {
        this.dataLoad({
          url: this.data.remote,
          delay: true,
          data: {
            filter: this.localFormData
          }
        }, dataSetOptions);
      }
    }
  };

  /* script */
  const __vue_script__$1q = script$1q;

  /* template */
  var __vue_render__$1k = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm.data
      ? _c(
          "div",
          { ref: "workList", staticClass: "v-stock stock" },
          [
            _c("v-loader", { attrs: { loading: _vm.loading } }),
            _vm.data.title
              ? _c("div", { staticClass: "stock__title" }, [
                  _vm._v(_vm._s(_vm.data.title)),
                ])
              : _vm._e(),
            _vm.data.subtitle
              ? _c("div", {
                  staticClass: "stock__subtitle",
                  domProps: { innerHTML: _vm._s(_vm.data.subtitle) },
                })
              : _vm._e(),
            _vm.data.filters || _vm.data.actions
              ? _c(
                  "div",
                  { staticClass: "stock__filters" },
                  [
                    _vm._l(_vm.data.filters, function (filter) {
                      return _c("v-field", {
                        key: filter.id,
                        staticClass: "stock__filter",
                        attrs: { field: filter },
                        on: {
                          input: function ($event) {
                            return _vm.fieldChanged(filter, $event)
                          },
                        },
                        model: {
                          value: filter.value,
                          callback: function ($$v) {
                            _vm.$set(filter, "value", $$v);
                          },
                          expression: "filter.value",
                        },
                      })
                    }),
                    _vm._l(_vm.data.actions, function (action) {
                      return _c(
                        "a",
                        {
                          staticClass: "stock__filter link",
                          attrs: { href: action.link },
                        },
                        [
                          _vm._v(_vm._s(action.text)),
                          _c(
                            "svg",
                            {
                              staticClass:
                                "svg-icon svg-icon svg-icon--arrow-right",
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#svg-icon-arrow-right" },
                              }),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm.data.items && _vm.data.items.length
              ? [
                  _c("hr", { staticClass: "stock__hr" }),
                  _c(
                    "div",
                    { staticClass: "stock__items" },
                    _vm._l(_vm.data.items, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "stock__item" },
                        [
                          item.count
                            ? _c("div", { staticClass: "stock__item-count" }, [
                                _c(
                                  "div",
                                  { staticClass: "stock__item-count-indicators" },
                                  _vm._l(3, function (count, i) {
                                    return _c("div", {
                                      key: i,
                                      staticClass: "stock__item-count-indicator",
                                      class: {
                                        active: item.count.value >= i + 1,
                                      },
                                    })
                                  }),
                                  0
                                ),
                                item.count.label
                                  ? _c(
                                      "span",
                                      { staticClass: "stock__item-count-text" },
                                      [_vm._v(_vm._s(item.count.label))]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "stock__item-content" }, [
                            item.title
                              ? _c("div", { staticClass: "stock__item-title" }, [
                                  _vm._v(_vm._s(item.title)),
                                ])
                              : _vm._e(),
                            item.subtitle
                              ? _c("div", {
                                  staticClass: "stock__item-subtitle",
                                  domProps: { innerHTML: _vm._s(item.subtitle) },
                                })
                              : _vm._e(),
                            item.text
                              ? _c("div", {
                                  staticClass: "stock__item-text",
                                  domProps: { innerHTML: _vm._s(item.text) },
                                })
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              : [
                  _c("div", { staticClass: "stock__message" }, [
                    _vm._v(_vm._s(_vm.data.message)),
                  ]),
                ],
          ],
          2
        )
      : _vm._e()
  };
  var __vue_staticRenderFns__$1k = [];
  __vue_render__$1k._withStripped = true;

    /* style */
    const __vue_inject_styles__$1q = undefined;
    /* scoped */
    const __vue_scope_id__$1q = undefined;
    /* module identifier */
    const __vue_module_identifier__$1q = undefined;
    /* functional template */
    const __vue_is_functional_template__$1q = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1q = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1k, staticRenderFns: __vue_staticRenderFns__$1k },
      __vue_inject_styles__$1q,
      __vue_script__$1q,
      __vue_scope_id__$1q,
      __vue_is_functional_template__$1q,
      __vue_module_identifier__$1q,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1r = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        menu: [],
        openMenuId: null,
        openTimeout: null,
        closeTimeout: null,
        touch: controller.touch
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        this.menu.push(data);
        this.menu.sort(function (groupA, groupB) {
          return groupA.type && groupA.type === 'catalog' ? 1 : -1;
        });
        this.menu.forEach(function (group, groupIndex) {
          group.items.forEach(function (item, itemIndex) {
            item.menuId = groupIndex + '-' + itemIndex;
          });
        });
        controller.updateMobileNav(data);
      },
      mouseenter: function mouseenter(item) {
        if (this.touch) {
          return;
        }

        if (item.items && item.items.length) {
          clearTimeout(item.closeTimeout);
          clearTimeout(this.closeTimeout);
          this.openMenuId = item.menuId;
          document.body.classList.add('state--sub-menu-open');
          controller.$emit('search-popup-close');
          controller.$emit('search-small-close');
          controller.$emit('question-popup-close');
          controller.$emit('user-small-close');
        }
      },
      mouseleave: function mouseleave(item) {
        var _this = this;

        if (this.touch) {
          return;
        }

        if (item.items && item.items.length) {
          this.closeTimeout = item.closeTimeout = setTimeout(function () {
            document.body.classList.remove('state--sub-menu-open');
            _this.openMenuId = null;
          }, 500);
        }
      },
      mousemove: function mousemove(item) {
        if (this.touch) {
          return;
        }

        if (item.items && item.items.length) {
          clearTimeout(item.closeTimeout);
          clearTimeout(this.closeTimeout);
          this.openMenuId = item.menuId;
        }
      },
      itemClick: function itemClick(item, e) {
        if (!this.touch) {
          return;
        }

        if (this.openMenuId !== item.menuId && item.items && item.items.length) {
          e.preventDefault();
          this.openMenuId = item.menuId;
        } else {
          this.openMenuId = null;
        }
      },
      handleClickOutside: function handleClickOutside(e) {
        if (!this.$el.contains(e.target)) {
          this.openMenuId = null;
        }
      },
      handleEsc: function handleEsc(e) {
        if (e.keyCode == 27) {
          this.openMenuId = null;
        }
      }
    },
    created: function created() {
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleEsc);
    },
    mounted: function mounted() {
      window.addEventListener('resize', function () {
        if (window.innerWidth >= breakpoints['md-min']) {
          controller.closeMobileNav();
        }
      });
    },
    destroyed: function destroyed() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleEsc);
    }
  };

  /* script */
  const __vue_script__$1r = script$1r;

  /* template */
  var __vue_render__$1l = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("nav", { staticClass: "v-main-nav main-nav" }, [
      _c(
        "div",
        { staticClass: "main-nav__layout" },
        [
          _vm._l(_vm.menu, function (group) {
            return _vm._l(group.items, function (item) {
              return _c("div", { staticClass: "main-nav__cell" }, [
                _c(
                  "a",
                  {
                    staticClass: "main-nav__link",
                    class: {
                      "main-nav__link--open":
                        _vm.openMenuId === item.menuId || item.active,
                      "main-nav__link--dd":
                        (item.items && item.items.length) ||
                        (item.aside && item.aside.length) ||
                        item.footer,
                    },
                    attrs: { href: item.link, tabindex: "0" },
                    on: {
                      mouseenter: function ($event) {
                        return _vm.mouseenter(item)
                      },
                      mouseleave: function ($event) {
                        return _vm.mouseleave(item)
                      },
                      mousemove: function ($event) {
                        return _vm.mousemove(item)
                      },
                      click: function ($event) {
                        return _vm.itemClick(item, $event)
                      },
                    },
                  },
                  [
                    item.icon
                      ? _c(
                          "svg",
                          { staticClass: "svg-icon main-nav__link-icon" },
                          [_c("use", { attrs: { "xlink:href": item.icon } })]
                        )
                      : _vm._e(),
                    item.text
                      ? _c("div", { staticClass: "main-nav__link-main" }, [
                          _vm._v(_vm._s(item.text)),
                        ])
                      : _vm._e(),
                  ]
                ),
                (item.items && item.items.length) ||
                (item.aside && item.aside.length) ||
                item.footer
                  ? _c(
                      "div",
                      {
                        staticClass: "main-nav__dd",
                        class: {
                          "main-nav__dd--open": _vm.openMenuId === item.menuId,
                        },
                        on: {
                          mouseenter: function ($event) {
                            return _vm.mouseenter(item)
                          },
                          mouseleave: function ($event) {
                            return _vm.mouseleave(item)
                          },
                          mousemove: function ($event) {
                            return _vm.mousemove(item)
                          },
                        },
                      },
                      [
                        (item.items && item.items.length) || group.footer
                          ? _c("div", { staticClass: "main-nav__dd-container" }, [
                              _c(
                                "div",
                                { staticClass: "main-nav__dd-grid" },
                                _vm._l(item.items, function (itemL2) {
                                  return _c(
                                    "div",
                                    { staticClass: "main-nav__dd-cell" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "main-nav__dd-list" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "main-nav__dd-list-head flc",
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "main-nav__dd-list-head-link",
                                                  class: {
                                                    "main-nav__dd-list-head-link--link":
                                                      itemL2.link,
                                                  },
                                                  attrs: { href: itemL2.link },
                                                },
                                                [_vm._v(_vm._s(itemL2.text))]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "main-nav__dd-list-body flc",
                                            },
                                            _vm._l(
                                              itemL2.items,
                                              function (itemL3) {
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "main-nav__dd-list-item flc",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "main-nav__dd-list-link",
                                                        class: {
                                                          "main-nav__dd-list-link--all":
                                                            itemL3.type == "all",
                                                        },
                                                        attrs: {
                                                          href: itemL3.link,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(itemL3.text)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                              item.footer
                                ? _c(
                                    "div",
                                    { staticClass: "main-nav__dd-footer" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "main-nav__dd-list-head-link",
                                          class: {
                                            "main-nav__dd-list-head-link--link":
                                              item.footer.link,
                                          },
                                          attrs: { href: item.footer.link },
                                        },
                                        [_vm._v(_vm._s(item.footer.text))]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        item.aside
                          ? _c("div", { staticClass: "main-nav__dd-aside" }, [
                              _c("div", { staticClass: "main-nav__dd-list" }, [
                                _c(
                                  "div",
                                  { staticClass: "main-nav__dd-list-head flc" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "main-nav__dd-list-head-link",
                                      },
                                      [_vm._v(_vm._s(item.aside.text))]
                                    ),
                                  ]
                                ),
                                item.aside.items && item.aside.items.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "main-nav__dd-list-body flc",
                                      },
                                      _vm._l(item.aside.items, function (itemL3) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass: "main-nav__dd-list-item",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "main-nav__dd-list-link",
                                                attrs: { href: itemL3.link },
                                              },
                                              [_vm._v(_vm._s(itemL3.text))]
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ])
            })
          }),
        ],
        2
      ),
    ])
  };
  var __vue_staticRenderFns__$1l = [];
  __vue_render__$1l._withStripped = true;

    /* style */
    const __vue_inject_styles__$1r = undefined;
    /* scoped */
    const __vue_scope_id__$1r = undefined;
    /* module identifier */
    const __vue_module_identifier__$1r = undefined;
    /* functional template */
    const __vue_is_functional_template__$1r = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1r = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1l, staticRenderFns: __vue_staticRenderFns__$1l },
      __vue_inject_styles__$1r,
      __vue_script__$1r,
      __vue_scope_id__$1r,
      __vue_is_functional_template__$1r,
      __vue_module_identifier__$1r,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1s = {
    data: function data() {
      return {
        menu: [],
        openPanels: [],
        openTimeout: null,
        closeTimeout: null,
        touch: controller.touch
      };
    },
    computed: {},
    methods: {
      dataSet: function dataSet(data) {
        this.menu = data;
        this.menu.sort(function (groupA, groupB) {
          var order = {
            'menu': 1,
            'catalog': 2
          };
          return (order[groupA.type] || 0) - (order[groupB.type] || 0);
        });
      },
      open: function open() {
        document.body.classList.add('state--mobile-nav-open');
      },
      close: function close() {
        document.body.classList.remove('state--mobile-nav-open');
      },
      itemClick: function itemClick(item, e) {
        if (item.hasItems) {
          e.preventDefault();
          this.openPanels.push(item.itemId);
        }
      },
      handleResize: function handleResize() {
        if (window.innerWidth >= breakpoints['sm-max'] && this.openPanels && this.openPanels.length) {
          this.close();
        }
      },
      handleEsc: function handleEsc(e) {
        if (e.keyCode == 27) {
          this.close();
        }
      }
    },
    created: function created() {
      this.dataSet(controller.mobileNavData);
      controller.$on('mobile-nav-updated', this.dataSet);
      controller.$on('mobile-nav-open', this.open);
      controller.$on('mobile-nav-close', this.close);
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('keydown', this.handleEsc);
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('keydown', this.handleEsc);
    },
    mounted: function mounted() {
      this.$nextTick(function () {
        view.initAllLocal();
      });
    },
    updated: function updated() {
      this.$nextTick(function () {
        view.initAllLocal();
      });
    }
  };

  /* script */
  const __vue_script__$1s = script$1s;

  /* template */
  var __vue_render__$1m = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("nav", { staticClass: "v-mobile-nav mobile-nav" }, [
      _vm.menu && _vm.menu.length
        ? _c(
            "div",
            { staticClass: "mobile-nav__wrapper" },
            [
              _vm._l(_vm.menu, function (group, groupIndex) {
                return _vm._l(group.items, function (menuItem, index) {
                  return _c(
                    "div",
                    {
                      key: "" + groupIndex + index + new Date().getTime(),
                      staticClass: "mobile-nav__item",
                      class: { "accordion js-accordion": menuItem.items },
                    },
                    [
                      _c("div", { staticClass: "mobile-nav__link" }, [
                        _c(
                          "a",
                          {
                            staticClass: "mobile-nav__link-text",
                            attrs: { href: menuItem.link },
                          },
                          [_vm._v(_vm._s(menuItem.text))]
                        ),
                        menuItem.items && menuItem.items.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "mobile-nav__toggler js-accordion__toggler",
                              },
                              [
                                _c("div", { staticClass: "accordion__icon" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon svg-icon--arrow-down",
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#svg-icon-arrow-down",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      menuItem.items && menuItem.items.length
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "mobile-nav__content accordion__content js-accordion__content",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mobile-nav__list js-accordion-group",
                                },
                                [
                                  _vm._l(
                                    menuItem.items,
                                    function (subitem, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index + new Date().getTime(),
                                          staticClass: "mobile-nav__item",
                                          class: {
                                            accordion:
                                              subitem.items &&
                                              subitem.items.length,
                                            "js-accordion-group__item":
                                              subitem.items &&
                                              subitem.items.length,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "mobile-nav__link" },
                                            [
                                              subitem.text
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "mobile-nav__link-text",
                                                      attrs: {
                                                        href: subitem.link,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(subitem.text))]
                                                  )
                                                : _vm._e(),
                                              subitem.items &&
                                              subitem.items.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mobile-nav__toggler js-accordion-group__toggler",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "accordion__icon",
                                                        },
                                                        [
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "svg-icon svg-icon--arrow-down",
                                                            },
                                                            [
                                                              _c("use", {
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#svg-icon-arrow-down",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          subitem.items && subitem.items.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mobile-nav__sublist accordion__content js-accordion-group__content",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mobile-nav__sublist-wrap",
                                                    },
                                                    _vm._l(
                                                      subitem.items,
                                                      function (lastItem, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key:
                                                              index +
                                                              new Date().getTime(),
                                                            staticClass:
                                                              "mobile-nav__link",
                                                          },
                                                          [
                                                            lastItem.text
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "mobile-nav__link-text",
                                                                    class: {
                                                                      "mobile-nav__link-text--all":
                                                                        lastItem.type ===
                                                                        "all",
                                                                    },
                                                                    attrs: {
                                                                      href: lastItem.link,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        lastItem.text
                                                                      )
                                                                    ),
                                                                    lastItem.type ===
                                                                    "all"
                                                                      ? _c(
                                                                          "svg",
                                                                          {
                                                                            staticClass:
                                                                              "svg-icon svg-icon--arrow-right",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "use",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    "xlink:href":
                                                                                      "#svg-icon-arrow-right",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  menuItem.aside
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "mobile-nav__item",
                                          class: {
                                            accordion:
                                              menuItem.aside.items &&
                                              menuItem.aside.items.length,
                                            "js-accordion-group__item":
                                              menuItem.aside.items &&
                                              menuItem.aside.items.length,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "mobile-nav__link" },
                                            [
                                              menuItem.aside.text
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "mobile-nav__link-text",
                                                      attrs: {
                                                        href: menuItem.aside.link,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          menuItem.aside.text
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              menuItem.aside.items &&
                                              menuItem.aside.items.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mobile-nav__toggler js-accordion-group__toggler",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "accordion__icon",
                                                        },
                                                        [
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "svg-icon svg-icon--arrow-down",
                                                            },
                                                            [
                                                              _c("use", {
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#svg-icon-arrow-down",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          menuItem.aside.items &&
                                          menuItem.aside.items.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mobile-nav__sublist accordion__content js-accordion-group__content",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mobile-nav__sublist-wrap",
                                                    },
                                                    _vm._l(
                                                      menuItem.aside.items,
                                                      function (lastItem, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key:
                                                              index +
                                                              new Date().getTime(),
                                                            staticClass:
                                                              "mobile-nav__link",
                                                          },
                                                          [
                                                            lastItem.text
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "mobile-nav__link-text",
                                                                    attrs: {
                                                                      href: lastItem.link,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        lastItem.text
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                })
              }),
            ],
            2
          )
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$1m = [];
  __vue_render__$1m._withStripped = true;

    /* style */
    const __vue_inject_styles__$1s = undefined;
    /* scoped */
    const __vue_scope_id__$1s = undefined;
    /* module identifier */
    const __vue_module_identifier__$1s = undefined;
    /* functional template */
    const __vue_is_functional_template__$1s = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1s = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1m, staticRenderFns: __vue_staticRenderFns__$1m },
      __vue_inject_styles__$1s,
      __vue_script__$1s,
      __vue_scope_id__$1s,
      __vue_is_functional_template__$1s,
      __vue_module_identifier__$1s,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1t = {
    data: function data() {
      return {
        menu: [],
        openPanels: [],
        openTimeout: null,
        closeTimeout: null,
        touch: controller.touch
      };
    },
    computed: {},
    methods: {
      dataSet: function dataSet(data) {
        this.menu = data;
      },
      open: function open() {
        document.body.classList.add('state--mobile-nav-open');
      },
      close: function close() {
        document.body.classList.remove('state--mobile-nav-open');
      },
      itemClick: function itemClick(item, e) {
        if (item.hasItems) {
          e.preventDefault();
          this.openPanels.push(item.itemId);
        }
      },
      handleResize: function handleResize() {
        if (window.innerWidth >= breakpoints['sm-max'] && this.openPanels && this.openPanels.length) {
          this.close();
        }
      },
      handleEsc: function handleEsc(e) {
        if (e.keyCode == 27) {
          this.close();
        }
      }
    },
    created: function created() {
      this.dataSet(controller.mobileNavData);
      controller.$on('mobile-nav-updated', this.dataSet);
      controller.$on('mobile-nav-open', this.open);
      controller.$on('mobile-nav-close', this.close);
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('keydown', this.handleEsc);
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('keydown', this.handleEsc);
    },
    mounted: function mounted() {
      this.$nextTick(function () {
        view.initAllLocal();
      });
    },
    updated: function updated() {
      this.$nextTick(function () {
        view.initAllLocal();
      });
    }
  };

  /* script */
  const __vue_script__$1t = script$1t;

  /* template */
  var __vue_render__$1n = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("nav", { staticClass: "v-mobile-nav mobile-nav mobile-nav--sup" }, [
      _vm.menu && _vm.menu.length
        ? _c(
            "div",
            { staticClass: "mobile-nav__wrapper" },
            [
              _vm._l(_vm.menu, function (group, groupIndex) {
                return _vm._l(group.items, function (menuItem, index) {
                  return _c(
                    "div",
                    {
                      key: "" + groupIndex + index + new Date().getTime(),
                      staticClass: "mobile-nav__item",
                      class: { "accordion js-accordion": menuItem.items },
                    },
                    [
                      menuItem.link && menuItem.text
                        ? _c("div", { staticClass: "mobile-nav__link" }, [
                            _c(
                              "a",
                              {
                                staticClass: "mobile-nav__link-text",
                                attrs: { href: menuItem.link },
                              },
                              [_vm._v(_vm._s(menuItem.text))]
                            ),
                            menuItem.items && menuItem.items.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mobile-nav__toggler js-accordion__toggler",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "accordion__icon" },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "svg-icon svg-icon--arrow-down",
                                          },
                                          [
                                            _c("use", {
                                              attrs: {
                                                "xlink:href":
                                                  "#svg-icon-arrow-down-big",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      menuItem.items && menuItem.items.length
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "mobile-nav__content accordion__content js-accordion__content",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mobile-nav__list" },
                                _vm._l(menuItem.items, function (subitem, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index + new Date().getTime(),
                                      staticClass: "mobile-nav__item",
                                      class: {
                                        accordion:
                                          subitem.items && subitem.items.length,
                                        "js-accordion-group__item":
                                          subitem.items && subitem.items.length,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "mobile-nav__link" },
                                        [
                                          subitem.text
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "mobile-nav__link-text",
                                                  attrs: { href: subitem.link },
                                                },
                                                [_vm._v(_vm._s(subitem.text))]
                                              )
                                            : _vm._e(),
                                          subitem.items && subitem.items.length
                                            ? _c("div", {
                                                staticClass:
                                                  "mobile-nav__toggler",
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                      subitem.items && subitem.items.length
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "mobile-nav__sublist",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mobile-nav__sublist-wrap",
                                                },
                                                _vm._l(
                                                  subitem.items,
                                                  function (lastItem, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key:
                                                          index +
                                                          new Date().getTime(),
                                                        staticClass:
                                                          "mobile-nav__link",
                                                      },
                                                      [
                                                        lastItem.text
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "mobile-nav__link-text",
                                                                class: {
                                                                  "mobile-nav__link-text--all":
                                                                    lastItem.type ===
                                                                    "all",
                                                                },
                                                                attrs: {
                                                                  href: lastItem.link,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    lastItem.text
                                                                  )
                                                                ),
                                                                lastItem.type ===
                                                                "all"
                                                                  ? _c(
                                                                      "svg",
                                                                      {
                                                                        staticClass:
                                                                          "svg-icon svg-icon--arrow-right",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "use",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "xlink:href":
                                                                                  "#svg-icon-arrow-right",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                })
              }),
            ],
            2
          )
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$1n = [];
  __vue_render__$1n._withStripped = true;

    /* style */
    const __vue_inject_styles__$1t = undefined;
    /* scoped */
    const __vue_scope_id__$1t = undefined;
    /* module identifier */
    const __vue_module_identifier__$1t = undefined;
    /* functional template */
    const __vue_is_functional_template__$1t = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1t = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1n, staticRenderFns: __vue_staticRenderFns__$1n },
      __vue_inject_styles__$1t,
      __vue_script__$1t,
      __vue_scope_id__$1t,
      __vue_is_functional_template__$1t,
      __vue_module_identifier__$1t,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1u = {
    computed: _objectSpread2(_objectSpread2({}, mapGetters({
      basketEmpty: 'basket/basketEmpty',
      basketItems: 'basket/basketItems'
    })), {}, {
      basket: function basket() {
        return this.$store.state.basket;
      },
      basketCountByItems: function basketCountByItems() {
        var result = 0;

        if (this.basketItems && this.basketItems.length) {
          result = this.basketItems.reduce(function (sum, item) {
            return sum + (item.count || 0);
          }, 0);
        }

        return result;
      }
    })
  };

  /* script */
  const __vue_script__$1u = script$1u;

  /* template */
  var __vue_render__$1o = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-basket-small basket-small",
        class: { "basket-small--empty": _vm.basketEmpty },
      },
      [
        _c(
          "a",
          {
            staticClass: "basket-small__widget",
            attrs: { href: _vm.basket.link },
          },
          [
            _c("div", { staticClass: "basket-small__cell-icon" }, [
              _c("svg", { staticClass: "svg-icon basket-small__icon" }, [
                _c("use", { attrs: { "xlink:href": "#svg-icon-cart" } }),
              ]),
              _vm.basketCountByItems
                ? _c(
                    "div",
                    { staticClass: "basket-small__badge badge badge--primary" },
                    [_vm._v(_vm._s(_vm.basketCountByItems))]
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    )
  };
  var __vue_staticRenderFns__$1o = [];
  __vue_render__$1o._withStripped = true;

    /* style */
    const __vue_inject_styles__$1u = undefined;
    /* scoped */
    const __vue_scope_id__$1u = undefined;
    /* module identifier */
    const __vue_module_identifier__$1u = undefined;
    /* functional template */
    const __vue_is_functional_template__$1u = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1u = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1o, staticRenderFns: __vue_staticRenderFns__$1o },
      __vue_inject_styles__$1u,
      __vue_script__$1u,
      __vue_scope_id__$1u,
      __vue_is_functional_template__$1u,
      __vue_module_identifier__$1u,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1v = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        openUser: false,
        menu: [],
        personalPage: null,
        login: null,
        modals: {}
      };
    },
    computed: _objectSpread2({}, mapGetters({
      userUnpList: 'user/userUnpList',
      userUnpActive: 'user/userUnpActive',
      authorised: 'user/authorised'
    })),
    methods: {
      dataSet: function dataSet(data) {
        this.menu = data.menu;
        this.modals = data.modals;
        this.personalPage = data.personalPage;
        this.login = data.login;
      },
      // открытие меню
      openMenu: function openMenu() {
        this.openUser = true;
        document.body.classList.add('state--user-small-open');
      },
      // закрытие меню
      closeMenu: function closeMenu() {
        this.openUser = false;
        document.body.classList.remove('state--user-small-open');
      },
      // переключение меню
      toggleMenu: function toggleMenu() {
        if (this.openUser) {
          controller.closeUserSmall();
        } else {
          controller.openUserSmall();
        }
      },
      // закрыте меню по клику снаружи
      clickOutside: function clickOutside(e) {
        if (!this.$el.contains(e.target)) {
          controller.closeUserSmall();
        }
      }
    },
    created: function created() {
      // привезка к переключение меню через контроллер состояний
      document.addEventListener('click', this.clickOutside);
      controller.$on('user-small-open', this.openMenu);
      controller.$on('user-small-close', this.closeMenu);
    }
  };

  /* script */
  const __vue_script__$1v = script$1v;

  /* template */
  var __vue_render__$1p = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-user-small user-small",
        class: { "open-user": _vm.openUser },
      },
      [
        _c(
          "div",
          {
            staticClass: "user-small__widget",
            on: {
              click: function ($event) {
                $event.preventDefault();
                return _vm.toggleMenu.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "user-small__cell-icon" }, [
              _c("svg", { staticClass: "svg-icon user-small__icon" }, [
                _c("use", { attrs: { "xlink:href": "#svg-icon-user" } }),
              ]),
              _vm.authorised
                ? _c("svg", { staticClass: "svg-icon user-small__icon-login" }, [
                    _c("use", {
                      attrs: { "xlink:href": "#svg-icon-user-login" },
                    }),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
        _c("div", { staticClass: "user-small__menu" }, [
          _c(
            "div",
            { staticClass: "user-small__menu-list" },
            [
              _vm._l(_vm.menu, function (item) {
                return _c("div", { staticClass: "user-small__menu-item" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "user-small__menu-link user-small__menu-link--w-arrow",
                      attrs: { href: item.link },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "user-small__menu-link-subtext" },
                        [_vm._v(_vm._s(item.subtext))]
                      ),
                      _c("span", { staticClass: "user-small__menu-link-text" }, [
                        _vm._v(_vm._s(item.text)),
                      ]),
                    ]
                  ),
                ])
              }),
              _vm.userUnpList.length
                ? _c("div", { staticClass: "user-small__menu-item" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "user-small__menu-link user-small__menu-link--unp js-open-modal",
                        attrs: {
                          "data-modal-data": '{"className": "modal--sm"}',
                          "data-modal-url": _vm.modals.selectUnp,
                        },
                        on: { click: _vm.closeMenu },
                      },
                      [
                        _c("span", [_vm._v("Текущий УНП")]),
                        _vm._v(_vm._s(_vm.userUnpActive)),
                        _c("mark", [_vm._v("Изменить")]),
                      ]
                    ),
                  ])
                : _c("div", { staticClass: "user-small__menu-item" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "user-small__menu-link user-small__menu-link--w-arrow js-open-modal",
                        attrs: {
                          "data-modal-data": '{"className": "modal--sm"}',
                          "data-modal-url": _vm.modals.enterUnp,
                        },
                        on: { click: _vm.closeMenu },
                      },
                      [_vm._v("Ввести УНП")]
                    ),
                  ]),
            ],
            2
          ),
        ]),
      ]
    )
  };
  var __vue_staticRenderFns__$1p = [];
  __vue_render__$1p._withStripped = true;

    /* style */
    const __vue_inject_styles__$1v = undefined;
    /* scoped */
    const __vue_scope_id__$1v = undefined;
    /* module identifier */
    const __vue_module_identifier__$1v = undefined;
    /* functional template */
    const __vue_is_functional_template__$1v = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1v = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1p, staticRenderFns: __vue_staticRenderFns__$1p },
      __vue_inject_styles__$1v,
      __vue_script__$1v,
      __vue_scope_id__$1v,
      __vue_is_functional_template__$1v,
      __vue_module_identifier__$1v,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1w = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        loading: false,
        openPopupState: false,
        localQuery: null,
        searchTimeout: null,
        search: {
          remote: null,
          query: null,
          link: null,
          suggestions: []
        }
      };
    },
    computed: {
      // показ результатов быстрого поиска
      showResult: function showResult() {
        var result = false;

        if (typeof this.search.query == 'string' && typeof this.localQuery == 'string' && this.localQuery.length >= 3) {
          // result = !!~this.search.query.toLowerCase().search(this.localQuery.toLowerCase())
          result = true;
        }

        return result;
      }
    },
    methods: {
      relocate: function relocate() {
        if (this.search.link && this.localQuery && this.localQuery.length >= 3) {
          var searchUrl = new URL(window.location.protocol + window.location.host + this.search.link);
          searchUrl.searchParams.delete('q');
          searchUrl.searchParams.append('q', this.localQuery);
          window.location = searchUrl;
        }
      },
      // открытие попапа
      openPopup: function openPopup() {
        this.openPopupState = true;
        document.body.classList.add('state--search-popup-open');
      },
      // закрытие попапа
      closePopup: function closePopup() {
        this.openPopupState = false;
        document.body.classList.remove('state--search-popup-open');
      },
      // переключение попапа
      togglePopup: function togglePopup() {
        if (this.openPopupState) {
          this.closePopup();
          controller.closeSearchPopup();
          controller.$emit('search-small-close', this.closeMenu);
        } else {
          this.openPopup();
          controller.openSearchPopup();
          controller.$emit('search-small-open', this.openMenu);
        }
      },
      open: function open() {
        document.body.classList.add('state--search-small-open');
      },
      close: function close() {
        document.body.classList.remove('state--search-small-open');
      },
      clickOutside: function clickOutside(e) {
        if (!this.$el.contains(e.target)) {
          controller.closeSearchPopup();
          controller.closeSearchSmall();
        }
      },
      searchInput: function searchInput() {
        clearTimeout(this.searchTimeout);

        if (this.localQuery && this.localQuery.length >= 3) {
          controller.openSearchSmall();
          this.searchTimeout = setTimeout(this.requestDataLoad, 200);
        } else {
          controller.closeSearchSmall();
        }
      },
      clearSearch: function clearSearch() {
        this.localQuery = '';
        this.search.suggestions = null;
        this.search.categories = null;
        this.search.total = 0;
      },
      requestDataLoad: function requestDataLoad() {
        this.dataLoad({
          url: this.search.remote,
          delay: true,
          data: {
            query: this.localQuery,
            bxajaxid: this.bxajaxid
          }
        });
      },
      dataSet: function dataSet(data) {
        if (!this.search.remote) {
          this.search = data;
        }

        if (typeof this.localQuery == 'string' && this.localQuery.length >= 3) {
          this.search = data;
        }
      }
    },
    created: function created() {
      document.addEventListener('click', this.clickOutside);
      controller.$on('search-small-open', this.open);
      controller.$on('search-small-close', this.close); // привезка к переключение попапа через контроллер состояний

      controller.$on('search-popup-open', this.openPopup);
      controller.$on('search-popup-close', this.closePopup);
    },
    destroyed: function destroyed() {
      document.removeEventListener('click', this.clickOutside);
    }
  };

  /* script */
  const __vue_script__$1w = script$1w;

  /* template */
  var __vue_render__$1q = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-search-small search-small",
        class: { "open-popup": _vm.openPopupState },
      },
      [
        _c(
          "div",
          {
            staticClass: "search-small__widget",
            on: {
              click: function ($event) {
                $event.preventDefault();
                return _vm.togglePopup.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "search-small__cell-icon" }, [
              _c("svg", { staticClass: "svg-icon search-small__icon" }, [
                _c("use", { attrs: { "xlink:href": "#svg-icon-lens" } }),
              ]),
            ]),
          ]
        ),
        _c("div", { staticClass: "search-small__popup" }, [
          _c("div", { staticClass: "search-small__wrap" }, [
            _c(
              "form",
              {
                staticClass: "search-small__form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault();
                    return _vm.relocate.apply(null, arguments)
                  },
                  reset: function ($event) {
                    $event.preventDefault();
                    return _vm.close.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "search-small__submit-btn",
                    attrs: { "aria-label": "Найти", type: "submit" },
                  },
                  [
                    _c(
                      "svg",
                      { staticClass: "svg-icon search-small__submit-btn-icon" },
                      [_c("use", { attrs: { "xlink:href": "#svg-icon-lens" } })]
                    ),
                  ]
                ),
                _c("v-field", {
                  staticClass: "search-small__field",
                  attrs: {
                    field: {
                      type: "search",
                      inputmode: "search",
                      placeholder: "Поиск по виртуальному магазину для бизнеса",
                    },
                  },
                  on: { input: _vm.searchInput },
                  model: {
                    value: _vm.localQuery,
                    callback: function ($$v) {
                      _vm.localQuery = $$v;
                    },
                    expression: "localQuery",
                  },
                }),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showResult,
                        expression: "showResult",
                      },
                    ],
                    staticClass: "search-small__close-btn",
                    attrs: { "aria-label": "Очистить", type: "reset" },
                    on: { click: _vm.clearSearch },
                  },
                  [
                    _c(
                      "svg",
                      { staticClass: "svg-icon search-small__close-btn-icon" },
                      [
                        _c("use", {
                          attrs: { "xlink:href": "#svg-icon-close-sm" },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showResult,
                    expression: "showResult",
                  },
                ],
                staticClass: "search-small__result",
              },
              [
                _c("div", { staticClass: "search-small__result-wrap" }, [
                  _vm.search
                    ? _c("div", { staticClass: "search-small__top" }, [
                        !_vm.search.total &&
                        _vm.localQuery &&
                        _vm.localQuery.length >= 3
                          ? _c(
                              "div",
                              {
                                staticClass: "search-small__categories-wrap flc",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "search-small__result-message",
                                    attrs: {
                                      href: this.search.link,
                                      title: _vm.localQuery,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      'По запросу "' +
                                        _vm._s(_vm.localQuery) +
                                        '" ничего не найдено.'
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.search.categories && _vm.search.categories.length
                          ? _c(
                              "div",
                              {
                                staticClass: "search-small__categories-wrap flc",
                              },
                              _vm._l(_vm.search.categories, function (categorie) {
                                return _c(
                                  "a",
                                  {
                                    staticClass: "search-small__categorie link",
                                    attrs: { href: categorie.link },
                                  },
                                  [_vm._v(_vm._s(categorie.text))]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm.search.suggestions && _vm.search.suggestions.length
                          ? _c(
                              "div",
                              {
                                staticClass: "search-small__suggestion-wrap flc",
                              },
                              _vm._l(
                                _vm.search.suggestions.slice(0, 5),
                                function (suggestion, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: suggestion.id,
                                      staticClass: "search-small__suggestion",
                                    },
                                    [
                                      _c("a", {
                                        staticClass:
                                          "search-small__suggestion-link link",
                                        attrs: { href: suggestion.link },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "search-small__suggestion-visual",
                                        },
                                        [
                                          suggestion.image
                                            ? _c("img", {
                                                attrs: {
                                                  src: suggestion.image,
                                                  loading: "lazy",
                                                  alt: suggestion.name,
                                                  title: suggestion.name,
                                                },
                                              })
                                            : _c(
                                                "svg",
                                                { staticClass: "svg-icon" },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      "xlink:href":
                                                        "#svg-icon-no-photo",
                                                    },
                                                  }),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "search-small__suggestion-content",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "search-small__suggestion-category",
                                            },
                                            [_vm._v(_vm._s(suggestion.category))]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "search-small__suggestion-name",
                                            },
                                            [_vm._v(_vm._s(suggestion.name))]
                                          ),
                                          suggestion.params &&
                                          suggestion.params.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "search-small__suggestion-params",
                                                },
                                                _vm._l(
                                                  suggestion.params,
                                                  function (param) {
                                                    return _c("v-field", {
                                                      attrs: { field: param },
                                                      model: {
                                                        value: param.value,
                                                        callback: function ($$v) {
                                                          _vm.$set(
                                                            param,
                                                            "value",
                                                            $$v
                                                          );
                                                        },
                                                        expression: "param.value",
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm.search.total
                          ? _c("div", { staticClass: "search-small__footer" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn--block btn--center btn--primary",
                                  attrs: { href: _vm.search.link },
                                },
                                [_vm._v("Смотреть все найденное")]
                              ),
                              _vm.search.suggestions
                                ? _c(
                                    "div",
                                    { staticClass: "search-small__count" },
                                    [
                                      _vm._v(
                                        "Найдено: " +
                                          _vm._s(_vm.search.suggestions.length)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    )
  };
  var __vue_staticRenderFns__$1q = [];
  __vue_render__$1q._withStripped = true;

    /* style */
    const __vue_inject_styles__$1w = undefined;
    /* scoped */
    const __vue_scope_id__$1w = undefined;
    /* module identifier */
    const __vue_module_identifier__$1w = undefined;
    /* functional template */
    const __vue_is_functional_template__$1w = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1w = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1q, staticRenderFns: __vue_staticRenderFns__$1q },
      __vue_inject_styles__$1w,
      __vue_script__$1w,
      __vue_scope_id__$1w,
      __vue_is_functional_template__$1w,
      __vue_module_identifier__$1w,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1x = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        openQuestion: false,
        consultants: null,
        buttons: null
      };
    },
    computed: {},
    methods: {
      dataSet: function dataSet(data) {
        this.consultants = data.consultants;
        this.buttons = data.buttons;
      },
      // открытие меню
      openPopup: function openPopup() {
        this.openQuestion = true;
        document.body.classList.add('state--question-small-open');
      },
      // закрытие меню
      closePopup: function closePopup() {
        this.openQuestion = false;
        document.body.classList.remove('state--question-small-open');
      },
      // переключение меню
      togglePopup: function togglePopup() {
        if (this.openQuestion) {
          controller.closeQuestionPopup();
        } else {
          controller.openQuestionPopup();
        }
      },
      // закрыте меню по клику снаружи
      clickOutside: function clickOutside(e) {
        if (!this.$el.contains(e.target)) {
          controller.closeQuestionPopup();
        }
      }
    },
    created: function created() {
      // привезка к переключение меню через контроллер состояний
      document.addEventListener('click', this.clickOutside);
      controller.$on('question-popup-open', this.openPopup);
      controller.$on('question-popup-close', this.closePopup);
    }
  };

  /* script */
  const __vue_script__$1x = script$1x;

  /* template */
  var __vue_render__$1r = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-question-small question-small",
        class: { "open-question": _vm.openQuestion },
      },
      [
        _c(
          "div",
          {
            staticClass: "question-small__widget",
            on: {
              click: function ($event) {
                $event.preventDefault();
                return _vm.togglePopup.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "question-small__cell-icon" }, [
              _c("svg", { staticClass: "svg-icon question-small__icon" }, [
                _c("use", { attrs: { "xlink:href": "#svg-icon-question" } }),
              ]),
            ]),
          ]
        ),
        _c("div", { staticClass: "question-small__popup" }, [
          _vm.buttons && _vm.buttons.length
            ? _c(
                "div",
                { staticClass: "question-small__buttons" },
                _vm._l(_vm.buttons, function (button) {
                  return _c(
                    "a",
                    {
                      staticClass: "btn btn--block btn--center",
                      class: button.class,
                      attrs: { href: button.link, target: "_blank" },
                    },
                    [_vm._v(_vm._s(button.text))]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.consultants && _vm.consultants.length
            ? _c("div", { staticClass: "question-small__consultants" }, [
                _c(
                  "div",
                  { staticClass: "question-small__consultants-caption" },
                  [_vm._v("Наши консультанты")]
                ),
                _c(
                  "div",
                  { staticClass: "question-small__consultants-list" },
                  _vm._l(_vm.consultants, function (item) {
                    return _c(
                      "a",
                      {
                        staticClass: "question-small__consultants-item",
                        attrs: { href: item.link, target: "_blank" },
                      },
                      [_vm._v(_vm._s(item.text))]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
      ]
    )
  };
  var __vue_staticRenderFns__$1r = [];
  __vue_render__$1r._withStripped = true;

    /* style */
    const __vue_inject_styles__$1x = undefined;
    /* scoped */
    const __vue_scope_id__$1x = undefined;
    /* module identifier */
    const __vue_module_identifier__$1x = undefined;
    /* functional template */
    const __vue_is_functional_template__$1x = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1x = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1r, staticRenderFns: __vue_staticRenderFns__$1r },
      __vue_inject_styles__$1x,
      __vue_script__$1x,
      __vue_scope_id__$1x,
      __vue_is_functional_template__$1x,
      __vue_module_identifier__$1x,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$1y = {
    computed: {
      favorite: function favorite() {
        return this.$store.state.favorite;
      },
      favoriteEmpty: function favoriteEmpty() {
        return this.$store.getters['favorite/favoriteEmpty'];
      },
      favoriteCount: function favoriteCount() {
        return this.$store.getters['favorite/favoriteCount'];
      }
    }
  };

  /* script */
  const __vue_script__$1y = script$1y;

  /* template */
  var __vue_render__$1s = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "v-favorite-small basket-small",
        class: { "basket-small--empty": _vm.favoriteEmpty },
      },
      [
        _c(
          "a",
          {
            staticClass: "basket-small__widget",
            attrs: { href: _vm.favoriteEmpty ? null : _vm.favorite.link },
          },
          [
            _c("div", { staticClass: "basket-small__cell-icon" }, [
              _c("svg", { staticClass: "svg-icon basket-small__icon" }, [
                _c("use", { attrs: { "xlink:href": "#svg-icon-favorite" } }),
              ]),
              _vm.favoriteCount
                ? _c(
                    "div",
                    { staticClass: "basket-small__badge badge badge--primary" },
                    [_vm._v(_vm._s(_vm.favoriteCount))]
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "basket-small__cell-main" }, [
              _c("div", { staticClass: "basket-small__title flc" }, [
                _vm._v("Избранное"),
              ]),
              _vm.favoriteEmpty
                ? _c("div", { staticClass: "basket-small__price flc" }, [
                    _vm._v("Нет товаров"),
                  ])
                : _c("div", { staticClass: "basket-small__price flc" }),
            ]),
          ]
        ),
      ]
    )
  };
  var __vue_staticRenderFns__$1s = [];
  __vue_render__$1s._withStripped = true;

    /* style */
    const __vue_inject_styles__$1y = undefined;
    /* scoped */
    const __vue_scope_id__$1y = undefined;
    /* module identifier */
    const __vue_module_identifier__$1y = undefined;
    /* functional template */
    const __vue_is_functional_template__$1y = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1y = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1s, staticRenderFns: __vue_staticRenderFns__$1s },
      __vue_inject_styles__$1y,
      __vue_script__$1y,
      __vue_scope_id__$1y,
      __vue_is_functional_template__$1y,
      __vue_module_identifier__$1y,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1z = {
    methods: {
      toggleMobileNav: function toggleMobileNav() {
        if (document.body.classList.contains('state--mobile-nav-open')) {
          controller.closeMobileNav();
        } else {
          controller.openMobileNav();
        }
      }
    }
  };

  /* script */
  const __vue_script__$1z = script$1z;

  /* template */
  var __vue_render__$1t = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "button",
      {
        staticClass: "v-hamburger hamburger hamburger--slider",
        attrs: { type: "button" },
        on: { click: _vm.toggleMobileNav },
      },
      [_vm._m(0)]
    )
  };
  var __vue_staticRenderFns__$1t = [
    function () {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("span", { staticClass: "hamburger-box" }, [
        _c("span", { staticClass: "hamburger-inner" }),
      ])
    },
  ];
  __vue_render__$1t._withStripped = true;

    /* style */
    const __vue_inject_styles__$1z = undefined;
    /* scoped */
    const __vue_scope_id__$1z = undefined;
    /* module identifier */
    const __vue_module_identifier__$1z = undefined;
    /* functional template */
    const __vue_is_functional_template__$1z = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1z = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1t, staticRenderFns: __vue_staticRenderFns__$1t },
      __vue_inject_styles__$1z,
      __vue_script__$1z,
      __vue_scope_id__$1z,
      __vue_is_functional_template__$1z,
      __vue_module_identifier__$1z,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1A = {
    mixins: [__vue_component__$2, __vue_component__$_],
    data: function data() {
      return {
        content: null
      };
    },
    methods: {
      dataSet: function dataSet(data) {
        this.content = data;
      },
      loginPhone: function loginPhone() {
        this.dataLoad({
          url: this.content.remote,
          action: 'understand',
          delay: false
        }).then(function () {
          controller.closeModal();
        });
      },
      callMethod: function callMethod(name) {
        this[name]();
      },
      asLegalEntity: function asLegalEntity() {
        this.setCookie('continue-as-legal-entity', true);
        controller.closeModal();
      },
      asPrivatePerson: function asPrivatePerson() {
        window.location.href = this.content.b2clink;
      },
      asGuest: function asGuest() {
        controller.closeAllModals();
        this.dataLoad({
          url: this.content.remote,
          delay: false,
          data: {
            action: 'guestset',
            bxajaxid: this.content.bxajaxid
          }
        });
      },
      changeUnp: function changeUnp() {
        controller.openModal({
          url: this.content.changeUnpModal,
          className: 'modal--sm'
        });
      }
    }
  };

  /* script */
  const __vue_script__$1A = script$1A;

  /* template */
  var __vue_render__$1u = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-continue-as continue-as" }, [
      _vm.content && _vm.content.note
        ? _c("div", { staticClass: "continue-as__note flc" }, [
            _vm._v(_vm._s(_vm.content.note)),
          ])
        : _vm._e(),
      _vm.content && _vm.content.buttons && _vm.content.buttons.length
        ? _c(
            "div",
            { staticClass: "continue-as__buttons" },
            [
              _vm._l(_vm.content.buttons, function (btn) {
                return [
                  btn.link
                    ? _c("a", { class: btn.class, attrs: { href: btn.link } }, [
                        _vm._v(_vm._s(btn.text)),
                      ])
                    : _c(
                        "button",
                        {
                          class: btn.class,
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.callMethod(btn.event)
                            },
                          },
                        },
                        [_vm._v(_vm._s(btn.text))]
                      ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
    ])
  };
  var __vue_staticRenderFns__$1u = [];
  __vue_render__$1u._withStripped = true;

    /* style */
    const __vue_inject_styles__$1A = undefined;
    /* scoped */
    const __vue_scope_id__$1A = undefined;
    /* module identifier */
    const __vue_module_identifier__$1A = undefined;
    /* functional template */
    const __vue_is_functional_template__$1A = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1A = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1u, staticRenderFns: __vue_staticRenderFns__$1u },
      __vue_inject_styles__$1A,
      __vue_script__$1A,
      __vue_scope_id__$1A,
      __vue_is_functional_template__$1A,
      __vue_module_identifier__$1A,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1B = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        slider: {}
      };
    },
    props: {
      options: {
        default: function _default() {
          return {
            speed: 860
          };
        }
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        var result = {};

        if (this.options.autoplay) {
          result.autoplay = {};
        }

        if (this.options.autoplaySpeed) {
          result.autoplay.delay = this.options.autoplaySpeed;
        }

        if (this.options.speed) {
          result.speed = this.options.speed;
        }

        return result;
      }
    },
    methods: {
      dataSet: function dataSet(data) {
        this.slider = data;
      }
    }
  };

  /* script */
  const __vue_script__$1B = script$1B;

  /* template */
  var __vue_render__$1v = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-hero-slider hero-slider" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.slider && _vm.slider.slides && _vm.slider.slides.length
          ? _c(
              "v-slider-carousel",
              {
                staticClass: "slider-carousel--fullscreen",
                attrs: {
                  options: Object.assign(
                    {},
                    {
                      loopAdditionalSlides: 1,
                      loopedSlides: 1,
                      loop: true,
                      pagination: { el: ".swiper-pagination", type: "bullets" },
                      breakpoints: {},
                    },
                    _vm.computedOptions
                  ),
                  pagination: "pagination",
                },
              },
              _vm._l(_vm.slider.slides, function (slide, index) {
                return _c(
                  "v-swiper-slide",
                  { key: slide.id || index },
                  [_c("v-hero-block", { attrs: { "data-source": slide } })],
                  1
                )
              }),
              1
            )
          : _vm._e(),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$1v = [];
  __vue_render__$1v._withStripped = true;

    /* style */
    const __vue_inject_styles__$1B = undefined;
    /* scoped */
    const __vue_scope_id__$1B = undefined;
    /* module identifier */
    const __vue_module_identifier__$1B = undefined;
    /* functional template */
    const __vue_is_functional_template__$1B = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1B = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1v, staticRenderFns: __vue_staticRenderFns__$1v },
      __vue_inject_styles__$1B,
      __vue_script__$1B,
      __vue_scope_id__$1B,
      __vue_is_functional_template__$1B,
      __vue_module_identifier__$1B,
      false,
      undefined,
      undefined,
      undefined
    );

  var lightgallery = createCommonjsModule(function (module, exports) {
    /**!
     * lightgallery.js | 1.4.0 | October 13th 2020
     * http://sachinchoolur.github.io/lightgallery.js/
     * Copyright (c) 2016 Sachin N;
     * @license GPLv3
     */
    (function (f) {
      {
        module.exports = f();
      }
    })(function () {
      return function () {
        function r(e, n, t) {
          function o(i, f) {
            if (!n[i]) {
              if (!e[i]) {
                var c = 'function' == typeof commonjsRequire && commonjsRequire;
                if (!f && c) return c(i, !0);
                if (u) return u(i, !0);
                var a = new Error('Cannot find module \'' + i + '\'');
                throw a.code = 'MODULE_NOT_FOUND', a;
              }

              var p = n[i] = {
                exports: {}
              };
              e[i][0].call(p.exports, function (r) {
                var n = e[i][1][r];
                return o(n || r);
              }, p, p.exports, r, e, n, t);
            }

            return n[i].exports;
          }

          for (var u = 'function' == typeof commonjsRequire && commonjsRequire, i = 0; i < t.length; i++) {
            o(t[i]);
          }

          return o;
        }

        return r;
      }()({
        1: [function (require, module, exports) {
          (function (global, factory) {
            if (typeof exports !== 'undefined') {
              factory(exports);
            } else {
              var mod = {
                exports: {}
              };
              factory(mod.exports);
              global.lgUtils = mod.exports;
            }
          })(this, function (exports) {

            Object.defineProperty(exports, '__esModule', {
              value: true
            });
            var utils = {
              getAttribute: function getAttribute(el, label) {
                return el[label];
              },
              setAttribute: function setAttribute(el, label, value) {
                el[label] = value;
              },
              wrap: function wrap(el, className) {
                if (!el) {
                  return;
                }

                var wrapper = document.createElement('div');
                wrapper.className = className;
                el.parentNode.insertBefore(wrapper, el);
                el.parentNode.removeChild(el);
                wrapper.appendChild(el);
              },
              addClass: function addClass(el, className) {
                if (!el) {
                  return;
                }

                if (el.classList) {
                  el.classList.add(className);
                } else {
                  el.className += ' ' + className;
                }
              },
              removeClass: function removeClass(el, className) {
                if (!el) {
                  return;
                }

                if (el.classList) {
                  el.classList.remove(className);
                } else {
                  el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                }
              },
              hasClass: function hasClass(el, className) {
                if (el.classList) {
                  return el.classList.contains(className);
                } else {
                  return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
                }
              },
              // ex Transform
              // ex TransitionTimingFunction
              setVendor: function setVendor(el, property, value) {
                if (!el) {
                  return;
                }

                el.style[property.charAt(0).toLowerCase() + property.slice(1)] = value;
                el.style['webkit' + property] = value;
                el.style['moz' + property] = value;
                el.style['ms' + property] = value;
                el.style['o' + property] = value;
              },
              trigger: function trigger(el, event) {
                var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                if (!el) {
                  return;
                }

                var customEvent = new CustomEvent(event, {
                  detail: detail
                });
                el.dispatchEvent(customEvent);
              },
              Listener: {
                uid: 0
              },
              on: function on(el, events, fn) {
                var _this = this;

                if (!el) {
                  return;
                }

                events.split(' ').forEach(function (event) {
                  var _id = _this.getAttribute(el, 'lg-event-uid') || '';

                  utils.Listener.uid++;
                  _id += '&' + utils.Listener.uid;

                  _this.setAttribute(el, 'lg-event-uid', _id);

                  utils.Listener[event + utils.Listener.uid] = fn;
                  el.addEventListener(event.split('.')[0], fn, false);
                });
              },
              off: function off(el, event) {
                if (!el) {
                  return;
                }

                var _id = this.getAttribute(el, 'lg-event-uid');

                if (_id) {
                  _id = _id.split('&');

                  for (var i = 0; i < _id.length; i++) {
                    if (_id[i]) {
                      var _event = event + _id[i];

                      if (_event.substring(0, 1) === '.') {
                        for (var key in utils.Listener) {
                          if (utils.Listener.hasOwnProperty(key)) {
                            if (key.split('.').indexOf(_event.split('.')[1]) > -1) {
                              el.removeEventListener(key.split('.')[0], utils.Listener[key]);
                              this.setAttribute(el, 'lg-event-uid', this.getAttribute(el, 'lg-event-uid').replace('&' + _id[i], ''));
                              delete utils.Listener[key];
                            }
                          }
                        }
                      } else {
                        el.removeEventListener(_event.split('.')[0], utils.Listener[_event]);
                        this.setAttribute(el, 'lg-event-uid', this.getAttribute(el, 'lg-event-uid').replace('&' + _id[i], ''));
                        delete utils.Listener[_event];
                      }
                    }
                  }
                }
              },
              param: function param(obj) {
                return Object.keys(obj).map(function (k) {
                  return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
                }).join('&');
              }
            };
            exports.default = utils;
          });
        }, {}],
        2: [function (require, module, exports) {
          (function (global, factory) {
            if (typeof exports !== 'undefined') {
              factory(require('./lg-utils'));
            } else {
              var mod = {
                exports: {}
              };
              factory(global.lgUtils);
              global.lightgallery = mod.exports;
            }
          })(this, function (_lgUtils) {

            var _lgUtils2 = _interopRequireDefault(_lgUtils);

            function _interopRequireDefault(obj) {
              return obj && obj.__esModule ? obj : {
                default: obj
              };
            }

            var _extends = Object.assign || function (target) {
              for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];

                for (var key in source) {
                  if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                  }
                }
              }

              return target;
            };
            /** Polyfill the CustomEvent() constructor functionality in Internet Explorer 9 and higher */


            (function () {
              if (typeof window.CustomEvent === 'function') {
                return false;
              }

              function CustomEvent(event, params) {
                params = params || {
                  bubbles: false,
                  cancelable: false,
                  detail: undefined
                };
                var evt = document.createEvent('CustomEvent');
                evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                return evt;
              }

              CustomEvent.prototype = window.Event.prototype;
              window.CustomEvent = CustomEvent;
            })();

            window.utils = _lgUtils2.default;
            window.lgData = {
              uid: 0
            };
            window.lgModules = {};
            var defaults = {
              mode: 'lg-slide',
              // Ex : 'ease'
              cssEasing: 'ease',
              //'for jquery animation'
              easing: 'linear',
              speed: 600,
              height: '100%',
              width: '100%',
              addClass: '',
              startClass: 'lg-start-zoom',
              backdropDuration: 150,
              // Set 0, if u don't want to hide the controls
              hideBarsDelay: 6000,
              useLeft: false,
              // aria-labelledby attribute fot gallery
              ariaLabelledby: '',
              //aria-describedby attribute for gallery
              ariaDescribedby: '',
              closable: true,
              loop: true,
              escKey: true,
              keyPress: true,
              controls: true,
              slideEndAnimatoin: true,
              hideControlOnEnd: false,
              mousewheel: false,
              getCaptionFromTitleOrAlt: true,
              // .lg-item || '.lg-sub-html'
              appendSubHtmlTo: '.lg-sub-html',
              subHtmlSelectorRelative: false,

              /**
               * @desc number of preload slides
               * will exicute only after the current slide is fully loaded.
               *
               * @ex you clicked on 4th image and if preload = 1 then 3rd slide and 5th
               * slide will be loaded in the background after the 4th slide is fully loaded..
               * if preload is 2 then 2nd 3rd 5th 6th slides will be preloaded.. ... ...
               *
               */
              preload: 1,
              showAfterLoad: true,
              selector: '',
              selectWithin: '',
              nextHtml: '',
              prevHtml: '',
              // 0, 1
              index: false,
              iframeMaxWidth: '100%',
              download: true,
              counter: true,
              appendCounterTo: '.lg-toolbar',
              swipeThreshold: 50,
              enableSwipe: true,
              enableDrag: true,
              dynamic: false,
              dynamicEl: [],
              galleryId: 1,
              supportLegacyBrowser: true
            };

            function Plugin(element, options) {
              // Current lightGallery element
              this.el = element; // lightGallery settings

              this.s = _extends({}, defaults, options); // When using dynamic mode, ensure dynamicEl is an array

              if (this.s.dynamic && this.s.dynamicEl !== 'undefined' && this.s.dynamicEl.constructor === Array && !this.s.dynamicEl.length) {
                throw 'When using dynamic mode, you must also define dynamicEl as an Array.';
              } // lightGallery modules


              this.modules = {}; // false when lightgallery complete first slide;

              this.lGalleryOn = false;
              this.lgBusy = false; // Timeout function for hiding controls;

              this.hideBartimeout = false; // To determine browser supports for touch events;

              this.isTouch = 'ontouchstart' in document.documentElement; // Disable hideControlOnEnd if sildeEndAnimation is true

              if (this.s.slideEndAnimatoin) {
                this.s.hideControlOnEnd = false;
              }

              this.items = []; // Gallery items

              if (this.s.dynamic) {
                this.items = this.s.dynamicEl;
              } else {
                if (this.s.selector === 'this') {
                  this.items.push(this.el);
                } else if (this.s.selector !== '') {
                  if (this.s.selectWithin) {
                    this.items = document.querySelector(this.s.selectWithin).querySelectorAll(this.s.selector);
                  } else {
                    this.items = this.el.querySelectorAll(this.s.selector);
                  }
                } else {
                  this.items = this.el.children;
                }
              } // .lg-item


              this.___slide = ''; // .lg-outer

              this.outer = '';
              this.init();
              return this;
            }

            Plugin.prototype.init = function () {
              var _this = this; // s.preload should not be more than $item.length


              if (_this.s.preload > _this.items.length) {
                _this.s.preload = _this.items.length;
              } // if dynamic option is enabled execute immediately


              var _hash = window.location.hash;

              if (_hash.indexOf('lg=' + this.s.galleryId) > 0) {
                _this.index = parseInt(_hash.split('&slide=')[1], 10);

                _lgUtils2.default.addClass(document.body, 'lg-from-hash');

                if (!_lgUtils2.default.hasClass(document.body, 'lg-on')) {
                  _lgUtils2.default.addClass(document.body, 'lg-on');

                  setTimeout(function () {
                    _this.build(_this.index);
                  });
                }
              }

              if (_this.s.dynamic) {
                _lgUtils2.default.trigger(this.el, 'onBeforeOpen');

                _this.index = _this.s.index || 0; // prevent accidental double execution

                if (!_lgUtils2.default.hasClass(document.body, 'lg-on')) {
                  _lgUtils2.default.addClass(document.body, 'lg-on');

                  setTimeout(function () {
                    _this.build(_this.index);
                  });
                }
              } else {
                for (var i = 0; i < _this.items.length; i++) {
                  /*jshint loopfunc: true */
                  (function (index) {
                    // Using different namespace for click because click event should not unbind if selector is same object('this')
                    _lgUtils2.default.on(_this.items[index], 'click.lgcustom', function (e) {
                      e.preventDefault();

                      _lgUtils2.default.trigger(_this.el, 'onBeforeOpen');

                      _this.index = _this.s.index || index;

                      if (!_lgUtils2.default.hasClass(document.body, 'lg-on')) {
                        _this.build(_this.index);

                        _lgUtils2.default.addClass(document.body, 'lg-on');
                      }
                    });
                  })(i);
                }
              }
            };

            Plugin.prototype.build = function (index) {
              var _this = this;

              _this.structure();

              for (var key in window.lgModules) {
                _this.modules[key] = new window.lgModules[key](_this.el);
              } // initiate slide function


              _this.slide(index, false, false);

              if (_this.s.keyPress) {
                _this.keyPress();
              }

              if (_this.items.length > 1) {
                _this.arrow();

                setTimeout(function () {
                  _this.enableDrag();

                  _this.enableSwipe();
                }, 50);

                if (_this.s.mousewheel) {
                  _this.mousewheel();
                }
              }

              _this.counter();

              _this.closeGallery();

              _lgUtils2.default.trigger(_this.el, 'onAfterOpen'); // Hide controllers if mouse doesn't move for some period


              if (_this.s.hideBarsDelay > 0) {
                // Hide controls if user doesn't use mouse or touch after opening gallery
                var initialHideBarTimeout = setTimeout(function () {
                  _lgUtils2.default.addClass(_this.outer, 'lg-hide-items');
                }, _this.s.hideBarsDelay);

                _lgUtils2.default.on(_this.outer, 'mousemove.lg click.lg touchstart.lg', function () {
                  // Cancel initalHideBarTimout if user uses mouse or touch events
                  // Before it fires
                  clearTimeout(initialHideBarTimeout);

                  _lgUtils2.default.removeClass(_this.outer, 'lg-hide-items');

                  clearTimeout(_this.hideBartimeout); // Timeout will be cleared on each slide movement also

                  _this.hideBartimeout = setTimeout(function () {
                    _lgUtils2.default.addClass(_this.outer, 'lg-hide-items');
                  }, _this.s.hideBarsDelay);
                });
              }
            };

            Plugin.prototype.structure = function () {
              var list = '';
              var controls = '';
              var i = 0;
              var subHtmlCont = '';
              var template;

              var _this = this;

              document.body.insertAdjacentHTML('beforeend', '<div class="lg-backdrop"></div>');

              _lgUtils2.default.setVendor(document.querySelector('.lg-backdrop'), 'TransitionDuration', this.s.backdropDuration + 'ms'); // Create gallery items


              for (i = 0; i < this.items.length; i++) {
                list += '<div class="lg-item"></div>';
              } // Create controlls


              if (this.s.controls && this.items.length > 1) {
                controls = '<div class="lg-actions">' + '<button type="button" aria-label="Previous slide" class="lg-prev lg-icon">' + this.s.prevHtml + '</button>' + '<button type="button" aria-label="Next slide" class="lg-next lg-icon">' + this.s.nextHtml + '</button>' + '</div>';
              }

              if (this.s.appendSubHtmlTo === '.lg-sub-html') {
                subHtmlCont = '<div role="status" aria-live="polite" class="lg-sub-html"></div>';
              }

              var ariaLabelledby = this.s.ariaLabelledby ? 'aria-labelledby="' + this.s.ariaLabelledby + '"' : '';
              var ariaDescribedby = this.s.ariaDescribedby ? 'aria-describedby="' + this.s.ariaDescribedby + '"' : '';
              template = '<div tabindex="-1" aria-modal="true" ' + ariaLabelledby + ' ' + ariaDescribedby + ' role="dialog" class="lg-outer ' + this.s.addClass + ' ' + this.s.startClass + '">' + '<div class="lg" style="width:' + this.s.width + '; height:' + this.s.height + '">' + '<div class="lg-inner">' + list + '</div>' + '<div class="lg-toolbar lg-group">' + '<button type="button" aria-label="Close gallery" class="lg-close lg-icon"></button>' + '</div>' + controls + subHtmlCont + '</div>' + '</div>';
              document.body.insertAdjacentHTML('beforeend', template);
              this.outer = document.querySelector('.lg-outer');
              this.outer.focus();
              this.___slide = this.outer.querySelectorAll('.lg-item');

              if (this.s.useLeft) {
                _lgUtils2.default.addClass(this.outer, 'lg-use-left'); // Set mode lg-slide if use left is true;


                this.s.mode = 'lg-slide';
              } else {
                _lgUtils2.default.addClass(this.outer, 'lg-use-css3');
              } // For fixed height gallery


              _this.setTop();

              _lgUtils2.default.on(window, 'resize.lg orientationchange.lg', function () {
                setTimeout(function () {
                  _this.setTop();
                }, 100);
              }); // add class lg-current to remove initial transition


              _lgUtils2.default.addClass(this.___slide[this.index], 'lg-current'); // add Class for css support and transition mode


              if (this.doCss()) {
                _lgUtils2.default.addClass(this.outer, 'lg-css3');
              } else {
                _lgUtils2.default.addClass(this.outer, 'lg-css'); // Set speed 0 because no animation will happen if browser doesn't support css3


                this.s.speed = 0;
              }

              _lgUtils2.default.addClass(this.outer, this.s.mode);

              if (this.s.enableDrag && this.items.length > 1) {
                _lgUtils2.default.addClass(this.outer, 'lg-grab');
              }

              if (this.s.showAfterLoad) {
                _lgUtils2.default.addClass(this.outer, 'lg-show-after-load');
              }

              if (this.doCss()) {
                var inner = this.outer.querySelector('.lg-inner');

                _lgUtils2.default.setVendor(inner, 'TransitionTimingFunction', this.s.cssEasing);

                _lgUtils2.default.setVendor(inner, 'TransitionDuration', this.s.speed + 'ms');
              }

              setTimeout(function () {
                _lgUtils2.default.addClass(document.querySelector('.lg-backdrop'), 'in');
              });
              setTimeout(function () {
                _lgUtils2.default.addClass(_this.outer, 'lg-visible');
              }, this.s.backdropDuration);

              if (this.s.download) {
                this.outer.querySelector('.lg-toolbar').insertAdjacentHTML('beforeend', '<a id="lg-download" aria-label="Download" target="_blank" download class="lg-download lg-icon"></a>');
              } // Store the current scroll top value to scroll back after closing the gallery..


              this.prevScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            }; // For fixed height gallery


            Plugin.prototype.setTop = function () {
              if (this.s.height !== '100%') {
                var wH = window.innerHeight;
                var top = (wH - parseInt(this.s.height, 10)) / 2;
                var lGallery = this.outer.querySelector('.lg');

                if (wH >= parseInt(this.s.height, 10)) {
                  lGallery.style.top = top + 'px';
                } else {
                  lGallery.style.top = '0px';
                }
              }
            }; // Find css3 support


            Plugin.prototype.doCss = function () {
              // check for css animation support
              var support = function support() {
                var transition = ['transition', 'MozTransition', 'WebkitTransition', 'OTransition', 'msTransition', 'KhtmlTransition'];
                var root = document.documentElement;
                var i = 0;

                for (i = 0; i < transition.length; i++) {
                  if (transition[i] in root.style) {
                    return true;
                  }
                }
              };

              if (support()) {
                return true;
              }

              return false;
            };
            /**
             *  @desc Check the given src is video
             *  @param {String} src
             *  @return {Object} video type
             *  Ex:{ youtube  :  ["//www.youtube.com/watch?v=c0asJgSyxcY", "c0asJgSyxcY"] }
             */


            Plugin.prototype.isVideo = function (src, index) {
              var html;

              if (this.s.dynamic) {
                html = this.s.dynamicEl[index].html;
              } else {
                html = this.items[index].getAttribute('data-html');
              }

              if (!src && html) {
                return {
                  html5: true
                };
              }

              var youtube = src.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)/i);
              var vimeo = src.match(/\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i);
              var dailymotion = src.match(/\/\/(?:www\.)?dai.ly\/([0-9a-z\-_]+)/i);
              var vk = src.match(/\/\/(?:www\.)?(?:vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?)(.*)/i);

              if (youtube) {
                return {
                  youtube: youtube
                };
              } else if (vimeo) {
                return {
                  vimeo: vimeo
                };
              } else if (dailymotion) {
                return {
                  dailymotion: dailymotion
                };
              } else if (vk) {
                return {
                  vk: vk
                };
              }
            };
            /**
             *  @desc Create image counter
             *  Ex: 1/10
             */


            Plugin.prototype.counter = function () {
              if (this.s.counter) {
                this.outer.querySelector(this.s.appendCounterTo).insertAdjacentHTML('beforeend', '<div id="lg-counter" role="status" aria-live="polite"><span id="lg-counter-current">' + (parseInt(this.index, 10) + 1) + '</span> / <span id="lg-counter-all">' + this.items.length + '</span></div>');
              }
            };
            /**
             *  @desc add sub-html into the slide
             *  @param {Number} index - index of the slide
             */


            Plugin.prototype.addHtml = function (index) {
              var subHtml = null;
              var currentEle;

              if (this.s.dynamic) {
                subHtml = this.s.dynamicEl[index].subHtml;
              } else {
                currentEle = this.items[index];
                subHtml = currentEle.getAttribute('data-sub-html');

                if (this.s.getCaptionFromTitleOrAlt && !subHtml) {
                  subHtml = currentEle.getAttribute('title');

                  if (subHtml && currentEle.querySelector('img')) {
                    subHtml = currentEle.querySelector('img').getAttribute('alt');
                  }
                }
              }

              if (typeof subHtml !== 'undefined' && subHtml !== null) {
                // get first letter of subhtml
                // if first letter starts with . or # get the html form the jQuery object
                var fL = subHtml.substring(0, 1);

                if (fL === '.' || fL === '#') {
                  if (this.s.subHtmlSelectorRelative && !this.s.dynamic) {
                    subHtml = currentEle.querySelector(subHtml).innerHTML;
                  } else {
                    subHtml = document.querySelector(subHtml).innerHTML;
                  }
                }
              } else {
                subHtml = '';
              }

              if (this.s.appendSubHtmlTo === '.lg-sub-html') {
                this.outer.querySelector(this.s.appendSubHtmlTo).innerHTML = subHtml;
              } else {
                this.___slide[index].insertAdjacentHTML('beforeend', subHtml);
              } // Add lg-empty-html class if title doesn't exist


              if (typeof subHtml !== 'undefined' && subHtml !== null) {
                if (subHtml === '') {
                  _lgUtils2.default.addClass(this.outer.querySelector(this.s.appendSubHtmlTo), 'lg-empty-html');
                } else {
                  _lgUtils2.default.removeClass(this.outer.querySelector(this.s.appendSubHtmlTo), 'lg-empty-html');
                }
              }

              _lgUtils2.default.trigger(this.el, 'onAfterAppendSubHtml', {
                index: index
              });
            };
            /**
             *  @desc Preload slides
             *  @param {Number} index - index of the slide
             */


            Plugin.prototype.preload = function (index) {
              var i = 1;
              var j = 1;

              for (i = 1; i <= this.s.preload; i++) {
                if (i >= this.items.length - index) {
                  break;
                }

                this.loadContent(index + i, false, 0);
              }

              for (j = 1; j <= this.s.preload; j++) {
                if (index - j < 0) {
                  break;
                }

                this.loadContent(index - j, false, 0);
              }
            };
            /**
             *  @desc Load slide content into slide.
             *  @param {Number} index - index of the slide.
             *  @param {Boolean} rec - if true call loadcontent() function again.
             *  @param {Boolean} delay - delay for adding complete class. it is 0 except first time.
             */


            Plugin.prototype.loadContent = function (index, rec, delay) {
              var _this = this;

              var _hasPoster = false;

              var _img;

              var _src;

              var _poster;

              var _srcset;

              var _sizes;

              var _html;

              var _alt;

              var getResponsiveSrc = function getResponsiveSrc(srcItms) {
                var rsWidth = [];
                var rsSrc = [];

                for (var i = 0; i < srcItms.length; i++) {
                  var __src = srcItms[i].split(' '); // Manage empty space


                  if (__src[0] === '') {
                    __src.splice(0, 1);
                  }

                  rsSrc.push(__src[0]);
                  rsWidth.push(__src[1]);
                }

                var wWidth = window.innerWidth;

                for (var j = 0; j < rsWidth.length; j++) {
                  if (parseInt(rsWidth[j], 10) > wWidth) {
                    _src = rsSrc[j];
                    break;
                  }
                }
              };

              if (_this.s.dynamic) {
                if (_this.s.dynamicEl[index].poster) {
                  _hasPoster = true;
                  _poster = _this.s.dynamicEl[index].poster;
                }

                _html = _this.s.dynamicEl[index].html;
                _src = _this.s.dynamicEl[index].src;
                _alt = _this.s.dynamicEl[index].alt;

                if (_this.s.dynamicEl[index].responsive) {
                  var srcDyItms = _this.s.dynamicEl[index].responsive.split(',');

                  getResponsiveSrc(srcDyItms);
                }

                _srcset = _this.s.dynamicEl[index].srcset;
                _sizes = _this.s.dynamicEl[index].sizes;
              } else {
                if (_this.items[index].getAttribute('data-poster')) {
                  _hasPoster = true;
                  _poster = _this.items[index].getAttribute('data-poster');
                }

                _html = _this.items[index].getAttribute('data-html');
                _src = _this.items[index].getAttribute('href') || _this.items[index].getAttribute('data-src');
                _alt = _this.items[index].getAttribute('title');

                if (_this.items[index].querySelector('img')) {
                  _alt = _alt || _this.items[index].querySelector('img').getAttribute('alt');
                }

                if (_this.items[index].getAttribute('data-responsive')) {
                  var srcItms = _this.items[index].getAttribute('data-responsive').split(',');

                  getResponsiveSrc(srcItms);
                }

                _srcset = _this.items[index].getAttribute('data-srcset');
                _sizes = _this.items[index].getAttribute('data-sizes');
              } //if (_src || _srcset || _sizes || _poster) {


              var iframe = false;

              if (_this.s.dynamic) {
                if (_this.s.dynamicEl[index].iframe) {
                  iframe = true;
                }
              } else {
                if (_this.items[index].getAttribute('data-iframe') === 'true') {
                  iframe = true;
                }
              }

              var _isVideo = _this.isVideo(_src, index);

              if (!_lgUtils2.default.hasClass(_this.___slide[index], 'lg-loaded')) {
                if (iframe) {
                  _this.___slide[index].insertAdjacentHTML('afterbegin', '<div class="lg-video-cont" style="max-width:' + _this.s.iframeMaxWidth + '"><div class="lg-video"><iframe class="lg-object" frameborder="0" src="' + _src + '"  allowfullscreen="true"></iframe></div></div>');
                } else if (_hasPoster) {
                  var videoClass = '';

                  if (_isVideo && _isVideo.youtube) {
                    videoClass = 'lg-has-youtube';
                  } else if (_isVideo && _isVideo.vimeo) {
                    videoClass = 'lg-has-vimeo';
                  } else {
                    videoClass = 'lg-has-html5';
                  }

                  _this.___slide[index].insertAdjacentHTML('beforeend', '<div class="lg-video-cont ' + videoClass + ' "><div class="lg-video"><span class="lg-video-play"></span><img class="lg-object lg-has-poster" src="' + _poster + '" /></div></div>');
                } else if (_isVideo) {
                  _this.___slide[index].insertAdjacentHTML('beforeend', '<div class="lg-video-cont "><div class="lg-video"></div></div>');

                  _lgUtils2.default.trigger(_this.el, 'hasVideo', {
                    index: index,
                    src: _src,
                    html: _html
                  });
                } else {
                  _alt = _alt ? 'alt="' + _alt + '"' : '';

                  _this.___slide[index].insertAdjacentHTML('beforeend', '<div class="lg-img-wrap"><img class="lg-object lg-image" ' + _alt + ' src="' + _src + '" /></div>');
                }

                _lgUtils2.default.trigger(_this.el, 'onAferAppendSlide', {
                  index: index
                });

                _img = _this.___slide[index].querySelector('.lg-object');

                if (_sizes) {
                  _img.setAttribute('sizes', _sizes);
                }

                if (_srcset) {
                  _img.setAttribute('srcset', _srcset);

                  if (this.s.supportLegacyBrowser) {
                    try {
                      picturefill({
                        elements: [_img[0]]
                      });
                    } catch (e) {
                      console.warn('If you want srcset to be supported for older browsers, ' + 'please include picturefil javascript library in your document.');
                    }
                  }
                }

                if (this.s.appendSubHtmlTo !== '.lg-sub-html') {
                  _this.addHtml(index);
                }

                _lgUtils2.default.addClass(_this.___slide[index], 'lg-loaded');
              }

              _lgUtils2.default.on(_this.___slide[index].querySelector('.lg-object'), 'load.lg error.lg', function () {
                // For first time add some delay for displaying the start animation.
                var _speed = 0; // Do not change the delay value because it is required for zoom plugin.
                // If gallery opened from direct url (hash) speed value should be 0

                if (delay && !_lgUtils2.default.hasClass(document.body, 'lg-from-hash')) {
                  _speed = delay;
                }

                setTimeout(function () {
                  _lgUtils2.default.addClass(_this.___slide[index], 'lg-complete');

                  _lgUtils2.default.trigger(_this.el, 'onSlideItemLoad', {
                    index: index,
                    delay: delay || 0
                  });
                }, _speed);
              }); // @todo check load state for html5 videos


              if (_isVideo && _isVideo.html5 && !_hasPoster) {
                _lgUtils2.default.addClass(_this.___slide[index], 'lg-complete');
              }

              if (rec === true) {
                if (!_lgUtils2.default.hasClass(_this.___slide[index], 'lg-complete')) {
                  _lgUtils2.default.on(_this.___slide[index].querySelector('.lg-object'), 'load.lg error.lg', function () {
                    _this.preload(index);
                  });
                } else {
                  _this.preload(index);
                }
              } //}

            };
            /**
             *   @desc slide function for lightgallery
             ** Slide() gets call on start
             ** ** Set lg.on true once slide() function gets called.
             ** Call loadContent() on slide() function inside setTimeout
             ** ** On first slide we do not want any animation like slide of fade
             ** ** So on first slide( if lg.on if false that is first slide) loadContent() should start loading immediately
             ** ** Else loadContent() should wait for the transition to complete.
             ** ** So set timeout s.speed + 50
            <=> ** loadContent() will load slide content in to the particular slide
             ** ** It has recursion (rec) parameter. if rec === true loadContent() will call preload() function.
             ** ** preload will execute only when the previous slide is fully loaded (images iframe)
             ** ** avoid simultaneous image load
            <=> ** Preload() will check for s.preload value and call loadContent() again accoring to preload value
             ** loadContent()  <====> Preload();
            	 *   @param {Number} index - index of the slide
             *   @param {Boolean} fromTouch - true if slide function called via touch event or mouse drag
             *   @param {Boolean} fromThumb - true if slide function called via thumbnail click
             */


            Plugin.prototype.slide = function (index, fromTouch, fromThumb) {
              var _prevIndex = 0;

              for (var i = 0; i < this.___slide.length; i++) {
                if (_lgUtils2.default.hasClass(this.___slide[i], 'lg-current')) {
                  _prevIndex = i;
                  break;
                }
              }

              var _this = this; // Prevent if multiple call
              // Required for hsh plugin


              if (_this.lGalleryOn && _prevIndex === index) {
                return;
              }

              var _length = this.___slide.length;

              var _time = _this.lGalleryOn ? this.s.speed : 0;

              var _next = false;
              var _prev = false;

              if (!_this.lgBusy) {
                if (this.s.download) {
                  var _src;

                  if (_this.s.dynamic) {
                    _src = _this.s.dynamicEl[index].downloadUrl !== false && (_this.s.dynamicEl[index].downloadUrl || _this.s.dynamicEl[index].src);
                  } else {
                    _src = _this.items[index].getAttribute('data-download-url') !== 'false' && (_this.items[index].getAttribute('data-download-url') || _this.items[index].getAttribute('href') || _this.items[index].getAttribute('data-src'));
                  }

                  if (_src) {
                    document.getElementById('lg-download').setAttribute('href', _src);

                    _lgUtils2.default.removeClass(_this.outer, 'lg-hide-download');
                  } else {
                    _lgUtils2.default.addClass(_this.outer, 'lg-hide-download');
                  }
                }

                _lgUtils2.default.trigger(_this.el, 'onBeforeSlide', {
                  prevIndex: _prevIndex,
                  index: index,
                  fromTouch: fromTouch,
                  fromThumb: fromThumb
                });

                _this.lgBusy = true;
                clearTimeout(_this.hideBartimeout); // Add title if this.s.appendSubHtmlTo === lg-sub-html

                if (this.s.appendSubHtmlTo === '.lg-sub-html') {
                  // wait for slide animation to complete
                  setTimeout(function () {
                    _this.addHtml(index);
                  }, _time);
                }

                this.arrowDisable(index);

                if (!fromTouch) {
                  // remove all transitions
                  _lgUtils2.default.addClass(_this.outer, 'lg-no-trans');

                  for (var j = 0; j < this.___slide.length; j++) {
                    _lgUtils2.default.removeClass(this.___slide[j], 'lg-prev-slide');

                    _lgUtils2.default.removeClass(this.___slide[j], 'lg-next-slide');
                  }

                  if (index < _prevIndex) {
                    _prev = true;

                    if (index === 0 && _prevIndex === _length - 1 && !fromThumb) {
                      _prev = false;
                      _next = true;
                    }
                  } else if (index > _prevIndex) {
                    _next = true;

                    if (index === _length - 1 && _prevIndex === 0 && !fromThumb) {
                      _prev = true;
                      _next = false;
                    }
                  }

                  if (_prev) {
                    //prevslide
                    _lgUtils2.default.addClass(this.___slide[index], 'lg-prev-slide');

                    _lgUtils2.default.addClass(this.___slide[_prevIndex], 'lg-next-slide');
                  } else if (_next) {
                    // next slide
                    _lgUtils2.default.addClass(this.___slide[index], 'lg-next-slide');

                    _lgUtils2.default.addClass(this.___slide[_prevIndex], 'lg-prev-slide');
                  } // give 50 ms for browser to add/remove class


                  setTimeout(function () {
                    _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-current'), 'lg-current'); //_this.$slide.eq(_prevIndex).removeClass('lg-current');


                    _lgUtils2.default.addClass(_this.___slide[index], 'lg-current'); // reset all transitions


                    _lgUtils2.default.removeClass(_this.outer, 'lg-no-trans');
                  }, 50);
                } else {
                  var touchPrev = index - 1;
                  var touchNext = index + 1;

                  if (index === 0 && _prevIndex === _length - 1) {
                    // next slide
                    touchNext = 0;
                    touchPrev = _length - 1;
                  } else if (index === _length - 1 && _prevIndex === 0) {
                    // prev slide
                    touchNext = 0;
                    touchPrev = _length - 1;
                  }

                  _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-prev-slide'), 'lg-prev-slide');

                  _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-current'), 'lg-current');

                  _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-next-slide'), 'lg-next-slide');

                  _lgUtils2.default.addClass(_this.___slide[touchPrev], 'lg-prev-slide');

                  _lgUtils2.default.addClass(_this.___slide[touchNext], 'lg-next-slide');

                  _lgUtils2.default.addClass(_this.___slide[index], 'lg-current');
                }

                if (_this.lGalleryOn) {
                  setTimeout(function () {
                    _this.loadContent(index, true, 0);
                  }, this.s.speed + 50);
                  setTimeout(function () {
                    _this.lgBusy = false;

                    _lgUtils2.default.trigger(_this.el, 'onAfterSlide', {
                      prevIndex: _prevIndex,
                      index: index,
                      fromTouch: fromTouch,
                      fromThumb: fromThumb
                    });
                  }, this.s.speed);
                } else {
                  _this.loadContent(index, true, _this.s.backdropDuration);

                  _this.lgBusy = false;

                  _lgUtils2.default.trigger(_this.el, 'onAfterSlide', {
                    prevIndex: _prevIndex,
                    index: index,
                    fromTouch: fromTouch,
                    fromThumb: fromThumb
                  });
                }

                _this.lGalleryOn = true;

                if (this.s.counter) {
                  if (document.getElementById('lg-counter-current')) {
                    document.getElementById('lg-counter-current').innerHTML = index + 1;
                  }
                }
              }
            };
            /**
             *  @desc Go to next slide
             *  @param {Boolean} fromTouch - true if slide function called via touch event
             */


            Plugin.prototype.goToNextSlide = function (fromTouch) {
              var _this = this;

              if (!_this.lgBusy) {
                if (_this.index + 1 < _this.___slide.length) {
                  _this.index++;

                  _lgUtils2.default.trigger(_this.el, 'onBeforeNextSlide', {
                    index: _this.index
                  });

                  _this.slide(_this.index, fromTouch, false);
                } else {
                  if (_this.s.loop) {
                    _this.index = 0;

                    _lgUtils2.default.trigger(_this.el, 'onBeforeNextSlide', {
                      index: _this.index
                    });

                    _this.slide(_this.index, fromTouch, false);
                  } else if (_this.s.slideEndAnimatoin) {
                    _lgUtils2.default.addClass(_this.outer, 'lg-right-end');

                    setTimeout(function () {
                      _lgUtils2.default.removeClass(_this.outer, 'lg-right-end');
                    }, 400);
                  }
                }
              }
            };
            /**
             *  @desc Go to previous slide
             *  @param {Boolean} fromTouch - true if slide function called via touch event
             */


            Plugin.prototype.goToPrevSlide = function (fromTouch) {
              var _this = this;

              if (!_this.lgBusy) {
                if (_this.index > 0) {
                  _this.index--;

                  _lgUtils2.default.trigger(_this.el, 'onBeforePrevSlide', {
                    index: _this.index,
                    fromTouch: fromTouch
                  });

                  _this.slide(_this.index, fromTouch, false);
                } else {
                  if (_this.s.loop) {
                    _this.index = _this.items.length - 1;

                    _lgUtils2.default.trigger(_this.el, 'onBeforePrevSlide', {
                      index: _this.index,
                      fromTouch: fromTouch
                    });

                    _this.slide(_this.index, fromTouch, false);
                  } else if (_this.s.slideEndAnimatoin) {
                    _lgUtils2.default.addClass(_this.outer, 'lg-left-end');

                    setTimeout(function () {
                      _lgUtils2.default.removeClass(_this.outer, 'lg-left-end');
                    }, 400);
                  }
                }
              }
            };

            Plugin.prototype.keyPress = function () {
              var _this = this;

              if (this.items.length > 1) {
                _lgUtils2.default.on(window, 'keyup.lg', function (e) {
                  if (_this.items.length > 1) {
                    if (e.keyCode === 37) {
                      e.preventDefault();

                      _this.goToPrevSlide();
                    }

                    if (e.keyCode === 39) {
                      e.preventDefault();

                      _this.goToNextSlide();
                    }
                  }
                });
              }

              _lgUtils2.default.on(window, 'keydown.lg', function (e) {
                if (_this.s.escKey === true && e.keyCode === 27) {
                  e.preventDefault();

                  if (!_lgUtils2.default.hasClass(_this.outer, 'lg-thumb-open')) {
                    _this.destroy();
                  } else {
                    _lgUtils2.default.removeClass(_this.outer, 'lg-thumb-open');
                  }
                }
              });
            };

            Plugin.prototype.arrow = function () {
              var _this = this;

              _lgUtils2.default.on(this.outer.querySelector('.lg-prev'), 'click.lg', function () {
                _this.goToPrevSlide();
              });

              _lgUtils2.default.on(this.outer.querySelector('.lg-next'), 'click.lg', function () {
                _this.goToNextSlide();
              });
            };

            Plugin.prototype.arrowDisable = function (index) {
              // Disable arrows if s.hideControlOnEnd is true
              if (!this.s.loop && this.s.hideControlOnEnd) {
                var next = this.outer.querySelector('.lg-next');
                var prev = this.outer.querySelector('.lg-prev');

                if (index + 1 < this.___slide.length) {
                  next.removeAttribute('disabled');

                  _lgUtils2.default.removeClass(next, 'disabled');
                } else {
                  next.setAttribute('disabled', 'disabled');

                  _lgUtils2.default.addClass(next, 'disabled');
                }

                if (index > 0) {
                  prev.removeAttribute('disabled');

                  _lgUtils2.default.removeClass(prev, 'disabled');
                } else {
                  prev.setAttribute('disabled', 'disabled');

                  _lgUtils2.default.addClass(prev, 'disabled');
                }
              }
            };

            Plugin.prototype.setTranslate = function (el, xValue, yValue) {
              // jQuery supports Automatic CSS prefixing since jQuery 1.8.0
              if (this.s.useLeft) {
                el.style.left = xValue;
              } else {
                _lgUtils2.default.setVendor(el, 'Transform', 'translate3d(' + xValue + 'px, ' + yValue + 'px, 0px)');
              }
            };

            Plugin.prototype.touchMove = function (startCoords, endCoords) {
              var distance = endCoords - startCoords;

              if (Math.abs(distance) > 15) {
                // reset opacity and transition duration
                _lgUtils2.default.addClass(this.outer, 'lg-dragging'); // move current slide


                this.setTranslate(this.___slide[this.index], distance, 0); // move next and prev slide with current slide

                this.setTranslate(document.querySelector('.lg-prev-slide'), -this.___slide[this.index].clientWidth + distance, 0);
                this.setTranslate(document.querySelector('.lg-next-slide'), this.___slide[this.index].clientWidth + distance, 0);
              }
            };

            Plugin.prototype.touchEnd = function (distance) {
              var _this = this; // keep slide animation for any mode while dragg/swipe


              if (_this.s.mode !== 'lg-slide') {
                _lgUtils2.default.addClass(_this.outer, 'lg-slide');
              }

              for (var i = 0; i < this.___slide.length; i++) {
                if (!_lgUtils2.default.hasClass(this.___slide[i], 'lg-current') && !_lgUtils2.default.hasClass(this.___slide[i], 'lg-prev-slide') && !_lgUtils2.default.hasClass(this.___slide[i], 'lg-next-slide')) {
                  this.___slide[i].style.opacity = '0';
                }
              } // set transition duration


              setTimeout(function () {
                _lgUtils2.default.removeClass(_this.outer, 'lg-dragging');

                if (distance < 0 && Math.abs(distance) > _this.s.swipeThreshold) {
                  _this.goToNextSlide(true);
                } else if (distance > 0 && Math.abs(distance) > _this.s.swipeThreshold) {
                  _this.goToPrevSlide(true);
                } else if (Math.abs(distance) < 5) {
                  // Trigger click if distance is less than 5 pix
                  _lgUtils2.default.trigger(_this.el, 'onSlideClick');
                }

                for (var i = 0; i < _this.___slide.length; i++) {
                  _this.___slide[i].removeAttribute('style');
                }
              }); // remove slide class once drag/swipe is completed if mode is not slide

              setTimeout(function () {
                if (!_lgUtils2.default.hasClass(_this.outer, 'lg-dragging') && _this.s.mode !== 'lg-slide') {
                  _lgUtils2.default.removeClass(_this.outer, 'lg-slide');
                }
              }, _this.s.speed + 100);
            };

            Plugin.prototype.enableSwipe = function () {
              var _this = this;

              var startCoords = 0;
              var endCoords = 0;
              var isMoved = false;

              if (_this.s.enableSwipe && _this.isTouch && _this.doCss()) {
                for (var i = 0; i < _this.___slide.length; i++) {
                  /*jshint loopfunc: true */
                  _lgUtils2.default.on(_this.___slide[i], 'touchstart.lg', function (e) {
                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed') && !_this.lgBusy) {
                      e.preventDefault();

                      _this.manageSwipeClass();

                      startCoords = e.targetTouches[0].pageX;
                    }
                  });
                }

                for (var j = 0; j < _this.___slide.length; j++) {
                  /*jshint loopfunc: true */
                  _lgUtils2.default.on(_this.___slide[j], 'touchmove.lg', function (e) {
                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed')) {
                      e.preventDefault();
                      endCoords = e.targetTouches[0].pageX;

                      _this.touchMove(startCoords, endCoords);

                      isMoved = true;
                    }
                  });
                }

                for (var k = 0; k < _this.___slide.length; k++) {
                  /*jshint loopfunc: true */
                  _lgUtils2.default.on(_this.___slide[k], 'touchend.lg', function () {
                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed')) {
                      if (isMoved) {
                        isMoved = false;

                        _this.touchEnd(endCoords - startCoords);
                      } else {
                        _lgUtils2.default.trigger(_this.el, 'onSlideClick');
                      }
                    }
                  });
                }
              }
            };

            Plugin.prototype.enableDrag = function () {
              var _this = this;

              var startCoords = 0;
              var endCoords = 0;
              var isDraging = false;
              var isMoved = false;

              if (_this.s.enableDrag && !_this.isTouch && _this.doCss()) {
                for (var i = 0; i < _this.___slide.length; i++) {
                  /*jshint loopfunc: true */
                  _lgUtils2.default.on(_this.___slide[i], 'mousedown.lg', function (e) {
                    // execute only on .lg-object
                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed')) {
                      if (_lgUtils2.default.hasClass(e.target, 'lg-object') || _lgUtils2.default.hasClass(e.target, 'lg-video-play')) {
                        e.preventDefault();

                        if (!_this.lgBusy) {
                          _this.manageSwipeClass();

                          startCoords = e.pageX;
                          isDraging = true; // ** Fix for webkit cursor issue https://code.google.com/p/chromium/issues/detail?id=26723

                          _this.outer.scrollLeft += 1;
                          _this.outer.scrollLeft -= 1; // *

                          _lgUtils2.default.removeClass(_this.outer, 'lg-grab');

                          _lgUtils2.default.addClass(_this.outer, 'lg-grabbing');

                          _lgUtils2.default.trigger(_this.el, 'onDragstart');
                        }
                      }
                    }
                  });
                }

                _lgUtils2.default.on(window, 'mousemove.lg', function (e) {
                  if (isDraging) {
                    isMoved = true;
                    endCoords = e.pageX;

                    _this.touchMove(startCoords, endCoords);

                    _lgUtils2.default.trigger(_this.el, 'onDragmove');
                  }
                });

                _lgUtils2.default.on(window, 'mouseup.lg', function (e) {
                  if (isMoved) {
                    isMoved = false;

                    _this.touchEnd(endCoords - startCoords);

                    _lgUtils2.default.trigger(_this.el, 'onDragend');
                  } else if (_lgUtils2.default.hasClass(e.target, 'lg-object') || _lgUtils2.default.hasClass(e.target, 'lg-video-play')) {
                    _lgUtils2.default.trigger(_this.el, 'onSlideClick');
                  } // Prevent execution on click


                  if (isDraging) {
                    isDraging = false;

                    _lgUtils2.default.removeClass(_this.outer, 'lg-grabbing');

                    _lgUtils2.default.addClass(_this.outer, 'lg-grab');
                  }
                });
              }
            };

            Plugin.prototype.manageSwipeClass = function () {
              var touchNext = this.index + 1;
              var touchPrev = this.index - 1;
              var length = this.___slide.length;

              if (this.s.loop) {
                if (this.index === 0) {
                  touchPrev = length - 1;
                } else if (this.index === length - 1) {
                  touchNext = 0;
                }
              }

              for (var i = 0; i < this.___slide.length; i++) {
                _lgUtils2.default.removeClass(this.___slide[i], 'lg-next-slide');

                _lgUtils2.default.removeClass(this.___slide[i], 'lg-prev-slide');
              }

              if (touchPrev > -1) {
                _lgUtils2.default.addClass(this.___slide[touchPrev], 'lg-prev-slide');
              }

              _lgUtils2.default.addClass(this.___slide[touchNext], 'lg-next-slide');
            };

            Plugin.prototype.mousewheel = function () {
              var _this = this;

              _lgUtils2.default.on(_this.outer, 'mousewheel.lg', function (e) {
                if (!e.deltaY) {
                  return;
                }

                if (e.deltaY > 0) {
                  _this.goToPrevSlide();
                } else {
                  _this.goToNextSlide();
                }

                e.preventDefault();
              });
            };

            Plugin.prototype.closeGallery = function () {
              var _this = this;

              var mousedown = false;

              _lgUtils2.default.on(this.outer.querySelector('.lg-close'), 'click.lg', function () {
                _this.destroy();
              });

              if (_this.s.closable) {
                // If you drag the slide and release outside gallery gets close on chrome
                // for preventing this check mousedown and mouseup happened on .lg-item or lg-outer
                _lgUtils2.default.on(_this.outer, 'mousedown.lg', function (e) {
                  if (_lgUtils2.default.hasClass(e.target, 'lg-outer') || _lgUtils2.default.hasClass(e.target, 'lg-item') || _lgUtils2.default.hasClass(e.target, 'lg-img-wrap')) {
                    mousedown = true;
                  } else {
                    mousedown = false;
                  }
                });

                _lgUtils2.default.on(_this.outer, 'mouseup.lg', function (e) {
                  if (_lgUtils2.default.hasClass(e.target, 'lg-outer') || _lgUtils2.default.hasClass(e.target, 'lg-item') || _lgUtils2.default.hasClass(e.target, 'lg-img-wrap') && mousedown) {
                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-dragging')) {
                      _this.destroy();
                    }
                  }
                });
              }
            };

            Plugin.prototype.destroy = function (d) {
              var _this = this;

              if (!d) {
                _lgUtils2.default.trigger(_this.el, 'onBeforeClose');
              }

              document.body.scrollTop = _this.prevScrollTop;
              document.documentElement.scrollTop = _this.prevScrollTop;
              /**
               * if d is false or undefined destroy will only close the gallery
               * plugins instance remains with the element
               *
               * if d is true destroy will completely remove the plugin
               */

              if (d) {
                if (!_this.s.dynamic) {
                  // only when not using dynamic mode is $items a jquery collection
                  for (var i = 0; i < this.items.length; i++) {
                    _lgUtils2.default.off(this.items[i], '.lg');

                    _lgUtils2.default.off(this.items[i], '.lgcustom');
                  }
                }

                var lguid = _this.el.getAttribute('lg-uid');

                delete window.lgData[lguid];

                _this.el.removeAttribute('lg-uid');
              } // Unbind all events added by lightGallery


              _lgUtils2.default.off(this.el, '.lgtm'); // Distroy all lightGallery modules


              for (var key in window.lgModules) {
                if (_this.modules[key]) {
                  _this.modules[key].destroy(d);
                }
              }

              this.lGalleryOn = false;
              clearTimeout(_this.hideBartimeout);
              this.hideBartimeout = false;

              _lgUtils2.default.off(window, '.lg');

              _lgUtils2.default.removeClass(document.body, 'lg-on');

              _lgUtils2.default.removeClass(document.body, 'lg-from-hash');

              if (_this.outer) {
                _lgUtils2.default.removeClass(_this.outer, 'lg-visible');
              }

              _lgUtils2.default.removeClass(document.querySelector('.lg-backdrop'), 'in');

              setTimeout(function () {
                try {
                  if (_this.outer) {
                    _this.outer.parentNode.removeChild(_this.outer);
                  }

                  if (document.querySelector('.lg-backdrop')) {
                    document.querySelector('.lg-backdrop').parentNode.removeChild(document.querySelector('.lg-backdrop'));
                  }

                  if (!d) {
                    _lgUtils2.default.trigger(_this.el, 'onCloseAfter');
                  }

                  _this.el.focus();
                } catch (err) {}
              }, _this.s.backdropDuration + 50);
            };

            window.lightGallery = function (el, options) {
              if (!el) {
                return;
              }

              try {
                if (!el.getAttribute('lg-uid')) {
                  var uid = 'lg' + window.lgData.uid++;
                  window.lgData[uid] = new Plugin(el, options);
                  el.setAttribute('lg-uid', uid);
                } else {
                  window.lgData[el.getAttribute('lg-uid')].init();
                }
              } catch (err) {
                console.error('lightGallery has not initiated properly', err);
              }
            };
          });
        }, {
          './lg-utils': 1
        }]
      }, {}, [2])(2);
    });
  });
  unwrapExports(lightgallery);

  var script$1C = {
    mixins: [__vue_component__$2],
    data: function data() {
      var _breakpoints;

      return {
        optionsMain: {
          // effect: 'fade',
          speed: 800,
          threshold: 30,
          // lazy load images
          lazy: {
            loadPrevNext: true,
            loadOnTransitionStart: true
          }
        },
        optionsThumb: {
          threshold: 60,
          // Responsive breakpoints
          breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, breakpoints['4xs-min'], {
            slidesPerView: 4,
            direction: 'horizontal',
            updateOnWindowResize: true,
            height: 48,
            spaceBetween: 12
          }), _defineProperty(_breakpoints, breakpoints['3xs-min'], {
            updateOnWindowResize: true,
            direction: 'horizontal',
            slidesPerView: 5,
            height: 48,
            spaceBetween: 12
          }), _defineProperty(_breakpoints, breakpoints['2xs-min'], {
            updateOnWindowResize: true,
            direction: 'horizontal',
            slidesPerView: 6,
            height: 48,
            spaceBetween: 12
          }), _defineProperty(_breakpoints, breakpoints['sm-min'], {
            direction: 'vertical',
            slidesPerView: 5,
            spaceBetween: 24,
            height: 496,
            updateOnWindowResize: false
          }), _breakpoints)
        }
      };
    },
    props: {
      options: {
        default: null
      }
    },
    mounted: function mounted() {
      var _this = this;

      // установка связи меду слайдерами
      this.$nextTick(function () {
        var sliderMain = _this.$refs.sliderMain.$swiper;
        var sliderThumbs = _this.$refs.sliderThumbs.$swiper;
        sliderMain.thumbs.swiper = sliderThumbs;
        sliderMain.thumbs.init();
        sliderMain.thumbs.update();
        window.lightGallery(_this.$el, {
          selector: '.js-gallery-img'
        });
      });
    }
  };

  /* script */
  const __vue_script__$1C = script$1C;

  /* template */
  var __vue_render__$1w = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "v-slider-thumbs slider slider--w-thumbs" }, [
      _c(
        "div",
        { staticClass: "slider__thumbs" },
        [
          _c(
            "v-swiper",
            { ref: "sliderThumbs", attrs: { options: _vm.optionsThumb } },
            [_vm._t("thumbs")],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "slider__main" },
        [
          _c(
            "v-swiper",
            { ref: "sliderMain", attrs: { options: _vm.optionsMain } },
            [_vm._t("default")],
            2
          ),
        ],
        1
      ),
    ])
  };
  var __vue_staticRenderFns__$1w = [];
  __vue_render__$1w._withStripped = true;

    /* style */
    const __vue_inject_styles__$1C = undefined;
    /* scoped */
    const __vue_scope_id__$1C = undefined;
    /* module identifier */
    const __vue_module_identifier__$1C = undefined;
    /* functional template */
    const __vue_is_functional_template__$1C = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1C = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1w, staticRenderFns: __vue_staticRenderFns__$1w },
      __vue_inject_styles__$1C,
      __vue_script__$1C,
      __vue_scope_id__$1C,
      __vue_is_functional_template__$1C,
      __vue_module_identifier__$1C,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1D = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        slider: {}
      };
    },
    props: {
      options: {
        default: null
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        var _breakpoints,
            _this = this;

        var result = {
          // скрывать навигацию если не хватает слайдов
          watchOverflow: true,
          // Responsive breakpoints
          breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, breakpoints['4xs-min'], {
            slidesPerView: 1,
            loop: false,
            centeredSlides: true
          }), _defineProperty(_breakpoints, breakpoints['xs-min'], {
            slidesPerView: 2,
            loop: false
          }), _defineProperty(_breakpoints, breakpoints['sm-mid'] + 1, {
            slidesPerView: 3
          }), _breakpoints)
        };

        if (this.options) {
          Object.keys(this.options).forEach(function (key) {
            if (typeof _this.options[key] !== 'undefined') {
              result[key] = _this.options[key];
            }
          });
        }

        return result;
      }
    },
    methods: {
      dataSet: function dataSet(data) {
        this.slider = data;
      }
    }
  };

  /* script */
  const __vue_script__$1D = script$1D;

  /* template */
  var __vue_render__$1x = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-product-slider product-slider" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _c(
          "v-slider-carousel",
          {
            staticClass: "slider--products",
            attrs: {
              options: _vm.computedOptions,
              customClassName: "products-carousel",
              navigation: "navigation",
            },
          },
          _vm._l(_vm.slider.items, function (item, index) {
            return _c(
              "v-swiper-slide",
              {
                key: index + new Date().getTime(),
                staticClass: "product-slider__slide swiper-slide--stretch",
              },
              [
                _vm.slider.type === "products"
                  ? _c("v-product", {
                      attrs: { template: "grid", product: item },
                    })
                  : _vm._e(),
                _vm.slider.type === "articles"
                  ? _c("v-article-poster", { attrs: { article: item } })
                  : _vm._e(),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$1x = [];
  __vue_render__$1x._withStripped = true;

    /* style */
    const __vue_inject_styles__$1D = undefined;
    /* scoped */
    const __vue_scope_id__$1D = undefined;
    /* module identifier */
    const __vue_module_identifier__$1D = undefined;
    /* functional template */
    const __vue_is_functional_template__$1D = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1D = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1x, staticRenderFns: __vue_staticRenderFns__$1x },
      __vue_inject_styles__$1D,
      __vue_script__$1D,
      __vue_scope_id__$1D,
      __vue_is_functional_template__$1D,
      __vue_module_identifier__$1D,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1E = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        slider: {}
      };
    },
    props: {
      options: {
        default: null
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        var _breakpoints,
            _this = this;

        var result = {
          // скрывать навигацию если не хватает слайдов
          watchOverflow: true,
          // Responsive breakpoints
          breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, breakpoints['4xs-min'], {
            slidesPerView: 1,
            loopAdditionalSlides: 1,
            loopedSlides: 1,
            initialSlide: 2,
            loop: true,
            centeredSlides: true
          }), _defineProperty(_breakpoints, breakpoints['2xs-min'], {
            slidesPerView: 3
          }), _defineProperty(_breakpoints, breakpoints['sm-min'], {
            slidesPerView: 4
          }), _defineProperty(_breakpoints, breakpoints['sm-mid'] + 1, {
            slidesPerView: 5
          }), _defineProperty(_breakpoints, breakpoints['md-min'], {
            slidesPerView: 6
          }), _breakpoints)
        };

        if (this.options) {
          Object.keys(this.options).forEach(function (key) {
            if (typeof _this.options[key] !== 'undefined') {
              result[key] = _this.options[key];
            }
          });
        }

        return result;
      }
    },
    methods: {
      dataSet: function dataSet(data) {
        this.slider = data;
      }
    }
  };

  /* script */
  const __vue_script__$1E = script$1E;

  /* template */
  var __vue_render__$1y = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-brands-slider brands-slider" },
      [
        _c("v-loader", { attrs: { loading: _vm.loading } }),
        _vm.slider && _vm.slider.items && _vm.slider.items.length
          ? _c(
              "v-slider-carousel",
              {
                staticClass: "slider--products",
                attrs: { options: _vm.computedOptions, navigation: "navigation" },
              },
              _vm._l(_vm.slider.items, function (item, index) {
                return _c(
                  "v-swiper-slide",
                  {
                    key: index + new Date().getTime(),
                    staticClass: "product-slider__slide swiper-slide--stretch",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "brands-slider__item",
                        attrs: { href: item.link },
                      },
                      [
                        _c("img", {
                          staticClass: "brands-slider__img",
                          attrs: {
                            src: item.image,
                            alt: item.alt,
                            title: item.alt,
                          },
                        }),
                      ]
                    ),
                  ]
                )
              }),
              1
            )
          : _vm._e(),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$1y = [];
  __vue_render__$1y._withStripped = true;

    /* style */
    const __vue_inject_styles__$1E = undefined;
    /* scoped */
    const __vue_scope_id__$1E = undefined;
    /* module identifier */
    const __vue_module_identifier__$1E = undefined;
    /* functional template */
    const __vue_is_functional_template__$1E = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1E = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1y, staticRenderFns: __vue_staticRenderFns__$1y },
      __vue_inject_styles__$1E,
      __vue_script__$1E,
      __vue_scope_id__$1E,
      __vue_is_functional_template__$1E,
      __vue_module_identifier__$1E,
      false,
      undefined,
      undefined,
      undefined
    );

  var script$1F = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        timeout: null,
        reloadAutoplay: false
      };
    },
    props: {
      options: {
        default: null
      },
      navigation: {
        default: false
      },
      pagination: {
        default: false
      },
      customClassName: {
        default: false
      },
      fullscreen: {
        default: false
      }
    },
    methods: {
      prev: function prev() {
        this.$refs.sliderMain.$swiper.slidePrev();
      },
      next: function next() {
        this.$refs.sliderMain.$swiper.slideNext();
      },
      // если слайдов не хвататает для скролла вешаем класс на карусель
      checkEmptyCarousel: function checkEmptyCarousel() {
        var sliderMain = this.$refs.sliderMain.$swiper;
        var slidesWidth = 0;
        Array.from(sliderMain.slides).forEach(function (slide) {
          slidesWidth += slide.offsetWidth;
        });

        if (slidesWidth > sliderMain.$el[0].offsetWidth) {
          this.$el.classList.remove('slider--not-full');
        } else {
          this.$el.classList.add('slider--not-full');
        }
      }
    },
    computed: {
      computedOptions: function computedOptions() {
        var _breakpoints,
            _this = this;

        var vm = this;
        var result = {
          // скрывать навигацию если не хватает слайдов
          watchOverflow: true,
          threshold: 30,
          // Responsive breakpoints
          breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, breakpoints['4xs-min'], {
            slidesPerView: 1,
            loopAdditionalSlides: 1,
            loopedSlides: 1,
            initialSlide: 2,
            loop: true,
            centeredSlides: true // allowTouchMove: true,

          }), _defineProperty(_breakpoints, breakpoints['xs-min'], {
            // allowTouchMove: false,
            slidesPerView: 2
          }), _defineProperty(_breakpoints, breakpoints['sm-mid'] + 1, {
            // allowTouchMove: true,
            slidesPerView: 3
          }), _breakpoints),
          on: {
            // переключение автоплэя при свайпе лайдера
            touchEnd: function touchEnd() {
              vm.reloadAutoplay = false;
            }
          }
        }; // если пердан параметр добавлем пагинацию

        if (this.pagination) {
          result.pagination = {
            el: '.' + this.customClassName + '__pagination',
            type: 'bullets',
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 7
          };
        } // переопределение параметров слайдера переданных в атрибуте компонента


        if (this.options) {
          Object.keys(this.options).forEach(function (key) {
            if (typeof _this.options[key] !== 'undefined') {
              result[key] = _this.options[key];
            }
          });
        }

        return result;
      }
    },
    mounted: function mounted() {
      var _this2 = this;

      // обновление слайдера
      this.$nextTick(function () {
        var sliderMain = _this2.$refs.sliderMain.$swiper; // если пердан параметр добавлем навигацию

        if (_this2.navigation) {
          sliderMain.params.navigation.nextEl = _this2.$refs.next;
          sliderMain.params.navigation.prevEl = _this2.$refs.prev;
          sliderMain.navigation.init();
          sliderMain.navigation.update();
        } // если пердан параметр добавлем навигацию


        if (_this2.pagination) {
          sliderMain.params.pagination.clickable = true;
          sliderMain.pagination.init();
          sliderMain.pagination.update();
        }

        sliderMain.update();

        _this2.checkEmptyCarousel();

        window.addEventListener('resize', _this2.checkEmptyCarousel);
      });
    },
    updated: function updated() {
      var _this3 = this;

      // обновление слайдера
      this.$nextTick(function () {
        _this3.checkEmptyCarousel();

        _this3.$refs.sliderMain.$swiper.slideTo(0, 0);
      });
    }
  };

  /* script */
  const __vue_script__$1F = script$1F;

  /* template */
  var __vue_render__$1z = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-slider-carousel slider slider--carousel" },
      [
        _c(
          "v-swiper",
          { ref: "sliderMain", attrs: { options: _vm.computedOptions } },
          [_vm._t("default")],
          2
        ),
        _vm.pagination
          ? _c("div", {
              staticClass: "swiper-pagination",
              class: _vm.customClassName + "__pagination",
            })
          : _vm._e(),
        _vm.navigation
          ? _c(
              "div",
              {
                ref: "prev",
                staticClass: "slider__prev swiper-button-prev",
                class: _vm.customClassName + "__prev",
              },
              [
                _c("svg", { staticClass: "svg-icon" }, [
                  _c("use", { attrs: { "xlink:href": "#svg-icon-arrow-left" } }),
                ]),
              ]
            )
          : _vm._e(),
        _vm.navigation
          ? _c(
              "div",
              {
                ref: "next",
                staticClass: "slider__next swiper-button-next",
                class: _vm.customClassName + "__next",
              },
              [
                _c("svg", { staticClass: "svg-icon" }, [
                  _c("use", { attrs: { "xlink:href": "#svg-icon-arrow-right" } }),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$1z = [];
  __vue_render__$1z._withStripped = true;

    /* style */
    const __vue_inject_styles__$1F = undefined;
    /* scoped */
    const __vue_scope_id__$1F = undefined;
    /* module identifier */
    const __vue_module_identifier__$1F = undefined;
    /* functional template */
    const __vue_is_functional_template__$1F = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1F = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1z, staticRenderFns: __vue_staticRenderFns__$1z },
      __vue_inject_styles__$1F,
      __vue_script__$1F,
      __vue_scope_id__$1F,
      __vue_is_functional_template__$1F,
      __vue_module_identifier__$1F,
      false,
      undefined,
      undefined,
      undefined
    );

  //
  var script$1G = {
    mixins: [__vue_component__$2],
    data: function data() {
      return {
        tabs: {},
        activeTab: null
      };
    },
    methods: {
      setActiveTab: function setActiveTab() {
        var _this = this;

        this.activeTab = this.tabs.tabs.find(function (item) {
          return _this.tabs.tabsToggler.value == item.id;
        });
      },
      dataSet: function dataSet(data) {
        this.tabs = data;
        this.setActiveTab();
      }
    }
  };

  /* script */
  const __vue_script__$1G = script$1G;

  /* template */
  var __vue_render__$1A = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { staticClass: "v-tabs-slider tabs-slider" },
      [
        _vm.tabs.header
          ? _c("v-page-section-header", {
              attrs: {
                "data-source": _vm.tabs.header,
                "active-link": _vm.tabs.tabsToggler.value,
              },
            })
          : _vm._e(),
        _c("div", { staticClass: "tabs-slider__navigation-wrap" }, [
          _vm.tabs.tabsToggler
            ? _c(
                "div",
                { staticClass: "tabs-slider__navigation" },
                [
                  _c("v-field", {
                    attrs: { field: _vm.tabs.tabsToggler },
                    on: { input: _vm.setActiveTab },
                    model: {
                      value: _vm.tabs.tabsToggler.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.tabs.tabsToggler, "value", $$v);
                      },
                      expression: "tabs.tabsToggler.value",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm.activeTab
          ? _c(
              "div",
              { staticClass: "tabs-slider__content" },
              [
                _c("v-product-slider", {
                  attrs: { "data-source": _vm.activeTab },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    )
  };
  var __vue_staticRenderFns__$1A = [];
  __vue_render__$1A._withStripped = true;

    /* style */
    const __vue_inject_styles__$1G = undefined;
    /* scoped */
    const __vue_scope_id__$1G = undefined;
    /* module identifier */
    const __vue_module_identifier__$1G = undefined;
    /* functional template */
    const __vue_is_functional_template__$1G = false;
    /* style inject */
    
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    const __vue_component__$1G = /*#__PURE__*/normalizeComponent(
      { render: __vue_render__$1A, staticRenderFns: __vue_staticRenderFns__$1A },
      __vue_inject_styles__$1G,
      __vue_script__$1G,
      __vue_scope_id__$1G,
      __vue_is_functional_template__$1G,
      __vue_module_identifier__$1G,
      false,
      undefined,
      undefined,
      undefined
    );

  var vue2DaterangePicker_umd_min = createCommonjsModule(function (module, exports) {
    (function (t, e) {
       module.exports = e() ;
    })("undefined" !== typeof self ? self : commonjsGlobal, function () {
      return function (t) {
        var e = {};

        function n(r) {
          if (e[r]) return e[r].exports;
          var a = e[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return t[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
        }

        return n.m = t, n.c = e, n.d = function (t, e, r) {
          n.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: r
          });
        }, n.r = function (t) {
          "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, n.t = function (t, e) {
          if (1 & e && (t = n(t)), 8 & e) return t;
          if (4 & e && "object" === _typeof(t) && t && t.__esModule) return t;
          var r = Object.create(null);
          if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
          }), 2 & e && "string" != typeof t) for (var a in t) {
            n.d(r, a, function (e) {
              return t[e];
            }.bind(null, a));
          }
          return r;
        }, n.n = function (t) {
          var e = t && t.__esModule ? function () {
            return t["default"];
          } : function () {
            return t;
          };
          return n.d(e, "a", e), e;
        }, n.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, n.p = "", n(n.s = "fb15");
      }({
        "00ee": function ee(t, e, n) {
          var r = n("b622"),
              a = r("toStringTag"),
              i = {};
          i[a] = "z", t.exports = "[object z]" === String(i);
        },
        "057f": function f(t, e, n) {
          var r = n("fc6a"),
              a = n("241c").f,
              i = {}.toString,
              o = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
              s = function s(t) {
            try {
              return a(t);
            } catch (e) {
              return o.slice();
            }
          };

          t.exports.f = function (t) {
            return o && "[object Window]" == i.call(t) ? s(t) : a(r(t));
          };
        },
        "06cf": function cf(t, e, n) {
          var r = n("83ab"),
              a = n("d1e7"),
              i = n("5c6c"),
              o = n("fc6a"),
              s = n("c04e"),
              c = n("5135"),
              u = n("0cfb"),
              l = Object.getOwnPropertyDescriptor;
          e.f = r ? l : function (t, e) {
            if (t = o(t), e = s(e, !0), u) try {
              return l(t, e);
            } catch (n) {}
            if (c(t, e)) return i(!a.f.call(t, e), t[e]);
          };
        },
        "0cfb": function cfb(t, e, n) {
          var r = n("83ab"),
              a = n("d039"),
              i = n("cc12");
          t.exports = !r && !a(function () {
            return 7 != Object.defineProperty(i("div"), "a", {
              get: function get() {
                return 7;
              }
            }).a;
          });
        },
        "0e58": function e58(t, e, n) {

          var r = n("beb7"),
              a = n.n(r);
          a.a;
        },
        "14c3": function c3(t, e, n) {
          var r = n("c6b6"),
              a = n("9263");

          t.exports = function (t, e) {
            var n = t.exec;

            if ("function" === typeof n) {
              var i = n.call(t, e);
              if ("object" !== _typeof(i)) throw TypeError("RegExp exec method returned something other than an Object or null");
              return i;
            }

            if ("RegExp" !== r(t)) throw TypeError("RegExp#exec called on incompatible receiver");
            return a.call(t, e);
          };
        },
        "159b": function b(t, e, n) {
          var r = n("da84"),
              a = n("fdbc"),
              i = n("17c2"),
              o = n("9112");

          for (var s in a) {
            var c = r[s],
                u = c && c.prototype;
            if (u && u.forEach !== i) try {
              o(u, "forEach", i);
            } catch (l) {
              u.forEach = i;
            }
          }
        },
        "17c2": function c2(t, e, n) {

          var r = n("b727").forEach,
              a = n("b301");
          t.exports = a("forEach") ? function (t) {
            return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
          } : [].forEach;
        },
        "18e6": function e6(t, e, n) {},
        "1be4": function be4(t, e, n) {
          var r = n("d066");
          t.exports = r("document", "documentElement");
        },
        "1c0b": function c0b(t, e) {
          t.exports = function (t) {
            if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
            return t;
          };
        },
        "1c7e": function c7e(t, e, n) {
          var r = n("b622"),
              a = r("iterator"),
              i = !1;

          try {
            var o = 0,
                s = {
              next: function next() {
                return {
                  done: !!o++
                };
              },
              return: function _return() {
                i = !0;
              }
            };
            s[a] = function () {
              return this;
            }, Array.from(s, function () {
              throw 2;
            });
          } catch (c) {}

          t.exports = function (t, e) {
            if (!e && !i) return !1;
            var n = !1;

            try {
              var r = {};
              r[a] = function () {
                return {
                  next: function next() {
                    return {
                      done: n = !0
                    };
                  }
                };
              }, t(r);
            } catch (c) {}

            return n;
          };
        },
        "1d80": function d80(t, e) {
          t.exports = function (t) {
            if (void 0 == t) throw TypeError("Can't call method on " + t);
            return t;
          };
        },
        "1dde": function dde(t, e, n) {
          var r = n("d039"),
              a = n("b622"),
              i = n("60ae"),
              o = a("species");

          t.exports = function (t) {
            return i >= 51 || !r(function () {
              var e = [],
                  n = e.constructor = {};
              return n[o] = function () {
                return {
                  foo: 1
                };
              }, 1 !== e[t](Boolean).foo;
            });
          };
        },
        "23cb": function cb(t, e, n) {
          var r = n("a691"),
              a = Math.max,
              i = Math.min;

          t.exports = function (t, e) {
            var n = r(t);
            return n < 0 ? a(n + e, 0) : i(n, e);
          };
        },
        "23e7": function e7(t, e, n) {
          var r = n("da84"),
              a = n("06cf").f,
              i = n("9112"),
              o = n("6eeb"),
              s = n("ce4e"),
              c = n("e893"),
              u = n("94ca");

          t.exports = function (t, e) {
            var n,
                l,
                f,
                d,
                h,
                p,
                m = t.target,
                g = t.global,
                v = t.stat;
            if (l = g ? r : v ? r[m] || s(m, {}) : (r[m] || {}).prototype, l) for (f in e) {
              if (h = e[f], t.noTargetGet ? (p = a(l, f), d = p && p.value) : d = l[f], n = u(g ? f : m + (v ? "." : "#") + f, t.forced), !n && void 0 !== d) {
                if (_typeof(h) === _typeof(d)) continue;
                c(h, d);
              }

              (t.sham || d && d.sham) && i(h, "sham", !0), o(l, f, h, t);
            }
          };
        },
        "241c": function c(t, e, n) {
          var r = n("ca84"),
              a = n("7839"),
              i = a.concat("length", "prototype");

          e.f = Object.getOwnPropertyNames || function (t) {
            return r(t, i);
          };
        },
        "25f0": function f0(t, e, n) {

          var r = n("6eeb"),
              a = n("825a"),
              i = n("d039"),
              o = n("ad6d"),
              s = "toString",
              c = RegExp.prototype,
              u = c[s],
              l = i(function () {
            return "/a/b" != u.call({
              source: "a",
              flags: "b"
            });
          }),
              f = u.name != s;
          (l || f) && r(RegExp.prototype, s, function () {
            var t = a(this),
                e = String(t.source),
                n = t.flags,
                r = String(void 0 === n && t instanceof RegExp && !("flags" in c) ? o.call(t) : n);
            return "/" + e + "/" + r;
          }, {
            unsafe: !0
          });
        },
        "35a1": function a1(t, e, n) {
          var r = n("f5df"),
              a = n("3f8c"),
              i = n("b622"),
              o = i("iterator");

          t.exports = function (t) {
            if (void 0 != t) return t[o] || t["@@iterator"] || a[r(t)];
          };
        },
        "37e8": function e8(t, e, n) {
          var r = n("83ab"),
              a = n("9bf2"),
              i = n("825a"),
              o = n("df75");
          t.exports = r ? Object.defineProperties : function (t, e) {
            i(t);
            var n,
                r = o(e),
                s = r.length,
                c = 0;

            while (s > c) {
              a.f(t, n = r[c++], e[n]);
            }

            return t;
          };
        },
        "3bbe": function bbe(t, e, n) {
          var r = n("861d");

          t.exports = function (t) {
            if (!r(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
            return t;
          };
        },
        "3ca3": function ca3(t, e, n) {

          var r = n("6547").charAt,
              a = n("69f3"),
              i = n("7dd0"),
              o = "String Iterator",
              s = a.set,
              c = a.getterFor(o);
          i(String, "String", function (t) {
            s(this, {
              type: o,
              string: String(t),
              index: 0
            });
          }, function () {
            var t,
                e = c(this),
                n = e.string,
                a = e.index;
            return a >= n.length ? {
              value: void 0,
              done: !0
            } : (t = r(n, a), e.index += t.length, {
              value: t,
              done: !1
            });
          });
        },
        "3f8c": function f8c(t, e) {
          t.exports = {};
        },
        "428f": function f(t, e, n) {
          var r = n("da84");
          t.exports = r;
        },
        "44ad": function ad(t, e, n) {
          var r = n("d039"),
              a = n("c6b6"),
              i = "".split;
          t.exports = r(function () {
            return !Object("z").propertyIsEnumerable(0);
          }) ? function (t) {
            return "String" == a(t) ? i.call(t, "") : Object(t);
          } : Object;
        },
        "44d2": function d2(t, e, n) {
          var r = n("b622"),
              a = n("7c73"),
              i = n("9112"),
              o = r("unscopables"),
              s = Array.prototype;
          void 0 == s[o] && i(s, o, a(null)), t.exports = function (t) {
            s[o][t] = !0;
          };
        },
        "466d": function d(t, e, n) {

          var r = n("d784"),
              a = n("825a"),
              i = n("50c4"),
              o = n("1d80"),
              s = n("8aa5"),
              c = n("14c3");
          r("match", 1, function (t, e, n) {
            return [function (e) {
              var n = o(this),
                  r = void 0 == e ? void 0 : e[t];
              return void 0 !== r ? r.call(e, n) : new RegExp(e)[t](String(n));
            }, function (t) {
              var r = n(e, t, this);
              if (r.done) return r.value;
              var o = a(t),
                  u = String(this);
              if (!o.global) return c(o, u);
              var l = o.unicode;
              o.lastIndex = 0;
              var f,
                  d = [],
                  h = 0;

              while (null !== (f = c(o, u))) {
                var p = String(f[0]);
                d[h] = p, "" === p && (o.lastIndex = s(u, i(o.lastIndex), l)), h++;
              }

              return 0 === h ? null : d;
            }];
          });
        },
        4930: function _(t, e, n) {
          var r = n("d039");
          t.exports = !!Object.getOwnPropertySymbols && !r(function () {
            return !String(Symbol());
          });
        },
        "4d64": function d64(t, e, n) {
          var r = n("fc6a"),
              a = n("50c4"),
              i = n("23cb"),
              o = function o(t) {
            return function (e, n, o) {
              var s,
                  c = r(e),
                  u = a(c.length),
                  l = i(o, u);

              if (t && n != n) {
                while (u > l) {
                  if (s = c[l++], s != s) return !0;
                }
              } else for (; u > l; l++) {
                if ((t || l in c) && c[l] === n) return t || l || 0;
              }

              return !t && -1;
            };
          };

          t.exports = {
            includes: o(!0),
            indexOf: o(!1)
          };
        },
        "4de4": function de4(t, e, n) {

          var r = n("23e7"),
              a = n("b727").filter,
              i = n("d039"),
              o = n("1dde"),
              s = o("filter"),
              c = s && !i(function () {
            [].filter.call({
              length: -1,
              0: 1
            }, function (t) {
              throw t;
            });
          });
          r({
            target: "Array",
            proto: !0,
            forced: !s || !c
          }, {
            filter: function filter(t) {
              return a(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
          });
        },
        "4df4": function df4(t, e, n) {

          var r = n("f8c2"),
              a = n("7b0b"),
              i = n("9bdd"),
              o = n("e95a"),
              s = n("50c4"),
              c = n("8418"),
              u = n("35a1");

          t.exports = function (t) {
            var e,
                n,
                l,
                f,
                d,
                h = a(t),
                p = "function" == typeof this ? this : Array,
                m = arguments.length,
                g = m > 1 ? arguments[1] : void 0,
                v = void 0 !== g,
                y = 0,
                b = u(h);
            if (v && (g = r(g, m > 2 ? arguments[2] : void 0, 2)), void 0 == b || p == Array && o(b)) for (e = s(h.length), n = new p(e); e > y; y++) {
              c(n, y, v ? g(h[y], y) : h[y]);
            } else for (f = b.call(h), d = f.next, n = new p(); !(l = d.call(f)).done; y++) {
              c(n, y, v ? i(f, g, [l.value, y], !0) : l.value);
            }
            return n.length = y, n;
          };
        },
        "50c4": function c4(t, e, n) {
          var r = n("a691"),
              a = Math.min;

          t.exports = function (t) {
            return t > 0 ? a(r(t), 9007199254740991) : 0;
          };
        },
        5135: function _(t, e) {
          var n = {}.hasOwnProperty;

          t.exports = function (t, e) {
            return n.call(t, e);
          };
        },
        5319: function _(t, e, n) {

          var r = n("d784"),
              a = n("825a"),
              i = n("7b0b"),
              o = n("50c4"),
              s = n("a691"),
              c = n("1d80"),
              u = n("8aa5"),
              l = n("14c3"),
              f = Math.max,
              d = Math.min,
              h = Math.floor,
              p = /\$([$&'`]|\d\d?|<[^>]*>)/g,
              m = /\$([$&'`]|\d\d?)/g,
              g = function g(t) {
            return void 0 === t ? t : String(t);
          };

          r("replace", 2, function (t, e, n) {
            return [function (n, r) {
              var a = c(this),
                  i = void 0 == n ? void 0 : n[t];
              return void 0 !== i ? i.call(n, a, r) : e.call(String(a), n, r);
            }, function (t, i) {
              var c = n(e, t, this, i);
              if (c.done) return c.value;
              var h = a(t),
                  p = String(this),
                  m = "function" === typeof i;
              m || (i = String(i));
              var v = h.global;

              if (v) {
                var y = h.unicode;
                h.lastIndex = 0;
              }

              var b = [];

              while (1) {
                var D = l(h, p);
                if (null === D) break;
                if (b.push(D), !v) break;
                var w = String(D[0]);
                "" === w && (h.lastIndex = u(p, o(h.lastIndex), y));
              }

              for (var x = "", S = 0, M = 0; M < b.length; M++) {
                D = b[M];

                for (var k = String(D[0]), _ = f(d(s(D.index), p.length), 0), O = [], T = 1; T < D.length; T++) {
                  O.push(g(D[T]));
                }

                var C = D.groups;

                if (m) {
                  var P = [k].concat(O, _, p);
                  void 0 !== C && P.push(C);
                  var j = String(i.apply(void 0, P));
                } else j = r(k, p, _, O, C, i);

                _ >= S && (x += p.slice(S, _) + j, S = _ + k.length);
              }

              return x + p.slice(S);
            }];

            function r(t, n, r, a, o, s) {
              var c = r + t.length,
                  u = a.length,
                  l = m;
              return void 0 !== o && (o = i(o), l = p), e.call(s, l, function (e, i) {
                var s;

                switch (i.charAt(0)) {
                  case "$":
                    return "$";

                  case "&":
                    return t;

                  case "`":
                    return n.slice(0, r);

                  case "'":
                    return n.slice(c);

                  case "<":
                    s = o[i.slice(1, -1)];
                    break;

                  default:
                    var l = +i;
                    if (0 === l) return e;

                    if (l > u) {
                      var f = h(l / 10);
                      return 0 === f ? e : f <= u ? void 0 === a[f - 1] ? i.charAt(1) : a[f - 1] + i.charAt(1) : e;
                    }

                    s = a[l - 1];
                }

                return void 0 === s ? "" : s;
              });
            }
          });
        },
        "53ca": function ca(t, e, n) {

          n.d(e, "a", function () {
            return a;
          });
          n("a4d3"), n("e01a"), n("d28b"), n("e260"), n("d3b7"), n("3ca3"), n("ddb0");

          function r(t) {
            return r = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (t) {
              return _typeof(t);
            } : function (t) {
              return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
            }, r(t);
          }

          function a(t) {
            return a = "function" === typeof Symbol && "symbol" === r(Symbol.iterator) ? function (t) {
              return r(t);
            } : function (t) {
              return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : r(t);
            }, a(t);
          }
        },
        5692: function _(t, e, n) {
          var r = n("c430"),
              a = n("c6cd");
          (t.exports = function (t, e) {
            return a[t] || (a[t] = void 0 !== e ? e : {});
          })("versions", []).push({
            version: "3.5.0",
            mode: r ? "pure" : "global",
            copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
          });
        },
        "56ef": function ef(t, e, n) {
          var r = n("d066"),
              a = n("241c"),
              i = n("7418"),
              o = n("825a");

          t.exports = r("Reflect", "ownKeys") || function (t) {
            var e = a.f(o(t)),
                n = i.f;
            return n ? e.concat(n(t)) : e;
          };
        },
        5899: function _(t, e) {
          t.exports = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
        },
        "58a8": function a8(t, e, n) {
          var r = n("1d80"),
              a = n("5899"),
              i = "[" + a + "]",
              o = RegExp("^" + i + i + "*"),
              s = RegExp(i + i + "*$"),
              c = function c(t) {
            return function (e) {
              var n = String(r(e));
              return 1 & t && (n = n.replace(o, "")), 2 & t && (n = n.replace(s, "")), n;
            };
          };

          t.exports = {
            start: c(1),
            end: c(2),
            trim: c(3)
          };
        },
        "5c6c": function c6c(t, e) {
          t.exports = function (t, e) {
            return {
              enumerable: !(1 & t),
              configurable: !(2 & t),
              writable: !(4 & t),
              value: e
            };
          };
        },
        "60ae": function ae(t, e, n) {
          var r,
              a,
              i = n("da84"),
              o = n("b39a"),
              s = i.process,
              c = s && s.versions,
              u = c && c.v8;
          u ? (r = u.split("."), a = r[0] + r[1]) : o && (r = o.match(/Edge\/(\d+)/), (!r || r[1] >= 74) && (r = o.match(/Chrome\/(\d+)/), r && (a = r[1]))), t.exports = a && +a;
        },
        6547: function _(t, e, n) {
          var r = n("a691"),
              a = n("1d80"),
              i = function i(t) {
            return function (e, n) {
              var i,
                  o,
                  s = String(a(e)),
                  c = r(n),
                  u = s.length;
              return c < 0 || c >= u ? t ? "" : void 0 : (i = s.charCodeAt(c), i < 55296 || i > 56319 || c + 1 === u || (o = s.charCodeAt(c + 1)) < 56320 || o > 57343 ? t ? s.charAt(c) : i : t ? s.slice(c, c + 2) : o - 56320 + (i - 55296 << 10) + 65536);
            };
          };

          t.exports = {
            codeAt: i(!1),
            charAt: i(!0)
          };
        },
        "65f0": function f0(t, e, n) {
          var r = n("861d"),
              a = n("e8b5"),
              i = n("b622"),
              o = i("species");

          t.exports = function (t, e) {
            var n;
            return a(t) && (n = t.constructor, "function" != typeof n || n !== Array && !a(n.prototype) ? r(n) && (n = n[o], null === n && (n = void 0)) : n = void 0), new (void 0 === n ? Array : n)(0 === e ? 0 : e);
          };
        },
        "69f3": function f3(t, e, n) {
          var r,
              a,
              i,
              o = n("7f9a"),
              s = n("da84"),
              c = n("861d"),
              u = n("9112"),
              l = n("5135"),
              f = n("f772"),
              d = n("d012"),
              h = s.WeakMap,
              p = function p(t) {
            return i(t) ? a(t) : r(t, {});
          },
              m = function m(t) {
            return function (e) {
              var n;
              if (!c(e) || (n = a(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
              return n;
            };
          };

          if (o) {
            var g = new h(),
                v = g.get,
                y = g.has,
                b = g.set;
            r = function r(t, e) {
              return b.call(g, t, e), e;
            }, a = function a(t) {
              return v.call(g, t) || {};
            }, i = function i(t) {
              return y.call(g, t);
            };
          } else {
            var D = f("state");
            d[D] = !0, r = function r(t, e) {
              return u(t, D, e), e;
            }, a = function a(t) {
              return l(t, D) ? t[D] : {};
            }, i = function i(t) {
              return l(t, D);
            };
          }

          t.exports = {
            set: r,
            get: a,
            has: i,
            enforce: p,
            getterFor: m
          };
        },
        "6eeb": function eeb(t, e, n) {
          var r = n("da84"),
              a = n("9112"),
              i = n("5135"),
              o = n("ce4e"),
              s = n("8925"),
              c = n("69f3"),
              u = c.get,
              l = c.enforce,
              f = String(String).split("String");
          (t.exports = function (t, e, n, s) {
            var c = !!s && !!s.unsafe,
                u = !!s && !!s.enumerable,
                d = !!s && !!s.noTargetGet;
            "function" == typeof n && ("string" != typeof e || i(n, "name") || a(n, "name", e), l(n).source = f.join("string" == typeof e ? e : "")), t !== r ? (c ? !d && t[e] && (u = !0) : delete t[e], u ? t[e] = n : a(t, e, n)) : u ? t[e] = n : o(e, n);
          })(Function.prototype, "toString", function () {
            return "function" == typeof this && u(this).source || s(this);
          });
        },
        7156: function _(t, e, n) {
          var r = n("861d"),
              a = n("d2bb");

          t.exports = function (t, e, n) {
            var i, o;
            return a && "function" == typeof (i = e.constructor) && i !== n && r(o = i.prototype) && o !== n.prototype && a(t, o), t;
          };
        },
        7418: function _(t, e) {
          e.f = Object.getOwnPropertySymbols;
        },
        "746f": function f(t, e, n) {
          var r = n("428f"),
              a = n("5135"),
              i = n("c032"),
              o = n("9bf2").f;

          t.exports = function (t) {
            var e = r.Symbol || (r.Symbol = {});
            a(e, t) || o(e, t, {
              value: i.f(t)
            });
          };
        },
        7839: function _(t, e) {
          t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        },
        "7a50": function a50(t, e, n) {

          n.r(e);
          n("a4d3"), n("4de4"), n("d81d"), n("fb6a"), n("e439"), n("dbb4"), n("b64b"), n("159b");

          var r = n("ade3"),
              a = (n("d3b7"), n("466d"), n("5319"), n("53ca")),
              i = function () {
            var t = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|"[^"]*"|'[^']*'/g,
                e = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
                n = /[^-+\dA-Z]/g;
            return function (r, a, l, f) {
              if (1 !== arguments.length || "string" !== u(r) || /\d/.test(r) || (a = r, r = void 0), r = r || new Date(), r instanceof Date || (r = new Date(r)), isNaN(r)) throw TypeError("Invalid date");
              a = String(i.masks[a] || a || i.masks["default"]);
              var d = a.slice(0, 4);
              "UTC:" !== d && "GMT:" !== d || (a = a.slice(4), l = !0, "GMT:" === d && (f = !0));
              var h = l ? "getUTC" : "get",
                  p = r[h + "Date"](),
                  m = r[h + "Day"](),
                  g = r[h + "Month"](),
                  v = r[h + "FullYear"](),
                  y = r[h + "Hours"](),
                  b = r[h + "Minutes"](),
                  D = r[h + "Seconds"](),
                  w = r[h + "Milliseconds"](),
                  x = l ? 0 : r.getTimezoneOffset(),
                  S = s(r),
                  M = c(r),
                  k = {
                d: p,
                dd: o(p),
                ddd: i.i18n.dayNames[m],
                dddd: i.i18n.dayNames[m + 7],
                m: g + 1,
                mm: o(g + 1),
                mmm: i.i18n.monthNames[g],
                mmmm: i.i18n.monthNames[g + 12],
                yy: String(v).slice(2),
                yyyy: v,
                h: y % 12 || 12,
                hh: o(y % 12 || 12),
                H: y,
                HH: o(y),
                M: b,
                MM: o(b),
                s: D,
                ss: o(D),
                l: o(w, 3),
                L: o(Math.round(w / 10)),
                t: y < 12 ? i.i18n.timeNames[0] : i.i18n.timeNames[1],
                tt: y < 12 ? i.i18n.timeNames[2] : i.i18n.timeNames[3],
                T: y < 12 ? i.i18n.timeNames[4] : i.i18n.timeNames[5],
                TT: y < 12 ? i.i18n.timeNames[6] : i.i18n.timeNames[7],
                Z: f ? "GMT" : l ? "UTC" : (String(r).match(e) || [""]).pop().replace(n, ""),
                o: (x > 0 ? "-" : "+") + o(100 * Math.floor(Math.abs(x) / 60) + Math.abs(x) % 60, 4),
                S: ["th", "st", "nd", "rd"][p % 10 > 3 ? 0 : (p % 100 - p % 10 != 10) * p % 10],
                W: S,
                N: M
              };
              return a.replace(t, function (t) {
                return t in k ? k[t] : t.slice(1, t.length - 1);
              });
            };
          }();

          function o(t, e) {
            t = String(t), e = e || 2;

            while (t.length < e) {
              t = "0" + t;
            }

            return t;
          }

          function s(t) {
            var e = new Date(t.getFullYear(), t.getMonth(), t.getDate());
            e.setDate(e.getDate() - (e.getDay() + 6) % 7 + 3);
            var n = new Date(e.getFullYear(), 0, 4);
            n.setDate(n.getDate() - (n.getDay() + 6) % 7 + 3);
            var r = e.getTimezoneOffset() - n.getTimezoneOffset();
            e.setHours(e.getHours() - r);
            var a = (e - n) / 6048e5;
            return 1 + Math.floor(a);
          }

          function c(t) {
            var e = t.getDay();
            return 0 === e && (e = 7), e;
          }

          function u(t) {
            return null === t ? "null" : void 0 === t ? "undefined" : "object" !== Object(a["a"])(t) ? Object(a["a"])(t) : Array.isArray(t) ? "array" : {}.toString.call(t).slice(8, -1).toLowerCase();
          }

          function l(t, e) {
            var n = Object.keys(t);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(t);
              e && (r = r.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function f(t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? l(Object(n), !0).forEach(function (e) {
                Object(r["a"])(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }

            return t;
          }

          i.masks = {
            default: "ddd mmm dd yyyy HH:MM:ss",
            shortDate: "m/d/yy",
            mediumDate: "mmm d, yyyy",
            longDate: "mmmm d, yyyy",
            fullDate: "dddd, mmmm d, yyyy",
            shortTime: "h:MM TT",
            mediumTime: "h:MM:ss TT",
            longTime: "h:MM:ss TT Z",
            isoDate: "yyyy-mm-dd",
            isoTime: "HH:MM:ss",
            isoDateTime: "yyyy-mm-dd'T'HH:MM:sso",
            isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
            expiresHeaderFormat: "ddd, dd mmm yyyy HH:MM:ss Z"
          }, i.i18n = {
            dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            timeNames: ["a", "p", "am", "pm", "A", "P", "AM", "PM"]
          };
          var d = {
            isSame: function isSame(t, e, n) {
              var r = new Date(t),
                  a = new Date(e);
              return "date" === n && (r.setHours(0, 0, 0, 0), a.setHours(0, 0, 0, 0)), r.getTime() === a.getTime();
            },
            daysInMonth: function daysInMonth(t, e) {
              return new Date(t, e, 0).getDate();
            },
            weekNumber: function weekNumber(t) {
              return s(t);
            },
            format: function format(t, e) {
              return i(t, e);
            },
            nextMonth: function nextMonth(t) {
              var e = new Date(t.getTime());
              return e.setDate(1), e.setMonth(e.getMonth() + 1), e;
            },
            prevMonth: function prevMonth(t) {
              var e = new Date(t.getTime());
              return e.setDate(1), e.setMonth(e.getMonth() - 1), e;
            },
            validateDateRange: function validateDateRange(t, e, n) {
              var r = new Date(n),
                  a = new Date(e);
              return n && t.getTime() > r.getTime() ? r : e && t.getTime() < a.getTime() ? a : t;
            },
            localeData: function localeData(t) {
              var e = {
                direction: "ltr",
                format: "mm/dd/yyyy",
                separator: " - ",
                applyLabel: "Apply",
                cancelLabel: "Cancel",
                weekLabel: "W",
                customRangeLabel: "Custom Range",
                daysOfWeek: i.i18n.dayNames.slice(0, 7).map(function (t) {
                  return t.substring(0, 2);
                }),
                monthNames: i.i18n.monthNames.slice(0, 12),
                firstDay: 0
              };
              return f({}, e, {}, t);
            },
            yearMonth: function yearMonth(t) {
              var e = t.getMonth() + 1;
              return t.getFullYear() + (e < 10 ? "0" : "") + e;
            },
            isValidDate: function isValidDate(t) {
              return t instanceof Date && !isNaN(t);
            }
          };
          e["default"] = d;
        },
        "7b0b": function b0b(t, e, n) {
          var r = n("1d80");

          t.exports = function (t) {
            return Object(r(t));
          };
        },
        "7c73": function c73(t, e, n) {
          var r = n("825a"),
              a = n("37e8"),
              i = n("7839"),
              o = n("d012"),
              s = n("1be4"),
              c = n("cc12"),
              u = n("f772"),
              l = u("IE_PROTO"),
              f = "prototype",
              d = function d() {},
              _h = function h() {
            var t,
                e = c("iframe"),
                n = i.length,
                r = "<",
                a = "script",
                o = ">",
                u = "java" + a + ":";
            e.style.display = "none", s.appendChild(e), e.src = String(u), t = e.contentWindow.document, t.open(), t.write(r + a + o + "document.F=Object" + r + "/" + a + o), t.close(), _h = t.F;

            while (n--) {
              delete _h[f][i[n]];
            }

            return _h();
          };

          t.exports = Object.create || function (t, e) {
            var n;
            return null !== t ? (d[f] = r(t), n = new d(), d[f] = null, n[l] = t) : n = _h(), void 0 === e ? n : a(n, e);
          }, o[l] = !0;
        },
        "7db0": function db0(t, e, n) {

          var r = n("23e7"),
              a = n("b727").find,
              i = n("44d2"),
              o = "find",
              s = !0;
          o in [] && Array(1)[o](function () {
            s = !1;
          }), r({
            target: "Array",
            proto: !0,
            forced: s
          }, {
            find: function find(t) {
              return a(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
          }), i(o);
        },
        "7dd0": function dd0(t, e, n) {

          var r = n("23e7"),
              a = n("9ed3"),
              i = n("e163"),
              o = n("d2bb"),
              s = n("d44e"),
              c = n("9112"),
              u = n("6eeb"),
              l = n("b622"),
              f = n("c430"),
              d = n("3f8c"),
              h = n("ae93"),
              p = h.IteratorPrototype,
              m = h.BUGGY_SAFARI_ITERATORS,
              g = l("iterator"),
              v = "keys",
              y = "values",
              b = "entries",
              D = function D() {
            return this;
          };

          t.exports = function (t, e, n, l, h, w, x) {
            a(n, e, l);

            var S,
                M,
                k,
                _ = function _(t) {
              if (t === h && j) return j;
              if (!m && t in C) return C[t];

              switch (t) {
                case v:
                  return function () {
                    return new n(this, t);
                  };

                case y:
                  return function () {
                    return new n(this, t);
                  };

                case b:
                  return function () {
                    return new n(this, t);
                  };
              }

              return function () {
                return new n(this);
              };
            },
                O = e + " Iterator",
                T = !1,
                C = t.prototype,
                P = C[g] || C["@@iterator"] || h && C[h],
                j = !m && P || _(h),
                A = "Array" == e && C.entries || P;

            if (A && (S = i(A.call(new t())), p !== Object.prototype && S.next && (f || i(S) === p || (o ? o(S, p) : "function" != typeof S[g] && c(S, g, D)), s(S, O, !0, !0), f && (d[O] = D))), h == y && P && P.name !== y && (T = !0, j = function j() {
              return P.call(this);
            }), f && !x || C[g] === j || c(C, g, j), d[e] = j, h) if (M = {
              values: _(y),
              keys: w ? j : _(v),
              entries: _(b)
            }, x) for (k in M) {
              !m && !T && k in C || u(C, k, M[k]);
            } else r({
              target: e,
              proto: !0,
              forced: m || T
            }, M);
            return M;
          };
        },
        "7f9a": function f9a(t, e, n) {
          var r = n("da84"),
              a = n("8925"),
              i = r.WeakMap;
          t.exports = "function" === typeof i && /native code/.test(a(i));
        },
        "825a": function a(t, e, n) {
          var r = n("861d");

          t.exports = function (t) {
            if (!r(t)) throw TypeError(String(t) + " is not an object");
            return t;
          };
        },
        "83ab": function ab(t, e, n) {
          var r = n("d039");
          t.exports = !r(function () {
            return 7 != Object.defineProperty({}, "a", {
              get: function get() {
                return 7;
              }
            }).a;
          });
        },
        8418: function _(t, e, n) {

          var r = n("c04e"),
              a = n("9bf2"),
              i = n("5c6c");

          t.exports = function (t, e, n) {
            var o = r(e);
            o in t ? a.f(t, o, i(0, n)) : t[o] = n;
          };
        },
        "861d": function d(t, e) {
          t.exports = function (t) {
            return "object" === _typeof(t) ? null !== t : "function" === typeof t;
          };
        },
        8925: function _(t, e, n) {
          var r = n("c6cd"),
              a = Function.toString;
          "function" != typeof r.inspectSource && (r.inspectSource = function (t) {
            return a.call(t);
          }), t.exports = r.inspectSource;
        },
        "8aa5": function aa5(t, e, n) {

          var r = n("6547").charAt;

          t.exports = function (t, e, n) {
            return e + (n ? r(t, e).length : 1);
          };
        },
        "8b2e": function b2e(t, e, n) {},
        "90e3": function e3(t, e) {
          var n = 0,
              r = Math.random();

          t.exports = function (t) {
            return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++n + r).toString(36);
          };
        },
        9112: function _(t, e, n) {
          var r = n("83ab"),
              a = n("9bf2"),
              i = n("5c6c");
          t.exports = r ? function (t, e, n) {
            return a.f(t, e, i(1, n));
          } : function (t, e, n) {
            return t[e] = n, t;
          };
        },
        9263: function _(t, e, n) {

          var r = n("ad6d"),
              a = RegExp.prototype.exec,
              i = String.prototype.replace,
              o = a,
              s = function () {
            var t = /a/,
                e = /b*/g;
            return a.call(t, "a"), a.call(e, "a"), 0 !== t.lastIndex || 0 !== e.lastIndex;
          }(),
              c = void 0 !== /()??/.exec("")[1],
              u = s || c;

          u && (o = function o(t) {
            var e,
                n,
                o,
                u,
                l = this;
            return c && (n = new RegExp("^" + l.source + "$(?!\\s)", r.call(l))), s && (e = l.lastIndex), o = a.call(l, t), s && o && (l.lastIndex = l.global ? o.index + o[0].length : e), c && o && o.length > 1 && i.call(o[0], n, function () {
              for (u = 1; u < arguments.length - 2; u++) {
                void 0 === arguments[u] && (o[u] = void 0);
              }
            }), o;
          }), t.exports = o;
        },
        "94ca": function ca(t, e, n) {
          var r = n("d039"),
              a = /#|\.prototype\./,
              i = function i(t, e) {
            var n = s[o(t)];
            return n == u || n != c && ("function" == typeof e ? r(e) : !!e);
          },
              o = i.normalize = function (t) {
            return String(t).replace(a, ".").toLowerCase();
          },
              s = i.data = {},
              c = i.NATIVE = "N",
              u = i.POLYFILL = "P";

          t.exports = i;
        },
        "9bdd": function bdd(t, e, n) {
          var r = n("825a");

          t.exports = function (t, e, n, a) {
            try {
              return a ? e(r(n)[0], n[1]) : e(n);
            } catch (o) {
              var i = t["return"];
              throw void 0 !== i && r(i.call(t)), o;
            }
          };
        },
        "9bf2": function bf2(t, e, n) {
          var r = n("83ab"),
              a = n("0cfb"),
              i = n("825a"),
              o = n("c04e"),
              s = Object.defineProperty;
          e.f = r ? s : function (t, e, n) {
            if (i(t), e = o(e, !0), i(n), a) try {
              return s(t, e, n);
            } catch (r) {}
            if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
            return "value" in n && (t[e] = n.value), t;
          };
        },
        "9d0d": function d0d(t, e, n) {

          var r = n("8b2e"),
              a = n.n(r);
          a.a;
        },
        "9ed3": function ed3(t, e, n) {

          var r = n("ae93").IteratorPrototype,
              a = n("7c73"),
              i = n("5c6c"),
              o = n("d44e"),
              s = n("3f8c"),
              c = function c() {
            return this;
          };

          t.exports = function (t, e, n) {
            var u = e + " Iterator";
            return t.prototype = a(r, {
              next: i(1, n)
            }), o(t, u, !1, !0), s[u] = c, t;
          };
        },
        a4d3: function a4d3(t, e, n) {

          var r = n("23e7"),
              a = n("da84"),
              i = n("d066"),
              o = n("c430"),
              s = n("83ab"),
              c = n("4930"),
              u = n("fdbf"),
              l = n("d039"),
              f = n("5135"),
              d = n("e8b5"),
              h = n("861d"),
              p = n("825a"),
              m = n("7b0b"),
              g = n("fc6a"),
              v = n("c04e"),
              y = n("5c6c"),
              b = n("7c73"),
              D = n("df75"),
              w = n("241c"),
              x = n("057f"),
              S = n("7418"),
              M = n("06cf"),
              k = n("9bf2"),
              _ = n("d1e7"),
              O = n("9112"),
              T = n("6eeb"),
              C = n("5692"),
              P = n("f772"),
              j = n("d012"),
              A = n("90e3"),
              N = n("b622"),
              R = n("c032"),
              $ = n("746f"),
              E = n("d44e"),
              U = n("69f3"),
              F = n("b727").forEach,
              I = P("hidden"),
              L = "Symbol",
              H = "prototype",
              B = N("toPrimitive"),
              Y = U.set,
              W = U.getterFor(L),
              V = Object[H],
              _G = a.Symbol,
              z = i("JSON", "stringify"),
              J = M.f,
              Z = k.f,
              X = x.f,
              q = _.f,
              K = C("symbols"),
              Q = C("op-symbols"),
              tt = C("string-to-symbol-registry"),
              et = C("symbol-to-string-registry"),
              nt = C("wks"),
              rt = a.QObject,
              at = !rt || !rt[H] || !rt[H].findChild,
              it = s && l(function () {
            return 7 != b(Z({}, "a", {
              get: function get() {
                return Z(this, "a", {
                  value: 7
                }).a;
              }
            })).a;
          }) ? function (t, e, n) {
            var r = J(V, e);
            r && delete V[e], Z(t, e, n), r && t !== V && Z(V, e, r);
          } : Z,
              ot = function ot(t, e) {
            var n = K[t] = b(_G[H]);
            return Y(n, {
              type: L,
              tag: t,
              description: e
            }), s || (n.description = e), n;
          },
              st = c && "symbol" == _typeof(_G.iterator) ? function (t) {
            return "symbol" == _typeof(t);
          } : function (t) {
            return Object(t) instanceof _G;
          },
              ct = function ct(t, e, n) {
            t === V && ct(Q, e, n), p(t);
            var r = v(e, !0);
            return p(n), f(K, r) ? (n.enumerable ? (f(t, I) && t[I][r] && (t[I][r] = !1), n = b(n, {
              enumerable: y(0, !1)
            })) : (f(t, I) || Z(t, I, y(1, {})), t[I][r] = !0), it(t, r, n)) : Z(t, r, n);
          },
              ut = function ut(t, e) {
            p(t);
            var n = g(e),
                r = D(n).concat(pt(n));
            return F(r, function (e) {
              s && !ft.call(n, e) || ct(t, e, n[e]);
            }), t;
          },
              lt = function lt(t, e) {
            return void 0 === e ? b(t) : ut(b(t), e);
          },
              ft = function ft(t) {
            var e = v(t, !0),
                n = q.call(this, e);
            return !(this === V && f(K, e) && !f(Q, e)) && (!(n || !f(this, e) || !f(K, e) || f(this, I) && this[I][e]) || n);
          },
              dt = function dt(t, e) {
            var n = g(t),
                r = v(e, !0);

            if (n !== V || !f(K, r) || f(Q, r)) {
              var a = J(n, r);
              return !a || !f(K, r) || f(n, I) && n[I][r] || (a.enumerable = !0), a;
            }
          },
              ht = function ht(t) {
            var e = X(g(t)),
                n = [];
            return F(e, function (t) {
              f(K, t) || f(j, t) || n.push(t);
            }), n;
          },
              pt = function pt(t) {
            var e = t === V,
                n = X(e ? Q : g(t)),
                r = [];
            return F(n, function (t) {
              !f(K, t) || e && !f(V, t) || r.push(K[t]);
            }), r;
          };

          if (c || (_G = function G() {
            if (this instanceof _G) throw TypeError("Symbol is not a constructor");

            var t = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
                e = A(t),
                n = function n(t) {
              this === V && n.call(Q, t), f(this, I) && f(this[I], e) && (this[I][e] = !1), it(this, e, y(1, t));
            };

            return s && at && it(V, e, {
              configurable: !0,
              set: n
            }), ot(e, t);
          }, T(_G[H], "toString", function () {
            return W(this).tag;
          }), _.f = ft, k.f = ct, M.f = dt, w.f = x.f = ht, S.f = pt, s && (Z(_G[H], "description", {
            configurable: !0,
            get: function get() {
              return W(this).description;
            }
          }), o || T(V, "propertyIsEnumerable", ft, {
            unsafe: !0
          }))), u || (R.f = function (t) {
            return ot(N(t), t);
          }), r({
            global: !0,
            wrap: !0,
            forced: !c,
            sham: !c
          }, {
            Symbol: _G
          }), F(D(nt), function (t) {
            $(t);
          }), r({
            target: L,
            stat: !0,
            forced: !c
          }, {
            for: function _for(t) {
              var e = String(t);
              if (f(tt, e)) return tt[e];

              var n = _G(e);

              return tt[e] = n, et[n] = e, n;
            },
            keyFor: function keyFor(t) {
              if (!st(t)) throw TypeError(t + " is not a symbol");
              if (f(et, t)) return et[t];
            },
            useSetter: function useSetter() {
              at = !0;
            },
            useSimple: function useSimple() {
              at = !1;
            }
          }), r({
            target: "Object",
            stat: !0,
            forced: !c,
            sham: !s
          }, {
            create: lt,
            defineProperty: ct,
            defineProperties: ut,
            getOwnPropertyDescriptor: dt
          }), r({
            target: "Object",
            stat: !0,
            forced: !c
          }, {
            getOwnPropertyNames: ht,
            getOwnPropertySymbols: pt
          }), r({
            target: "Object",
            stat: !0,
            forced: l(function () {
              S.f(1);
            })
          }, {
            getOwnPropertySymbols: function getOwnPropertySymbols(t) {
              return S.f(m(t));
            }
          }), z) {
            var mt = !c || l(function () {
              var t = _G();

              return "[null]" != z([t]) || "{}" != z({
                a: t
              }) || "{}" != z(Object(t));
            });
            r({
              target: "JSON",
              stat: !0,
              forced: mt
            }, {
              stringify: function stringify(t, e, n) {
                var r,
                    a = [t],
                    i = 1;

                while (arguments.length > i) {
                  a.push(arguments[i++]);
                }

                if (r = e, (h(e) || void 0 !== t) && !st(t)) return d(e) || (e = function e(t, _e) {
                  if ("function" == typeof r && (_e = r.call(this, t, _e)), !st(_e)) return _e;
                }), a[1] = e, z.apply(null, a);
              }
            });
          }

          _G[H][B] || O(_G[H], B, _G[H].valueOf), E(_G, L), j[I] = !0;
        },
        a630: function a630(t, e, n) {
          var r = n("23e7"),
              a = n("4df4"),
              i = n("1c7e"),
              o = !i(function (t) {
          });
          r({
            target: "Array",
            stat: !0,
            forced: o
          }, {
            from: a
          });
        },
        a691: function a691(t, e) {
          var n = Math.ceil,
              r = Math.floor;

          t.exports = function (t) {
            return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
          };
        },
        a6da: function a6da(t, e, n) {
          var r = {
            "./native": "7a50",
            "./native.js": "7a50"
          };

          function a(t) {
            var e = i(t);
            return n(e);
          }

          function i(t) {
            if (!n.o(r, t)) {
              var e = new Error("Cannot find module '" + t + "'");
              throw e.code = "MODULE_NOT_FOUND", e;
            }

            return r[t];
          }

          a.keys = function () {
            return Object.keys(r);
          }, a.resolve = i, t.exports = a, a.id = "a6da";
        },
        a9e3: function a9e3(t, e, n) {

          var r = n("83ab"),
              a = n("da84"),
              i = n("94ca"),
              o = n("6eeb"),
              s = n("5135"),
              c = n("c6b6"),
              u = n("7156"),
              l = n("c04e"),
              f = n("d039"),
              d = n("7c73"),
              h = n("241c").f,
              p = n("06cf").f,
              m = n("9bf2").f,
              g = n("58a8").trim,
              v = "Number",
              y = a[v],
              b = y.prototype,
              D = c(d(b)) == v,
              w = function w(t) {
            var e,
                n,
                r,
                a,
                i,
                o,
                s,
                c,
                u = l(t, !1);
            if ("string" == typeof u && u.length > 2) if (u = g(u), e = u.charCodeAt(0), 43 === e || 45 === e) {
              if (n = u.charCodeAt(2), 88 === n || 120 === n) return NaN;
            } else if (48 === e) {
              switch (u.charCodeAt(1)) {
                case 66:
                case 98:
                  r = 2, a = 49;
                  break;

                case 79:
                case 111:
                  r = 8, a = 55;
                  break;

                default:
                  return +u;
              }

              for (i = u.slice(2), o = i.length, s = 0; s < o; s++) {
                if (c = i.charCodeAt(s), c < 48 || c > a) return NaN;
              }

              return parseInt(i, r);
            }
            return +u;
          };

          if (i(v, !y(" 0o1") || !y("0b1") || y("+0x1"))) {
            for (var x, S = function S(t) {
              var e = arguments.length < 1 ? 0 : t,
                  n = this;
              return n instanceof S && (D ? f(function () {
                b.valueOf.call(n);
              }) : c(n) != v) ? u(new y(w(e)), n, S) : w(e);
            }, M = r ? h(y) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), k = 0; M.length > k; k++) {
              s(y, x = M[k]) && !s(S, x) && m(S, x, p(y, x));
            }

            S.prototype = b, b.constructor = S, o(a, v, S);
          }
        },
        ad6d: function ad6d(t, e, n) {

          var r = n("825a");

          t.exports = function () {
            var t = r(this),
                e = "";
            return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
          };
        },
        ade3: function ade3(t, e, n) {

          function r(t, e, n) {
            return e in t ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = n, t;
          }

          n.d(e, "a", function () {
            return r;
          });
        },
        ae93: function ae93(t, e, n) {

          var r,
              a,
              i,
              o = n("e163"),
              s = n("9112"),
              c = n("5135"),
              u = n("b622"),
              l = n("c430"),
              f = u("iterator"),
              d = !1,
              h = function h() {
            return this;
          };

          [].keys && (i = [].keys(), "next" in i ? (a = o(o(i)), a !== Object.prototype && (r = a)) : d = !0), void 0 == r && (r = {}), l || c(r, f) || s(r, f, h), t.exports = {
            IteratorPrototype: r,
            BUGGY_SAFARI_ITERATORS: d
          };
        },
        b041: function b041(t, e, n) {

          var r = n("00ee"),
              a = n("f5df");
          t.exports = r ? {}.toString : function () {
            return "[object " + a(this) + "]";
          };
        },
        b301: function b301(t, e, n) {

          var r = n("d039");

          t.exports = function (t, e) {
            var n = [][t];
            return !n || !r(function () {
              n.call(null, e || function () {
                throw 1;
              }, 1);
            });
          };
        },
        b39a: function b39a(t, e, n) {
          var r = n("d066");
          t.exports = r("navigator", "userAgent") || "";
        },
        b622: function b622(t, e, n) {
          var r = n("da84"),
              a = n("5692"),
              i = n("5135"),
              o = n("90e3"),
              s = n("4930"),
              c = n("fdbf"),
              u = a("wks"),
              l = r.Symbol,
              f = c ? l : o;

          t.exports = function (t) {
            return i(u, t) || (s && i(l, t) ? u[t] = l[t] : u[t] = f("Symbol." + t)), u[t];
          };
        },
        b64b: function b64b(t, e, n) {
          var r = n("23e7"),
              a = n("7b0b"),
              i = n("df75"),
              o = n("d039"),
              s = o(function () {
            i(1);
          });
          r({
            target: "Object",
            stat: !0,
            forced: s
          }, {
            keys: function keys(t) {
              return i(a(t));
            }
          });
        },
        b727: function b727(t, e, n) {
          var r = n("f8c2"),
              a = n("44ad"),
              i = n("7b0b"),
              o = n("50c4"),
              s = n("65f0"),
              c = [].push,
              u = function u(t) {
            var e = 1 == t,
                n = 2 == t,
                u = 3 == t,
                l = 4 == t,
                f = 6 == t,
                d = 5 == t || f;
            return function (h, p, m, g) {
              for (var v, y, b = i(h), D = a(b), w = r(p, m, 3), x = o(D.length), S = 0, M = g || s, k = e ? M(h, x) : n ? M(h, 0) : void 0; x > S; S++) {
                if ((d || S in D) && (v = D[S], y = w(v, S, b), t)) if (e) k[S] = y;else if (y) switch (t) {
                  case 3:
                    return !0;

                  case 5:
                    return v;

                  case 6:
                    return S;

                  case 2:
                    c.call(k, v);
                } else if (l) return !1;
              }

              return f ? -1 : u || l ? l : k;
            };
          };

          t.exports = {
            forEach: u(0),
            map: u(1),
            filter: u(2),
            some: u(3),
            every: u(4),
            find: u(5),
            findIndex: u(6)
          };
        },
        beb7: function beb7(t, e, n) {},
        c032: function c032(t, e, n) {
          var r = n("b622");
          e.f = r;
        },
        c04e: function c04e(t, e, n) {
          var r = n("861d");

          t.exports = function (t, e) {
            if (!r(t)) return t;
            var n, a;
            if (e && "function" == typeof (n = t.toString) && !r(a = n.call(t))) return a;
            if ("function" == typeof (n = t.valueOf) && !r(a = n.call(t))) return a;
            if (!e && "function" == typeof (n = t.toString) && !r(a = n.call(t))) return a;
            throw TypeError("Can't convert object to primitive value");
          };
        },
        c430: function c430(t, e) {
          t.exports = !1;
        },
        c6b6: function c6b6(t, e) {
          var n = {}.toString;

          t.exports = function (t) {
            return n.call(t).slice(8, -1);
          };
        },
        c6cd: function c6cd(t, e, n) {
          var r = n("da84"),
              a = n("ce4e"),
              i = "__core-js_shared__",
              o = r[i] || a(i, {});
          t.exports = o;
        },
        c8ba: function c8ba(t, e) {
          var n;

          n = function () {
            return this;
          }();

          try {
            n = n || new Function("return this")();
          } catch (r) {
            "object" === (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
          }

          t.exports = n;
        },
        ca84: function ca84(t, e, n) {
          var r = n("5135"),
              a = n("fc6a"),
              i = n("4d64").indexOf,
              o = n("d012");

          t.exports = function (t, e) {
            var n,
                s = a(t),
                c = 0,
                u = [];

            for (n in s) {
              !r(o, n) && r(s, n) && u.push(n);
            }

            while (e.length > c) {
              r(s, n = e[c++]) && (~i(u, n) || u.push(n));
            }

            return u;
          };
        },
        cc12: function cc12(t, e, n) {
          var r = n("da84"),
              a = n("861d"),
              i = r.document,
              o = a(i) && a(i.createElement);

          t.exports = function (t) {
            return o ? i.createElement(t) : {};
          };
        },
        ce4e: function ce4e(t, e, n) {
          var r = n("da84"),
              a = n("9112");

          t.exports = function (t, e) {
            try {
              a(r, t, e);
            } catch (n) {
              r[t] = e;
            }

            return e;
          };
        },
        ce5f: function ce5f(t, e, n) {

          var r = n("18e6"),
              a = n.n(r);
          a.a;
        },
        d012: function d012(t, e) {
          t.exports = {};
        },
        d039: function d039(t, e) {
          t.exports = function (t) {
            try {
              return !!t();
            } catch (e) {
              return !0;
            }
          };
        },
        d066: function d066(t, e, n) {
          var r = n("428f"),
              a = n("da84"),
              i = function i(t) {
            return "function" == typeof t ? t : void 0;
          };

          t.exports = function (t, e) {
            return arguments.length < 2 ? i(r[t]) || i(a[t]) : r[t] && r[t][e] || a[t] && a[t][e];
          };
        },
        d1e7: function d1e7(t, e, n) {

          var r = {}.propertyIsEnumerable,
              a = Object.getOwnPropertyDescriptor,
              i = a && !r.call({
            1: 2
          }, 1);
          e.f = i ? function (t) {
            var e = a(this, t);
            return !!e && e.enumerable;
          } : r;
        },
        d28b: function d28b(t, e, n) {
          var r = n("746f");
          r("iterator");
        },
        d2bb: function d2bb(t, e, n) {
          var r = n("825a"),
              a = n("3bbe");
          t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
            var t,
                e = !1,
                n = {};

            try {
              t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, t.call(n, []), e = n instanceof Array;
            } catch (i) {}

            return function (n, i) {
              return r(n), a(i), e ? t.call(n, i) : n.__proto__ = i, n;
            };
          }() : void 0);
        },
        d3b7: function d3b7(t, e, n) {
          var r = n("00ee"),
              a = n("6eeb"),
              i = n("b041");
          r || a(Object.prototype, "toString", i, {
            unsafe: !0
          });
        },
        d44e: function d44e(t, e, n) {
          var r = n("9bf2").f,
              a = n("5135"),
              i = n("b622"),
              o = i("toStringTag");

          t.exports = function (t, e, n) {
            t && !a(t = n ? t : t.prototype, o) && r(t, o, {
              configurable: !0,
              value: e
            });
          };
        },
        d784: function d784(t, e, n) {

          var r = n("9112"),
              a = n("6eeb"),
              i = n("d039"),
              o = n("b622"),
              s = n("9263"),
              c = o("species"),
              u = !i(function () {
            var t = /./;
            return t.exec = function () {
              var t = [];
              return t.groups = {
                a: "7"
              }, t;
            }, "7" !== "".replace(t, "$<a>");
          }),
              l = !i(function () {
            var t = /(?:)/,
                e = t.exec;

            t.exec = function () {
              return e.apply(this, arguments);
            };

            var n = "ab".split(t);
            return 2 !== n.length || "a" !== n[0] || "b" !== n[1];
          });

          t.exports = function (t, e, n, f) {
            var d = o(t),
                h = !i(function () {
              var e = {};
              return e[d] = function () {
                return 7;
              }, 7 != ""[t](e);
            }),
                p = h && !i(function () {
              var e = !1,
                  n = /a/;
              return "split" === t && (n = {}, n.constructor = {}, n.constructor[c] = function () {
                return n;
              }, n.flags = "", n[d] = /./[d]), n.exec = function () {
                return e = !0, null;
              }, n[d](""), !e;
            });

            if (!h || !p || "replace" === t && !u || "split" === t && !l) {
              var m = /./[d],
                  g = n(d, ""[t], function (t, e, n, r, a) {
                return e.exec === s ? h && !a ? {
                  done: !0,
                  value: m.call(e, n, r)
                } : {
                  done: !0,
                  value: t.call(n, e, r)
                } : {
                  done: !1
                };
              }),
                  v = g[0],
                  y = g[1];
              a(String.prototype, t, v), a(RegExp.prototype, d, 2 == e ? function (t, e) {
                return y.call(t, this, e);
              } : function (t) {
                return y.call(t, this);
              }), f && r(RegExp.prototype[d], "sham", !0);
            }
          };
        },
        d81d: function d81d(t, e, n) {

          var r = n("23e7"),
              a = n("b727").map,
              i = n("d039"),
              o = n("1dde"),
              s = o("map"),
              c = s && !i(function () {
            [].map.call({
              length: -1,
              0: 1
            }, function (t) {
              throw t;
            });
          });
          r({
            target: "Array",
            proto: !0,
            forced: !s || !c
          }, {
            map: function map(t) {
              return a(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
          });
        },
        da84: function da84(t, e, n) {
          (function (e) {
            var n = function n(t) {
              return t && t.Math == Math && t;
            };

            t.exports = n("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis) || n("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) || n("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) || n("object" == _typeof(e) && e) || Function("return this")();
          }).call(this, n("c8ba"));
        },
        dbb4: function dbb4(t, e, n) {
          var r = n("23e7"),
              a = n("83ab"),
              i = n("56ef"),
              o = n("fc6a"),
              s = n("06cf"),
              c = n("8418");
          r({
            target: "Object",
            stat: !0,
            sham: !a
          }, {
            getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
              var e,
                  n,
                  r = o(t),
                  a = s.f,
                  u = i(r),
                  l = {},
                  f = 0;

              while (u.length > f) {
                n = a(r, e = u[f++]), void 0 !== n && c(l, e, n);
              }

              return l;
            }
          });
        },
        ddb0: function ddb0(t, e, n) {
          var r = n("da84"),
              a = n("fdbc"),
              i = n("e260"),
              o = n("9112"),
              s = n("b622"),
              c = s("iterator"),
              u = s("toStringTag"),
              l = i.values;

          for (var f in a) {
            var d = r[f],
                h = d && d.prototype;

            if (h) {
              if (h[c] !== l) try {
                o(h, c, l);
              } catch (m) {
                h[c] = l;
              }
              if (h[u] || o(h, u, f), a[f]) for (var p in i) {
                if (h[p] !== i[p]) try {
                  o(h, p, i[p]);
                } catch (m) {
                  h[p] = i[p];
                }
              }
            }
          }
        },
        df75: function df75(t, e, n) {
          var r = n("ca84"),
              a = n("7839");

          t.exports = Object.keys || function (t) {
            return r(t, a);
          };
        },
        e01a: function e01a(t, e, n) {

          var r = n("23e7"),
              a = n("83ab"),
              i = n("da84"),
              o = n("5135"),
              s = n("861d"),
              c = n("9bf2").f,
              u = n("e893"),
              l = i.Symbol;

          if (a && "function" == typeof l && (!("description" in l.prototype) || void 0 !== l().description)) {
            var f = {},
                d = function d() {
              var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]),
                  e = this instanceof d ? new l(t) : void 0 === t ? l() : l(t);
              return "" === t && (f[e] = !0), e;
            };

            u(d, l);
            var h = d.prototype = l.prototype;
            h.constructor = d;
            var p = h.toString,
                m = "Symbol(test)" == String(l("test")),
                g = /^Symbol\((.*)\)[^)]+$/;
            c(h, "description", {
              configurable: !0,
              get: function get() {
                var t = s(this) ? this.valueOf() : this,
                    e = p.call(t);
                if (o(f, t)) return "";
                var n = m ? e.slice(7, -1) : e.replace(g, "$1");
                return "" === n ? void 0 : n;
              }
            }), r({
              global: !0,
              forced: !0
            }, {
              Symbol: d
            });
          }
        },
        e163: function e163(t, e, n) {
          var r = n("5135"),
              a = n("7b0b"),
              i = n("f772"),
              o = n("e177"),
              s = i("IE_PROTO"),
              c = Object.prototype;
          t.exports = o ? Object.getPrototypeOf : function (t) {
            return t = a(t), r(t, s) ? t[s] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? c : null;
          };
        },
        e177: function e177(t, e, n) {
          var r = n("d039");
          t.exports = !r(function () {
            function t() {}

            return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
          });
        },
        e260: function e260(t, e, n) {

          var r = n("fc6a"),
              a = n("44d2"),
              i = n("3f8c"),
              o = n("69f3"),
              s = n("7dd0"),
              c = "Array Iterator",
              u = o.set,
              l = o.getterFor(c);
          t.exports = s(Array, "Array", function (t, e) {
            u(this, {
              type: c,
              target: r(t),
              index: 0,
              kind: e
            });
          }, function () {
            var t = l(this),
                e = t.target,
                n = t.kind,
                r = t.index++;
            return !e || r >= e.length ? (t.target = void 0, {
              value: void 0,
              done: !0
            }) : "keys" == n ? {
              value: r,
              done: !1
            } : "values" == n ? {
              value: e[r],
              done: !1
            } : {
              value: [r, e[r]],
              done: !1
            };
          }, "values"), i.Arguments = i.Array, a("keys"), a("values"), a("entries");
        },
        e439: function e439(t, e, n) {
          var r = n("23e7"),
              a = n("d039"),
              i = n("fc6a"),
              o = n("06cf").f,
              s = n("83ab"),
              c = a(function () {
            o(1);
          }),
              u = !s || c;
          r({
            target: "Object",
            stat: !0,
            forced: u,
            sham: !s
          }, {
            getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
              return o(i(t), e);
            }
          });
        },
        e893: function e893(t, e, n) {
          var r = n("5135"),
              a = n("56ef"),
              i = n("06cf"),
              o = n("9bf2");

          t.exports = function (t, e) {
            for (var n = a(e), s = o.f, c = i.f, u = 0; u < n.length; u++) {
              var l = n[u];
              r(t, l) || s(t, l, c(e, l));
            }
          };
        },
        e8b5: function e8b5(t, e, n) {
          var r = n("c6b6");

          t.exports = Array.isArray || function (t) {
            return "Array" == r(t);
          };
        },
        e95a: function e95a(t, e, n) {
          var r = n("b622"),
              a = n("3f8c"),
              i = r("iterator"),
              o = Array.prototype;

          t.exports = function (t) {
            return void 0 !== t && (a.Array === t || o[i] === t);
          };
        },
        f5df: function f5df(t, e, n) {
          var r = n("00ee"),
              a = n("c6b6"),
              i = n("b622"),
              o = i("toStringTag"),
              s = "Arguments" == a(function () {
            return arguments;
          }()),
              c = function c(t, e) {
            try {
              return t[e];
            } catch (n) {}
          };

          t.exports = r ? a : function (t) {
            var e, n, r;
            return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = c(e = Object(t), o)) ? n : s ? a(e) : "Object" == (r = a(e)) && "function" == typeof e.callee ? "Arguments" : r;
          };
        },
        f6fd: function f6fd(t, e) {
          (function (t) {
            var e = "currentScript",
                n = t.getElementsByTagName("script");
            e in t || Object.defineProperty(t, e, {
              get: function get() {
                try {
                  throw new Error();
                } catch (r) {
                  var t,
                      e = (/.*at [^\(]*\((.*):.+:.+\)$/gi.exec(r.stack) || [!1])[1];

                  for (t in n) {
                    if (n[t].src == e || "interactive" == n[t].readyState) return n[t];
                  }

                  return null;
                }
              }
            });
          })(document);
        },
        f772: function f772(t, e, n) {
          var r = n("5692"),
              a = n("90e3"),
              i = r("keys");

          t.exports = function (t) {
            return i[t] || (i[t] = a(t));
          };
        },
        f8c2: function f8c2(t, e, n) {
          var r = n("1c0b");

          t.exports = function (t, e, n) {
            if (r(t), void 0 === e) return t;

            switch (n) {
              case 0:
                return function () {
                  return t.call(e);
                };

              case 1:
                return function (n) {
                  return t.call(e, n);
                };

              case 2:
                return function (n, r) {
                  return t.call(e, n, r);
                };

              case 3:
                return function (n, r, a) {
                  return t.call(e, n, r, a);
                };
            }

            return function () {
              return t.apply(e, arguments);
            };
          };
        },
        fb15: function fb15(t, e, n) {

          var r;
          (n.r(e), "undefined" !== typeof window) && (n("f6fd"), (r = window.document.currentScript) && (r = r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)) && (n.p = r[1]));

          var a = function a() {
            var t = this,
                e = t.$createElement,
                n = t._self._c || e;
            return n("div", {
              staticClass: "vue-daterange-picker",
              class: {
                inline: "inline" === t.opens
              }
            }, [n("div", {
              ref: "toggle",
              class: t.controlContainerClass,
              on: {
                click: t.onClickPicker
              }
            }, [t._t("input", [n("i", {
              staticClass: "glyphicon glyphicon-calendar fa fa-calendar"
            }), t._v(" "), n("span", [t._v(t._s(t.rangeText))]), n("b", {
              staticClass: "caret"
            })], {
              startDate: t.start,
              endDate: t.end,
              ranges: t.ranges,
              rangeText: t.rangeText
            })], 2), n("transition", {
              attrs: {
                name: "slide-fade",
                mode: "out-in"
              }
            }, [t.open || "inline" === t.opens ? n("div", {
              directives: [{
                name: "append-to-body",
                rawName: "v-append-to-body"
              }],
              ref: "dropdown",
              staticClass: "daterangepicker ltr",
              class: t.pickerStyles
            }, [t._t("header", null, {
              rangeText: t.rangeText,
              locale: t.locale,
              clickCancel: t.clickCancel,
              clickApply: t.clickedApply,
              in_selection: t.in_selection,
              autoApply: t.autoApply
            }), n("div", {
              staticClass: "calendars"
            }, [t.showRanges ? t._t("ranges", [n("calendar-ranges", {
              attrs: {
                "always-show-calendars": t.alwaysShowCalendars,
                "locale-data": t.locale,
                ranges: t.ranges,
                selected: {
                  startDate: t.start,
                  endDate: t.end
                }
              },
              on: {
                "click-range": t.clickRange,
                "show-custom-range": function showCustomRange(e) {
                  t.showCustomRangeCalendars = !0;
                }
              }
            })], {
              startDate: t.start,
              endDate: t.end,
              ranges: t.ranges,
              clickRange: t.clickRange
            }) : t._e(), t.showCalendars ? n("div", {
              staticClass: "calendars-container"
            }, [n("div", {
              staticClass: "drp-calendar col left",
              class: {
                single: t.singleDatePicker
              }
            }, [t._e(), n("div", {
              staticClass: "calendar-table"
            }, [n("calendar", {
              attrs: {
                monthDate: t.monthDate,
                "locale-data": t.locale,
                start: t.start,
                end: t.end,
                minDate: t.min,
                maxDate: t.max,
                "show-dropdowns": t.showDropdowns,
                "date-format": t.dateFormatFn,
                showWeekNumbers: t.showWeekNumbers
              },
              on: {
                "change-month": t.changeLeftMonth,
                "date-click": t.dateClick,
                "hover-date": t.hoverDate
              },
              scopedSlots: t._u([{
                key: "date-slot",
                fn: function fn(e) {
                  return t._t("date", null, null, e);
                }
              }], null, !0)
            })], 1), t.timePicker && t.start ? n("calendar-time", {
              attrs: {
                "miniute-increment": t.timePickerIncrement,
                hour24: t.timePicker24Hour,
                "second-picker": t.timePickerSeconds,
                "current-time": t.start,
                readonly: t.readonly
              },
              on: {
                update: t.onUpdateStartTime
              }
            }) : t._e()], 1), t.singleDatePicker ? t._e() : n("div", {
              staticClass: "drp-calendar col right"
            }, [t._e(), n("div", {
              staticClass: "calendar-table"
            }, [n("calendar", {
              attrs: {
                monthDate: t.nextMonthDate,
                "locale-data": t.locale,
                start: t.start,
                end: t.end,
                minDate: t.min,
                maxDate: t.max,
                "show-dropdowns": t.showDropdowns,
                "date-format": t.dateFormatFn,
                showWeekNumbers: t.showWeekNumbers
              },
              on: {
                "change-month": t.changeRightMonth,
                "date-click": t.dateClick,
                "hover-date": t.hoverDate
              },
              scopedSlots: t._u([{
                key: "date-slot",
                fn: function fn(e) {
                  return t._t("date", null, null, e);
                }
              }], null, !0)
            })], 1), t.timePicker && t.end ? n("calendar-time", {
              attrs: {
                "miniute-increment": t.timePickerIncrement,
                hour24: t.timePicker24Hour,
                "second-picker": t.timePickerSeconds,
                "current-time": t.end,
                readonly: t.readonly
              },
              on: {
                update: t.onUpdateEndTime
              }
            }) : t._e()], 1)]) : t._e()], 2), t._t("footer", [t.autoApply ? t._e() : n("div", {
              staticClass: "drp-buttons"
            }, [t.showCalendars ? n("span", {
              staticClass: "drp-selected"
            }, [t._v(t._s(t.rangeText))]) : t._e(), t.readonly ? t._e() : n("button", {
              staticClass: "cancelBtn btn btn-sm btn-secondary",
              attrs: {
                type: "button"
              },
              on: {
                click: t.clickCancel
              }
            }, [t._v(t._s(t.locale.cancelLabel) + " ")]), t.readonly ? t._e() : n("button", {
              staticClass: "applyBtn btn btn-sm btn-success",
              attrs: {
                disabled: t.in_selection,
                type: "button"
              },
              on: {
                click: t.clickedApply
              }
            }, [t._v(t._s(t.locale.applyLabel) + " ")])])], {
              rangeText: t.rangeText,
              locale: t.locale,
              clickCancel: t.clickCancel,
              clickApply: t.clickedApply,
              in_selection: t.in_selection,
              autoApply: t.autoApply
            })], 2) : t._e()])], 1);
          },
              i = [],
              o = (n("a4d3"), n("4de4"), n("7db0"), n("a9e3"), n("e439"), n("dbb4"), n("b64b"), n("159b"), n("53ca"));

          function s(t) {
            if (Array.isArray(t)) {
              for (var e = 0, n = new Array(t.length); e < t.length; e++) {
                n[e] = t[e];
              }

              return n;
            }
          }

          n("e01a"), n("d28b"), n("a630"), n("e260"), n("d3b7"), n("25f0"), n("3ca3"), n("ddb0");

          function c(t) {
            if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
          }

          function u() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
          }

          function l(t) {
            return s(t) || c(t) || u();
          }

          var f = n("ade3"),
              d = function d() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "native";
            return t instanceof Object ? t : "string" === typeof t || t instanceof String ? n("a6da")("./" + t).default : void 0;
          },
              h = {
            props: {
              dateUtil: {
                type: [Object, String],
                default: "native"
              }
            },
            beforeCreate: function beforeCreate() {
              this.$dateUtil = d("native");
            }
          },
              p = function p() {
            var t = this,
                e = t.$createElement,
                n = t._self._c || e;
            return n("table", {
              staticClass: "table-condensed"
            }, [n("thead", [n("tr", [n("th", {
              staticClass: "prev available",
              attrs: {
                tabindex: "0"
              },
              on: {
                click: t.prevMonthClick
              }
            }, [n("span")]), t.showDropdowns ? n("th", {
              staticClass: "month",
              attrs: {
                colspan: t.showWeekNumbers ? 6 : 5
              }
            }, [n("div", {
              staticClass: "row mx-1"
            }, [n("select", {
              directives: [{
                name: "model",
                rawName: "v-model",
                value: t.month,
                expression: "month"
              }],
              staticClass: "monthselect col",
              on: {
                change: function change(e) {
                  var n = Array.prototype.filter.call(e.target.options, function (t) {
                    return t.selected;
                  }).map(function (t) {
                    var e = "_value" in t ? t._value : t.value;
                    return e;
                  });
                  t.month = e.target.multiple ? n : n[0];
                }
              }
            }, t._l(t.months, function (e, r) {
              return n("option", {
                key: r,
                attrs: {
                  disabled: !e.enabled
                },
                domProps: {
                  value: e.value + 1
                }
              }, [t._v(t._s(e.label))]);
            }), 0), n("input", {
              directives: [{
                name: "model",
                rawName: "v-model",
                value: t.year,
                expression: "year"
              }],
              ref: "yearSelect",
              staticClass: "yearselect col",
              attrs: {
                type: "number"
              },
              domProps: {
                value: t.year
              },
              on: {
                blur: t.checkYear,
                input: function input(e) {
                  e.target.composing || (t.year = e.target.value);
                }
              }
            })])]) : n("th", {
              staticClass: "month",
              attrs: {
                colspan: t.showWeekNumbers ? 6 : 5
              }
            }, [t._v(t._s(t.monthName) + " " + t._s(t.year))]), n("th", {
              staticClass: "next available",
              attrs: {
                tabindex: "0"
              },
              on: {
                click: t.nextMonthClick
              }
            }, [n("span")])])]), n("tbody", [n("tr", [t.showWeekNumbers ? n("th", {
              staticClass: "week"
            }, [t._v(t._s(t.locale.weekLabel))]) : t._e(), t._l(t.locale.daysOfWeek, function (e, r) {
              return n("th", {
                key: r
              }, [t._v(t._s(e))]);
            })], 2), t._l(t.calendar, function (e, r) {
              return n("tr", {
                key: r
              }, [t.showWeekNumbers && (r % 7 || 0 === r) ? n("td", {
                staticClass: "week"
              }, [t._v(" " + t._s(t.$dateUtil.weekNumber(e[0])) + " ")]) : t._e(), t._l(e, function (e, r) {
                return n("td", {
                  key: r,
                  class: t.dayClass(e),
                  attrs: {
                    "data-date": e.toISOString().substring(0, 10)
                  },
                  on: {
                    click: function click(n) {
                      return t.$emit("date-click", e);
                    },
                    mouseover: function mouseover(n) {
                      return t.$emit("hover-date", e);
                    }
                  }
                }, [t._t("date-slot", [t._v(" " + t._s(e.getDate()) + " ")], {
                  date: e
                })], 2);
              })], 2);
            })], 2)]);
          },
              m = [],
              g = (n("d81d"), {
            mixins: [h],
            name: "calendar",
            props: {
              monthDate: Date,
              localeData: Object,
              start: Date,
              end: Date,
              minDate: Date,
              maxDate: Date,
              showDropdowns: {
                type: Boolean,
                default: !1
              },
              showWeekNumbers: {
                type: Boolean,
                default: !1
              },
              dateFormat: {
                type: Function,
                default: null
              }
            },
            data: function data() {
              var t = this.monthDate || this.start || new Date();
              return {
                currentMonthDate: t,
                year_text: t.getFullYear()
              };
            },
            methods: {
              prevMonthClick: function prevMonthClick() {
                this.changeMonthDate(this.$dateUtil.prevMonth(this.currentMonthDate));
              },
              nextMonthClick: function nextMonthClick() {
                this.changeMonthDate(this.$dateUtil.nextMonth(this.currentMonthDate));
              },
              changeMonthDate: function changeMonthDate(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                    n = this.$dateUtil.yearMonth(this.currentMonthDate);
                this.currentMonthDate = this.$dateUtil.validateDateRange(t, this.minDate, this.maxDate), e && n !== this.$dateUtil.yearMonth(this.currentMonthDate) && this.$emit("change-month", {
                  month: this.currentMonthDate.getMonth() + 1,
                  year: this.currentMonthDate.getFullYear()
                }), this.checkYear();
              },
              dayClass: function dayClass(t) {
                var e = new Date(t);
                e.setHours(0, 0, 0, 0);
                var n = new Date(this.start);
                n.setHours(0, 0, 0, 0);
                var r = new Date(this.end);
                r.setHours(0, 0, 0, 0);
                var a = new Date(e);
                a.setHours(23, 59, 59, 999);
                var i = {
                  off: t.getMonth() + 1 !== this.month,
                  weekend: 6 === t.getDay() || 0 === t.getDay(),
                  today: e.setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0),
                  active: e.setHours(0, 0, 0, 0) == new Date(this.start).setHours(0, 0, 0, 0) || e.setHours(0, 0, 0, 0) == new Date(this.end).setHours(0, 0, 0, 0),
                  "in-range": e >= n && e <= r,
                  "start-date": e.getTime() === n.getTime(),
                  "end-date": e.getTime() === r.getTime(),
                  disabled: this.minDate && a.getTime() < this.minDate.getTime() || this.maxDate && e.getTime() > this.maxDate.getTime()
                };
                return this.dateFormat ? this.dateFormat(i, t) : i;
              },
              checkYear: function checkYear() {
                var t = this;
                this.$refs.yearSelect !== document.activeElement && this.$nextTick(function () {
                  t.year_text = t.monthDate.getFullYear();
                });
              }
            },
            computed: {
              monthName: function monthName() {
                return this.locale.monthNames[this.currentMonthDate.getMonth()];
              },
              year: {
                get: function get() {
                  return this.year_text;
                },
                set: function set(t) {
                  this.year_text = t;
                  var e = this.$dateUtil.validateDateRange(new Date(t, this.month, 1), this.minDate, this.maxDate);
                  this.$dateUtil.isValidDate(e) && this.$emit("change-month", {
                    month: e.getMonth(),
                    year: e.getFullYear()
                  });
                }
              },
              month: {
                get: function get() {
                  return this.currentMonthDate.getMonth() + 1;
                },
                set: function set(t) {
                  var e = this.$dateUtil.validateDateRange(new Date(this.year, t - 1, 1), this.minDate, this.maxDate);
                  this.$emit("change-month", {
                    month: e.getMonth() + 1,
                    year: e.getFullYear()
                  });
                }
              },
              calendar: function calendar() {
                for (var t = this.month, e = this.currentMonthDate.getFullYear(), n = new Date(e, t - 1, 1), r = this.$dateUtil.prevMonth(n).getMonth() + 1, a = this.$dateUtil.prevMonth(n).getFullYear(), i = new Date(a, t - 1, 0).getDate(), o = n.getDay(), s = [], c = 0; c < 6; c++) {
                  s[c] = [];
                }

                var u = i - o + this.locale.firstDay + 1;
                u > i && (u -= 7), o === this.locale.firstDay && (u = i - 6);

                for (var l = new Date(a, r - 1, u, 12, 0, 0), f = 0, d = 0, h = 0; f < 42; f++, d++, l.setDate(l.getDate() + 1)) {
                  f > 0 && d % 7 === 0 && (d = 0, h++), s[h][d] = new Date(l.getTime());
                }

                return s;
              },
              months: function months() {
                var t = this;
                return this.locale.monthNames.map(function (e, n) {
                  return {
                    label: e,
                    value: n,
                    enabled: (!t.maxDate || t.maxDate >= new Date(t.year, n, 1)) && (!t.minDate || t.minDate <= new Date(t.year, n + 1, 0))
                  };
                });
              },
              locale: function locale() {
                return this.$dateUtil.localeData(this.localeData);
              }
            },
            watch: {
              monthDate: function monthDate(t) {
                this.currentMonthDate.getTime() !== t.getTime() && this.changeMonthDate(t, !1);
              }
            }
          }),
              v = g;

          n("9d0d");

          function y(t, e, n, r, a, i, o, s) {
            var c,
                u = "function" === typeof t ? t.options : t;
            if (e && (u.render = e, u.staticRenderFns = n, u._compiled = !0), r && (u.functional = !0), i && (u._scopeId = "data-v-" + i), o ? (c = function c(t) {
              t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" === typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), a && a.call(this, t), t && t._registeredComponents && t._registeredComponents.add(o);
            }, u._ssrRegister = c) : a && (c = s ? function () {
              a.call(this, this.$root.$options.shadowRoot);
            } : a), c) if (u.functional) {
              u._injectStyles = c;
              var l = u.render;

              u.render = function (t, e) {
                return c.call(e), l(t, e);
              };
            } else {
              var f = u.beforeCreate;
              u.beforeCreate = f ? [].concat(f, c) : [c];
            }
            return {
              exports: t,
              options: u
            };
          }

          var b = y(v, p, m, !1, null, "98ac2448", null),
              D = b.exports,
              w = function w() {
            var t = this,
                e = t.$createElement,
                n = t._self._c || e;
            return n("div", {
              staticClass: "calendar-time"
            }, [n("select", {
              directives: [{
                name: "model",
                rawName: "v-model",
                value: t.hour,
                expression: "hour"
              }],
              staticClass: "hourselect form-control mr-1",
              attrs: {
                disabled: t.readonly
              },
              on: {
                change: function change(e) {
                  var n = Array.prototype.filter.call(e.target.options, function (t) {
                    return t.selected;
                  }).map(function (t) {
                    var e = "_value" in t ? t._value : t.value;
                    return e;
                  });
                  t.hour = e.target.multiple ? n : n[0];
                }
              }
            }, t._l(t.hours, function (e) {
              return n("option", {
                key: e,
                domProps: {
                  value: e
                }
              }, [t._v(t._s(t._f("formatNumber")(e)))]);
            }), 0), t._v(" :"), n("select", {
              directives: [{
                name: "model",
                rawName: "v-model",
                value: t.minute,
                expression: "minute"
              }],
              staticClass: "minuteselect form-control ml-1",
              attrs: {
                disabled: t.readonly
              },
              on: {
                change: function change(e) {
                  var n = Array.prototype.filter.call(e.target.options, function (t) {
                    return t.selected;
                  }).map(function (t) {
                    var e = "_value" in t ? t._value : t.value;
                    return e;
                  });
                  t.minute = e.target.multiple ? n : n[0];
                }
              }
            }, t._l(t.minutes, function (e) {
              return n("option", {
                key: e,
                domProps: {
                  value: e
                }
              }, [t._v(t._s(t._f("formatNumber")(e)))]);
            }), 0), t.secondPicker ? [t._v(" :"), n("select", {
              directives: [{
                name: "model",
                rawName: "v-model",
                value: t.second,
                expression: "second"
              }],
              staticClass: "secondselect form-control ml-1",
              attrs: {
                disabled: t.readonly
              },
              on: {
                change: function change(e) {
                  var n = Array.prototype.filter.call(e.target.options, function (t) {
                    return t.selected;
                  }).map(function (t) {
                    var e = "_value" in t ? t._value : t.value;
                    return e;
                  });
                  t.second = e.target.multiple ? n : n[0];
                }
              }
            }, t._l(60, function (e) {
              return n("option", {
                key: e - 1,
                domProps: {
                  value: e - 1
                }
              }, [t._v(t._s(t._f("formatNumber")(e - 1)))]);
            }), 0)] : t._e(), t.hour24 ? t._e() : n("select", {
              directives: [{
                name: "model",
                rawName: "v-model",
                value: t.ampm,
                expression: "ampm"
              }],
              staticClass: "ampmselect",
              attrs: {
                disabled: t.readonly
              },
              on: {
                change: function change(e) {
                  var n = Array.prototype.filter.call(e.target.options, function (t) {
                    return t.selected;
                  }).map(function (t) {
                    var e = "_value" in t ? t._value : t.value;
                    return e;
                  });
                  t.ampm = e.target.multiple ? n : n[0];
                }
              }
            }, [n("option", {
              attrs: {
                value: "AM"
              }
            }, [t._v("AM")]), n("option", {
              attrs: {
                value: "PM"
              }
            }, [t._v("PM")])])], 2);
          },
              x = [],
              S = {
            filters: {
              formatNumber: function formatNumber(t) {
                return t < 10 ? "0" + t.toString() : t.toString();
              }
            },
            props: {
              miniuteIncrement: {
                type: Number,
                default: 5
              },
              hour24: {
                type: Boolean,
                default: !0
              },
              secondPicker: {
                type: Boolean,
                default: !1
              },
              currentTime: {
                default: function _default() {
                  return new Date();
                }
              },
              readonly: {
                type: Boolean,
                default: !1
              }
            },
            data: function data() {
              var t = this.currentTime ? this.currentTime : new Date(),
                  e = t.getHours();
              return {
                hour: this.hour24 ? e : e % 12 || 12,
                minute: t.getMinutes() - t.getMinutes() % this.miniuteIncrement,
                second: t.getSeconds(),
                ampm: e < 12 ? "AM" : "PM"
              };
            },
            computed: {
              hours: function hours() {
                for (var t = [], e = this.hour24 ? 24 : 12, n = 0; n < e; n++) {
                  t.push(this.hour24 ? n : n + 1);
                }

                return t;
              },
              minutes: function minutes() {
                for (var t = [], e = 60, n = 0; n < e; n += this.miniuteIncrement) {
                  t.push(n);
                }

                return t;
              }
            },
            watch: {
              hour: function hour() {
                this.onChange();
              },
              minute: function minute() {
                this.onChange();
              },
              second: function second() {
                this.onChange();
              },
              ampm: function ampm() {
                this.onChange();
              }
            },
            methods: {
              getHour: function getHour() {
                return this.hour24 ? this.hour : 12 === this.hour ? "AM" === this.ampm ? 0 : 12 : this.hour + ("PM" === this.ampm ? 12 : 0);
              },
              onChange: function onChange() {
                this.$emit("update", {
                  hours: this.getHour(),
                  minutes: this.minute,
                  seconds: this.second
                });
              }
            }
          },
              M = S,
              k = y(M, w, x, !1, null, null, null),
              _ = k.exports,
              O = function O() {
            var t = this,
                e = t.$createElement,
                n = t._self._c || e;
            return n("div", {
              staticClass: "ranges"
            }, [t.ranges ? n("ul", [t._l(t.listedRanges, function (e) {
              return n("li", {
                key: e.label,
                class: t.range_class(e),
                attrs: {
                  "data-range-key": e.label,
                  tabindex: "0"
                },
                on: {
                  click: function click(n) {
                    return t.clickRange(e.value);
                  }
                }
              }, [t._v(t._s(e.label) + " ")]);
            }), t.showCustomRangeLabel ? n("li", {
              class: {
                active: t.customRangeActive || !t.selectedRange
              },
              attrs: {
                tabindex: "0"
              },
              on: {
                click: t.clickCustomRange
              }
            }, [t._v(" " + t._s(t.localeData.customRangeLabel) + " ")]) : t._e()], 2) : t._e()]);
          },
              T = [],
              C = {
            mixins: [h],
            props: {
              ranges: Object,
              selected: Object,
              localeData: Object,
              alwaysShowCalendars: Boolean
            },
            data: function data() {
              return {
                customRangeActive: !1
              };
            },
            methods: {
              clickRange: function clickRange(t) {
                this.customRangeActive = !1, this.$emit("click-range", t);
              },
              clickCustomRange: function clickCustomRange() {
                this.customRangeActive = !0, this.$emit("show-custom-range");
              },
              range_class: function range_class(t) {
                return {
                  active: !0 === t.selected
                };
              }
            },
            computed: {
              listedRanges: function listedRanges() {
                var t = this;
                return !!this.ranges && Object.keys(this.ranges).map(function (e) {
                  return {
                    label: e,
                    value: t.ranges[e],
                    selected: t.$dateUtil.isSame(t.selected.startDate, t.ranges[e][0]) && t.$dateUtil.isSame(t.selected.endDate, t.ranges[e][1])
                  };
                });
              },
              selectedRange: function selectedRange() {
                return this.listedRanges.find(function (t) {
                  return !0 === t.selected;
                });
              },
              showCustomRangeLabel: function showCustomRangeLabel() {
                return !this.alwaysShowCalendars;
              }
            }
          },
              P = C,
              j = y(P, O, T, !1, null, null, null),
              A = j.exports,
              N = {
            inserted: function inserted(t, e, n) {
              var r = n.context;

              if (r.appendToBody) {
                var a = r.$refs.toggle.getBoundingClientRect(),
                    i = a.height,
                    o = a.top,
                    s = a.left,
                    c = a.width,
                    u = a.right;
                t.unbindPosition = r.calculatePosition(t, r, {
                  width: c,
                  top: window.scrollY + o + i,
                  left: window.scrollX + s,
                  right: u
                }), document.body.appendChild(t);
              } else r.$el.appendChild(t);
            },
            unbind: function unbind(t, e, n) {
              var r = n.context;
              r.appendToBody && (t.unbindPosition && "function" === typeof t.unbindPosition && t.unbindPosition(), t.parentNode && t.parentNode.removeChild(t));
            }
          };

          function R(t, e) {
            var n = Object.keys(t);

            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(t);
              e && (r = r.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })), n.push.apply(n, r);
            }

            return n;
          }

          function $(t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? R(Object(n), !0).forEach(function (e) {
                Object(f["a"])(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }

            return t;
          }

          var E = {
            inheritAttrs: !1,
            components: {
              Calendar: D,
              CalendarTime: _,
              CalendarRanges: A
            },
            mixins: [h],
            directives: {
              appendToBody: N
            },
            model: {
              prop: "dateRange",
              event: "update"
            },
            props: {
              minDate: {
                type: [String, Date],
                default: function _default() {
                  return null;
                }
              },
              maxDate: {
                type: [String, Date],
                default: function _default() {
                  return null;
                }
              },
              showWeekNumbers: {
                type: Boolean,
                default: !1
              },
              linkedCalendars: {
                type: Boolean,
                default: !0
              },
              singleDatePicker: {
                type: [Boolean, String],
                default: !1
              },
              showDropdowns: {
                type: Boolean,
                default: !1
              },
              timePicker: {
                type: Boolean,
                default: !1
              },
              timePickerIncrement: {
                type: Number,
                default: 5
              },
              timePicker24Hour: {
                type: Boolean,
                default: !0
              },
              timePickerSeconds: {
                type: Boolean,
                default: !1
              },
              autoApply: {
                type: Boolean,
                default: !1
              },
              localeData: {
                type: Object,
                default: function _default() {
                  return {};
                }
              },
              dateRange: {
                type: [Object],
                default: null,
                required: !0
              },
              ranges: {
                type: [Object, Boolean],
                default: function _default() {
                  var t = new Date();
                  t.setHours(0, 0, 0, 0);
                  var e = new Date();
                  e.setHours(11, 59, 59, 999);
                  var n = new Date();
                  n.setDate(t.getDate() - 1), n.setHours(0, 0, 0, 0);
                  var r = new Date();
                  r.setDate(t.getDate() - 1), r.setHours(11, 59, 59, 999);
                  var a = new Date(t.getFullYear(), t.getMonth(), 1),
                      i = new Date(t.getFullYear(), t.getMonth() + 1, 0, 11, 59, 59, 999);
                  return {
                    Today: [t, e],
                    Yesterday: [n, r],
                    "This month": [a, i],
                    "This year": [new Date(t.getFullYear(), 0, 1), new Date(t.getFullYear(), 11, 31, 11, 59, 59, 999)],
                    "Last month": [new Date(t.getFullYear(), t.getMonth() - 1, 1), new Date(t.getFullYear(), t.getMonth(), 0, 11, 59, 59, 999)]
                  };
                }
              },
              opens: {
                type: String,
                default: "center"
              },
              dateFormat: Function,
              alwaysShowCalendars: {
                type: Boolean,
                default: !0
              },
              disabled: {
                type: Boolean,
                default: !1
              },
              controlContainerClass: {
                type: [Object, String],
                default: "form-control reportrange-text"
              },
              appendToBody: {
                type: Boolean,
                default: !1
              },
              calculatePosition: {
                type: Function,
                default: function _default(t, e, n) {
                  var r = n.width,
                      a = n.top,
                      i = n.left,
                      o = n.right;
                  "center" === e.opens ? t.style.left = i + r / 2 + "px" : "left" === e.opens ? t.style.right = window.innerWidth - o + "px" : "right" === e.opens && (t.style.left = i + "px"), t.style.top = a + "px";
                }
              },
              closeOnEsc: {
                type: Boolean,
                default: !0
              },
              readonly: {
                type: Boolean
              }
            },
            data: function data() {
              var t = d(),
                  e = {
                locale: t.localeData($({}, this.localeData))
              },
                  n = this.dateRange.startDate || null,
                  r = this.dateRange.endDate || null;

              if (e.monthDate = n ? new Date(n) : new Date(), e.nextMonthDate = t.nextMonth(e.monthDate), e.start = n ? new Date(n) : null, this.singleDatePicker && "range" !== this.singleDatePicker ? e.end = e.start : e.end = r ? new Date(r) : null, e.in_selection = !1, e.open = !1, e.showCustomRangeCalendars = !1, 0 !== e.locale.firstDay) {
                var a = e.locale.firstDay,
                    i = l(e.locale.daysOfWeek);

                while (a > 0) {
                  i.push(i.shift()), a--;
                }

                e.locale.daysOfWeek = i;
              }

              return e;
            },
            methods: {
              selectMonthDate: function selectMonthDate() {
                var t = this.end || new Date();
                !1 !== this.singleDatePicker ? this.changeLeftMonth({
                  year: t.getFullYear(),
                  month: t.getMonth() + 1
                }) : this.changeRightMonth({
                  year: t.getFullYear(),
                  month: t.getMonth() + 1
                });
              },
              dateFormatFn: function dateFormatFn(t, e) {
                var n = new Date(e);
                n.setHours(0, 0, 0, 0);
                var r = new Date(this.start);
                r.setHours(0, 0, 0, 0);
                var a = new Date(this.end);
                return a.setHours(0, 0, 0, 0), t["in-range"] = n >= r && n <= a, this.dateFormat ? this.dateFormat(t, e) : t;
              },
              changeLeftMonth: function changeLeftMonth(t) {
                var e = new Date(t.year, t.month - 1, 1);
                this.monthDate = e, (this.linkedCalendars || this.$dateUtil.yearMonth(this.monthDate) >= this.$dateUtil.yearMonth(this.nextMonthDate)) && (this.nextMonthDate = this.$dateUtil.validateDateRange(this.$dateUtil.nextMonth(e), this.minDate, this.maxDate), this.singleDatePicker || this.$dateUtil.yearMonth(this.monthDate) !== this.$dateUtil.yearMonth(this.nextMonthDate) || (this.monthDate = this.$dateUtil.validateDateRange(this.$dateUtil.prevMonth(this.monthDate), this.minDate, this.maxDate))), this.$emit("change-month", this.monthDate, 0);
              },
              changeRightMonth: function changeRightMonth(t) {
                var e = new Date(t.year, t.month - 1, 1);
                this.nextMonthDate = e, (this.linkedCalendars || this.$dateUtil.yearMonth(this.nextMonthDate) <= this.$dateUtil.yearMonth(this.monthDate)) && (this.monthDate = this.$dateUtil.validateDateRange(this.$dateUtil.prevMonth(e), this.minDate, this.maxDate), this.$dateUtil.yearMonth(this.monthDate) === this.$dateUtil.yearMonth(this.nextMonthDate) && (this.nextMonthDate = this.$dateUtil.validateDateRange(this.$dateUtil.nextMonth(this.nextMonthDate), this.minDate, this.maxDate))), this.$dateUtil.yearMonth(this.monthDate) === this.$dateUtil.yearMonth(this.nextMonthDate) && (this.nextMonthDate = this.$dateUtil.nextMonth(this.nextMonthDate)), this.$emit("change-month", this.nextMonthDate, 1);
              },
              normalizeDatetime: function normalizeDatetime(t, e) {
                var n = new Date(t);
                return this.timePicker && e && (n.setHours(e.getHours()), n.setMinutes(e.getMinutes()), n.setSeconds(e.getSeconds()), n.setMilliseconds(e.getMilliseconds())), n;
              },
              dateClick: function dateClick(t) {
                if (this.readonly) return !1;
                this.in_selection ? (this.in_selection = !1, this.$emit("finish-selection", t), this.onSelect(), this.autoApply && this.clickedApply()) : (this.start = this.normalizeDatetime(t, this.start), this.end = this.normalizeDatetime(t, this.end), this.singleDatePicker && "range" !== this.singleDatePicker ? (this.onSelect(), this.autoApply && this.clickedApply()) : (this.in_selection = this.end, this.$emit("start-selection", this.start)));
              },
              hoverDate: function hoverDate(t) {
                if (this.readonly) return !1;
                var e = this.normalizeDatetime(t, this.end),
                    n = this.normalizeDatetime(t, this.start);
                this.in_selection && (this.in_selection <= e && (this.end = e), this.in_selection >= n && (this.start = n)), this.$emit("hover-date", t);
              },
              onClickPicker: function onClickPicker() {
                this.disabled || this.togglePicker(null, !0);
              },
              togglePicker: function togglePicker(t, e) {
                this.open = "boolean" === typeof t ? t : !this.open, !0 === e && this.$emit("toggle", this.open, this.togglePicker);
              },
              clickedApply: function clickedApply() {
                this.togglePicker(!1, !0), this.$emit("update", {
                  startDate: this.start,
                  endDate: this.singleDatePicker && "range" !== this.singleDatePicker ? this.start : this.end
                });
              },
              clickCancel: function clickCancel() {
                if (this.open) {
                  var t = this.dateRange.startDate,
                      e = this.dateRange.endDate;
                  this.start = t ? new Date(t) : null, this.end = e ? new Date(e) : null, this.in_selection = !1, this.togglePicker(!1, !0);
                }
              },
              onSelect: function onSelect() {
                this.$emit("select", {
                  startDate: this.start,
                  endDate: this.end
                });
              },
              clickAway: function clickAway(t) {
                t && t.target && !this.$el.contains(t.target) && this.$refs.dropdown && !this.$refs.dropdown.contains(t.target) && this.clickCancel();
              },
              clickRange: function clickRange(t) {
                this.in_selection = !1, this.$dateUtil.isValidDate(t[0]) && this.$dateUtil.isValidDate(t[1]) ? (this.start = this.$dateUtil.validateDateRange(new Date(t[0]), this.minDate, this.maxDate), this.end = this.$dateUtil.validateDateRange(new Date(t[1]), this.minDate, this.maxDate), this.changeLeftMonth({
                  month: this.start.getMonth() + 1,
                  year: this.start.getFullYear()
                }), !1 === this.linkedCalendars && this.changeRightMonth({
                  month: this.end.getMonth() + 1,
                  year: this.end.getFullYear()
                })) : (this.start = null, this.end = null), this.onSelect(), this.autoApply && this.clickedApply();
              },
              onUpdateStartTime: function onUpdateStartTime(t) {
                var e = new Date(this.start);
                e.setHours(t.hours), e.setMinutes(t.minutes), e.setSeconds(t.seconds), this.start = this.$dateUtil.validateDateRange(e, this.minDate, this.maxDate), this.autoApply && this.$emit("update", {
                  startDate: this.start,
                  endDate: this.singleDatePicker && "range" !== this.singleDatePicker ? this.start : this.end
                });
              },
              onUpdateEndTime: function onUpdateEndTime(t) {
                var e = new Date(this.end);
                e.setHours(t.hours), e.setMinutes(t.minutes), e.setSeconds(t.seconds), this.end = this.$dateUtil.validateDateRange(e, this.minDate, this.maxDate), this.autoApply && this.$emit("update", {
                  startDate: this.start,
                  endDate: this.end
                });
              },
              handleEscape: function handleEscape(t) {
                this.open && 27 === t.keyCode && this.closeOnEsc && this.clickCancel();
              }
            },
            computed: {
              showRanges: function showRanges() {
                return !1 !== this.ranges && !this.readonly;
              },
              showCalendars: function showCalendars() {
                return this.alwaysShowCalendars || this.showCustomRangeCalendars;
              },
              startText: function startText() {
                return null === this.start ? "" : this.$dateUtil.format(this.start, this.locale.format);
              },
              endText: function endText() {
                return null === this.end ? "" : this.$dateUtil.format(this.end, this.locale.format);
              },
              rangeText: function rangeText() {
                var t = this.startText;
                return this.singleDatePicker && "range" !== this.singleDatePicker || (t += this.locale.separator + this.endText), t;
              },
              min: function min() {
                return this.minDate ? new Date(this.minDate) : null;
              },
              max: function max() {
                return this.maxDate ? new Date(this.maxDate) : null;
              },
              pickerStyles: function pickerStyles() {
                var t;
                return t = {
                  "show-calendar": this.open || "inline" === this.opens,
                  "show-ranges": this.showRanges,
                  "show-weeknumbers": this.showWeekNumbers,
                  single: this.singleDatePicker
                }, Object(f["a"])(t, "opens" + this.opens, !0), Object(f["a"])(t, "linked", this.linkedCalendars), Object(f["a"])(t, "hide-calendars", !this.showCalendars), t;
              },
              isClear: function isClear() {
                return !this.dateRange.startDate || !this.dateRange.endDate;
              },
              isDirty: function isDirty() {
                var t = new Date(this.dateRange.startDate),
                    e = new Date(this.dateRange.endDate);
                return !this.isClear && (this.start.getTime() !== t.getTime() || this.end.getTime() !== e.getTime());
              }
            },
            watch: {
              minDate: function minDate() {
                this.selectMonthDate();
              },
              maxDate: function maxDate() {
                this.selectMonthDate();
              },
              "dateRange.startDate": function dateRangeStartDate(t) {
                this.$dateUtil.isValidDate(new Date(t)) && (this.start = t && !this.isClear && this.$dateUtil.isValidDate(new Date(t)) ? new Date(t) : null, this.isClear ? (this.start = null, this.end = null) : (this.start = new Date(this.dateRange.startDate), this.end = new Date(this.dateRange.endDate)));
              },
              "dateRange.endDate": function dateRangeEndDate(t) {
                this.$dateUtil.isValidDate(new Date(t)) && (this.end = t && !this.isClear ? new Date(t) : null, this.isClear ? (this.start = null, this.end = null) : (this.start = new Date(this.dateRange.startDate), this.end = new Date(this.dateRange.endDate)));
              },
              open: {
                handler: function handler(t) {
                  var e = this;
                  "object" === ("undefined" === typeof document ? "undefined" : Object(o["a"])(document)) && (this.selectMonthDate(), this.$nextTick(function () {
                    t ? document.body.addEventListener("click", e.clickAway) : document.body.removeEventListener("click", e.clickAway), t ? document.addEventListener("keydown", e.handleEscape) : document.removeEventListener("keydown", e.handleEscape), !e.alwaysShowCalendars && e.ranges && (e.showCustomRangeCalendars = !Object.keys(e.ranges).find(function (t) {
                      return e.$dateUtil.isSame(e.start, e.ranges[t][0], "date") && e.$dateUtil.isSame(e.end, e.ranges[t][1], "date");
                    }));
                  }));
                },
                immediate: !0
              }
            }
          },
              U = E,
              F = (n("0e58"), n("ce5f"), y(U, a, i, !1, null, "1ebd09d2", null)),
              I = F.exports,
              L = I;
          e["default"] = L;
        },
        fb6a: function fb6a(t, e, n) {

          var r = n("23e7"),
              a = n("861d"),
              i = n("e8b5"),
              o = n("23cb"),
              s = n("50c4"),
              c = n("fc6a"),
              u = n("8418"),
              l = n("1dde"),
              f = n("b622"),
              d = f("species"),
              h = [].slice,
              p = Math.max;
          r({
            target: "Array",
            proto: !0,
            forced: !l("slice")
          }, {
            slice: function slice(t, e) {
              var n,
                  r,
                  l,
                  f = c(this),
                  m = s(f.length),
                  g = o(t, m),
                  v = o(void 0 === e ? m : e, m);
              if (i(f) && (n = f.constructor, "function" != typeof n || n !== Array && !i(n.prototype) ? a(n) && (n = n[d], null === n && (n = void 0)) : n = void 0, n === Array || void 0 === n)) return h.call(f, g, v);

              for (r = new (void 0 === n ? Array : n)(p(v - g, 0)), l = 0; g < v; g++, l++) {
                g in f && u(r, l, f[g]);
              }

              return r.length = l, r;
            }
          });
        },
        fc6a: function fc6a(t, e, n) {
          var r = n("44ad"),
              a = n("1d80");

          t.exports = function (t) {
            return r(a(t));
          };
        },
        fdbc: function fdbc(t, e) {
          t.exports = {
            CSSRuleList: 0,
            CSSStyleDeclaration: 0,
            CSSValueList: 0,
            ClientRectList: 0,
            DOMRectList: 0,
            DOMStringList: 0,
            DOMTokenList: 1,
            DataTransferItemList: 0,
            FileList: 0,
            HTMLAllCollection: 0,
            HTMLCollection: 0,
            HTMLFormElement: 0,
            HTMLSelectElement: 0,
            MediaList: 0,
            MimeTypeArray: 0,
            NamedNodeMap: 0,
            NodeList: 1,
            PaintRequestList: 0,
            Plugin: 0,
            PluginArray: 0,
            SVGLengthList: 0,
            SVGNumberList: 0,
            SVGPathSegList: 0,
            SVGPointList: 0,
            SVGStringList: 0,
            SVGTransformList: 0,
            SourceBufferList: 0,
            StyleSheetList: 0,
            TextTrackCueList: 0,
            TextTrackList: 0,
            TouchList: 0
          };
        },
        fdbf: function fdbf(t, e, n) {
          var r = n("4930");
          t.exports = r && !Symbol.sham && "symbol" == _typeof(Symbol());
        }
      });
    });
  });
  var DateRangePicker = unwrapExports(vue2DaterangePicker_umd_min);

  function extend$1(dest, src) {
    if (src) {
      var props = Object.keys(src);

      for (var i = 0, l = props.length; i < l; i++) {
        dest[props[i]] = src[props[i]];
      }
    }

    return dest;
  }

  function copy(obj) {
    return extend$1({}, obj);
  }
  /**
   * Merge an object defining format characters into the defaults.
   * Passing null/undefined for en existing format character removes it.
   * Passing a definition for an existing format character overrides it.
   * @param {?Object} formatCharacters.
   */


  function mergeFormatCharacters(formatCharacters) {
    var merged = copy(DEFAULT_FORMAT_CHARACTERS);

    if (formatCharacters) {
      var chars = Object.keys(formatCharacters);

      for (var i = 0, l = chars.length; i < l; i++) {
        var char = chars[i];

        if (formatCharacters[char] == null) {
          delete merged[char];
        } else {
          merged[char] = formatCharacters[char];
        }
      }
    }

    return merged;
  }

  var ESCAPE_CHAR = '\\';
  var DIGIT_RE = /^\d$/;
  var LETTER_RE = /^[A-Za-z]$/;
  var ALPHANNUMERIC_RE = /^[\dA-Za-z]$/;
  var DEFAULT_PLACEHOLDER_CHAR = '_';
  var DEFAULT_FORMAT_CHARACTERS = {
    '*': {
      validate: function validate(char) {
        return ALPHANNUMERIC_RE.test(char);
      }
    },
    '1': {
      validate: function validate(char) {
        return DIGIT_RE.test(char);
      }
    },
    'a': {
      validate: function validate(char) {
        return LETTER_RE.test(char);
      }
    },
    'A': {
      validate: function validate(char) {
        return LETTER_RE.test(char);
      },
      transform: function transform(char) {
        return char.toUpperCase();
      }
    },
    '#': {
      validate: function validate(char) {
        return ALPHANNUMERIC_RE.test(char);
      },
      transform: function transform(char) {
        return char.toUpperCase();
      }
    }
  };
  /**
   * @param {string} source
   * @patam {?Object} formatCharacters
   */

  function Pattern(source, formatCharacters, placeholderChar, isRevealingMask) {
    if (!(this instanceof Pattern)) {
      return new Pattern(source, formatCharacters, placeholderChar);
    }
    /** Placeholder character */


    this.placeholderChar = placeholderChar || DEFAULT_PLACEHOLDER_CHAR;
    /** Format character definitions. */

    this.formatCharacters = formatCharacters || DEFAULT_FORMAT_CHARACTERS;
    /** Pattern definition string with escape characters. */

    this.source = source;
    /** Pattern characters after escape characters have been processed. */

    this.pattern = [];
    /** Length of the pattern after escape characters have been processed. */

    this.length = 0;
    /** Index of the first editable character. */

    this.firstEditableIndex = null;
    /** Index of the last editable character. */

    this.lastEditableIndex = null;
    /** Lookup for indices of editable characters in the pattern. */

    this._editableIndices = {};
    /** If true, only the pattern before the last valid value character shows. */

    this.isRevealingMask = isRevealingMask || false;

    this._parse();
  }

  Pattern.prototype._parse = function parse() {
    var sourceChars = this.source.split('');
    var patternIndex = 0;
    var pattern = [];

    for (var i = 0, l = sourceChars.length; i < l; i++) {
      var char = sourceChars[i];

      if (char === ESCAPE_CHAR) {
        if (i === l - 1) {
          throw new Error('InputMask: pattern ends with a raw ' + ESCAPE_CHAR);
        }

        char = sourceChars[++i];
      } else if (char in this.formatCharacters) {
        if (this.firstEditableIndex === null) {
          this.firstEditableIndex = patternIndex;
        }

        this.lastEditableIndex = patternIndex;
        this._editableIndices[patternIndex] = true;
      }

      pattern.push(char);
      patternIndex++;
    }

    if (this.firstEditableIndex === null) {
      throw new Error('InputMask: pattern "' + this.source + '" does not contain any editable characters.');
    }

    this.pattern = pattern;
    this.length = pattern.length;
  };
  /**
   * @param {Array<string>} value
   * @return {Array<string>}
   */


  Pattern.prototype.formatValue = function format(value) {
    var valueBuffer = new Array(this.length);
    var valueIndex = 0;

    for (var i = 0, l = this.length; i < l; i++) {
      if (this.isEditableIndex(i)) {
        if (this.isRevealingMask && value.length <= valueIndex && !this.isValidAtIndex(value[valueIndex], i)) {
          break;
        }

        valueBuffer[i] = value.length > valueIndex && this.isValidAtIndex(value[valueIndex], i) ? this.transform(value[valueIndex], i) : this.placeholderChar;
        valueIndex++;
      } else {
        valueBuffer[i] = this.pattern[i]; // Also allow the value to contain static values from the pattern by
        // advancing its index.

        if (value.length > valueIndex && value[valueIndex] === this.pattern[i]) {
          valueIndex++;
        }
      }
    }

    return valueBuffer;
  };
  /**
   * @param {number} index
   * @return {boolean}
   */


  Pattern.prototype.isEditableIndex = function isEditableIndex(index) {
    return !!this._editableIndices[index];
  };
  /**
   * @param {string} char
   * @param {number} index
   * @return {boolean}
   */


  Pattern.prototype.isValidAtIndex = function isValidAtIndex(char, index) {
    return this.formatCharacters[this.pattern[index]].validate(char);
  };

  Pattern.prototype.transform = function transform(char, index) {
    var format = this.formatCharacters[this.pattern[index]];
    return typeof format.transform == 'function' ? format.transform(char) : char;
  };

  function InputMask(options) {
    if (!(this instanceof InputMask)) {
      return new InputMask(options);
    }

    options = extend$1({
      formatCharacters: null,
      pattern: null,
      isRevealingMask: false,
      placeholderChar: DEFAULT_PLACEHOLDER_CHAR,
      selection: {
        start: 0,
        end: 0
      },
      value: ''
    }, options);

    if (options.pattern == null) {
      throw new Error('InputMask: you must provide a pattern.');
    }

    if (typeof options.placeholderChar !== 'string' || options.placeholderChar.length > 1) {
      throw new Error('InputMask: placeholderChar should be a single character or an empty string.');
    }

    this.placeholderChar = options.placeholderChar;
    this.formatCharacters = mergeFormatCharacters(options.formatCharacters);
    this.setPattern(options.pattern, {
      value: options.value,
      selection: options.selection,
      isRevealingMask: options.isRevealingMask
    });
  } // Editing

  /**
   * Applies a single character of input based on the current selection.
   * @param {string} char
   * @return {boolean} true if a change has been made to value or selection as a
   *   result of the input, false otherwise.
   */


  InputMask.prototype.input = function input(char) {
    // Ignore additional input if the cursor's at the end of the pattern
    if (this.selection.start === this.selection.end && this.selection.start === this.pattern.length) {
      return false;
    }

    var selectionBefore = copy(this.selection);
    var valueBefore = this.getValue();
    var inputIndex = this.selection.start; // If the cursor or selection is prior to the first editable character, make
    // sure any input given is applied to it.

    if (inputIndex < this.pattern.firstEditableIndex) {
      inputIndex = this.pattern.firstEditableIndex;
    } // Bail out or add the character to input


    if (this.pattern.isEditableIndex(inputIndex)) {
      if (!this.pattern.isValidAtIndex(char, inputIndex)) {
        return false;
      }

      this.value[inputIndex] = this.pattern.transform(char, inputIndex);
    } // If multiple characters were selected, blank the remainder out based on the
    // pattern.


    var end = this.selection.end - 1;

    while (end > inputIndex) {
      if (this.pattern.isEditableIndex(end)) {
        this.value[end] = this.placeholderChar;
      }

      end--;
    } // Advance the cursor to the next character


    this.selection.start = this.selection.end = inputIndex + 1; // Skip over any subsequent static characters

    while (this.pattern.length > this.selection.start && !this.pattern.isEditableIndex(this.selection.start)) {
      this.selection.start++;
      this.selection.end++;
    } // History


    if (this._historyIndex != null) {
      // Took more input after undoing, so blow any subsequent history away
      this._history.splice(this._historyIndex, this._history.length - this._historyIndex);

      this._historyIndex = null;
    }

    if (this._lastOp !== 'input' || selectionBefore.start !== selectionBefore.end || this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
      this._history.push({
        value: valueBefore,
        selection: selectionBefore,
        lastOp: this._lastOp
      });
    }

    this._lastOp = 'input';
    this._lastSelection = copy(this.selection);
    return true;
  };
  /**
   * Attempts to delete from the value based on the current cursor position or
   * selection.
   * @return {boolean} true if the value or selection changed as the result of
   *   backspacing, false otherwise.
   */


  InputMask.prototype.backspace = function backspace() {
    // If the cursor is at the start there's nothing to do
    if (this.selection.start === 0 && this.selection.end === 0) {
      return false;
    }

    var selectionBefore = copy(this.selection);
    var valueBefore = this.getValue(); // No range selected - work on the character preceding the cursor

    if (this.selection.start === this.selection.end) {
      if (this.pattern.isEditableIndex(this.selection.start - 1)) {
        this.value[this.selection.start - 1] = this.placeholderChar;
      }

      this.selection.start--;
      this.selection.end--;
    } // Range selected - delete characters and leave the cursor at the start of the selection
    else {
      var end = this.selection.end - 1;

      while (end >= this.selection.start) {
        if (this.pattern.isEditableIndex(end)) {
          this.value[end] = this.placeholderChar;
        }

        end--;
      }

      this.selection.end = this.selection.start;
    } // History


    if (this._historyIndex != null) {
      // Took more input after undoing, so blow any subsequent history away
      this._history.splice(this._historyIndex, this._history.length - this._historyIndex);
    }

    if (this._lastOp !== 'backspace' || selectionBefore.start !== selectionBefore.end || this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
      this._history.push({
        value: valueBefore,
        selection: selectionBefore,
        lastOp: this._lastOp
      });
    }

    this._lastOp = 'backspace';
    this._lastSelection = copy(this.selection);
    return true;
  };
  /**
   * Attempts to paste a string of input at the current cursor position or over
   * the top of the current selection.
   * Invalid content at any position will cause the paste to be rejected, and it
   * may contain static parts of the mask's pattern.
   * @param {string} input
   * @return {boolean} true if the paste was successful, false otherwise.
   */


  InputMask.prototype.paste = function paste(input) {
    // This is necessary because we're just calling input() with each character
    // and rolling back if any were invalid, rather than checking up-front.
    var initialState = {
      value: this.value.slice(),
      selection: copy(this.selection),
      _lastOp: this._lastOp,
      _history: this._history.slice(),
      _historyIndex: this._historyIndex,
      _lastSelection: copy(this._lastSelection)
    }; // If there are static characters at the start of the pattern and the cursor
    // or selection is within them, the static characters must match for a valid
    // paste.

    if (this.selection.start < this.pattern.firstEditableIndex) {
      for (var i = 0, l = this.pattern.firstEditableIndex - this.selection.start; i < l; i++) {
        if (input.charAt(i) !== this.pattern.pattern[i]) {
          return false;
        }
      } // Continue as if the selection and input started from the editable part of
      // the pattern.


      input = input.substring(this.pattern.firstEditableIndex - this.selection.start);
      this.selection.start = this.pattern.firstEditableIndex;
    }

    for (i = 0, l = input.length; i < l && this.selection.start <= this.pattern.lastEditableIndex; i++) {
      var valid = this.input(input.charAt(i)); // Allow static parts of the pattern to appear in pasted input - they will
      // already have been stepped over by input(), so verify that the value
      // deemed invalid by input() was the expected static character.

      if (!valid) {
        if (this.selection.start > 0) {
          // XXX This only allows for one static character to be skipped
          var patternIndex = this.selection.start - 1;

          if (!this.pattern.isEditableIndex(patternIndex) && input.charAt(i) === this.pattern.pattern[patternIndex]) {
            continue;
          }
        }

        extend$1(this, initialState);
        return false;
      }
    }

    return true;
  }; // History


  InputMask.prototype.undo = function undo() {
    // If there is no history, or nothing more on the history stack, we can't undo
    if (this._history.length === 0 || this._historyIndex === 0) {
      return false;
    }

    var historyItem;

    if (this._historyIndex == null) {
      // Not currently undoing, set up the initial history index
      this._historyIndex = this._history.length - 1;
      historyItem = this._history[this._historyIndex]; // Add a new history entry if anything has changed since the last one, so we
      // can redo back to the initial state we started undoing from.

      var value = this.getValue();

      if (historyItem.value !== value || historyItem.selection.start !== this.selection.start || historyItem.selection.end !== this.selection.end) {
        this._history.push({
          value: value,
          selection: copy(this.selection),
          lastOp: this._lastOp,
          startUndo: true
        });
      }
    } else {
      historyItem = this._history[--this._historyIndex];
    }

    this.value = historyItem.value.split('');
    this.selection = historyItem.selection;
    this._lastOp = historyItem.lastOp;
    return true;
  };

  InputMask.prototype.redo = function redo() {
    if (this._history.length === 0 || this._historyIndex == null) {
      return false;
    }

    var historyItem = this._history[++this._historyIndex]; // If this is the last history item, we're done redoing

    if (this._historyIndex === this._history.length - 1) {
      this._historyIndex = null; // If the last history item was only added to start undoing, remove it

      if (historyItem.startUndo) {
        this._history.pop();
      }
    }

    this.value = historyItem.value.split('');
    this.selection = historyItem.selection;
    this._lastOp = historyItem.lastOp;
    return true;
  }; // Getters & setters


  InputMask.prototype.setPattern = function setPattern(pattern, options) {
    options = extend$1({
      selection: {
        start: 0,
        end: 0
      },
      value: ''
    }, options);
    this.pattern = new Pattern(pattern, this.formatCharacters, this.placeholderChar, options.isRevealingMask);
    this.setValue(options.value);
    this.emptyValue = this.pattern.formatValue([]).join('');
    this.selection = options.selection;

    this._resetHistory();
  };

  InputMask.prototype.setSelection = function setSelection(selection) {
    this.selection = copy(selection);

    if (this.selection.start === this.selection.end) {
      if (this.selection.start < this.pattern.firstEditableIndex) {
        this.selection.start = this.selection.end = this.pattern.firstEditableIndex;
        return true;
      } // Set selection to the first editable, non-placeholder character before the selection
      // OR to the beginning of the pattern


      var index = this.selection.start;

      while (index >= this.pattern.firstEditableIndex) {
        if (this.pattern.isEditableIndex(index - 1) && this.value[index - 1] !== this.placeholderChar || index === this.pattern.firstEditableIndex) {
          this.selection.start = this.selection.end = index;
          break;
        }

        index--;
      }

      return true;
    }

    return false;
  };

  InputMask.prototype.setValue = function setValue(value) {
    if (value == null) {
      value = '';
    }

    this.value = this.pattern.formatValue(value.split(''));
  };

  InputMask.prototype.getValue = function getValue() {
    return this.value.join('');
  };

  InputMask.prototype.getRawValue = function getRawValue() {
    var rawValue = [];

    for (var i = 0; i < this.value.length; i++) {
      if (this.pattern._editableIndices[i] === true) {
        rawValue.push(this.value[i]);
      }
    }

    return rawValue.join('');
  };

  InputMask.prototype._resetHistory = function _resetHistory() {
    this._history = [];
    this._historyIndex = null;
    this._lastOp = null;
    this._lastSelection = copy(this.selection);
  };

  InputMask.Pattern = Pattern;
  var lib = InputMask;

  // Copy paste from https://gist.github.com/nuxodin/9250e56a3ce6c0446efa
  function ffpoly () {
    var w = window,
        d = w.document;

    if (w.onfocusin === undefined) {
      d.addEventListener('focus', addPolyfill, true);
      d.addEventListener('blur', addPolyfill, true);
      d.addEventListener('focusin', removePolyfill, true);
      d.addEventListener('focusout', removePolyfill, true);
    }

    function addPolyfill(e) {
      var type = e.type === 'focus' ? 'focusin' : 'focusout';
      var event = new CustomEvent(type, {
        bubbles: true,
        cancelable: false
      });
      event.c1Generated = true;
      e.target.dispatchEvent(event);
    }

    function removePolyfill(e) {
      if (!e.c1Generated) {
        // focus after focusin, so chrome will the first time trigger tow times focusin
        d.removeEventListener('focus', addPolyfill, true);
        d.removeEventListener('blur', addPolyfill, true);
        d.removeEventListener('focusin', removePolyfill, true);
        d.removeEventListener('focusout', removePolyfill, true);
      }

      setTimeout(function () {
        d.removeEventListener('focusin', removePolyfill, true);
        d.removeEventListener('focusout', removePolyfill, true);
      });
    }
  }

  function _toConsumableArray$1(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  ffpoly();
  var MaskedInput = {
    name: 'MaskedInput',
    render: function render(h) {
      return h('input', {
        ref: 'input',
        attrs: {
          disabled: this.maskCore === null || this.disabled
        },
        domProps: {
          value: this.value
        },
        on: {
          keydown: this.keyDown,
          keypress: this.keyPress,
          keyup: this.keyUp,
          textInput: this.textInput,
          mouseup: this.mouseUp,
          focusout: this.focusOut,
          cut: this.cut,
          copy: this.copy,
          paste: this.paste
        }
      });
    },
    data: function data() {
      return {
        marginLeft: 0,
        maskCore: null,
        updateAfterAll: false
      };
    },
    props: {
      value: {
        type: String
      },
      mask: {
        required: true,
        validator: function validator(value) {
          return !!(value && value.length >= 1 || value instanceof Object);
        }
      },
      placeholderChar: {
        type: String,
        default: '_',
        validator: function validator(value) {
          return !!(value && value.length === 1);
        }
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      mask: function mask(newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.initMask();
        }
      },
      value: function value(newValue) {
        if (this.maskCore) this.maskCore.setValue(newValue); // For multiple inputs support
      }
    },
    mounted: function mounted() {
      this.initMask();
    },
    methods: {
      initMask: function initMask() {
        var _this = this;

        try {
          if (this.mask instanceof Object) {
            this.maskCore = new lib(this.mask);
          } else {
            this.maskCore = new lib({
              pattern: this.mask,
              value: '',
              placeholderChar: this.placeholderChar,

              /* eslint-disable quote-props */
              formatCharacters: {
                'a': {
                  validate: function validate(char) {
                    return /^[A-Za-zА-Яа-я]$/.test(char);
                  }
                },
                'A': {
                  validate: function validate(char) {
                    return /^[A-Za-zА-Яа-я]$/.test(char);
                  },
                  transform: function transform(char) {
                    return char.toUpperCase();
                  }
                },
                '*': {
                  validate: function validate(char) {
                    return /^[\dA-Za-zА-Яа-я]$/.test(char);
                  }
                },
                '#': {
                  validate: function validate(char) {
                    return /^[\dA-Za-zА-Яа-я]$/.test(char);
                  },
                  transform: function transform(char) {
                    return char.toUpperCase();
                  }
                },
                '+': {
                  validate: function validate() {
                    return true;
                  }
                }
              }
            });
          }

          [].concat(_toConsumableArray$1(this.$refs.input.value)).reduce(function (memo, item) {
            return _this.maskCore.input(item);
          }, null);
          this.maskCore.setSelection({
            start: 0,
            end: 0
          });

          if (this.$refs.input.value === '') {
            this.$emit('input', '', '');
          } else {
            this.updateToCoreState();
          }
        } catch (e) {
          this.maskCore = null;
          this.$refs.input.value = 'Error';
          this.$emit('input', this.$refs.input.value, '');
        }
      },
      getValue: function getValue() {
        return this.maskCore ? this.maskCore.getValue() : '';
      },
      keyDown: function keyDown(e) {
        // Always
        if (this.maskCore === null) {
          e.preventDefault();
          return;
        }

        this.setNativeSelection();

        switch (e.keyCode) {
          // backspace
          case 8:
            e.preventDefault();

            if (this.maskCore.selection.start > this.marginLeft || this.maskCore.selection.start !== this.maskCore.selection.end) {
              this.maskCore.backspace();
              this.updateToCoreState();
            }

            break;
          // left arrow

          case 37:
            e.preventDefault();

            if (this.$refs.input.selectionStart === this.$refs.input.selectionEnd) {
              // this.$refs.input.selectionEnd = this.$refs.input.selectionStart - 1; @TODO
              this.$refs.input.selectionStart -= 1;
            }

            this.maskCore.selection = {
              start: this.$refs.input.selectionStart,
              end: this.$refs.input.selectionStart
            };
            this.updateToCoreState();
            break;
          // right arrow

          case 39:
            e.preventDefault();

            if (this.$refs.input.selectionStart === this.$refs.input.selectionEnd) {
              this.$refs.input.selectionEnd += 1;
            }

            this.maskCore.selection = {
              start: this.$refs.input.selectionEnd,
              end: this.$refs.input.selectionEnd
            };
            this.updateToCoreState();
            break;
          // end

          case 35:
            e.preventDefault();
            this.$refs.input.selectionStart = this.$refs.input.value.length;
            this.$refs.input.selectionEnd = this.$refs.input.value.length;
            this.maskCore.selection = {
              start: this.$refs.input.selectionEnd,
              end: this.$refs.input.selectionEnd
            };
            this.updateToCoreState();
            break;
          // home

          case 36:
            e.preventDefault();
            this.$refs.input.selectionStart = 0;
            this.$refs.input.selectionEnd = 0;
            this.maskCore.selection = {
              start: this.$refs.input.selectionStart,
              end: this.$refs.input.selectionStart
            };
            this.updateToCoreState();
            break;
          // delete

          case 46:
            e.preventDefault();

            if (this.$refs.input.selectionStart === this.$refs.input.selectionEnd) {
              this.maskCore.setValue('');
              this.maskCore.setSelection({
                start: 0,
                end: 0
              });
              this.$refs.input.selectionStart = this.maskCore.selection.start;
              this.$refs.input.selectionEnd = this.maskCore.selection.start;
            } else {
              this.maskCore.backspace();
            }

            this.updateToCoreState();
            break;
        }
      },
      keyPress: function keyPress(e) {
        // works only on Desktop
        if (e.ctrlKey) return; // Fix FF copy/paste issue
        // IE & FF are not trigger textInput event, so we have to force it

        /* eslint-disable */

        var isIE =
        /*@cc_on!@*/
         !!document.documentMode; //by http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

        /* eslint-enable */

        var isFirefox = typeof InstallTrigger !== 'undefined';

        if (isIE || isFirefox) {
          e.preventDefault();
          e.data = e.key;
          this.textInput(e);
        }
      },
      textInput: function textInput(e) {
        if (e.preventDefault) e.preventDefault();

        if (this.maskCore.input(e.data)) {
          this.updateAfterAll = true;
        }

        this.updateToCoreState();
      },
      keyUp: function keyUp(e) {
        if (e.keyCode === 9) {
          // Preven change selection for Tab in
          return;
        }

        this.updateToCoreState();
        this.updateAfterAll = false;
      },
      cut: function cut(e) {
        e.preventDefault();

        if (this.$refs.input.selectionStart !== this.$refs.input.selectionEnd) {
          try {
            document.execCommand('copy');
          } catch (err) {} // eslint-disable-line no-empty


          this.maskCore.backspace();
          this.updateToCoreState();
        }
      },
      copy: function copy() {},
      paste: function paste(e) {
        var _this2 = this;

        e.preventDefault();
        var text = e.clipboardData.getData('text');
        [].concat(_toConsumableArray$1(text)).reduce(function (memo, item) {
          return _this2.maskCore.input(item);
        }, null);
        this.updateToCoreState();
      },
      updateToCoreState: function updateToCoreState() {
        if (this.maskCore === null) {
          return;
        }

        if (this.$refs.input.value !== this.maskCore.getValue()) {
          this.$refs.input.value = this.maskCore.getValue();
          this.$emit('input', this.$refs.input.value, this.maskCore.getRawValue());
        }

        this.$refs.input.selectionStart = this.maskCore.selection.start;
        this.$refs.input.selectionEnd = this.maskCore.selection.end;
      },
      isEmpty: function isEmpty() {
        if (this.maskCore === null) return true;
        return this.maskCore.getValue() === this.maskCore.emptyValue;
      },
      focusOut: function focusOut() {
        if (this.isEmpty()) {
          this.$refs.input.value = '';
          this.maskCore.setSelection({
            start: 0,
            end: 0
          });
          this.$emit('input', '', '');
        }
      },
      setNativeSelection: function setNativeSelection() {
        this.maskCore.selection = {
          start: this.$refs.input.selectionStart,
          end: this.$refs.input.selectionEnd
        };
      },
      mouseUp: function mouseUp() {
        if (this.isEmpty() && this.$refs.input.selectionStart === this.$refs.input.selectionEnd) {
          this.maskCore.setSelection({
            start: 0,
            end: 0
          });
          this.$refs.input.selectionStart = this.maskCore.selection.start;
          this.$refs.input.selectionEnd = this.maskCore.selection.start;
          this.marginLeft = this.maskCore.selection.start;
          this.updateToCoreState();
        } else {
          this.setNativeSelection();
        }
      }
    }
  };

  /**
   * SSR Window 2.0.0
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2020, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: May 12, 2020
   */

  /* eslint-disable no-param-reassign */
  function isObject$2(obj) {
    return obj !== null && _typeof(obj) === 'object' && 'constructor' in obj && obj.constructor === Object;
  }

  function extend$2(target, src) {
    if (target === void 0) {
      target = {};
    }

    if (src === void 0) {
      src = {};
    }

    Object.keys(src).forEach(function (key) {
      if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
        extend$2(target[key], src[key]);
      }
    });
  }

  var doc = typeof document !== 'undefined' ? document : {};
  var ssrDocument = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ''
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS: function createElementNS() {
      return {};
    },
    importNode: function importNode() {
      return null;
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    }
  };
  extend$2(doc, ssrDocument);
  var win = typeof window !== 'undefined' ? window : {};
  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ''
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    },
    history: {
      replaceState: function replaceState() {},
      pushState: function pushState() {},
      go: function go() {},
      back: function back() {}
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
      return {};
    }
  };
  extend$2(win, ssrWindow);

  var Dom7 = /*#__PURE__*/_createClass(function Dom7(arr) {
    _classCallCheck(this, Dom7);

    var self = this; // Create array-like object

    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }

    self.length = arr.length; // Return collection with methods

    return this;
  });

  function $(selector, context) {
    var arr = [];
    var i = 0;

    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }

    if (selector) {
      // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;

        var _html = selector.trim();

        if (_html.indexOf('<') >= 0 && _html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (_html.indexOf('<li') === 0) toCreate = 'ul';
          if (_html.indexOf('<tr') === 0) toCreate = 'tbody';
          if (_html.indexOf('<td') === 0 || _html.indexOf('<th') === 0) toCreate = 'tr';
          if (_html.indexOf('<tbody') === 0) toCreate = 'table';
          if (_html.indexOf('<option') === 0) toCreate = 'select';
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = _html;

          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }

          for (i = 0; i < els.length; i += 1) {
            if (els[i]) arr.push(els[i]);
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }

    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique$1(arr) {
    var uniqueArray = [];

    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    }

    return uniqueArray;
  }


  function addClass$1(className) {
    if (typeof className === 'undefined') {
      return this;
    }

    var classes = className.split(' ');

    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
      }
    }

    return this;
  }

  function removeClass$1(className) {
    var classes = className.split(' ');

    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
      }
    }

    return this;
  }

  function hasClass(className) {
    if (!this[0]) return false;
    return this[0].classList.contains(className);
  }

  function toggleClass(className) {
    var classes = className.split(' ');

    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
      }
    }

    return this;
  }

  function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) return this[0].getAttribute(attrs);
      return undefined;
    } // Set attrs


    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }

    return this;
  } // eslint-disable-next-line


  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }

    return this;
  } // eslint-disable-next-line

  function data$1(key, value) {
    var el;

    if (typeof value === 'undefined') {
      el = this[0]; // Get value

      if (el) {
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute("data-".concat(key));

        if (dataKey) {
          return dataKey;
        }

        return undefined;
      }

      return undefined;
    } // Set value


    for (var i = 0; i < this.length; i += 1) {
      el = this[i];
      if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
      el.dom7ElementDataStorage[key] = value;
    }

    return this;
  }
  // eslint-disable-next-line


  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }

    return this;
  }

  function transition$1(duration) {
    if (typeof duration !== 'string') {
      duration = "".concat(duration, "ms"); // eslint-disable-line
    }

    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }

    return this;
  } // Events


  function on$1() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var eventType = args[0],
        targetSelector = args[1],
        listener = args[2],
        capture = args[3];

    if (typeof args[1] === 'function') {
      eventType = args[0];
      listener = args[1];
      capture = args[2];
      targetSelector = undefined;
    }

    if (!capture) capture = false;

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) return;
      var eventData = e.target.dom7EventData || [];

      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }

      if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
        var _parents = $(target).parents(); // eslint-disable-line


        for (var k = 0; k < _parents.length; k += 1) {
          if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
        }
      }
    }

    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];

      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }

      listener.apply(this, eventData);
    }

    var events = eventType.split(' ');
    var j;

    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];

      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) el.dom7Listeners = {};
          if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var _event = events[j];
          if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
          if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

          el.dom7LiveListeners[_event].push({
            listener: listener,
            proxyListener: handleLiveEvent
          });

          el.addEventListener(_event, handleLiveEvent, capture);
        }
      }
    }

    return this;
  }

  function off() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var eventType = args[0],
        targetSelector = args[1],
        listener = args[2],
        capture = args[3];

    if (typeof args[1] === 'function') {
      eventType = args[0];
      listener = args[1];
      capture = args[2];
      targetSelector = undefined;
    }

    if (!capture) capture = false;
    var events = eventType.split(' ');

    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];

      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = void 0;

        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }

        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];

            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }

    return this;
  }

  function trigger$1() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    var events = args[0].split(' ');
    var eventData = args[1];

    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];

      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var evt = void 0;

        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        } // eslint-disable-next-line


        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }

    return this;
  }

  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;

    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) return;
      callback.call(this, e);

      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }

    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }

    return this;
  }

  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var _styles = this.styles();

        return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
      }

      return this[0].offsetWidth;
    }

    return null;
  }

  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var _styles2 = this.styles();

        return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
      }

      return this[0].offsetHeight;
    }

    return null;
  }

  function offset$2() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;

      var _scrollTop = el === win ? win.scrollY : el.scrollTop;

      var _scrollLeft = el === win ? win.scrollX : el.scrollLeft;

      return {
        top: box.top + _scrollTop - clientTop,
        left: box.left + _scrollLeft - clientLeft
      };
    }

    return null;
  }

  function styles() {
    if (this[0]) return win.getComputedStyle(this[0], null);
    return {};
  }

  function css(props, value) {
    var i;

    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) return win.getComputedStyle(this[0], null).getPropertyValue(props);
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var _prop in props) {
            this[i].style[_prop] = props[_prop];
          }
        }

        return this;
      }
    }

    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }

      return this;
    }

    return this;
  } // Dom manipulation


  function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) return this; // Iterate over the current collection

    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this[i], i, this[i]) === false) {
        // End the loop early
        return this;
      }
    } // Return `this` to allow chained DOM operations


    return this;
  }

  function filter(callback) {
    var matchedItems = [];
    var dom = this;

    for (var i = 0; i < dom.length; i += 1) {
      if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
    }

    return new Dom7(matchedItems);
  }


  function html$1(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }

    return this;
  } // eslint-disable-next-line


  function text$1(text) {
    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }

      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }

    return this;
  }

  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') return false;

    if (typeof selector === 'string') {
      if (el.matches) return el.matches(selector);else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
      compareWith = $(selector);

      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) return true;
      }

      return false;
    } else if (selector === doc) return el === doc;else if (selector === win) return el === win;

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;

      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) return true;
      }

      return false;
    }

    return false;
  }

  function index$3() {
    var child = this[0];
    var i;

    if (child) {
      i = 0; // eslint-disable-next-line

      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) i += 1;
      }

      return i;
    }

    return undefined;
  } // eslint-disable-next-line


  function eq(index) {
    if (typeof index === 'undefined') return this;
    var length = this.length;
    var returnIndex;

    if (index > length - 1) {
      return new Dom7([]);
    }

    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) return new Dom7([]);
      return new Dom7([this[returnIndex]]);
    }

    return new Dom7([this[index]]);
  }

  function append() {
    var newChild;

    for (var k = 0; k < arguments.length; k += 1) {
      newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;

          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  } // eslint-disable-next-line

  function prepend(newChild) {
    var i;
    var j;

    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;

        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }

    return this;
  } // eslint-disable-next-line

  function next$1(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }

        return new Dom7([]);
      }

      if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
      return new Dom7([]);
    }

    return new Dom7([]);
  }

  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) return new Dom7([]);

    while (el.nextElementSibling) {
      var _next = el.nextElementSibling; // eslint-disable-line

      if (selector) {
        if ($(_next).is(selector)) nextEls.push(_next);
      } else nextEls.push(_next);

      el = _next;
    }

    return new Dom7(nextEls);
  }

  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];

      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }

        return new Dom7([]);
      }

      if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
      return new Dom7([]);
    }

    return new Dom7([]);
  }

  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) return new Dom7([]);

    while (el.previousElementSibling) {
      var _prev = el.previousElementSibling; // eslint-disable-line

      if (selector) {
        if ($(_prev).is(selector)) prevEls.push(_prev);
      } else prevEls.push(_prev);

      el = _prev;
    }

    return new Dom7(prevEls);
  }

  function parent(selector) {
    var parents = []; // eslint-disable-line

    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }

    return $(unique$1(parents));
  }

  function parents(selector) {
    var parents = []; // eslint-disable-line

    for (var i = 0; i < this.length; i += 1) {
      var _parent = this[i].parentNode; // eslint-disable-line

      while (_parent) {
        if (selector) {
          if ($(_parent).is(selector)) parents.push(_parent);
        } else {
          parents.push(_parent);
        }

        _parent = _parent.parentNode;
      }
    }

    return $(unique$1(parents));
  }

  function closest(selector) {
    var closest = this; // eslint-disable-line

    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }

    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }

    return closest;
  }

  function find$1(selector) {
    var foundElements = [];

    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);

      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }

    return new Dom7(foundElements);
  }

  function children(selector) {
    var children = []; // eslint-disable-line

    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }

    return new Dom7(unique$1(children));
  }

  function remove$3() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    }

    return this;
  }

  function add$2() {
    var dom = this;
    var i;
    var j;

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);

      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }

    return dom;
  }

  var Methods = {
    addClass: addClass$1,
    removeClass: removeClass$1,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data$1,
    transform: transform,
    transition: transition$1,
    on: on$1,
    off: off,
    trigger: trigger$1,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset$2,
    css: css,
    each: each,
    html: html$1,
    text: text$1,
    is: is,
    index: index$3,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next$1,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find$1,
    children: children,
    filter: filter,
    remove: remove$3,
    add: add$2,
    styles: styles
  };
  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  });
  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {// no getter for object
        }

        try {
          delete object[key];
        } catch (e) {// something got wrong
        }
      });
    },
    nextTick: function nextTick(callback) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el) {
      var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
      var matrix;
      var curTransform;
      var transformMatrix;
      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;

        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) {
            return a.replace(',', '.');
          }).join(', ');
        } // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case


        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
      }

      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
      }

      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;

      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) {
          return paramsPart !== '';
        });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }

      return query;
    },
    isObject: function isObject(o) {
      return _typeof(o) === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var to = Object(arguments.length <= 0 ? undefined : arguments[0]);

      for (var i = 1; i < arguments.length; i += 1) {
        var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));

          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }

      return to;
    }
  };

  var Support = function Support() {
    return {
      touch: !!('ontouchstart' in win || win.DocumentTouch && doc instanceof win.DocumentTouch),
      pointerEvents: !!win.PointerEvent && 'maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints >= 0,
      observer: function checkObserver() {
        return 'MutationObserver' in win || 'WebkitMutationObserver' in win;
      }(),
      passiveListener: function checkPassiveListener() {
        var supportsPassive = false;

        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            }
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {// No support
        }

        return supportsPassive;
      }(),
      gestures: function checkGestures() {
        return 'ongesturestart' in win;
      }()
    };
  }();

  var SwiperClass = /*#__PURE__*/function () {
    function SwiperClass() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, SwiperClass);

      var self = this;
      self.params = params; // Events

      self.eventsListeners = {};

      if (self.params && self.params.on) {
        Object.keys(self.params.on).forEach(function (eventName) {
          self.on(eventName, self.params.on[eventName]);
        });
      }
    }

    _createClass(SwiperClass, [{
      key: "on",
      value: function on(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(function (event) {
          if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
          self.eventsListeners[event][method](handler);
        });
        return self;
      }
    }, {
      key: "once",
      value: function once(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;

        function onceHandler() {
          self.off(events, onceHandler);

          if (onceHandler.f7proxy) {
            delete onceHandler.f7proxy;
          }

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          handler.apply(self, args);
        }

        onceHandler.f7proxy = handler;
        return self.on(events, onceHandler, priority);
      }
    }, {
      key: "off",
      value: function off(events, handler) {
        var self = this;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(function (event) {
          if (typeof handler === 'undefined') {
            self.eventsListeners[event] = [];
          } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
            self.eventsListeners[event].forEach(function (eventHandler, index) {
              if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) {
                self.eventsListeners[event].splice(index, 1);
              }
            });
          }
        });
        return self;
      }
    }, {
      key: "emit",
      value: function emit() {
        var self = this;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
          events = args[0];
          data = args.slice(1, args.length);
          context = self;
        } else {
          events = args[0].events;
          data = args[0].data;
          context = args[0].context || self;
        }

        var eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(function (event) {
          if (self.eventsListeners && self.eventsListeners[event]) {
            var handlers = [];
            self.eventsListeners[event].forEach(function (eventHandler) {
              handlers.push(eventHandler);
            });
            handlers.forEach(function (eventHandler) {
              eventHandler.apply(context, data);
            });
          }
        });
        return self;
      }
    }, {
      key: "useModulesParams",
      value: function useModulesParams(instanceParams) {
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function (moduleName) {
          var module = instance.modules[moduleName]; // Extend params

          if (module.params) {
            Utils.extend(instanceParams, module.params);
          }
        });
      }
    }, {
      key: "useModules",
      value: function useModules() {
        var modulesParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function (moduleName) {
          var module = instance.modules[moduleName];
          var moduleParams = modulesParams[moduleName] || {}; // Extend instance methods and props

          if (module.instance) {
            Object.keys(module.instance).forEach(function (modulePropName) {
              var moduleProp = module.instance[modulePropName];

              if (typeof moduleProp === 'function') {
                instance[modulePropName] = moduleProp.bind(instance);
              } else {
                instance[modulePropName] = moduleProp;
              }
            });
          } // Add event listeners


          if (module.on && instance.on) {
            Object.keys(module.on).forEach(function (moduleEventName) {
              instance.on(moduleEventName, module.on[moduleEventName]);
            });
          } // Module create callback


          if (module.create) {
            module.create.bind(instance)(moduleParams);
          }
        });
      }
    }], [{
      key: "components",
      set: function set(components) {
        var Class = this;
        if (!Class.use) return;
        Class.use(components);
      }
    }, {
      key: "installModule",
      value: function installModule(module) {
        var Class = this;
        if (!Class.prototype.modules) Class.prototype.modules = {};
        var name = module.name || "".concat(Object.keys(Class.prototype.modules).length, "_").concat(Utils.now());
        Class.prototype.modules[name] = module; // Prototype

        if (module.proto) {
          Object.keys(module.proto).forEach(function (key) {
            Class.prototype[key] = module.proto[key];
          });
        } // Class


        if (module.static) {
          Object.keys(module.static).forEach(function (key) {
            Class[key] = module.static[key];
          });
        } // Callback


        if (module.install) {
          for (var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            params[_key3 - 1] = arguments[_key3];
          }

          module.install.apply(Class, params);
        }

        return Class;
      }
    }, {
      key: "use",
      value: function use(module) {
        var Class = this;

        if (Array.isArray(module)) {
          module.forEach(function (m) {
            return Class.installModule(m);
          });
          return Class;
        }

        for (var _len4 = arguments.length, params = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          params[_key4 - 1] = arguments[_key4];
        }

        return Class.installModule.apply(Class, [module].concat(params));
      }
    }]);

    return SwiperClass;
  }();

  function updateSize() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;

    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }

    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }

    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
      return;
    } // Subtract paddings


    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height
    });
  }

  function updateSlides() {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl,
        swiperSize = swiper.size,
        rtl = swiper.rtlTranslate,
        wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(".".concat(swiper.params.slideClass));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    function slidesForMargin(slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }

    var offsetBefore = params.slidesOffsetBefore;

    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;

    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;

    if (typeof swiperSize === 'undefined') {
      return;
    }

    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    }

    swiper.virtualSize = -spaceBetween; // reset margins

    if (rtl) slides.css({
      marginLeft: '',
      marginTop: ''
    });else slides.css({
      marginRight: '',
      marginBottom: ''
    });
    var slidesNumberEvenToRows;

    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }

      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    } // Calc slides


    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;

      var _slide = slides.eq(i);

      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = void 0;
        var column = void 0;
        var row = void 0;

        if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
          var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
          var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
          var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
          row = Math.floor(slideIndexInGroup / columnsInGroup);
          column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
          newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;

          _slide.css({
            '-webkit-box-ordinal-group': newSlideOrderIndex,
            '-moz-box-ordinal-group': newSlideOrderIndex,
            '-ms-flex-order': newSlideOrderIndex,
            '-webkit-order': newSlideOrderIndex,
            order: newSlideOrderIndex
          });
        } else if (params.slidesPerColumnFill === 'column') {
          column = Math.floor(i / slidesPerColumn);
          row = i - column * slidesPerColumn;

          if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
            row += 1;

            if (row >= slidesPerColumn) {
              row = 0;
              column += 1;
            }
          }
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - row * slidesPerRow;
        }

        _slide.css("margin-".concat(swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && "".concat(params.spaceBetween, "px"));
      }

      if (_slide.css('display') === 'none') continue; // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(_slide[0], null);
        var currentTransform = _slide[0].style.transform;
        var currentWebKitTransform = _slide[0].style.webkitTransform;

        if (currentTransform) {
          _slide[0].style.transform = 'none';
        }

        if (currentWebKitTransform) {
          _slide[0].style.webkitTransform = 'none';
        }

        if (params.roundLengths) {
          slideSize = swiper.isHorizontal() ? _slide.outerWidth(true) : _slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width'));
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
            var boxSizing = slideStyles.getPropertyValue('box-sizing');

            if (boxSizing && boxSizing === 'border-box') {
              slideSize = width + marginLeft + marginRight;
            } else {
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height'));
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));

            var _boxSizing = slideStyles.getPropertyValue('box-sizing');

            if (_boxSizing && _boxSizing === 'border-box') {
              slideSize = height + marginTop + marginBottom;
            } else {
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
          }
        }

        if (currentTransform) {
          _slide[0].style.transform = currentTransform;
        }

        if (currentWebKitTransform) {
          _slide[0].style.webkitTransform = currentWebKitTransform;
        }

        if (params.roundLengths) slideSize = Math.floor(slideSize);
      } else {
        slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
        if (params.roundLengths) slideSize = Math.floor(slideSize);

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = "".concat(slideSize, "px");
          } else {
            slides[i].style.height = "".concat(slideSize, "px");
          }
        }
      }

      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }

      slidesSizesGrid.push(slideSize);

      if (params.centeredSlides) {
        slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;
      prevSlideSize = slideSize;
      index += 1;
    }

    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({
        width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
      });
    }

    if (params.setWrapperSize) {
      if (swiper.isHorizontal()) $wrapperEl.css({
        width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
      });else $wrapperEl.css({
        height: "".concat(swiper.virtualSize + params.spaceBetween, "px")
      });
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) $wrapperEl.css({
        width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
      });else $wrapperEl.css({
        height: "".concat(swiper.virtualSize + params.spaceBetween, "px")
      });

      if (params.centeredSlides) {
        newSlidesGrid = [];

        for (var _i = 0; _i < snapGrid.length; _i += 1) {
          var slidesGridItem = snapGrid[_i];
          if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
          if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
        }

        snapGrid = newSlidesGrid;
      }
    } // Remove last grid elements depending on width


    if (!params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
        var _slidesGridItem = snapGrid[_i2];
        if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

        if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(_slidesGridItem);
        }
      }

      snapGrid = newSlidesGrid;

      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }

    if (snapGrid.length === 0) snapGrid = [0];

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) slides.filter(slidesForMargin).css({
          marginLeft: "".concat(spaceBetween, "px")
        });else slides.filter(slidesForMargin).css({
          marginRight: "".concat(spaceBetween, "px")
        });
      } else slides.filter(slidesForMargin).css({
        marginBottom: "".concat(spaceBetween, "px")
      });
    }

    if (params.centeredSlides && params.centeredSlidesBounds) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      var maxSnap = allSlidesSize - swiperSize;
      snapGrid = snapGrid.map(function (snap) {
        if (snap < 0) return -offsetBefore;
        if (snap > maxSnap) return maxSnap + offsetAfter;
        return snap;
      });
    }

    if (params.centerInsufficientSlides) {
      var _allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      _allSlidesSize -= params.spaceBetween;

      if (_allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }

    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) swiper.checkOverflow();
      swiper.emit('snapGridLengthChange');
    }

    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;

    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    } // Find slides currently in view


    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      if (swiper.params.centeredSlides) {
        swiper.visibleSlides.each(function (index, slide) {
          activeSlides.push(slide);
        });
      } else {
        for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
          var _index = swiper.activeIndex + i;

          if (_index > swiper.slides.length) break;
          activeSlides.push(swiper.slides.eq(_index)[0]);
        }
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    } // Find new height from highest slide in view


    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    } // Update Height


    if (newHeight) swiper.$wrapperEl.css('height', "".concat(newHeight, "px"));
  }

  function updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress() {
    var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides,
        rtl = swiper.rtlTranslate;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides

    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var _slide2 = slides[i];
      var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - _slide2.swiperSlideOffset) / (_slide2.swiperSlideSize + params.spaceBetween);

      if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
        var slideBefore = -(offsetCenter - _slide2.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

        if (isVisible) {
          swiper.visibleSlides.push(_slide2);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }

      _slide2.progress = rtl ? -slideProgress : slideProgress;
    }

    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress(translate) {
    var swiper = this;

    if (typeof translate === 'undefined') {
      var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

      translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }

    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress,
        isBeginning = swiper.isBeginning,
        isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;

    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / translatesDiff;
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }

    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }

    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }

    if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides,
        params = swiper.params,
        $wrapperEl = swiper.$wrapperEl,
        activeIndex = swiper.activeIndex,
        realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass("".concat(params.slideActiveClass, " ").concat(params.slideNextClass, " ").concat(params.slidePrevClass, " ").concat(params.slideDuplicateActiveClass, " ").concat(params.slideDuplicateNextClass, " ").concat(params.slideDuplicatePrevClass));
    var activeSlide;

    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(activeIndex, "\"]"));
    } else {
      activeSlide = slides.eq(activeIndex);
    } // Active classes


    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
      }
    } // Next Slide


    var nextSlide = activeSlide.nextAll(".".concat(params.slideClass)).eq(0).addClass(params.slideNextClass);

    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    } // Prev Slide


    var prevSlide = activeSlide.prevAll(".".concat(params.slideClass)).eq(0).addClass(params.slidePrevClass);

    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }

    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
      }

      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid,
        snapGrid = swiper.snapGrid,
        params = swiper.params,
        previousIndex = swiper.activeIndex,
        previousRealIndex = swiper.realIndex,
        previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;

    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      } // Normalize slideIndex


      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
      }
    }

    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
      snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }

    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }

      return;
    } // Get real index


    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');

    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }

    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(".".concat(params.slideClass))[0];
    var slideFound = false;

    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) slideFound = true;
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;

      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }

    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update$1 = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide
  };

  function getTranslate() {
    var axis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.isHorizontal() ? 'x' : 'y';
    var swiper = this;
    var params = swiper.params,
        rtl = swiper.rtlTranslate,
        translate = swiper.translate,
        $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }

    if (params.cssMode) {
      return translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
  }

  function setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate,
        params = swiper.params,
        $wrapperEl = swiper.$wrapperEl,
        wrapperEl = swiper.wrapperEl,
        progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (params.cssMode) {
      wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    } else if (!params.virtualTranslate) {
      $wrapperEl.transform("translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)"));
    }

    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    }

    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate() {
    return -this.snapGrid[0];
  }

  function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }

  function translateTo() {
    var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
    var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var translateBounds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var internal = arguments.length > 4 ? arguments[4] : undefined;
    var swiper = this;
    var params = swiper.params,
        wrapperEl = swiper.wrapperEl;

    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

    swiper.updateProgress(newTranslate);

    if (params.cssMode) {
      var isH = swiper.isHorizontal();

      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          var _wrapperEl$scrollTo;

          wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _defineProperty(_wrapperEl$scrollTo, isH ? 'left' : 'top', -newTranslate), _defineProperty(_wrapperEl$scrollTo, "behavior", 'smooth'), _wrapperEl$scrollTo));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        }
      }

      return true;
    }

    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(newTranslate);

      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionEnd');
      }
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(newTranslate);

      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionStart');
      }

      if (!swiper.animating) {
        swiper.animating = true;

        if (!swiper.onTranslateToWrapperTransitionEnd) {
          swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
            swiper.onTranslateToWrapperTransitionEnd = null;
            delete swiper.onTranslateToWrapperTransitionEnd;

            if (runCallbacks) {
              swiper.emit('transitionEnd');
            }
          };
        }

        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
      }
    }

    return true;
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
    translateTo: translateTo
  };

  function setTransition(duration, byController) {
    var swiper = this;

    if (!swiper.params.cssMode) {
      swiper.$wrapperEl.transition(duration);
    }

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var direction = arguments.length > 1 ? arguments[1] : undefined;
    var swiper = this;
    var activeIndex = swiper.activeIndex,
        params = swiper.params,
        previousIndex = swiper.previousIndex;
    if (params.cssMode) return;

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;

    if (!dir) {
      if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }

      swiper.emit('slideChangeTransitionStart');

      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var direction = arguments.length > 1 ? arguments[1] : undefined;
    var swiper = this;
    var activeIndex = swiper.activeIndex,
        previousIndex = swiper.previousIndex,
        params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    var dir = direction;

    if (!dir) {
      if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }

      swiper.emit('slideChangeTransitionEnd');

      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$2 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1
  };

  function slideTo() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
    var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var internal = arguments.length > 3 ? arguments[3] : undefined;
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params,
        snapGrid = swiper.snapGrid,
        slidesGrid = swiper.slidesGrid,
        previousIndex = swiper.previousIndex,
        activeIndex = swiper.activeIndex,
        rtl = swiper.rtlTranslate,
        wrapperEl = swiper.wrapperEl;

    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex]; // Update progress

    swiper.updateProgress(translate); // Normalize slideIndex

    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    } // Directions locks


    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }

      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) return false;
      }
    }

    var direction;
    if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
      swiper.updateActiveIndex(slideIndex); // Update Height

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }

      swiper.updateSlidesClasses();

      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }

      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }

      return false;
    }

    if (params.cssMode) {
      var isH = swiper.isHorizontal();
      var t = -translate;

      if (rtl) {
        t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
      }

      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          var _wrapperEl$scrollTo2;

          wrapperEl.scrollTo((_wrapperEl$scrollTo2 = {}, _defineProperty(_wrapperEl$scrollTo2, isH ? 'left' : 'top', t), _defineProperty(_wrapperEl$scrollTo2, "behavior", 'smooth'), _wrapperEl$scrollTo2));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        }
      }

      return true;
    }

    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);

      if (!swiper.animating) {
        swiper.animating = true;

        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }

        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
    var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var internal = arguments.length > 3 ? arguments[3] : undefined;
    var swiper = this;
    var newIndex = index;

    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }
  /* eslint no-unused-vars: "off" */


  function slideNext() {
    var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
    var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var internal = arguments.length > 2 ? arguments[2] : undefined;
    var swiper = this;
    var params = swiper.params,
        animating = swiper.animating;
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

    if (params.loop) {
      if (animating) return false;
      swiper.loopFix(); // eslint-disable-next-line

      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }

    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
  }
  /* eslint no-unused-vars: "off" */


  function slidePrev() {
    var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
    var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var internal = arguments.length > 2 ? arguments[2] : undefined;
    var swiper = this;
    var params = swiper.params,
        animating = swiper.animating,
        snapGrid = swiper.snapGrid,
        slidesGrid = swiper.slidesGrid,
        rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) return false;
      swiper.loopFix(); // eslint-disable-next-line

      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }

    var translate = rtlTranslate ? swiper.translate : -swiper.translate;

    function normalize(val) {
      if (val < 0) return -Math.floor(Math.abs(val));
      return Math.floor(val);
    }

    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) {
      return normalize(val);
    });
    var normalizedSlidesGrid = slidesGrid.map(function (val) {
      return normalize(val);
    });
    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

    if (typeof prevSnap === 'undefined' && params.cssMode) {
      snapGrid.forEach(function (snap) {
        if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
      });
    }

    var prevIndex;

    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    }

    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }
  /* eslint no-unused-vars: "off" */


  function slideReset() {
    var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
    var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var internal = arguments.length > 2 ? arguments[2] : undefined;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }
  /* eslint no-unused-vars: "off" */


  function slideToClosest() {
    var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
    var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var internal = arguments.length > 2 ? arguments[2] : undefined;
    var threshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

    if (translate >= swiper.snapGrid[snapIndex]) {
      // The current translate is on or after the current snap index, so the choice
      // is between the current index and the one after it.
      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];

      if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
        index += swiper.params.slidesPerGroup;
      }
    } else {
      // The current translate is before the current snap index, so the choice
      // is between the current index and the one before it.
      var prevSnap = swiper.snapGrid[snapIndex - 1];
      var _currentSnap = swiper.snapGrid[snapIndex];

      if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
        index -= swiper.params.slidesPerGroup;
      }
    }

    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide() {
    var swiper = this;
    var params = swiper.params,
        $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;

    if (params.loop) {
      if (swiper.animating) return;
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

      if (params.centeredSlides) {
        if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
          swiper.loopFix();
          slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide
  };

  function loopCreate() {
    var swiper = this;
    var params = swiper.params,
        $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

    $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass)).remove();
    var slides = $wrapperEl.children(".".concat(params.slideClass));

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass("".concat(params.slideClass, " ").concat(params.slideBlankClass));
          $wrapperEl.append(blankNode);
        }

        slides = $wrapperEl.children(".".concat(params.slideClass));
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;

    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) appendSlides.push(el);
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
      slide.attr('data-swiper-slide-index', index);
    });

    for (var _i3 = 0; _i3 < appendSlides.length; _i3 += 1) {
      $wrapperEl.append($(appendSlides[_i3].cloneNode(true)).addClass(params.slideDuplicateClass));
    }

    for (var _i4 = prependSlides.length - 1; _i4 >= 0; _i4 -= 1) {
      $wrapperEl.prepend($(prependSlides[_i4].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix() {
    var swiper = this;
    swiper.emit('beforeLoopFix');
    var activeIndex = swiper.activeIndex,
        slides = swiper.slides,
        loopedSlides = swiper.loopedSlides,
        allowSlidePrev = swiper.allowSlidePrev,
        allowSlideNext = swiper.allowSlideNext,
        snapGrid = swiper.snapGrid,
        rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

    if (activeIndex < loopedSlides) {
      newIndex = slides.length - loopedSlides * 3 + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);

      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if (activeIndex >= slides.length - loopedSlides) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;

      var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

      if (_slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }

    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
  }

  function loopDestroy() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        params = swiper.params,
        slides = swiper.slides;
    $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, ",.").concat(params.slideClass, ".").concat(params.slideBlankClass)).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy
  };

  function setGrabCursor(moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor() {
    var swiper = this;
    if (Support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor
  };

  function appendSlide(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        params = swiper.params;

    if (params.loop) {
      swiper.loopDestroy();
    }

    if (_typeof(slides) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) $wrapperEl.append(slides[i]);
      }
    } else {
      $wrapperEl.append(slides);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide(slides) {
    var swiper = this;
    var params = swiper.params,
        $wrapperEl = swiper.$wrapperEl,
        activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }

    var newActiveIndex = activeIndex + 1;

    if (_typeof(slides) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) $wrapperEl.prepend(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }

    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        params = swiper.params,
        activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;

    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }

    var baseLength = swiper.slides.length;

    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }

    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }

    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];

    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (_typeof(slides) === 'object' && 'length' in slides) {
      for (var _i5 = 0; _i5 < slides.length; _i5 += 1) {
        if (slides[_i5]) $wrapperEl.append(slides[_i5]);
      }

      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var _i6 = 0; _i6 < slidesBuffer.length; _i6 += 1) {
      $wrapperEl.append(slidesBuffer[_i6]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }

    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params,
        $wrapperEl = swiper.$wrapperEl,
        activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;

    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }

    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (_typeof(slidesIndexes) === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
      }

      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }

    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];

    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }

    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides
  };

  var Device = function Device() {
    var platform = win.navigator.platform;
    var ua = win.navigator.userAgent;
    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      iphone: false,
      ipod: false,
      ipad: false,
      edge: false,
      ie: false,
      firefox: false,
      macos: false,
      windows: false,
      cordova: !!(win.cordova || win.phonegap),
      phonegap: !!(win.cordova || win.phonegap),
      electron: false
    };
    var screenWidth = win.screen.width;
    var screenHeight = win.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var ie = ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
    var edge = ua.indexOf('Edge/') >= 0;
    var firefox = ua.indexOf('Gecko/') >= 0 && ua.indexOf('Firefox/') >= 0;
    var windows = platform === 'Win32';
    var electron = ua.toLowerCase().indexOf('electron') >= 0;
    var macos = platform === 'MacIntel'; // iPadOs 13 fix

    if (!ipad && macos && Support.touch && (screenWidth === 1024 && screenHeight === 1366 // Pro 12.9
    || screenWidth === 834 && screenHeight === 1194 // Pro 11
    || screenWidth === 834 && screenHeight === 1112 // Pro 10.5
    || screenWidth === 768 && screenHeight === 1024 // other
    )) {
      ipad = ua.match(/(Version)\/([\d.]+)/);
      macos = false;
    }

    device.ie = ie;
    device.edge = edge;
    device.firefox = firefox; // Android

    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }

    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    } // iOS


    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }

    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }

    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.ipod = true;
    } // iOS 8+ changed UA


    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    } // Webview


    device.webView = !!((iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone)) || win.matchMedia && win.matchMedia('(display-mode: standalone)').matches;
    device.webview = device.webView;
    device.standalone = device.webView; // Desktop

    device.desktop = !(device.ios || device.android) || electron;

    if (device.desktop) {
      device.electron = electron;
      device.macos = macos;
      device.windows = windows;

      if (device.macos) {
        device.os = 'macos';
      }

      if (device.windows) {
        device.os = 'windows';
      }
    } // Pixel Ratio


    device.pixelRatio = win.devicePixelRatio || 1; // Export object

    return device;
  }();

  function onTouchStart(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params,
        touches = swiper.touches;

    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }

    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var $targetEl = $(e.target);

    if (params.touchEventsTarget === 'wrapper') {
      if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }

    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;

    if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass))[0]) {
      swiper.allowClick = true;
      return;
    }

    if (params.swipeHandler) {
      if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= win.screen.width - edgeSwipeThreshold)) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;

    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($targetEl.is(data.formElements)) preventDefault = false;

      if (doc.activeElement && $(doc.activeElement).is(data.formElements) && doc.activeElement !== $targetEl[0]) {
        doc.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }

    swiper.emit('touchStart', e);
  }

  function onTouchMove(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params,
        touches = swiper.touches,
        rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;

    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }

      return;
    }

    if (data.isTouchEvent && e.type !== 'touchmove') return;
    var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }

    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;

      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY
        });
        data.touchStartTime = Utils.now();
      }

      return;
    }

    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
        return;
      }
    }

    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }

    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }

    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;

      if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
          touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
      }
    }

    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }

    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }

    if (!data.startMoving) {
      return;
    }

    swiper.allowClick = false;

    if (!params.cssMode && e.cancelable) {
      e.preventDefault();
    }

    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }

      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);

      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }

      data.allowMomentumBounce = false; // Grab Cursor

      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }

      swiper.emit('sliderFirstMove', e);
    }

    swiper.emit('sliderMove', e);
    data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;

    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }

    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    } // Directions locks


    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }

    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    } // Threshold


    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger || params.cssMode) return; // Update active index in free mode

    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime
        });
      }

      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now()
      });
    } // Update progress


    swiper.updateProgress(data.currentTranslate); // Update translate

    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params,
        touches = swiper.touches,
        rtl = swiper.rtlTranslate,
        $wrapperEl = swiper.$wrapperEl,
        slidesGrid = swiper.slidesGrid,
        snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;

    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }

    data.allowTouchCallbacks = false;

    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }

      data.isMoved = false;
      data.startMoving = false;
      return;
    } // Return Grab Cursor


    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    } // Time diff


    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap click', e);

      if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
        swiper.emit('doubleTap doubleClick', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) swiper.allowClick = true;
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }

    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;

    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.cssMode) {
      return;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }

      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }

        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();
          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;

          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          } // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.


          if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }

        swiper.velocity *= params.freeModeMomentumVelocityRatio;
        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;
        var newPosition = swiper.translate + momentumDistance;
        if (rtl) newPosition = -newPosition;
        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;

        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }

            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }

          if (params.loop && params.centeredSlides) needsLoopFix = true;
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }

            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }

          if (params.loop && params.centeredSlides) needsLoopFix = true;
        } else if (params.freeModeSticky) {
          var nextSlide;

          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }

          newPosition = -newPosition;
        }

        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        } // Fix duration


        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }

          if (params.freeModeSticky) {
            // If freeModeSticky is active and the user ends a swipe with a slow-velocity
            // event, then durations can be 20+ seconds to slide one (or zero!) slides.
            // It's easy to see this when simulating touch with mouse events. To fix this,
            // limit single-slide swipes to the default slide duration. This also has the
            // nice side effect of matching slide speed if the user stopped moving before
            // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
            // For faster swipes, also apply limits (albeit higher ones).
            var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
            var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

            if (moveDistance < currentSlideSize) {
              momentumDuration = params.speed;
            } else if (moveDistance < 2 * currentSlideSize) {
              momentumDuration = params.speed * 1.5;
            } else {
              momentumDuration = params.speed * 2.5;
            }
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
            swiper.emit('momentumBounce');
            swiper.setTransition(params.speed);
            setTimeout(function () {
              swiper.setTranslate(afterBouncePosition);
              $wrapperEl.transitionEnd(function () {
                if (!swiper || swiper.destroyed) return;
                swiper.transitionEnd();
              });
            }, 0);
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);

          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }

      return;
    } // Find current slide


    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];

    for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
      var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

      if (typeof slidesGrid[i + _increment] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
          stopIndex = i;
          groupSize = slidesGrid[i + _increment] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    } // Find current slide size


    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }

      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
      }

      if (swiper.swipeDirection === 'prev') {
        if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }

      var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

      if (!isNavButtonTarget) {
        if (swiper.swipeDirection === 'next') {
          swiper.slideTo(stopIndex + increment);
        }

        if (swiper.swipeDirection === 'prev') {
          swiper.slideTo(stopIndex);
        }
      } else if (e.target === swiper.navigation.nextEl) {
        swiper.slideTo(stopIndex + increment);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize() {
    var swiper = this;
    var params = swiper.params,
        el = swiper.el;
    if (el && el.offsetWidth === 0) return; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    } // Save locks


    var allowSlideNext = swiper.allowSlideNext,
        allowSlidePrev = swiper.allowSlidePrev,
        snapGrid = swiper.snapGrid; // Disable locks on resize

    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();

    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }

    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    } // Return locks after resize


    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick(e) {
    var swiper = this;

    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) e.preventDefault();

      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function onScroll() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl,
        rtlTranslate = swiper.rtlTranslate;
    swiper.previousTranslate = swiper.translate;

    if (swiper.isHorizontal()) {
      if (rtlTranslate) {
        swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
      } else {
        swiper.translate = -wrapperEl.scrollLeft;
      }
    } else {
      swiper.translate = -wrapperEl.scrollTop;
    } // eslint-disable-next-line


    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    }

    if (newProgress !== swiper.progress) {
      swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    }

    swiper.emit('setTranslate', swiper.translate, false);
  }

  var dummyEventAttached = false;

  function dummyEventListener() {}

  function attachEvents() {
    var swiper = this;
    var params = swiper.params,
        touchEvents = swiper.touchEvents,
        el = swiper.el,
        wrapperEl = swiper.wrapperEl;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);

    if (params.cssMode) {
      swiper.onScroll = onScroll.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);
    var capture = !!params.nested; // Touch Events

    if (!Support.touch && Support.pointerEvents) {
      el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
      doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
      doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? {
          passive: false,
          capture: capture
        } : capture);
        el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

        if (touchEvents.cancel) {
          el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }

        if (!dummyEventAttached) {
          doc.addEventListener('touchstart', dummyEventListener);
          dummyEventAttached = true;
        }
      }

      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        el.addEventListener('mousedown', swiper.onTouchStart, false);
        doc.addEventListener('mousemove', swiper.onTouchMove, capture);
        doc.addEventListener('mouseup', swiper.onTouchEnd, false);
      }
    } // Prevent Links Clicks


    if (params.preventClicks || params.preventClicksPropagation) {
      el.addEventListener('click', swiper.onClick, true);
    }

    if (params.cssMode) {
      wrapperEl.addEventListener('scroll', swiper.onScroll);
    } // Resize handler


    if (params.updateOnWindowResize) {
      swiper.on(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
    } else {
      swiper.on('observerUpdate', onResize, true);
    }
  }

  function detachEvents() {
    var swiper = this;
    var params = swiper.params,
        touchEvents = swiper.touchEvents,
        el = swiper.el,
        wrapperEl = swiper.wrapperEl;
    var capture = !!params.nested; // Touch Events

    if (!Support.touch && Support.pointerEvents) {
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
      doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

        if (touchEvents.cancel) {
          el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
      }

      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        el.removeEventListener('mousedown', swiper.onTouchStart, false);
        doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
        doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
      }
    } // Prevent Links Clicks


    if (params.preventClicks || params.preventClicksPropagation) {
      el.removeEventListener('click', swiper.onClick, true);
    }

    if (params.cssMode) {
      wrapperEl.removeEventListener('scroll', swiper.onScroll);
    } // Resize handler


    swiper.off(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
  }

  var events$2 = {
    attachEvents: attachEvents,
    detachEvents: detachEvents
  };

  function setBreakpoint() {
    var swiper = this;
    var activeIndex = swiper.activeIndex,
        initialized = swiper.initialized,
        _swiper$loopedSlides = swiper.loopedSlides,
        loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
        params = swiper.params,
        $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

    var breakpoint = swiper.getBreakpoint(breakpoints);

    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') return;

          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }

      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var wasMultiRow = params.slidesPerColumn > 1;
      var isMultiRow = breakpointParams.slidesPerColumn > 1;

      if (wasMultiRow && !isMultiRow) {
        $el.removeClass("".concat(params.containerModifierClass, "multirow ").concat(params.containerModifierClass, "multirow-column"));
      } else if (!wasMultiRow && isMultiRow) {
        $el.addClass("".concat(params.containerModifierClass, "multirow"));

        if (breakpointParams.slidesPerColumnFill === 'column') {
          $el.addClass("".concat(params.containerModifierClass, "multirow-column"));
        }
      }

      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

      if (directionChanged && initialized) {
        swiper.changeDirection();
      }

      Utils.extend(swiper.params, breakpointParams);
      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
      });
      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
      }

      swiper.emit('breakpoint', breakpointParams);
    }
  }

  function getBreakpoint(breakpoints) {
    // Get breakpoint for window width
    if (!breakpoints) return undefined;
    var breakpoint = false;
    var points = Object.keys(breakpoints).map(function (point) {
      if (typeof point === 'string' && point.indexOf('@') === 0) {
        var minRatio = parseFloat(point.substr(1));
        var value = win.innerHeight * minRatio;
        return {
          value: value,
          point: point
        };
      }

      return {
        value: point,
        point: point
      };
    });
    points.sort(function (a, b) {
      return parseInt(a.value, 10) - parseInt(b.value, 10);
    });

    for (var i = 0; i < points.length; i += 1) {
      var _points$i = points[i],
          point = _points$i.point,
          value = _points$i.value;

      if (value <= win.innerWidth) {
        breakpoint = point;
      }
    }

    return breakpoint || 'max';
  }

  var breakpoints$1 = {
    setBreakpoint: setBreakpoint,
    getBreakpoint: getBreakpoint
  };

  function addClasses() {
    var swiper = this;
    var classNames = swiper.classNames,
        params = swiper.params,
        rtl = swiper.rtl,
        $el = swiper.$el;
    var suffixes = [];
    suffixes.push('initialized');
    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }

    if (params.autoHeight) {
      suffixes.push('autoheight');
    }

    if (rtl) {
      suffixes.push('rtl');
    }

    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');

      if (params.slidesPerColumnFill === 'column') {
        suffixes.push('multirow-column');
      }
    }

    if (Device.android) {
      suffixes.push('android');
    }

    if (Device.ios) {
      suffixes.push('ios');
    }

    if (params.cssMode) {
      suffixes.push('css-mode');
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });
    $el.addClass(classNames.join(' '));
  }

  function removeClasses() {
    var swiper = this;
    var $el = swiper.$el,
        classNames = swiper.classNames;
    $el.removeClass(classNames.join(' '));
  }

  var classes = {
    addClasses: addClasses,
    removeClasses: removeClasses
  };

  function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;

    function onReady() {
      if (callback) callback();
    }

    var isPicture = $(imageEl).parent('picture')[0];

    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;

        if (sizes) {
          image.sizes = sizes;
        }

        if (srcset) {
          image.srcset = srcset;
        }

        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages() {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');

    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
      if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) swiper.update();
        swiper.emit('imagesReady');
      }
    }

    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages
  };

  function checkOverflow() {
    var swiper = this;
    var params = swiper.params;
    var wasLocked = swiper.isLocked;
    var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

    if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
      swiper.isLocked = lastSlidePosition <= swiper.size;
    } else {
      swiper.isLocked = swiper.snapGrid.length === 1;
    }

    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked; // events

    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      if (swiper.navigation) swiper.navigation.update();
    }
  }

  var checkOverflow$1 = {
    checkOverflow: checkOverflow
  };
  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    //
    preventInteractionOnTransition: false,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: 'swiper-container-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true
  };
  /* eslint no-param-reassign: "off" */

  var prototypes = {
    update: update$1,
    translate: translate,
    transition: transition$2,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events$2,
    breakpoints: breakpoints$1,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images
  };
  var extendedDefaults = {};

  var Swiper = /*#__PURE__*/function (_SwiperClass) {
    _inherits(Swiper, _SwiperClass);

    var _super = _createSuper(Swiper);

    function Swiper() {
      var _this;

      _classCallCheck(this, Swiper);

      var el;
      var params;

      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        el = args[0];
        params = args[1];
      }

      if (!params) params = {};
      params = Utils.extend({}, params);
      if (el && !params.el) params.el = el;
      _this = _super.call(this, params);
      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      }); // Swiper Instance

      var swiper = _assertThisInitialized(_this);

      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }

      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];

        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (_typeof(moduleParams) !== 'object' || moduleParams === null) return;
          if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

          if (params[moduleParamName] === true) {
            params[moduleParamName] = {
              enabled: true
            };
          }

          if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
            params[moduleParamName].enabled = true;
          }

          if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
          };
        }
      }); // Extend defaults with modules params

      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams); // Extend defaults with passed params

      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params); // Save Dom lib

      swiper.$ = $; // Find el

      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return _possibleConstructorReturn(_this, undefined);
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, {
            el: containerEl
          });
          swipers.push(new Swiper(newParams));
        });
        return _possibleConstructorReturn(_this, swipers);
      }

      el.swiper = swiper;
      $el.data('swiper', swiper); // Find Wrapper

      var $wrapperEl;

      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        $wrapperEl = $(el.shadowRoot.querySelector(".".concat(swiper.params.wrapperClass))); // Children needs to return slot items

        $wrapperEl.children = function (options) {
          return $el.children(options);
        };
      } else {
        $wrapperEl = $el.children(".".concat(swiper.params.wrapperClass));
      } // Extend Swiper


      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],
        // Classes
        classNames: [],
        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',
        // Indexes
        activeIndex: 0,
        realIndex: 0,
        //
        isBeginning: true,
        isEnd: false,
        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,
        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
        // Touch Events
        touchEvents: function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];

          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          }

          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
            cancel: touch[3]
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2]
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }(),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video, label',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined
        },
        // Clicks
        allowClick: true,
        // Touches
        allowTouchMove: swiper.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },
        // Images
        imagesToLoad: [],
        imagesLoaded: 0
      }); // Install Modules

      swiper.useModules(); // Init

      if (swiper.params.init) {
        swiper.init();
      } // Return app instance


      return _possibleConstructorReturn(_this, swiper);
    }

    _createClass(Swiper, [{
      key: "slidesPerViewDynamic",
      value: function slidesPerViewDynamic() {
        var swiper = this;
        var params = swiper.params,
            slides = swiper.slides,
            slidesGrid = swiper.slidesGrid,
            swiperSize = swiper.size,
            activeIndex = swiper.activeIndex;
        var spv = 1;

        if (params.centeredSlides) {
          var slideSize = slides[activeIndex].swiperSlideSize;
          var breakLoop;

          for (var i = activeIndex + 1; i < slides.length; i += 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }

          for (var _i7 = activeIndex - 1; _i7 >= 0; _i7 -= 1) {
            if (slides[_i7] && !breakLoop) {
              slideSize += slides[_i7].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
        } else {
          for (var _i8 = activeIndex + 1; _i8 < slides.length; _i8 += 1) {
            if (slidesGrid[_i8] - slidesGrid[activeIndex] < swiperSize) {
              spv += 1;
            }
          }
        }

        return spv;
      }
    }, {
      key: "update",
      value: function update() {
        var swiper = this;
        if (!swiper || swiper.destroyed) return;
        var snapGrid = swiper.snapGrid,
            params = swiper.params; // Breakpoints

        if (params.breakpoints) {
          swiper.setBreakpoint();
        }

        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();

        function setTranslate() {
          var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
          var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
          swiper.setTranslate(newTranslate);
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }

        var translated;

        if (swiper.params.freeMode) {
          setTranslate();

          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        } else {
          if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
            translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
          } else {
            translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
          }

          if (!translated) {
            setTranslate();
          }
        }

        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
          swiper.checkOverflow();
        }

        swiper.emit('update');
      }
    }, {
      key: "changeDirection",
      value: function changeDirection(newDirection) {
        var needUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var swiper = this;
        var currentDirection = swiper.params.direction;

        if (!newDirection) {
          // eslint-disable-next-line
          newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        }

        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
          return swiper;
        }

        swiper.$el.removeClass("".concat(swiper.params.containerModifierClass).concat(currentDirection)).addClass("".concat(swiper.params.containerModifierClass).concat(newDirection));
        swiper.params.direction = newDirection;
        swiper.slides.each(function (slideIndex, slideEl) {
          if (newDirection === 'vertical') {
            slideEl.style.width = '';
          } else {
            slideEl.style.height = '';
          }
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
      }
    }, {
      key: "init",
      value: function init() {
        var swiper = this;
        if (swiper.initialized) return;
        swiper.emit('beforeInit'); // Set breakpoint

        if (swiper.params.breakpoints) {
          swiper.setBreakpoint();
        } // Add Classes


        swiper.addClasses(); // Create loop

        if (swiper.params.loop) {
          swiper.loopCreate();
        } // Update size


        swiper.updateSize(); // Update slides

        swiper.updateSlides();

        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        } // Set Grab Cursor


        if (swiper.params.grabCursor) {
          swiper.setGrabCursor();
        }

        if (swiper.params.preloadImages) {
          swiper.preloadImages();
        } // Slide To Initial Slide


        if (swiper.params.loop) {
          swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
        } else {
          swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
        } // Attach events


        swiper.attachEvents(); // Init Flag

        swiper.initialized = true; // Emit

        swiper.emit('init');
      }
    }, {
      key: "destroy",
      value: function destroy() {
        var deleteInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var cleanStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var swiper = this;
        var params = swiper.params,
            $el = swiper.$el,
            $wrapperEl = swiper.$wrapperEl,
            slides = swiper.slides;

        if (typeof swiper.params === 'undefined' || swiper.destroyed) {
          return null;
        }

        swiper.emit('beforeDestroy'); // Init Flag

        swiper.initialized = false; // Detach events

        swiper.detachEvents(); // Destroy loop

        if (params.loop) {
          swiper.loopDestroy();
        } // Cleanup styles


        if (cleanStyles) {
          swiper.removeClasses();
          $el.removeAttr('style');
          $wrapperEl.removeAttr('style');

          if (slides && slides.length) {
            slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
          }
        }

        swiper.emit('destroy'); // Detach emitter events

        Object.keys(swiper.eventsListeners).forEach(function (eventName) {
          swiper.off(eventName);
        });

        if (deleteInstance !== false) {
          swiper.$el[0].swiper = null;
          swiper.$el.data('swiper', null);
          Utils.deleteProps(swiper);
        }

        swiper.destroyed = true;
        return null;
      }
    }], [{
      key: "extendDefaults",
      value: function extendDefaults(newDefaults) {
        Utils.extend(extendedDefaults, newDefaults);
      }
    }, {
      key: "extendedDefaults",
      get: function get() {
        return extendedDefaults;
      }
    }, {
      key: "defaults",
      get: function get() {
        return defaults;
      }
    }, {
      key: "Class",
      get: function get() {
        return SwiperClass;
      }
    }, {
      key: "$",
      get: function get() {
        return $;
      }
    }]);

    return Swiper;
  }(SwiperClass);

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device
    },
    static: {
      device: Device
    }
  };
  var Support$1 = {
    name: 'support',
    proto: {
      support: Support
    },
    static: {
      support: Support
    }
  };

  var Browser = function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }

    return {
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent)
    };
  }();

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser
    },
    static: {
      browser: Browser
    }
  };
  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            swiper.emit('orientationchange');
          }
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this; // Emit resize

        win.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      }
    }
  };
  var Observer$1 = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var swiper = this;
      var ObserverFunc = Observer$1.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }

        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });
      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData
      });
      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) return;

      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();

        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      } // Observe container


      swiper.observer.attach(swiper.$el[0], {
        childList: swiper.params.observeSlideChildren
      }); // Observe wrapper

      swiper.observer.attach(swiper.$wrapperEl[0], {
        attributes: false
      });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    }
  };
  var Observer$1$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer$1.init.bind(swiper),
          attach: Observer$1.attach.bind(swiper),
          destroy: Observer$1.destroy.bind(swiper),
          observers: []
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      }
    }
  };
  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var _swiper$params = swiper.params,
          slidesPerView = _swiper$params.slidesPerView,
          slidesPerGroup = _swiper$params.slidesPerGroup,
          centeredSlides = _swiper$params.centeredSlides;
      var _swiper$params$virtua = swiper.params.virtual,
          addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
          addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
      var _swiper$virtual = swiper.virtual,
          previousFrom = _swiper$virtual.from,
          previousTo = _swiper$virtual.to,
          slides = _swiper$virtual.slides,
          previousSlidesGrid = _swiper$virtual.slidesGrid,
          renderSlide = _swiper$virtual.renderSlide,
          previousOffset = _swiper$virtual.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;
      var offsetProp;
      if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
      var slidesAfter;
      var slidesBefore;

      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }

      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();

        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, "".concat(offset, "px"));
        }

        swiper.updateProgress();
        return;
      }

      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: function getSlides() {
            var slidesToRender = [];

            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }

            return slidesToRender;
          }()
        });
        onRendered();
        return;
      }

      var prependIndexes = [];
      var appendIndexes = [];

      if (force) {
        swiper.$wrapperEl.find(".".concat(swiper.params.slideClass)).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find(".".concat(swiper.params.slideClass, "[data-swiper-slide-index=\"").concat(i, "\"]")).remove();
          }
        }
      }

      for (var _i9 = 0; _i9 < slides.length; _i9 += 1) {
        if (_i9 >= from && _i9 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(_i9);
          } else {
            if (_i9 > previousTo) appendIndexes.push(_i9);
            if (_i9 < previousFrom) prependIndexes.push(_i9);
          }
        }
      }

      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) {
        return b - a;
      }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, "".concat(offset, "px"));
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;

      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }

      var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $("<div class=\"".concat(swiper.params.slideClass, "\" data-swiper-slide-index=\"").concat(index, "\">").concat(slide, "</div>"));
      if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
      if (params.cache) swiper.virtual.cache[index] = $slideEl;
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;

      if (_typeof(slides) === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) swiper.virtual.slides.push(slides[i]);
        }
      } else {
        swiper.virtual.slides.push(slides);
      }

      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;

      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
        }

        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }

      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          var $cachedEl = cache[cachedIndex];
          var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

          if (cachedElIndex) {
            $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
          }

          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
        });
        swiper.virtual.cache = newCache;
      }

      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
      var activeIndex = swiper.activeIndex;

      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);

          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }

          if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }

        if (slidesIndexes < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }

      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];

      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }

      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    }
  };
  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          removeSlide: Virtual.removeSlide.bind(swiper),
          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {}
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
        var overwriteParams = {
          watchSlidesProgress: true
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.update();
      }
    }
  };
  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) e = e.originalEvent; // jquery fix

      var kc = e.keyCode || e.charCode;
      var pageUpDown = swiper.params.keyboard.pageUpDown;
      var isPageUp = pageUpDown && kc === 33;
      var isPageDown = pageUpDown && kc === 34;
      var isArrowLeft = kc === 37;
      var isArrowRight = kc === 39;
      var isArrowUp = kc === 38;
      var isArrowDown = kc === 40; // Directions locks

      if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
        return false;
      }

      if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
        return false;
      }

      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }

      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }

      if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
        var inView = false; // Check that swiper should be inside of visible area of window

        if (swiper.$el.parents(".".concat(swiper.params.slideClass)).length > 0 && swiper.$el.parents(".".concat(swiper.params.slideActiveClass)).length === 0) {
          return undefined;
        }

        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];

          if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
            inView = true;
          }
        }

        if (!inView) return undefined;
      }

      if (swiper.isHorizontal()) {
        if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
          if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        }

        if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
        if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
      } else {
        if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
          if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        }

        if (isPageDown || isArrowDown) swiper.slideNext();
        if (isPageUp || isArrowUp) swiper.slidePrev();
      }

      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) return;
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) return;
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    }
  };
  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
        pageUpDown: true
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper)
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;

        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;

        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      }
    }
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = (eventName in doc);

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported && doc.implementation && doc.implementation.hasFeature // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    && doc.implementation.hasFeature('', '') !== true) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }

  var Mousewheel = {
    lastScrollTime: Utils.now(),
    lastEventBeforeSnap: undefined,
    recentWheelEvents: [],
    event: function event() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
      return isEventSupported() ? 'wheel' : 'mousewheel';
    },
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;
      var sX = 0;
      var sY = 0; // spinX, spinY

      var pX = 0;
      var pY = 0; // pixelX, pixelY
      // Legacy

      if ('detail' in e) {
        sY = e.detail;
      }

      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }

      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }

      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      } // side scrolling on FF with DOMMouseScroll


      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }

      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if (e.shiftKey && !pX) {
        // if user scrolls with shift he wants horizontal scroll
        pX = pY;
        pY = 0;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) {
          // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else {
          // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      } // Fall-back if spin cannot be determined


      if (pX && !sX) {
        sX = pX < 1 ? -1 : 1;
      }

      if (pY && !sY) {
        sY = pY < 1 ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (swiper.params.cssMode) {
        e.preventDefault();
      }

      var target = swiper.$el;

      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }

      if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
      if (e.originalEvent) e = e.originalEvent; // jquery fix

      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;
      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) return true;
      if (params.invert) delta = -delta;

      if (!swiper.params.freeMode) {
        // Register the new event in a variable which stores the relevant data
        var newEvent = {
          time: Utils.now(),
          delta: Math.abs(delta),
          direction: Math.sign(delta),
          raw: event
        }; // Keep the most recent events

        var recentWheelEvents = swiper.mousewheel.recentWheelEvents;

        if (recentWheelEvents.length >= 2) {
          recentWheelEvents.shift(); // only store the last N events
        }

        var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
        recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
        //   If direction has changed or
        //   if the scroll is quicker than the previous one:
        //     Animate the slider.
        // Else (this is the first time the wheel is moved):
        //     Animate the slider.

        if (prevEvent) {
          if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
            swiper.mousewheel.animateSlider(newEvent);
          }
        } else {
          swiper.mousewheel.animateSlider(newEvent);
        } // If it's time to release the scroll:
        //   Return now so you don't hit the preventDefault.


        if (swiper.mousewheel.releaseScroll(newEvent)) {
          return true;
        }
      } else {
        // Freemode or scrollContainer:
        // If we recently snapped after a momentum scroll, then ignore wheel events
        // to give time for the deceleration to finish. Stop ignoring after 500 msecs
        // or if it's a new scroll (larger delta or inverse sign as last event before
        // an end-of-momentum snap).
        var _newEvent = {
          time: Utils.now(),
          delta: Math.abs(delta),
          direction: Math.sign(delta)
        };
        var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
        var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;

        if (!ignoreWheelEvents) {
          swiper.mousewheel.lastEventBeforeSnap = undefined;

          if (swiper.params.loop) {
            swiper.loopFix();
          }

          var position = swiper.getTranslate() + delta * params.sensitivity;
          var wasBeginning = swiper.isBeginning;
          var wasEnd = swiper.isEnd;
          if (position >= swiper.minTranslate()) position = swiper.minTranslate();
          if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
          swiper.setTransition(0);
          swiper.setTranslate(position);
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();

          if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
            swiper.updateSlidesClasses();
          }

          if (swiper.params.freeModeSticky) {
            // When wheel scrolling starts with sticky (aka snap) enabled, then detect
            // the end of a momentum scroll by storing recent (N=15?) wheel events.
            // 1. do all N events have decreasing or same (absolute value) delta?
            // 2. did all N events arrive in the last M (M=500?) msecs?
            // 3. does the earliest event have an (absolute value) delta that's
            //    at least P (P=1?) larger than the most recent event's delta?
            // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
            // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
            // Snap immediately and ignore remaining wheel events in this scroll.
            // See comment above for "remaining wheel events in this scroll" determination.
            // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
            clearTimeout(swiper.mousewheel.timeout);
            swiper.mousewheel.timeout = undefined;
            var _recentWheelEvents = swiper.mousewheel.recentWheelEvents;

            if (_recentWheelEvents.length >= 15) {
              _recentWheelEvents.shift(); // only store the last N events

            }

            var _prevEvent = _recentWheelEvents.length ? _recentWheelEvents[_recentWheelEvents.length - 1] : undefined;

            var firstEvent = _recentWheelEvents[0];

            _recentWheelEvents.push(_newEvent);

            if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) {
              // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
              _recentWheelEvents.splice(0);
            } else if (_recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
              // We're at the end of the deceleration of a momentum scroll, so there's no need
              // to wait for more events. Snap ASAP on the next tick.
              // Also, because there's some remaining momentum we'll bias the snap in the
              // direction of the ongoing scroll because it's better UX for the scroll to snap
              // in the same direction as the scroll instead of reversing to snap.  Therefore,
              // if it's already scrolled more than 20% in the current direction, keep going.
              var snapToThreshold = delta > 0 ? 0.8 : 0.2;
              swiper.mousewheel.lastEventBeforeSnap = _newEvent;

              _recentWheelEvents.splice(0);

              swiper.mousewheel.timeout = Utils.nextTick(function () {
                swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
              }, 0); // no delay; move on next tick
            }

            if (!swiper.mousewheel.timeout) {
              // if we get here, then we haven't detected the end of a momentum scroll, so
              // we'll consider a scroll "complete" when there haven't been any wheel events
              // for 500ms.
              swiper.mousewheel.timeout = Utils.nextTick(function () {
                var snapToThreshold = 0.5;
                swiper.mousewheel.lastEventBeforeSnap = _newEvent;

                _recentWheelEvents.splice(0);

                swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
              }, 500);
            }
          } // Emit event


          if (!ignoreWheelEvents) swiper.emit('scroll', e); // Stop autoplay

          if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

          if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
        }
      }

      if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      return false;
    },
    animateSlider: function animateSlider(newEvent) {
      var swiper = this; // If the movement is NOT big enough and
      // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
      //   Don't go any further (avoid insignificant scroll movement).

      if (newEvent.delta >= 6 && Utils.now() - swiper.mousewheel.lastScrollTime < 60) {
        // Return false as a default
        return true;
      } // If user is scrolling towards the end:
      //   If the slider hasn't hit the latest slide or
      //   if the slider is a loop and
      //   if the slider isn't moving right now:
      //     Go to next slide and
      //     emit a scroll event.
      // Else (the user is scrolling towards the beginning) and
      // if the slider hasn't hit the first slide or
      // if the slider is a loop and
      // if the slider isn't moving right now:
      //   Go to prev slide and
      //   emit a scroll event.


      if (newEvent.direction < 0) {
        if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
          swiper.slideNext();
          swiper.emit('scroll', newEvent.raw);
        }
      } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
        swiper.slidePrev();
        swiper.emit('scroll', newEvent.raw);
      } // If you got here is because an animation has been triggered so store the current time


      swiper.mousewheel.lastScrollTime = new win.Date().getTime(); // Return false as a default

      return false;
    },
    releaseScroll: function releaseScroll(newEvent) {
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (newEvent.direction < 0) {
        if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
          // Return true to animate scroll on edges
          return true;
        }
      } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }

      return false;
    },
    enable: function enable() {
      var swiper = this;
      var event = Mousewheel.event();

      if (swiper.params.cssMode) {
        swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
        return true;
      }

      if (!event) return false;
      if (swiper.mousewheel.enabled) return false;
      var target = swiper.$el;

      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }

      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      var event = Mousewheel.event();

      if (swiper.params.cssMode) {
        swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
        return true;
      }

      if (!event) return false;
      if (!swiper.mousewheel.enabled) return false;
      var target = swiper.$el;

      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }

      target.off(event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    }
  };
  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          animateSlider: Mousewheel.animateSlider.bind(swiper),
          releaseScroll: Mousewheel.releaseScroll.bind(swiper),
          lastScrollTime: Utils.now(),
          lastEventBeforeSnap: undefined,
          recentWheelEvents: []
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;

        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
          swiper.mousewheel.disable();
        }

        if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
      },
      destroy: function destroy() {
        var swiper = this;

        if (swiper.params.cssMode) {
          swiper.mousewheel.enable();
        }

        if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
      }
    }
  };
  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;
      if (swiper.params.loop) return;
      var _swiper$navigation = swiper.navigation,
          $nextEl = _swiper$navigation.$nextEl,
          $prevEl = _swiper$navigation.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }

        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }

      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }

        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) return;
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) return;
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) return;
      var $nextEl;
      var $prevEl;

      if (params.nextEl) {
        $nextEl = $(params.nextEl);

        if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }

      if (params.prevEl) {
        $prevEl = $(params.prevEl);

        if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }

      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0]
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var _swiper$navigation2 = swiper.navigation,
          $nextEl = _swiper$navigation2.$nextEl,
          $prevEl = _swiper$navigation2.$prevEl;

      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }

      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    }
  };
  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
          onNextClick: Navigation.onNextClick.bind(swiper),
          onPrevClick: Navigation.onPrevClick.bind(swiper)
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var _swiper$navigation3 = swiper.navigation,
            $nextEl = _swiper$navigation3.$nextEl,
            $prevEl = _swiper$navigation3.$prevEl;

        if (swiper.params.navigation.hideOnClick && !$(e.target).is($prevEl) && !$(e.target).is($nextEl)) {
          var isHidden;

          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }

          if (isHidden === true) {
            swiper.emit('navigationShow', swiper);
          } else {
            swiper.emit('navigationHide', swiper);
          }

          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }

          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      }
    }
  };
  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el; // Current/Total

      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

        if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
          current -= slidesLength - swiper.loopedSlides * 2;
        }

        if (current > total - 1) current -= total;
        if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      } // Types


      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;

        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', "".concat(swiper.pagination.bulletSize * (params.dynamicMainBullets + 4), "px"));

          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

            if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }

          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }

        bullets.removeClass("".concat(params.bulletActiveClass, " ").concat(params.bulletActiveClass, "-next ").concat(params.bulletActiveClass, "-next-next ").concat(params.bulletActiveClass, "-prev ").concat(params.bulletActiveClass, "-prev-prev ").concat(params.bulletActiveClass, "-main"));

        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();

            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }

            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass("".concat(params.bulletActiveClass, "-main"));
              }

              if (bulletIndex === firstIndex) {
                $bullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
              }

              if (bulletIndex === lastIndex) {
                $bullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          var bulletIndex = $bullet.index();
          $bullet.addClass(params.bulletActiveClass);

          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);

            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass("".concat(params.bulletActiveClass, "-main"));
            }

            if (swiper.params.loop) {
              if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                for (var _i10 = params.dynamicMainBullets; _i10 >= 0; _i10 -= 1) {
                  bullets.eq(bullets.length - _i10).addClass("".concat(params.bulletActiveClass, "-main"));
                }

                bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass("".concat(params.bulletActiveClass, "-prev"));
              } else {
                $firstDisplayedBullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
                $lastDisplayedBullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
              }
            } else {
              $firstDisplayedBullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
              $lastDisplayedBullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
            }
          }
        }

        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', "".concat(bulletsOffset, "px"));
        }
      }

      if (params.type === 'fraction') {
        $el.find(".".concat(params.currentClass)).text(params.formatFractionCurrent(current + 1));
        $el.find(".".concat(params.totalClass)).text(params.formatFractionTotal(total));
      }

      if (params.type === 'progressbar') {
        var progressbarDirection;

        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }

        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;

        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }

        $el.find(".".concat(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")")).transition(swiper.params.speed);
      }

      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }

      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      var paginationHTML = '';

      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<".concat(params.bulletElement, " class=\"").concat(params.bulletClass, "\"></").concat(params.bulletElement, ">");
          }
        }

        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(".".concat(params.bulletClass));
      }

      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"".concat(params.currentClass, "\"></span>") + ' / ' + "<span class=\"".concat(params.totalClass, "\"></span>");
        }

        $el.html(paginationHTML);
      }

      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"".concat(params.progressbarFillClass, "\"></span>");
        }

        $el.html(paginationHTML);
      }

      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) return;
      var $el = $(params.el);
      if ($el.length === 0) return;

      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass("".concat(params.modifierClass).concat(params.type, "-dynamic"));
        swiper.pagination.dynamicBulletIndex = 0;

        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }

      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', ".".concat(params.bulletClass), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) index += swiper.loopedSlides;
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0]
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
      var $el = swiper.pagination.$el;
      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

      if (params.clickable) {
        $el.off('click', ".".concat(params.bulletClass));
      }
    }
  };
  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets',
        // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function formatFractionCurrent(number) {
          return number;
        },
        formatFractionTotal: function formatFractionTotal(number) {
          return number;
        },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-',
        // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable',
        // NEW
        lockClass: 'swiper-pagination-lock'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;

        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;

        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;

        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;

        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;

        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(e.target).hasClass(swiper.params.pagination.bulletClass)) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

          if (isHidden === true) {
            swiper.emit('paginationShow', swiper);
          } else {
            swiper.emit('paginationHide', swiper);
          }

          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      }
    }
  };
  var Scrollbar$1 = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
      var scrollbar = swiper.scrollbar,
          rtl = swiper.rtlTranslate,
          progress = swiper.progress;
      var dragSize = scrollbar.dragSize,
          trackSize = scrollbar.trackSize,
          $dragEl = scrollbar.$dragEl,
          $el = scrollbar.$el;
      var params = swiper.params.scrollbar;
      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;

      if (rtl) {
        newPos = -newPos;

        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }

      if (swiper.isHorizontal()) {
        $dragEl.transform("translate3d(".concat(newPos, "px, 0, 0)"));
        $dragEl[0].style.width = "".concat(newSize, "px");
      } else {
        $dragEl.transform("translate3d(0px, ".concat(newPos, "px, 0)"));
        $dragEl[0].style.height = "".concat(newSize, "px");
      }

      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl,
          $el = scrollbar.$el;
      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;

      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = "".concat(dragSize, "px");
      } else {
        $dragEl[0].style.height = "".concat(dragSize, "px");
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }

      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }

      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;

      if (swiper.isHorizontal()) {
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
      }

      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar,
          rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el,
          dragSize = scrollbar.dragSize,
          trackSize = scrollbar.trackSize,
          dragStartPos = scrollbar.dragStartPos;
      var positionRatio;
      positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);

      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar,
          $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el,
          $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();
      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);
      clearTimeout(swiper.scrollbar.dragTimeout);
      $el.transition(0);

      if (params.hide) {
        $el.css('opacity', 1);
      }

      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css('scroll-snap-type', 'none');
      }

      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar,
          $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el,
          $dragEl = scrollbar.$dragEl;
      if (!swiper.scrollbar.isTouched) return;
      if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar,
          $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      if (!swiper.scrollbar.isTouched) return;
      swiper.scrollbar.isTouched = false;

      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css('scroll-snap-type', '');
        $wrapperEl.transition('');
      }

      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }

      swiper.emit('scrollbarDragEnd', e);

      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) return;
      var scrollbar = swiper.scrollbar,
          touchEventsTouch = swiper.touchEventsTouch,
          touchEventsDesktop = swiper.touchEventsDesktop,
          params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? {
        passive: false,
        capture: false
      } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;

      if (!Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) return;
      var scrollbar = swiper.scrollbar,
          touchEventsTouch = swiper.touchEventsTouch,
          touchEventsDesktop = swiper.touchEventsDesktop,
          params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? {
        passive: false,
        capture: false
      } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;

      if (!Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) return;
      var scrollbar = swiper.scrollbar,
          $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;
      var $el = $(params.el);

      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find(".".concat(swiper.params.scrollbar.dragClass));

      if ($dragEl.length === 0) {
        $dragEl = $("<div class=\"".concat(swiper.params.scrollbar.dragClass, "\"></div>"));
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0]
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    }
  };
  var Scrollbar$1$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar$1.init.bind(swiper),
          destroy: Scrollbar$1.destroy.bind(swiper),
          updateSize: Scrollbar$1.updateSize.bind(swiper),
          setTranslate: Scrollbar$1.setTranslate.bind(swiper),
          setTransition: Scrollbar$1.setTransition.bind(swiper),
          enableDraggable: Scrollbar$1.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar$1.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar$1.setDragPosition.bind(swiper),
          getPointerPosition: Scrollbar$1.getPointerPosition.bind(swiper),
          onDragStart: Scrollbar$1.onDragStart.bind(swiper),
          onDragMove: Scrollbar$1.onDragMove.bind(swiper),
          onDragEnd: Scrollbar$1.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      }
    }
  };
  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;
      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;
      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if (x.indexOf('%') >= 0) {
        x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
      } else {
        x = "".concat(x * progress * rtlFactor, "px");
      }

      if (y.indexOf('%') >= 0) {
        y = "".concat(parseInt(y, 10) * progress, "%");
      } else {
        y = "".concat(y * progress, "px");
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
        $el[0].style.opacity = currentOpacity;
      }

      if (typeof scale === 'undefined' || scale === null) {
        $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px)"));
      } else {
        var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
        $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px) scale(").concat(currentScale, ")"));
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el,
          slides = swiper.slides,
          progress = swiper.progress,
          snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
        swiper.parallax.setTransform(el, progress);
      });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;

        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
        }

        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
          swiper.parallax.setTransform(el, slideProgress);
        });
      });
    },
    setTransition: function setTransition() {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, parallaxEl) {
        var $parallaxEl = $(parallaxEl);
        var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
        if (duration === 0) parallaxDuration = 0;
        $parallaxEl.transition(parallaxDuration);
      });
    }
  };
  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) return;
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) return;
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax.enabled) return;
        swiper.parallax.setTransition(duration);
      }
    }
  };
  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) return 1;
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;

      if (!Support.gestures) {
        if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
          return;
        }

        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }

      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest(".".concat(swiper.params.slideClass));
        if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
        gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }

      if (gesture.$imageEl) {
        gesture.$imageEl.transition(0);
      }

      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;

      if (!Support.gestures) {
        if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
          return;
        }

        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }

      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

      if (Support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
      }

      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
      }

      if (zoom.scale < params.minRatio) {
        zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
      }

      gesture.$imageEl.transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;

      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }

        if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android) {
          return;
        }

        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }

      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) gesture.$slideEl = undefined;
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture,
          image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      if (image.isTouched) return;
      if (Device.android && e.cancelable) e.preventDefault();
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture,
          image = zoom.image,
          velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) return;

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);

        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      } // Define if we need image drag


      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
      image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
      image.maxX = -image.minX;
      image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
      image.maxY = -image.minY;
      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
          image.isTouched = false;
          return;
        }

        if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
          image.isTouched = false;
          return;
        }
      }

      if (e.cancelable) {
        e.preventDefault();
      }

      e.stopPropagation();
      image.isMoved = true;
      image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
      image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
      }

      if (image.currentX > image.maxX) {
        image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
      }

      if (image.currentY < image.minY) {
        image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
      }

      if (image.currentY > image.maxY) {
        image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
      } // Velocity


      if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
      if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
      if (!velocity.prevTime) velocity.prevTime = Date.now();
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();
      gesture.$imageWrapEl.transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture,
          image = zoom.image,
          velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }

      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY; // Fix duration

      if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
      if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
      image.currentX = newPositionX;
      image.currentY = newPositionY; // Define if we need image drag

      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
      image.maxX = -image.minX;
      image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
      gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;

      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        if (gesture.$imageEl) {
          gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        }

        if (gesture.$imageWrapEl) {
          gesture.$imageWrapEl.transform('translate3d(0,0,0)');
        }

        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function _in(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture,
          image = zoom.image;

      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }

        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
        gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
      }

      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      gesture.$slideEl.addClass("".concat(params.zoomedSlideClass));
      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = offsetX + slideWidth / 2 - touchX;
        diffY = offsetY + slideHeight / 2 - touchY;
        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;
        translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;
        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }

        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }

        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }

      gesture.$imageWrapEl.transition(300).transform("translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)"));
      gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    },
    out: function out() {
      var swiper = this;
      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }

        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
        gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
      }

      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass("".concat(params.zoomedSlideClass));
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) return;
      zoom.enabled = true;
      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      var activeListenerWithCapture = Support.passiveListener ? {
        passive: false,
        capture: true
      } : true;
      var slideSelector = ".".concat(swiper.params.slideClass); // Scale image

      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
        swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);

        if (swiper.touchEvents.cancel) {
          swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
        }
      } // Move image


      swiper.$wrapperEl.on(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), zoom.onTouchMove, activeListenerWithCapture);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) return;
      swiper.zoom.enabled = false;
      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      var activeListenerWithCapture = Support.passiveListener ? {
        passive: false,
        capture: true
      } : true;
      var slideSelector = ".".concat(swiper.params.slideClass); // Scale image

      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
        swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);

        if (swiper.touchEvents.cancel) {
          swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
        }
      } // Move image


      swiper.$wrapperEl.off(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), zoom.onTouchMove, activeListenerWithCapture);
    }
  };
  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed'
      }
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {}
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined
        }
      };
      'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom
      });
      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }

          scale = value;
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;

        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) return;
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) return;
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;

        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;

        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
      slideChange: function slideChange() {
        var swiper = this;

        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
          swiper.zoom.onTransitionEnd();
        }
      }
    }
  };
  var Lazy = {
    loadInSlide: function loadInSlide(index) {
      var loadInDuplicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') return;
      if (swiper.slides.length === 0) return;
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var $slideEl = isVirtual ? swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, "[data-swiper-slide-index=\"").concat(index, "\"]")) : swiper.slides.eq(index);
      var $images = $slideEl.find(".".concat(params.elementClass, ":not(.").concat(params.loadedClass, "):not(.").concat(params.loadingClass, ")"));

      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }

      if ($images.length === 0) return;
      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);
        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');
        var $pictureEl = $imageEl.parent('picture');
        swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

          if (background) {
            $imageEl.css('background-image', "url(\"".concat(background, "\")"));
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }

            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }

            if ($pictureEl.length) {
              $pictureEl.children('source').each(function (sourceIndex, sourceEl) {
                var $source = $(sourceEl);

                if ($source.attr('data-srcset')) {
                  $source.attr('srcset', $source.attr('data-srcset'));
                  $source.removeAttr('data-srcset');
                }
              });
            }

            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(".".concat(params.preloaderClass)).remove();

          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"".concat(slideOriginalIndex, "\"]:not(.").concat(swiper.params.slideDuplicateClass, ")"));
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children(".".concat(swiper.params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(slideOriginalIndex, "\"]"));
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }

          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);

          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        });
        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl,
          swiperParams = swiper.params,
          slides = swiper.slides,
          activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;
      var slidesPerView = swiperParams.slidesPerView;

      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children(".".concat(swiperParams.slideClass, "[data-swiper-slide-index=\"").concat(index, "\"]")).length) {
            return true;
          }
        } else if (slides[index]) return true;

        return false;
      }

      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }

        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;

      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children(".".concat(swiperParams.slideVisibleClass)).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) swiper.lazy.loadInSlide(i);
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }

      if (params.loadPrevNext) {
        if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

          for (var _i11 = activeIndex + slidesPerView; _i11 < maxIndex; _i11 += 1) {
            if (slideExist(_i11)) swiper.lazy.loadInSlide(_i11);
          } // Prev Slides


          for (var _i12 = minIndex; _i12 < activeIndex; _i12 += 1) {
            if (slideExist(_i12)) swiper.lazy.loadInSlide(_i12);
          }
        } else {
          var nextSlide = $wrapperEl.children(".".concat(swiperParams.slideNextClass));
          if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
          var prevSlide = $wrapperEl.children(".".concat(swiperParams.slidePrevClass));
          if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
        }
      }
    }
  };
  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,
        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;

        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;

        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;

        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;

        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;

        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;

        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;

        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
      slideChange: function slideChange() {
        var swiper = this;

        if (swiper.params.lazy.enabled && swiper.params.cssMode) {
          swiper.lazy.load();
        }
      }
    }
  };
  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;

          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;

            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }

          return maxIndex;
        };
      }();

      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.

      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

        return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
      };

      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;

      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(_setTranslate, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;

      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out

          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }

        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }

      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;

      function setControlledTransition(c) {
        c.setTransition(duration, swiper);

        if (duration !== 0) {
          c.transitionStart();

          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }

          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) return;

            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }

            c.transitionEnd();
          });
        }
      }

      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    }
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide' // or 'container'

      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper)
        }
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) return;

        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) return;

        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) return;

        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
      }
    }
  };
  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    makeElNotFocusable: function makeElNotFocusable($el) {
      $el.attr('tabIndex', '-1');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) return;
      var $targetEl = $(e.target);

      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }

        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }

      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }

        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }

      if (swiper.pagination && $targetEl.is(".".concat(swiper.params.pagination.bulletClass))) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) return;
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;
      if (swiper.params.loop || !swiper.navigation) return;
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
          swiper.a11y.makeElNotFocusable($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
          swiper.a11y.makeElFocusable($prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
          swiper.a11y.makeElNotFocusable($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
          swiper.a11y.makeElFocusable($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;

      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;
      swiper.$el.append(swiper.a11y.liveRegion); // Navigation

      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;

      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }

      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }

      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }

      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      } // Pagination


      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', ".".concat(swiper.params.pagination.bulletClass), swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
      var $nextEl;
      var $prevEl;

      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }

      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }

      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }

      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      } // Pagination


      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', ".".concat(swiper.params.pagination.bulletClass), swiper.a11y.onEnterKey);
      }
    }
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $("<span class=\"".concat(swiper.params.a11y.notificationClass, "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>"))
        }
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.destroy();
      }
    }
  };
  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) return;

      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }

      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) return;
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);

      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;

      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) {
        return part !== '';
      });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return {
        key: key,
        value: value
      };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) return;
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));

      if (!win.location.pathname.includes(key)) {
        value = "".concat(key, "/").concat(value);
      }

      var currentState = win.history.state;

      if (currentState && currentState.value === value) {
        return;
      }

      if (swiper.params.history.replaceState) {
        win.history.replaceState({
          value: value
        }, null, value);
      } else {
        win.history.pushState({
          value: value
        }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;

      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var _slide3 = swiper.slides.eq(i);

          var slideHistory = History.slugify(_slide3.attr('data-history'));

          if (slideHistory === value && !_slide3.hasClass(swiper.params.slideDuplicateClass)) {
            var _index2 = _slide3.index();

            swiper.slideTo(_index2, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    }
  };
  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper)
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;

        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;

        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;

        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
      slideChange: function slideChange() {
        var swiper = this;

        if (swiper.history.initialized && swiper.params.cssMode) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      }
    }
  };
  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      swiper.emit('hashChange');
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, "[data-hash=\"").concat(newHash, "\"]")).index();
        if (typeof newIndex === 'undefined') return;
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;

      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, "#".concat(swiper.slides.eq(swiper.activeIndex).attr('data-hash')) || '');
        swiper.emit('hashSet');
      } else {
        var _slide4 = swiper.slides.eq(swiper.activeIndex);

        var hash = _slide4.attr('data-hash') || _slide4.attr('data-history');

        doc.location.hash = hash || '';
        swiper.emit('hashSet');
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');

      if (hash) {
        var speed = 0;

        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var _slide5 = swiper.slides.eq(i);

          var slideHash = _slide5.attr('data-hash') || _slide5.attr('data-history');

          if (slideHash === hash && !_slide5.hasClass(swiper.params.slideDuplicateClass)) {
            var _index3 = _slide5.index();

            swiper.slideTo(_index3, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }

      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;

      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    }
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper)
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;

        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;

        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;

        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
      slideChange: function slideChange() {
        var swiper = this;

        if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
          swiper.hashNavigation.setHash();
        }
      }
    }
  };
  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;

      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }

      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }

        if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') return false;
      if (swiper.autoplay.running) return false;
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) return false;
      if (typeof swiper.autoplay.timeout === 'undefined') return false;

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }

      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) return;
      if (swiper.autoplay.paused) return;
      if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.paused = true;

      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    }
  };
  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onVisibilityChange: function onVisibilityChange() {
            if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
              swiper.autoplay.pause();
            }

            if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
              swiper.autoplay.run();
              swiper.autoplay.paused = false;
            }
          },
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;

            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          }
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;

        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
          document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;

        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;

        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      touchEnd: function touchEnd() {
        var swiper = this;

        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.run();
        }
      },
      destroy: function destroy() {
        var swiper = this;

        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }

        document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
      }
    }
  };
  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;

      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var _offset = $slideEl[0].swiperSlideOffset;
        var tx = -_offset;
        if (!swiper.params.virtualTranslate) tx -= swiper.translate;
        var ty = 0;

        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }

        var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl.css({
          opacity: slideOpacity
        }).transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides,
          $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);

      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) return;
          if (!swiper || swiper.destroyed) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    }
  };
  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "fade"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') return;
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') return;
        swiper.fadeEffect.setTransition(duration);
      }
    }
  };
  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el,
          $wrapperEl = swiper.$wrapperEl,
          slides = swiper.slides,
          swiperWidth = swiper.width,
          swiperHeight = swiper.height,
          rtl = swiper.rtlTranslate,
          swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }

          $cubeShadowEl.css({
            height: "".concat(swiperWidth, "px")
          });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');

          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }

      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;

        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }

        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);

        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }

        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;

        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + round * 4 * swiperSize;
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = 3 * swiperSize + swiperSize * 4 * round;
        }

        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var _transform = "rotateX(".concat(isHorizontal ? 0 : -slideAngle, "deg) rotateY(").concat(isHorizontal ? slideAngle : 0, "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");

        if (progress <= 1 && progress > -1) {
          wrapperRotate = slideIndex * 90 + progress * 90;
          if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
        }

        $slideEl.transform(_transform);

        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

          if (shadowBefore.length === 0) {
            shadowBefore = $("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'left' : 'top', "\"></div>"));
            $slideEl.append(shadowBefore);
          }

          if (shadowAfter.length === 0) {
            shadowAfter = $("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'right' : 'bottom', "\"></div>"));
            $slideEl.append(shadowAfter);
          }

          if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
          if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
        }
      }

      $wrapperEl.css({
        '-webkit-transform-origin': "50% 50% -".concat(swiperSize / 2, "px"),
        '-moz-transform-origin': "50% 50% -".concat(swiperSize / 2, "px"),
        '-ms-transform-origin': "50% 50% -".concat(swiperSize / 2, "px"),
        'transform-origin': "50% 50% -".concat(swiperSize / 2, "px")
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform("translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")"));
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
          var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var _offset2 = params.shadowOffset;
          $cubeShadowEl.transform("scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + _offset2, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-90deg)"));
        }
      }

      var zFactor = Browser.isSafari || Browser.isWebView ? -swiperSize / 2 : 0;
      $wrapperEl.transform("translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(swiper.isHorizontal() ? 0 : wrapperRotate, "deg) rotateY(").concat(swiper.isHorizontal() ? -wrapperRotate : 0, "deg)"));
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el,
          slides = swiper.slides;
      slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    }
  };
  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "cube"));
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') return;
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') return;
        swiper.cubeEffect.setTransition(duration);
      }
    }
  };
  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides,
          rtl = swiper.rtlTranslate;

      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;

        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }

        var _offset3 = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -_offset3;
        var ty = 0;

        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

          if (shadowBefore.length === 0) {
            shadowBefore = $("<div class=\"swiper-slide-shadow-".concat(swiper.isHorizontal() ? 'left' : 'top', "\"></div>"));
            $slideEl.append(shadowBefore);
          }

          if (shadowAfter.length === 0) {
            shadowAfter = $("<div class=\"swiper-slide-shadow-".concat(swiper.isHorizontal() ? 'right' : 'bottom', "\"></div>"));
            $slideEl.append(shadowAfter);
          }

          if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
          if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
        }

        $slideEl.transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides,
          activeIndex = swiper.activeIndex,
          $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false; // eslint-disable-next-line

        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) return;
          if (!swiper || swiper.destroyed) return; // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;

          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    }
  };
  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "flip"));
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') return;
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') return;
        swiper.flipEffect.setTransition(duration);
      }
    }
  };
  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width,
          swiperHeight = swiper.height,
          slides = swiper.slides,
          $wrapperEl = swiper.$wrapperEl,
          slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth; // Each slide offset from center

      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

        var translateZ = -translate * Math.abs(offsetMultiplier);
        var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

        if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
          stretch = parseFloat(params.stretch) / 100 * slideSize;
        }

        var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
        var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
        var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

        if (Math.abs(translateX) < 0.001) translateX = 0;
        if (Math.abs(translateY) < 0.001) translateY = 0;
        if (Math.abs(translateZ) < 0.001) translateZ = 0;
        if (Math.abs(rotateY) < 0.001) rotateY = 0;
        if (Math.abs(rotateX) < 0.001) rotateX = 0;
        if (Math.abs(scale) < 0.001) scale = 0;
        var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg) scale(").concat(scale, ")");
        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'left' : 'top', "\"></div>"));
            $slideEl.append($shadowBeforeEl);
          }

          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'right' : 'bottom', "\"></div>"));
            $slideEl.append($shadowAfterEl);
          }

          if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
          if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
        }
      } // Set correct perspective for IE10


      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = "".concat(center, "px 50%");
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    }
  };
  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        scale: 1,
        modifier: 1,
        slideShadows: true
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "coverflow"));
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') return;
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') return;
        swiper.coverflowEffect.setTransition(duration);
      }
    }
  };
  var Thumbs = {
    init: function init() {
      var swiper = this;
      var thumbsParams = swiper.params.thumbs;
      var SwiperClass = swiper.constructor;

      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false
        }));
        swiper.thumbs.swiperCreated = true;
      }

      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
      var slideToIndex;

      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }

      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;

        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix(); // eslint-disable-next-line

          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }

        var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"".concat(slideToIndex, "\"]")).eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"".concat(slideToIndex, "\"]")).eq(0).index();
        if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
      }

      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
      var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
      var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

      if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        var direction;

        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix(); // eslint-disable-next-line

            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          } // Find actual thumbs index to slide to


          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"".concat(swiper.realIndex, "\"]")).eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"".concat(swiper.realIndex, "\"]")).eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;else newThumbsIndex = prevThumbsIndex;
          direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
        } else {
          newThumbsIndex = swiper.realIndex;
          direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
        }

        if (useOffset) {
          newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
        }

        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }

          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      } // Activate thumbs


      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      if (!swiper.params.thumbs.multipleActiveThumbs) {
        thumbsToActivate = 1;
      }

      thumbsToActivate = Math.floor(thumbsToActivate);
      thumbsSwiper.slides.removeClass(thumbActiveClass);

      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"".concat(swiper.realIndex + i, "\"]")).addClass(thumbActiveClass);
        }
      } else {
        for (var _i13 = 0; _i13 < thumbsToActivate; _i13 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + _i13).addClass(thumbActiveClass);
        }
      }
    }
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        swiper: null,
        multipleActiveThumbs: true,
        autoScrollOffset: 0,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) return;
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) return;
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) return;
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) return;
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;

        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      }
    }
  }; // Swiper Class

  var components = [Device$1, Support$1, Browser$1, Resize, Observer$1$1, Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs$1];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  /*!
   * vue-awesome-swiper v4.1.1
   * Copyright (c) Surmon. All rights reserved.
   * Released under the MIT License.
   * Surmon <https://github.com/surmon-china>
   */
  /**
   * @file vue-awesome-swiper
   * @module constants
   * @author Surmon <https://github.com/surmon-china>
   */

  var CoreNames;

  (function (CoreNames) {
    CoreNames["SwiperComponent"] = "Swiper";
    CoreNames["SwiperSlideComponent"] = "SwiperSlide";
    CoreNames["SwiperDirective"] = "swiper";
    CoreNames["SwiperInstance"] = "$swiper";
  })(CoreNames || (CoreNames = {}));

  var DEFAULT_CLASSES = Object.freeze({
    containerClass: 'swiper-container',
    wrapperClass: 'swiper-wrapper',
    slideClass: 'swiper-slide'
  });
  var ComponentEvents;

  (function (ComponentEvents) {
    ComponentEvents["Ready"] = "ready";
    ComponentEvents["ClickSlide"] = "clickSlide";
  })(ComponentEvents || (ComponentEvents = {}));

  var ComponentPropNames;

  (function (ComponentPropNames) {
    ComponentPropNames["AutoUpdate"] = "autoUpdate";
    ComponentPropNames["AutoDestroy"] = "autoDestroy";
    ComponentPropNames["DeleteInstanceOnDestroy"] = "deleteInstanceOnDestroy";
    ComponentPropNames["CleanupStylesOnDestroy"] = "cleanupStylesOnDestroy";
  })(ComponentPropNames || (ComponentPropNames = {})); // https://swiperjs.com/api/#events


  var SWIPER_EVENTS = ['init', 'beforeDestroy', 'slideChange', 'slideChangeTransitionStart', 'slideChangeTransitionEnd', 'slideNextTransitionStart', 'slideNextTransitionEnd', 'slidePrevTransitionStart', 'slidePrevTransitionEnd', 'transitionStart', 'transitionEnd', 'touchStart', 'touchMove', 'touchMoveOpposite', 'sliderMove', 'touchEnd', 'click', 'tap', 'doubleTap', 'imagesReady', 'progress', 'reachBeginning', 'reachEnd', 'fromEdge', 'setTranslate', 'setTransition', 'resize', 'observerUpdate', 'beforeLoopFix', 'loopFix'];
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0

  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.

  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */

  function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
      s += arguments[i].length;
    }

    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
        r[k] = a[j];
      }
    }

    return r;
  }
  /**
   * @file vue-awesome-swiper
   * @module utils
   * @author Surmon <https://github.com/surmon-china>
   */


  var kebabcase = function kebabcase(string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
  };
  /**
   * @file vue-awesome-swiper
   * @module event
   * @author Surmon <https://github.com/surmon-china>
   */


  var handleClickSlideEvent = function handleClickSlideEvent(swiper, event, emit) {
    var _a, _b, _c;

    if (swiper && !swiper.destroyed) {
      var eventPath = ((_a = event.composedPath) === null || _a === void 0 ? void 0 : _a.call(event)) || event.path;

      if ((event === null || event === void 0 ? void 0 : event.target) && eventPath) {
        var slides_1 = Array.from(swiper.slides);
        var paths = Array.from(eventPath); // Click slide || slide[children]

        if (slides_1.includes(event.target) || paths.some(function (item) {
          return slides_1.includes(item);
        })) {
          var clickedIndex = swiper.clickedIndex;
          var reallyIndex = Number((_c = (_b = swiper.clickedSlide) === null || _b === void 0 ? void 0 : _b.dataset) === null || _c === void 0 ? void 0 : _c.swiperSlideIndex);
          var reallyIndexValue = Number.isInteger(reallyIndex) ? reallyIndex : null;
          emit(ComponentEvents.ClickSlide, clickedIndex, reallyIndexValue);
          emit(kebabcase(ComponentEvents.ClickSlide), clickedIndex, reallyIndexValue);
        }
      }
    }
  };

  var bindSwiperEvents = function bindSwiperEvents(swiper, emit) {
    SWIPER_EVENTS.forEach(function (eventName) {
      swiper.on(eventName, function () {
        var arguments$1 = arguments;
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments$1[_i];
        }

        emit.apply(void 0, __spreadArrays([eventName], args));
        var kebabcaseName = kebabcase(eventName);

        if (kebabcaseName !== eventName) {
          emit.apply(void 0, __spreadArrays([kebabcaseName], args));
        }
      });
    });
  };
  /**
   * @file vue-awesome-swiper
   * @module directive
   * @author Surmon <https://github.com/surmon-china>
   */


  var INSTANCE_NAME_KEY = 'instanceName';

  function getDirective(SwiperClass, globalOptions) {
    var getStandardisedOptionByAttrs = function getStandardisedOptionByAttrs(vnode, key) {
      var _a, _b, _c, _d;

      var value = (_b = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs) === null || _b === void 0 ? void 0 : _b[key];
      return value !== undefined ? value : (_d = (_c = vnode.data) === null || _c === void 0 ? void 0 : _c.attrs) === null || _d === void 0 ? void 0 : _d[kebabcase(key)];
    }; // Get swiper instace name in directive


    var getSwiperInstanceName = function getSwiperInstanceName(element, binding, vnode) {
      return binding.arg || getStandardisedOptionByAttrs(vnode, INSTANCE_NAME_KEY) || element.id || CoreNames.SwiperInstance;
    };

    var getSwiperInstance = function getSwiperInstance(element, binding, vnode) {
      var instanceName = getSwiperInstanceName(element, binding, vnode);
      return vnode.context[instanceName] || null;
    };

    var getSwipeOptions = function getSwipeOptions(binding) {
      return binding.value || globalOptions;
    };

    var getBooleanValueByInput = function getBooleanValueByInput(input) {
      return [true, undefined, null, ''].includes(input);
    }; // Emit event in Vue directive


    var getEventEmiter = function getEventEmiter(vnode) {
      var _a, _b;

      var handlers = ((_a = vnode.data) === null || _a === void 0 ? void 0 : _a.on) || ((_b = vnode.componentOptions) === null || _b === void 0 ? void 0 : _b.listeners);
      return function (name) {
        var arguments$1 = arguments;
        var args = [];

        for (var _i = 1; _i < arguments.length; _i++) {
          args[_i - 1] = arguments$1[_i];
        }

        var _a;

        var handle = (_a = handlers) === null || _a === void 0 ? void 0 : _a[name];

        if (handle) {
          handle.fns.apply(handle, args);
        }
      };
    };

    return {
      // Init
      bind: function bind(element, binding, vnode) {
        // auto class name
        if (element.className.indexOf(DEFAULT_CLASSES.containerClass) === -1) {
          element.className += (element.className ? ' ' : '') + DEFAULT_CLASSES.containerClass;
        } // bind click event


        element.addEventListener('click', function (event) {
          var emitEvent = getEventEmiter(vnode);
          var swiper = getSwiperInstance(element, binding, vnode);
          handleClickSlideEvent(swiper, event, emitEvent);
        });
      },
      // DOM inserted
      inserted: function inserted(element, binding, vnode) {
        var context = vnode.context;
        var swiperOptions = getSwipeOptions(binding);
        var instanceName = getSwiperInstanceName(element, binding, vnode);
        var emitEvent = getEventEmiter(vnode);
        var vueContext = context;
        var swiper = vueContext === null || vueContext === void 0 ? void 0 : vueContext[instanceName]; // Swiper will destroy but not delete instance, when used <keep-alive>

        if (!swiper || swiper.destroyed) {
          swiper = new SwiperClass(element, swiperOptions);
          vueContext[instanceName] = swiper;
          bindSwiperEvents(swiper, emitEvent);
          emitEvent(ComponentEvents.Ready, swiper); // MARK: Reinstance when the nexttick with <keep-alive>
          // Vue.nextTick(instancing) | setTimeout(instancing)
        }
      },
      // On options changed or DOM updated
      componentUpdated: function componentUpdated(element, binding, vnode) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

        var autoUpdate = getStandardisedOptionByAttrs(vnode, ComponentPropNames.AutoUpdate);

        if (getBooleanValueByInput(autoUpdate)) {
          var swiper = getSwiperInstance(element, binding, vnode);

          if (swiper) {
            var swiperOptions = getSwipeOptions(binding);
            var isLoop = swiperOptions.loop;

            if (isLoop) {
              (_b = (_a = swiper) === null || _a === void 0 ? void 0 : _a.loopDestroy) === null || _b === void 0 ? void 0 : _b.call(_a);
            }

            (_c = swiper === null || swiper === void 0 ? void 0 : swiper.update) === null || _c === void 0 ? void 0 : _c.call(swiper);
            (_e = (_d = swiper.navigation) === null || _d === void 0 ? void 0 : _d.update) === null || _e === void 0 ? void 0 : _e.call(_d);
            (_g = (_f = swiper.pagination) === null || _f === void 0 ? void 0 : _f.render) === null || _g === void 0 ? void 0 : _g.call(_f);
            (_j = (_h = swiper.pagination) === null || _h === void 0 ? void 0 : _h.update) === null || _j === void 0 ? void 0 : _j.call(_h);

            if (isLoop) {
              (_l = (_k = swiper) === null || _k === void 0 ? void 0 : _k.loopCreate) === null || _l === void 0 ? void 0 : _l.call(_k);
              (_m = swiper === null || swiper === void 0 ? void 0 : swiper.update) === null || _m === void 0 ? void 0 : _m.call(swiper);
            }
          }
        }
      },
      // Destroy this directive
      unbind: function unbind(element, binding, vnode) {
        var _a;

        var autoDestroy = getStandardisedOptionByAttrs(vnode, ComponentPropNames.AutoDestroy);

        if (getBooleanValueByInput(autoDestroy)) {
          var swiper = getSwiperInstance(element, binding, vnode);

          if (swiper && swiper.initialized) {
            (_a = swiper === null || swiper === void 0 ? void 0 : swiper.destroy) === null || _a === void 0 ? void 0 : _a.call(swiper, getBooleanValueByInput(getStandardisedOptionByAttrs(vnode, ComponentPropNames.DeleteInstanceOnDestroy)), getBooleanValueByInput(getStandardisedOptionByAttrs(vnode, ComponentPropNames.CleanupStylesOnDestroy)));
          }
        }
      }
    };
  }
  /**
   * @file vue-awesome-swiper
   * @module SwiperComponent
   * @author Surmon <https://github.com/surmon-china>
   */


  var SlotNames;

  (function (SlotNames) {
    SlotNames["ParallaxBg"] = "parallax-bg";
    SlotNames["Pagination"] = "pagination";
    SlotNames["Scrollbar"] = "scrollbar";
    SlotNames["PrevButton"] = "button-prev";
    SlotNames["NextButton"] = "button-next";
  })(SlotNames || (SlotNames = {}));

  function getSwiperComponent(SwiperClass) {
    var _a;

    return Vue.extend({
      name: CoreNames.SwiperComponent,
      props: (_a = {
        defaultOptions: {
          type: Object,
          required: false,
          default: function _default() {
            return {};
          }
        },
        // eslint-disable-next-line vue/require-default-prop
        options: {
          type: Object,
          required: false
        }
      }, _a[ComponentPropNames.AutoUpdate] = {
        type: Boolean,
        default: true
      }, // https://github.com/surmon-china/vue-awesome-swiper/pull/550/files
      _a[ComponentPropNames.AutoDestroy] = {
        type: Boolean,
        default: true
      }, // https://github.com/surmon-china/vue-awesome-swiper/pull/388
      _a[ComponentPropNames.DeleteInstanceOnDestroy] = {
        type: Boolean,
        required: false,
        default: true
      }, _a[ComponentPropNames.CleanupStylesOnDestroy] = {
        type: Boolean,
        required: false,
        default: true
      }, _a),
      data: function data() {
        var _a;

        return _a = {}, _a[CoreNames.SwiperInstance] = null, _a;
      },
      computed: {
        swiperInstance: {
          cache: false,
          set: function set(swiper) {
            this[CoreNames.SwiperInstance] = swiper;
          },
          get: function get() {
            return this[CoreNames.SwiperInstance];
          }
        },
        swiperOptions: function swiperOptions() {
          return this.options || this.defaultOptions;
        },
        wrapperClass: function wrapperClass() {
          return this.swiperOptions.wrapperClass || DEFAULT_CLASSES.wrapperClass;
        }
      },
      methods: {
        // Feature: click event
        handleSwiperClick: function handleSwiperClick(event) {
          handleClickSlideEvent(this.swiperInstance, event, this.$emit.bind(this));
        },
        autoReLoopSwiper: function autoReLoopSwiper() {
          var _a, _b;

          if (this.swiperInstance && this.swiperOptions.loop) {
            // https://github.com/surmon-china/vue-awesome-swiper/issues/593
            // https://github.com/surmon-china/vue-awesome-swiper/issues/544
            // https://github.com/surmon-china/vue-awesome-swiper/pull/545/files
            var swiper = this.swiperInstance;
            (_a = swiper === null || swiper === void 0 ? void 0 : swiper.loopDestroy) === null || _a === void 0 ? void 0 : _a.call(swiper);
            (_b = swiper === null || swiper === void 0 ? void 0 : swiper.loopCreate) === null || _b === void 0 ? void 0 : _b.call(swiper);
          }
        },
        updateSwiper: function updateSwiper() {
          var _a, _b, _c, _d, _e, _f, _g, _h;

          if (this[ComponentPropNames.AutoUpdate] && this.swiperInstance) {
            this.autoReLoopSwiper();
            (_b = (_a = this.swiperInstance) === null || _a === void 0 ? void 0 : _a.update) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = this.swiperInstance.navigation) === null || _c === void 0 ? void 0 : _c.update) === null || _d === void 0 ? void 0 : _d.call(_c);
            (_f = (_e = this.swiperInstance.pagination) === null || _e === void 0 ? void 0 : _e.render) === null || _f === void 0 ? void 0 : _f.call(_e);
            (_h = (_g = this.swiperInstance.pagination) === null || _g === void 0 ? void 0 : _g.update) === null || _h === void 0 ? void 0 : _h.call(_g);
          }
        },
        destroySwiper: function destroySwiper() {
          var _a, _b;

          if (this[ComponentPropNames.AutoDestroy] && this.swiperInstance) {
            // https://github.com/surmon-china/vue-awesome-swiper/pull/341
            // https://github.com/surmon-china/vue-awesome-swiper/issues/340
            if (this.swiperInstance.initialized) {
              (_b = (_a = this.swiperInstance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a, this[ComponentPropNames.DeleteInstanceOnDestroy], this[ComponentPropNames.CleanupStylesOnDestroy]);
            }
          }
        },
        initSwiper: function initSwiper() {
          this.swiperInstance = new SwiperClass(this.$el, this.swiperOptions);
          bindSwiperEvents(this.swiperInstance, this.$emit.bind(this));
          this.$emit(ComponentEvents.Ready, this.swiperInstance);
        }
      },
      mounted: function mounted() {
        if (!this.swiperInstance) {
          this.initSwiper();
        }
      },
      // Update swiper when the parent component activated with `keep-alive`.
      activated: function activated() {
        this.updateSwiper();
      },
      updated: function updated() {
        this.updateSwiper();
      },
      beforeDestroy: function beforeDestroy() {
        // https://github.com/surmon-china/vue-awesome-swiper/commit/2924a9d4d3d1cf51c0d46076410b1f804b2b8a43#diff-7f4e0261ac562c0f354cb91a1ca8864f
        this.$nextTick(this.destroySwiper);
      },
      render: function render(createElement) {
        return createElement('div', {
          staticClass: DEFAULT_CLASSES.containerClass,
          on: {
            click: this.handleSwiperClick
          }
        }, [this.$slots[SlotNames.ParallaxBg], createElement('div', {
          class: this.wrapperClass
        }, this.$slots.default), this.$slots[SlotNames.Pagination], this.$slots[SlotNames.PrevButton], this.$slots[SlotNames.NextButton], this.$slots[SlotNames.Scrollbar]]);
      }
    });
  }
  /**
   * @file vue-awesome-swiper
   * @module SwiperSlideComponent
   * @author Surmon <https://github.com/surmon-china>
   */


  var SwiperSlideComponent = Vue.extend({
    name: CoreNames.SwiperSlideComponent,
    computed: {
      slideClass: function slideClass() {
        var _a, _b;

        return ((_b = (_a = this.$parent) === null || _a === void 0 ? void 0 : _a.swiperOptions) === null || _b === void 0 ? void 0 : _b.slideClass) || DEFAULT_CLASSES.slideClass;
      }
    },
    methods: {
      update: function update() {
        var _a;

        var parent = this.$parent; // https://github.com/surmon-china/vue-awesome-swiper/issues/632

        if (parent[ComponentPropNames.AutoUpdate]) {
          (_a = parent === null || parent === void 0 ? void 0 : parent.swiperInstance) === null || _a === void 0 ? void 0 : _a.update();
        }
      }
    },
    mounted: function mounted() {
      this.update();
    },
    updated: function updated() {
      this.update();
    },
    render: function render(createElement) {
      return createElement('div', {
        class: this.slideClass
      }, this.$slots.default);
    }
  });
  /**
   * @file vue-awesome-swiper
   * @module exporter
   * @author Surmon <https://github.com/surmon-china>
   */

  var getInstaller = function getInstaller(SwiperClass) {
    var install = function install(Vue, globalOptions) {
      if (install.installed) {
        return;
      }

      var SwiperComponent = getSwiperComponent(SwiperClass);

      if (globalOptions) {
        SwiperComponent.options.props.defaultOptions.default = function () {
          return globalOptions;
        };
      }

      Vue.component(CoreNames.SwiperComponent, SwiperComponent);
      Vue.component(CoreNames.SwiperSlideComponent, SwiperSlideComponent);
      Vue.directive(CoreNames.SwiperDirective, getDirective(SwiperClass, globalOptions));
      install.installed = true;
    };

    return install;
  };

  function exporter(SwiperClass) {
    var _a;

    return _a = {
      version: '4.1.1',
      install: getInstaller(SwiperClass),
      directive: getDirective(SwiperClass)
    }, _a[CoreNames.SwiperComponent] = getSwiperComponent(SwiperClass), _a[CoreNames.SwiperSlideComponent] = SwiperSlideComponent, _a;
  }
  /**
   * @file vue-awesome-swiper
   * @module default-export
   * @author Surmon <https://github.com/surmon-china>
   */


  var VueAwesomeSwiper = exporter(Swiper);
  var version = VueAwesomeSwiper.version;
  var install$1 = VueAwesomeSwiper.install;
  var directive$1 = VueAwesomeSwiper.directive;
  var Swiper$1 = VueAwesomeSwiper.Swiper;
  var SwiperSlide = VueAwesomeSwiper.SwiperSlide;

  Vue.component('v-scope', __vue_component__);
  Vue.component('v-source', __vue_component__$1);
  Vue.component('v-model-source', __vue_component__$3);
  Vue.component('v-loader', __vue_component__$4);
  Vue.component('v-image', __vue_component__$5);
  Vue.component('v-video', __vue_component__$6);
  Vue.component('v-lazy-component', __vue_component__$7);
  Vue.component('v-tooltip', __vue_component__$8);
  Vue.component('v-transition-expand', __vue_component__$9); // forms

  Vue.component('v-form', __vue_component__$a);
  Vue.component('v-form-unp-input', __vue_component__$b);
  Vue.component('v-form-unp-select', __vue_component__$c);
  Vue.component('v-remove-product', __vue_component__$d);
  Vue.component('v-remove-company', __vue_component__$e);
  Vue.component('v-subscription-form', __vue_component__$f);
  Vue.component('v-field', __vue_component__$g);
  Vue.component('v-field-text', __vue_component__$h);
  Vue.component('v-field-select', __vue_component__$i);
  Vue.component('v-field-check-list', __vue_component__$j);
  Vue.component('v-field-tag-list', __vue_component__$k);
  Vue.component('v-link-list', __vue_component__$l);
  Vue.component('v-field-check-blocks', __vue_component__$m);
  Vue.component('v-field-checkbox', __vue_component__$n);
  Vue.component('v-field-tag', __vue_component__$o);
  Vue.component('v-field-count', __vue_component__$p);
  Vue.component('v-field-range', __vue_component__$q);
  Vue.component('v-field-file', __vue_component__$r);
  Vue.component('v-field-view-picker', __vue_component__$s);
  Vue.component('v-field-color', __vue_component__$t);
  Vue.component('v-field-color-list', __vue_component__$u);
  Vue.component('v-field-switch-list', __vue_component__$v);
  Vue.component('v-field-switch', __vue_component__$w);
  Vue.component('v-field-tabs-list', __vue_component__$x);
  Vue.component('v-field-tab', __vue_component__$y);
  Vue.component('v-field-tooltip', __vue_component__$z);
  Vue.component('v-field-date-range', __vue_component__$A);
  Vue.component('v-change-account', __vue_component__$C);
  Vue.component('v-add-company', __vue_component__$D);
  Vue.component('v-field-date', __vue_component__$E); // other

  Vue.component('v-page-section', __vue_component__$F);
  Vue.component('v-page-section-header', __vue_component__$G);
  Vue.component('v-hero-block', __vue_component__$H);
  Vue.component('v-price', __vue_component__$J);
  Vue.component('v-status', __vue_component__$K);
  Vue.component('v-catalog', __vue_component__$L);
  Vue.component('v-filter', __vue_component__$M);
  Vue.component('v-filter-active-items', __vue_component__$N);
  Vue.component('v-page-nav', __vue_component__$O);
  Vue.component('v-availability', __vue_component__$P);
  Vue.component('v-basket-action', __vue_component__$Q);
  Vue.component('v-basket-action-big', __vue_component__$R);
  Vue.component('v-product-grid', __vue_component__$S);
  Vue.component('v-product-list', __vue_component__$T);
  Vue.component('v-product-line', __vue_component__$U);
  Vue.component('v-product', __vue_component__$V);
  Vue.component('v-product-image', __vue_component__$W);
  Vue.component('v-article-grid', __vue_component__$X);
  Vue.component('v-article-poster', __vue_component__$Y);
  Vue.component('v-catalog-item', __vue_component__$Z);
  Vue.component('v-modal', __vue_component__$$);
  Vue.component('v-message', __vue_component__$10);
  Vue.component('v-gallery', __vue_component__$11);
  Vue.component('v-modal-window', __vue_component__$12);
  Vue.component('v-price-panel', __vue_component__$13);
  Vue.component('v-basket-big', __vue_component__$14);
  Vue.component('v-basket-item', __vue_component__$15);
  Vue.component('v-product-colors', __vue_component__$16);
  Vue.component('v-switch', __vue_component__$17);
  Vue.component('v-compare-action', __vue_component__$18);
  Vue.component('v-compare-panel', __vue_component__$19);
  Vue.component('v-field-range-slider', __vue_component__$B);
  Vue.component('v-order', __vue_component__$1a);
  Vue.component('v-cookies', __vue_component__$1b);
  Vue.component('v-compare', __vue_component__$1c);
  Vue.component('v-compare-bar', __vue_component__$1d);
  Vue.component('v-account', __vue_component__$1e);
  Vue.component('v-companies', __vue_component__$1f);
  Vue.component('v-orders', __vue_component__$1g);
  Vue.component('v-order-list-item', __vue_component__$1h);
  Vue.component('v-order-detail', __vue_component__$1i);
  Vue.component('v-tiles', __vue_component__$1j);
  Vue.component('v-tiles-item', __vue_component__$1k);
  Vue.component('v-search', __vue_component__$1l);
  Vue.component('v-faq-result', __vue_component__$1m);
  Vue.component('v-tags', __vue_component__$1n);
  Vue.component('v-specification', __vue_component__$1o);
  Vue.component('v-work-list', __vue_component__$1p);
  Vue.component('v-stock', __vue_component__$1q); // header

  Vue.component('v-main-nav', __vue_component__$1r);
  Vue.component('v-mobile-nav', __vue_component__$1s);
  Vue.component('v-mobile-nav-sup', __vue_component__$1t);
  Vue.component('v-basket-small', __vue_component__$1u);
  Vue.component('v-user-small', __vue_component__$1v);
  Vue.component('v-search-small', __vue_component__$1w);
  Vue.component('v-question-small', __vue_component__$1x);
  Vue.component('v-favorite-small', __vue_component__$1y);
  Vue.component('v-hamburger', __vue_component__$1z);
  Vue.component('v-continue-as', __vue_component__$1A); // sliders

  Vue.component('v-hero-slider', __vue_component__$1B);
  Vue.component('v-slider-thumbs', __vue_component__$1C);
  Vue.component('v-product-slider', __vue_component__$1D);
  Vue.component('v-brands-slider', __vue_component__$1E);
  Vue.component('v-slider-carousel', __vue_component__$1F);
  Vue.component('v-tabs-slider', __vue_component__$1G); // plugins

  Vue.component('v-date-range-picker', DateRangePicker);
  Vue.component('v-masked-input', MaskedInput);
  Vue.component('v-swiper', Swiper$1);
  Vue.component('v-swiper-slide', SwiperSlide);

  document.querySelectorAll('v-scope, [v-scope]').forEach(function (element) {
    return new Vue({
      store: store,
      el: element
    });
  });

}());
